import { EMAIL_SUPPORT } from "../../utils/constants";
import {
  BID_CONTROL_PLACEHOLDER,
  HIGHEST_VOLUME_PLACEHOLDER,
  SAVE_LOCATION_SET_TITLE,
  SAVE_LOCATION_SET_NAME_LABEL,
  SAVE_LOCATION_SET_SAVE_BUTTON,
  SAVE_LOCATION_SET_SAVING_BUTTON,
  SAVE_LOCATION_SET_CANCEL_BUTTON,
  SAVED_LOCATION_SETS_TITLE,
  SAVED_LOCATION_SETS_CLOSE_BUTTON,
  FIELD_OPEN_MAP_RADIUS_SELECT_TITLE,
  FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION,
  LOAD_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_SUCCESS,
  SAVE_LOCATION_SET_ERROR,
  LOAD_LOCATION_SETS_ERROR,
  SAVE_LOCATION_SET_DUPLICATE_ERROR,
  CUSTOMER_ACQUISITION_TITLE,
  CUSTOMER_ACQUISITION_SWITCH_LABEL,
  CUSTOMER_ACQUISITION_ACCOUNT_LEVEL,
  CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE,
  ALERT_PLATFORM_STATUS_BANNER,
  ALERT_REBRAND_BANNER,
  ALERT_REBRAND_BANNER_DISCORD_BODY,
  DISCORD_LINK,
  ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_LINK,
  APPSUMO_REVIEW_BANNER_LINK,
  ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS,
  ALERT_REBRAND_BANNER_CAROUSEL_NEXT,
  MODAL_REBRAND_ADLE_TITLE,
  MODAL_REBRAND_ADLE_DESCRIPTION,
  MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON,
  ADS_CONFIGURATION_APPS_TITLE,
  ADS_CONFIGURATION_DESTINATION_TITLE,
  ADS_CAMPAIGN_PREVIEW,
  SEARCH,
  LOADING_INFORMATION,
  AUDIENCE,
  AUDIENCE_TITLE_EXPLANATION,
  AUDIENCE_EXPLANATION,
  ENGAGEMENT,
  ENGAGEMENT_TITLE_EXPLANATION,
  ENGAGEMENT_EXPLANATION,
  RECORDS_IN_TABLE,
  SHOP_DEACTIVATE_ALERT_DESCRIPTION,
  PAGE_IN_TABLE,
  BUTTON_RETRY,
  BUTTON_RETRY_PUBLISHING,
  BUTTON_INVITE,
  BUTTON_EDIT_INVITE,
  BUTTON_VIEW_REQUEST,
  BUTTON_START_NOW,
  BUTTON_REJECT_REQUEST,
  BUTTON_ORDER_IN_PROCESS,
  BUTTON_VIEW_COLLABORATION,
  NEW_CREATORS_CATEGORY,
  CREATORS_TITLE,
  CREATOR_DESCRIPTION,
  SEARCH_BAR_TEXT_CREATORS,
  TAB_CREATORS,
  TAB_REQUESTS,
  TAB_SUGGESTED,
  CREATORS_TABLE_COLUMN_NAME,
  CREATORS_TABLE_COLUMN_CITY,
  CREATORS_TABLE_COLUMN_AUDIENCE,
  CREATORS_TABLE_COLUMN_ENGAGEMENT,
  CREATORS_TABLE_COLUMN_DATE,
  CREATORS_TABLE_COLUMN_CATEGORIES,
  CREATORS_TABLE_COLUMN_SCORE,
  CREATORS_TABLE_COLUMN_ACTIVITY,
  BUTTON_VIEW_INVITE,
  DATE_SHORT,
  CALENDAR_MONTH,
  CALENDAR_WEEK,
  CALENDAR_DAY,
  CALENDAR_TODAY,
  CALENDAR_TOMORROW,
  CALENDAR_NEXT,
  CALENDAR_PREVIOUS,
  CALENDAR_AGENDA,
  CALENDAR_SHOW_MORE,
  VIEW_CALENDAR,
  POST_TITLE,
  CALENDAR_POST_TITLE,
  CALENDAR_INVALID_DATE_ERROR,
  EVENT_DETAILS_DESCRIPTION,
  EVENT_DETAILS_DATE_AND_TIME,
  EVENT_DETAILS_SOCIAL_NETWORK,
  EVENT_DETAILS_STATUS,
  EVENT_DETAILS_STATUS_DRAFT,
  EVENT_DETAILS_STATUS_SCHEDULED,
  EVENT_DETAILS_STATUS_PUBLISHED,
  GALLERY_MAX_SELECTIONS_REACHED,
  GALLERY_PUBLISHED_ON_PLATFORMS,
  GALLERY_PLATFORM_STATUSES_LABEL,
  GALLERY_STATUS_PUBLISHED_DIRECT,
  GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN,
  GALLERY_STATUS_SCHEDULED,
  GALLERY_STATUS_SCHEDULED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_SCHEDULE,
  GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN,
  GALLERY_STATUS_FAILED,
  GALLERY_STATUS_FAILED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_LEGACY,
  SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED,
  EVENT_DETAILS_STATUS_FAILED,
  EVENT_DETAILS_NETWORK_INSTAGRAM,
  EVENT_DETAILS_NETWORK_FACEBOOK,
  EVENT_DETAILS_NETWORK_TIKTOK,
  EVENT_DETAILS_NETWORK_LINKEDIN,
  EVENT_DETAILS_NETWORK_YOUTUBE,
  EVENT_DETAILS_CONTENT,
  ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE,
  ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION,
  ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE,
  ORGANIC_PUBLISH_RETRY_ERROR,
  ORGANIC_PUBLISH_PARTIAL_STATUS,
  BUTTON_VIEW_METRICS,
  QUALITY_AUDIENCE,
  QUALITY_CONTENT,
  CONTENT,
  ANALYTIC,
  COMMENTS,
  EMPTY_COMMENTS,
  SHOW_COMMENTS,
  BUTTON_CANCEL_INVITE,
  ADVANCED_CONFIGURATION,
  MENU_PLATFORM,
  MENU_ACTIONS,
  MENU_CONFIGURATION,
  MENU_ADMINISTRATION,
  SUB_MENU_CREATORS,
  SUB_MENU_PUBLICATIONS,
  SUB_MENU_EVENTS,
  SUB_MENU_CAMPAIGNS,
  SUB_MENU_REPORTS,
  SUB_MENU_REDEEM_CODE,
  SUB_MENU_ORDERS,
  SUB_MENU_ACCOUNT,
  SUB_MENU_STORES,
  SUB_MENU_MENU,
  SUB_MENU_USERS,
  SUB_MENU_BILLING_AND_PAYMENTS,
  SUB_MENU_BILLING_DASHBOARD,
  SUB_MENU_BILLING_DATA,
  SUB_MENU_USERS_OWNER,
  SUB_MENU_BRANDS,
  SUB_MENU_BRAND_SIGNUPS,
  SUB_MENU_CREATORS_OWNER,
  SUB_MENU_CREATORS_EXTERNALS,
  SUB_MENU_PAY_CREATORS,
  SUB_MENU_CREATOR_SIGNUPS,
  SUB_MENU_CONTENTS,
  SUB_MENU_DELIVERIES,
  SUB_MENU_REPORTS_OWNER,
  SUB_MENU_FEEDBACK,
  SUB_MENU_PAYMENTS_FAILED,
  SUB_MENU_DISCOVERY,
  SUB_MENU_GALLERY,
  REQUEST_REJECTED,
  REQUEST_REJECTED_DESCRIPTION,
  REPORTED_CONTENT_STATUS_REJECTED,
  REPORTED_CONTENT_STATUS_PENDING,
  REPORTED_CONTENT_STATUS_APPROVED,
  HELP,
  CREDITS,
  COST_OF_ACTION,
  COST_OF_CAMPAIGN,
  COST_OF_RESIZE,
  CURRENT,
  CURRENT_BALANCE,
  BALANCE_AFTER,
  DEACTIVATE,
  ACTIVATE,
  BRAND,
  NOTIFICATIONS,
  LOGOUT,
  LOADING_SUGGESTED_INFORMATION,
  ALERT_AD_CPA_LOW_LABEL,
  ALERT_AD_CPA_MEDIUM_LABEL,
  ALERT_AD_CPA_HIGH_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_GROUP_CPA_LOW_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_CPA_LOW_TABLE_LABEL,
  ALERT_AD_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_CPA_HIGH_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL,
  GO_TO_PROFILE,
  CREATORS_SUGGESTED_EMPTY,
  WARNING,
  WAIT,
  ERROR,
  ERROR_DESCRIPTION_GENERIC,
  LIST_CREATORS_WITH_AUDIENCE_SIMILAR,
  LAST_UPDATE_DATE,
  BUTTON_INIT_CHAT,
  UPDATE,
  INFORMATION_INVALID_ACCESS,
  FOLLOWERS,
  AVG_LIKES,
  AVG_COMMENTS,
  ANALYTICS,
  AVG_VIEWS,
  AUDIENCE_INFORMATION,
  AUDIENCE_CREDIBILITY,
  AUDIENCE_CREDIBILITY_TITLE_EXPLANATION,
  AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION,
  AUDIENCE_BY_COUNTRY,
  AUDIENCE_BY_CITIES,
  AUDIENCE_BY_BRAND_AFFINITY,
  AUDIENCE_BY_INTERESTS,
  MALES,
  FEMALES,
  AUDIENCE_BY_DISTRIBUTION_AGE,
  AUDIENCE_BY_PERCENTAGE_GENDERS,
  BUTTON_USE_AS_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE,
  PROFILE,
  PUBLISHED_DATE,
  GALLERY_CONTENT_BUZZLY,
  EMPTY_CONTENT_SHOW,
  LOADING_SIMILAR_PROFILES_INFORMATION,
  EMPTY_SIMILAR_PROFILES_SHOW,
  FIELD_REQUIRED,
  FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS,
  EMPTY_RESULTS_SHOW,
  DISCOVER_NEW_CREATORS,
  BUTTON_DOWNLOAD,
  START_DATE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  BUTTON_CALCULATE,
  BUTTON_ENTERPRISE_CALCULATE,
  LOADING_REPORT_INFORMATION,
  COLLABORATIONS,
  LIKES,
  SHARES,
  UNKNOWN_FORMAT,
  COLLABORATION,
  CATEGORY,
  REDEEM_CODE_TITLE,
  REDEEM_CODE_DESCRIPTION,
  REDEEM_CODE_SEARCHBAR_PLACEHOLDER,
  BUTTON_REDEEM_CODE,
  BUTTON_ADD_STORE,
  STORE,
  SELECT_STORE,
  EMPTY_STORES,
  REDEEM_CODE_TABLE_COLUMN_VALUE,
  REDEEM_CODE_TABLE_COLUMN_DATE,
  REDEEM_CODE_TABLE_COLUMN_CODE,
  FIELD_ALPHANUMERIC,
  FIELD_TEXT,
  FIELD_NUMERIC,
  CODE_REDEEMED,
  VALUE_CODE_REDEEMED,
  CODE_NO_EXIST,
  CODE_NO_REDEEM_BEFORE_DATE,
  EVENT_NO_EXIST,
  EVENT_DISABLED,
  ORDERS_SEARCHBAR_PLACEHOLDER,
  ORDERS_DESCRIPTION,
  ORDERS_TITLE,
  NEW_ORDER,
  ORDERS_TAB_TO_BE_DELIVERED,
  ORDERS_TAB_IN_PREPARATION,
  ORDERS_TAB_TO_BE_ACCEPTED,
  ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION,
  ORDERS_TAB_IN_PREPARATION_DESCRIPTION,
  ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION,
  NEW,
  MINUTE_LETTER_COUNT_DOWN,
  HOUR_LETTER_COUNT_DOWN,
  DAY_LETTER_COUNT_DOWN,
  WEEK_LETTER_COUNT_DOWN,
  DELIVERY_INTERN,
  DELIVERY_ON_THE_WAY,
  ORDER_ACCEPTED,
  ORDER_ACCEPTED_DESCRIPTION,
  ORDER_READY,
  ORDER_READY_DESCRIPTION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON,
  ORDER_DELIVERED,
  ORDER_DELIVERED_DESCRIPTION,
  DELIVERY_SELECTED,
  ORDER_REJECTED,
  ORDER_REJECTED_DESCRIPTION,
  DELIVERY_SELECTED_DESCRIPTION,
  ORDER_TOTAL_VALUE,
  ORDER_LIST_OF_PRODUCTS,
  VALUE_WITH_CURRENCY,
  NUMBER_CURRENCY,
  ORDER_OPTIONS,
  CLIENT,
  ADDRESS,
  IDENTIFICATION_NUMBER,
  PHONE_NUMBER,
  NAME,
  BUTTON_ACCEPT_ORDER,
  BUTTON_REJECT_ORDER,
  DATE_LONG,
  MINUTES,
  HOURS,
  DAYS,
  WEEKS,
  ORDER_TIME_PREPARATION_TITLE,
  MIN_VALUE_PREPARATION_ORDER,
  MAX_VALUE_PREPARATION_ORDER,
  INVALID_TIME_PREPARATION,
  TIME_PREPARATION_VALUES_VALIDATION,
  GO,
  BUTTON_READY_ORDER,
  GUIDE_NUMBER_REQUIRED,
  DELIVERY_TYPE_DUPLICATE,
  SELECT_DELIVERY_TYPE,
  SELECT_DELIVERY_TYPE_OTHER,
  GUIDE_NUMBER,
  DELIVERY_DATA,
  BUTTON_DELIVER_ORDER,
  BUTTON_CANCEL,
  BUTTON_CREATE_CAMPAIGN,
  CAMPAIGNS_TITLE,
  CAMPAIGNS_DESCRIPTION,
  CAMPAIGNS_SEARCHBAR_PLACEHOLDER,
  CAMPAIGNS_TABLE_COLUMN_NAME,
  CAMPAIGNS_TABLE_COLUMN_PLATFORMS,
  CAMPAIGNS_TABLE_COLUMN_STATUS,
  CAMPAIGN_ACTIVATE,
  CAMPAIGN_DEACTIVATE,
  CAMPAIGN_ACTIVATE_TIME_CONFIRMATION,
  CAMPAIGN_DEACTIVATE_TIME,
  CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED,
  CAMPAIGN_ACTIVATE_FIELDS_REQUIRED,
  CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR,
  CAMPAIGN_ACTIVATE_TRAFFIC_LINK,
  CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM,
  CAMPAIGN_ACTIVATE_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_QUESTION,
  CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER,
  CREATE_CAMPAIGN_NAME_REQUIRED,
  CREATE_CAMPAIGN_DESCRIPTION_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_MIN_VALUE,
  CREATE_CAMPAIGN_PLATFORMS_REQUIRED,
  CREATE_CAMPAIGN_TYPE_CONTENT,
  CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED,
  CREATE_CAMPAIGN_DATES_REQUIRED,
  CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED,
  CREATE_CAMPAIGN_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE,
  CREATE_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED,
  CREATE_CAMPAIGN_SAVE_PROGRESS,
  BUTTON_SAVE_PROGRESS,
  QUESTION,
  CREATE_CAMPAIGN_NAME_EXAMPLE,
  BUTTON_NEXT,
  BUTTON_PREVIOUS,
  BUTTON_ADVANCED_CONFIGURATION,
  BUTTON_FINISH,
  CREATE_CAMPAIGN_NAME_QUESTION,
  CREATE_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_CAMPAIGN_DESCRIPTION_QUESTION,
  CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CREATE_CAMPAIGN_BUDGET_QUESTION,
  CREATE_CAMPAIGN_BUDGET_DESCRIPTION,
  CREATE_CAMPAIGN_PLATFORMS,
  CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER,
  CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION,
  CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_QUESTION,
  CREATE_CAMPAIGN_DATES_DESCRIPTION,
  CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_REPOST_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION,
  CREATE_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_CAMPAIGN_BRIEF_QUESTION,
  CREATE_CAMPAIGN_BRIEF_DESCRIPTION,
  CREATE_CAMPAIGN_UPLOAD_BRIEF,
  CREATE_CAMPAIGN_REMOVED_BRIEF,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CREATE_CAMPAIGN_HASHTAG_QUESTION,
  CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CREATE_CAMPAIGN_ENVIRONMENT_QUESTION,
  CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_KEY_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER,
  CREATE_CAMPAIGN_OUTFIT_QUESTION,
  CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_UPLOAD_CONTENT,
  BUTTON_UPLOAD_DOCUMENT,
  BUTTON_REMOVE_CONTENT,
  DELETE_CONTENT_CONFIRMATION_TITLE,
  DELETE_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_SUCCESS,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION,
  BUTTON_DELETE_CONTENT,
  CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  READY,
  FIELD_HAS_NO_VALUE_TO_COPY,
  CAMPAIGN_FINISHED_CONFIRMATION,
  BUTTON_FINISHED_CAMPAIGN,
  BUTTON_SAVE_CAMPAIGN,
  BUTTON_DEACTIVATE_CAMPAIGN,
  BUTTON_ACTIVATE_CAMPAIGN,
  CAMPAIGN_HAS_BEEN_FINISHED,
  CAMPAIGN_DETAIL_TITLE,
  CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE,
  CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE,
  CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE,
  ACTIONS,
  STATUS,
  CITIES,
  CATEGORIES,
  CAMPAIGN_FINISH_APPLICANTS_ACCEPTED,
  PAYMENT_SUCCESSFUL,
  UPGRADE_SUBSCRIPTION_SUCCESSFUL,
  BUTTON_SEND_INVITE,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION,
  CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION,
  BUTTON_REJECT,
  LIST_OF_CREATORS,
  CAMPAIGN_FIELDS_REQUIRED,
  CAMPAIGN_NAME_PLACEHOLDER,
  CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CAMPAIGN_BUDGET_PLACEHOLDER,
  CAMPAIGN_PLATFORMS_PLACEHOLDER,
  CAMPAIGN_TYPE_CONTENT_PLACEHOLDER,
  CAMPAIGN_COPY_POST_PLACEHOLDER,
  CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER,
  CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CAMPAIGN_REPOST_PLACEHOLDER,
  CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CAMPAIGN_AGE_RANGE_PLACEHOLDER,
  CAMPAIGN_BRIEF_PLACEHOLDER,
  CAMPAIGN_BRIEF_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER,
  CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_TITLE,
  CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CAMPAIGN_GENDERS_PLACEHOLDER,
  CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CAMPAIGN_HASHTAG_PLACEHOLDER,
  CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_ACCEPT,
  BUTTON_ASSIGN_INVITE,
  BUTTON_REVIEW_CONTENT,
  BUTTON_VIEW_PRELIMINARY_CONTENT,
  BUTTON_VIEW_APPLICANT,
  BUTTON_ACCEPT_AND_PAY,
  PAYMENT_METHOD,
  PAYMENT_METHODS,
  CONTENT_CREATOR,
  PRICE_TO_BE_PAID,
  PAYMENT_METHODS_SECURE,
  PAYMENT_METHODS_SECURE_EXPLANATION,
  PAYMENT_METHODS_ENCRYPTED,
  PAY,
  PAYMENT_METHODS_EMPTY,
  OTHERS_PAYMENT_METHODS,
  MAIN_PAYMENT_METHOD,
  OTHERS_PAYMENT_METHODS_EMPTY,
  ADD_CARD,
  VERIFY_SUBSCRIPTION_TITLE,
  VERIFY_SUBSCRIPTION_DESCRIPTION,
  VERIFY_SUBSCRIPTION_CTA,
  SAVE_CONFIGURATION,
  ADD,
  NAME_PLACEHOLDER,
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRMATION_PLACEHOLDER,
  CARD_INFORMATION_EXPLANATION_TITLE,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_CVV_EXPLANATION_TITLE,
  CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION,
  APPLICANTS_STATUS_PENDING,
  APPLICANTS_STATUS_REJECTED,
  APPLICANTS_STATUS_ACCEPTED,
  APPLICANTS_STATUS_CONTENT_SUBMITTED,
  APPLICANTS_STATUS_CONTENT_REVISIONS,
  APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL,
  APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS,
  APPLICANTS_STATUS_DELIVERED,
  BUTTON_REVIEW,
  APPLICANT_CONTENT_OF_CREATOR,
  APPLICANT_REVISION_PLACEHOLDER,
  BUTTON_ACCEPT_CONTENT,
  BUTTON_REJECT_CONTENT,
  BUTTON_SEND_REVIEW,
  WARNING_MOBILE_TUTORIAL,
  BUTTON_CONTINUE,
  BUTTON_SIGN_UP,
  BUTTON_UNDERSTOOD,
  BUTTON_MORE_QUESTIONS,
  FAQ_DESCRIPTION,
  EMPTY_QUESTIONS_SHOW,
  BUTTON_INIT_TUTORIAL,
  FAQ_QUESTION_WHAT_IS_BUZZLY,
  FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_REQUEST,
  FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_ORDER,
  FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_STORE,
  FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION,
  FAQ_QUESTION_WHAT_ROLES_EXISTS,
  FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION,
  FAQ_QUESTION_MUST_CALL_ADMIN,
  FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION,
  BUTTON_PAYMENTS,
  BUTTON_BROADCAST,
  BUTTON_SAVE,
  RECURRENT_FIELDS_DEFAULT_TITLE,
  RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER,
  RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION,
  RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION,
  RECURRENT_FIELD_FREQUENCY_PLACEHOLDER,
  RECURRENT_FIELD_DAY_AN_PLACEHOLDER,
  RECURRENT_FIELD_DAY_ALL_PLACEHOLDER,
  WEEK,
  MONTHS,
  MONTH,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
  SELECT_A_OPTION,
  FILE_SELECTED,
  BUTTON_SEND_MESSAGE,
  BUTTON_UPLOAD_FILE,
  BUTTON_REMOVE_FILE,
  MODAL_BROADCAST_ARIAL_LABEL,
  MODAL_BROADCAST_TITLE,
  MODAL_BROADCAST_SELECT_USER_PLACEHOLDER,
  MODAL_BROADCAST_SELECT_USER_REQUIRED,
  MODAL_BROADCAST_MESSAGE_PLACEHOLDER,
  BROADCAST_MESSAGE_SENT,
  SELECT_PAYMENT_METHOD,
  YOU_WILL_PAY,
  DAY,
  HOUR,
  MINUTE,
  SECONDS,
  SECOND,
  PUBLICATION_TITLE,
  PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION,
  PUBLICATION_FINISH_DESCRIPTION,
  FEEDBACK_PLACEHOLDER,
  FEEDBACK_TITLE,
  NUMBER_PUBLICATION,
  FIELD_MIN_LENGTH,
  PUBLICATIONS_TITLE,
  PUBLICATIONS_DESCRIPTION,
  PUBLICATIONS_TABLE_ARIA_LABEL,
  PUBLICATIONS_TABLE_COLUMN_DATE,
  PUBLICATION_STATUS_PENDING,
  PUBLICATIONS_STATUS_PENDING_ANALYTICS,
  PUBLICATIONS_STATUS_SENT,
  PUBLICATIONS_STATUS_FEEDBACK,
  PUBLICATIONS_STATUS_VERIFIED,
  FEEDBACK_REASON,
  FEEDBACK_COMMENT,
  ANALYTICS_EXPLANATION_TITLE,
  ANALYTICS_EXPLANATION_DESCRIPTION,
  ANALYTICS_EXPLANATION_DESCRIPTION_2,
  ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION,
  ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION,
  ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION,
  ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION,
  EMPTY_ANALYTICS,
  BUTTON_VERIFY_PUBLICATION,
  FEEDBACK_REASON_ABOUT,
  RECURRENT_VALUE_NOT_FOUND,
  MODAL_REVIEW_ARIA_LABEL,
  MODAL_REVIEW_DISCLAIMER,
  MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION,
  MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE,
  MODAL_REVIEW_COMMENT_PLACEHOLDER,
  YES,
  NO,
  LOADING_DOWNLOAD_PROFILES,
  BUTTON_SEARCH,
  BUTTON_METRICS_READY,
  IMAGES,
  VIDEOS,
  LOADING_CONTENT,
  MODAL_GALLERY_ARIA_LABEL,
  MODAL_GALLERY_EMPTY_CONTENT,
  SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  MODAL_GALLERY_NO_MORE_CONTENT,
  MODAL_MEDIA_ARIA_LABEL,
  BUTTON_UPLOAD_TIKTOK,
  MODAL_UPLOAD_TIKTOK_ARIA_LABEL,
  MODAL_UPLOAD_TIKTOK_TITLE,
  MODAL_UPLOAD_FAILED_GET_CONFIGURATION,
  LOADING_CONFIGURATION,
  MODAL_UPLOAD_CONTENT_UPLOADED,
  MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION,
  BUTTON_VIEW_PROFILE,
  BUTTON_GENERATE_DESCRIPTION,
  ACCOUNT_TITLE,
  ACCOUNT_DESCRIPTION,
  BUTTON_UPLOAD_IMAGE,
  BUTTON_REMOVE_IMAGE,
  FIELD_IMAGE_REQUIRED,
  FIELD_IMAGE_FORMAT_VALID,
  FIELD_IMAGE_SIZE_VALID,
  FIELD_FILE_REQUIRED,
  FIELD_FILE_SIZE_VALID,
  COMPANY_INFORMATION_TITLE,
  COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE,
  COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH,
  COMPANY_INFORMATION_ID_NUMBER_TYPE,
  COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_ADDRESS_PLACEHOLDER,
  COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER,
  COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER,
  COMPANY_INFORMATION_CATEGORY_PLACEHOLDER,
  COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER,
  COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_VIEW_DOCUMENT,
  COMPANY_INFORMATION_SHOP_ID_COPIED,
  COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE,
  FIELD_URL_VALID,
  FIELD_URL_ADLE_APP_DOMAIN,
  BUTTON_SAVE_CHANGES,
  BUTTON_REMOVE_VIDEO,
  BUTTON_UPLOAD_VIDEO,
  BUTTON_CONNECT_TIKTOK,
  BUTTON_DISCONNECT,
  PLATFORMS_CONNECTED_TITLE,
  SCHEDULE_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION,
  SCHEDULE_ONE_DAY_WITH_TURN,
  SCHEDULE_EMPTY_TURN,
  SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION,
  SCHEDULE_MAX_CLOSE_HOUR,
  BUTTON_BE_ECOMMERCE,
  BUTTON_NOT_BE_ECOMMERCE,
  SCHEDULE_TABLE_ARIA_LABEL,
  SCHEDULE_TABLE_COLUMN_OPEN,
  SCHEDULE_TABLE_COLUMN_CLOSE,
  BUTTON_ADD_TURN,
  SCHEDULE_SAVED,
  LEGAL_REPRESENTATIVE_TITLE,
  LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_SAVED,
  PASSWORD_TITLE,
  PASSWORD_CURRENT_PASSWORD_PLACEHOLDER,
  PASSWORD_NEW_PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER,
  PASSWORD_FORMAT_DESCRIPTION,
  PASSWORD_FORMAT_SUGGESTION1,
  PASSWORD_FORMAT_SUGGESTION2,
  PASSWORD_FORMAT_SUGGESTION3,
  PASSWORD_FORMAT_SUGGESTION4,
  PASSWORD_INSECURE,
  PASSWORDS_NOT_MATCH,
  PASSWORD_CHANGED,
  PASSWORD_CURRENT_INVALID,
  PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS,
  OK,
  BUTTON_DELETE,
  BUTTON_CREATE,
  MODAL_STORE_ARIA_LABEL,
  MODAL_STORE_TYPE_PLACEHOLDER,
  MODAL_STORE_HOW_TO_INTEGRATE_STORE,
  MODAL_STORE_NAME_PLACEHOLDER,
  MODAL_STORE_DESCRIPTION_PLACEHOLDER,
  MODAL_STORE_ADDRESS_PLACEHOLDER,
  MODAL_STORE_CITY_PLACEHOLDER,
  MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER,
  MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER,
  MODAL_STORE_LOOK_NAME_SHOPIFY,
  MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT,
  MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER,
  MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER,
  MODAL_STORE_CITIES_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION,
  MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER,
  MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION,
  MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER,
  MODAL_STORE_TYPE_REGULAR_OPTION,
  FIELD_EMAIL_VALID,
  FIELD_SPACES_VALID,
  MODAL_STORE_PHONE_PLACEHOLDER,
  FIELD_PHONE_VALID,
  USERS_TITLE,
  USERS_DESCRIPTION,
  USERS_CONTACTS_TAB,
  USERS_PORTAL_TAB,
  USERS_TABS_ARIA_LABEL,
  USERS_EMAIL_DUPLICATE,
  USERS_USER_CREATED,
  USERS_USER_SAVED,
  USERS_USER_DELETE_CONFIRMATION_TITLE,
  USERS_USER_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_USER_DELETING,
  USERS_USER_DELETED,
  USERS_LIMIT_REACHED,
  ADVERTISERS_LIMIT_REACHED,
  USERS_ONBOARDING_FINISH,
  USERS_USER_SEARCH_BAR_PLACEHOLDER,
  BUTTON_CREATE_USER,
  BUTTON_CREATE_ACCOUNT,
  MODAL_CREATE_ACCOUNT_TITLE,
  MODAL_CREATE_ACCOUNT_DESCRIPTION,
  FILTER,
  OPERATOR,
  ADMIN,
  USERS_TABLE_COLUMN_ROLE,
  USERS_TABLE_COLUMN_STORE,
  USERS_TABLE_COLUMN_EMAIL,
  USERS_TABLE_COLUMN_NAME,
  USERS_TABLE_ARIA_LABEL,
  MODAL_USER_ARIA_LABEL,
  MODAL_USER_TITLE,
  MODAL_USER_NAME_PLACEHOLDER,
  MODAL_USER_ROLE_PLACEHOLDER,
  MODAL_USER_ROLE_OPERATOR_EXPLANATION,
  MODAL_USER_STORE_PLACEHOLDER,
  MODAL_USER_PASSWORD_PLACEHOLDER,
  MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER,
  FIELD_PASSWORDS_NO_MATCH,
  FIELD_PASSWORD_MIN_LENGTH,
  FIELD_ALL_REQUIRED,
  USERS_CONTACT_CREATED,
  USERS_CONTACT_SAVED,
  USERS_CONTACT_DELETE_CONFIRMATION_TITLE,
  USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_CONTACT_DELETED,
  USERS_CONTACT_SEARCH_BAR_PLACEHOLDER,
  BUTTON_CREATE_CONTACT,
  USERS_CONTACT_TABLE_ARIA_LABEL,
  USERS_CONTACT_TABLE_COLUMN_PHONE,
  MODAL_CONTACT_ARIA_LABEL,
  MODAL_CONTACT_TITLE,
  MODAL_CONTACT_PHONE_PLACEHOLDER,
  STORAGE_USAGE_TITLE,
  STORAGE_USAGE_LABEL,
  STORAGE_FULL_TITLE,
  STORAGE_FULL_MESSAGE,
  STORAGE_FULL_BUTTON_DELETE,
  STORAGE_FULL_BUTTON_UPGRADE,
  BILLING_DATA_TITLE,
  BILLING_DATA_DESCRIPTION,
  BILLING_DATA_SAVED,
  BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION,
  BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER,
  BILLING_AND_PAYMENTS_TITLE,
  BILLING_AND_PAYMENTS_DESCRIPTION,
  BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS,
  PAYMENT_REASON_COLLABORATION,
  PAYMENT_REASON_APPLICANT,
  PAYMENT_REASON_CLAPP_CREDITS,
  PAYMENT_REASON_PACKAGE,
  PAYMENT_REASON_PLAN,
  PAYMENT_PAID,
  PAYMENT_PENDING,
  BUTTON_VIEW_DETAILS,
  BUTTON_DOWNLOAD_INVOICE,
  BUTTON_CLOSE,
  TOTAL,
  MODAL_INVOICE_ARIA_LABEL,
  MODAL_INVOICE_TITLE,
  MODAL_INVOICE_DISCLAIMER,
  MODAL_INVOICE_NUMBER_CREDITS,
  PURCHASE_CREDITS,
  PURCHASE_VIDEOS,
  PURCHASE_X_CREDITS,
  MODAL_INVOICE_ORDER_TO_COLLECT,
  MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID,
  MODAL_PAY_INVOICE_ARIA_LABEL,
  MODAL_PAY_INVOICE_TITLE,
  MODAL_PAY_INVOICE_WILL_PAY,
  MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE,
  MODAL_PAY_SUBSCRIPTION_PAY_NOW,
  MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE,
  BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION,
  NO_HAVE,
  BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN,
  BILLING_AND_PAYMENT_ACTIVATE_PLAN,
  BILLING_AND_PAYMENT_SELECT_PLAN,
  BILLING_AND_PAYMENT_NO_HAVE_PLAN,
  BILLING_AND_PAYMENT_PLAN_EXPIRED,
  BILLING_AND_PAYMENT_PLAN_NAME,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1,
  BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS,
  BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE,
  ADD_PAYMENT_METHOD,
  MODAL_SELECT_PACKAGE_ARIA_LABEL,
  MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE,
  MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION,
  MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION,
  SUPPORT,
  MODAL_SELECT_PACKAGE_VALUE_EXPRESSED,
  CONTACT_US,
  MODAL_SELECT_PACKAGE_PRICE,
  MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT,
  MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME,
  MODAL_SELECT_PACKAGE_COST_COLLABORATION,
  MODAL_SELECT_PACKAGE_BENEFIT_CATALOG,
  MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION,
  MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC,
  MODAL_SELECT_PACKAGE_BENEFIT_KAM,
  MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT,
  MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH,
  MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED,
  MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS,
  MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL,
  MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER,
  COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION,
  MODAL_FREE_TRIAL_TITLE,
  MODAL_FREE_TRIAL_DESCRIPTION,
  MODAL_FREE_TRIAL_BUTTON,
  ACCEPT_TERMS_PAY,
  DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE,
  QUANTITY_TO_PAY,
  BLOCK_PAYMENT_FAILED_TITLE,
  BLOCK_TRIAL_END_TITLE,
  BLOCK_PLAN_BUTTON,
  MODAL_BUY_CREDITS_ARIA_LABEL,
  MODAL_BUY_CREDITS_TITLE,
  MODAL_BUY_CREDITS_DESCRIPTION,
  MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION,
  MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY,
  MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME,
  MODAL_BUY_CREDITS_ADDITIONAL_CREDITS,
  MODAL_BUY_CREDITS_LAST_TEXT_PAY,
  MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE,
  MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_BUY_CREDITS_NEGATIVE,
  MODAL_BUY_CREDITS_PURCHASED,
  MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION,
  MODAL_BUY_VIDEOS_PURCHASED,
  MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION,
  MODAL_BUY_CREDITS_GIFT_CREDITS,
  MODAL_PURCHASE_CREDITS_TITLE,
  MODAL_PURCHASE_CREDITS_ARIA_LABEL,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK,
  MODAL_PURCHASE_CREDITS_SELECT_AMOUNT,
  MODAL_PURCHASE_CREDITS_CREDITS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT,
  MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES,
  MODAL_PURCHASE_CREDITS_VIDEOS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO,
  MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE,
  MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT,
  MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER,
  MODAL_PURCHASE_CREDITS_UPGRADE_PLAN,
  MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON,
  MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY,
  SECTION_COMPETITORS_TITLE,
  SECTION_COMPETITORS_SUBTITLE_SINGULAR,
  SECTION_COMPETITORS_SUBTITLE_PLURAL,
  SECTION_SOCIAL_TITLE,
  SECTION_SOCIAL_SUBTITLE_SINGULAR,
  SECTION_SOCIAL_SUBTITLE_PLURAL,
  SECTION_VOICE_TITLE,
  SECTION_VOICE_SUBTITLE,
  SECTION_VOICE_TONE_DESCRIPTION,
  SECTION_VOICE_ATTRIBUTES_LABEL,
  SECTION_OFFER_TITLE,
  SECTION_OFFER_SUBTITLE,
  SECTION_OFFER_TYPE_LABEL,
  SECTION_OFFER_VISUAL_STYLE_LABEL,
  SECTION_OFFER_DEFAULT_VALUE,
  SECTION_COUNTRY_TITLE,
  SECTION_COUNTRY_SUBTITLE,
  SECTION_COUNTRY_LABEL,
  SECTION_COUNTRY_DEFAULT_VALUE,
  SECTION_TYPOGRAPHY_TITLE,
  SECTION_TYPOGRAPHY_SUBTITLE,
  SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL,
  SECTION_TYPOGRAPHY_TITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_BODY_FONT_LABEL,
  SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY,
  SECTION_TYPOGRAPHY_FONT_SIZES_LABEL,
  SECTION_TYPOGRAPHY_HEADING_LABEL,
  SECTION_TYPOGRAPHY_SUBHEADING_LABEL,
  SECTION_TYPOGRAPHY_BODY_LABEL,
  SECTION_TYPOGRAPHY_PX_UNIT,
  SECTION_TYPOGRAPHY_GENERATING_PREVIEW,
  SECTION_TYPOGRAPHY_ADD_FONT,
  SECTION_LOGO_TITLE,
  SECTION_LOGO_SUBTITLE,
  SECTION_COLORS_TITLE,
  SECTION_COLORS_SUBTITLE,
  SECTION_COLORS_ADD_COLOR,
  SECTION_TARGET_AUDIENCE_TITLE,
  SECTION_TARGET_AUDIENCE_SUBTITLE,
  SECTION_TARGET_AUDIENCE_ICP_LABEL,
  SECTION_PRODUCT_IMAGES_TITLE,
  SECTION_PRODUCT_IMAGES_SUBTITLE,
  BUTTON_UPLOAD_PRODUCT_IMAGES,
  BUTTON_DELETE_PRODUCT_IMAGE,
  SECTION_ADDITIONAL_ASSETS_TITLE,
  SECTION_ADDITIONAL_ASSETS_SUBTITLE,
  SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL,
  SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER,
  SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED,
  BUTTON_UPLOAD_ADDITIONAL_ASSET,
  SECTION_ADDITIONAL_ASSETS_MAX_ERROR,
  SECTION_ADDITIONAL_ASSETS_ASSET_LABEL,
  SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE,
  SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER,
  MODAL_ADDITIONAL_ASSET_TITLE,
  BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE,
  SECTION_BUYER_PERSONA_TITLE,
  SECTION_BUYER_PERSONA_SUBTITLE,
  SECTION_BUYER_PERSONA_LABEL,
  BUTTON_COPY_CATALOG,
  BUTTON_UPLOAD_CATALOG,
  MENU_TITLE,
  MENU_DESCRIPTION,
  MENU_EMPTY_STORES,
  MODAL_COPY_MENU_ARIA_LABEL,
  MODAL_COPY_MENU_TITLE,
  MODAL_COPY_MENU_SAME_STORE,
  MODAL_COPY_MENU_CONFIRM_ALERT_TITLE,
  MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_COPY_MENU_COPIED,
  SELECT_CATALOG,
  BUTTON_DOWNLOAD_FORMAT,
  MODAL_UPLOAD_MENU_ARIA_LABEL,
  MODAL_UPLOAD_MENU_TITLE,
  MODAL_UPLOAD_MENU_DESCRIPTION,
  MODAL_UPLOAD_MENU_FILE_PLACEHOLDER,
  MODAL_UPLOAD_MENU_ERROR_FORMAT,
  MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_UPLOAD_MENU_UPLOADED,
  BUTTON_EDIT,
  BUTTON_DUPLICATE,
  BUTTON_DUPLICATE_IN_SAME_GROUP,
  BUTTON_DUPLICATE_IN_OTHER_AD_GROUP,
  DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE,
  DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS,
  BUTTON_DUPLICATE_IN_SAME_CAMPAIGN,
  BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN,
  DUPLICATE_AD_GROUP_MODAL_TITLE,
  DUPLICATE_AD_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH,
  DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH,
  DUPLICATE_ASSETS_GROUP_MODAL_TITLE,
  DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING,
  MENU_ADD_CATEGORY,
  MENU_CATEGORY_NAME_PLACEHOLDER,
  MENU_CATEGORY_REQUIRED,
  BUTTON_MOVE_OTHER_CATEGORY,
  MENU_ADD_PRODUCT,
  MENU_PRODUCT_MIN_VALUE,
  MENU_CREATE_PRODUCT_TITLE,
  MENU_PRODUCT_NAME_PLACEHOLDER,
  MENU_PRODUCT_DESCRIPTION_PLACEHOLDER,
  MENU_PRODUCT_PRICE_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER,
  BUTTON_COPY,
  FIELD_NUMBER_NEGATIVE,
  FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD,
  FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER,
  MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED,
  MODAL_MOVE_PRODUCT_BUTTON,
  MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE,
  MODAL_MOVE_PRODUCT_ARIA_LABEL,
  PRODUCTS,
  PRODUCT,
  MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED,
  MENU_ONBOARDING_TEST_CATEGORY,
  MENU_ONBOARDING_TEST_PRODUCT,
  MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION,
  MENU_ONBOARDING_FINISH_DESCRIPTION,
  MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION,
  MENU_CATEGORY_DUPLICATE,
  MENU_CATEGORY_CREATED,
  MENU_CATEGORY_SAVED,
  MENU_CATEGORY_DELETE_CONFIRMATION_TITLE,
  MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_CATEGORY_DELETED,
  MENU_PRODUCT_DUPLICATE,
  MENU_PRODUCT_DUPLICATE_DESCRIPTION,
  MENU_PRODUCT_CREATED,
  MENU_PRODUCT_SAVED,
  MENU_PRODUCT_DELETE_CONFIRMATION_TITLE,
  MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_PRODUCT_DELETING,
  MENU_PRODUCT_DELETED,
  MENU_PRODUCT_MOVE_SAME_CATEGORY,
  MENU_PRODUCT_MOVED,
  MENU_PRODUCT_CHANGE_STATUS,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION,
  MENU_ACCOMPANIMENT_TYPE_COPIED,
  MENU_ACCOMPANIMENT_DUPLICATED,
  MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION,
  MENU_CATEGORY_DUPLICATE_DESCRIPTION,
  MENU_CATEGORY_DELETING,
  REGISTER_HERE,
  NO_HAVE_ACCOUNT,
  FORGOT_PASSWORD,
  LOG_IN,
  AUTH_LAYOUT_HERO_TITLE,
  AUTH_LAYOUT_HERO_DESCRIPTION,
  AUTH_LAYOUT_PREVIEW_PLACEHOLDER,
  AUTH_LAYOUT_PREVIEW_IMAGE_ALT,
  AUTH_LAYOUT_FEATURE_AI_TITLE,
  AUTH_LAYOUT_FEATURE_AI_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE,
  AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE,
  AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION,
  LOG_GROUP_AUDIENCE_NETWORK,
  LOG_GROUP_FEEDS,
  LOG_GROUP_REELS_STORIES,
  FIELD_EMAIL_REQUIRED,
  ACCOUNT_ROLE_INVALID,
  ERROR_INTERNAL,
  AUTH_INVALID_PASSWORD,
  AUTH_WRONG_PASSWORD,
  AUTH_MANY_REQUESTS,
  AUTH_USER_NOT_FOUND,
  AUTH_EMAIL_ALREADY_EXISTS,
  PHONE_ALREADY_REGISTERED,
  STRIPE_CARD_DECLINED,
  STRIPE_EXPIRED_CARD,
  STRIPE_INCORRECT_CVC,
  STRIPE_PROCESSING_ERROR,
  STRIPE_INCORRECT_NUMBER,
  STRIPE_GENERIC_DECLINE,
  STRIPE_INSUFFICIENT_FUNDS,
  STRIPE_LOST_CARD,
  STRIPE_STOLEN_CARD,
  STRIPE_PROFILE_NOT_FOUND,
  STRIPE_INTENT_AUTH_FAILURE,
  NIT_VALID,
  BUSINESS_NAME_VALID,
  BRAND_NAME_VALID,
  ADDRESS_VALID,
  CATEGORY_VALID,
  SUBCATEGORIES_VALID,
  SHORT_DESCRIPTION_VALID,
  ORDERS_METHODS_VALID,
  LOGO_IMG_VALID,
  COVER_IMG_VALID,
  SCHEDULE_VALID,
  STORES_VALID,
  IS_PLAN_ACTIVE_VALID,
  MENUS_VALID,
  DEFAULT_PAYMENT_METHOD_VALID,
  HAS_DEBT_VALID,
  SUBSCRIPTION_PLAN_VALID,
  REGISTER_COUNTRY_ANSWER,
  REGISTER_COUNTRY_PLACEHOLDER,
  REGISTER_NAME_ANSWER,
  REGISTER_PHONE_ANSWER,
  REGISTER_EMAIL_ANSWER,
  REGISTER_BUSINESS_NAME_ANSWER,
  REGISTER_CATEGORY_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION,
  REGISTER_WEBSITE_ANSWER,
  REGISTER_WEBSITE_ANSWER_DESCRIPTION,
  REGISTER_MONTHLY_SALES_ANSWER,
  REGISTER_BUDGET_MARKETING_ANSWER,
  REGISTER_EMPLOYEES_ANSWER,
  REGISTER_PRODUCT_AVAILABILITY_ANSWER,
  REGISTER_RUT_ANSWER,
  REGISTER_INVIMA_ANSWER,
  REGISTER_ICA_ANSWER,
  REGISTER_YOU_MEET_ANSWER,
  REGISTER_WRITE_PLACEHOLDER,
  REGISTER_SELECT_PLACEHOLDER,
  BUTTON_REGISTER,
  BUTTON_NO_HAVE_DOCUMENT,
  BUTTON_UPLOAD_AFTER,
  REGISTER_COUNTRY_REQUIRED,
  REGISTER_NAME_REQUIRED,
  REGISTER_PHONE_REQUIRED,
  REGISTER_PHONE_NUMERIC_REQUIRED,
  REGISTER_BUSINESS_NAME_REQUIRED,
  REGISTER_CATEGORY_REQUIRED,
  REGISTER_SOCIAL_NETWORK_REQUIRED,
  REGISTER_WEB_SITE_REQUIRED,
  REGISTER_MONTHLY_SALES_REQUIRED,
  REGISTER_BUDGET_MARKETING_REQUIRED,
  REGISTER_EMPLOYEES_REQUIRED,
  REGISTER_PRODUCT_AVAILABILITY_REQUIRED,
  REGISTER_RUT_REQUIRED,
  REGISTER_INVIMA_REQUIRED,
  REGISTER_ICA_REQUIRED,
  REGISTER_YOU_MEET_REQUIRED,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION,
  REGISTER_REGISTERED_ALERT_DESCRIPTION,
  RESTAURANTS,
  FOODS,
  TRAVEL,
  ENTERTAINMENT,
  TECHNOLOGY,
  FITNESS,
  FASHION,
  BEAUTY,
  PETS,
  HOME,
  EMPLOYEES_2_10,
  EMPLOYEES_10_20,
  EMPLOYEES_20_50,
  EMPLOYEES_50_100,
  EMPLOYEES_100_THAN,
  PRODUCT_AVAILABILITY_LOCAL,
  PRODUCT_AVAILABILITY_NATIONAL,
  PRODUCT_AVAILABILITY_INTERNATIONAL,
  INSTAGRAM,
  TIKTOK,
  LINKEDIN,
  GOOGLE,
  YOUTUBE,
  DARK_KITCHEN,
  OTHERS,
  PLEASE_SELECT_COUNTRY,
  BLOCK_PACKAGE_TITLE,
  BLOCK_PACKAGE_DESCRIPTION,
  BLOCK_PLAN_BUTTON_ACTIVATE_PLAN,
  BILLING_AND_PAYMENT_PLAN_TRIAL,
  BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION,
  BILLING_AND_PAYMENT_PLAN_DEACTIVATE,
  BUTTON_INVITED,
  MAIN_FUNCTIONALITY_STEP_1,
  MAIN_FUNCTIONALITY_STEP_2,
  MAIN_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_1,
  PUBLICATIONS_FUNCTIONALITY_STEP_2,
  PUBLICATIONS_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_4,
  PUBLICATION_FUNCTIONALITY_STEP_1,
  PUBLICATION_FUNCTIONALITY_STEP_2,
  PUBLICATION_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_1,
  REVIEW_FUNCTIONALITY_STEP_2,
  REVIEW_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_4,
  REVIEW_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_1,
  MENU_FUNCTIONALITY_STEP_2,
  MENU_FUNCTIONALITY_STEP_3,
  MENU_FUNCTIONALITY_STEP_4,
  MENU_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_6,
  MENU_FUNCTIONALITY_STEP_7,
  MENU_FUNCTIONALITY_STEP_8,
  MENU_FUNCTIONALITY_STEP_9,
  MENU_FUNCTIONALITY_STEP_10,
  MENU_FUNCTIONALITY_STEP_11,
  MENU_FUNCTIONALITY_STEP_12,
  USERS_FUNCTIONALITY_STEP_1,
  USERS_FUNCTIONALITY_STEP_2,
  USERS_FUNCTIONALITY_STEP_3,
  USERS_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_1,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_2,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_3,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_5,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_6,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_7,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_8,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_9,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_10,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_11,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_12,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_13,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_14,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_15,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_16,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_17,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_18,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_19,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_20,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_21,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_22,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_23,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_24,
  CAMPAIGNS_FUNCTIONALITY_STEP_1,
  CAMPAIGNS_FUNCTIONALITY_STEP_2,
  CAMPAIGNS_FUNCTIONALITY_STEP_3,
  CAMPAIGNS_FUNCTIONALITY_STEP_4,
  CAMPAIGNS_FUNCTIONALITY_STEP_5,
  CAMPAIGNS_FUNCTIONALITY_STEP_6,
  CAMPAIGNS_FUNCTIONALITY_STEP_7,
  CAMPAIGNS_FUNCTIONALITY_STEP_8,
  CAMPAIGNS_FUNCTIONALITY_STEP_9,
  CAMPAIGNS_FUNCTIONALITY_STEP_10,
  CAMPAIGNS_FUNCTIONALITY_STEP_11,
  CAMPAIGNS_FUNCTIONALITY_STEP_12,
  CAMPAIGNS_FUNCTIONALITY_STEP_13,
  CAMPAIGNS_FUNCTIONALITY_STEP_14,
  CAMPAIGNS_FUNCTIONALITY_STEP_15,
  CAMPAIGNS_FUNCTIONALITY_STEP_16,
  CAMPAIGNS_FUNCTIONALITY_STEP_17,
  AUTH_SENT_EMAIL_RESET_PASSWORD,
  EMAIL_UNSUBSCRIBE_SUCCESS_TITLE,
  EMAIL_UNSUBSCRIBE_SUCCESS_TEXT,
  EMAIL_UNSUBSCRIBE_ERROR_TITLE,
  EMAIL_UNSUBSCRIBE_ERROR_TEXT,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER,
  AUTH_LOGIN_OWNER_CHIP_LABEL,
  AUTH_LOGIN_OWNER_SUBMIT,
  AUTH_LOGIN_OWNER_NOT_OWNER,
  AUTH_LOGIN_OWNER_GO_TO_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_REGISTER,
  AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD,
  AUTH_PAGE_BRANDING_LOGO_ALT,
  AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER,
  EVENT_RECURRENT_REQUIRED,
  EVENT_HAS_FIELDS_REQUIRED,
  BILLING_AND_PAYMENT_PLAN_CANCELLED,
  COMPANY_INFORMATION_SAVED,
  ALERT_INACTIVE_SHOP_TITLE,
  ALERT_INACTIVE_SHOP_DESCRIPTION,
  ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION,
  BUTTON_YES_I_SURE,
  ERROR_COMPONENT_CURRENT_ROUTE,
  ERROR_COMPONENT_BUTTON_RELOAD_PAGE,
  ERROR_COMPONENT_DESCRIPTION,
  ERROR_COMPONENT_TITLE,
  LESS_500K,
  BETWEEN_500K_1M,
  BETWEEN_1M_2_5M,
  BETWEEN_2_5M_5M,
  MORE_5M,
  LESS_1M,
  BETWEEN_1M_5M,
  BETWEEN_5M_15M,
  BETWEEN_15M_30M,
  BETWEEN_30M_100M,
  MORE_100M,
  LESS_150,
  BETWEEN_150_250,
  BETWEEN_250_650,
  BETWEEN_650_1250,
  MORE_1250,
  LESS_250,
  BETWEEN_250_1250,
  BETWEEN_1250_3750,
  BETWEEN_3750_7500,
  BETWEEN_7500_25K,
  MORE_25K,
  DOCUMENT_CC,
  DOCUMENT_CE,
  DOCUMENT_NUIP,
  DOCUMENT_NIT,
  DOCUMENT_CI,
  DOCUMENT_PASSPORT,
  DOCUMENT_ID,
  DOCUMENT_RUC,
  MISSING_PARAMETERS,
  PASSWORD_INVALID,
  INVALID_SEARCH,
  USER_ID_REQUIRED,
  SHOP_ID_REQUIRED,
  LAST_USER_NOT_DELETED,
  PLAN_TRIAL_USER_USED,
  ORDERS_NOT_FOUND_IN_INTERVAL,
  TYPE_REPORT_NOT_FOUND,
  SHOP_NOT_FOUND,
  PAYMENT_MODEL_INVALID,
  SHOP_NOT_HAS_SOCIAL_NETWORK,
  NO_VALID_PLATFORM_FOUND,
  GETTING_STATISTICS,
  SHOP_BUSINESS_NAME_NOT_FOUND,
  REFERENCE_PROFILES_REQUIRED,
  DECRYPTING_PASSWORD,
  USER_ID_AND_PAYMENT_ID,
  MESSAGES_REQUIRED,
  PLAN_IS_NO_ACTIVE,
  USER_BANNED,
  GETTING_LOCALES,
  GETTING_PROFILE,
  PRODUCTS_NOT_SENT,
  ACCOUNT_NOT_FOUND,
  COLLECTING_INFORMATION_RETRY_AFTER,
  ERROR_OCCURRED,
  FREE_BOT_MESSAGES_LIMIT_REACHED,
  TEXT_REGENERATION_LIMIT_REACHED,
  REFERENCE_VIDEO_ANALYSIS_UNAVAILABLE,
  ACTION_COULD_NOT_BE_COMPLETED,
  PLATFORM_NOT_SENT,
  PLATFORM_APP_REQUEST_LIMIT_REACHED,
  VERIFICATION_CODE_NOT_FOUND,
  ORDER_NOT_FOUND,
  TYPE_OR_PATH_NOT_SENT,
  ID_OR_PATH_NOT_SENT,
  IDS_NOT_SENT,
  ANALYTIC_URL_NOT_SENT,
  ANALYTIC_URL_INVALID,
  EXTRACTING_ANALYTICS,
  CREDENTIALS_INVALID,
  COLLABORATION_PRICE_NOT_BE_NEGATIVE,
  CREDITS_NOT_BE_NEGATIVE,
  PACKAGES_PRICES_NOT_BE_NEGATIVE,
  ROL_REQUIRED,
  SHOP_ID_AND_STORE_ID_REQUIRED,
  PASSWORD_MUST_BE_6_CHARACTERS,
  ALL_USERS_NOT_DELETE,
  SHOP_APPLICANT_NOT_FOUND,
  USER_PASSWORD_NOT_FOUND,
  PLAN_NOT_FOUND,
  SUBSCRIPTION_NOT_CREATED,
  ID_SUBSCRIPTION_NOT_FOUND,
  SUBSCRIPTION_REACTIVATE,
  CUSTOMER_ID_NOT_FOUND,
  APPLICANT_NOT_FOUND,
  SHOP_COUNTRY_NOT_FOUND,
  FINAL_PRICE_NOT_FOUND,
  PAYMENT_FAILED,
  CREDITS_MUST_BE_GREATER_THAN_ZERO,
  CSRF_INVALID,
  INTEGRATION_INFORMATION_NOT_FOUND,
  GETTING_VIDEO,
  UPLOAD_URL_NOT_FOUND,
  UPLOADING_VIDEO,
  STORE_NOT_FOUND,
  NAME_REQUIRED,
  PRICE_REQUIRED,
  CURRENCY_REQUIRED,
  RECURRING_REQUIRED,
  CREATING_PRODUCT,
  CREATING_PRICE,
  CREATING_PAYMENT_LINK,
  GETTING_PAYMENT_LINK,
  MODAL_REVIEW_SCORE_PLACEHOLDER,
  SCORE,
  CHAT_ERROR_SENT_MESSAGE,
  CHAT_DO_PAYMENT,
  CHAT_WRITE_QUESTION_HERE,
  CHAT_WRITE_MESSAGE_HERE,
  CHAT_EMAIL_NO_PERMITTED,
  RESET_PASSWORD_EMAIL_SENT,
  RESET_PASSWORD,
  RESET_PASSWORD_GET_TOKEN_FAILED,
  RESET_PASSWORD_SAVED,
  TOKEN_INVALID,
  TOKEN_EXPIRED,
  NOTIFICATIONS_TITLE,
  NOTIFICATIONS_MARK_READS,
  NOTIFICATIONS_EMPTY,
  NOTIFICATIONS_NO_MORE,
  NOTIFICATIONS_CHECK_NOTIFICATION,
  ONE_SECOND_AGO,
  DATE_DISTANCE,
  CAMPAIGN_FINISH_ONBOARDING,
  CHAT_FIRST_MESSAGE_BOT,
  OWN_DELIVERY,
  CHAT_NO_MORE,
  PUBLICATION_STATUS_PENDING_CONTENT,
  PUBLICATION_STATUS_PENDING_APPROVAL,
  BUTTON_SEND_REVISION,
  BUTTON_APPROVE_CONTENT,
  REVISION_COUNT,
  ONE,
  TWO,
  THREE,
  DATE_HOUR,
  ORDER_CANCELLED_CONFIRMATION,
  ORDER_CANCELLED_CONFIRMATION_BUTTON,
  COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER,
  IG_ACCOUNT_NOT_FOUND,
  IG_DATA_NOT_FOUND,
  BUTTON_UPLOAD_INSTAGRAM,
  BUTTON_CONNECT_INSTAGRAM,
  PLATFORMS_CONNECTED_INSTAGRAM_FAILED,
  PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE,
  PLATFORMS_CONNECTED_META_BLOCKED_TITLE,
  PLATFORMS_CONNECTED_META_POPUP_BLOCKED,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY,
  MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TITLE,
  MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL,
  PLATFORMS_TOKEN_EXPIRED,
  INTEGRATIONS_TERMS_TITLE,
  INTEGRATIONS_TERMS_DESCRIPTION,
  INTEGRATIONS_TERMS_CONTENT,
  LESS_1000,
  BETWEEN_1000_5000,
  BETWEEN_5000_15K,
  BETWEEN_15K_30K,
  BETWEEN_30K_60K,
  MORE_60K,
  BETWEEN_1000_2000,
  BETWEEN_2000_5000,
  BETWEEN_5000_10K,
  MORE_10K,
  DOCUMENT_EIN,
  MENU_SERVICES,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE,
  RESTAURANTS_SUBCATEGORY_FOOD,
  RESTAURANTS_SUBCATEGORY_DRINKS,
  RESTAURANTS_SUBCATEGORY_DESSERTS,
  RESTAURANTS_SUBCATEGORY_COFFEE,
  RESTAURANTS_SUBCATEGORY_HOT_DRINKS,
  RESTAURANTS_SUBCATEGORY_COLD_DRINKS,
  RESTAURANTS_SUBCATEGORY_SOFT_DRINKS,
  RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS,
  RESTAURANTS_SUBCATEGORY_SUSHI,
  RESTAURANTS_SUBCATEGORY_ASIAN,
  RESTAURANTS_SUBCATEGORY_JAPANESE,
  RESTAURANTS_SUBCATEGORY_CHINESE,
  RESTAURANTS_SUBCATEGORY_ITALIAN,
  RESTAURANTS_SUBCATEGORY_MEXICAN,
  RESTAURANTS_SUBCATEGORY_HEALTHY,
  RESTAURANTS_SUBCATEGORY_VEGAN,
  RESTAURANTS_SUBCATEGORY_VEGETARIAN,
  FOODS_SUBCATEGORY_SEASONINGS,
  FOODS_SUBCATEGORY_FOOD,
  FOODS_SUBCATEGORY_GRANOLA,
  FOODS_SUBCATEGORY_DRIED_FRUITS,
  FOODS_SUBCATEGORY_HEALTHY,
  TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM,
  TRAVEL_SUBCATEGORY_RURAL_TOURISM,
  TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM,
  TRAVEL_SUBCATEGORY_NATURE_TOURISM,
  TRAVEL_SUBCATEGORY_CULTURAL_TOURISM,
  TRAVEL_SUBCATEGORY_HEALTH_TOURISM,
  ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT,
  TECHNOLOGY_SUBCATEGORY_PHONES,
  TECHNOLOGY_SUBCATEGORY_COMPUTERS,
  TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES,
  TECHNOLOGY_SUBCATEGORY_ACCESSORIES,
  TECHNOLOGY_SUBCATEGORY_PERIPHERALS,
  TECHNOLOGY_SUBCATEGORY_ELECTRONICS,
  FITNESS_SUBCATEGORY_SPORTSWEAR,
  FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES,
  FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS,
  FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT,
  FASHION_SUBCATEGORY_HAUTE_COUTURE,
  FASHION_SUBCATEGORY_HIPSTER,
  FASHION_SUBCATEGORY_CASUAL,
  FASHION_SUBCATEGORY_CLASSIC,
  FASHION_SUBCATEGORY_ROMANTIC,
  FASHION_SUBCATEGORY_SPORTSWEAR,
  FASHION_SUBCATEGORY_PREPPY,
  FASHION_SUBCATEGORY_GRUNGE,
  FASHION_SUBCATEGORY_VINTAGE,
  BEAUTY_SUBCATEGORY_COSMETICS,
  BEAUTY_SUBCATEGORY_EYE_CARE,
  BEAUTY_SUBCATEGORY_FEMININE_HYGIENE,
  BEAUTY_SUBCATEGORY_FIRST_AID,
  BEAUTY_SUBCATEGORY_HAIR_CARE,
  BEAUTY_SUBCATEGORY_MEDICAL_DEVICES,
  BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT,
  BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS,
  BEAUTY_SUBCATEGORY_MEDICATIONS,
  BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE,
  BEAUTY_SUBCATEGORY_SCALES,
  BEAUTY_SUBCATEGORY_SKIN_CARE,
  BEAUTY_SUBCATEGORY_VITAMINS,
  BEAUTY_SUBCATEGORY_FACIAL_TISSUES,
  PETS_SUBCATEGORY_FOOD,
  PETS_SUBCATEGORY_COSMETICS,
  PETS_SUBCATEGORY_ACCESSORIES,
  PETS_SUBCATEGORY_CLOTHING,
  PETS_SUBCATEGORY_MEDICATIONS,
  HOME_SUBCATEGORY_TEXTILES_CARPETS,
  HOME_SUBCATEGORY_ART_PRINTS,
  HOME_SUBCATEGORY_STORAGE_ORGANIZATION,
  HOME_SUBCATEGORY_PLANT_DECOR,
  HOME_SUBCATEGORY_CURTAINS_BLINDS,
  UPLOAD_NEW_CONTENT,
  MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL,
  BUTTON_RELOAD_PAGE,
  NEW_VERSION_TITLE,
  NEW_VERSION_DESCRIPTION,
  DELIVERY_INTERN_ON_THE_WAY,
  FIELD_EMAIL_REGISTERED,
  MODAL_DISSATISFACTION_COLLABORATION_TITLE,
  MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION,
  MODAL_DISSATISFACTION_COLLABORATION_BUTTON,
  MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT,
  REVIEW_NOT_FOUND,
  REVIEW_IS_NOT_ONE_START,
  DISSATISFACTION_CREDIT_ALREADY_EXISTS,
  MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED,
  BUTTON_REPLACE_IMAGE,
  ADD_URL_PUBLICATION,
  VALUE_EXPRESSED_IN,
  ANY,
  GENDER,
  FIELD_SEARCH_CHATS_MORE_3_CHARACTERS,
  MODAL_SUBSCRIPTION_PRO_ARIA_LABEL,
  MODAL_SUBSCRIPTION_PRO_TITLE_HERO,
  MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO,
  MODAL_SUBSCRIPTION_PRO_TITLE,
  MODAL_SUBSCRIPTION_PRO_SUB_HEADER,
  MODAL_SUBSCRIPTION_PRO_BENEFIT_1,
  MODAL_SUBSCRIPTION_PRO_BUY_BUTTON,
  PAYMENT_REASON_SUBSCRIPTION_PRO,
  NO_ADDED,
  BUTTON_SEE_PUBLICATION_ON,
  REVISIONS,
  CURRENT_CONTENT,
  CURRENT_CONTENT_EMPTY,
  MALE,
  FEMALE,
  COMMENT,
  NO_SEND_CONTENT_FEEDBACK,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION,
  FIELD_NUMBER_0_OR_NEGATIVE,
  FIELD_NUMBER_100_GREATER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1,
  VALUE_GENERAL_CODE_REDEEMED,
  VALUE_WITH_PERCENTAGE,
  FIELD_NUMBER_LESS_THAN,
  FIELD_NUMBER_GREATER_THAN,
  SUPER_ADMIN,
  SELECT_BUSINESS_PLACEHOLDER,
  NAME_AND_LAST_NAME_PLACEHOLDER,
  SELECT_STORE_PLACEHOLDER,
  SELECT_BRAND_PLACEHOLDER,
  MAIN_BRAND_PLACEHOLDER,
  SELECT_BRANDS_PLACEHOLDER,
  NAME_BUSINESS_PLACEHOLDER,
  FIELD_PASSWORD_CHANGE_MIN_LENGTH,
  ORDER_TOTAL_VALUE_DISCOUNT,
  GO_TO_ACCOUNT,
  ORDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED,
  CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION,
  SELECT_TYPE_PLAN_PLACEHOLDER,
  COST_COLLABORATION_PLACEHOLDER,
  CREDITS_PLACEHOLDER,
  TRIAL_DAYS_PLACEHOLDER,
  TYPE_PACKAGE_PLACEHOLDER,
  PRICE_BASIC_PLACEHOLDER,
  COST_COLLABORATION_BASIC_PLACEHOLDER,
  PRICE_GROWTH_PLACEHOLDER,
  COST_COLLABORATION_GROWTH_PLACEHOLDER,
  PLAN_PAY_PER_USE,
  PLAN_PACKAGE,
  PLAN_REGULAR,
  PLAN_ENTERPRISE,
  COLUMN_NAME_BRAND,
  COLUMN_NAME_AGENCY,
  COLUMN_NAME_ADVERTISER,
  COLUMN_NAME_USER,
  COLUMN_NAME_CATEGORY,
  COLUMN_NAME_IS_LOGGED,
  COLUMN_NAME_IS_ACTIVE,
  COLUMN_NAME_PACKAGE,
  COLUMN_NAME_EMAIL,
  COLUMN_NAME_NAME,
  COLUMN_NAME_PHONE,
  COLUMN_NAME_STAFF,
  COLUMN_NAME_ACCEPTED,
  COLUMN_NAME_MONTHLY_SALES,
  COLUMN_NAME_BUDGET_MARKETING,
  COLUMN_NAME_EMPLOYEES,
  COLUMN_NAME_PRODUCT_AVAILABILITY,
  COLUMN_NAME_SOCIAL_NETWORK,
  COLUMN_NAME_WEB_SITE,
  COLUMN_NAME_YOU_MEET,
  COLUMN_NAME_DATE,
  COMMERCIAL_PLACEHOLDER,
  ADD_NEW_OPTION,
  MODAL_COMMERCIAL_TITLE_CREATE,
  MODAL_COMMERCIAL_TITLE_EDIT,
  MODAL_COMMERCIAL_CREATE_COMMERCIAL,
  MODAL_COMMERCIAL_ALREADY_EXIST,
  BUTTON_ADD_SHOP,
  COLUMN_NAME_PLAN,
  COLUMN_NAME_PAYMENT_METHOD,
  COLUMN_NAME_COST_COLLABORATION,
  COLUMN_NAME_CREDITS,
  COLUMN_NAME_COUNTRY,
  PLAN_PAY_PER_USE_NAME,
  PLAN_PACKAGE_NAME,
  BUSINESS_NAME_PLACEHOLDER,
  FIELD_CREDITS_NOT_BE_NEGATIVE,
  FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE,
  FIELD_PLAN_PRICES_NOT_BE_NEGATIVE,
  FIELD_STAFF_IS_REQUIRED,
  FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE,
  USERS,
  STORES,
  PLAN,
  AUTOMATIC_RENOVATION,
  DEACTIVATED,
  ACTIVE,
  MODAL_CREATE_PAYMENT_LINK_TITLE,
  MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL,
  MODAL_CREATE_PAYMENT_LINK_LINKS,
  MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY,
  MODAL_CREATE_PAYMENT_LINK_NAME,
  DESCRIPTION_OPTIONAL_PLACEHOLDER,
  PRICE_PLACEHOLDER,
  CURRENCY_PLACEHOLDER,
  IS_RECURRENCE_PLACEHOLDER,
  RECURRENCE_PLACEHOLDER,
  RECURRENT_OPTION,
  RECURRING_DAYS,
  RECURRING_WEEKS,
  RECURRING_MONTHS,
  RECURRING_YEARS,
  FIELD_BOTH_DATES_REQUIRED,
  FIELD_START_DATE_GREATER_THAN_END_DATE,
  SOMETHING_ERROR_GENERATING_STATISTICS,
  BUTTON_DOWNLOAD_REPORT,
  META_INTEGRATION_UNLINKED_PAGES_ERROR,
  EDIT,
  MENU_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION,
  CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER,
  THIS_CREATOR_IS_FAVORITE,
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  REDEEM_CODE_TABLE_COLUMN_TERMS,
  BUTTON_GENERATE_COMMENT,
  FAVORITES_CATEGORY,
  EMAIL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION,
  BUTTON_GENERATE_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  BUTTON_UPLOAD_LOGO,
  BUTTON_REPLACE_LOGO,
  BUTTON_UPLOAD_BACKGROUND,
  BUTTON_REPLACE_BACKGROUND,
  BUTTON_REMOVE_BACKGROUND,
  BUTTON_REGENERATE_CONTENT,
  SUB_MENU_SOCIAL_FEED,
  CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE,
  ORDERS_REMEMBER_MARK_AS_DELIVERED,
  BUTTON_CONTINUOUS,
  CREATE_CAMPAIGN_GOAL_QUESTION,
  CREATE_CAMPAIGN_GOAL_PLACEHOLDER,
  CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION,
  CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION,
  CREATE_CAMPAIGN_GOAL_LEADS_OPTION,
  CREATE_CAMPAIGN_GOAL_SALES_OPTION,
  CREATE_CAMPAIGN_GOAL_REQUIRED,
  CAMPAIGN_GOAL_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR,
  MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS,
  MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT,
  MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS,
  CAMPAIGN_REPOST_PLACEHOLDER_ITEM,
  PAYMENT_METHOD_NOT_FOUND,
  HAS_PENDING_PAYMENTS,
  CREATE_CAMPAIGN_TRAFFIC_LINK_VALID,
  ORDER_ID,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL,
  ENGLISH,
  SPANISH,
  CAMPAIGN_FINISHED_TIME,
  DATE_SHORT_LOCALIZED,
  DATE_LONG_LOCALIZED,
  VIEW,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL,
  FIELD_MAX_LENGTH,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING,
  BUTTON_GENERATE_OTHER,
  MODAL_INVOICE_SUBSCRIPTION,
  MODAL_INVOICE_APPLICANT,
  MODAL_INVOICE_FEE,
  MODAL_INVOICE_IVA,
  MODAL_INVOICE_COLLABORATION,
  MODAL_INVOICE_CREDITS,
  MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS,
  BUTTON_SUBSCRIBE_NOW,
  FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE,
  PENDING,
  ACCEPTED,
  ARE_YOU_SURE,
  ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT,
  CHANGE,
  BUTTON_PASS_TO_SUBSCRIPTION_BASIC,
  COLUMN_NAME_CREATOR_NAME,
  COLUMN_NAME_CITY,
  COLUMN_NAME_AUDIENCE,
  COLUMN_NAME_ENGAGEMENT,
  COLUMN_NAME_CATEGORIES,
  COLUMN_NAME_SCORE,
  COLUMN_NAME_ACTIVITY,
  COLUMN_NAME_CREATOR_PLATFORM,
  COLUMN_NAME_ACTIONS,
  COLUMN_NAME_STATUS,
  COLUMN_NAME_REDEEMED_DATE,
  COLUMN_NAME_TERMS,
  COLUMN_NAME_TYPE,
  COLUMN_NAME_ADDRESS,
  COLUMN_NAME_STORE,
  COLUMN_NAME_ROLE,
  COLUMN_NAME_REASON,
  COLUMN_NAME_DUE_DATE,
  COLUMN_NAME_PAID_DATE,
  COLUMN_NAME_VALUE,
  COLUMN_NAME_ID,
  COLUMN_NAME_CREATOR,
  COLUMN_NAME_CREATED_DATE,
  COLUMN_NAME_ACCEPTED_DATE,
  COLUMN_NAME_DETAILS,
  COLUMN_NAME_DELIVERY,
  COLUMN_NAME_CODE_VERIFICATION,
  COLUMN_NAME_ACCOUNT_NAME,
  COLUMN_NAME_IS_HIDDEN,
  COLUMN_NAME_COMMENT,
  BUTTON_EXTEND,
  REPORT_REQUESTS,
  REQUESTS_ACCEPTED,
  REQUESTS_REJECTED,
  REQUESTS_ACTIVE,
  CODE,
  IS_AUTOMATIC,
  REDEEMED,
  EXPIRED,
  EXPIRED_SINGULAR,
  REDEEMED_SINGULAR,
  EMPTY_RESULTS_SHOW_ON_THIS_PAGE,
  CONTENT_TITLE,
  REPORTS_TITLE,
  REPORTS_DESCRIPTION,
  REPORTS_ERROR_GENERATING,
  REPORTS_REQUESTS_ACTIVE,
  REPORTS_REQUESTS_INACTIVE,
  REPORTS_TYPE_USERS,
  REPORTS_NUMBER_USERS,
  REPORTS_TYPE_ORDER,
  REPORTS_NUMBER_ORDER,
  REJECTED,
  ROLE,
  REPORTS_MODAL_DESCRIPTION,
  REPORTS_MODAL_ONLY_BRANDS_ACTIVE,
  REPORTS_MODAL_TYPE_REPORT_LABEL,
  REPORTS_MODAL_TYPE_REPORT_BRANDS,
  REPORTS_MODAL_TYPE_REPORT_CREATORS,
  REPORTS_MODAL_TYPE_REPORT_ORDERS,
  BUTTON_ARCHIVE,
  BUTTON_UNARCHIVE,
  TRANSACTION_CONCEPT_LABEL,
  TRANSACTION_TYPE,
  TRANSACTION_TYPE_CREDIT,
  TRANSACTION_TYPE_DEBIT,
  TRANSACTION_STATUS,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_PENDING_RELEASE,
  TRANSACTION_STATUS_IN_PROCESS_RELEASE,
  TRANSACTION_STATUS_RELEASED,
  TRANSACTION_STATUS_PENDING_SENT,
  TRANSACTION_IN_TRANSIT,
  TRANSACTION_STATUS_PAID,
  UNKNOWN,
  TRANSACTION_WAS_PAID,
  BUTTON_CREATE_TRANSACTION,
  BUTTON_UPDATE_STATISTICS,
  MODAL_CREATE_TRANSACTION,
  MODAL_CREATE_TRANSACTION_AMOUNT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT,
  MODAL_CREATE_TRANSACTION_CONCEPT_ORDER,
  MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL,
  MODAL_CREATE_TRANSACTION_CONCEPT_ID,
  FIELD_END_DATE_GREATER_NOW,
  BUTTON_SEND_PAYMENT,
  BUTTON_VIEW_REPORT,
  REVIEWS,
  REVIEW,
  SHOW_REVIEWS,
  EMPTY_REVIEWS,
  DESCRIPTION_SEND_MESSAGE,
  DESCRIPTION_SEND_PAYMENT,
  SELECT_CAMPAIGN_PLACEHOLDER,
  CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE,
  MODAL_PAY_CREATOR_AMOUNT_LABEL,
  FIELD_MIN_AMOUNT_PAY,
  REGISTER_PASSWORD_ANSWER,
  FIELD_PASSWORD_INSECURE,
  BLOCK_TRIAL_ACTIVE_TITLE,
  BLOCK_TRIAL_ACTIVE_DESCRIPTION,
  BLOCK_TRIAL_ACTIVE_BUTTON,
  MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION,
  TRIAL_CONFIGURING_EXPERIENCE,
  TRIAL_PREPARING_PLATFORM,
  TRIAL_RETRY_ACCESS,
  BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE,
  FIELD_BOTH_PASSWORD_REQUIRED,
  MODAL_FREE_TRIAL_CAPTION,
  BUTTON_ADD_AS_REFERENCE,
  BUTTON_ADDED,
  BUTTON_CREATE_CAMPAIGN2,
  BUTTON_LAUNCH_AD,
  BUTTON_CREATOR_CHAT,
  BUTTON_SEND_FILE,
  COLUMN_NAME_ACTION,
  BUTTON_SEE_MORE,
  BUTTON_SEE_LESS,
  BUTTON_SEND,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL,
  RIGHT,
  LEFT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL,
  LOGO,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL,
  FIELD_FILE_VALID_REQUIRED,
  FIELD_FILE_MAX_SIZE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  BUTTON_YOU_HAVE_DOUBTS,
  BUTTON_WATCH_DEMO,
  CANCEL_ANYTIME,
  NO_IMAGES_FOUND_ON_PAGE,
  FIELD_URL_HTTPS_VALID,
  FIELD_URL_REPEATED,
  ADD_BRAND,
  MODAL_ADD_BRAND_SUPER_ADMIN_TITLE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION,
  DATE_LONG_TEXT,
  DATE,
  BUTTON_SAVE_CONTENT,
  BUTTON_REGENERATE_TEXT,
  DATE_LONG_TEXT_WITH_HOUR,
  DATE_LONG_TEXT_2,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE,
  NO_CREATE_DISCOUNT_SHOPIFY,
  NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY,
  FIELD_ACCESS_TOKEN_SHOPIFY_VALID,
  BUTTON_SEND_BROADCAST,
  MODAL_BROADCAST_CONFIRM_TITLE,
  MODAL_BROADCAST_CONFIRM_DESCRIPTION,
  NAME_BUSINESS_BOT,
  SERVICE_FEE,
  TOTAL_PAYMENT,
  MODAL_USER_TITLE_EDIT,
  MODAL_USER_DESCRIPTION_EDIT,
  MODAL_USER_DESCRIPTION,
  MODAL_CONTACT_TITLE_EDIT,
  MODAL_CONTACT_DESCRIPTION,
  MODAL_CONTACT_DESCRIPTION_EDIT,
  MODAL_STORE_DESCRIPTION_EDIT,
  MODAL_STORE_DESCRIPTION,
  MODAL_STORE_TITLE_EDIT,
  MODAL_STORE_TITLE,
  MODAL_BROADCAST_DESCRIPTION,
  MODAL_COPY_MENU_DESCRIPTION,
  DESIGNER,
  MODAL_CREATE_PAYMENT_LINK_DESCRIPTION,
  BUTTON_ADD_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND,
  OPTION_UGC_FORMAT_GRWM,
  OPTION_UGC_FORMAT_GRWM_EXPLANATION,
  OPTION_UGC_FORMAT_OODT,
  OPTION_UGC_FORMAT_OODT_EXPLANATION,
  OPTION_UGC_FORMAT_HAULS,
  OPTION_UGC_FORMAT_HAULS_EXPLANATION,
  OPTION_UGC_FORMAT_DIYS,
  OPTION_UGC_FORMAT_DIYS_EXPLANATION,
  OPTION_UGC_FORMAT_UNBOXING,
  OPTION_UGC_FORMAT_UNBOXING_EXPLANATION,
  OPTION_UGC_FORMAT_CHALLENGES,
  OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION,
  OPTION_UGC_FORMAT_REVIEWS,
  OPTION_UGC_FORMAT_REVIEWS_EXPLANATION,
  OPTION_UGC_FORMAT_VLOGS,
  OPTION_UGC_FORMAT_VLOGS_EXPLANATION,
  OPTION_UGC_FORMAT_QA,
  OPTION_UGC_FORMAT_QA_EXPLANATION,
  OPTION_UGC_FORMAT_STORYTIME,
  OPTION_UGC_FORMAT_STORYTIME_EXPLANATION,
  OPTION_UGC_FORMAT_ROOM_TOURS,
  OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION,
  OPTION_UGC_FORMAT_COOKING,
  OPTION_UGC_FORMAT_COOKING_EXPLANATION,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION,
  OPTION_UGC_FORMAT_ASMR,
  OPTION_UGC_FORMAT_ASMR_EXPLANATION,
  OPTION_UGC_FORMAT_PLAN_WITH_ME,
  OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION,
  OPTION_UGC_FORMAT_MUKBANG,
  OPTION_UGC_FORMAT_MUKBANG_EXPLANATION,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION,
  SELECT_UGC_CONTENT_FORMAT,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER,
  SUB_MENU_CONTENT_APPLICATION,
  CONTENT_APPLICATION_TITLE,
  COLUMN_NAME_URLS,
  CONTENT_APPLICATION_ACCEPT_TITLE,
  CONTENT_APPLICATION_ACCEPT_DESCRIPTION,
  CONTENT_APPLICATION_REJECT_TITLE,
  CONTENT_APPLICATION_REJECT_DESCRIPTION,
  BUTTON_CONNECT_WOOCOMMERCE,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION,
  BUTTON_ADD_CONTENT,
  BUTTON_SEE_ALL_APPLICANTS,
  REQUEST_REJECT_CONFIRMATION_DESCRIPTION,
  REQUEST_APPROVE_CONFIRMATION_DESCRIPTION,
  MAIN_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_ONBOARDING_FINISH,
  GETTING_INFORMATION_FROM_SHOPIFY_URL,
  LAST_COLLABORATION,
  REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER,
  REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER,
  REGISTER_PROFILE_CREATOR_GENDER_ANSWER,
  REGISTER_PROFILE_CREATOR_AGE_ANSWER,
  REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED,
  REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED,
  REGISTER_PROFILE_CREATOR_GENDER_REQUIRED,
  REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED,
  SELECT_SOME_OPTIONS,
  REGISTER_PROFILE_CREATOR_CITIES_ANSWER,
  REGISTER_PROFILE_CREATOR_CITIES_REQUIRED,
  RATE_DAILY_LIMIT_AI,
  RATE_DAILY_LIMIT_AI_CHAT,
  BUTTON_GO_BACK,
  TOP_RATED_CATEGORY,
  BUTTON_CLEAR_FILTERS,
  PERSONALIZED_INSTRUCTIONS,
  EMPTY_REQUESTS,
  EMPTY_CAMPAIGNS,
  EMPTY_ORDERS,
  EMPTY_REDEEM_CODES,
  EMPTY_USERS,
  EMPTY_CONTACTS,
  EMPTY_INVOICES,
  EMPTY_APPLICANTS_PENDING,
  EMPTY_APPLICANTS_ACCEPTED,
  PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS,
  AUTH_TIKTOK_VERIFICATION_LOADING,
  AUTH_TIKTOK_VERIFICATION_SUCCESS,
  AUTH_TIKTOK_VERIFICATION_FAILED,
  DOCUMENT_ID_EMIRATES,
  DOCUMENT_TRN,
  ADS_CAMPAIGNS_DESCRIPTION,
  ADS_CAMPAIGNS_TITLE,
  EMPTY_ADS_CAMPAIGNS,
  CREATE_ADS_CAMPAIGN_NAME_QUESTION,
  CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION,
  CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_ADS_CAMPAIGN_GENDERS_QUESTION,
  CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
  ADS_CAMPAIGN_OBJECTIVE_LEADS,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS,
  CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION,
  FIELD_NAME_REQUIRED,
  FIELD_OBJECTIVE_REQUIRED,
  FIELD_TYPE_BUDGET_REQUIRED,
  FIELD_BUDGET_REQUIRED,
  FIELD_CURRENCY_MIN_VALUE,
  FIELD_LOCATIONS_REQUIRED,
  FIELD_GENDERS_REQUIRED,
  FIELD_INTERESTS_REQUIRED,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION,
  FIELD_PLATFORMS_REQUIRED,
  CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION,
  CTR,
  CLICKS,
  IMPRESSIONS,
  REPORTS,
  PLATFORMS,
  AGES,
  GENDERS,
  LOCATIONS,
  TARGET_CAMPAIGN,
  ADS_CAMPAIGN_TITLE,
  ADS_CAMPAIGN_HAS_BEEN_FINISHED,
  OBJECTIVE_PLACEHOLDER,
  PLATFORMS_PLACEHOLDER,
  DAILY_BUDGET_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  EXCLUDED_LOCATIONS_PLACEHOLDER,
  AGE_RANGE_PLACEHOLDER,
  GENDERS_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  INDUSTRIES_PLACEHOLDER,
  JOB_FUNCTIONS_PLACEHOLDER,
  SENIORITIES_PLACEHOLDER,
  JOB_TITLES_PLACEHOLDER,
  COMPANY_SIZES_PLACEHOLDER,
  COMPANIES_PLACEHOLDER,
  DEGREES_PLACEHOLDER,
  FIELDS_OF_STUDY_PLACEHOLDER,
  SCHOOLS_PLACEHOLDER,
  SKILLS_PLACEHOLDER,
  MEMBER_TRAITS_PLACEHOLDER,
  MEMBER_BEHAVIORS_PLACEHOLDER,
  MEMBER_GROUPS_PLACEHOLDER,
  AUDIENCE_ATTRIBUTES_PLACEHOLDER,
  DEGREES_SEARCH_PLACEHOLDER,
  FIELDS_OF_STUDY_SEARCH_PLACEHOLDER,
  INTERESTS_SEARCH_PLACEHOLDER,
  SCHOOLS_SEARCH_PLACEHOLDER,
  SKILLS_SEARCH_PLACEHOLDER,
  COMPANIES_SEARCH_PLACEHOLDER,
  INDUSTRIES_SEARCH_PLACEHOLDER,
  COMPANY_SIZES_SEARCH_PLACEHOLDER,
  JOB_FUNCTIONS_SEARCH_PLACEHOLDER,
  JOB_TITLES_SEARCH_PLACEHOLDER,
  SENIORITIES_SEARCH_PLACEHOLDER,
  MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER,
  DESCRIPTION_PLACEHOLDER,
  ADS_CAMPAIGN_HAS_BEEN_ACTIVATE,
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  FIELD_DESCRIPTION_REQUIRED,
  TYPE_LEAST_CHARACTERS,
  LOADING,
  META,
  META_FACEBOOK_AND_INSTAGRAM,
  PLATFORM,
  FIELD_PLATFORM_REQUIRED,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION,
  BUTTON_TIKTOK_BILLING,
  BUTTON_META_BILLING,
  PLATFORM_PLACEHOLDER,
  SUB_MENU_ADS_CAMPAIGNS,
  OBJECTIVE,
  AWARENESS,
  TRAFFIC,
  INTERACTIONS,
  LEADS,
  DOWNLOADS,
  SALES,
  FIELD_VIDEO_REQUIRED,
  FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION,
  BUTTON_REPLACE_CONTENT,
  TIKTOK_CAMPAIGN,
  META_CAMPAIGN,
  ADS_CAMPAIGN_HAS_BEEN_DUPLICATE,
  BUTTON_REPLACE_VIDEO,
  BUTTON_SELECT_VIDEO,
  CONTENT_TO_ADVERTISE,
  FIELD_BEHAVIORS_REQUIRED,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  DEMOGRAPHICS_PLACEHOLDER,
  BUTTON_SELECT_THIS_CONTENT,
  BUTTON_REMOVE_SELECTION,
  IG_BUSINESS_ACCOUNT_NOT_FOUND,
  FACEBOOK_PAGE_ID_NOT_FOUND,
  META_BUSINESS_ACCOUNT_NOT_FOUND,
  CREATE_ADS_CAMPAIGN_TRACKING_QUESTION,
  EMPTY_TRACKING_IDS_META,
  FIELD_META_TRACKING_ID_REQUIRED,
  TRACKING_META_ID_PLACEHOLDER,
  FINISHED,
  ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  ACCOUNT_TOKEN_META_NOT_FOUND,
  ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  OBJECTIVE_CAMPAIGN_META_INVALID,
  SPECIAL_CATEGORY_CAMPAIGN_META_INVALID,
  CAMPAIGN_META_NOT_DELETED,
  CAMPAIGN_META_NOT_CREATED,
  ADS_CAMPAIGN_NOT_FOUND,
  NO_PIXELS_FOUND,
  NO_PIXELS_ACTIVE,
  CAMPAIGN_META_NOT_FOUND,
  CAMPAIGN_META_NOT_UPDATED,
  CAMPAIGN_AD_SET_META_NOT_CREATED,
  CAMPAIGN_AD_SET_META_NOT_UPDATED,
  CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT,
  CAMPAIGN_MEDIA_META_NOT_CREATED,
  CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND,
  CAMPAIGN_CREATIVE_AD_META_NOT_CREATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_FOUND,
  CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND,
  CAMPAIGN_AD_META_NOT_CREATED,
  CAMPAIGN_AD_META_NOT_UPDATED,
  CAMPAIGN_METRICS_META_NOT_FOUND,
  BUTTON_CONNECT_TIKTOK_BUSINESS,
  TIKTOK_BUSINESS,
  EMPTY_TRACKING_IDS_TIKTOK,
  TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE,
  TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS,
  TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR,
  TIKTOK_PRIVACY_LEVEL_SELF_ONLY,
  TIKTOK_PRIVACY_LEVEL_LABEL,
  TIKTOK_ACCOUNT_LABEL,
  TIKTOK_DISABLE_DUET_LABEL,
  TIKTOK_DISABLE_DUET_DESCRIPTION,
  TIKTOK_DISABLE_STITCH_LABEL,
  TIKTOK_DISABLE_STITCH_DESCRIPTION,
  TIKTOK_DISABLE_COMMENT_LABEL,
  TIKTOK_DISABLE_COMMENT_DESCRIPTION,
  TIKTOK_IS_AIGC_LABEL,
  TIKTOK_IS_AIGC_DESCRIPTION,
  SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS,
  CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION,
  FIELD_DESTINATION_URL_REQUIRED,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED,
  CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  BUTTON_RECHARGE_BALANCE,
  ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM,
  INFORMATION,
  DESTINATION_URL_PLACEHOLDER,
  CAMPAIGN_BUDGET_IS_TOO_LOW,
  CAMPAIGN_AUDIENCE_IS_TOO_NARROW,
  PRICE_PRO_PLACEHOLDER,
  COST_COLLABORATION_PRO_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS,
  MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM,
  MODAL_SELECT_PACKAGE_LICENSED_PRICE,
  MODAL_SELECT_PACKAGE_LICENSED_FEE,
  MODAL_SELECT_PACKAGE_COST_CONTENT,
  WOOCOMMERCE,
  SHOPIFY,
  BUTTON_CONNECT_SHOPIFY,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY,
  MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE,
  ALERT_DESCRIPTION_DISCONNECT_FACEBOOK,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK,
  MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT,
  MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE,
  MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS,
  VIDEO_ERROR_ILLEGAL_DURATION,
  VIDEO_ERROR_BLACK_EDGE,
  VIDEO_ERROR_ASPECT_RATIO,
  VIDEO_ERROR_NO_BACKGROUND_AUDIO,
  VIDEO_ERROR_LOW_RESOLUTION,
  IDENTITY_NOT_FOUND,
  TRACKING_TIKTOK_ID_PLACEHOLDER,
  BUTTON_CONNECT_META,
  FIELD_TIKTOK_TRACKING_ID_REQUIRED,
  ENGAGEMENT_ABBREVIATED,
  FOLLOWERS_ABBREVIATED,
  NO_MORE_RESULTS_TO_SHOW,
  PUBLICATION_STATUS_PENDING_SOCIAL,
  ADD_NEW_STYLE,
  WANTS_SOCIAL_MEDIA_POST,
  DOES_NOT_WANTS_SOCIAL_MEDIA_POST,
  BUTTON_CONTACT_AN_ADVISOR,
  BUTTON_GENERATE_SCRIPT,
  EXPLANATION_SEND_ONE_REVISION,
  I_NEED_HELP,
  REVISION_OPTION_GOOD,
  REVISION_OPTION_REGULAR,
  REVISION_OPTION_BAD,
  BUTTON_VIEW_INVOICE,
  MODAL_INVOICE_LICENSE,
  CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER,
  CREATOR_CONTENT_STYLE_PLACEHOLDER,
  CREATOR_CLOTHING_STYLE_PLACEHOLDER,
  CREATOR_BODY_BUILD_PLACEHOLDER,
  BODY_BUILD_THIN,
  BODY_BUILD_AVERAGE,
  BODY_BUILD_WIDE,
  BODY_BUILD_MUSCULAR,
  BODY_BUILD_CURVY,
  BODY_BUILD_ATHLETIC,
  CLOTHING_STYLE_CASUAL,
  CLOTHING_STYLE_FORMAL,
  CLOTHING_STYLE_SPORTY,
  CLOTHING_STYLE_BUSINESS,
  CLOTHING_STYLE_ELEGANT,
  CLOTHING_STYLE_TRENDY,
  CLOTHING_STYLE_STREETWEAR,
  CLOTHING_STYLE_TRADITIONAL,
  CLOTHING_STYLE_VINTAGE,
  CLOTHING_STYLE_BOHEMIAN,
  CLOTHING_STYLE_HIPSTER,
  CLOTHING_STYLE_PUNK,
  CLOTHING_STYLE_GOTHIC,
  DISTINGUISHING_FEATURES_TATTOOS,
  DISTINGUISHING_FEATURES_SCARS,
  DISTINGUISHING_FEATURES_BIRTHMARKS,
  DISTINGUISHING_FEATURES_FRECKLES,
  DISTINGUISHING_FEATURES_MOLES,
  DISTINGUISHING_FEATURES_PIERCINGS,
  DISTINGUISHING_FEATURES_DIMPLES,
  DISTINGUISHING_FEATURES_WRINKLES,
  DISTINGUISHING_FEATURES_GLASSES,
  DISTINGUISHING_FEATURES_BRACES,
  DISTINGUISHING_FEATURES_MAKEUP,
  DISTINGUISHING_FEATURES_HAIR_ACCESSORIES,
  DISTINGUISHING_FEATURES_BEARD,
  DISTINGUISHING_FEATURES_MUSTACHE,
  CONTENT_STYLE_ELEGANT,
  CONTENT_STYLE_AESTHETIC,
  CONTENT_STYLE_RAW,
  CONTENT_STYLE_MINIMALISTIC,
  CONTENT_STYLE_ARTISTIC,
  CONTENT_STYLE_VINTAGE,
  CONTENT_STYLE_MODERN,
  CONTENT_STYLE_PLAYFUL,
  CONTENT_STYLE_RUSTIC,
  CONTENT_STYLE_MONOCHROMATIC,
  REGISTER_PROFILE_CREATOR_BODY_BUILD,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE,
  REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED,
  BUTTON_ADJUST_PREFERENCES,
  FIELD_MAX_LENGTH_SELECT,
  FIELD_MIN_LENGTH_SELECT,
  CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION,
  CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION,
  CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS,
  CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS,
  CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  BUTTON_GENERATE_AGAIN,
  BUTTON_CREATE_ADS_CAMPAIGN,
  WHY_THESE_RECOMMENDED_SETTINGS,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION,
  BUTTON_EDIT_BUDGET,
  CALL_TO_ACTION_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU,
  ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP,
  ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_JOIN,
  ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER,
  ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US,
  ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD,
  ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES,
  ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
  ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME,
  ADS_CAMPAIGN_CALL_TO_ACTION_SAVE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES,
  ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS,
  ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP,
  ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE,
  BUTTON_PUBLISH_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_TITLE,
  CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON,
  PIXEL_REQUIRED,
  ADS_CAMPAIGN_CONTEXT,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE,
  BUTTON_START_CHAT,
  FIELD_WEBSITE_URL_REQUIRED,
  CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION,
  BUTTON_SELECT_CONTENT,
  BUTTON_SELECT_DOCUMENT,
  BUTTON_SELECT_POST,
  FIELD_CONTENT_REQUIRED,
  TYPE_BUDGET_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  DRAFT,
  BUTTON_CREATE_WITH_CANVA,
  BUTTON_CONNECT_CANVA,
  CANVA,
  ALERT_DESCRIPTION_DISCONNECT_CANVA,
  MODAL_CANVA_DESCRIPTION,
  MODAL_CANVA_TITLE,
  MODAL_CANVA_ARIA_LABEL,
  MODAL_CANVA_CREATING_DESIGN,
  MODAL_CANVA_DESIGN_NOT_CREATED,
  MODAL_CANVA_DESIGN_NOT_RETRIEVED,
  MODAL_CANVA_IS_EDITING_IN_CANVA,
  MODAL_CANVA_IS_GETTING_YOUR_DESIGN,
  BUTTON_USE_THIS_CONTENT,
  MODAL_CANVA_INFORMATION_SAVE_DESIGN,
  MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON,
  MODAL_CANVA_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE,
  MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION,
  MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON,
  GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR,
  GOOGLE_DRIVE_OPENING_SELECTOR,
  GOOGLE_DRIVE_IMPORTING_FILES,
  MODAL_CANVA_FOLDER_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_TITLE,
  MODAL_CANVA_DISCONNECT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_BUTTON,
  ERROR_WIDTH_RANGE,
  ERROR_HEIGHT_RANGE,
  CONNECTED_ACCOUNTS,
  CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE,
  CONNECTED_ACCOUNTS_ACCORDION_EXPAND,
  SLIDE_MENU_COLLAPSE,
  SLIDE_MENU_EXPAND,
  CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS,
  CONNECTED_ACCOUNTS_BUTTON_CONNECT,
  CONNECTED_ACCOUNTS_EMPTY_HINT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR,
  CONNECTED_ACCOUNTS_PLATFORM_GOOGLE,
  CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN,
  CONNECTED_ACCOUNTS_PLATFORM_META,
  CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL,
  ADS_CAMPAIGN_USE_GENERAL_BUDGET,
  AD_GROUP,
  AD,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE,
  NUMBER_ITEM,
  TITLES,
  HEADLINES,
  DESCRIPTIONS,
  HEADLINE_PLACEHOLDER,
  TITLE_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION,
  FIELD_START_AND_END_DATES_REQUIRED,
  WEBSITE_URL_PLACEHOLDER,
  COMING_SOON,
  BUTTON_CONNECT_GOOGLE,
  BUTTON_CONNECT_GOOGLE_DRIVE,
  LANGUAGE_CAMPAIGN_PLACEHOLDER,
  FIELD_LANGUAGE_REQUIRED,
  CREATE_ADS_LANGUAGE_QUESTION,
  CREATE_ADS_PLATFORMS_QUESTION,
  BUTTON_DESELECT,
  BUTTON_SELECT,
  BUTTON_SEND_CODE,
  VERIFICATION_CODE_PLACEHOLDER,
  ENTER_CODE,
  AUTH_INVALID_VERIFICATION_CODE,
  BUTTON_VERIFY_CODE,
  WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE,
  MODIFY_PHONE_NUMBER,
  OTP_VERIFICATION_TITLE,
  OTP_VERIFICATION_EMAIL_SENT,
  OTP_BACK_TO_EMAIL,
  ERROR_GETTING_URL_INFORMATION_BY_PROTECTED,
  META_TOGGLE_DESCRIPTION,
  GOOGLE_TOGGLE_DESCRIPTION,
  TIKTOK_TOGGLE_DESCRIPTION,
  NOT_AVAILABLE,
  BUTTON_CONNECTED,
  EDIT_INSTRUCTIONS,
  PROMPT,
  BUTTON_ADD_RE_TARGETING,
  MODAL_CUSTOM_AUDIENCES_DESCRIPTION,
  MODAL_CUSTOM_AUDIENCES_TITLE,
  MODAL_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT,
  TYPE,
  RETENTION_DAYS,
  ERRORS,
  OPERATION_STATUS,
  DELIVERY_STATUS,
  MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL,
  MODAL_CREATE_CUSTOM_AUDIENCE_TITLE,
  MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION,
  RETENTION_DAYS_PLACEHOLDER,
  TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION,
  MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST,
  ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS,
  ADS_SUBSCRIPTION_BENEFIT_USERS,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER,
  VALUE_SUBSCRIPTION_MONTHLY,
  BUTTON_BUY_PLAN,
  MOST_POPULAR,
  PRICING_HERO_DESCRIPTION,
  PRICING_HERO_TITLE_PACKAGES,
  PRICING_HERO_TITLE_CREDITS,
  PRICING_APPSUMO_CREDITS_STACK_TITLE,
  PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION,
  PRICING_CREDIT_USAGE_TITLE,
  PRICING_CREDIT_USAGE_CAMPAIGN,
  PRICING_CREDIT_USAGE_IMAGE,
  PRICING_CREDIT_USAGE_VIDEO,
  PRICING_CREDIT_USAGE_ANIMATE_IMAGE,
  PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK,
  PRICING_CREDIT_USAGE_OPTIMIZATION,
  PRICING_CREDIT_USAGE_SCHEDULED_POST,
  PRICING_CREDIT_USAGE_PER,
  PRICING_CREDIT_USAGE_CREDIT,
  PRICING_CREDIT_USAGE_CREDITS,
  CREDIT_COST_ITEM,
  MANUAL_SEGMENTATION,
  RE_TARGETING_SEGMENTATION,
  BUTTON_ADD,
  BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS,
  ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION,
  BUTTON_UPDATE,
  UPDATING_INFORMATION,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE,
  FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE,
  TITLE,
  IDENTITIES_TIK_TOK_EMPTY,
  IDENTITY_TIK_TOK_PLACEHOLDER,
  ADD_NEW_IDENTITY,
  PROFILE_IMAGE_PLACEHOLDER,
  PROFILE_NAME_PLACEHOLDER,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION,
  MENU_CONNECTED_ACCOUNTS,
  GENERAL_INFORMATION,
  CONTEXT,
  FIELD_TRACKING_IDS_REQUIRED,
  CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION,
  AUTH_INVALID_APP_CREDENTIAL,
  LOADING_METRICS_FROM_PLATFORMS,
  CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED,
  HOW_IS_YOUR_CAMPAIGN_GOING,
  AN_ERROR_OCCURRED_GETTING_THE_REPORT,
  META_ERROR_GETTING_USER_INFORMATION,
  META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  META_OAUTH_PERMISSIONS_ERROR,
  META_ACCOUNT_AUTHENTICATION_REQUIRED,
  AD_ACCOUNTS,
  FACEBOOK_PAGES,
  INSTAGRAM_ACCOUNTS,
  AD_ACCOUNT_META_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION,
  AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  FIELD_AD_ACCOUNTS_REQUIRED,
  INSTAGRAM_ACCOUNT_PLACEHOLDER,
  USE_FB_PAGE_AS_IG,
  YOUTUBE_ACCOUNT_PLACEHOLDER,
  YOUTUBE_PRIVACY_LEVEL_PUBLIC,
  YOUTUBE_PRIVACY_LEVEL_UNLISTED,
  YOUTUBE_PRIVACY_LEVEL_PRIVATE,
  YOUTUBE_PRIVACY_LEVEL_LABEL,
  YOUTUBE_TITLE_LABEL,
  YOUTUBE_DESCRIPTION_LABEL,
  YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL,
  YOUTUBE_MADE_FOR_KIDS_LABEL,
  PAGE_FACEBOOK_PLACEHOLDER,
  META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
  META_AD_ACCOUNT_IS_NOT_ACTIVE,
  FIELD_CONTENT_IS_BEING_PROCESSED,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE,
  BUTTON_CONNECT_ACCOUNT,
  CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION,
  CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION,
  META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT,
  MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION,
  MODAL_CLOSE_UNSAVED_CONFIRM,
  META_ADAPT_PLACEMENTS_CONFIRM_TITLE,
  META_ADAPT_PLACEMENTS_CONFIRM_TEXT,
  META_ADAPT_PLACEMENTS_CONFIRM_YES,
  META_ADAPT_PLACEMENTS_CONFIRM_NO,
  META_ADAPT_PLACEMENTS_CHECKBOX_LABEL,
  META_ADAPT_PLACEMENTS_CHECKBOX_COST,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_DONATE,
  ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH,
  ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT,
  ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_LEAD,
  ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION,
  LAST_UPDATE,
  DATE_RELATIVE,
  LAST_UPDATE_DATE_SHORT,
  BUTTON_RESEND_CODE,
  FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR,
  LAST_RECORDED_EVENT_ON,
  NEVER,
  PIXEL_HAS_NO_RECORDED_EVENTS,
  DATE_SHORT_2,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  FORMAT_PLACEHOLDER,
  BUTTON_REPLACE,
  BUTTON_SUPPORT,
  ADS_SUBSCRIPTION_DESCRIPTION,
  ADS_SUBSCRIPTION_TITLE,
  SPEND_FEE,
  IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE,
  BUTTON_REACTIVATE_SUBSCRIPTION,
  BUTTON_CANCEL_SUBSCRIPTION,
  BUTTON_CHANGE_PAYMENT_METHODS,
  ALERT_REACTIVATE_SUBSCRIPTION_TITLE,
  ALERT_PAYMENT_METHOD_CHANGED_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION,
  ALERT_CANCEL_SUBSCRIPTION_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM,
  ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER,
  CUSTOM_EVENT,
  INACTIVE,
  ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK,
  CURRENCY_MISMATCH,
  ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION,
  RETRIEVING_INSTAGRAM_ACCOUNTS,
  RETRIEVING_FACEBOOK_PAGES,
  RETRIEVING_AD_ACCOUNTS,
  RETRIEVING_GENERAL_INFORMATION,
  ENDING_CONNECTION,
  ALERT_POPUP_BLOCKED_DESCRIPTION,
  ALERT_POPUP_BLOCKED_TITLE,
  VERIFYING_YOUR_SESSION,
  ALREADY_HAVE_AN_ACCOUNT,
  GETTING_REQUIRED_INFORMATION,
  VERIFYING_PLATFORMS_INFORMATION,
  CREATING_CAMPAIGN,
  CREATING_AD_GROUPS,
  UPLOADING_CONTENTS,
  CREATING_ADS,
  SAVING_INFORMATION,
  CREATE_ADS_CAMPAIGN_MODE_QUESTION,
  CREATE_ADS_CAMPAIGN_QUICK_MODE,
  CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION,
  FAST,
  EASY,
  AUTOMATED,
  FULL_CONTROL,
  CUSTOMIZE,
  TAILORED,
  ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION,
  BUTTON_DELETE_PLATFORM,
  MODAL_CONNECT_ACCOUNTS_TITLE,
  MODAL_CONNECT_ACCOUNTS_DESCRIPTION,
  TURKISH,
  INDONESIAN,
  KOREAN,
  JAVANESE,
  GERMAN,
  PUNJABI,
  BENGALI,
  ARABIC,
  HINDI,
  MANDARIN,
  JAPANESE,
  RUSSIAN,
  FRENCH,
  PORTUGUESE,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS,
  ADVERTISER_SELECTOR_BRANDS_COUNT,
  ADVERTISER_SELECTOR_NO_RESULTS,
  ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER,
  ADVERTISER_SELECTOR_TRY_ANOTHER_NAME,
  ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON,
  SELECT_ADVERTISER_ID_PLACEHOLDER,
  ADVERTISER_ID_TO_CHANGE_NO_PERMISSION,
  CANNOT_DELETE_MAIN_ADVERTISER,
  RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION,
  ALERT_DUPLICATE_CAMPAIGN_TITLE,
  ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_TITLE,
  CAMPAIGN_CREATED,
  CREATIFY_VIDEO_PREVIEW_CLARIFICATION,
  CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION,
  COPY,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN,
  BUTTON_GENERATE_WITH_AI,
  GENERATING_VIDEO_MESSAGE,
  TASK_ALERT_ESTIMATED_TIME,
  BULGARIAN,
  SLOVAK,
  CROATIAN,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER,
  BUTTON_CHANGE_CONTENT,
  BUTTON_EDIT_CONTENT,
  BUTTON_CHANGE_SLIDE,
  PLATFORM_ONLY_ACCEPTS_VIDEOS,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION,
  SOCIAL_NETWORK_URL_PLACEHOLDER,
  DISCOUNT_CODE_PLACEHOLDER,
  DO_YOU_HAVE_DISCOUNT_CODE,
  DISCOUNT_CODE_NOT_FOUND,
  DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT,
  DISCOUNT_VALUE,
  NORMAL_PRICE,
  CONTENT_NUMERATION,
  ALERT_DELETE_CAMPAIGN_DESCRIPTION,
  ALERT_DELETE_CAMPAIGN_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TEXT,
  FIELD_URL_INSTAGRAM,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER,
  BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  LANGUAGE_PLACEHOLDER,
  SCRIPT_PLACEHOLDER,
  BUTTON_CHANGE_AVATAR,
  BUTTON_SELECT_AVATAR,
  WE_CANT_GET_AVATARS,
  CONTENT_GENERATOR,
  SELECT_BACKGROUND_CONTENT_CLARIFICATION,
  SELECT_BACKGROUND_CONTENT,
  CUSTOM,
  BUTTON_CONTACT_US,
  BUTTON_GENERATE,
  BUTTON_GENERATE_RANDOM,
  SCRIPT_IS_TOO_SHORT,
  FIELD_MIN_CONTENT,
  BUTTON_ADD_SELECTED_CONTENT,
  INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED,
  DANISH,
  BUTTON_LOG_IN_WITH_GOOGLE,
  BUTTON_REGISTER_WITH_GOOGLE,
  EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM,
  CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER,
  OAUTH_IN_WINDOW_NO_COMPLETED,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT,
  BUTTON_CHANGE_LOGO,
  ERROR_PROCESSING_REQUEST,
  ERROR_PROCESSING_CAMPAIGNS,
  ERROR_ANALYZING_LINK_CREATIFY,
  GENERATE_AI_FREE_VIDEO_LIMIT,
  NOT_HAVE_ENOUGH_USAGE_VALUE,
  USAGE_VALUE_NOT_FOUND,
  FAL_AI_CREDENTIALS_INVALID,
  HEYGEN_CREDENTIALS_INVALID,
  GETTING_CREATIFY_VIDEO_DATA,
  COINS,
  VALUE_NUMBER,
  PER_MONTH,
  ACTION_CONFIRM_TEXT,
  BUTTON_UPGRADE_PLAN,
  LABEL_CURRENT_SUBSCRIPTION_PLAN,
  COINS_VALUE,
  CREDITS_VALUE,
  ADS_SUBSCRIPTION_CREDITS_BENEFIT,
  ADS_SUBSCRIPTION_COINS_BENEFIT,
  VALUE_SUBSCRIPTION_PRORATED,
  VALUE_SUBSCRIPTION_AFTER_PRORATED,
  RENEWED_ON,
  EXPIRE_ON,
  YOUR_TRIAL_COINS_END,
  YOUR_TRIAL_CREDITS_END,
  BUTTON_UPGRADE_TO_PAID_PLAN,
  CURRENT_USAGE_TYPE,
  LOADING_PLAN_INFORMATION,
  YOUR_TRIAL_END,
  ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE,
  CREATE_ACTIVATED,
  CREATE_DEACTIVATED,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM,
  FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW,
  FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW,
  FIELD_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW,
  FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW,
  BUTTON_UPGRADE_PLAN_2,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP,
  ALERT_DESCRIPTION_DISCONNECT_GOOGLE,
  EMPTY_TRACKING_IDS_GOOGLE,
  TRACKING_GOOGLE_ID_PLACEHOLDER,
  AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER,
  COINS_EXPLANATION,
  CREDITS_EXPLANATION,
  KEYWORDS_PLACEHOLDER,
  ADS_CAMPAIGN_TYPE_VIDEO,
  ADS_CAMPAIGN_TYPE_SHOPPING,
  ADS_CAMPAIGN_TYPE_SEARCH,
  ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION,
  CAMPAIGN_TYPE_PLACEHOLDER,
  ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  META_DESTINATION_TYPE_PLACEHOLDER,
  META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION,
  CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION,
  VIEWER,
  MARKETER,
  ADVERTISER,
  DELETED,
  ROLE_PLACEHOLDER,
  VIEWER_ROLE_DESCRIPTION_EXPLANATION,
  VIEWER_ROLE_READ_ONLY_CAPABILITY,
  VIEWER_ROLE_TITLE_EXPLANATION,
  VIEWER_CAPABILITY_VIEW_CAMPAIGNS,
  VIEWER_CAPABILITY_VIEW_CONTENT,
  VIEWER_CAPABILITY_VIEW_CALENDAR,
  VIEWER_CAPABILITY_VIEW_REPORTS,
  MARKETER_ROLE_DESCRIPTION_EXPLANATION,
  MARKETER_ROLE_TILE_EXPLANATION,
  ADVERTISER_ROLE_DESCRIPTION_EXPLANATION,
  ADVERTISER_ROLE_TITLE_EXPLANATION,
  DESIGNER_ROLE_TITLE_EXPLANATION,
  ROLE_CAPABILITY_CAN_MANAGE_USERS,
  ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS,
  ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN,
  ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN,
  ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT,
  ROLE_CAPABILITY_CAN_EDIT_GALLERY,
  ROLE_CAPABILITY_CAN_POST,
  ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP,
  ROLE_CAPABILITY_CAN_EDIT_BILLING,
  PASSWORD_CLARIFICATION_IN_EDIT_USER,
  CREATED_AT,
  CREATED_BY,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE,
  BUTTON_BOOK_A_DEMO,
  YEARLY,
  SEMIYEARLY,
  QUARTERLY,
  MONTHLY,
  CPA,
  CPA_CLARIFICATION,
  MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTIC_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_LEAD_CLARIFICATION,
  MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_CLICK_CLARIFICATION,
  MAIN_STATISTIC_CPM_CLARIFICATION,
  MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CPM_CLARIFICATION,
  MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION,
  MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION,
  MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION,
  GENERATING_OPTIMIZATIONS,
  COMPARING_RESULTS_OBTAINED,
  ANALYZING_CAMPAIGN_STATISTICS,
  CAMPAIGN_OPTIMIZED_NAME,
  CAMPAIGN_OPTIMIZED_GENERATED,
  BUTTON_APPLY_OPTIMIZATIONS,
  BUTTON_DISCARD_OPTIMIZATIONS,
  ERROR_NETWORK_CONNECTION,
  FIELD_START_DATE_LESS_THAN_NOW,
  FIELD_END_DATE_LESS_THAN_NOW,
  CAMPAIGN_UPDATED,
  ERROR_ON_AD_GROUP_ID,
  ERROR_ON_AD_ID_OF_AD_GROUP_ID,
  CAMPAIGN_OPTIMIZED,
  APPLYING_OPTIMIZATIONS,
  ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE,
  DATE_DAY_AND_MONTH_SHORT,
  CLICK,
  CPM,
  CPC,
  RESULTS,
  SPEND,
  PERIOD,
  AVERAGE,
  MAIN_ACTIONS_BY_PLATFORM,
  CLICKS_BY_PLATFORM,
  IMPRESSIONS_BY_PLATFORM,
  RECOMMENDATIONS,
  CONCLUSION,
  WEEK_COUNT,
  DAY_COUNT,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY,
  EMPTY_STATISTICS_FOR_DETAILED_REPORT,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  LOCATIONS_TIK_TOK_EMPTY,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION,
  CHAT_DO_A_QUESTION,
  CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN,
  CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION,
  CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS,
  CHAT_BOT_NAME,
  CHAT_BOT_DESCRIPTION,
  CHAT_BOT_WELCOME_MESSAGE,
  CHAT_BOT_WELCOME_MESSAGE_STATISTICS,
  CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS,
  CHAT_BOT_WELCOME_MESSAGE_OWNER,
  CHAT_BOT_WELCOME_DESCRIPTION_OWNER,
  CHAT_ASK_A_QUESTION_OWNER,
  CHAT_REASONING_ANALYZING_USER_MESSAGE,
  CHAT_REASONING_PROCESSING_CAMPAIGN_DATA,
  CHAT_REASONING_GETTING_PERFORMANCE_METRICS,
  CHAT_REASONING_ANALYZING_BEST_PRACTICES,
  CHAT_REASONING_GENERATING_RECOMMENDATIONS,
  TARGET_AUDIENCE_CONTEXT,
  PRODUCT_OR_SERVICE_CONTEXT,
  REQUEST_TIME_OUT,
  TIME_OUT_FOR_PROVIDER,
  ADS_META_DESTINATION_TYPE_ON_VIDEO,
  ADS_META_DESTINATION_TYPE_ON_POST,
  FIELD_POST_ID_REQUIRED_AD_PREVIEW,
  FACEBOOK,
  WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
  ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE,
  ADS_META_DESTINATION_TYPE_WHATSAPP,
  WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  MESSAGE_TEMPLATE_UNSUPPORTED_TITLE,
  MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION,
  BUTTON_CREATE_TEMPLATE,
  MODAL_MESSAGE_TEMPLATE_TITLE,
  MODAL_MESSAGE_TEMPLATE_DESCRIPTION,
  CUSTOMER_TEXTS_PLACEHOLDER,
  LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS,
  CUSTOMER_TEXT_PLACEHOLDER,
  CUSTOMER_TYPE_MESSAGE_PLACEHOLDER,
  GREETING_MESSAGE_PLACEHOLDER,
  CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE,
  CUSTOMER_TYPE_PREFILL_MESSAGE,
  FIRST_USER_MESSAGE,
  GREETING,
  BUTTON_EDIT_TEMPLATE,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  BUTTON_VIEW_DETAILED_REPORT,
  IS_CAROUSEL,
  CARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  FIELD_MIN_CARDS_AD_CAROUSEL,
  BUTTON_SELECT_INSTANT_FORM,
  FORM,
  MODAL_INSTANT_FORMS_LIST_TITLE,
  MODAL_INSTANT_FORMS_LIST_DESCRIPTION,
  INSTANT_FORM_PLACEHOLDER,
  TIKTOK_LEAD_DESTINATION_WEBSITE,
  TIKTOK_LEAD_DESTINATION_INSTANT_FORM,
  TIKTOK_INSTANT_FORM_EDITOR_HINT,
  TIKTOK_INSTANT_FORM_CREATE,
  TIKTOK_INSTANT_FORM_EDITOR_FAILED,
  INTEGRATION_MISSING_PERMISSION,
  TIKTOK_INSTANT_FORM_LOCKED_DESTINATION,
  TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT,
  TIKTOK_INSTANT_FORM_PREVIEW_NAME,
  CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION,
  INSTANT_FORM_SECTION_FORM_TYPE,
  INSTANT_FORM_SECTION_INTRO,
  INSTANT_FORM_SECTION_QUESTIONS,
  INSTANT_FORM_SECTION_END,
  INSTANT_FORM_FIELD_HEADLINE,
  INSTANT_FORM_FIELD_DESCRIPTION,
  INSTANT_FORM_FIELD_CTA,
  MODAL_INSTANT_FORMS_EMPTY_TEXT,
  FORMS,
  MODAL_CREATE_INSTANT_FORM_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TITLE,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME,
  MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL,
  MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS,
  MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT,
  MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_WEBSITE_URL,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER,
  MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT,
  MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT,
  LEAD_FORM_RECOMMENDATION_GENERATING,
  LEAD_FORM_RECOMMENDATION_CANCEL,
  LEAD_FORM_RECOMMENDATION_FAILED,
  LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING,
  QUESTIONS,
  ENTER_ANSWER_PLACEHOLDER,
  ANSWERS,
  ANSWER,
  YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP,
  FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER,
  MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION,
  MODAL_VERIFY_INTEGRATION_SCOPES_TITLE,
  BUTTON_RECONNECT_ACCOUNT,
  BUTTON_RECONNECT,
  ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION,
  ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT,
  ADS_SUBSCRIPTION_BENEFIT_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS,
  ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT,
  CONVERSION_ACTIONS_PLACEHOLDER,
  SEARCH_KEYWORDS_PLACEHOLDER,
  GOOGLE_PHRASE_KEYWORD,
  GOOGLE_PHRASE_KEYWORD_EXPLANATION,
  GOOGLE_EXACT_KEYWORD,
  GOOGLE_EXACT_KEYWORD_EXPLANATION,
  GOOGLE_BROAD_KEYWORD,
  GOOGLE_BROAD_KEYWORD_EXPLANATION,
  GOOGLE_KEYWORDS_EXPLANATION,
  GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL,
  GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD,
  GOOGLE_SEARCH_AD_GROUP_TYPE_DSA,
  GOOGLE_WEBPAGE_CRITERIA_TITLE,
  GOOGLE_WEBPAGE_CRITERIA_EXPLANATION,
  GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL,
  GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL,
  GOOGLE_WEBPAGE_CRITERION_URL_EQUALS,
  GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS,
  FIELD_WEBPAGE_CRITERIA_REQUIRED,
  FIELD_WEBPAGE_CRITERIA_REPEATED,
  GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS,
  GOOGLE_DSA_SETTINGS_TITLE,
  GOOGLE_DSA_SETTINGS_EXPLANATION,
  GOOGLE_DSA_DOMAIN_LABEL,
  GOOGLE_DSA_LANGUAGE_LABEL,
  GOOGLE_WEBPAGES_NOT_ADDED,
  GOOGLE_WEBPAGE_ADD_TITLE,
  GOOGLE_WEBPAGE_EDIT_TITLE,
  GOOGLE_WEBPAGE_URL_LABEL,
  COLUMN_NAME_URL,
  ALERT_DELETE_WEBPAGE_TITLE,
  ALERT_DELETE_WEBPAGE_DESCRIPTION,
  ALERT_DELETE_WEBPAGES_TITLE,
  ALERT_DELETE_WEBPAGES_DESCRIPTION,
  ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH,
  BUTTON_ADD_CONVERSION_ACTION,
  FIELD_MAX_CONTENT,
  IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  LOGO_OF_THE_BRAND_PLACEHOLDER,
  FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS,
  NETWORK_DISPLAY_SETTING_PLACEHOLDER,
  GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_CONTENT_NETWORK,
  GOOGLE_NETWORK_SETTING_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH,
  GOOGLE_AI_MAX_ENABLE_QUESTION,
  GOOGLE_AI_MAX_ACTIVATED,
  GOOGLE_AI_MAX_DEACTIVATED,
  ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE,
  COLUMN_NAME_CPA,
  COLUMN_NAME_CPM,
  COLUMN_NAME_CPC,
  COLUMN_NAME_CONVERSIONS,
  COLUMN_NAME_CTR,
  COLUMN_NAME_CLICKS,
  COLUMN_NAME_IMPRESSIONS,
  COLUMN_NAME_KEYWORD,
  COLUMN_NAME_SEARCH_TERM,
  GOOGLE_SEARCH_TERMS_TITLE,
  GOOGLE_SEARCH_TERMS_DESCRIPTION,
  GOOGLE_SEARCH_TERMS_EMPTY,
  SEARCH_TERM_MATCH_TYPE_BROAD,
  SEARCH_TERM_MATCH_TYPE_PHRASE,
  SEARCH_TERM_MATCH_TYPE_EXACT,
  SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE,
  SEARCH_TERM_MATCH_TYPE_NEAR_EXACT,
  SEARCH_TERM_MATCH_TYPE_AI_MAX,
  EMPTY_KEYWORDS,
  TOP_KEYWORDS,
  BETA,
  ALERT_CONNECT_GOOGLE_BETA_TITLE,
  ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION,
  SAVING_MEDIA,
  PROCESSING_MEDIA_TO_USE,
  TUTORIAL,
  SELECT_RANGE_DATE,
  TO,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY,
  REPORT_BREAKDOWN_PLACEHOLDER,
  MONTH_COUNT,
  BUTTON_FILTER,
  BUTTON_CONNECT_LINKEDIN,
  LINKEDIN_TOGGLE_DESCRIPTION,
  FIELD_TEXT_REPEATED,
  FIELD_IMAGES_REPEATED,
  FIELD_VIDEOS_REPEATED,
  FIELD_MEDIA_FILE_MIN_DIMENSIONS,
  ERROR_WITH_MOBILE_PROVIDER,
  FIELD_KEYWORDS_REPEATED,
  FIELD_KEYWORDS_MAX_LENGTH,
  ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  ADS_CAMPAIGN_CONTEXT_EXAMPLE,
  ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER,
  ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_EXAMPLE,
  ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER,
  FIELDS_REQUIRED,
  BUDGET_PLACEHOLDER,
  WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN,
  BUTTON_REMOVE,
  ADD_PLATFORMS,
  BUTTON_TRY_AGAIN,
  ERROR_GENERATING_CAMPAIGN,
  BUTTON_PUBLISH_CHANGES,
  FIELD_MIN_DAILY_BUDGET,
  BUTTON_ANALYZE,
  BRAND_SETUP_TITLE,
  BUSINESS_DESCRIPTION_PLACEHOLDER,
  SOCIAL_NETWORKS_PLACEHOLDER,
  SOCIAL_NETWORK_EXAMPLE,
  BUSINESS_TEXT_STYLE_PLACEHOLDER,
  THIS_ITEM_HAS_ERRORS,
  FIND_A_LOCATION_PLACEHOLDER,
  BUTTON_DROP_PIN,
  CREATIVE_TYPE_PLACEHOLDER,
  INDIVIDUAL,
  CAROUSEL,
  BUTTON_EDIT_PLACEMENTS,
  MODAL_EDIT_PLACEMENTS_META_TITLE,
  MODAL_EDIT_PLACEMENTS_META_DESCRIPTION,
  MODAL_EDIT_GROUP_CREATIVE_META_TITLE,
  MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION,
  PLACEMENT_META_USE,
  PLACEMENT_META_RESIZE,
  PLACEMENT_META_SELECT_OTHER_CONTENT,
  FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW,
  MARKER_LIST,
  MARKER_NUMBER_LIST,
  MARKER_TYPE,
  MARKER_LNG,
  MARKER_LAT,
  MARKER_RADIUS,
  RADIUS,
  AROUND,
  ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER,
  BUTTON_EDIT_ADVANTAGE_ENHANCES,
  ADVANTAGE_ENHANCES_ACTIVE_COUNT,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  UKRAINIAN,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN,
  ALERT_FILL_BRAND_SETUP_TITLE,
  BUTTON_COMPLETE_INFORMATION,
  KEYWORDS_NEGATIVE_PLACEHOLDER,
  FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED,
  ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE,
  SITE_LINKS_PLACEHOLDER,
  SITE_LINK_TEXT_PLACEHOLDER,
  SITE_LINK_DESCRIPTION_PLACEHOLDER,
  SITE_LINK_FINAL_URL_PLACEHOLDER,
  SITE_LINK_DESCRIPTIONS_PLACEHOLDER,
  SITE_LINK_PLACEHOLDER,
  CALLOUT_TEXT_PLACEHOLDER,
  CALLOUTS_PLACEHOLDER,
  GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION,
  CREATE_ADS_CAMPAIGN_TYPE_QUESTION,
  WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS,
  OPTIONAL,
  CREATE_ADS_CAMPAIGN_DATES_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION,
  FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE,
  COLUMN_NAME_MATCH_TYPE,
  KEYWORD_BROAD_MATCH_TYPE_OPTION,
  KEYWORD_PHRASE_MATCH_TYPE_OPTION,
  KEYWORD_EXACT_MATCH_TYPE_OPTION,
  KEYWORD_PLACEHOLDER,
  KEYWORD_MATCH_TYPE_PLACEHOLDER,
  KEYWORD_TYPE_NORMAL,
  KEYWORD_TYPE_NEGATIVE,
  BUTTON_ADD_KEYWORDS,
  MODAL_EDIT_KEYWORD_TITLE,
  MODAL_ADD_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORD_TITLE,
  ALERT_DELETE_KEYWORD_DESCRIPTION,
  KEYWORDS_NOT_ADDED,
  KEYWORDS_NEGATIVE_NOT_ADDED,
  FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION,
  ENTER_ONE_KEYWORD_PER_LINE,
  BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION,
  FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED,
  META_AD_PREVIEW_AD_BLOCKER_NOTICE,
  FROM_PLACEHOLDER,
  KEYWORDS,
  KEYWORDS_NEGATIVE,
  COLUMN_NAME_SPEND,
  ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS,
  ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS,
  COLUMN_NAME_PLATFORM,
  COLUMN_NAME_RESULTS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA,
  TOTAL_IMPRESSIONS,
  TOTAL_CLICKS,
  TOTAL_CLICK,
  TOTAL_RESULTS,
  TOTAL_SPEND,
  CUSTOM_AUDIENCES,
  CREATIVE,
  BUTTON_CREATE_NEW,
  FIELD_START_DATE_REQUIRED,
  SELECTED,
  ALERT_DELETE_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORDS_DESCRIPTION,
  ROAS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS,
  FORECAST,
  ACTION,
  MODAL_PREVIEW_OPTIMIZATIONS_TITLE,
  MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION,
  WHY_THIS_OPTIMIZATION,
  BUTTON_PREVIEW_OPTIMIZATION,
  COLUMN_NAME_FIELD,
  COLUMN_NAME_CURRENT_VALUE,
  COLUMN_NAME_NEW_VALUE,
  DELETE,
  INSIGHTS,
  CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT,
  BUTTON_CHANGE_CREATIVE,
  BUTTON_APPLIED,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP,
  ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION,
  LONG_HEADLINES,
  VIDEOS_OF_CAMPAIGN_PLACEHOLDER,
  LONG_HEADLINE_PLACEHOLDER,
  LOGO_URLS_PLACEHOLDER,
  ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE,
  ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE,
  SEARCH_THEMES_PLACEHOLDER,
  PRESS_ENTER_TO_ADD_OPTION,
  GOOGLE_SEARCH,
  GOOGLE_P_MAX,
  BUTTON_SKIP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP,
  ASSETS_GROUP,
  DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT,
  YOUTUBE_VIDEO_SOURCE_YOUTUBE,
  YOUTUBE_VIDEO_SOURCE_GALLERY,
  YOUTUBE_VIDEO_SOURCE_URL,
  MODAL_GALLERY_YOUTUBE_TITLE,
  MODAL_GALLERY_YOUTUBE_EMPTY,
  BUTTON_SELECT_FROM_YOUTUBE,
  BUTTON_PUBLISH_VIDEO_ON_YOUTUBE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID,
  YOUTUBE_VIDEO_LINK,
  FIELD_VIDEO_YOUTUBE_URL_INVALID,
  FIELD_MAX_IMAGES_VALID,
  FIELD_MAX_VIDEOS_YOUTUBE_VALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC,
  FIELD_YOUTUBE_VIDEO_DURATION_INVALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID,
  FIELD_MAX_TEXTS_VALID,
  FIELD_MIN_TEXTS_VALID,
  REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE,
  REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE,
  BUTTON_ADD_VIDEO,
  ERROR_ON_ASSETS_GROUP_ID,
  BUTTON_IMPORT_FROM_PLATFORM,
  BUTTON_IMPORT_FROM_GOOGLE_DRIVE,
  BUTTON_CREATE_FROM_SCRATCH,
  BUTTON_CREATE_FROM_TEMPLATES,
  MODAL_IMPORT_ADS_CAMPAIGN_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION,
  BUTTON_IMPORT_CAMPAIGN,
  BUTTON_DUPLICATE_FROM_PLATFORM,
  BUTTON_DUPLICATE_CAMPAIGN,
  MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES,
  STATUS_PLACEHOLDER,
  CAMPAIGNS_NOT_FOUND,
  CAMPAIGNS_TABLE_EXPAND_ROW,
  CAMPAIGNS_TABLE_COLLAPSE_ROW,
  CAMPAIGNS_TABLE_EXPAND_GROUP,
  CAMPAIGNS_TABLE_COLLAPSE_GROUP,
  CAMPAIGNS_TABLE_TREE_EMPTY,
  CAMPAIGNS_TABLE_TREE_ERROR,
  CAMPAIGNS_TABLE_TREE_METRICS_ERROR,
  CAMPAIGNS_TABLE_TREE_ADS_EMPTY,
  CAMPAIGNS_TABLE_SHOW_MORE_ADS,
  CAMPAIGN_SELECTED,
  ALREADY_IMPORTED,
  CREATE_A_CAMPAIGN,
  CREATE_A_CAMPAIGN_FOR_BRAND_NAME,
  BUTTON_SAVE_AND_PUBLISH,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION,
  AD_ACCOUNTS_TITLE,
  SETTINGS_TITLE,
  API_KEYS_TAB_TITLE,
  BYOK_SETTINGS_DESCRIPTION,
  BYOK_DEFAULT_PAYMENT_MODE_LABEL,
  BYOK_DEFAULT_PAYMENT_MODE_HELPER,
  BYOK_PAYMENT_MODE_CREDITS,
  BYOK_PAYMENT_MODE_BYOK,
  BYOK_CONFIGURED_PREVIEW,
  BYOK_NOT_CONFIGURED,
  BYOK_PROVIDER_INPUT_LABEL,
  BYOK_PROVIDER_INPUT_PLACEHOLDER,
  BYOK_SAVE_BUTTON,
  BYOK_SAVING_BUTTON,
  BYOK_SAVE_SUCCESS_TITLE,
  BYOK_SAVE_SUCCESS_DESCRIPTION,
  BYOK_SAVE_ERROR,
  BYOK_PROVIDER_KEYS_TITLE,
  BYOK_PROVIDERS_COUNTER,
  BYOK_KEY_CONFIGURED_STATUS,
  BYOK_NO_KEY_CONFIGURED_STATUS,
  BYOK_REPLACE_KEY,
  BYOK_DELETE_KEY,
  BYOK_DELETE_KEY_TITLE,
  BYOK_DELETE_KEY_DESCRIPTION,
  BYOK_DELETE_KEY_ERROR,
  BYOK_DELETE_KEY_SUCCESS_TITLE,
  BYOK_DELETE_KEY_SUCCESS_DESCRIPTION,
  BYOK_KEY_ENCRYPTED_NOTICE,
  BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION,
  BYOK_PROVIDERS_WILL_BE_USED,
  BYOK_CONFIGURE_MISSING_PROVIDERS,
  MODAL_API_KEYS_ARIA_LABEL,
  BUSINESS_COMPETITORS_PLACEHOLDER,
  COPY_VALUE_IN_OTHER_ADS,
  COPY_VALUES_IN_OTHER_ADS,
  COPY_VALUE_IN_OTHER_ADGROUPS,
  COPY_VALUES_IN_OTHER_ADGROUPS,
  REST_CAMPAIGNS,
  REST_CREATIVES,
  CREATIVES_REMAINING_SHORT,
  FIELD_TITLES_REQUIRED_AD_PREVIEW,
  FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK,
  FIELD_HEADLINES_REQUIRED_AD_PREVIEW,
  FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW,
  USE_CAMPAIGN_BUDGET_PLACEHOLDER,
  GETTING_METRICS,
  GENERATING_REPORT,
  ADS_META_DESTINATION_TYPE_NONE,
  DESTINATION_TYPE_AD_PLACEHOLDER,
  ALL_COPIES_OF_PLATFORM,
  COPIES_OF_AD,
  EXPORT_COPIES_TO_GOOGLE_DRIVE,
  ADVERTISER_ID_NOT_FOUND_GOOGLE,
  CONFIGURED_SITE_LINKS,
  MODAL_SITE_LINKS_TITLE,
  MODAL_SITE_LINKS_DESCRIPTION,
  MODAL_SITE_LINK_TITLE,
  MODAL_SITE_LINK_IMAGE_URL,
  MODAL_SITE_LINK_URL,
  BUTTON_ADD_SITE_LINK,
  BUTTON_EDIT_SITE_LINKS,
  ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE,
  DATA_TYPE_PLACEHOLDER,
  BUTTON_SELECT_CSV_FILE,
  DATA_TYPE_CONTACT_INFORMATION_OPTION,
  DATA_TYPE_CRM_ID_OPTION,
  ALL_CUSTOMERS,
  PURCHASERS,
  HIGH_VALUE_CUSTOMERS,
  DISENGAGED_CUSTOMERS,
  QUALIFIED_LEADS,
  CONVERTED_LEADS,
  PAID_SUBSCRIBERS,
  LOYALTY_SIGN_UPS,
  CART_ABANDONERS,
  CUSTOMER_TYPES_PLACEHOLDER,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_PLACEHOLDER,
  COUNTRY_CODE_PLACEHOLDER,
  POSTAL_CODE_PLACEHOLDER,
  PHONE_PLACEHOLDER,
  NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE,
  BUTTON_DOWNLOAD_TEMPLATE,
  FIELD_MIN_BUDGET,
  VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT,
  ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM,
  WITH_OUT_PLAN,
  CONFIRMATION_USAGE_TEXT,
  BUSINESS_LOGO,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION,
  TIKTOK_CREATE_AD_ACCOUNT_OPTION,
  TIKTOK_CREDIT_BANNER_EYEBROW,
  TIKTOK_CREDIT_BANNER_TITLE,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT,
  TIKTOK_CREDIT_BANNER_CTA,
  TIKTOK_CREDIT_BADGE_TOOLTIP,
  AD_ACCOUNT_CREATED_FROM_BUSINESS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW,
  GUIDE_TIKTOK_AD_ACCOUNT_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_INTRO,
  GUIDE_TIKTOK_AD_ACCOUNT_BACK,
  GUIDE_TIKTOK_AD_ACCOUNT_LINK,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT,
  CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION,
  BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY,
  SQUARE_FORMAT,
  VERTICAL_FORMAT,
  SELECT_RANGE_DATE_PLACEHOLDER,
  CAMPAIGN,
  ADS_CAMPAIGNS_LOGS_TITLE,
  EMPTY_CHANGES,
  CHANGES,
  AD_GROUPS,
  ADS,
  ASSETS_GROUPS,
  CUSTOM_AUDIENCES_PLACEHOLDER,
  CUSTOM_PLACEMENTS_PLACEHOLDER,
  EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER,
  MEDIA_URLS_PLACEHOLDER,
  ADDED,
  REMOVED,
  IT_WAS_CREATED,
  HISTORICAL_CHANGES,
  STATUS_DEACTIVATED,
  STATUS_ACTIVE,
  STATUS_FINISHED,
  MODAL_STEP_DATA_TITLE,
  BUTTON_MARK_AS_DONE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT,
  LINKEDIN_DOCUMENT_PREVIEW_PREV,
  LINKEDIN_DOCUMENT_PREVIEW_NEXT,
  LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT,
  LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL,
  CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION,
  CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR,
  CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION,
  BUTTON_ADD_PRODUCT,
  BUTTON_ADD_SERVICE,
  PRODUCT_URL_PLACEHOLDER,
  SERVICE_URL_PLACEHOLDER,
  PRODUCT_LABEL,
  SERVICE_LABEL,
  PRODUCT_FIELDS_REQUIRED,
  SERVICE_FIELDS_REQUIRED,
  PRODUCT_URL_INVALID,
  SERVICE_URL_INVALID,
  MEDIA_URLS_TAB_SINGULAR_PRODUCT,
  MEDIA_URLS_TAB_SINGULAR_SERVICE,
  MEDIA_URLS_TAB_MULTIPLE_PRODUCTS,
  MEDIA_URLS_TAB_MULTIPLE_SERVICES,
  MEDIA_URLS_MODE_EXPLANATION_PRODUCTS,
  MEDIA_URLS_MODE_EXPLANATION_SERVICES,
  N_NUMBER_SELECTED,
  CALL_TO_ACTIONS_PLACEHOLDER,
  FILTER_BY_STATUS,
  CREATE_ADS_CAMPAIGN_CATALOG_QUESTION,
  ADS_META_DESTINATION_TYPE_CATALOG,
  CATALOG_PLACEHOLDER,
  IS_CATALOG_CAMPAIGN_PLACEHOLDER,
  PROMOTED_PRODUCTS_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE,
  SELECT_CATALOG_IN_CAMPAIGN_LEVEL,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET,
  PRODUCT_SET_PLACEHOLDER,
  PRODUCT_CONFIGURATION_PLACEHOLDER,
  PRODUCT_LIST,
  PRODUCT_LIST_PLACEHOLDER,
  BUTTON_ADD_PRODUCTS,
  MODAL_PRODUCT_LIST_TIKTOK_TITLE,
  MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION,
  SEARCH_PRODUCT_PLACEHOLDER,
  BRAND_PLACEHOLDER,
  RETAILER_ID_PLACEHOLDER,
  SHORT_DESCRIPTION_PLACEHOLDER,
  CURRENT_PRICE_PLACEHOLDER,
  UNIT_PRICE_PLACEHOLDER,
  CUSTOM_LABEL_NUMBER_PLACEHOLDER,
  CUSTOM_NUMBER_PLACEHOLDER,
  URL_PLACEHOLDER,
  INTRO_CARD,
  CATALOG_CARD,
  PROFILE_CARD,
  CREATIVE_FROM_PLACEHOLDER,
  SLIDES_SHOW,
  SINGLE_IMAGE,
  EDIT_CREATIVE_TOOLS_PLACEHOLDER,
  MODIFY_CATALOG_LABELS,
  MODIFY_PRODUCT_TAGS,
  OVERLAY_TYPE_PLACEHOLDER,
  OVERLAY_POSITION_PLACEHOLDER,
  OVERLAY_SHAPE_PLACEHOLDER,
  OVERLAY_COLOR_PLACEHOLDER,
  OVERLAY_OPACITY_PLACEHOLDER,
  OVERLAY_FONT_PLACEHOLDER,
  PRICE_LABEL_PLACEHOLDER,
  AUTO_SHOW_LABEL_PLACEHOLDER,
  SOLID,
  TRANSPARENT,
  MODAL_CATALOG_LABELS_TITLE,
  MODAL_CATALOG_LABELS_DESCRIPTION,
  LABEL_TEXT_PLACEHOLDER,
  AUTOMATIC_LABELS,
  MANUAL_LABEL,
  STRIKETHROUGH_PRICE_PLACEHOLDER,
  PERCENTAGE_OFF_PLACEHOLDER,
  FREE_SHIPPING_PLACEHOLDER,
  RECTANGLE,
  PILL,
  CIRCLE,
  TRIANGLE,
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  OVERLAY_TEXT_COLOR_PLACEHOLDER,
  OVERLAY_TEXT_FONT_PLACEHOLDER,
  MODAL_PRODUCT_TAGS_TITLE_META,
  MODAL_PRODUCT_TAGS_DESCRIPTION_META,
  AUTOMATICALLY_TAG_PRODUCTS,
  ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT,
  APP_PLACEHOLDER,
  ANDROID_DEEP_LINK_PLACEHOLDER,
  IOS_DEEP_LINK_PLACEHOLDER,
  INSTANT_EXPERIENCE,
  BUTTON_SELECT_INSTANT_EXPERIENCE,
  INSTANT_EXPERIENCE_PLACEHOLDER,
  MODAL_INSTANT_EXPERIENCE_LIST_TITLE,
  MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION,
  MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT,
  FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW,
  FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW,
  FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION,
  FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW,
  FILTER_BY_NAME,
  CREATE_ADS_CAMPAIGN_APP_ID_QUESTION,
  ADS_META_DESTINATION_TYPE_APP_STORE,
  ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  DEEP_DESTINATION_APP_URL_PLACEHOLDER,
  CUSTOM_STORE_LISTING_ID_PLACEHOLDER,
  CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER,
  IOS_14_CAMPAIGN_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP,
  UTM_PARAMETERS_PLACEHOLDER,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING,
  BUTTON_DISCONNECTED,
  CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION,
  MERCHANT_CENTER_ID_PLACEHOLDER,
  ALL_PRODUCTS,
  PRODUCTS_TO_PROMOTE_PLACEHOLDER,
  ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION,
  PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION,
  CATEGORY_ANIMALS_PET_SUPPLIES,
  CATEGORY_ARTS_ENTERTAINMENT,
  CATEGORY_BUSINESS_INDUSTRIAL,
  CATEGORY_CAMERAS_OPTICS,
  CATEGORY_CLOTHING_ACCESSORIES,
  CATEGORY_ELECTRONICS,
  CATEGORY_FOOD_BEVERAGES,
  CATEGORY_FURNITURE,
  CATEGORY_HEALTH_BEAUTY,
  CATEGORY_HOME_GARDEN,
  CATEGORY_BABY_TODDLER,
  CATEGORY_HARDWARE,
  CATEGORY_MATURE,
  CATEGORY_MEDIA,
  CATEGORY_VEHICLES_PARTS,
  CATEGORY_OFFICE_SUPPLIES,
  CATEGORY_SPORTING_GOODS,
  CATEGORY_TOYS_GAMES,
  CATEGORY_SOFTWARE,
  CATEGORY_LUGGAGE_BAGS,
  CATEGORY_RELIGIOUS_CEREMONIAL,
  USE_A_SELECTION_OF_PRODUCTS,
  SELECT_PRODUCTS_BY,
  CONDITION,
  PRODUCT_TYPE,
  CHANNEL,
  CUSTOM_LABEL,
  CONDITION_NEW,
  CONDITION_USED,
  CONDITION_REFURBISHED,
  CHANNEL_ONLINE,
  CHANNEL_LOCAL,
  ITEM_ID,
  SELECT_ALL,
  RECOMMENDED_ACTIONS,
  BUTTON_VIEW_ACTION,
  BUTTON_CREATE_CUSTOM_AUDIENCE,
  COLUMN_NAME_CAMPAIGN,
  COLUMN_NAME_BUDGET,
  COLUMN_NAME_CREATED_BY,
  CAMPAIGNS_TABLE_ARIA_LABEL,
  CAMPAIGNS_TABLE_TITLE,
  CAMPAIGNS_STATUS_DRAFT,
  DAY_SLASH_TIME,
  DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD,
  SELECTED_TIME_PERIOD,
  NO_SELECTION,
  BUTTON_CLEAR_ALL,
  BUTTON_RESET_TO_BASIC_METRICS,
  ADS_SCHEDULE_PLACEHOLDER,
  ADS_SCHEDULE_ALWAYS_ON,
  TIMEZONE_PLACEHOLDER,
  USER_TIMEZONE,
  AD_ACCOUNT_TIMEZONE,
  AD_SCHEDULE_PLACEHOLDER,
  DEMOGRAPHICS_BASIC_PLACEHOLDER,
  BUDGET_CONFIGURATION_PLACEHOLDER,
  DESTINATION_TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL,
  SEARCH_BY_NAME_PLACEHOLDER,
  PLACEMENTS_PLACEHOLDER,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION,
  FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED,
  FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED,
  DEVICES_PLACEHOLDER,
  CAMPAIGNS_STATUS_FINISHED,
  ADS_META_DESTINATION_TYPE_APP,
  ADVANTAGE_CATALOG_PLACEHOLDER,
  MANUAL_UPLOAD_PLACEHOLDER,
  FROM_CATALOG,
  MANUAL_UPLOAD,
  PUBLICATION_DESCRIPTION,
  CREATIVE_SOURCE_PLACEHOLDER,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY,
  ADS_CAMPAIGN_META_FALLBACK_CATALOG,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK,
  ADS_CAMPAIGN_META_AD_SETUP,
  ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT,
  MODAL_META_REUSE_CREATIVES_TITLE,
  MODAL_META_REUSE_CREATIVES_DESCRIPTION,
  MODAL_META_REUSE_CREATIVES_EMPTY,
  MODAL_META_REUSE_CREATIVES_VALID,
  MODAL_META_REUSE_CREATIVES_INVALID,
  MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE,
  MODAL_META_REUSE_CREATIVES_CLEAR_FILTER,
  MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN,
  MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY,
  MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS,
  MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE,
  ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE,
  ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT,
  DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER,
  SUGGESTION_BUDGET_TITLE,
  SUGGESTION_BUDGET_TEXT,
  SUGGESTION_BUDGET_PREVIOUS,
  SUGGESTION_BUDGET_CURRENT,
  SUGGESTION_BUDGET_APPLY,
  SUGGESTION_BUDGET_CANCEL,
  SUGGESTION_BUDGET_MINIMUM,
  TITLE_CAMPAIGN_INSTRUCTIONS,
  DOCUMENTS_ATTACHMENT_LABEL,
  MODAL_INSTANT_EXPERIENCE_CREATE_TITLE,
  MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION,
  COVER_CONTENT_PLACEHOLDER,
  ERROR_CREATING_INSTANT_EXPERIENCE,
  ALERT_ARCHIVE_CAMPAIGN_TITLE,
  ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION,
  BUTTON_ARCHIVE_CAMPAIGN,
  CAMPAIGN_REQUEST_ABORTED,
  GOOGLE_ORIGIN_APP,
  GOOGLE_ORIGIN_CALL_FROM_ADS,
  GOOGLE_ORIGIN_GOOGLE_HOSTED,
  GOOGLE_ORIGIN_STORE,
  GOOGLE_ORIGIN_WEBSITE,
  GOOGLE_ORIGIN_YOUTUBE_HOSTED,
  GOOGLE_CATEGORY_ADD_TO_CART,
  GOOGLE_CATEGORY_BEGIN_CHECKOUT,
  GOOGLE_CATEGORY_BOOK_APPOINTMENT,
  GOOGLE_CATEGORY_CONTACT,
  GOOGLE_CATEGORY_CONVERTED_LEAD,
  GOOGLE_CATEGORY_DEFAULT,
  GOOGLE_CATEGORY_DOWNLOAD,
  GOOGLE_CATEGORY_ENGAGEMENT,
  GOOGLE_CATEGORY_GET_DIRECTIONS,
  GOOGLE_CATEGORY_IMPORTED_LEAD,
  GOOGLE_CATEGORY_OUTBOUND_CLICK,
  GOOGLE_CATEGORY_PAGE_VIEW,
  GOOGLE_CATEGORY_PHONE_CALL_LEAD,
  GOOGLE_CATEGORY_PURCHASE,
  GOOGLE_CATEGORY_QUALIFIED_LEAD,
  GOOGLE_CATEGORY_REQUEST_QUOTE,
  GOOGLE_CATEGORY_SIGNUP,
  GOOGLE_CATEGORY_STORE_SALE,
  GOOGLE_CATEGORY_STORE_VISIT,
  GOOGLE_CATEGORY_SUBMIT_LEAD_FORM,
  GOOGLE_CATEGORY_SUBSCRIBE_PAID,
  SEARCH_PLACEHOLDER,
  ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  TRACKING_WEBSITE_EVENTS,
  ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION,
  ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION,
  ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION,
  ADS_TIKTOK_APP_EVENT_LOGIN_OPTION,
  ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION,
  ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SEARCH_OPTION,
  ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION,
  CHOOSE_AN_ADDRESS_PLACEHOLDER,
  FIELD_ADDRESS_REQUIRED_AD_PREVIEW,
  FIELD_DATE_IN_PAST,
  FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE,
  FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE,
  FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
  FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW,
  OFFLINE_EVENTS_PLACEHOLDER,
  DEEP_LINK_PLACEHOLDER,
  TRACKING_EVENTS,
  COLUMN_NAME_CONFIGURE_COLUMNS,
  CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE,
  FIELD_IMAGES_MIN_REQUIRED,
  APP_URL_NOT_FOUND,
  SIZE_FOR_DISPLAY_PLACEHOLDER,
  SIZE_FOR_SEARCH_PLACEHOLDER,
  VALID,
  INVALID,
  SIZE_PLACEHOLDER,
  INSIGHT,
  NOT_READY,
  INSIGHT_APPLIED,
  MAXIMIZE_CONVERSIONS,
  MAXIMIZE_CONVERSION_VALUE,
  MAXIMUM_COST_PER_CLICK_PLACEHOLDER,
  TARGET_CPA_PLACEHOLDER,
  TARGET_ROAS_PLACEHOLDER,
  BIDDING_STRATEGY_TYPE_PLACEHOLDER,
  ADVERTISERS_AVAILABLE_PLACEHOLDER,
  ALL_CONVERSIONS,
  ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  ALL_CONVERSIONS_VALUE,
  APP_EVENT_ADD_TO_CART,
  APP_INSTALL,
  AVERAGE_CART_SIZE,
  AVERAGE_COST,
  AVERAGE_CPC,
  AVERAGE_ORDER_VALUE_MICROS,
  CHECKOUT,
  COMMENTS_METRICS,
  CONVERSION_RATE,
  CONVERSIONS_FROM_INTERACTIONS_RATE,
  CONVERSIONS_VALUE,
  COST_OF_GOODS_SOLD_MICROS,
  COST_PER_ALL_CONVERSIONS,
  COST_PER_APP_EVENT_ADD_TO_CART,
  COST_PER_APP_INSTALL,
  COST_PER_CHECKOUT,
  COST_PER_CONVERSION,
  COST_PER_PURCHASE,
  COST_PER_VIEW_CONTENT,
  CROSS_DEVICE_CONVERSIONS,
  CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  CROSS_SELL_GROSS_PROFIT_MICROS,
  CROSS_SELL_REVENUE_MICROS,
  CROSS_SELL_UNITS_SOLD,
  ENGAGEMENT_RATE,
  FOLLOWS,
  GROSS_PROFIT_MARGIN,
  GROSS_PROFIT_MICROS,
  INTERACTION_RATE,
  INTERACTIONS_METRICS,
  LEAD_COST_OF_GOODS_SOLD_MICROS,
  LEAD_GROSS_PROFIT_MICROS,
  LEAD_REVENUE_MICROS,
  LEAD_UNITS_SOLD,
  LIKES_METRICS,
  ORDERS_METRICS,
  PROFILE_VISITS,
  PURCHASE,
  REVENUE_MICROS,
  SHARES_METRICS,
  VALUE_PER_ALL_CONVERSIONS,
  VALUE_PER_CONVERSION,
  VIDEO_VIEWS_P100,
  VIEW_CONTENT,
  VIEW_THROUGH_CONVERSIONS,
  ACTION_VALUES,
  ACTIONS_METRICS,
  COST_PER_ADD_TO_CART_META,
  ADD_TO_CART_META,
  COST_PER_WEB_IN_STORE_PURCHASE_META,
  WEB_IN_STORE_PURCHASE_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  COST_PER_LINK_CLICK_META,
  LINK_CLICK_META,
  COST_PER_PAGE_ENGAGEMENT_META,
  PAGE_ENGAGEMENT_META,
  COST_PER_PURCHASE_META,
  PURCHASE_META,
  COST_PER_LANDING_PAGE_VIEW_META,
  LANDING_PAGE_VIEW_META,
  COST_PER_POST_ENGAGEMENT_META,
  POST_ENGAGEMENT_META,
  COST_PER_ONSITE_WEB_VIEW_CONTENT_META,
  ONSITE_WEB_VIEW_CONTENT_META,
  COST_PER_ONSITE_WEB_ADD_TO_CART_META,
  ONSITE_WEB_ADD_TO_CART_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  COST_PER_COMMENT_META,
  COMMENT_META,
  COST_PER_ONSITE_WEB_APP_PURCHASE_META,
  ONSITE_WEB_APP_PURCHASE_META,
  COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  COST_PER_VIEW_CONTENT_META,
  VIEW_CONTENT_META,
  COST_PER_WEB_APP_IN_STORE_PURCHASE_META,
  WEB_APP_IN_STORE_PURCHASE_META,
  COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META,
  ONSITE_WEB_APP_ADD_TO_CART_META,
  COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META,
  OFFSITE_SEARCH_ADD_META_LEADS_META,
  COST_PER_POST_META,
  POST_META,
  COST_PER_ONSITE_CONVERSION_POST_SAVE_META,
  ONSITE_CONVERSION_POST_SAVE_META,
  COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META,
  ONSITE_WEB_INITIATE_CHECKOUT_META,
  COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META,
  ONSITE_CONVERSION_POST_NET_SAVE_META,
  COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META,
  ONSITE_WEB_APP_VIEW_CONTENT_META,
  COST_PER_POST_INTERACTION_GROSS_META,
  POST_INTERACTION_GROSS_META,
  COST_PER_ONSITE_WEB_PURCHASE_META,
  ONSITE_WEB_PURCHASE_META,
  COST_PER_ADD_PAYMENT_INFO_META,
  ADD_PAYMENT_INFO_META,
  COST_PER_SEARCH_META,
  SEARCH_META,
  COST_PER_VIDEO_VIEW_META,
  VIDEO_VIEW_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  COST_PER_POST_REACTION_META,
  POST_REACTION_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  COST_PER_INITIATE_CHECKOUT_META,
  INITIATE_CHECKOUT_META,
  COST_PER_LIKE_META,
  LIKE_META,
  AD_CLICK_ACTIONS,
  AD_IMPRESSION_ACTIONS,
  AUCTION_BID,
  AUCTION_COMPETITIVENESS,
  AUCTION_MAX_COMPETITOR_BID,
  CANVAS_AVG_VIEW_PERCENT,
  CANVAS_AVG_VIEW_TIME,
  CATALOG_SEGMENT_ACTIONS,
  CATALOG_SEGMENT_VALUE,
  CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  CONVERSION_VALUES,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PRODUCT_QUANTITY,
  CONVERTED_PRODUCT_VALUE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  CONVERTED_PROMOTED_PRODUCT_VALUE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  COST_PER_15SEC_VIDEO_VIEW,
  COST_PER_15_SEC_VIDEO_VIEW,
  COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  COST_PER_ACTION_TYPE,
  COST_PER_AD_CLICK,
  COST_PER_DDA_COUNT_BY_CONVS,
  COST_PER_ESTIMATED_AD_RECALLERS,
  COST_PER_INLINE_LINK_CLICK,
  COST_PER_INLINE_POST_ENGAGEMENT,
  COST_PER_OBJECTIVE_RESULT,
  COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  COST_PER_OUTBOUND_CLICK,
  COST_PER_RESULT,
  COST_PER_THRUPLAY,
  COST_PER_UNIQUE_ACTION_TYPE,
  COST_PER_UNIQUE_CLICK,
  COST_PER_UNIQUE_CONVERSION,
  COST_PER_UNIQUE_INLINE_LINK_CLICK,
  COST_PER_UNIQUE_OUTBOUND_CLICK,
  CPP,
  DDA_COUNT_BY_CONVS,
  DDA_RESULTS,
  ESTIMATED_AD_RECALLERS,
  INSTAGRAM_PROFILE_FOLLOW,
  FULL_VIEW_IMPRESSIONS,
  FULL_VIEW_REACH,
  INLINE_LINK_CLICK_CTR,
  INLINE_LINK_CLICKS,
  INLINE_POST_ENGAGEMENT,
  INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  INSTANT_EXPERIENCE_CLICKS_TO_START,
  INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  INTERACTIVE_COMPONENT_TAP,
  LANDING_PAGE_VIEW_PER_LINK_CLICK,
  MARKETING_MESSAGES_DELIVERY_RATE,
  OBJECTIVE_RESULT_RATE,
  OBJECTIVE_RESULTS,
  OUTBOUND_CLICKS,
  OUTBOUND_CLICKS_CTR,
  PURCHASE_PER_LANDING_PAGE_VIEW,
  QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  RESULT_RATE,
  RESULTS_METRICS,
  ROAS_METRICS,
  SHOPS_ASSISTED_PURCHASES,
  SOCIAL_SPEND,
  TOTAL_CARD_VIEW,
  VIDEO_30SEC_WATCHED_ACTIONS,
  VIDEO_30_SEC_WATCHED_ACTIONS,
  VIDEO_AVG_TIME_WATCHED_ACTIONS,
  VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  VIDEO_P100_WATCHED_ACTIONS,
  VIDEO_P25_WATCHED_ACTIONS,
  VIDEO_P50_WATCHED_ACTIONS,
  VIDEO_P75_WATCHED_ACTIONS,
  VIDEO_P95_WATCHED_ACTIONS,
  VIDEO_PLAY_ACTIONS,
  VIDEO_PLAY_CURVE_ACTIONS,
  VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  VIDEO_TIME_WATCHED_ACTIONS,
  WEBSITE_CTR,
  WEBSITE_PURCHASE_ROAS,
  BILLED_COST,
  GROSS_IMPRESSIONS,
  CONVERSION_RATE_TIKTOK,
  RESULT_RATE_TIKTOK,
  VIDEO_VIEWS_P100_TIKTOK,
  AVERAGE_VIDEO_PLAY,
  ENGAGEMENT_RATE_TIKTOK,
  FOLLOWS_TIKTOK,
  LIKES_TIKTOK,
  COMMENTS_TIKTOK,
  SHARES_TIKTOK,
  PROFILE_VISITS_TIKTOK,
  COMMENTS_LINKEDIN,
  COMPANY_PAGE_CLICKS_LINKEDIN,
  EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  FOLLOWS_LINKEDIN,
  FULL_SCREEN_PLAYS_LINKEDIN,
  LANDING_PAGE_CLICKS_LINKEDIN,
  LIKES_LINKEDIN,
  REACTIONS_LINKEDIN,
  RETURN_ON_AD_SPEND_LINKEDIN,
  SHARES_LINKEDIN,
  TOTAL_ENGAGEMENTS_LINKEDIN,
  VIDEO_COMPLETIONS_LINKEDIN,
  VIDEO_STARTS_LINKEDIN,
  VIDEO_VIEWS_LINKEDIN,
  ONE_CLICK_LEADS_LINKEDIN,
  ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN,
  LEAD_FORM_COMPLETION_RATE_LINKEDIN,
  VALID_WORK_EMAIL_LEADS_LINKEDIN,
  DOWNLOAD_CLICKS_LINKEDIN,
  DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN,
  DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_COMPLETIONS_LINKEDIN,
  LIVE_VIEWS,
  APP_INSTALL_TIKTOK,
  COST_PER_APP_INSTALL_TIKTOK,
  REGISTRATION,
  COST_PER_REGISTRATION,
  PURCHASE_TIKTOK,
  COST_PER_PURCHASE_TIKTOK,
  PURCHASE_RATE,
  TOTAL_PURCHASE_VALUE,
  APP_EVENT_ADD_TO_CART_TIKTOK,
  COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK,
  CHECKOUT_TIKTOK,
  COST_PER_CHECKOUT_TIKTOK,
  VIEW_CONTENT_TIKTOK,
  COST_PER_VIEW_CONTENT_TIKTOK,
  NEXT_DAY_OPEN,
  DAY7_RETENTION,
  CASH_SPEND,
  VOUCHER_SPEND,
  COST_PER_1000_REACHED,
  CONVERSION_RATE_V2,
  REAL_TIME_CONVERSION,
  REAL_TIME_COST_PER_CONVERSION,
  REAL_TIME_CONVERSION_RATE,
  REAL_TIME_CONVERSION_RATE_V2,
  REAL_TIME_RESULT,
  REAL_TIME_COST_PER_RESULT,
  REAL_TIME_RESULT_RATE,
  SECONDARY_GOAL_RESULT,
  COST_PER_SECONDARY_GOAL_RESULT,
  SECONDARY_GOAL_RESULT_RATE,
  VIDEO_PLAY_ACTIONS_TIKTOK,
  VIDEO_WATCHED_2S,
  VIDEO_WATCHED_6S,
  VIDEO_VIEWS_P25,
  VIDEO_VIEWS_P50,
  VIDEO_VIEWS_P75,
  AVERAGE_VIDEO_PLAY_PER_USER,
  PAID_ENGAGED_VIEW,
  PAID_ENGAGEMENT_ENGAGED_VIEW,
  ENGAGED_VIEW_15S,
  PAID_ENGAGED_VIEW_15S,
  PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  CLICKS_ON_MUSIC_DISC,
  DUET_CLICKS,
  STITCH_CLICKS,
  SOUND_USAGE_CLICKS,
  MUSIC_UPLOAD_TITLE,
  MUSIC_UPLOAD_BUTTON,
  MUSIC_REMOVE_BUTTON,
  MUSIC_UPLOAD_DESCRIPTION,
  ANCHOR_CLICKS,
  ANCHOR_CLICK_RATE,
  CLICKS_ON_HASHTAG_CHALLENGE,
  PROFILE_VISITS_RATE,
  TT_PLAYLIST_VISIT,
  TT_PLAYLIST_VISIT_RATE,
  LIVE_UNIQUE_VIEWS,
  LIVE_EFFECTIVE_VIEWS,
  LIVE_PRODUCT_CLICKS,
  INTERACTIVE_ADD_ON_IMPRESSIONS,
  INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  COUNTDOWN_STICKER_RECALL_CLICKS,
  IX_PAGE_DURATION_AVG,
  IX_PAGE_VIEWRATE_AVG,
  IX_VIDEO_VIEWS,
  IX_VIDEO_VIEWS_P25,
  IX_VIDEO_VIEWS_P50,
  IX_VIDEO_VIEWS_P75,
  IX_VIDEO_VIEWS_P100,
  IX_AVERAGE_VIDEO_PLAY,
  REAL_TIME_APP_INSTALL,
  REAL_TIME_APP_INSTALL_COST,
  REGISTRATION_RATE,
  TOTAL_REGISTRATION,
  COST_PER_TOTAL_REGISTRATION,
  TOTAL_PURCHASE,
  COST_PER_TOTAL_PURCHASE,
  VALUE_PER_TOTAL_PURCHASE,
  TOTAL_ACTIVE_PAY_ROAS,
  TOTAL_PURCHASE_ROAS_DAY0,
  TOTAL_PURCHASE_ROAS_DAY2,
  TOTAL_PURCHASE_ROAS_DAY6,
  TOTAL_PURCHASE_VALUE_DAY0,
  TOTAL_PURCHASE_VALUE_DAY2,
  TOTAL_PURCHASE_VALUE_DAY6,
  APP_EVENT_ADD_TO_CART_RATE,
  TOTAL_APP_EVENT_ADD_TO_CART,
  COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  CHECKOUT_RATE,
  TOTAL_CHECKOUT,
  COST_PER_TOTAL_CHECKOUT,
  VALUE_PER_CHECKOUT,
  TOTAL_CHECKOUT_VALUE,
  VIEW_CONTENT_RATE,
  TOTAL_VIEW_CONTENT,
  COST_PER_TOTAL_VIEW_CONTENT,
  VALUE_PER_TOTAL_VIEW_CONTENT,
  TOTAL_VIEW_CONTENT_VALUE,
  COST_PER_NEXT_DAY_OPEN,
  NEXT_DAY_OPEN_RATE,
  TOTAL_NEXT_DAY_OPEN,
  COST_PER_TOTAL_NEXT_DAY_OPEN,
  COST_PER_DAY7_RETENTION,
  DAY7_RETENTION_RATE,
  TOTAL_DAY7_RETENTION,
  COST_PER_TOTAL_DAY7_RETENTION,
  VALUE_PER_TOTAL_DAY7_RETENTION,
  TOTAL_DAY7_RETENTION_VALUE,
  ADD_PAYMENT_INFO,
  COST_PER_ADD_PAYMENT_INFO,
  ADD_PAYMENT_INFO_RATE,
  TOTAL_ADD_PAYMENT_INFO,
  COST_TOTAL_ADD_PAYMENT_INFO,
  ADD_TO_WISHLIST,
  COST_PER_ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_RATE,
  TOTAL_ADD_TO_WISHLIST,
  COST_PER_TOTAL_ADD_TO_WISHLIST,
  VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  TOTAL_ADD_TO_WISHLIST_VALUE,
  LAUNCH_APP,
  COST_PER_LAUNCH_APP,
  LAUNCH_APP_RATE,
  TOTAL_LAUNCH_APP,
  COST_PER_TOTAL_LAUNCH_APP,
  COMPLETE_TUTORIAL,
  COST_PER_COMPLETE_TUTORIAL,
  COMPLETE_TUTORIAL_RATE,
  TOTAL_COMPLETE_TUTORIAL,
  COST_PER_TOTAL_COMPLETE_TUTORIAL,
  VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  TOTAL_COMPLETE_TUTORIAL_VALUE,
  CREATE_GROUP,
  COST_PER_CREATE_GROUP,
  CREATE_GROUP_RATE,
  TOTAL_CREATE_GROUP,
  COST_PER_TOTAL_CREATE_GROUP,
  VALUE_PER_TOTAL_CREATE_GROUP,
  TOTAL_CREATE_GROUP_VALUE,
  JOIN_GROUP,
  COST_PER_JOIN_GROUP,
  JOIN_GROUP_RATE,
  TOTAL_JOIN_GROUP,
  COST_PER_TOTAL_JOIN_GROUP,
  VALUE_PER_TOTAL_JOIN_GROUP,
  TOTAL_JOIN_GROUP_VALUE,
  CREATE_GAMEROLE,
  COST_PER_CREATE_GAMEROLE,
  CREATE_GAMEROLE_RATE,
  TOTAL_CREATE_GAMEROLE,
  COST_PER_TOTAL_CREATE_GAMEROLE,
  VALUE_PER_TOTAL_CREATE_GAMEROLE,
  TOTAL_CREATE_GAMEROLE_VALUE,
  SPEND_CREDITS,
  COST_PER_SPEND_CREDITS,
  SPEND_CREDITS_RATE,
  TOTAL_SPEND_CREDITS,
  COST_PER_TOTAL_SPEND_CREDITS,
  VALUE_PER_TOTAL_SPEND_CREDITS,
  TOTAL_SPEND_CREDITS_VALUE,
  ACHIEVE_LEVEL,
  COST_PER_ACHIEVE_LEVEL,
  ACHIEVE_LEVEL_RATE,
  TOTAL_ACHIEVE_LEVEL,
  COST_PER_TOTAL_ACHIEVE_LEVEL,
  VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  TOTAL_ACHIEVE_LEVEL_VALUE,
  UNLOCK_ACHIEVEMENT,
  COST_PER_UNLOCK_ACHIEVEMENT,
  UNLOCK_ACHIEVEMENT_RATE,
  TOTAL_UNLOCK_ACHIEVEMENT,
  COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SALES_LEAD,
  COST_PER_SALES_LEAD,
  SALES_LEAD_RATE,
  TOTAL_SALES_LEAD,
  COST_PER_TOTAL_SALES_LEAD,
  VALUE_PER_TOTAL_SALES_LEAD,
  TOTAL_SALES_LEAD_VALUE,
  IN_APP_AD_CLICK,
  COST_PER_IN_APP_AD_CLICK,
  IN_APP_AD_CLICK_RATE,
  TOTAL_IN_APP_AD_CLICK,
  COST_PER_TOTAL_IN_APP_AD_CLICK,
  VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  TOTAL_IN_APP_AD_CLICK_VALUE,
  IN_APP_AD_IMPR,
  COST_PER_IN_APP_AD_IMPR,
  IN_APP_AD_IMPR_RATE,
  TOTAL_IN_APP_AD_IMPR,
  COST_PER_TOTAL_IN_APP_AD_IMPR,
  VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  TOTAL_IN_APP_AD_IMPR_VALUE,
  LOAN_APPLY,
  COST_PER_LOAN_APPLY,
  LOAN_APPLY_RATE,
  TOTAL_LOAN_APPLY,
  COST_PER_TOTAL_LOAN_APPLY,
  LOAN_CREDIT,
  COST_PER_LOAN_CREDIT,
  LOAN_CREDIT_RATE,
  TOTAL_LOAN_CREDIT,
  COST_PER_TOTAL_LOAN_CREDIT,
  LOAN_DISBURSEMENT,
  COST_PER_LOAN_DISBURSEMENT,
  LOAN_DISBURSEMENT_RATE,
  TOTAL_LOAN_DISBURSEMENT,
  COST_PER_TOTAL_LOAN_DISBURSEMENT,
  LOGIN,
  COST_PER_LOGIN,
  LOGIN_RATE,
  TOTAL_LOGIN,
  COST_PER_TOTAL_LOGIN,
  RATINGS,
  GALLERY_VIEW_SCORES,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION,
  GALLERY_SELECTED_COUNT_SINGULAR,
  GALLERY_SELECTED_COUNT_PLURAL,
  GALLERY_FOLDERS_ALL,
  GALLERY_FOLDERS_CREATE_TITLE,
  GALLERY_FOLDERS_NAME,
  GALLERY_FOLDERS_DUPLICATE,
  GALLERY_FOLDERS_CREATE_SUCCESS,
  GALLERY_FOLDERS_MOVE_SUCCESS,
  GALLERY_FOLDERS_CREATE_ERROR,
  GALLERY_FOLDERS_MOVE_ERROR,
  GALLERY_FOLDERS_BAR_ARIA_LABEL,
  GALLERY_FOLDERS_NEW_INLINE,
  GALLERY_UPLOAD_FOLDER_EMPTY,
  GALLERY_FOLDERS_UNASSIGN_SUCCESS,
  GALLERY_FOLDERS_UNASSIGN_ERROR,
  GALLERY_FOLDERS_CREATE_IN,
  GALLERY_FOLDERS_MOVE,
  GALLERY_FOLDERS_MOVE_TITLE,
  GALLERY_FOLDERS_MOVE_DESCRIPTION,
  GALLERY_FOLDERS_DESTINATION,
  GALLERY_FOLDERS_SELECT,
  GALLERY_FOLDERS_DESTINATION_PATH,
  GALLERY_FOLDERS_RENAME_TITLE,
  GALLERY_FOLDERS_RENAME_SUCCESS,
  GALLERY_FOLDERS_RENAME_ERROR,
  GALLERY_FOLDERS_RENAME_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_TITLE,
  GALLERY_FOLDERS_DELETE_TEXT,
  GALLERY_FOLDERS_DELETE_SUCCESS,
  GALLERY_FOLDERS_DELETE_ERROR,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT,
  GALLERY_FILTER_APPROVAL_STATUS,
  CAMPAIGNS_FOLDER_EMPTY,
  CAMPAIGNS_MOVE_SELECTED,
  CAMPAIGNS_FOLDERS_MOVE,
  CAMPAIGNS_FOLDERS_MOVE_TITLE,
  CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION,
  CAMPAIGNS_FOLDERS_MOVE_SUCCESS,
  CAMPAIGNS_FOLDERS_MOVE_ERROR,
  CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS,
  CAMPAIGNS_FOLDERS_UNASSIGN_ERROR,
  CAMPAIGNS_SELECT_ROW,
  COST_PER_RATINGS,
  RATINGS_RATE,
  TOTAL_RATINGS,
  COST_PER_TOTAL_RATINGS,
  VALUE_PER_TOTAL_RATINGS,
  TOTAL_RATINGS_VALUE,
  SEARCH_TIKTOK,
  COST_PER_SEARCH,
  SEARCH_RATE,
  TOTAL_SEARCH,
  COST_PER_TOTAL_SEARCH,
  START_TRIAL,
  COST_PER_START_TRIAL,
  START_TRIAL_RATE,
  TOTAL_START_TRIAL,
  COST_PER_TOTAL_START_TRIAL,
  SUBSCRIBE,
  COST_PER_SUBSCRIBE,
  SUBSCRIBE_RATE,
  TOTAL_SUBSCRIBE,
  COST_PER_TOTAL_SUBSCRIBE,
  VALUE_PER_TOTAL_SUBSCRIBE,
  TOTAL_SUBSCRIBE_VALUE,
  UNIQUE_CUSTOM_APP_EVENTS,
  COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENT_RATE,
  CUSTOM_APP_EVENTS,
  COST_PER_CUSTOM_APP_EVENT,
  VALUE_PER_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENTS_VALUE,
  UNIQUE_AD_IMPRESSION_EVENTS,
  COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  ADS_IMPRESSION_EVENTS,
  COST_PRE_AD_IMPRESSION_EVENT,
  VALUE_PER_AD_IMPRESSION_EVENT,
  TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  TOTAL_AD_IMPRESSION_ROAS,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  AD_IMPRESSION_AD_REVENUE_DAY0,
  AD_IMPRESSION_AD_REVENUE_DAY2,
  AD_IMPRESSION_AD_REVENUE_DAY6,
  COMPLETE_PAYMENT_ROAS,
  COMPLETE_PAYMENT,
  COST_PER_COMPLETE_PAYMENT,
  COMPLETE_PAYMENT_RATE,
  VALUE_PER_COMPLETE_PAYMENT,
  TOTAL_COMPLETE_PAYMENT_RATE,
  TOTAL_LANDING_PAGE_VIEW,
  COST_PER_LANDING_PAGE_VIEW,
  LANDING_PAGE_VIEW_RATE,
  TOTAL_PAGEVIEW,
  COST_PER_PAGEVIEW,
  PAGEVIEW_RATE,
  AVG_VALUE_PER_PAGEVIEW,
  TOTAL_VALUE_PER_PAGEVIEW,
  PAGE_BROWSE_VIEW,
  COST_PER_PAGE_BROWSE_VIEW,
  PAGE_BROWSE_VIEW_RATE,
  TOTAL_PAGE_BROWSE_VIEW_VALUE,
  VALUE_PER_PAGE_BROWSE_VIEW,
  BUTTON_CLICK,
  COST_PER_BUTTON_CLICK,
  BUTTON_CLICK_RATE,
  VALUE_PER_BUTTON_CLICK,
  TOTAL_BUTTON_CLICK_VALUE,
  ONLINE_CONSULT,
  COST_PER_ONLINE_CONSULT,
  ONLINE_CONSULT_RATE,
  VALUE_PER_ONLINE_CONSULT,
  TOTAL_ONLINE_CONSULT_VALUE,
  USER_REGISTRATION,
  COST_PER_USER_REGISTRATION,
  USER_REGISTRATION_RATE,
  VALUE_PER_USER_REGISTRATION,
  TOTAL_USER_REGISTRATION_VALUE,
  PAGE_CONTENT_VIEW_EVENTS,
  COST_PER_PAGE_CONTENT_VIEW_EVENT,
  PAGE_CONTENT_VIEW_EVENT_RATE,
  VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  PRODUCT_DETAILS_PAGE_BROWSE,
  COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  WEB_EVENT_ADD_TO_CART,
  COST_PER_WEB_EVENT_ADD_TO_CART,
  WEB_EVENT_ADD_TO_CART_RATE,
  VALUE_PER_WEB_EVENT_ADD_TO_CART,
  TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  ON_WEB_ORDER,
  COST_PER_ON_WEB_ORDER,
  ON_WEB_ORDER_RATE,
  VALUE_PER_ON_WEB_ORDER,
  TOTAL_ON_WEB_ORDER_VALUE,
  INITIATE_CHECKOUT,
  COST_PER_INITIATE_CHECKOUT,
  INITIATE_CHECKOUT_RATE,
  VALUE_PER_INITIATE_CHECKOUT,
  TOTAL_INITIATE_CHECKOUT_VALUE,
  ADD_BILLING,
  COST_PER_ADD_BILLING,
  ADD_BILLING_RATE,
  VALUE_PER_ADD_BILLING,
  TOTAL_ADD_BILLING_VALUE,
  PAGE_EVENT_SEARCH,
  COST_PER_PAGE_EVENT_SEARCH,
  PAGE_EVENT_SEARCH_RATE,
  VALUE_PER_PAGE_EVENT_SEARCH,
  TOTAL_PAGE_EVENT_SEARCH_VALUE,
  FORM_TIKTOK,
  COST_PER_FORM,
  FORM_RATE,
  VALUE_PER_FORM,
  TOTAL_FORM_VALUE,
  DOWNLOAD_START,
  COST_PER_DOWNLOAD_START,
  DOWNLOAD_START_RATE,
  VALUE_PER_DOWNLOAD_START,
  TOTAL_DOWNLOAD_START_VALUE,
  ON_WEB_ADD_TO_WISHLIST,
  COST_PER_ON_WEB_ADD_TO_WISHLIST,
  ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  ON_WEB_SUBSCRIBE,
  COST_PER_ON_WEB_SUBSCRIBE,
  ON_WEB_SUBSCRIBE_PER_CLICK,
  VALUE_PER_ON_WEB_SUBSCRIBE,
  TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  WEBSITE_TOTAL_FIND_LOCATION,
  WEBSITE_COST_PER_FIND_LOCATION,
  WEBSITE_FIND_LOCATION_RATE,
  WEBSITE_VALUE_PER_FIND_LOCATION,
  WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  WEBSITE_TOTAL_SCHEDULE,
  WEBSITE_COST_PER_SCHEDULE,
  WEBSITE_SCHEDULE_RATE,
  WEBSITE_VALUE_PER_SCHEDULE,
  WEBSITE_TOTAL_SCHEDULE_VALUE,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  CUSTOM_PAGE_EVENTS,
  COST_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENT_RATE,
  VALUE_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENTS_VALUE,
  ONSITE_PURCHASES_ROAS,
  ONSITE_TOTAL_PURCHASE,
  ONSITE_COST_PER_PURCHASE,
  ONSITE_PURCHASE_RATE,
  ONSITE_VALUE_PER_PURCHASE,
  ONSITE_TOTAL_PURCHASE_VALUE,
  ONSITE_TOTAL_CHECKOUT_INITIATION,
  ONSITE_COST_PER_CHECKOUT_INITIATION,
  ONSITE_CHECKOUT_INITIATION_RATE,
  ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  ONSITE_TOTAL_ADD_TO_CART,
  ONSITE_COST_PER_ADD_TO_CART,
  ONSITE_ADD_TO_CART_RATE,
  ONSITE_VALUE_PER_ADD_TO_CART,
  ONSITE_TOTAL_ADD_TO_CART_VALUE,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  ONSITE_ADD_TO_WISHLIST,
  COST_PER_ONSITE_ADD_TO_WISHLIST,
  ONSITE_ADD_TO_WISHLIST_RATE,
  VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  ONSITE_ADD_BILLING,
  COST_PER_ONSITE_ADD_BILLING,
  ONSITE_ADD_BILLING_RATE,
  VALUE_PER_ONSITE_ADD_BILLING,
  TOTAL_ONSITE_ADD_BILLING_VALUE,
  ONSITE_FORM,
  COST_PER_ONSITE_FORM,
  ONSITE_FORM_RATE,
  VALUE_PER_ONSITE_FORM,
  TOTAL_ONSITE_FORM_VALUE,
  ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  ONSITE_DOWNLOAD_START,
  COST_PER_ONSITE_DOWNLOAD_START,
  ONSITE_DOWNLOAD_START_RATE,
  ONSITE_DESTINATION_VISITS,
  COST_PER_ONSITE_DESTINATION_VISIT,
  ONSITE_DESTINATION_VISIT_RATE,
  IX_PAGE_VIEW_COUNT,
  COST_PER_IX_PAGE_VIEW_COUNT,
  IX_PAGE_VIEW_COUNT_RATE,
  IX_BUTTON_CLICK_COUNT,
  COST_PER_IX_BUTTON_CLICK_COUNT,
  IX_BUTTON_CLICK_COUNT_RATE,
  IX_PRODUCT_CLICK_COUNT,
  COST_PER_IX_PRODUCT_CLICK_COUNT,
  IX_PRODUCT_CLICK_COUNT_RATE,
  OFFLINE_TOTAL_CRM_EVENTS,
  OFFLINE_COST_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_RATE,
  OFFLINE_VALUE_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_VALUE,
  OFFLINE_SHOPPING_EVENTS,
  COST_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENT_RATE,
  VALUE_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENTS_VALUE,
  OFFLINE_SHOPPING_EVENTS_ROAS,
  OFFLINE_CONTACT_EVENTS,
  COST_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENT_RATE,
  VALUE_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENTS_VALUE,
  OFFLINE_SUBSCRIBE_EVENTS,
  COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENT_RATE,
  VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  OFFLINE_FORM_EVENTS,
  COST_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENT_RATE,
  VALUE_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENTS_VALUE,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  OFFLINE_ADD_TO_CART_EVENTS,
  COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  OFFLINE_ADD_TO_WISHLIST_EVENTS,
  COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  OFFLINE_CLICK_BUTTON_EVENTS,
  COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENT_RATE,
  VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  OFFLINE_DOWNLOAD_EVENTS,
  COST_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENT_RATE,
  VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENTS_VALUE,
  OFFLINE_INITIATE_CHECKOUT_EVENTS,
  COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  OFFLINE_PLACE_ORDER_EVENTS,
  COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENT_RATE,
  VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  OFFLINE_SEARCH_EVENTS,
  COST_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENT_RATE,
  VALUE_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENTS_VALUE,
  OFFLINE_VIEW_CONTENT_EVENTS,
  COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENT_RATE,
  VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  OFFLINE_PREFERRED_LEADS,
  OFFLINE_COST_PER_PREFERRED_LEAD,
  OFFLINE_PREFERRED_LEAD_RATE,
  OFFLINE_TOTAL_FIND_LOCATION,
  OFFLINE_COST_PER_FIND_LOCATION,
  OFFLINE_FIND_LOCATION_RATE,
  OFFLINE_VALUE_PER_FIND_LOCATION,
  OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  OFFLINE_TOTAL_SCHEDULE,
  OFFLINE_COST_PER_SCHEDULE,
  OFFLINE_SCHEDULE_RATE,
  OFFLINE_VALUE_PER_SCHEDULE,
  OFFLINE_TOTAL_SCHEDULE_VALUE,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  OFFLINE_TOTAL_CUSTOM_EVENTS,
  OFFLINE_COST_PER_CUSTOM_EVENT,
  OFFLINE_CUSTOM_EVENT_RATE,
  OFFLINE_VALUE_PER_CUSTOM_EVENT,
  OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  ONSITE_SHOPPING_ROAS,
  ONSITE_SHOPPING,
  COST_PER_ONSITE_SHOPPING,
  ONSITE_SHOPPING_RATE,
  VALUE_PER_ONSITE_SHOPPING,
  TOTAL_ONSITE_SHOPPING_VALUE,
  SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  SHOP_TOTAL_ITEMS_PURCHASED,
  ONSITE_INITIATE_CHECKOUT_COUNT,
  COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  ONSITE_ON_WEB_DETAIL,
  COST_PER_ONSITE_ON_WEB_DETAIL,
  ONSITE_ON_WEB_DETAIL_RATE,
  VALUE_PER_ONSITE_ON_WEB_DETAIL,
  TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  ONSITE_ON_WEB_CART,
  COST_PER_ONSITE_ON_WEB_CART,
  ONSITE_ON_WEB_CART_RATE,
  VALUE_PER_ONSITE_ON_WEB_CART,
  TOTAL_ONSITE_ON_WEB_CART_VALUE,
  VTA_CONVERSION,
  COST_PER_VTA_CONVERSION,
  CTA_CONVERSION,
  COST_PER_CTA_CONVERSION,
  ENGAGED_VIEW_THROUGH_CONVERSIONS,
  COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  VTA_APP_INSTALL,
  COST_PER_VTA_APP_INSTALL,
  CTA_APP_INSTALL,
  COST_PER_CTA_APP_INSTALL,
  EVTA_APP_INSTALL,
  COST_PER_EVTA_APP_INSTALL,
  VTA_REGISTRATION,
  COST_PER_VTA_REGISTRATION,
  CTA_REGISTRATION,
  COST_PER_CTA_REGISTRATION,
  EVTA_REGISTRATION,
  COST_PER_EVTA_REGISTRATION,
  VTA_PURCHASE,
  COST_PER_VTA_PURCHASE,
  CTA_PURCHASE,
  COST_PER_CTA_PURCHASE,
  EVTA_PURCHASE,
  COST_PER_EVTA_PURCHASE,
  VTA_COMPLETE_PAYMENT,
  COST_PER_VTA_PAYMENTS_COMPLETED,
  EVTA_PAYMENTS_COMPLETED,
  COST_PER_EVTA_PAYMENTS_COMPLETED,
  VTA_COMPLETE_PAYMENT_VALUE,
  VTA_COMPLETE_PAYMENT_ROAS,
  SKAN_RESULT,
  SKAN_COST_PER_RESULT,
  SKAN_RESULT_RATE,
  SKAN_CONVERSION,
  SKAN_COST_PER_CONVERSION,
  SKAN_CONVERSION_RATE,
  SKAN_CONVERSION_RATE_V2,
  SKAN_CLICK_TIME_CONVERSION,
  SKAN_CLICK_TIME_COST_PER_CONVERSION,
  SKAN_CLICK_TIME_CONVERSION_RATE,
  SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  SKAN_APP_INSTALL,
  SKAN_COST_PER_APP_INSTALL,
  SKAN_APP_INSTALL_WITHHELD,
  SKAN_REGISTRATION,
  SKAN_COST_PER_REGISTRATION,
  SKAN_REGISTRATION_RATE,
  SKAN_TOTAL_REGISTRATION,
  SKAN_COST_PER_TOTAL_REGISTRATION,
  SKAN_PURCHASE,
  SKAN_COST_PER_PURCHASE,
  SKAN_PURCHASE_RATE,
  SKAN_TOTAL_PURCHASE,
  SKAN_COST_PER_TOTAL_PURCHASE,
  SKAN_TOTAL_PURCHASE_VALUE,
  SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  SKAN_ADD_TO_CART,
  SKAN_COST_PER_ADD_TO_CART,
  SKAN_ADD_TO_CART_RATE,
  SKAN_TOTAL_ADD_TO_CART,
  SKAN_COST_PER_TOTAL_ADD_TO_CART,
  SKAN_TOTAL_ADD_TO_CART_VALUE,
  SKAN_CHECKOUT,
  SKAN_COST_PER_CHECKOUT,
  SKAN_CHECKOUT_RATE,
  SKAN_TOTAL_CHECKOUT,
  SKAN_COST_PER_TOTAL_CHECKOUT,
  SKAN_TOTAL_CHECKOUT_VALUE,
  SKAN_VIEW_CONTENT,
  SKAN_COST_PER_VIEW_CONTENT,
  SKAN_VIEW_CONTENT_RATE,
  SKAN_TOTAL_VIEW_CONTENT,
  SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  SKAN_TOTAL_VIEW_CONTENT_VALUE,
  SKAN_ADD_PAYMENT_INFO,
  SKAN_COST_PER_ADD_PAYMENT_INFO,
  SKAN_ADD_PAYMENT_INFO_RATE,
  SKAN_TOTAL_ADD_PAYMENT_INFO,
  SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  SKAN_ADD_TO_WISHLIST,
  SKAN_COST_PER_ADD_TO_WISHLIST,
  SKAN_ADD_TO_WISHLIST_RATE,
  SKAN_TOTAL_ADD_TO_WISHLIST,
  SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  SKAN_LAUNCH_APP,
  SKAN_COST_PER_LAUNCH_APP,
  SKAN_LAUNCH_APP_RATE,
  SKAN_TOTAL_LAUNCH_APP,
  SKAN_COST_PER_TOTAL_LAUNCH_APP,
  SKAN_COMPLETE_TUTORIAL,
  SKAN_COST_PER_COMPLETE_TUTORIAL,
  SKAN_COMPLETE_TUTORIAL_RATE,
  SKAN_TOTAL_COMPLETE_TUTORIAL,
  SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  SKAN_CREATE_GROUP,
  SKAN_COST_PER_CREATE_GROUP,
  SKAN_CREATE_GROUP_RATE,
  SKAN_TOTAL_CREATE_GROUP,
  SKAN_COST_PER_TOTAL_CREATE_GROUP,
  SKAN_TOTAL_CREATE_GROUP_VALUE,
  SKAN_JOIN_GROUP,
  SKAN_COST_PER_JOIN_GROUP,
  SKAN_JOIN_GROUP_RATE,
  SKAN_TOTAL_JOIN_GROUP,
  SKAN_COST_PER_TOTAL_JOIN_GROUP,
  SKAN_TOTAL_JOIN_GROUP_VALUE,
  SKAN_CREATE_GAMEROLE,
  SKAN_COST_PER_CREATE_GAMEROLE,
  SKAN_CREATE_GAMEROLE_RATE,
  SKAN_TOTAL_CREATE_GAMEROLE,
  SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  SKAN_SPEND_CREDITS,
  SKAN_COST_PER_SPEND_CREDITS,
  SKAN_SPEND_CREDITS_RATE,
  SKAN_TOTAL_SPEND_CREDITS,
  SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  SKAN_TOTAL_SPEND_CREDITS_VALUE,
  SKAN_ACHIEVE_LEVEL,
  SKAN_COST_PER_ACHIEVE_LEVEL,
  SKAN_ACHIEVE_LEVEL_RATE,
  SKAN_TOTAL_ACHIEVE_LEVEL,
  SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  SKAN_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  SKAN_UNLOCK_ACHIEVEMENT_RATE,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SKAN_SALES_LEAD,
  SKAN_COST_PER_SALES_LEAD,
  SKAN_SALES_LEAD_RATE,
  SKAN_TOTAL_SALES_LEAD,
  SKAN_COST_PER_TOTAL_SALES_LEAD,
  SKAN_TOTAL_SALES_LEAD_VALUE,
  SKAN_IN_APP_AD_CLICK,
  SKAN_COST_PER_IN_APP_AD_CLICK,
  SKAN_IN_APP_AD_CLICK_RATE,
  SKAN_TOTAL_IN_APP_AD_CLICK,
  SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  SKAN_IN_APP_AD_IMPR,
  SKAN_COST_PER_IN_APP_AD_IMPR,
  SKAN_IN_APP_AD_IMPR_RATE,
  SKAN_TOTAL_IN_APP_AD_IMPR,
  SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  SKAN_LOAN_APPLY,
  SKAN_COST_PER_LOAN_APPLY,
  SKAN_LOAN_APPLY_RATE,
  SKAN_TOTAL_LOAN_APPLY,
  SKAN_COST_PER_TOTAL_LOAN_APPLY,
  SKAN_LOAN_CREDIT,
  SKAN_COST_PER_LOAN_CREDIT,
  SKAN_LOAN_CREDIT_RATE,
  SKAN_TOTAL_LOAN_CREDIT,
  SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  SKAN_LOAN_DISBURSEMENT,
  SKAN_COST_PER_LOAN_DISBURSEMENT,
  SKAN_LOAN_DISBURSEMENT_RATE,
  SKAN_TOTAL_LOAN_DISBURSEMENT,
  SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  SKAN_LOGIN,
  SKAN_COST_PER_LOGIN,
  SKAN_LOGIN_RATE,
  SKAN_TOTAL_LOGIN,
  SKAN_COST_PER_TOTAL_LOGIN,
  SKAN_RATINGS,
  SKAN_COST_PER_RATINGS,
  SKAN_RATINGS_RATE,
  SKAN_TOTAL_RATINGS,
  SKAN_COST_PER_TOTAL_RATINGS,
  SKAN_TOTAL_RATINGS_VALUE,
  SKAN_SEARCH,
  SKAN_COST_PER_SEARCH,
  SKAN_SEARCH_RATE,
  SKAN_TOTAL_SEARCH,
  SKAN_COST_PER_TOTAL_SEARCH,
  SKAN_START_TRIAL,
  SKAN_COST_PER_START_TRIAL,
  SKAN_START_TRIAL_RATE,
  SKAN_TOTAL_START_TRIAL,
  SKAN_COST_PER_TOTAL_START_TRIAL,
  SKAN_SUBSCRIBE,
  SKAN_COST_PER_SUBSCRIBE,
  SKAN_SUBSCRIBE_RATE,
  SKAN_TOTAL_SUBSCRIBE,
  SKAN_COST_PER_TOTAL_SUBSCRIBE,
  SKAN_TOTAL_SUBSCRIBE_VALUE,
  SKAN_VTA_CONVERSION,
  SKAN_COST_PER_VTA_CONVERSION,
  SKAN_VTA_APP_INSTALL,
  SKAN_COST_PER_VTA_APP_INSTALL,
  SKAN_VTA_REGISTRATION,
  SKAN_COST_PER_VTA_REGISTRATION,
  SKAN_VTA_PURCHASE,
  SKAN_COST_PER_VTA_PURCHASE,
  SKAN_CTA_CONVERSION,
  SKAN_COST_PER_CTA_CONVERSION,
  SKAN_CTA_APP_INSTALL,
  SKAN_COST_PER_CTA_APP_INSTALL,
  SKAN_CTA_REGISTRATION,
  SKAN_COST_PER_CTA_REGISTRATION,
  SKAN_CTA_PURCHASE,
  SKAN_COST_PER_CTA_PURCHASE,
  REACH,
  FREQUENCY,
  CPM_METRICS,
  CPC_METRICS,
  METRICS_NOT_FOUND_MESSAGE,
  SEARCH_METRICS_PLACEHOLDER,
  CONFIGURE_METRICS,
  GENERAL_METRIC,
  PREVIOUS_PERIOD,
  LOADING_CONFIGURATION_METRICS,
  IN_CURRENCY,
  BID_GOAL_EXPLANATION,
  TARGET_CPA_EXPLANATION,
  OPTIMIZATION_GOAL_CONVERSATIONS,
  OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE,
  OPTIMIZATION_GOAL_LINK_CLICKS,
  OPTIMIZATION_GOAL_THRUPLAY,
  OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_OPTION_REACH,
  OPTIMIZATION_GOAL_OPTION_THRUPLAY,
  OPTIMIZATION_GOAL_OPTION_LINK_CLICKS,
  OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_PLACEHOLDER,
  OPTIMIZATION_GOAL_POST_ENGAGEMENT,
  OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS,
  OPTIMIZATION_GOAL_LEAD_GENERATION,
  OPTIMIZATION_GOAL_APP_INSTALLS,
  OPTIMIZATION_GOAL_CPM,
  OPTIMIZATION_GOAL_CLICK_TO_APP,
  OPTIMIZATION_GOAL_CONVERSION_IN_APP,
  PUBLISHING_ALERT_TITLE,
  PUBLISHING_ALERT_ERROR_TITLE,
  PUBLISHING_ALERT_SUCCESS_TITLE,
  PUBLISHING_ALERT_RETRY_BUTTON,
  HIDE_ALERTS,
  SHOW_ALERTS,
  ACTIVITY,
  NO_TASKS,
  NO_TASKS_DESCRIPTION,
  GLOBAL_ALERTS_PANEL_TITLE,
  GLOBAL_ALERTS_EMPTY,
  GLOBAL_ALERTS_EMPTY_DESCRIPTION,
  GLOBAL_ALERTS_BELL_ARIA,
  TITLES_META,
  GENERATING_CAMPAIGN,
  CAMPAIGN_GENERATED_SUCCESS,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_ERROR_DESCRIPTION,
  TOTAL_ROAS_GOOGLE,
  TOTAL_ROAS_TIK_TOK,
  TOTAL_ROAS_META,
  BUYING_TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION,
  CHANGE_BUYING_TYPE_TO_RESERVED_TITLE,
  CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION,
  ESTIMATED_AUDIENCE_SIZE,
  REACH_AT_TARGET_FREQUENCY,
  AUDIENCE_SIZE,
  POTENTIAL_REACH,
  ESTIMATED_DAILY_RESULTS,
  AUDIENCE_ESTIMATES,
  TIMES_EVERY,
  FREQUENCY_CAP_EXPLANATION,
  FREQUENCY_SPECS_CONTROL_PLACEHOLDER,
  FREQUENCY_SPECS_CAP_EXPLANATION,
  FREQUENCY_SPECS_CAP_DESCRIPTION,
  BUTTON_DISCARD,
  BUTTON_VIEW,
  SEARCH_SPECIFIC_LOCATION_PLACEHOLDER,
  SEARCH_SPECIFIC_LOCATION_EXAMPLE,
  CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION,
  ADS_CAMPAIGN_APP_PROMOTION_ANDROID,
  ADS_CAMPAIGN_APP_PROMOTION_IOS,
  ADS_CAMPAIGN_APP_PROMOTION_BOTH,
  INSIGHT_DISCARDED,
  BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION,
  SYNCING_INFORMATION_NO_EDIT_CLARIFICATION,
  WAIT_FOR_CAMPAIGN_SYNC,
  BUTTON_GO_TO_BILLING,
  BRAND_GUIDELINES_ENABLED_CLARIFICATION,
  MODAL_BRAND_SETUP_TITLE,
  MODAL_BRAND_SETUP_DESCRIPTION,
  METRICS,
  BUTTON_WHY_THIS_RECOMMENDATION,
  ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE,
  BUTTON_REVERT_CHANGE,
  REVERT_CHANGE_CONFIRM_TITLE,
  REVERT_CHANGE_CONFIRM_TEXT,
  REVERT_CHANGE_SUCCESS,
  REVERT_CHANGE_ERROR,
  ENGLISH_US,
  ENGLISH_UK,
  SPANISH_SPAIN,
  PORTUGUESE_BRAZIL,
  PORTUGUESE_PORTUGAL,
  FRENCH_FRANCE,
  FRENCH_CANADA,
  TRADITIONAL_CHINESE_HONG_KONG,
  TRADITIONAL_CHINESE_TAIWAN,
  JAPANESE_KANSAI,
  NORWEGIAN_BOKMAL,
  NORWEGIAN_NYNORSK,
  CATALAN,
  CZECH,
  WELSH,
  BASQUE,
  FINNISH,
  GALICIAN,
  HUNGARIAN,
  ITALIAN,
  DUTCH,
  FRISIAN,
  POLISH,
  ROMANIAN,
  SLOVENIAN,
  SWEDISH,
  FLEMISH,
  ESPERANTO,
  ESTONIAN,
  FAROESE,
  GREEK,
  ICELANDIC,
  IRISH,
  LATVIAN,
  LITHUANIAN,
  MACEDONIAN,
  THAI,
  VIETNAMESE,
  KHMER,
  FILIPINO,
  MALAY,
  GUJARATI,
  KANNADA,
  TAMIL,
  TELUGU,
  MALAYALAM,
  URDU,
  HEBREW,
  PERSIAN,
  NORTHERN_KURDISH_KURMANJI,
  ARMENIAN,
  AZERBAIJANI,
  BELARUSIAN,
  BOSNIAN,
  GEORGIAN,
  KAZAKH,
  MONGOLIAN,
  SERBIAN,
  TAJIK,
  UZBEK,
  AFRIKAANS,
  SWAHILI,
  ALBANIAN,
  CEBUANO,
  GUARANI,
  MARATHI,
  NEPALI,
  PASHTO,
  SINHALA,
  CHINESE,
  LANGUAGES_PLACEHOLDER,
  RAJASTHANI,
  ORIYA,
  BIHARI,
  HARYANAVI,
  ASSAMESE,
  NORWEGIAN,
  ALERT_CHANGE_ADVERTISER_TITLE,
  CHAT_QUESTION_1,
  CHAT_QUESTION_2,
  CHAT_QUESTION_3,
  CHAT_QUESTION_4,
  CHAT_QUESTION_5,
  CHAT_QUESTION_6,
  CHAT_QUESTION_7,
  CHAT_QUESTION_8,
  CHAT_QUESTION_9,
  TARGET,
  TARGET_FREQUENCY_EXPLANATION,
  CAP,
  CAP_FREQUENCY_EXPLANATION,
  FREQUENCY_TARGET_EXPLANATION,
  FIELD_ESTIMATION_ID_REQUIRED,
  RESERVATION_ESTIMATES,
  FIELD_ESTIMATION_BUDGET_REQUIRED,
  FIELD_ESTIMATION_START_END_DATE_REQUIRED,
  FIELD_ESTIMATION_FREQUENCY_REQUIRED,
  FIELD_ESTIMATION_LOCATION_REQUIRED,
  RESERVATION_STATUS_1,
  RESERVATION_STATUS_2,
  RESERVATION_STATUS_3,
  RESERVATION_STATUS_4,
  RESERVATION_STATUS_5,
  RESERVATION_STATUS_6,
  RESERVATION_STATUS_7,
  RESERVATION_STATUS_8,
  RESERVATION_STATUS_9,
  RESERVATION_STATUS_10,
  RESERVATION_STATUS_11,
  RESERVATION_STATUS_12,
  RESERVATION_STATUS_13,
  RESERVATION_STATUS_14,
  RESERVATION_STATUS_15,
  RESERVATION_STATUS_16,
  RESERVATION_STATUS_17,
  RESERVATION_STATUS_18,
  RESERVATION_STATUS_19,
  RESERVATION_STATUS_20,
  RESERVATION_STATUS_21,
  RESERVATION_STATUS_23,
  RESERVATION_STATUS_24,
  RESERVATION_STATUS_25,
  RESERVATION_STATUS_26,
  RESERVATION_STATUS_27,
  RESERVATION_STATUS_28,
  RESERVATION_STATUS_29,
  RESERVATION_STATUS_30,
  RESERVATION_STATUS_31,
  RESERVATION_STATUS_32,
  RESERVATION_STATUS_35,
  RESERVATION_STATUS_36,
  RESERVATION_STATUS_37,
  RESERVATION_STATUS_39,
  RESERVATION_STATUS_40,
  RESERVATION_STATUS_41,
  RESERVATION_STATUS_42,
  RESERVATION_STATUS_44,
  RESERVATION_STATUS_45,
  RESERVATION_STATUS_50,
  RESERVATION_STATUS_53,
  RESERVATION_STATUS_60,
  RESERVATION_STATUS_66,
  RESERVATION_STATUS_69,
  RESERVATION_STATUS_100,
  FREQUENCY_CONTROL_PLACEHOLDER,
  EXPORTING_LOCATIONS_TO_FORM,
  LOADING_LOCATIONS_IN_MAP,
  SUGGESTED_LOCATIONS_TITLE,
  LOADING_SUGGESTED_LOCATIONS,
  SUGGESTED_LOCATIONS_COUNT,
  ADD_ALL_LOCATIONS,
  ESTIMATED_DAILY_REACH,
  AVERAGE_AUDIENCE_SIZE,
  NO_ESTIMATION_AVAILABLE,
  CHAT_SUMMARY_OVERVIEW_TEXT,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS,
  REPORT_GENERATED_BY_BUZZLY_AI,
  AI_GENERATED_SECTION_CHIP,
  AI_GENERATED_SECTION_CHIP_ARIA,
  REPORT_DATE_GENERATED,
  DOWNLOADING_PDF,
  PDF_DOWNLOADED_SUCCESSFULLY,
  OPTIMIZATION,
  BUTTON_DOWNLOAD_PDF,
  OVERVIEW_REPORT_GENERATING_SUMMARY,
  OVERVIEW_REPORT_SUMMARY_NOT_GENERATED,
  MONTH_SHORT,
  FILTER_BY_USERS_PLACEHOLDER,
  FILTER_BY_DATES_PLACEHOLDER,
  BUTTON_CLEAR_DATES,
  ALL_USERS,
  ALL_TIME,
  ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE,
  APPLY_OPTIMIZATIONS_WITH_NAME,
  BUTTON_OPTIMIZATION_APPLIED,
  MODAL_WELCOME_TITLE,
  MODAL_WELCOME_SUBTITLE,
  MODAL_WELCOME_PLAN_NAME,
  MODAL_WELCOME_BUTTON,
  VALUE_SUBSCRIPTION_3_DAYS_FREE,
  FIRST_USER_MESSAGE_BRAND_SETUP,
  CONNECTING_TO_PLATFORM,
  MODAL_CANCEL_SUBSCRIPTION_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS,
  MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD,
  BUTTON_KEEP_MY_ACCOUNT,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS,
  BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS,
  CANCELLATION_REASON_SELECT_LABEL,
  CANCELLATION_REASON_TOO_EXPENSIVE,
  CANCELLATION_REASON_NOT_FREQUENT_USE,
  CANCELLATION_REASON_BETTER_ALTERNATIVE,
  CANCELLATION_REASON_TECHNICAL_ISSUES,
  CANCELLATION_REASON_NOT_MEET_NEEDS,
  CANCELLATION_REASON_DIFFICULT_TO_USE,
  CANCELLATION_REASON_SITUATION_CHANGED,
  CANCELLATION_REASON_TEMPORARY_NEED,
  CANCELLATION_REASON_SECURITY_CONCERNS,
  CANCELLATION_REASON_OTHER,
  CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION,
  BUTTON_NEW_CAMPAIGN,
  FILTERS_GALLERY_IMAGE,
  FILTERS_GALLERY_VIDEO,
  FILTERS_GALLERY_HORIZONTAL,
  FILTERS_GALLERY_VERTICAL,
  FILTERS_GALLERY_SQUARE,
  FILTERS_GALLERY_TODAY,
  FILTERS_GALLERY_WEEK,
  FILTERS_GALLERY_MONTH,
  FILTERS_GALLERY_YEAR,
  FILTERS_GALLERY_RESET_FILTERS,
  FILTERS_GALLERY_RESULTS_COUNTER,
  GALLERY_SOURCE_MY_CONTENT,
  GALLERY_SOURCE_GOOGLE,
  GALLERY_SOURCE_AD_ACCOUNT,
  GALLERY_SOURCE_AD_ACCOUNT_EMPTY,
  GALLERY_SOURCE_GOOGLE_DRIVE,
  GALLERY_SOURCE_SOCIAL_POSTS,
  GALLERY_SOCIAL_POSTS_DESCRIPTION,
  GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP,
  GALLERY_SELECT_SOURCE,
  GALLERY_ASSETS_TITLE,
  GALLERY_ASSETS_RENAME_TITLE,
  GALLERY_ASSETS_RENAME_SUCCESS,
  GALLERY_ASSETS_RENAME_ERROR,
  GALLERY_ASSETS_RENAME_ARIA_LABEL,
  GALLERY_ASSETS_NAME_LABEL,
  GALLERY_UPLOADING_ASSETS,
  GALLERY_GOOGLE_NOT_CONNECTED,
  GALLERY_META_NOT_CONNECTED,
  GALLERY_CONTENT_TYPE,
  GALLERY_DIMENSIONS,
  GALLERY_DATE_RANGE,
  GALLERY_TITLE_DIMENSIONS,
  FIELD_SEARCH_THEMES_MAX_WORDS,
  BUDGET_CAMPAIGN_DATES_PLACEHOLDER,
  CAROUSEL_IMAGES_MANAGER_TITLE,
  CAROUSEL_IMAGES_MANAGER_DELETE_ALL,
  CAROUSEL_IMAGES_MANAGER_NO_IMAGES,
  CAROUSEL_IMAGES_MANAGER_ADD_IMAGE,
  CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP,
  FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW,
  MAP_TRADUCCIONES_STATUS,
  MAP_TRADUCCIONES_PLATFORM,
  MAP_TRADUCCIONES_TITLES,
  MAP_TRADUCCIONES_CTA,
  MAP_TRADUCCIONES_CTAS,
  MAP_TRADUCCIONES_CTA_ID,
  MAP_TRADUCCIONES_CALL_TO_ACTION,
  MAP_TRADUCCIONES_CALL_TO_ACTIONS,
  MAP_TRADUCCIONES_CALL_TO_ACTION_ID,
  CAMPAIGN_SYNCING_STATUS,
  MAP_TRADUCCIONES_MEDIA_URLS,
  MAP_TRADUCCIONES_MEDIA_DATA,
  MAP_TRADUCCIONES_MUSIC_URL,
  MAP_TRADUCCIONES_IS_CAROUSEL,
  MAP_TRADUCCIONES_OBJECTIVE,
  MAP_TRADUCCIONES_INTEGRATION_ID,
  MAP_TRADUCCIONES_AD_ACCOUNT_ID,
  MAP_TRADUCCIONES_PAGE_ID,
  MAP_TRADUCCIONES_INSTAGRAM_ID,
  MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET,
  MAP_TRADUCCIONES_TYPE_BUDGET,
  MAP_TRADUCCIONES_BUDGET,
  MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN,
  MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER,
  MAP_TRADUCCIONES_MESSAGE_TEMPLATE,
  MAP_TRADUCCIONES_INSTANT_FORM,
  MAP_TRADUCCIONES_TRACKING_ID,
  MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID,
  MAP_TRADUCCIONES_CATALOG_ID,
  MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN,
  MAP_TRADUCCIONES_APP_ID,
  MAP_TRADUCCIONES_BUYING_TYPE,
  MAP_TRADUCCIONES_DESCRIPTIONS,
  MAP_TRADUCCIONES_ADS,
  MAP_TRADUCCIONES_KEYWORDS,
  MAP_TRADUCCIONES_KEYWORDS_NEGATIVE,
  MAP_TRADUCCIONES_START_DATE,
  MAP_TRADUCCIONES_END_DATE,
  MAP_TRADUCCIONES_AGE_RANGE,
  MAP_TRADUCCIONES_GENDERS,
  MAP_TRADUCCIONES_LOCATIONS,
  MAP_TRADUCCIONES_INTERESTS,
  MAP_TRADUCCIONES_BEHAVIORS,
  MAP_TRADUCCIONES_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_BID_GOAL,
  MAP_TRADUCCIONES_OPTIMIZATION_GOAL,
  MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID,
  MAP_TRADUCCIONES_TYPE,
  MAP_TRADUCCIONES_ID,
  MAP_TRADUCCIONES_DESTINATION_URL,
  MAP_TRADUCCIONES_BUSINESS_NAME,
  MAP_TRADUCCIONES_LOGO_URLS,
  MAP_TRADUCCIONES_IMAGE_URLS,
  MAP_TRADUCCIONES_VIDEO_URLS,
  MAP_TRADUCCIONES_LONG_HEADLINES,
  MAP_TRADUCCIONES_SEARCH_THEMES,
  MAP_STATUS_ACTIVE,
  MAP_STATUS_DEACTIVATED,
  BUTTON_OPTIMIZE_CAMPAIGN,
  BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE,
  START_DATE_AND_END_DATE_VALIDATION,
  ADD_CHANGES,
  UPDATE_CHANGES,
  REMOVE_CHANGES,
  BUTTON_DISCONNECT_ACCOUNT,
  DISCONNECTED_ACCOUNT,
  CAMPAIGN_ALREADY_BEING_CREATED,
  CAMPAIGN_ALREADY_BEING_UPDATED,
  GALLERY_SOURCE_CANVA,
  IMAGE_TYPE_PORTRAIT_LABEL,
  IMAGE_TYPE_LANDSCAPE_LABEL,
  IMAGE_TYPE_SQUARE_LABEL,
  ALERT_SHARE_INSTAGRAM_ERROR,
  ALERT_SHARE_SUCCESS,
  ALERT_SHARE_SCHEDULED_SUCCESS,
  BUTTON_SHARE_MEDIA,
  BUTTON_SHARE_LOADING,
  BUTTON_SCHEDULE_MEDIA,
  BUTTON_SCHEDULING_MEDIA,
  BUTTON_PUBLISH_NOW,
  SCHEDULE_DATE_MIN_FUTURE_ERROR,
  SUGGESTED_PUBLISH_SCHEDULE_LOADING,
  DESCRIPTION_INSTAGRAM_LABEL,
  TYPE_CONTENT_INSTAGRAM_LABEL,
  INSTAGRAM_COLLABORATORS_LABEL,
  INSTAGRAM_COLLABORATORS_PLACEHOLDER,
  INSTAGRAM_COLLABORATORS_HELPER,
  IMAGE_NO_CONTENT_TO_SHOW,
  NO_SUPPORTED_FILE,
  MODAL_SHARE_TITLE,
  MODAL_SHARE_SELECT_PLATFORMS_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL,
  VIDEO,
  IMAGE,
  MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN,
  MODAL_CREATE_WITH_IA_TITLE,
  MODAL_CREATE_WITH_IA_SUBTITLE,
  MODAL_CREATE_WITH_IA_GENERATED_CREATIVES,
  BUTTON_CREATE_WITH_IA,
  MODAL_CREATE_WITH_IA_ADD_URL,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA,
  MODAL_CREATE_WITH_IA_EXTRACT_URL,
  MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT,
  MODAL_CREATE_WITH_IA_DESCRIPTION,
  MODAL_CREATE_WITH_IA_UPLOAD_IMAGE,
  MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH,
  MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION,
  MODAL_CREATE_WITH_IA_REFERENCE_VIDEO_FORCES_CUSTOM,
  MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION,
  MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE,
  MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_THEME,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION,
  MODAL_IMAGE_EDIT_TITLE,
  MODAL_IMAGE_EDIT_SUBTITLE,
  MODAL_IMAGE_EDIT_PROCESSING_MESSAGE,
  MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64,
  MODAL_IMAGE_EDIT_ERROR_EDITING,
  MODAL_IMAGE_EDIT_ERROR_PROCESSING,
  MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER,
  MODAL_IMAGE_EDIT_EDITING_LABEL,
  MODAL_IMAGE_EDIT_LOADING_LABEL,
  MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND,
  MODAL_IMAGE_EDIT_START_CREATING,
  MODAL_IMAGE_EDIT_IMAGE_ALT,
  MODAL_IMAGE_EDIT_VERSION_FORMAT,
  MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_IMAGE_EDIT_REPLACE_BUTTON,
  MODAL_VIDEO_EDITOR_TITLE,
  MODAL_VIDEO_EDITOR_EDIT_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_IMAGE,
  MODAL_VIDEO_EDITOR_ADD_AUDIO,
  MODAL_VIDEO_EDITOR_ADD_SUBTITLES,
  MODAL_VIDEO_EDITOR_EXPORTING,
  MODAL_VIDEO_EDITOR_SAVE_ERROR,
  MODAL_VIDEO_EDITOR_SPLIT_HINT,
  MODAL_VIDEO_EDITOR_ARIA_LABEL,
  MODAL_VIDEO_EDITOR_TRACK_VIDEO,
  MODAL_VIDEO_EDITOR_TRACK_IMAGE,
  MODAL_VIDEO_EDITOR_TRACK_AUDIO,
  MODAL_VIDEO_EDITOR_CLIP_DURATION,
  MODAL_VIDEO_EDITOR_SPLIT_CLIP,
  MODAL_VIDEO_EDITOR_CLIP_ACTIONS,
  MODAL_VIDEO_EDITOR_BRAND,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT,
  MODAL_VIDEO_EDITOR_DROP_HINT,
  MODAL_VIDEO_EDITOR_PLAY,
  MODAL_VIDEO_EDITOR_PAUSE,
  MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME,
  MODAL_VIDEO_EDITOR_TIMELINE_ARIA,
  MODAL_VIDEO_EDITOR_TIMELINE_RESIZE,
  MODAL_VIDEO_EDITOR_INSERT_START,
  MODAL_VIDEO_EDITOR_INSERT_END,
  MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES,
  MODAL_VIDEO_EDITOR_TRACK_SUBTITLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ARIA,
  MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION,
  MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR,
  MODAL_VIDEO_EDITOR_PROPERTIES_TITLE,
  MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY,
  MODAL_VIDEO_EDITOR_PROPERTIES_NAME,
  MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME,
  MODAL_VIDEO_EDITOR_PROPERTIES_MIXED,
  MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT,
  MODAL_VIDEO_EDITOR_PROPERTIES_POSITION,
  MODAL_VIDEO_EDITOR_PROPERTIES_SIZE,
  MODAL_VIDEO_EDITOR_PROPERTIES_X,
  MODAL_VIDEO_EDITOR_PROPERTIES_Y,
  MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH,
  MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT,
  MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_IMAGE_EDIT_WORK_MODE_LABEL,
  MODAL_IMAGE_EDIT_GENERATIVE_TITLE,
  MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ADD,
  MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO,
  MODAL_IMAGE_EDIT_LAYERS_BACKGROUND,
  MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME,
  MODAL_IMAGE_EDIT_LAYERS_ANALYZING,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_CLOSE_TITLE,
  MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION,
  ANALYZE_LAYERS_EDIT_TEXT_TITLE,
  ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION,
  ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON,
  ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO,
  MODAL_CREATE_WITH_IA_LANGUAGE_ES,
  MODAL_CREATE_WITH_IA_LANGUAGE_EN,
  MODAL_CREATE_WITH_IA_LANGUAGE_FR,
  MODAL_CREATE_WITH_IA_LANGUAGE_DE,
  MODAL_CREATE_WITH_IA_LANGUAGE_IT,
  MODAL_CREATE_WITH_IA_DIMENSION_SQUARE,
  MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL,
  MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL,
  MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_LANGUAGE,
  MODAL_CREATE_WITH_IA_LABEL_ACCENT,
  MODAL_CREATE_WITH_IA_LABEL_LOCATION,
  MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS,
  MODAL_CREATE_WITH_IA_LABEL_PLATFORM,
  MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT,
  MODAL_CREATE_WITH_IA_LABEL_CAROUSEL,
  MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLATFORM_META,
  MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK,
  MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL,
  MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_URLS_ADDED,
  MODAL_CREATE_WITH_IA_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_GENERATING,
  MODAL_CREATE_WITH_IA_GENERATE_WITH_AI,
  MODAL_CREATE_WITH_IA_IMAGES_CREATED,
  MODAL_CREATE_WITH_IA_GENERATING_IMAGES,
  MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE,
  MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS,
  MODAL_CREATE_WITH_IA_GENERATION_FAILED,
  MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS,
  MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE,
  MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT,
  MODAL_CREATE_WITH_IA_DOWNLOAD_ALL,
  MODAL_CREATE_WITH_IA_MORE_VARIATIONS,
  MODAL_CREATE_WITH_IA_ARIA_LABEL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION,
  MODAL_CREATE_WITH_IA_GALLERY_BUTTON,
  MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY,
  COMPETITOR_SCOPE_MENU_ITEM,
  COMPETITOR_SCOPE_MODAL_TITLE,
  ALERT_COMPETITOR_SCOPE_TITLE,
  ALERT_COMPETITOR_SCOPE_DESCRIPTION,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION,
  BUTTON_CONFIGURE_BRAND,
  BUTTON_CONFIGURE_COMPETITORS,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION,
  MODAL_COMPETITORS_PREPARING_REFERENCE,
  MODAL_COMPETITORS_SHOW_FAVORITES_ONLY,
  MODAL_COMPETITORS_SHOW_ALL_ADS,
  MODAL_COMPETITORS_FAVORITES_EMPTY,
  MODAL_COMPETITORS_SAVED_TO_FAVORITES,
  MODAL_COMPETITORS_SAVED_TO_FOLDER,
  MODAL_COMPETITORS_REMOVED_FROM_FOLDER,
  MODAL_COMPETITORS_SELECT_FOLDER_TITLE,
  MODAL_COMPETITORS_CHANGE_LOCATION,
  MODAL_COMPETITORS_REMOVED_FROM_FAVORITES,
  MODAL_COMPETITORS_ADD_OPTION,
  MODAL_COMPETITORS_EDIT_BUTTON,
  MODAL_COMPETITORS_EDIT_TITLE,
  MODAL_COMPETITORS_EDIT_SUBTITLE,
  MODAL_COMPETITORS_EDIT_COUNT_ARIA,
  MODAL_COMPETITORS_STRONG_SIGNAL,
  MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL,
  MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING,
  MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT,
  MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL,
  MODAL_META_AD_LIBRARY_COMPETITOR_ALL,
  MODAL_META_AD_LIBRARY_PLATFORM_ALL,
  MODAL_META_AD_LIBRARY_DURATION_HOURS,
  MODAL_META_AD_LIBRARY_DURATION_DAYS,
  MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP,
  MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS,
  MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS,
  MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT,
  MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY,
  BUSINESS_LOOK_AND_FEEL_PLACEHOLDER,
  BUSINESS_OFFERING_PLACEHOLDER,
  BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER,
  BUSINESS_OFFERING_SERVICES_PLACEHOLDER,
  DESCRIPTION_INSTAGRAM_GENERATING,
  MODAL_FILTERS_LABEL,
  FIELD_CONSECUTIVE_UPPERCASE,
  FIELD_EMOJI_NOT_ALLOWED,
  ADS_CAMPAIGNS_TITLE_DASHBOARD,
  OVERVIEW_HOME_STATISTICS,
  KPI_TARGET_CPA_ABOVE_PLATFORM,
  KPI_TARGET_CPA_ALERTS_TITLE,
  OVERVIEW_HOME_STATISTICS_VIEW_MORE,
  STATISTICS_ONLY_BUZZLY_CAMPAIGNS,
  VIEW_SPEND_BREAKDOWN,
  LIST_TABLE_CAMPAIGNS_TITLE,
  DASHBOARD_METRICS_DELAY_WARNING,
  TRIAL_CONTENT_CTA_MESSAGE,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK,
  TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS,
  CAMPAIGNS,
  GALLERY_TITLE,
  BUTTON_SELECT_ALL,
  BUTTON_DESELECT_ALL,
  AVERAGE_CTR,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  ALERT_PIXEL_NOT_FIRED_LABEL,
  ALERT_CAMPAIGN_STARTED_LABEL,
  ALERT_CAMPAIGN_CPA_HIGH_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LABEL,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES,
  BUTTON_CREATE_CONTENT,
  MODAL_REDIRECT_BRAND_SETUP_TITLE,
  MODAL_REDIRECT_BRAND_SETUP_SUBTITLE,
  MODAL_REDIRECT_BRAND_SETUP_BUTTON,
  MODAL_SUCCESS_BRAND_SETUP_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_SUBTITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_START,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER,
  ONBOARDING_CHECKLIST_HEADER_TITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE,
  ONBOARDING_CHECKLIST_FOOTER_COMPLETED,
  ONBOARDING_CHECKLIST_SUBTITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION,
  ONBOARDING_CHECKLIST_PROGRESS_COMPLETED,
  ONBOARDING_CHECKLIST_SKIP_GUIDE,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USER,
  ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL,
  ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM,
  TEXT_IN_IMAGE,
  LOGO_IN_IMAGE,
  LOGO_IN_VIDEO,
  LOGO_IN_VIDEO_DESCRIPTION_LEAD,
  FIELD_MAX_LENGTH_SHORT,
  COLUMN_NAME_ENTITY,
  UNKNOWN_VALUE,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN,
  I_DONT_HAVE_A_WEBSITE,
  SET_UP_BRAND,
  LOOK_AND_FEEL_PLACEHOLDER,
  CHAT_BOT_WELCOME_DESCRIPTION,
  CARD_GENERATE_COPY,
  CARD_GENERATE_COPY_DESCRIPTION,
  CARD_GENERATE_COPY_QUESTION,
  CARD_GET_CAMPAIGN_LEARNINGS,
  CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION,
  CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  CARD_OPTIMIZE_GENERAL,
  CARD_OPTIMIZE_GENERAL_DESCRIPTION,
  CARD_OPTIMIZE_GENERAL_QUESTION,
  CARD_MANAGE_BUDGET,
  CARD_MANAGE_BUDGET_DESCRIPTION,
  CARD_MANAGE_BUDGET_QUESTION,
  CARD_OWNER_CLIENT_HEALTH,
  CARD_OWNER_CLIENT_HEALTH_DESCRIPTION,
  CARD_OWNER_CLIENT_HEALTH_QUESTION,
  CARD_OWNER_INSIGHTS,
  CARD_OWNER_INSIGHTS_DESCRIPTION,
  CARD_OWNER_INSIGHTS_QUESTION,
  CARD_OWNER_ACCOUNTS,
  CARD_OWNER_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_ACCOUNTS_QUESTION,
  CARD_OWNER_BILLING,
  CARD_OWNER_BILLING_DESCRIPTION,
  CARD_OWNER_BILLING_QUESTION,
  CARD_OWNER_SUPPORT,
  CARD_OWNER_SUPPORT_DESCRIPTION,
  CARD_OWNER_SUPPORT_QUESTION,
  CARD_OWNER_CLIENTS_ACCOUNTS,
  CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION,
  CARD_OWNER_BRANDS,
  CARD_OWNER_BRANDS_DESCRIPTION,
  CARD_OWNER_BRANDS_QUESTION,
  CARD_OWNER_PLANS_MRR,
  CARD_OWNER_PLANS_MRR_DESCRIPTION,
  CARD_OWNER_PLANS_MRR_QUESTION,
  DATE_RANGE_PRESET_TODAY,
  DATE_RANGE_PRESET_YESTERDAY,
  DATE_RANGE_PRESET_LAST_7,
  DATE_RANGE_PRESET_LAST_14,
  DATE_RANGE_PRESET_LAST_30,
  DATE_RANGE_PRESET_THIS_WEEK,
  DATE_RANGE_PRESET_LAST_WEEK,
  DATE_RANGE_PRESET_THIS_MONTH,
  DATE_RANGE_PRESET_LAST_MONTH,
  DATE_RANGE_PRESET_THIS_YEAR,
  DATE_RANGE_PRESET_LAST_YEAR,
  PRESETS_DATE_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_TITLE,
  MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION,
  MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED,
  MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING,
  MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR,
  MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_SAVE,
  DATE_RANGE_PRESET_CUSTOM,
  NPS_FORM_TITLE,
  NPS_LABEL_NOT_LIKELY_AT_ALL,
  NPS_LABEL_EXTREMELY_LIKELY,
  NPS_SAVING_RATING,
  NPS_THANK_YOU_TITLE,
  NPS_THANK_YOU_DESCRIPTION,
  OVERLAPS_WITH,
  MODAL_OVERLAP_CONFLICTS_TITLE,
  MODAL_OVERLAP_CONFLICTS_DESCRIPTION,
  BUTTON_PREVIEW_CHANGES,
  BUTTON_APPLY_CHANGES,
  BUTTON_CHANGES_APPLIED,
  ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISER,
  TOTAL_ADVERTISERS_COUNT,
  TOTAL_ADVERTISER_COUNT,
  CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP,
  CONFIGURATION_PANEL_WEBSITE_URL_TITLE,
  CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION,
  FORMAT_OPTIONS_TOOLTIP,
  EDIT_WITH_CANVA,
  EDIT_WITH_IA,
  ANIMATE_IMAGE_WITH_AI,
  ANIMATE_IMAGE_CONFIRMATION_TITLE,
  ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION,
  MODAL_ANIMATE_IMAGE_PREVIEW_TITLE,
  MODAL_ANIMATE_IMAGE_PROMPT_LABEL,
  MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER,
  MODAL_ANIMATE_IMAGE_PROMPT_HELPER,
  MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH,
  ANIMATE_IMAGE_OUTRO_LABEL,
  ANIMATE_IMAGE_OUTRO_HELPER,
  ANIMATE_IMAGE_OUTRO_NONE,
  ANIMATE_IMAGE_SAVE_OUTRO,
  ANIMATE_IMAGE_SAVE_OUTRO_TITLE,
  ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS,
  ANIMATE_IMAGE_SAVE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_FILE,
  ANIMATE_IMAGE_OUTRO_FILE_HINT,
  ANIMATE_IMAGE_IMPORT_OUTRO,
  ANIMATE_IMAGE_IMPORT_OUTRO_TITLE,
  ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY,
  ANIMATE_IMAGE_IMPORT_OUTRO_ERROR,
  ANIMATE_IMAGE_DELETE_OUTRO,
  ANIMATE_IMAGE_DELETE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_CLEAR,
  ANIMATE_IMAGE_OUTRO_TOO_LARGE,
  ANIMATE_IMAGE_OUTRO_TOO_LONG,
  ANIMATE_IMAGE_OUTRO_INVALID_TYPE,
  ANIMATE_IMAGE_USE_SELECTED,
  SELECT_CONTENT_CONFIRMATION_TEXT,
  RESIZE_TO_HORIZONTAL,
  RESIZE_TO_VERTICAL,
  RESIZE_TO_SQUARE,
  RESIZE_TO_FEED,
  RESIZE_MENU_LABEL,
  RESIZING_IMAGES_BATCH_MESSAGE,
  MULTI_FORMAT_RESIZE_FORMATS_COUNT,
  MULTI_FORMAT_RESIZE_CREDITS_COUNT,
  MULTI_FORMAT_RESIZE_ONE_FORMAT,
  MULTI_FORMAT_RESIZE_ONE_CREDIT,
  HORIZONTAL_FORMAT,
  ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION,
  CAMPAIGNS_STATUS_DELETED,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE,
  PAGE_NUMBER,
  TABLE_ADMIN_DASHBOARD_CLIENT,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE,
  TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE,
  TABLE_ADMIN_DASHBOARD_HEALTH_SCORE,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS,
  TABLE_ADMIN_DASHBOARD_KPI,
  TABLE_ADMIN_DASHBOARD_SPEND,
  TABLE_ADMIN_DASHBOARD_TARGET_CPA,
  TABLE_ADMIN_DASHBOARD_ROAS,
  TABLE_ADMIN_DASHBOARD_LAST_LOGIN,
  TABLE_ADMIN_DASHBOARD_LOGINS,
  TABLE_ADMIN_DASHBOARD_USERS,
  TABLE_ADMIN_DASHBOARD_AUTOMATION,
  TABLE_ADMIN_DASHBOARD_MRR,
  TABLE_ADMIN_DASHBOARD_PLAN,
  TABLE_ADMIN_DASHBOARD_CREATIVES,
  TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE,
  TABLE_ADMIN_DASHBOARD_LOADING_MORE,
  TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS,
  TABLE_ADMIN_CREATIVES_UTILIZED,
  TABLE_ADMIN_CREATIVE_UTILIZED,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE,
  TABLE_ADMIN_LAST_LOGIN_DAYS,
  TABLE_ADMIN_DASHBOARD_NPS,
  TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE,
  TABLE_ADMIN_CANCELLATION_REASON_BUTTON,
  TABLE_ADMIN_CANCELLED_BADGE,
  TABLE_ADMIN_ADD_ADVERTISER_BUTTON,
  TABLE_ADMIN_ADD_CREDITS_BUTTON,
  TABLE_ADMIN_ACTIONS_BUTTON,
  TABLE_ADMIN_ACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_MARK_DEMO_BUTTON,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE,
  TABLE_ADMIN_CREDITS_USAGE,
  TABLE_ADMIN_PENDING_PAYMENT_BADGE,
  TABLE_ADMIN_PRIORITY_BADGE,
  TABLE_ADMIN_SEND_EMAIL_BODY_LABEL,
  TABLE_ADMIN_SEND_EMAIL_BUTTON,
  TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON,
  OWNER_LOGIN_AS_USER_OPTION,
  OWNER_LOGIN_AS_USER_OPTION_EMAIL,
  OWNER_LOGIN_AS_CONNECTING,
  OWNER_LOGIN_AS_ERROR_TITLE,
  OWNER_LOGIN_AS_ERROR_EXPIRED,
  OWNER_LOGIN_AS_ERROR_INVALID,
  OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
  OWNER_LOGIN_AS_ERROR_GENERIC,
  OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND,
  OWNER_LOGIN_AS_ERROR_INVALID_EMAIL,
  OWNER_LOGIN_AS_ERROR_FORBIDDEN,
  OWNER_LOGIN_AS_ERROR_UNAUTHORIZED,
  SUPPORT_SESSION_BANNER_TITLE,
  SUPPORT_SESSION_BANNER_DESCRIPTION,
  SUPPORT_SESSION_ENDED_TITLE,
  SUPPORT_SESSION_ENDED_DESCRIPTION,
  TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER,
  TABLE_ADMIN_SEND_EMAIL_SELECT_ALL,
  TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON,
  TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL,
  TABLE_ADMIN_SEND_EMAIL_SUCCESS,
  TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON,
  TABLE_ADMIN_ENABLE_FEATURES_BUTTON,
  TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY,
  TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT,
  TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM,
  MODAL_MODIFY_KPI_CPA_TITLE,
  MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL,
  MODAL_MODIFY_KPI_CPA_TARGET_LABEL,
  MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL,
  MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS,
  MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL,
  MODAL_CAMPAIGN_KPI_CPA_TITLE,
  MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT,
  MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL,
  ADMIN_KPI_PRIMARY_LEADS,
  ADMIN_KPI_PRIMARY_SALES,
  ADMIN_KPI_PRIMARY_MESSAGES,
  ADMIN_KPI_PRIMARY_INTERACTIONS,
  ADMIN_KPI_PRIMARY_TRAFFIC,
  ADMIN_KPI_PRIMARY_CONVERSIONS,
  ADMIN_KPI_PRIMARY_DOWNLOADS,
  ADMIN_KPI_PRIMARY_APP_INSTALLS,
  ADMIN_KPI_PRIMARY_VIDEO_VIEWS,
  ADMIN_KPI_PRIMARY_AWARENESS,
  ADMIN_KPI_PRIMARY_REACH,
  ADMIN_KPI_PRIMARY_ENGAGEMENT,
  ADMIN_KPI_PRIMARY_STORE_VISITS,
  ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS,
  ADMIN_KPI_PRIMARY_CATALOG_SALES,
  ADMIN_KPI_PRIMARY_SIGNUPS,
  ADMIN_DASHBOARD_TITLE,
  OWNER_DASHBOARD_NAV_FORM,
  OWNER_DASHBOARD_NAV_REPORTED_CONTENT,
  OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES,
  OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS,
  OWNER_DASHBOARD_NAV_AD_SPEND,
  OWNER_AD_SPEND_TITLE,
  OWNER_AD_SPEND_DESCRIPTION,
  OWNER_AD_SPEND_PRESET_HISTORIC,
  OWNER_AD_SPEND_PRESET_LAST_7,
  OWNER_AD_SPEND_PRESET_LAST_30,
  OWNER_AD_SPEND_PRESET_LAST_90,
  OWNER_AD_SPEND_PRESET_THIS_MONTH,
  OWNER_AD_SPEND_PRESET_LAST_MONTH,
  OWNER_AD_SPEND_PRESET_CUSTOM,
  OWNER_AD_SPEND_CUSTOM_PENDING,
  OWNER_AD_SPEND_ACCURACY_WARNING,
  OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED,
  OWNER_AD_SPEND_KPI_TOTAL,
  OWNER_AD_SPEND_KPI_ADVERTISERS,
  OWNER_AD_SPEND_KPI_COUNTRIES,
  OWNER_AD_SPEND_VS_PREVIOUS_PERIOD,
  OWNER_AD_SPEND_CHART_TITLE,
  OWNER_AD_SPEND_CHART_DAILY,
  OWNER_AD_SPEND_CHART_MONTHLY,
  OWNER_AD_SPEND_PLATFORMS_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE,
  OWNER_AD_SPEND_TOP_COUNTRIES_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA,
  OWNER_AD_SPEND_TOP_COUNTRIES_ARIA,
  OWNER_AD_SPEND_COLUMN_ADVERTISER,
  OWNER_AD_SPEND_COLUMN_COUNTRY,
  OWNER_AD_SPEND_COLUMN_SPEND,
  OWNER_AD_SPEND_COLUMN_SHARE,
  OWNER_AD_SPEND_COLUMN_PLATFORMS,
  OWNER_AD_SPEND_UNASSIGNED_COUNTRY,
  OWNER_AD_SPEND_TREND_NEW,
  OWNER_AD_SPEND_ESTIMATED_BADGE,
  OWNER_AD_SPEND_EMPTY_TITLE,
  OWNER_AD_SPEND_EMPTY_DESCRIPTION,
  OWNER_AD_SPEND_MOCK_BADGE,
  OWNER_DASHBOARD_NAV_CREATE_USER,
  OWNER_DASHBOARD_NAV_OPTIONS,
  OWNER_GLOBAL_NOTIFICATIONS_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER,
  OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS,
  MODAL_CREATE_OWNER_USER_ARIA_LABEL,
  MODAL_CREATE_OWNER_USER_TITLE,
  MODAL_CREATE_OWNER_USER_DESCRIPTION,
  MODAL_CREATE_OWNER_USER_SUCCESS,
  REGISTER_PROMOTIONAL_CODE_LABEL,
  REGISTER_PROMOTIONAL_CODE_PLACEHOLDER,
  REGISTER_DISCOVERY_SOURCE_LABEL,
  OWNER_PROMOTIONAL_CODES_CREATE_TITLE,
  OWNER_PROMOTIONAL_CODES_CREATE_BUTTON,
  OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE,
  OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP,
  OWNER_PROMOTIONAL_CODES_FIELD_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_FIELD_TIER,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_1,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_2,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_3,
  OWNER_PROMOTIONAL_CODES_COLUMN_CODE,
  OWNER_PROMOTIONAL_CODES_COLUMN_CREATED,
  OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED,
  OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_COLUMN_TYPE,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT,
  PRICING_PROMO_DISCOUNT_APPLIED,
  OWNER_PROMOTIONAL_CODES_COLUMN_STATUS,
  OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE,
  OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE,
  OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS,
  OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID,
  PROMOTIONAL_CODE_NOT_FOUND,
  PROMOTIONAL_CODE_INACTIVE,
  PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  ADMIN_DASHBOARD_SUBTITLE,
  ADMIN_DASHBOARD_SEARCH_PLACEHOLDER,
  ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK,
  CREATE_BRAND_BUTTON,
  ADMIN_DASHBOARD_CREATE_BRAND_BUTTON,
  ANNOTATIONS_SIDEBAR_AGENCY_HEADER,
  ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER,
  ANNOTATIONS_SIDEBAR_EMPTY_TITLE,
  ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE,
  ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER,
  ANNOTATIONS_SIDEBAR_YOU_LABEL,
  ANNOTATIONS_SIDEBAR_LOADING,
  ANNOTATIONS_SIDEBAR_CLOSE,
  ANNOTATIONS_UNREAD_BADGE_ARIA,
  ANNOTATIONS_UNREAD_COUNT,
  ANNOTATIONS_MENTION_ALL,
  ANNOTATIONS_MENTION_MENU_ARIA,
  ANNOTATIONS_MESSAGE_EDIT,
  ANNOTATIONS_MESSAGE_DELETE,
  ANNOTATIONS_MESSAGE_DELETE_CONFIRM,
  ANNOTATIONS_MESSAGE_EDITING,
  ANNOTATIONS_MESSAGE_CANCEL_EDIT,
  ANNOTATIONS_MESSAGE_MENU_ARIA,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL,
  ADMIN_DASHBOARD_USER_CREATED_SUCCESS,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL,
  ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS,
  DELETE_BRAND_CONFIRMATION_TITLE,
  DELETE_BRAND_CONFIRMATION_DESCRIPTION,
  DELETE_BRAND_SUCCESS,
  DELETE_BRAND_ERROR,
  DELETE_BRAND_MAIN_CANNOT_DELETE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR,
  ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION,
  BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON,
  BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN,
  BRAND_USAGE_ALLOCATION_BELOW_CONSUMED,
  HEALTH_SCORE_LABEL,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  VIDEO_LANGUAGE,
  GENERATION_FAILED,
  ASPECT_RATIO_PLACEHOLDER,
  ASPECT_RATIO_9_16,
  ASPECT_RATIO_16_9,
  ASPECT_RATIO_1_1,
  ASPECT_RATIO_4_5,
  GENERATING_CREATIVE_TITLE,
  GENERATING_CREATIVE_SUCCESS,
  GENERATING_CREATIVE_ERROR,
  ALERT_GENERIC_ERROR_TITLE,
  GENERATING_CUSTOM_REPORT_MESSAGE,
  GENERATING_CUSTOM_REPORT_SUCCESS,
  GENERATING_CUSTOM_REPORT_ERROR,
  ANALYZING_IMAGE_LAYERS_MESSAGE,
  ANALYZING_IMAGE_LAYERS_SUCCESS,
  ANALYZING_IMAGE_LAYERS_ERROR,
  ANALYZING_CREATIVE_TEMPLATE_MESSAGE,
  ANALYZING_CREATIVE_TEMPLATE_SUCCESS,
  ANALYZING_CREATIVE_TEMPLATE_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR,
  PRODUCING_CREATIVE_TEMPLATE_ERROR,
  EDITING_IMAGE_TITLE,
  EDITING_IMAGE_SUCCESS,
  EDITING_IMAGE_ERROR,
  RESIZING_IMAGE_TITLE,
  RESIZING_IMAGE_SUCCESS,
  RESIZING_IMAGE_ERROR,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE,
  VIDEO_TYPE_UNBOXING,
  VIDEO_TYPE_PRODUCT_SHOWCASE,
  VIDEO_TYPE_UGC,
  VIDEO_TYPE_LIFESTYLE,
  VIDEO_TYPE_TESTIMONIALS_REVIEWS,
  VIDEO_TYPE_TESTIMONIAL,
  VIDEO_TYPE_EMOTIONAL_STORYTELLING,
  VIDEO_TYPE_CASE_STUDY,
  VIDEO_TYPE_CORPORATE,
  AGENT_LABEL,
  VIDEOS_REMAINING_SHORT,
  REST_VIDEOS,
  REST_CREATIVE_SINGULAR,
  REST_VIDEO_SINGULAR,
  REST_CREDITS,
  CREATIVES_REMAINING_SHORT_SINGULAR,
  SUGGESTED_CREATIVES_COUNT,
  VIDEOS_REMAINING_SHORT_SINGULAR,
  MAX_TOTAL_BUDGET_PLACEHOLDER,
  MIN_TOTAL_BUDGET_PLACEHOLDER,
  MAX_DAILY_BUDGET_PLACEHOLDER,
  MIN_DAILY_BUDGET_PLACEHOLDER,
  FIELD_APP_ID_REQUIRED_AD_PREVIEW,
  FIELD_URL_VALID_WITH_PROTOCOL,
  INVALID_APP_DEEP_LINK,
  CONNECTING_TO_PLATFORM_DESCRIPTION,
  MODAL_SAVED_AUDIENCES_TITLE,
  MODAL_SAVED_AUDIENCES_DESCRIPTION,
  BUTTON_USE_SAVED_AUDIENCE,
  ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE,
  YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS,
  GENERATION_VIDEO_REJECTED,
  VIDEO_INPUT_REAL_PERSON_REJECTED,
  IMAGE_LAYERS_CONTENT_POLICY_VIOLATION,
  AI_PROVIDER_CREDENTIALS_INVALID,
  AI_PROVIDER_CREDENTIALS_INVALID_GENERIC,
  AI_REQUEST_TIMEOUT,
  DARK_POST_DESCRIPTION_PLACEHOLDER,
  DARK_POST_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL,
  ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL,
  ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL,
  ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL,
  FILE_UPLOADED,
  CHAT_THINKING,
  GO_TO_DASHBOARD,
  IMAGES_MODERATION_BLOCKED,
  MALFORMED_FUNCTION_CALL,
  ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE,
  ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  RESET_CHAT_ALERT_TITLE,
  RESET_CHAT_ALERT_DESCRIPTION,
  DISCARD_OPTIMIZATION_ALERT_DESCRIPTION,
  DISCARD_OPTIMIZATION_ALERT_TITLE,
  DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION,
  DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION,
  DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION,
  DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  BUTTON_DISCARD_ALL,
  DISCARD_ALL_ACTIVITIES_TITLE,
  DISCARD_ALL_ACTIVITIES_DESCRIPTION,
  ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL,
  VIDEO_GENERATION_FAILED_BY_PROVIDER,
  AI_RATE_LIMITED,
  AI_PROVIDER_UNAVAILABLE,
  AI_GENERATION_FAILED,
  AGENT_REQUEST_COULD_NOT_BE_PROCESSED,
  CREDITS_RETURNED_SUFFIX,
  CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_AI_PROVIDER_ERROR,
  CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION,
  APP_STORE_ANDROID,
  APP_STORE_IOS,
  APP_STORE_PLACEHOLDER,
  GOOGLE_APP,
  MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES,
  MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK,
  MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION,
  MODAL_SUBTITLE_OPTIONS_TITLE,
  MODAL_SUBTITLE_OPTIONS_PERSONALIZE,
  MODAL_SUBTITLE_OPTIONS_FONT_FAMILY,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC,
  MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR,
  MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD,
  MODAL_SUBTITLE_OPTIONS_PRESET,
  MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_PRESET_BOXED,
  MODAL_SUBTITLE_OPTIONS_BOX_COLOR,
  MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND,
  MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR,
  MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL,
  ACCENT_ES_ARGENTINO,
  ACCENT_ES_COLOMBIANO,
  ACCENT_ES_CHILENO,
  ACCENT_ES_MEXICANO,
  ACCENT_ES_ESPANOL_ESPANA,
  ACCENT_ES_PERUANO,
  ACCENT_ES_VENEZOLANO,
  ACCENT_ES_CARIBENO,
  ACCENT_ES_NEUTRAL,
  ACCENT_ES_PUERTORRIQUENO,
  ACCENT_EN_AMERICAN,
  ACCENT_EN_BRITISH,
  ACCENT_EN_AUSTRALIAN,
  ACCENT_EN_NEUTRAL,
  REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  ANALYZING_CONTENT,
  CONTENT_RECOMMENDATIONS,
  NO_CONTENT_RECOMMENDATIONS,
  CONTENT_WARNING_TITLE,
  CONTENT_RECOMMENDATIONS_SUBTITLE,
  CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA,
  CONTENT_RECOMMENDATIONS_BANNER_TITLE,
  CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION,
  CONTENT_RECOMMENDATIONS_VIEW_ALL,
  CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS,
  CONTENT_RECOMMENDATION_GENERATED,
  CONTENT_RECOMMENDATION_GENERATE_ARIA,
  CONTENT_RECOMMENDATIONS_ALL_COMPLETED,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION,
  CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION,
  PARTNERSHIP,
  VIDEO_TYPE_OTHER,
  BAD,
  REGULAR,
  GOOD,
  VERY_GOOD,
  EXCELLENT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE,
  FIELD,
  EMPTY_TRACKING_IDS_LINKEDIN,
  TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER,
  AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
  LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER,
  LINKEDIN_PUBLISH_AS_PERSONAL_LABEL,
  LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL,
  TRACKING_LINKEDIN_ID_PLACEHOLDER,
  BUTTON_UPLOAD,
  BUTTON_UPLOAD_FILES,
  BUTTON_UPLOAD_FOLDER,
  BUTTON_URL,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE,
  ALERT_DESCRIPTION_DISCONNECT_LINKEDIN,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING,
  AD_FORMAT_PLACEHOLDER,
  SELECT_AD_FORMAT_TO_CONTINUE,
  INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW,
  MODAL_LEAD_FORMS_LIST_TITLE,
  MODAL_LEAD_FORMS_LIST_DESCRIPTION,
  MODAL_LEAD_FORMS_EMPTY_TEXT,
  MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT,
  MODAL_LEAD_FORMS_VIEW,
  MODAL_LEAD_FORMS_COPY_NAME_PREFIX,
  MODAL_CREATE_LEAD_FORM_TITLE,
  MODAL_VIEW_LEAD_FORM_TITLE,
  INSTANT_FORM_PREVIEW_MORE,
  MODAL_CREATE_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_LOAD_ERROR,
  MODAL_CREATE_LEAD_FORM_LOCALE_WARNING,
  MODAL_CREATE_LEAD_FORM_NAME,
  MODAL_CREATE_LEAD_FORM_HEADLINE,
  MODAL_CREATE_LEAD_FORM_DETAILS,
  MODAL_CREATE_LEAD_FORM_SECTION_FORM,
  MODAL_CREATE_LEAD_FORM_SECTION_CONTACT,
  MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY,
  MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_PHONE,
  MODAL_CREATE_LEAD_FORM_PROFILE_CITY,
  MODAL_CREATE_LEAD_FORM_PROFILE_STATE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY,
  MODAL_CREATE_LEAD_FORM_PROFILE_ZIP,
  MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY,
  MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS,
  MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TITLE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE,
  MODAL_CREATE_LEAD_FORM_ADD_OPTION,
  MODAL_CREATE_LEAD_FORM_OPTION,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT,
  MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE,
  MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL,
  MODAL_CREATE_LEAD_FORM_CTA,
  MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE,
  MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE,
  MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW,
  MODAL_CREATE_LEAD_FORM_MIN_OPTIONS,
  MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY,
  CAMPAIGN_LEARNINGS_TITLE,
  CAMPAIGN_LEARNINGS_SUBTITLE,
  CAMPAIGN_LEARNINGS_KEY_LEARNINGS,
  CAMPAIGN_LEARNINGS_WHAT_WORKED,
  CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK,
  PLATFORM_META,
  PLATFORM_GOOGLE,
  TABLE_ADMIN_DASHBOARD_CPA,
  TABLE_ADMIN_DASHBOARD_RESULTS,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE,
  TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS,
  SUGGESTED_CREATIVES_PROGRESS,
  LOGO_DESCRIPTION,
  CALENDAR_MULTIPLE_POST_TITLE,
  BENEFICIARY_OR_PAYER_NOT_FOUND,
  MODAL_BRAND_SETUP_CONFIRM_TITLE,
  MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION,
  MODAL_BRAND_SETUP_CONFIRM_BUTTON,
  MODAL_BRAND_SETUP_REVIEW_BUTTON,
  MODAL_UPLOAD_FACEBOOK_TYPE_LABEL,
  TYPE_CONTENT_FACEBOOK_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL,
  CALENDAR_STORIES_TITLE,
  CALENDAR_REELS_TITLE,
  MODAL_SELECT_CREDITS_ARIA_LABEL,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR,
  APPSUMO_SUBSCRIPTION_TIER_1,
  APPSUMO_SUBSCRIPTION_TIER_2,
  APPSUMO_SUBSCRIPTION_TIER_3,
  VALUE_SUBSCRIPTION_ONE_TIME,
  BUTTON_APPSUMO_VIEW_PLANS,
  VIDEO_RETENTION_RATE,
  VIDEO_HOOK_RATE,
  BUY_CREDITS,
  SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL,
  BRAND_SETUP_EXTRACTION_WARNING_MESSAGE,
  BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION,
  BRAND_SETUP_LOADING_ANALYZING_BRAND,
  BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE,
  BRAND_SETUP_LOADING_FINALIZING_DETAILS,
  BRAND_SETUP_GENERATION_PROMPT_LABEL,
  BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER,
  BRAND_SETUP_GENERATION_ATTACH_PDF,
  BRAND_SETUP_GENERATION_PDF_HINT,
  BRAND_SETUP_GENERATION_REMOVE_PDF,
  BRAND_SETUP_GENERATION_PDF_INVALID,
  BRAND_SETUP_GENERATION_PDF_TOO_LARGE,
  BRAND_SETUP_GENERATION_SHOW_ADVANCED,
  BRAND_SETUP_GENERATION_HIDE_ADVANCED,
  BRAND_SETUP_VERSION_CURRENT,
  BRAND_SETUP_VERSION_LABEL,
  BRAND_SETUP_VERSION_PLACEHOLDER,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION,
  BRAND_SETUP_GROUP_AUDIENCE_TITLE,
  BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION,
  BRAND_SETUP_GROUP_COPY_TITLE,
  BRAND_SETUP_GROUP_COPY_DESCRIPTION,
  BRAND_INSIGHTS_TAB_TITLE,
  BRAND_INSIGHTS_PAGE_TITLE,
  BRAND_INSIGHTS_PAGE_DESCRIPTION,
  BRAND_INSIGHTS_POSITIVE_TITLE,
  BRAND_INSIGHTS_NEGATIVE_TITLE,
  BRAND_INSIGHTS_POSITIVE_SUBTITLE,
  BRAND_INSIGHTS_NEGATIVE_SUBTITLE,
  BRAND_INSIGHTS_TOPIC_ANGLE,
  BRAND_INSIGHTS_TOPIC_COPY,
  BRAND_INSIGHTS_TOPIC_CTA,
  BRAND_INSIGHTS_TOPIC_TONE,
  BRAND_INSIGHTS_TOPIC_AESTHETIC,
  BRAND_INSIGHTS_TOPIC_VALUE_PROP,
  BRAND_INSIGHTS_EMPTY,
  BRAND_INSIGHTS_REVIEW_CHANGE,
  BRAND_INSIGHTS_DISMISS,
  BRAND_INSIGHTS_DISMISS_ALERT_TITLE,
  BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION,
  BRAND_INSIGHTS_COUNT,
  BRAND_INSIGHTS_UNREAD_ONE,
  BRAND_INSIGHTS_UNREAD_OTHER,
  BRAND_INSIGHTS_APPLY_TITLE,
  BRAND_INSIGHTS_APPLY_LOADING,
  BRAND_INSIGHTS_APPLY_CONFIRM,
  BRAND_INSIGHTS_APPLY_CANCEL,
  BRAND_INSIGHTS_APPLY_REJECTED,
  BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG,
  BRAND_INSIGHTS_APPLY_UNMAPPABLE,
  BRAND_INSIGHTS_APPLY_REWRITE,
  BRAND_INSIGHTS_APPLY_RETRY,
  BRAND_INSIGHTS_APPLY_TIMEOUT,
  BRAND_INSIGHTS_APPLY_FIELD,
  BRAND_INSIGHTS_APPLY_RESULT_TITLE,
  BRAND_INSIGHTS_APPLY_SHOW_FULL,
  BRAND_INSIGHTS_APPLY_SHOW_CHANGES,
  BRAND_INSIGHTS_APPLY_NO_CHANGES,
  BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED,
  LINKEDIN_ARTICLE_DEFAULT_TEXT,
  CREDIT_REWARD_MODAL_TITLE,
  CREDIT_REWARD_MODAL_SUBTITLE,
  CREDIT_REWARD_MODAL_ARIA_LABEL,
  CREDIT_REWARD_MODAL_REWARD,
  CREDIT_REWARD_MODAL_REWARD_DESCRIPTION,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER,
  CREDIT_REWARD_MODAL_VERIFICATION_NOTICE,
  CREDIT_REWARD_MODAL_BUTTON_CANCEL,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISH,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISHING,
  CREDIT_REWARD_MODAL_BUTTON_RETRY,
  CREDIT_REWARD_MODAL_LOADING_TITLE,
  CREDIT_REWARD_MODAL_LOADING_DESCRIPTION,
  CREDIT_REWARD_MODAL_SUCCESS_TITLE,
  CREDIT_REWARD_MODAL_SUCCESS_TEXT,
  CREDIT_REWARD_MODAL_ERROR_TITLE,
  CREDIT_REWARD_MODAL_ERROR_TEXT,
  CREDIT_REWARD_MODAL_BUTTON_TEXT,
  ALERT_CANCEL_PLAN_TITLE,
  X,
  THREADS,
  INSTAGRAM_FEED_ASPECT_RATIO_WARNING,
  CAROUSEL_MIN_IMAGES_WARNING,
  CAROUSEL_MAX_IMAGES_WARNING,
  CAROUSEL_DRAG_TO_REORDER,
  CAROUSEL_ADD_MORE_IMAGES,
  CAROUSEL_IMAGES_SELECTED,
  CAROUSEL_MAIN_IMAGE,
  TYPE_CONTENT_TIKTOK_LABEL,
  MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
  TIKTOK_AUTO_ADD_MUSIC_LABEL,
  CONTENT_TYPE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_TITLE,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST,
  CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE,
  BUTTON_KEEP_TEXTS,
  REGENERATING_AD_TEXTS_OVERLAY_MESSAGE,
  BRAND_SETUP_SECTION_BRAND_NAME,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER,
  ANONYMOUS_USER,
  LINKEDIN_STAFF_COUNT_MYSELF_ONLY,
  LINKEDIN_STAFF_COUNT_2_10,
  LINKEDIN_STAFF_COUNT_11_50,
  LINKEDIN_STAFF_COUNT_51_200,
  LINKEDIN_STAFF_COUNT_201_500,
  LINKEDIN_STAFF_COUNT_501_1000,
  LINKEDIN_STAFF_COUNT_1001_5000,
  LINKEDIN_STAFF_COUNT_5001_10000,
  LINKEDIN_STAFF_COUNT_10001_PLUS,
  LINKEDIN_JOB_FUNCTION_ACCOUNTING,
  LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE,
  LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN,
  LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT,
  LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES,
  LINKEDIN_JOB_FUNCTION_CONSULTING,
  LINKEDIN_JOB_FUNCTION_EDUCATION,
  LINKEDIN_JOB_FUNCTION_ENGINEERING,
  LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP,
  LINKEDIN_JOB_FUNCTION_FINANCE,
  LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES,
  LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES,
  LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY,
  LINKEDIN_JOB_FUNCTION_LEGAL,
  LINKEDIN_JOB_FUNCTION_MARKETING,
  LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION,
  LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES,
  LINKEDIN_JOB_FUNCTION_OPERATIONS,
  LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PURCHASING,
  LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE,
  LINKEDIN_JOB_FUNCTION_REAL_ESTATE,
  LINKEDIN_JOB_FUNCTION_RESEARCH,
  LINKEDIN_JOB_FUNCTION_SALES,
  LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT,
  LINKEDIN_SENIORITY_UNPAID,
  LINKEDIN_SENIORITY_TRAINING,
  LINKEDIN_SENIORITY_ENTRY,
  LINKEDIN_SENIORITY_SENIOR,
  LINKEDIN_SENIORITY_MANAGER,
  LINKEDIN_SENIORITY_DIRECTOR,
  LINKEDIN_SENIORITY_VP,
  LINKEDIN_SENIORITY_CXO,
  LINKEDIN_SENIORITY_PARTNER,
  LINKEDIN_SENIORITY_OWNER,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED,
  LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION,
  LINKEDIN_MEMBER_BEHAVIOR_EXPAT,
  LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_WINDOWS,
  LINKEDIN_MEMBER_BEHAVIOR_MAC,
  LINKEDIN_MEMBER_BEHAVIOR_LINUX,
  RETRIEVING_YOUTUBE_CHANNEL,
  RETRIEVING_TIKTOK_PROFILE,
  ESTABLISHING_CONNECTION_WITH_PLATFORM,
  RETRIEVING_AUTHORIZATION_DATA,
  OPENING_AUTHORIZATION_WINDOW,
  CONNECTING_CANVA_VERIFYING_AUTHORIZATION,
  CONNECTING_CANVA_LINKING_ACCOUNT,
  MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL,
  MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL,
  MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL,
  MODAL_FEEDBACK_TITLE,
  MODAL_FEEDBACK_DESCRIPTION,
  MODAL_FEEDBACK_PLACEHOLDER,
  MODAL_FEEDBACK_LIKE_LABEL,
  MODAL_FEEDBACK_DISLIKE_LABEL,
  MODAL_REPORT_CONTENT_TITLE,
  MODAL_REPORT_CONTENT_DESCRIPTION,
  MODAL_REPORT_CONTENT_PLACEHOLDER,
  MODAL_REPORT_CONTENT_SUCCESS,
  BUTTON_REPORT_CONTENT,
  FILTERS_GALLERY_CAROUSEL,
  GALLERY_CREATE_CAROUSEL,
  FILTERS_GALLERY_FEED,
  DASHBOARD_METRICS_DELAY_DISMISS,
  ALERT_DELETE_ELEMENT_DESCRIPTION,
  ALERT_DELETE_ELEMENT_TITLE,
  DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  BUTTON_DELETE_LOGO,
  LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED,
  MODAL_EDIT_URL_PARAMETERS_TITLE,
  MODAL_EDIT_URL_PARAMETERS_DESCRIPTION,
  MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE,
  MODAL_EDIT_URL_PARAMETERS_CONFIGURED,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED,
  MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL,
  URL_EXAMPLE_PLACEHOLDER,
  WHY_WOULD_IT_WORK,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL,
  BUTTON_CONTINUE_WITHOUT_CHANGES,
  BUTTON_RESIZE_AND_CONTINUE,
  ANIMATING_IMAGE_TITLE,
  ANIMATING_IMAGE_SUCCESS,
  ANIMATING_IMAGE_ERROR,
  CAMPAIGN_IS_GENERATING,
  INVALID_JOB_TYPE,
  JOB_CANCELLED_OR_FAILED,
  JOB_TIMEOUT,
  CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  VIDEO_TYPE_SURREAL,
  VIDEO_TYPE_MEGA_CREATIVE,
  SECTION_BUYER_PERSONA_PLACEHOLDER_NAME,
  SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION,
  ALL,
  SET_PASSWORD,
  COUNTRY_ANDORRA,
  COUNTRY_UNITED_ARAB_EMIRATES,
  COUNTRY_AFGHANISTAN,
  COUNTRY_ANTIGUA_AND_BARBUDA,
  COUNTRY_ANGUILLA,
  COUNTRY_ALBANIA,
  COUNTRY_ARMENIA,
  COUNTRY_ANGOLA,
  COUNTRY_ANTARCTICA,
  COUNTRY_ARGENTINA,
  COUNTRY_AMERICAN_SAMOA,
  COUNTRY_AUSTRIA,
  COUNTRY_AUSTRALIA,
  COUNTRY_ARUBA,
  COUNTRY_ALLAND_ISLANDS,
  COUNTRY_AZERBAIJAN,
  COUNTRY_BOSNIA_AND_HERZEGOVINA,
  COUNTRY_BARBADOS,
  COUNTRY_BANGLADESH,
  COUNTRY_BELGIUM,
  COUNTRY_BURKINA_FASO,
  COUNTRY_BULGARIA,
  COUNTRY_BAHRAIN,
  COUNTRY_BURUNDI,
  COUNTRY_BENIN,
  COUNTRY_SAINT_BARTHELEMY,
  COUNTRY_BERMUDA,
  COUNTRY_BRUNEI_DARUSSALAM,
  COUNTRY_BOLIVIA,
  COUNTRY_BRAZIL,
  COUNTRY_BAHAMAS,
  COUNTRY_BHUTAN,
  COUNTRY_BOUVET_ISLAND,
  COUNTRY_BOTSWANA,
  COUNTRY_BELARUS,
  COUNTRY_BELIZE,
  COUNTRY_CANADA,
  COUNTRY_COCOS_KEELING_ISLANDS,
  COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE,
  COUNTRY_CENTRAL_AFRICAN_REPUBLIC,
  COUNTRY_CONGO_REPUBLIC_OF_THE,
  COUNTRY_SWITZERLAND,
  COUNTRY_COTE_D_IVOIRE,
  COUNTRY_COOK_ISLANDS,
  COUNTRY_CHILE,
  COUNTRY_CAMEROON,
  COUNTRY_CHINA,
  COUNTRY_COLOMBIA,
  COUNTRY_COSTA_RICA,
  COUNTRY_CUBA,
  COUNTRY_CAPE_VERDE,
  COUNTRY_CURACAO,
  COUNTRY_CHRISTMAS_ISLAND,
  COUNTRY_CYPRUS,
  COUNTRY_CZECH_REPUBLIC,
  COUNTRY_GERMANY,
  COUNTRY_DJIBOUTI,
  COUNTRY_DENMARK,
  COUNTRY_DOMINICA,
  COUNTRY_DOMINICAN_REPUBLIC,
  COUNTRY_ALGERIA,
  COUNTRY_ECUADOR,
  COUNTRY_ESTONIA,
  COUNTRY_EGYPT,
  COUNTRY_WESTERN_SAHARA,
  COUNTRY_ERITREA,
  COUNTRY_SPAIN,
  COUNTRY_ETHIOPIA,
  COUNTRY_FINLAND,
  COUNTRY_FIJI,
  COUNTRY_FALKLAND_ISLANDS_MALVINAS,
  COUNTRY_MICRONESIA_FEDERATED_STATES_OF,
  COUNTRY_FAROE_ISLANDS,
  COUNTRY_FRANCE,
  COUNTRY_GABON,
  COUNTRY_UNITED_KINGDOM,
  COUNTRY_GRENADA,
  COUNTRY_GEORGIA,
  COUNTRY_FRENCH_GUIANA,
  COUNTRY_GUERNSEY,
  COUNTRY_GHANA,
  COUNTRY_GIBRALTAR,
  COUNTRY_GREENLAND,
  COUNTRY_GAMBIA,
  COUNTRY_GUINEA,
  COUNTRY_GUADELOUPE,
  COUNTRY_EQUATORIAL_GUINEA,
  COUNTRY_GREECE,
  COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  COUNTRY_GUATEMALA,
  COUNTRY_GUAM,
  COUNTRY_GUINEA_BISSAU,
  COUNTRY_GUYANA,
  COUNTRY_HONG_KONG,
  COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  COUNTRY_HONDURAS,
  COUNTRY_CROATIA,
  COUNTRY_HAITI,
  COUNTRY_HUNGARY,
  COUNTRY_INDONESIA,
  COUNTRY_IRELAND,
  COUNTRY_ISRAEL,
  COUNTRY_ISLE_OF_MAN,
  COUNTRY_INDIA,
  COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY,
  COUNTRY_IRAQ,
  COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF,
  COUNTRY_ICELAND,
  COUNTRY_ITALY,
  COUNTRY_JERSEY,
  COUNTRY_JAMAICA,
  COUNTRY_JORDAN,
  COUNTRY_JAPAN,
  COUNTRY_KENYA,
  COUNTRY_KYRGYZSTAN,
  COUNTRY_CAMBODIA,
  COUNTRY_KIRIBATI,
  COUNTRY_COMOROS,
  COUNTRY_SAINT_KITTS_AND_NEVIS,
  COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  COUNTRY_KOREA_REPUBLIC_OF,
  COUNTRY_KUWAIT,
  COUNTRY_CAYMAN_ISLANDS,
  COUNTRY_KAZAKHSTAN,
  COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  COUNTRY_LEBANON,
  COUNTRY_SAINT_LUCIA,
  COUNTRY_LIECHTENSTEIN,
  COUNTRY_SRI_LANKA,
  COUNTRY_LIBERIA,
  COUNTRY_LESOTHO,
  COUNTRY_LITHUANIA,
  COUNTRY_LUXEMBOURG,
  COUNTRY_LATVIA,
  COUNTRY_LIBYA,
  COUNTRY_MOROCCO,
  COUNTRY_MONACO,
  COUNTRY_MOLDOVA_REPUBLIC_OF,
  COUNTRY_MONTENEGRO,
  COUNTRY_SAINT_MARTIN_FRENCH_PART,
  COUNTRY_MADAGASCAR,
  COUNTRY_MARSHALL_ISLANDS,
  COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  COUNTRY_MALI,
  COUNTRY_MYANMAR,
  COUNTRY_MONGOLIA,
  COUNTRY_MACAO,
  COUNTRY_NORTHERN_MARIANA_ISLANDS,
  COUNTRY_MARTINIQUE,
  COUNTRY_MAURITANIA,
  COUNTRY_MONTSERRAT,
  COUNTRY_MALTA,
  COUNTRY_MAURITIUS,
  COUNTRY_MALDIVES,
  COUNTRY_MALAWI,
  COUNTRY_MEXICO,
  COUNTRY_MALAYSIA,
  COUNTRY_MOZAMBIQUE,
  COUNTRY_NAMIBIA,
  COUNTRY_NEW_CALEDONIA,
  COUNTRY_NIGER,
  COUNTRY_NORFOLK_ISLAND,
  COUNTRY_NIGERIA,
  COUNTRY_NICARAGUA,
  COUNTRY_NETHERLANDS,
  COUNTRY_NORWAY,
  COUNTRY_NEPAL,
  COUNTRY_NAURU,
  COUNTRY_NIUE,
  COUNTRY_NEW_ZEALAND,
  COUNTRY_OMAN,
  COUNTRY_PANAMA,
  COUNTRY_PERU,
  COUNTRY_FRENCH_POLYNESIA,
  COUNTRY_PAPUA_NEW_GUINEA,
  COUNTRY_PHILIPPINES,
  COUNTRY_PAKISTAN,
  COUNTRY_POLAND,
  COUNTRY_SAINT_PIERRE_AND_MIQUELON,
  COUNTRY_PITCAIRN,
  COUNTRY_PUERTO_RICO,
  COUNTRY_PALESTINE_STATE_OF,
  COUNTRY_PORTUGAL,
  COUNTRY_PALAU,
  COUNTRY_PARAGUAY,
  COUNTRY_QATAR,
  COUNTRY_REUNION,
  COUNTRY_ROMANIA,
  COUNTRY_SERBIA,
  COUNTRY_RUSSIAN_FEDERATION,
  COUNTRY_RWANDA,
  COUNTRY_SAUDI_ARABIA,
  COUNTRY_SOLOMON_ISLANDS,
  COUNTRY_SEYCHELLES,
  COUNTRY_SUDAN,
  COUNTRY_SWEDEN,
  COUNTRY_SINGAPORE,
  COUNTRY_SAINT_HELENA,
  COUNTRY_SLOVENIA,
  COUNTRY_SVALBARD_AND_JAN_MAYEN,
  COUNTRY_SLOVAKIA,
  COUNTRY_SIERRA_LEONE,
  COUNTRY_SAN_MARINO,
  COUNTRY_SENEGAL,
  COUNTRY_SOMALIA,
  COUNTRY_SURINAME,
  COUNTRY_SOUTH_SUDAN,
  COUNTRY_SAO_TOME_AND_PRINCIPE,
  COUNTRY_EL_SALVADOR,
  COUNTRY_SINT_MAARTEN_DUTCH_PART,
  COUNTRY_SYRIAN_ARAB_REPUBLIC,
  COUNTRY_SWAZILAND,
  COUNTRY_TURKS_AND_CAICOS_ISLANDS,
  COUNTRY_CHAD,
  COUNTRY_FRENCH_SOUTHERN_TERRITORIES,
  COUNTRY_TOGO,
  COUNTRY_THAILAND,
  COUNTRY_TAJIKISTAN,
  COUNTRY_TOKELAU,
  COUNTRY_TIMOR_LESTE,
  COUNTRY_TURKMENISTAN,
  COUNTRY_TUNISIA,
  COUNTRY_TONGA,
  COUNTRY_TURKEY,
  COUNTRY_TRINIDAD_AND_TOBAGO,
  COUNTRY_TUVALU,
  COUNTRY_TAIWAN,
  COUNTRY_UNITED_REPUBLIC_OF_TANZANIA,
  COUNTRY_UKRAINE,
  COUNTRY_UGANDA,
  COUNTRY_UNITED_STATES,
  COUNTRY_URUGUAY,
  COUNTRY_UZBEKISTAN,
  COUNTRY_HOLY_SEE_VATICAN_CITY_STATE,
  COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES,
  COUNTRY_VENEZUELA,
  COUNTRY_BRITISH_VIRGIN_ISLANDS,
  COUNTRY_US_VIRGIN_ISLANDS,
  COUNTRY_VIETNAM,
  COUNTRY_VANUATU,
  COUNTRY_WALLIS_AND_FUTUNA,
  COUNTRY_SAMOA,
  COUNTRY_KOSOVO,
  COUNTRY_YEMEN,
  COUNTRY_MAYOTTE,
  COUNTRY_SOUTH_AFRICA,
  COUNTRY_ZAMBIA,
  COUNTRY_ZIMBABWE,
  POST,
  MODAL_CREDITS_USAGE_DETAILED_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL,
  MODAL_CREDITS_USAGE_DETAILED_LINK,
  MODAL_CREDITS_USAGE_DETAILED_PERIOD,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_LOADING,
  MODAL_CREDITS_USAGE_DETAILED_EMPTY,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING,
  PRE_ACTIVATION_BADGE,
  PRE_ACTIVATION_SECTION_01_BUSINESS,
  PRE_ACTIVATION_SECTION_02_CURRENT_ADS,
  PRE_ACTIVATION_SECTION_03_OBJECTIVES,
  PRE_ACTIVATION_SECTION_04_MEETING_ACCESS,
  PRE_ACTIVATION_HERO_TITLE,
  PRE_ACTIVATION_HERO_DESCRIPTION,
  PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_FIELD_BUSINESS_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME,
  PRE_ACTIVATION_FIELD_FULL_NAME,
  PRE_ACTIVATION_FIELD_EMAIL,
  PRE_ACTIVATION_FIELD_WHATSAPP,
  PRE_ACTIVATION_FIELD_WHAT_YOU_SELL,
  PRE_ACTIVATION_HINT_WHAT_YOU_SELL,
  PRE_ACTIVATION_FIELD_AVERAGE_PRICE,
  PRE_ACTIVATION_HINT_AVERAGE_PRICE,
  PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER,
  PRE_ACTIVATION_HINT_IDEAL_CUSTOMER,
  PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS,
  PRE_ACTIVATION_FIELD_WEBSITE_URL,
  PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_WHATSAPP,
  PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL,
  PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE,
  PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER,
  PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA,
  PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP,
  PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE,
  PRE_ACTIVATION_SALES_CHANNEL_APP,
  PRE_ACTIVATION_FIELD_HAS_ADS,
  PRE_ACTIVATION_HAS_ADS_SI,
  PRE_ACTIVATION_HAS_ADS_ANTES,
  PRE_ACTIVATION_HAS_ADS_NO,
  PRE_ACTIVATION_FIELD_AD_PLATFORMS,
  PRE_ACTIVATION_ADS_PLATFORM_META,
  PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  PRE_ACTIVATION_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_FIELD_CURRENT_METRICS,
  PRE_ACTIVATION_HINT_CURRENT_METRICS,
  PRE_ACTIVATION_FIELD_TARGET_CPA,
  PRE_ACTIVATION_HINT_TARGET_CPA,
  PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS,
  PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA,
  PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_FIELD_MONTHLY_SALES,
  PRE_ACTIVATION_FIELD_SALES_GOAL_60_90,
  PRE_ACTIVATION_FIELD_BUZZLY_FOCUS,
  PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE,
  PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO,
  PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES,
  PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90,
  PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_MEETING_INTRO,
  PRE_ACTIVATION_FIELD_MEETING_ACCESS,
  PRE_ACTIVATION_MEETING_ACCESS_META_BM,
  PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_GA4,
  PRE_ACTIVATION_MEETING_ACCESS_PIXEL,
  PRE_ACTIVATION_MEETING_ACCESS_GTM,
  PRE_ACTIVATION_FIELD_ACCESS_NOT_READY,
  PRE_ACTIVATION_HINT_ACCESS_NOT_READY,
  PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY,
  PRE_ACTIVATION_ARIA_REQUIRED,
  PRE_ACTIVATION_SUBMIT_BUTTON,
  PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE,
  PRE_ACTIVATION_CONFIDENTIALITY_NOTE,
  PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE,
  PRE_ACTIVATION_HINT_ORGANIZATION_TYPE,
  PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL,
  PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL,
  PRE_ACTIVATION_SECTION_CONTACT,
  PRE_ACTIVATION_FIELD_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_01_BASICS,
  PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE,
  PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS,
  PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS,
  PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS,
  PRE_ACTIVATION_FIELD_AGENCY_MODULES,
  PRE_ACTIVATION_HINT_AGENCY_MODULES,
  PRE_ACTIVATION_AGENCY_MODULE_CREATIVE,
  PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA,
  PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL,
  PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS,
  PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_OPTION_YES,
  PRE_ACTIVATION_OPTION_NO,
  PRE_ACTIVATION_BEFORE_START_LABEL,
  PRE_ACTIVATION_BEFORE_START_TITLE,
  PRE_ACTIVATION_BEFORE_START_INTRO,
  PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_CALLOUT,
  PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  PRE_ACTIVATION_FIELD_AGENCY_PHONE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE,
  PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_SECTION_AGENCY_02_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_05_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_06_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_06_HEADING,
  PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL,
  PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED,
  PRE_ACTIVATION_AGENCY_TEAM_CALLOUT,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON,
  PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT,
  PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL,
  PRE_ACTIVATION_ONBOARDING_MODAL_TITLE,
  PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION,
  PRE_ACTIVATION_SCHEDULED_SESSION_TITLE,
  PRE_ACTIVATION_SCHEDULED_SESSION_DATE,
  PRE_ACTIVATION_SCHEDULED_SESSION_TIME,
  PRE_ACTIVATION_SCHEDULED_SESSION_MISSING,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY,
  OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE,
  ALERT_IMAGE_PROVIDER_STATUS_BANNER,
  ALERT_VIDEO_PROVIDER_STATUS_BANNER,
  ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER,
  TIKTOK_ADGROUP_PLACEMENTS_TITLE,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION,
  WHATSAPP,
  ID_PLATFORM,
  APPSUMO_CALLBACK_CONNECTING,
  APPSUMO_CALLBACK_ERROR_TITLE,
  APPSUMO_CALLBACK_ERROR_DESCRIPTION,
  APPSUMO_CALLBACK_ERROR_CODE_EXPIRED,
  APPSUMO_CALLBACK_ERROR_OAUTH_DENIED,
  APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO,
  APPSUMO_CALLBACK_ERROR_ANOMALOUS,
  APPSUMO_REGISTER_TITLE,
  APPSUMO_REGISTER_SUBTITLE,
  APPSUMO_REGISTER_BUTTON_SUBMIT,
  APPSUMO_REGISTER_SESSION_EXPIRED,
  APP_SUMO_REACTIVATION_NOT_ELIGIBLE,
  APPSUMO_REACTIVATION_OTP_TITLE,
  APPSUMO_REACTIVATION_OTP_EMAIL_SENT,
  BUTTON_HIRE_PERFORMANCE_SPECIALIST,
  MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL,
  MODAL_PERFORMANCE_SPECIALIST_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_SUBTITLE,
  MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_1,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_2,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_3,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_4,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2,
  MODAL_PERFORMANCE_SPECIALIST_CTA,
  MODAL_AD_HOC_SUPPORT_ARIA_LABEL,
  MODAL_AD_HOC_SUPPORT_TITLE,
  MODAL_AD_HOC_SUPPORT_DESCRIPTION,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION,
  BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL,
  ALERT_AD_ACCOUNT_NO_BALANCE_LABEL,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS,
  ENTERPRISE_INTAKE_BADGE,
  ENTERPRISE_INTAKE_BADGE_AGENCY,
  ENTERPRISE_INTAKE_BADGE_BRAND,
  ENTERPRISE_INTAKE_HERO_TITLE,
  ENTERPRISE_INTAKE_HERO_DESCRIPTION,
  ENTERPRISE_INTAKE_SECTION_01_CONTACT,
  ENTERPRISE_INTAKE_SECTION_03_USERS,
  ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT,
  ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_ARIA_REQUIRED,
  ENTERPRISE_INTAKE_SUBMIT_BUTTON,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE,
  ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE,
  ENTERPRISE_INTAKE_OTHER_OPTION,
  ENTERPRISE_INTAKE_OTHER_PLACEHOLDER,
  ENTERPRISE_INTAKE_FIELD_FULL_NAME,
  ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_FIELD_COMPANY_NAME,
  ENTERPRISE_INTAKE_FIELD_JOB_TITLE,
  ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED,
  ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS,
  ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT,
  ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH,
  ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR,
  ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR,
  ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES,
  ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES,
  ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS,
  ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND,
  ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND,
  ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE1_INTRO,
  ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG,
  ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL,
  ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE2_INTRO,
  ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_INTRO,
  ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_META,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN,
  ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_MODULE4_INTRO,
  ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER,
  ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE,
  ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE,
  ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE,
  ENTERPRISE_INTAKE_MODULE4_POST_MIXED,
  ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS,
  ENTERPRISE_INTAKE_CREDITS_MIXED,
  ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE,
  ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE,
  ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE,
  ENTERPRISE_INTAKE_VOLUME_ZERO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_CHANNEL_META,
  ENTERPRISE_INTAKE_CHANNEL_GOOGLE,
  ENTERPRISE_INTAKE_CHANNEL_TIKTOK,
  ENTERPRISE_INTAKE_CHANNEL_LINKEDIN,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K,
  ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES,
  ENTERPRISE_INTAKE_FIELD_WHITE_LABEL,
  ENTERPRISE_INTAKE_HINT_WHITE_LABEL,
  ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL,
  ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED,
  ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED,
  ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE,
  ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_BUDGET_LT_1000,
  ENTERPRISE_INTAKE_BUDGET_1000_2500,
  ENTERPRISE_INTAKE_BUDGET_2500_5000,
  ENTERPRISE_INTAKE_BUDGET_5000_10000,
  ENTERPRISE_INTAKE_BUDGET_GT_10000,
  ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED,
  ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER,
  ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL,
  ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY,
  ENTERPRISE_INTAKE_SUPPORT_PARTIAL,
  ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION,
  ENTERPRISE_INTAKE_FIELD_CSM_CADENCE,
  ENTERPRISE_INTAKE_CSM_WEEKLY,
  ENTERPRISE_INTAKE_CSM_BIWEEKLY,
  ENTERPRISE_INTAKE_CSM_MONTHLY,
  ENTERPRISE_INTAKE_CSM_AS_NEEDED,
  ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT,
  ENTERPRISE_INTAKE_CONTRACT_MONTHLY,
  ENTERPRISE_INTAKE_CONTRACT_QUARTERLY,
  ENTERPRISE_INTAKE_CONTRACT_ANNUAL,
  ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS,
  ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS,
  ENTERPRISE_INTAKE_SECURITY_SSO,
  ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS,
  ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_MODULE_REPORTS,
  ENTERPRISE_INTAKE_MODULE_COMPETITORS,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND,
  ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND,
  ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_BUFFER_STATICS,
  ENTERPRISE_INTAKE_BUFFER_ANIMATIONS,
  ENTERPRISE_INTAKE_BUFFER_VIDEOS,
  ENTERPRISE_INTAKE_BUFFER_NONE,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_10,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_15,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_20,
  ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER,
  ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND,
  ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH,
  ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_HINT_CONTRACT_TERM,
  ENTERPRISE_INTAKE_CONTRACT_TERM_6,
  ENTERPRISE_INTAKE_CONTRACT_TERM_12,
  ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_MEDIA_ADDON_YES,
  ENTERPRISE_INTAKE_MEDIA_ADDON_NO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_WHITE_LABEL_YES,
  ENTERPRISE_INTAKE_WHITE_LABEL_NO,
  ENTERPRISE_INTAKE_SECTION_PLAN,
  OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION,
  OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE,
  OPTION_EMAIL,
  OPTION_META,
  OPTION_LINKEDIN,
  OPTION_GOOGLE,
  OPTION_LLM,
  OPTION_OTHER,
  GLOBAL_REPORT_TITLE,
  GLOBAL_REPORT_DESCRIPTION,
  GLOBAL_REPORT_MENU_GROUP,
  GLOBAL_REPORT_MENU_ITEM,
  GLOBAL_REPORT_PAGE_TITLE,
  GLOBAL_REPORT_PERIOD_LAST_7_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_14_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_30_DAYS,
  GLOBAL_REPORT_AI_ANALYSIS,
  GLOBAL_REPORT_OBJECTIVES_BUTTON,
  GLOBAL_REPORT_TOTAL_INVESTMENT,
  GLOBAL_REPORT_AVERAGE_ROAS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS,
  GLOBAL_REPORT_REMAINING_BUDGET,
  GLOBAL_REPORT_BUDGET_EXPIRES_IN,
  GLOBAL_REPORT_PAUSED_CAMPAIGNS,
  GLOBAL_REPORT_VS_PREVIOUS_WEEK,
  GLOBAL_REPORT_AGENT_INSIGHTS,
  GLOBAL_REPORT_NEW_INSIGHTS,
  GLOBAL_REPORT_NO_INSIGHTS,
  GLOBAL_REPORT_INSIGHTS_ERROR,
  GLOBAL_REPORT_SUMMARY_TITLE,
  GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT,
  GLOBAL_REPORT_INSIGHTS_QUESTION,
  GLOBAL_REPORT_GENERATING_SUMMARY,
  GLOBAL_REPORT_SUMMARY_NOT_GENERATED,
  GLOBAL_REPORT_ASK_QUESTION,
  GLOBAL_REPORT_ASK_QUESTION_OPEN,
  GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS,
  GLOBAL_REPORT_AGENT_ACTIONS,
  GLOBAL_REPORT_ACTIONS_PERFORMED,
  GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN,
  GLOBAL_REPORT_ACTION_TYPE_CREATIVES,
  GLOBAL_REPORT_ACTION_TYPE_VIDEOS,
  GLOBAL_REPORT_ACTION_TYPE_MESSAGES,
  GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED,
  GLOBAL_REPORT_ACTION_TYPE_GENERIC,
  GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE,
  GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE,
  GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE,
  GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD,
  GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD,
  GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD,
  GLOBAL_REPORT_SELECT_DATES_PROMPT,
  GLOBAL_REPORT_MEASURABLE_KPI_LABEL,
  GLOBAL_REPORT_MEASURABLE_KPI_ALL,
  GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI,
  GLOBAL_REPORT_DOWNLOAD_NOT_READY,
  GLOBAL_REPORT_PDF_OPTION,
  GLOBAL_REPORT_CUSTOM_OPTION,
  GLOBAL_REPORT_SERVER_PDF_BUTTON,
  GLOBAL_REPORT_SERVER_PDF_FOOTER,
  GLOBAL_REPORT_SERVER_PDF_FILE_NAME,
  MODAL_CUSTOM_REPORT_CTA,
  MODAL_CUSTOM_REPORT_TITLE,
  MODAL_CUSTOM_REPORT_DESCRIPTION,
  MODAL_CUSTOM_REPORT_TEMPLATE,
  MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL,
  MODAL_CUSTOM_REPORT_TEMPLATE_SALES,
  MODAL_CUSTOM_REPORT_TEMPLATE_LEADS,
  MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM,
  MODAL_CUSTOM_REPORT_PROMPT,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER,
  MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT,
  MODAL_CUSTOM_REPORT_DATES,
  MODAL_CUSTOM_REPORT_FORMAT,
  MODAL_CUSTOM_REPORT_LANGUAGE,
  MODAL_CUSTOM_REPORT_FORMAT_PDF,
  MODAL_CUSTOM_REPORT_FORMAT_PPTX,
  MODAL_CUSTOM_REPORT_FORMAT_CSV,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV,
  MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE,
  MODAL_CUSTOM_REPORT_COLLECTING,
  MODAL_CUSTOM_REPORT_ANALYZING,
  MODAL_CUSTOM_REPORT_RENDERING,
  MODAL_CUSTOM_REPORT_ERROR,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS,
  GLOBAL_REPORT_HEAVY_LOAD_ANALYZING,
  GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_COLUMN_CAMPAIGN,
  GLOBAL_REPORT_COLUMN_INVESTMENT,
  GLOBAL_REPORT_COLUMN_ROAS,
  GLOBAL_REPORT_COLUMN_IMPRESSIONS,
  GLOBAL_REPORT_COLUMN_CTR,
  GLOBAL_REPORT_COLUMN_STATUS,
  GLOBAL_REPORT_STATUS_ALERT,
  GLOBAL_REPORT_STATUS_OPTIMAL,
  GLOBAL_REPORT_STATUS_BRAND,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION,
  GLOBAL_REPORT_ACTION_DATE_TODAY,
  GLOBAL_REPORT_ACTION_DATE_YESTERDAY,
  GLOBAL_REPORT_ACTION_DATE_MAR_26,
  GLOBAL_REPORT_ACTION_DATE_MAR_25,
  GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED,
  GLOBAL_REPORT_ACTION_IMAGES_GENERATED,
  GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED,
  GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED,
  GLOBAL_REPORT_DEFAULT_BRAND_NAME,
  GLOBAL_REPORT_STATS_TIME_TITLE,
  GLOBAL_REPORT_STATS_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE,
  GLOBAL_REPORT_STATS_RADAR_TITLE,
  GLOBAL_REPORT_STATS_RADAR_SUBTITLE,
  GLOBAL_REPORT_STATS_BELOW_AVERAGE,
  GLOBAL_REPORT_STATS_ABOVE_AVERAGE,
  GLOBAL_REPORT_STATS_NO_DATA,
  GLOBAL_REPORT_STATS_SPEND_AXIS,
  GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS,
  GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION,
  GLOBAL_REPORT_GOALS_TITLE,
  GLOBAL_REPORT_GOALS_SUBTITLE,
  GLOBAL_REPORT_GOALS_STACKED_TITLE,
  GLOBAL_REPORT_GOALS_STACKED_SUBTITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_TITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE,
  GLOBAL_REPORT_GOALS_ACHIEVED,
  GLOBAL_REPORT_GOALS_REMAINING,
  GLOBAL_REPORT_GOALS_EXCEEDED,
  GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL,
  GLOBAL_REPORT_GOALS_PROJECTION_FORECAST,
  GLOBAL_REPORT_GOALS_TARGET_LINE,
  GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT,
  GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON,
  GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT,
  VERIFICATION_CODE_INCORRECT,
  REGISTRATION_EMAIL_NOT_VERIFIED,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD,
  ORGANIC,
  ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE,
  ANIMATE,
  CAMPAIGN_APPROVAL_PAGE_TITLE,
  CAMPAIGN_APPROVAL_PAGE_DESCRIPTION,
  CAMPAIGN_APPROVAL_INVALID_TITLE,
  CAMPAIGN_APPROVAL_INVALID_DESCRIPTION,
  CAMPAIGN_APPROVAL_EXPIRED_TITLE,
  CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONTENT_EMPTY,
  CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA,
  CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_DECISION_TITLE,
  CAMPAIGN_APPROVAL_DECISION_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER,
  CAMPAIGN_APPROVAL_APPROVE_BUTTON,
  CAMPAIGN_APPROVAL_REJECT_BUTTON,
  CAMPAIGN_APPROVAL_TEXTS_TITLE,
  CAMPAIGN_APPROVAL_DESTINATION_TITLE,
  CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE,
  CAMPAIGN_APPROVAL_CREATIVES_TITLE,
  CAMPAIGN_APPROVAL_CREATIVE_TITLE,
  CAMPAIGN_APPROVAL_SLIDE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL,
  CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_AD,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP,
  CAMPAIGN_APPROVAL_CONTROLS_TITLE,
  CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION,
  CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_STATE_INACTIVE,
  CAMPAIGN_APPROVAL_STATE_ACTIVE,
  CAMPAIGN_APPROVAL_SHARED_LINK_LABEL,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_COPIED,
  CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION,
  CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_PENDING_DESCRIPTION,
  CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON,
  CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON,
  CAMPAIGN_APPROVAL_STATUS_PENDING,
  CAMPAIGN_APPROVAL_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_STATUS_REJECTED,
  GALLERY_CONTENT_APPROVAL_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_PANEL_TITLE,
  CAMPAIGN_APPROVAL_PANEL_DESCRIPTION,
  CAMPAIGN_APPROVAL_PANEL_EMPTY,
  CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE,
  CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED,
  CAMPAIGN_APPROVAL_STALE_LABEL,
  CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER,
  CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE,
  CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR,
  CAMPAIGN_APPROVAL_SEND_FOR_REVIEW,
  CONTENT_APPROVAL_PAGE_TITLE,
  CONTENT_APPROVAL_REPLACE_BUTTON,
  CONTENT_APPROVAL_EDIT_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON,
  CONTENT_APPROVAL_SIDEBAR_TITLE,
  CONTENT_APPROVAL_ALL_GOOD_QUESTION,
  CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE,
  CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR,
  APPROVAL_REVIEW_EMAIL_LABEL,
  APPROVAL_EMAIL_SEND_BUTTON,
  APPROVAL_EMAIL_SEND_SENT,
  APPROVAL_EMAIL_INVALID,
  APPROVAL_REVIEWER_NOT_FOUND,
  APPROVAL_ADD_REVIEWER,
  APPROVAL_REVIEWER_LABEL,
  APPROVAL_REVIEWER_MAX_REACHED,
  APPROVAL_REVIEWER_EMAIL_DUPLICATED,
  APPROVAL_REVIEWER_ADDED_SUCCESS,
  APPROVAL_REVIEWER_STATUS_PENDING,
  APPROVAL_REVIEWER_STATUS_APPROVED,
  APPROVAL_REVIEWER_STATUS_REJECTED,
  APPROVAL_CURRENT_REVIEWER_LABEL,
  APPROVAL_REVIEWING_AS_PREFIX,
  APPROVAL_REVIEWERS_SECTION_LABEL,
  APPROVAL_COMMENT_AUTHOR_LABEL,
  CONTENT_APPROVAL_SENT_DATE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY,
  CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY,
  CONTENT_APPROVAL_COMMENT_PLACEHOLDER,
  CONTENT_APPROVAL_REVIEW_LINK_LABEL,
  CONTENT_APPROVAL_STATUS_SECTION_LABEL,
  CONTENT_APPROVAL_MAIN_CREATIVE_LABEL,
  CONTENT_APPROVAL_CREATIVE_CARD_TITLE,
  CONTENT_APPROVAL_CREATIVE_TYPE_LABEL,
  CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER,
  CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE,
  CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_BUTTON,
  CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS,
  CONTENT_APPROVAL_CONTENT_APPROVED_TITLE,
  CONTENT_APPROVAL_COMMENT_SENT_SUCCESS,
  CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON,
  CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON,
  CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE,
  CONTENT_APPROVAL_LOCKED_STATUS_APPROVED,
  CONTENT_APPROVAL_INVALID_TITLE,
  CONTENT_APPROVAL_INVALID_DESCRIPTION,
  CONTENT_APPROVAL_EXPIRED_TITLE,
  CONTENT_APPROVAL_EXPIRED_DESCRIPTION,
  CONTENT_APPROVAL_LOADING_VALIDATING_LINK,
  CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES,
  CONTENT_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_READY_TO_DECIDE,
  CAMPAIGN_APPROVAL_COMMENTS_LEFT,
  CAMPAIGN_APPROVAL_AD_SET_LABEL,
  CAMPAIGN_APPROVAL_ADS_COUNT,
  CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT,
  CAMPAIGN_APPROVAL_COMMENT_SEND_HINT,
  CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS,
  CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS,
  RESIZE_CUSTOM,
  MODAL_RESIZE_CUSTOM_TITLE,
  MODAL_RESIZE_CUSTOM_DESCRIPTION,
  MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL,
  ERROR_RESIZE_DIMENSION_INVALID,
  ERROR_RESIZE_DIMENSION_MAX_EDGE,
  ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX,
  ERROR_RESIZE_DIMENSION_OR,
  ERROR_RESIZE_TOTAL_TOO_SMALL,
  ERROR_RESIZE_TOTAL_TOO_LARGE,
  ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
  BUTTON_RESIZE_IMAGE,
  MODAL_BATCH_IMAGE_EDIT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL,
  MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER,
  MODAL_BATCH_IMAGE_EDIT_GENERATE,
  MODAL_BATCH_IMAGE_EDIT_APPLY,
  MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING,
  MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS,
  MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR,
  MODAL_BATCH_IMAGE_EDIT_RETRY,
  MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE,
  MODAL_BATCH_IMAGE_EDIT_EXPAND,
  MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID,
  MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION,
  MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON,
  TEMPLATES_MENU_ITEM,
  TEMPLATES_TITLE,
  TEMPLATE,
  TEMPLATES_SEARCH_PLACEHOLDER,
  TEMPLATES_SEARCH_NO_RESULTS,
  TEMPLATES_SORT_NEWEST_FIRST,
  TEMPLATES_SORT_OLDEST_FIRST,
  TEMPLATES_SORT_NAME_ASC,
  TEMPLATES_SORT_NAME_DESC,
  TEMPLATES_DESCRIPTION,
  TEMPLATES_BUTTON_UPLOAD,
  TEMPLATES_UPLOAD_FROM_GALLERY,
  TEMPLATES_UPLOAD_FROM_DEVICE,
  TEMPLATES_BUTTON_CREATE,
  TEMPLATES_LAYOUT_KIND_IMAGE,
  TEMPLATES_LAYOUT_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_TITLE,
  TEMPLATES_CREATE_KIND_DESCRIPTION,
  TEMPLATES_CREATE_KIND_SINGLE,
  TEMPLATES_CREATE_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_SLIDE_COUNT,
  TEMPLATES_SLIDE_LABEL,
  TEMPLATES_ADD_SLIDE,
  TEMPLATES_DUPLICATE_SLIDE,
  TEMPLATES_DELETE_SLIDE,
  TEMPLATES_SLIDES_ROW,
  TEMPLATES_CAROUSEL_TYPE,
  TEMPLATES_CONTINUOUS_SETUP_TITLE,
  TEMPLATES_CONTINUOUS_SETUP_SLIDES,
  TEMPLATES_CONTINUOUS_SETUP_FORMAT,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED,
  TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION,
  TEMPLATES_STRIP_FORMAT_TOO_LARGE,
  TEMPLATES_FORMATS_ROW,
  TEMPLATES_CAROUSEL_CHIP,
  TEMPLATES_CONTINUOUS_CAROUSEL_CHIP,
  TEMPLATES_EMPTY,
  TEMPLATES_FOLDER_EMPTY,
  TEMPLATES_EMPTY_CANVAS_HINT,
  TEMPLATES_EMPTY_ADD_LAYER,
  TEMPLATES_BACKGROUND_LAYER,
  TEMPLATES_OPEN,
  TEMPLATES_DUPLICATE,
  TEMPLATES_DELETE,
  TEMPLATES_SAVE,
  TEMPLATES_USAGE_GUIDE,
  TEMPLATES_GUIDE_PDF_URL,
  TEMPLATES_GUIDE_VIDEO_URL,
  TEMPLATES_BACK,
  TEMPLATES_NAME,
  TEMPLATES_UNTITLED,
  TEMPLATES_ZONES,
  TEMPLATES_LAYERS,
  TEMPLATES_PROPERTIES,
  TEMPLATES_NO_SELECTION,
  TEMPLATES_ADD_LAYER,
  TEMPLATES_ZONE_NAME,
  TEMPLATES_LAYER_NAME,
  TEMPLATES_ZONE_TYPE,
  TEMPLATES_ZONE_SOURCE,
  TEMPLATES_TYPE_TEXT,
  TEMPLATES_TYPE_IMAGE,
  TEMPLATES_TYPE_SHAPE,
  TEMPLATES_TYPE_GROUP,
  TEMPLATES_SOURCE_ASSET,
  TEMPLATES_SOURCE_DATA,
  TEMPLATES_SOURCE_GENERATED,
  TEMPLATES_SOURCE_FIXED,
  TEMPLATES_SOURCE_COMPUTED,
  TEMPLATES_SOURCE_ASSET_HINT,
  TEMPLATES_SOURCE_DATA_HINT,
  TEMPLATES_SOURCE_GENERATED_HINT,
  TEMPLATES_SOURCE_COMPUTED_HINT,
  TEMPLATES_FIXED_VALUE,
  TEMPLATES_FIXED_VALUE_PLACEHOLDER,
  TEMPLATES_LAYER_TEXT,
  TEMPLATES_STYLE,
  TEMPLATES_ORIGIN_TEXT,
  TEMPLATES_EXPRESSION,
  TEMPLATES_VARIABLE,
  TEMPLATES_PROMPT,
  TEMPLATES_GENERATE_PROMPT,
  TEMPLATES_GENERATE_PROMPT_ERROR,
  TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE,
  TEMPLATES_SAVE_PROMPT,
  TEMPLATES_SAVE_PROMPT_TITLE,
  TEMPLATES_SAVE_PROMPT_ERROR,
  TEMPLATES_SAVE_PROMPT_SUCCESS,
  TEMPLATES_IMPORT_PROMPT,
  TEMPLATES_IMPORT_PROMPT_TITLE,
  TEMPLATES_IMPORT_SELECTED,
  TEMPLATES_IMPORT_PROMPT_EMPTY,
  TEMPLATES_IMPORT_PROMPT_ERROR,
  TEMPLATES_DELETE_PROMPT,
  TEMPLATES_DELETE_PROMPT_ERROR,
  TEMPLATES_TRY_LAYER,
  TEMPLATES_TRY_LAYER_ERROR,
  TEMPLATES_IS_BACKGROUND,
  TEMPLATES_NEGATIVE_PROMPT,
  TEMPLATES_ASSET_REF,
  TEMPLATES_SELECT_ASSET,
  TEMPLATES_CHANGE_ASSET,
  TEMPLATES_FIT,
  TEMPLATES_SHAPE_FILL,
  TEMPLATES_SHAPE_RADIUS,
  TEMPLATES_FONT_SIZE,
  TEMPLATES_FONT_COLOR,
  TEMPLATES_STROKE_WIDTH,
  TEMPLATES_STROKE_METRIC,
  TEMPLATES_SHADOW,
  TEMPLATES_SHADOW_ANGLE,
  TEMPLATES_SHADOW_DISTANCE,
  TEMPLATES_SHADOW_BLUR,
  TEMPLATES_PRESETS,
  TEMPLATES_SHADOW_PRESET_SOFT,
  TEMPLATES_SHADOW_PRESET_LIFT,
  TEMPLATES_SHADOW_PRESET_HARD,
  TEMPLATES_SHADOW_PRESET_GLOW,
  TEMPLATES_STROKE_COLOR,
  TEMPLATES_BACKGROUND_PADDING,
  TEMPLATES_BACKGROUND_SEPARATION,
  TEMPLATES_BACKGROUND_RADIUS,
  TEMPLATES_BACKGROUND_COLOR,
  TEMPLATES_PAINT_SETTINGS,
  TEMPLATES_HIGHLIGHTS_TITLE,
  TEMPLATES_HIGHLIGHTS_HINT,
  TEMPLATES_HIGHLIGHTS_ADD,
  TEMPLATES_HIGHLIGHTS_REMOVE,
  TEMPLATES_HIGHLIGHTS_KIND_FILL,
  TEMPLATES_HIGHLIGHTS_KIND_STROKE,
  TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND,
  TEMPLATES_HIGHLIGHTS_PHRASE,
  TEMPLATES_HIGHLIGHTS_PHRASE_INVALID,
  TEMPLATES_HIGHLIGHTS_CAPTURE,
  TEMPLATES_HIGHLIGHTS_CAPTURING,
  TEMPLATES_INLINE_REPLACEMENTS_TITLE,
  TEMPLATES_INLINE_REPLACEMENTS_HINT,
  TEMPLATES_INLINE_REPLACEMENTS_ADD,
  TEMPLATES_INLINE_REPLACEMENTS_REMOVE,
  TEMPLATES_INLINE_REPLACEMENTS_PHRASE,
  TEMPLATES_LINE_SPACING,
  TEMPLATES_LETTER_SPACING,
  TEMPLATES_FONT_FAMILY,
  TEMPLATES_FONT_FACE,
  TEMPLATES_TEXT_STYLE,
  TEMPLATES_TEXT_STYLE_NORMAL,
  TEMPLATES_TEXT_STYLE_ITALIC,
  TEMPLATES_TEXT_STYLE_UNDERLINE,
  TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE,
  TEMPLATES_ADD_FONT,
  TEMPLATES_ADD_FONT_TITLE,
  TEMPLATES_ADD_FONT_NAME,
  TEMPLATES_ADD_FONT_NAME_HINT,
  TEMPLATES_ADD_FONT_FILE,
  TEMPLATES_ADD_FONT_SELECT_FILE,
  TEMPLATES_ADD_FONT_ERROR,
  TEMPLATES_ADD_FONT_INVALID_FILE,
  TEMPLATES_ADD_FONT_INVALID_NAME,
  TEMPLATES_ADD_FONT_MATCH_HINT,
  TEMPLATES_ADD_FONT_PARSE_FAILED,
  TEMPLATES_ADD_FONT_PARTIAL_ERROR,
  TEMPLATES_ADD_FONT_VARIABLE,
  TEMPLATES_ADD_FONT_SUMMARY,
  TEMPLATES_ADD_FONT_SUMMARY_FAMILY,
  TEMPLATES_ADD_FONT_SUMMARY_STYLE,
  TEMPLATES_ADD_FONT_SUMMARY_KIND,
  TEMPLATES_ADD_FONT_SUMMARY_STATIC,
  TEMPLATES_ADD_FONT_SUMMARY_STYLES,
  TEMPLATES_ADD_FONT_SUMMARY_HINT,
  TEMPLATES_ADD_FONT_CHANGE_FILE,
  TEMPLATES_ALIGN,
  TEMPLATES_ALIGN_LEFT,
  TEMPLATES_ALIGN_CENTER,
  TEMPLATES_ALIGN_RIGHT,
  TEMPLATES_ALIGN_TOP,
  TEMPLATES_ALIGN_MIDDLE,
  TEMPLATES_ALIGN_BOTTOM,
  TEMPLATES_ALIGN_LAYERS,
  TEMPLATES_LOCK_LAYER,
  TEMPLATES_UNLOCK_LAYER,
  TEMPLATES_HIDE_LAYER,
  TEMPLATES_SHOW_LAYER,
  TEMPLATES_ALIGNMENT_GUIDES,
  TEMPLATES_GUIDE_OPACITY,
  TEMPLATES_ORIENTATION,
  TEMPLATES_ORIENTATION_HORIZONTAL,
  TEMPLATES_ORIENTATION_VERTICAL,
  TEMPLATES_ORIENTATION_VERTICAL_UP,
  TEMPLATES_OVERFLOW,
  TEMPLATES_MAX_LINES,
  TEMPLATES_MIN_LINES,
  TEMPLATES_MIN_FONT,
  TEMPLATES_POSITION,
  TEMPLATES_SIZE,
  TEMPLATES_POS_X,
  TEMPLATES_POS_Y,
  TEMPLATES_POS_W,
  TEMPLATES_POS_H,
  TEMPLATES_FRAME_W,
  TEMPLATES_FRAME_H,
  TEMPLATES_CLIP,
  TEMPLATES_HIDE,
  TEMPLATES_SHOW,
  TEMPLATES_MIN_SIZE,
  TEMPLATES_PADDING,
  TEMPLATES_DRAW,
  TEMPLATES_DRAWING,
  TEMPLATES_DRAW_HINT,
  TEMPLATES_OVERFLOW_SHRINK,
  TEMPLATES_OVERFLOW_REJECT,
  TEMPLATES_BACKDROP_NOTE,
  TEMPLATES_NODE_COUNT,
  TEMPLATES_NODE_COUNT_SINGLE,
  TEMPLATES_ARTBOARD,
  TEMPLATES_ADD_FORMAT,
  TEMPLATES_CUSTOM_FORMAT,
  TEMPLATES_CUSTOM_FORMAT_TITLE,
  TEMPLATES_CUSTOM_WIDTH,
  TEMPLATES_CUSTOM_HEIGHT,
  TEMPLATES_CUSTOM_SIZE_INVALID,
  TEMPLATES_EDIT_PREVIOUS,
  TEMPLATES_NEW_FORMAT_HINT,
  TEMPLATES_REMOVE_FORMAT,
  TEMPLATES_THIS_FORMAT,
  TEMPLATES_UPLOAD_REFERENCE,
  TEMPLATES_CHANGE_REFERENCE,
  TEMPLATES_SHOW_GUIDE,
  TEMPLATES_HIDE_GUIDE,
  TEMPLATES_GUIDE_HINT,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION,
  TEMPLATES_EDITOR_PREVIEW_ERROR,
  TEMPLATES_EDITOR_PREVIEW_TITLE,
  TEMPLATES_EDITOR_PREVIEW_USED_VALUES,
  TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY,
  TEMPLATES_ZOOM_IN,
  TEMPLATES_ZOOM_OUT,
  TEMPLATES_ZOOM_FIT,
  TEMPLATES_TEXT_COLLISION_ONE,
  TEMPLATES_TEXT_COLLISION_OTHER,
  TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT,
  TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE,
  CANVAS_TOOLS_BAR_LABEL,
  CANVAS_TOOL_ERASER,
  CANVAS_TOOL_ERASER_HINT,
  CANVAS_TOOL_ERASER_BRUSH_SIZE,
  CANVAS_TOOL_ERASER_APPLY,
  TEMPLATES_UNAUTHORIZED,
  TEMPLATES_ANALYZING_LOCK,
  TEMPLATES_SAVE_SUCCESS,
  TEMPLATES_DELETE_ERROR,
  TEMPLATES_UPLOAD_ERROR,
  TEMPLATES_ANALYZE_ERROR,
  TEMPLATES_ANALYZE_IMAGE_TOO_SMALL,
  IMAGE_TOO_SMALL_FOR_LAYERIZE,
  TEMPLATES_ANALYZE_RETRY,
  TEMPLATES_CREATE_ERROR,
  TEMPLATES_SAVE_ERROR,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION,
  TEMPLATES_CONFIRM_DELETE_TITLE,
  TEMPLATES_CONFIRM_DELETE_DESCRIPTION,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_ADD_FORMAT,
  TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION,
  TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM,
  TEMPLATES_AI_RESIZE_BACKGROUND_LOCK,
  TEMPLATES_KEEP_EDITING,
  TEMPLATES_CLOSE_UNSAVED_DESCRIPTION,
  TEMPLATES_PRODUCE_DRAFT_COMPLETE,
  TEMPLATES_PRODUCE_DRAFT_TITLE,
  TEMPLATES_PRODUCE_DRAFT_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_TITLE,
  TEMPLATES_SAVE_BLOCKED_PRODUCING,
  TEMPLATES_SAVE_PRODUCE_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_CONFIRM,
  TEMPLATES_SAVE_PRODUCE_CANCEL,
  TEMPLATES_NEW_ZONE,
  TEMPLATES_NEW_LAYER,
  TEMPLATES_PRODUCE_MENU_ITEM,
  TEMPLATES_PRODUCE_TITLE,
  TEMPLATES_PRODUCE_DESCRIPTION,
  TEMPLATES_PRODUCE_CONFIG_KICKER,
  TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL,
  TEMPLATES_PRODUCE_VARIABLES_EYEBROW,
  TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_COST,
  TEMPLATES_PRODUCE_SUMMARY_COST_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_RATE,
  TEMPLATES_PRODUCE_SUMMARY_FORMAT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE,
  TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT_SINGLE,
  TEMPLATES_PRODUCE_TEMPLATE,
  TEMPLATES_PRODUCE_CHANGE,
  TEMPLATES_PRODUCE_DIMENSIONS,
  TEMPLATES_PRODUCE_LANGUAGE,
  TEMPLATES_PRODUCE_VARIATIONS,
  TEMPLATES_PRODUCE_VARIATIONS_PER_ROW,
  TEMPLATES_PRODUCE_ROWS,
  TEMPLATES_PRODUCE_ROWS_HINT,
  TEMPLATES_PRODUCE_ADD_ROW,
  TEMPLATES_PRODUCE_LOAD_LAST_CONFIG,
  TEMPLATES_PRODUCE_UPLOAD_CSV,
  TEMPLATES_PRODUCE_DOWNLOAD_FORMAT,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT,
  TEMPLATES_PRODUCE_GENERATE,
  TEMPLATES_PRODUCE_GENERATE_SINGLE,
  TEMPLATES_PRODUCE_PREVIEW,
  TEMPLATES_PRODUCE_PREVIEW_TOOLTIP,
  TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE,
  TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL,
  TEMPLATES_PRODUCE_SUMMARY,
  TEMPLATES_PRODUCE_EMPTY_TEMPLATES,
  TEMPLATES_PRODUCE_EMPTY_VARIABLES,
  TEMPLATES_PRODUCE_SELECT_TEMPLATE,
  TEMPLATES_PRODUCE_CSV_TITLE,
  TEMPLATES_PRODUCE_CSV_DESCRIPTION,
  TEMPLATES_PRODUCE_CSV_REPLACE,
  TEMPLATES_PRODUCE_CSV_APPEND,
  TEMPLATES_PRODUCE_CSV_ERROR,
  TEMPLATES_PRODUCE_CSV_EMPTY,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION,
  TEMPLATES_PRODUCE_VALIDATION_ERROR,
  TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT,
  TEMPLATES_PRODUCE_VALIDATION_NO_ROWS,
  TEMPLATES_PRODUCE_VALIDATION_VARIATIONS,
  TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS,
  TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS,
  TEMPLATES_PRODUCE_GENERATE_SUCCESS,
  TEMPLATES_PRODUCE_DELETE_ROW,
  TEMPLATES_PRODUCE_COPY_TO_COLUMN,
  TEMPLATES_PRODUCE_SELECT_IMAGE,
  TEMPLATES_PRODUCE_REPLACE_IMAGE,
  TEMPLATES_PRODUCE_IMAGE_CHECKING,
  TEMPLATES_PRODUCE_IMAGE_UNUSABLE,
  TEMPLATES_PRODUCE_IMAGES_PROCESSING,
  TEMPLATES_PRODUCE_IMAGES_UNUSABLE,
  TEMPLATES_PRODUCE_DELETE_IMAGE,
  TEMPLATES_PRODUCE_RESULTS,
  TEMPLATES_PRODUCE_RUN_TITLE,
  TEMPLATES_PRODUCE_RUN_LEGACY,
  TEMPLATES_PRODUCE_DELETE_SELECTED,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT,
  TEMPLATES_PRODUCE_DELETE_ERROR,
  TEMPLATES_PRODUCE_DOWNLOAD_CONFIG,
  TEMPLATES_PRODUCE_CONFIG_FILENAME,
  TEMPLATES_PRODUCE_GENERATING,
  TEMPLATES_PRODUCE_ACTIVE_RUN,
  TEMPLATES_PRODUCE_EDIT_TITLE,
  TEMPLATES_PRODUCE_EDIT_NO_INSTANCE,
  TEMPLATES_PRODUCE_ADD_TEXT,
  TEMPLATES_PRODUCE_ADD_IMAGE,
  TEMPLATES_PRODUCE_ADD_SHAPE,
  TEMPLATES_PRODUCE_ADD_GROUP,
  TEMPLATES_GROUP_LAYERS,
  TEMPLATES_PRODUCE_SAVE_ERROR,
  TEMPLATES_PRODUCE_PARTIAL_SUMMARY,
  TEMPLATES_PRODUCE_PARTIAL_TITLE,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL,
  TEMPLATES_PRODUCE_RETRY_FAILED,
  TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR,
  TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL,
  TEMPLATES_PRODUCE_FAILURE_GENERIC,
  TEMPLATES_PRODUCE_FAILURE_BUSY,
  TEMPLATES_PRODUCE_FAILURE_IMAGE,
  TEMPLATES_PRODUCE_FAILURE_DATA,
  INSIGHTS_PAGE_TITLE,
  INSIGHTS_HEADER_BRAND,
  INSIGHTS_HEADER_HELP,
  INSIGHTS_CONNECT_STEP_NUMBER,
  INSIGHTS_CONNECT_TITLE,
  INSIGHTS_CONNECT_MUTED,
  INSIGHTS_CONNECT_DESCRIPTION,
  INSIGHTS_CONNECT_CARD_TITLE,
  INSIGHTS_CONNECT_CARD_SUBTITLE,
  INSIGHTS_CONNECT_CTA,
  INSIGHTS_CONNECT_CONNECTING,
  INSIGHTS_CONNECT_CREDENTIALS_NOTE,
  INSIGHTS_CONNECT_ERROR_CANCELLED,
  INSIGHTS_CONNECT_ERROR_FAILED,
  INSIGHTS_CONNECT_ERROR_SDK,
  INSIGHTS_CONNECT_ERROR_NO_ACCOUNTS,
  INSIGHTS_CONNECT_ERROR_GENERIC,
  INSIGHTS_ACCOUNT_BACK,
  INSIGHTS_ACCOUNT_STEP_NUMBER,
  INSIGHTS_ACCOUNT_TITLE,
  INSIGHTS_ACCOUNT_MUTED,
  INSIGHTS_ACCOUNT_DESCRIPTION,
  INSIGHTS_ACCOUNT_CONTINUE,
  INSIGHTS_ACCOUNT_EMPTY,
  INSIGHTS_ACCOUNT_STATUS_ACTIVE,
  INSIGHTS_ACCOUNT_STATUS_PAUSED,
  INSIGHTS_GENERATING_STEP_NUMBER,
  INSIGHTS_GENERATING_TITLE,
  INSIGHTS_GENERATING_MUTED,
  INSIGHTS_GENERATING_DESCRIPTION,
  INSIGHTS_GENERATING_PROCESSING_LABEL,
  INSIGHTS_GENERATING_ERROR,
  INSIGHTS_GENERATING_RETRY,
  INSIGHTS_DONE_STEP_NUMBER,
  INSIGHTS_DONE_TITLE,
  INSIGHTS_DONE_MUTED,
  INSIGHTS_DONE_DESCRIPTION,
  INSIGHTS_DONE_REPORT_TITLE,
  INSIGHTS_DONE_REPORT_SUBTITLE,
  INSIGHTS_DONE_CTA_TITLE,
  INSIGHTS_DONE_CTA_DESCRIPTION,
  INSIGHTS_DONE_SCHEDULE_DEMO,
  INSIGHTS_DONE_RESTART,
  INSIGHTS_REPORT_WHY,
  INSIGHTS_REPORT_WHAT_TO_DO,
  INSIGHTS_REPORT_QUICK_WINS,
  INSIGHTS_FEATURES_HEADING,
  INSIGHTS_FEATURE_AI_MEDIA_TITLE,
  INSIGHTS_FEATURE_AI_MEDIA_DESCRIPTION,
  INSIGHTS_FEATURE_AI_CAMPAIGNS_TITLE,
  INSIGHTS_FEATURE_AI_CAMPAIGNS_DESCRIPTION,
  INSIGHTS_FEATURE_COMPETITORS_TITLE,
  INSIGHTS_FEATURE_COMPETITORS_DESCRIPTION,
  INSIGHTS_FEATURE_REPORTS_TITLE,
  INSIGHTS_FEATURE_REPORTS_DESCRIPTION,
  AI_COMPETITORS_PAGE_TITLE,
  AI_COMPETITORS_URL_STEP_NUMBER,
  AI_COMPETITORS_URL_TITLE,
  AI_COMPETITORS_URL_MUTED,
  AI_COMPETITORS_URL_DESCRIPTION,
  AI_COMPETITORS_URL_PLACEHOLDER,
  AI_COMPETITORS_URL_CTA,
  AI_COMPETITORS_URL_INVALID,
  AI_COMPETITORS_URL_BLOCKED,
  AI_COMPETITORS_URL_NO_COMPETITORS,
  AI_COMPETITORS_ANALYZING_STEP_NUMBER,
  AI_COMPETITORS_ANALYZING_TITLE,
  AI_COMPETITORS_ANALYZING_MUTED,
  AI_COMPETITORS_ANALYZING_DESCRIPTION,
  AI_COMPETITORS_PROGRESS_FALLBACK,
  AI_COMPETITORS_PROGRESS_REVIEWING_PAGE,
  AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_RESOLVING_ADS,
  AI_COMPETITORS_PROGRESS_SEARCHING_ADS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS,
  AI_COMPETITORS_COMPETITORS_STEP_NUMBER,
  AI_COMPETITORS_COMPETITORS_TITLE,
  AI_COMPETITORS_COMPETITORS_MUTED,
  AI_COMPETITORS_COMPETITORS_DESCRIPTION,
  AI_COMPETITORS_COMPETITORS_EMPTY,
  AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER,
  AI_COMPETITORS_COMPETITORS_ADD,
  AI_COMPETITORS_COMPETITORS_ADD_INVALID,
  AI_COMPETITORS_COMPETITORS_NAME_LABEL,
  AI_COMPETITORS_COMPETITORS_REMOVE,
  AI_COMPETITORS_COMPETITORS_CTA,
  AI_COMPETITORS_COMPETITORS_NEED_ONE,
  AI_COMPETITORS_COMPETITORS_ADD_MAX,
  AI_COMPETITORS_SEARCHING_STEP_NUMBER,
  AI_COMPETITORS_SEARCHING_TITLE,
  AI_COMPETITORS_SEARCHING_MUTED,
  AI_COMPETITORS_SEARCHING_ERROR,
  AI_COMPETITORS_SEARCHING_RETRY,
  AI_COMPETITORS_RESULTS_STEP_NUMBER,
  AI_COMPETITORS_RESULTS_TITLE,
  AI_COMPETITORS_RESULTS_MUTED,
  AI_COMPETITORS_RESULTS_SUMMARY,
  AI_COMPETITORS_RESULTS_NO_ADS,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY,
  AI_COMPETITORS_RESULTS_NO_ADS_CTA,
  AI_COMPETITORS_RESULTS_VIEW_MORE,
  AI_COMPETITORS_RESULTS_GENERATE,
  AI_COMPETITORS_RESULTS_LOCKED_COUNT,
  AI_COMPETITORS_RESULTS_DOWNLOAD,
  AI_COMPETITORS_RESULTS_FORMAT_IMAGE,
  AI_COMPETITORS_RESULTS_FORMAT_VIDEO,
  AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL,
  AI_COMPETITORS_AGENDA_CONFIRM_TITLE,
  AI_COMPETITORS_AGENDA_CONFIRM_TEXT,
  AI_COMPETITORS_AGENDA_CONFIRM_CTA,
  AI_COMPETITORS_AGENDA_BACK,
  AI_COMPETITORS_AGENDA_STEP_NUMBER,
  AI_COMPETITORS_AGENDA_TITLE,
  AI_COMPETITORS_AGENDA_MUTED,
  AI_COMPETITORS_AGENDA_CONTEXT,
  AI_COMPETITORS_AGENDA_CONTEXT_ZERO,
  AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK,
  AI_COMPETITORS_THANKS_STEP_NUMBER,
  AI_COMPETITORS_THANKS_TITLE,
  AI_COMPETITORS_THANKS_MUTED,
  AI_COMPETITORS_THANKS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_BADGE,
  NEW_FEATURE_CALLOUT_CLOSE_ARIA,
  NEW_FEATURE_CALLOUT_DEFAULT_CTA,
  NEW_FEATURE_CALLOUT_INSIGHTS_TITLE,
  NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION,
  AUTOMATIONS_MENU_TITLE,
  AUTOMATIONS_PAGE_TITLE,
  AUTOMATIONS_PAGE_DESCRIPTION,
  BUTTON_NEW_AUTOMATION,
  AUTOMATIONS_HERO_TITLE,
  AUTOMATIONS_HERO_DESCRIPTION,
  AUTOMATIONS_STATUS_ACTIVE,
  AUTOMATIONS_STATUS_PAUSED,
  AUTOMATIONS_LABEL_FOLDER,
  AUTOMATIONS_LABEL_PLATFORMS,
  AUTOMATIONS_LABEL_FREQUENCY,
  AUTOMATIONS_LABEL_NEXT_POST,
  AUTOMATIONS_MOCK_BRAND_CONTENT,
  AUTOMATIONS_MOCK_PRODUCT_LAUNCH,
  AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP,
  AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER,
  AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT,
  AUTOMATIONS_MOCK_FOLDER_LINKEDIN,
  AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY,
  AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_ONE_PER_DAY,
  AUTOMATIONS_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_FREQ_SIX_PER_WEEK,
  AUTOMATIONS_MOCK_NEXT_TODAY,
  AUTOMATIONS_MOCK_NEXT_EMPTY,
  AUTOMATIONS_MOCK_NEXT_TOMORROW,
  MODAL_CREATE_AUTOMATION_TITLE,
  AUTOMATIONS_STEP_SOURCE,
  AUTOMATIONS_STEP_PLATFORMS,
  AUTOMATIONS_STEP_SCHEDULE,
  AUTOMATIONS_STEP_CONTENT_AI,
  AUTOMATIONS_STEP_REVIEW,
  AUTOMATIONS_STEP_SOURCE_TITLE,
  AUTOMATIONS_STEP_SOURCE_HELP,
  AUTOMATIONS_SOURCE_ALL_TITLE,
  AUTOMATIONS_SOURCE_ALL_DESCRIPTION,
  AUTOMATIONS_SOURCE_FOLDER_TITLE,
  AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP,
  AUTOMATIONS_STEP_LANGUAGE_TITLE,
  AUTOMATIONS_STEP_LANGUAGE_HELP,
  AUTOMATIONS_VALIDATION_LANGUAGE,
  AUTOMATIONS_REVIEW_LANGUAGE,
  AUTOMATIONS_CONNECT_ACCOUNTS,
  AUTOMATIONS_STEP_PLATFORMS_TITLE,
  AUTOMATIONS_STEP_PLATFORMS_HELP,
  AUTOMATIONS_PLATFORM_CONNECTED,
  AUTOMATIONS_STEP_SCHEDULE_TITLE,
  AUTOMATIONS_STEP_SCHEDULE_HELP,
  AUTOMATIONS_SCHEDULE_FREQUENCY,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP,
  AUTOMATIONS_SCHEDULE_TIMEZONE,
  AUTOMATIONS_SCHEDULE_VALIDITY,
  AUTOMATIONS_SCHEDULE_VALIDITY_HELP,
  AUTOMATIONS_SCHEDULE_START,
  AUTOMATIONS_SCHEDULE_START_NOW,
  AUTOMATIONS_SCHEDULE_START_NOW_HELP,
  AUTOMATIONS_SCHEDULE_START_SCHEDULED,
  AUTOMATIONS_SCHEDULE_END,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP,
  AUTOMATIONS_SCHEDULE_END_SCHEDULED,
  AUTOMATIONS_STEP_CONTENT_AI_TITLE,
  AUTOMATIONS_STEP_CONTENT_AI_HELP,
  AUTOMATIONS_CONTENT_ORIGINAL_TITLE,
  AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION,
  AUTOMATIONS_CONTENT_AI_TITLE,
  AUTOMATIONS_CONTENT_AI_DESCRIPTION,
  AUTOMATIONS_AI_NOTE_TITLE,
  AUTOMATIONS_AI_NOTE_DESCRIPTION,
  AUTOMATIONS_STEP_REVIEW_TITLE,
  AUTOMATIONS_STEP_REVIEW_HELP,
  AUTOMATIONS_REVIEW_SOURCE,
  AUTOMATIONS_REVIEW_PLATFORMS,
  AUTOMATIONS_REVIEW_SCHEDULE,
  AUTOMATIONS_REVIEW_VALIDITY,
  AUTOMATIONS_REVIEW_VALIDITY_VALUE,
  AUTOMATIONS_REVIEW_VALIDITY_START_NOW,
  AUTOMATIONS_REVIEW_VALIDITY_START_AT,
  AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON,
  AUTOMATIONS_REVIEW_VALIDITY_END_AT,
  AUTOMATIONS_REVIEW_NAME,
  AUTOMATIONS_REVIEW_CONTENT_AI,
  AUTOMATIONS_DEFAULT_NAME,
  AUTOMATIONS_BUTTON_BACK,
  AUTOMATIONS_BUTTON_CREATE,
  AUTOMATIONS_BUTTON_SAVE,
  AUTOMATIONS_REVIEW_SCHEDULE_VALUE,
  AUTOMATIONS_STATUS_WAITING,
  AUTOMATIONS_STATUS_SCHEDULING,
  AUTOMATIONS_STATUS_ATTENTION,
  AUTOMATIONS_STATUS_OFF,
  AUTOMATIONS_STATUS_ENDED,
  AUTOMATIONS_MENU_EDIT,
  AUTOMATIONS_MENU_VIEW_CALENDAR,
  AUTOMATIONS_MENU_TURN_OFF,
  AUTOMATIONS_TURN_OFF_TITLE,
  AUTOMATIONS_TURN_OFF_DESCRIPTION,
  AUTOMATIONS_TURN_OFF_CONFIRM,
  AUTOMATIONS_WAITING_BANNER,
  AUTOMATIONS_ATTENTION_BANNER,
  AUTOMATIONS_VALIDATION_FOLDER,
  AUTOMATIONS_VALIDATION_ACCOUNTS,
  AUTOMATIONS_VALIDATION_WINDOW,
  AUTOMATIONS_VALIDATION_START_REQUIRED,
  AUTOMATIONS_VALIDATION_START_FUTURE,
  AUTOMATIONS_VALIDATION_END_REQUIRED,
  AUTOMATIONS_VALIDATION_END_FUTURE,
  AUTOMATIONS_VALIDATION_END_AFTER_START,
  AUTOMATIONS_HERO_QUEUED,
  AUTOMATIONS_HERO_PUBLISHED,
  AUTOMATIONS_HERO_FAILED,
  AUTOMATIONS_HERO_NEXT,
  AUTOMATIONS_NEXT_NONE,
  AUTOMATIONS_REMAINING_CONTENT,
  CALENDAR_SOURCE_AUTOMATED,
  CALENDAR_ACTIVE_AUTOMATIONS,
  CALENDAR_AUTOMATION_ENDS,
  CALENDAR_AUTOMATION_FOLDER,
  CALENDAR_SOURCE_MANUAL,
  EVENT_DETAILS_AUTOMATION,
  EVENT_DETAILS_ACCOUNT,
  MODAL_EDIT_AUTOMATION_TITLE,
  AUTOMATIONS_NO_PERMISSION,
  OPTIMISTIC_SWITCH_FAILURE_BODY,
  OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD,
  OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT,
  CREATE_CAMPAIGN_WIZARD_ARIA,
  CREATE_CAMPAIGN_SETUP_TITLE,
  CREATE_CAMPAIGN_SETUP_DESCRIPTION,
  CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP,
  ACTIVATED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR,
  GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION,
  GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_JUVENILE,
  GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN,
  GOOGLE_ADS_CONTENT_LABEL_PROFANITY,
  GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE,
  GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES,
  GOOGLE_ADS_CONTENT_LABEL_TRAGEDY,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T,
  FEATURE_ADDON_PAYWALL_TITLE,
  FEATURE_ADDON_PAYWALL_DESCRIPTION,
  FEATURE_ADDON_PAYWALL_CURRENT_LIMIT,
  FEATURE_ADDON_PAYWALL_TIER_CTA,
  FEATURE_ADDON_PAYWALL_CLOSE,
  FEATURE_ADDON_PAYWALL_FREE,
  FEATURE_ADDON_PAYWALL_INCLUDED,
  FEATURE_ADDON_INCLUDED_AUTOMATIONS,
  FEATURE_ADDON_INCLUDED_TEMPLATES,
  FEATURE_ADDON_INCLUDED_COMPETITORS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE,
  FEATURE_ADDON_PAYWALL_CURRENT,
  FEATURE_ADDON_PAYWALL_PER_MONTH,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE,
  FEATURE_ADDON_BENEFIT_ACTIONS,
  FEATURE_ADDON_BENEFIT_ACTIONS_ONE,
  FEATURE_ADDON_BENEFIT_VISIBILITY,
  FEATURE_ADDON_BENEFIT_VISIBILITY_ALL,
  FEATURE_ADDON_PAYWALL_TIER_NAME,
  FEATURE_ADDON_HERO_AUTOMATIONS,
  FEATURE_ADDON_HERO_TEMPLATES,
  FEATURE_ADDON_HERO_COMPETITORS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE,
  FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS,
  FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY,
  FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL,
  FEATURE_ADDON_NAME_AUTOMATIONS,
  FEATURE_ADDON_NAME_TEMPLATES,
  FEATURE_ADDON_NAME_COMPETITORS,
  FEATURE_ADDON_UNPAID_TITLE,
  FEATURE_ADDON_UNPAID_PERIOD,
  FEATURE_ADDON_UNPAID_AMOUNT,
  FEATURE_ADDON_BILLING_TITLE,
  FEATURE_ADDON_BILLING_RENEWS,
  FEATURE_ADDON_BILLING_CANCELS,
  FEATURE_ADDON_BILLING_UPGRADE,
  FEATURE_ADDON_BILLING_CANCEL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP,
  FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION,
  FEATURE_ADDON_BILLING_CANCELLED_TITLE,
  FEATURE_ADDON_BILLING_REACTIVATED_TITLE,
  FEATURE_ADDON_BILLING_MENU,
  EXTRA_SEATS_MANAGE,
  EXTRA_SEATS_MODAL_TITLE,
  EXTRA_SEATS_MODAL_SUBTITLE,
  EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE,
  EXTRA_SEATS_QUANTITY_LABEL,
  EXTRA_SEATS_DELTA_USERS_ONE,
  EXTRA_SEATS_DELTA_USERS,
  EXTRA_SEATS_AMOUNT_PER_MONTH,
  EXTRA_SEATS_DUE_TODAY_LABEL,
  EXTRA_SEATS_PRORATION_TODAY,
  EXTRA_SEATS_NEXT_TOTAL_FROM,
  EXTRA_SEATS_NEXT_TOTAL_MONTHLY,
  EXTRA_SEATS_MONTHLY_TOTAL,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE,
  EXTRA_SEATS_PRORATION_NOTE,
  EXTRA_SEATS_NO_CHARGE_NOTE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK,
  EXTRA_SEATS_REDUCE_BLOCKED_ONE,
  EXTRA_SEATS_REDUCE_BLOCKED,
  EXTRA_SEATS_CONFIRM,
  EXTRA_SEATS_ADDED,
  EXTRA_SEATS_CHECKOUT_CANCELLED,
  EXTRA_SEATS_CHECKOUT_INCOMPLETE,
  EXTRA_SEATS_BILLING_ROW_TITLE,
  EXTRA_SEATS_QUANTITY_BADGE,
  EXTRA_SEATS_REDUCE_NOTICE,
  EXTRA_SEATS_CANCEL_NOTICE,
  EXTRA_SEATS_CHANGE_SAVED,
  EXTRA_SEATS_FORBIDDEN,
  EXTRA_SEATS_DECREASE,
  EXTRA_SEATS_INCREASE,
  EXTRA_SEATS_RETRY,
  EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE,
  EXTRA_SEATS_CHECKOUT_FORBIDDEN,
  EXTRA_SEATS_MISSING_AGENCY,
  SEAT_LIMIT_REACHED,
  SEATS_QUANTITY_CHANGED,
  SEATS_OPERATION_IN_PROGRESS,
  SEATS_UNPAID,
  SEATS_QUANTITY_OUT_OF_RANGE,
  SEATS_NOT_ELIGIBLE,
  SEATS_PRICE_NOT_CONFIGURED,
  SEATS_SUBSCRIPTION_NOT_FOUND,
  BUTTON_BULK_CREATE_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY,
  BULK_CAMPAIGNS_LIST_TITLE,
  BULK_CAMPAIGNS_GENERATE,
  BULK_CAMPAIGNS_GENERATING,
  BULK_CAMPAIGNS_ALERT_ANALYZING,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR,
  BULK_CAMPAIGNS_ALERT_GENERATING,
  BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS,
  BULK_CAMPAIGNS_ALERT_GENERATION_ERROR,
  BULK_CAMPAIGNS_GENERATE_ERROR,
  BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED,
  BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED,
  BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_TITLE,
  BULK_CAMPAIGNS_DESCRIPTION,
  BULK_CAMPAIGNS_DROP_TITLE,
  BULK_CAMPAIGNS_DROP_FORMATS,
  BULK_CAMPAIGNS_ANALYZING,
  BULK_CAMPAIGNS_FILE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_FILE_TOO_LARGE,
  BULK_CAMPAIGNS_EXTRACT_ERROR,
  BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR,
  BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND,
  BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE,
  CAMPAIGN_AGENT_WELCOME_TITLE,
  CAMPAIGN_AGENT_WELCOME_SUBTITLE,
  CAMPAIGN_AGENT_STEP_ASK,
  CAMPAIGN_AGENT_STEP_REVIEW,
  CAMPAIGN_AGENT_STEP_APPLY,
  CAMPAIGN_AGENT_WELCOME_HINT,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6,
  CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE,
  CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_TITLE,
  CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION,
  CAMPAIGN_AGENT_CARD_BUDGET_TITLE,
  CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  CAMPAIGN_AGENT_CARD_COPY_TITLE,
  CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION,
  CAMPAIGN_AGENT_CHANGES_COUNT_ONE,
  CAMPAIGN_AGENT_CHANGES_COUNT_MANY,
  CAMPAIGN_AGENT_CREATIVE_BADGE,
  CAMPAIGN_AGENT_SUMMARY_TITLE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUES,
  CAMPAIGN_AGENT_SUMMARY_ADD_ONE,
  CAMPAIGN_AGENT_SUMMARY_ADD_MANY,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY,
  CAMPAIGN_AGENT_SUMMARY_CREATE,
  CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE,
  CAMPAIGN_AGENT_SUMMARY_MORE_ONE,
  CAMPAIGN_AGENT_SUMMARY_MORE_MANY,
  CAMPAIGN_AGENT_SUMMARY_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_MANUAL,
  BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY,
  BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD,
  BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION,
  BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES,
  CAMPAIGN_AGENT_APPLIED_BADGE,
  CAMPAIGN_AGENT_APPLIED_CAPTION,
  CAMPAIGN_AGENT_DONE_CAPTION,
  CAMPAIGN_AGENT_DISCARDED_BADGE,
  CAMPAIGN_AGENT_DISCARDED_CAPTION,
  CAMPAIGN_AGENT_RESULT_APPLIED_TITLE,
  CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE,
  CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_FAILED_TITLE,
  CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE,
  CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION,
  BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH,
  BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT,
  BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE,
  CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY,
  PAYWALL_INSUFFICIENT_CREDITS_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL,
  BULK_CAMPAIGNS_CONTENTS_COUNTER,
  BULK_PLATFORM_GOOGLE,
  BULK_PLATFORM_META,
  BULK_PLATFORM_TIKTOK,
  BULK_PLATFORM_LINKEDIN,
  BULK_FIELD_INSTAGRAM,
  BULK_CAMPAIGNS_EMPTY_FILE,
  BULK_CAMPAIGNS_TOO_MANY_CONTENTS,
  BULK_CAMPAIGNS_ANALYZE,
  BULK_CAMPAIGNS_CANCEL_ANALYSIS,
  BULK_CAMPAIGNS_STALE,
  BULK_CAMPAIGNS_SELECT_CONTENTS,
  BULK_CAMPAIGNS_CONTENTS_HINT,
  BULK_CAMPAIGNS_REMOVE_CONTENT,
  BULK_CAMPAIGNS_FILE_READY,
  BULK_CAMPAIGNS_REPLACE_FILE,
  BULK_CAMPAIGNS_RESULT_CREATED,
  BULK_CAMPAIGNS_RESULT_FAILED,
  BULK_CAMPAIGNS_RESULT_CLEARED,
  BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL,
  BULK_CAMPAIGNS_RESULT_TITLE,
  BULK_CAMPAIGNS_VIEW_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY_COUNT,
  BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE,
  BULK_FIELD_PRIMARY_TEXT,
  BULK_FIELD_HEADLINE,
  BULK_FIELD_LONG_HEADLINE,
  BULK_FIELD_SEARCH_THEME,
  BULK_FIELD_CALL_TO_ACTION,
  BULK_FIELD_TITLES,
  BULK_FIELD_HEADLINES,
  BULK_FIELD_LONG_HEADLINES,
  BULK_FIELD_DESCRIPTIONS,
  BULK_FIELD_KEYWORDS,
  BULK_FIELD_KEYWORDS_NEGATIVE,
  BULK_FIELD_DESTINATION_URL,
  BULK_FIELD_DAILY_BUDGET,
  BULK_FIELD_LANGUAGE,
  BULK_FIELD_OBJECTIVE,
  BULK_FIELD_SEARCH_THEMES,
  BULK_FIELD_CALLOUTS,
  BULK_FIELD_AUDIENCE,
  BULK_FIELD_PAGE,
  BULK_FIELD_IDENTITY,
  BULK_FIELD_APP,
  BULK_FIELD_APP_STORE,
  BULK_FIELD_AD_FORMAT,
  BULK_FIELD_ACCOUNT,
  BULK_FIELD_MERCHANT,
  BULK_FIELD_LOCATIONS,
  TIKTOK_INDUSTRY_22102000000,
  TIKTOK_INDUSTRY_22101000000,
  TIKTOK_INDUSTRY_22107000000,
  TIKTOK_INDUSTRY_22108000000,
  TIKTOK_INDUSTRY_22109000000,
  TIKTOK_INDUSTRY_22106000000,
  TIKTOK_INDUSTRY_22999000000,
  TIKTOK_INDUSTRY_22112000000,
  TIKTOK_INDUSTRY_22105000000,
  TIKTOK_INDUSTRY_22113000000,
  TIKTOK_INDUSTRY_22110000000,
  TIKTOK_INDUSTRY_22111000000,
  TIKTOK_INDUSTRY_16105000000,
  TIKTOK_INDUSTRY_16104000000,
  TIKTOK_INDUSTRY_16101000000,
  TIKTOK_INDUSTRY_16102000000,
  TIKTOK_INDUSTRY_16999000000,
  TIKTOK_INDUSTRY_16100000000,
  TIKTOK_INDUSTRY_20101000000,
  TIKTOK_INDUSTRY_20110000000,
  TIKTOK_INDUSTRY_20104000000,
  TIKTOK_INDUSTRY_20106000000,
  TIKTOK_INDUSTRY_20109000000,
  TIKTOK_INDUSTRY_20107000000,
  TIKTOK_INDUSTRY_20102000000,
  TIKTOK_INDUSTRY_20105000000,
  TIKTOK_INDUSTRY_20999000000,
  TIKTOK_INDUSTRY_20111000000,
  TIKTOK_INDUSTRY_20103000000,
  TIKTOK_INDUSTRY_20100000000,
  TIKTOK_INDUSTRY_20108000000,
  TIKTOK_INDUSTRY_20112000000,
  TIKTOK_INDUSTRY_12104000000,
  TIKTOK_INDUSTRY_12108000000,
  TIKTOK_INDUSTRY_12100000000,
  TIKTOK_INDUSTRY_12102000000,
  TIKTOK_INDUSTRY_12110000000,
  TIKTOK_INDUSTRY_12105000000,
  TIKTOK_INDUSTRY_12107000000,
  TIKTOK_INDUSTRY_12109000000,
  TIKTOK_INDUSTRY_12103000000,
  TIKTOK_INDUSTRY_12999000000,
  TIKTOK_INDUSTRY_12101000000,
  TIKTOK_INDUSTRY_12106000000,
  TIKTOK_INDUSTRY_14105000000,
  TIKTOK_INDUSTRY_14104000000,
  TIKTOK_INDUSTRY_14107000000,
  TIKTOK_INDUSTRY_14106000000,
  TIKTOK_INDUSTRY_14101000000,
  TIKTOK_INDUSTRY_14100000000,
  TIKTOK_INDUSTRY_14999000000,
  TIKTOK_INDUSTRY_14103000000,
  TIKTOK_INDUSTRY_14102000000,
  TIKTOK_INDUSTRY_24108000000,
  TIKTOK_INDUSTRY_24118000000,
  TIKTOK_INDUSTRY_24105000000,
  TIKTOK_INDUSTRY_24103000000,
  TIKTOK_INDUSTRY_24104000000,
  TIKTOK_INDUSTRY_24109000000,
  TIKTOK_INDUSTRY_24114000000,
  TIKTOK_INDUSTRY_24107000000,
  TIKTOK_INDUSTRY_24120000000,
  TIKTOK_INDUSTRY_24119000000,
  TIKTOK_INDUSTRY_24116000000,
  TIKTOK_INDUSTRY_24117000000,
  TIKTOK_INDUSTRY_24111000000,
  TIKTOK_INDUSTRY_24106000000,
  TIKTOK_INDUSTRY_24112000000,
  TIKTOK_INDUSTRY_24101000000,
  TIKTOK_INDUSTRY_24999000000,
  TIKTOK_INDUSTRY_24113000000,
  TIKTOK_INDUSTRY_24100000000,
  TIKTOK_INDUSTRY_24102000000,
  TIKTOK_INDUSTRY_24110000000,
  TIKTOK_INDUSTRY_24115000000,
  TIKTOK_INDUSTRY_30100000000,
  TIKTOK_INDUSTRY_30102000000,
  TIKTOK_INDUSTRY_30101000000,
  TIKTOK_INDUSTRY_10100000000,
  TIKTOK_INDUSTRY_10102000000,
  TIKTOK_INDUSTRY_10105000000,
  TIKTOK_INDUSTRY_10106000000,
  TIKTOK_INDUSTRY_10999000000,
  TIKTOK_INDUSTRY_10103000000,
  TIKTOK_INDUSTRY_10101000000,
  TIKTOK_INDUSTRY_10104000000,
  TIKTOK_INDUSTRY_13100000000,
  TIKTOK_INDUSTRY_13108000000,
  TIKTOK_INDUSTRY_13117000000,
  TIKTOK_INDUSTRY_13115000000,
  TIKTOK_INDUSTRY_13116000000,
  TIKTOK_INDUSTRY_13112000000,
  TIKTOK_INDUSTRY_13107000000,
  TIKTOK_INDUSTRY_13104000000,
  TIKTOK_INDUSTRY_13102000000,
  TIKTOK_INDUSTRY_13110000000,
  TIKTOK_INDUSTRY_13111000000,
  TIKTOK_INDUSTRY_13109000000,
  TIKTOK_INDUSTRY_13999000000,
  TIKTOK_INDUSTRY_13105000000,
  TIKTOK_INDUSTRY_13113000000,
  TIKTOK_INDUSTRY_13101000000,
  TIKTOK_INDUSTRY_13114000000,
  TIKTOK_INDUSTRY_1310300000,
  TIKTOK_INDUSTRY_27103000000,
  TIKTOK_INDUSTRY_27104000000,
  TIKTOK_INDUSTRY_27100000000,
  TIKTOK_INDUSTRY_27101000000,
  TIKTOK_INDUSTRY_27102000000,
  TIKTOK_INDUSTRY_27999000000,
  TIKTOK_INDUSTRY_25301000000,
  TIKTOK_INDUSTRY_25302000000,
  TIKTOK_INDUSTRY_25300000000,
  TIKTOK_INDUSTRY_25313000000,
  TIKTOK_INDUSTRY_25303000000,
  TIKTOK_INDUSTRY_25999000000,
  TIKTOK_INDUSTRY_25311000000,
  TIKTOK_INDUSTRY_25304000000,
  TIKTOK_INDUSTRY_25305000000,
  TIKTOK_INDUSTRY_25306000000,
  TIKTOK_INDUSTRY_25307000000,
  TIKTOK_INDUSTRY_25308000000,
  TIKTOK_INDUSTRY_25309000000,
  TIKTOK_INDUSTRY_25310000000,
  TIKTOK_INDUSTRY_25312000000,
  TIKTOK_INDUSTRY_29102000000,
  TIKTOK_INDUSTRY_29101000000,
  TIKTOK_INDUSTRY_29100000000,
  TIKTOK_INDUSTRY_29103000000,
  TIKTOK_INDUSTRY_29999000000,
  TIKTOK_INDUSTRY_21102000000,
  TIKTOK_INDUSTRY_21101000000,
  TIKTOK_INDUSTRY_21103000000,
  TIKTOK_INDUSTRY_21104000000,
  TIKTOK_INDUSTRY_21100000000,
  TIKTOK_INDUSTRY_21999000000,
  TIKTOK_INDUSTRY_21105000000,
  TIKTOK_INDUSTRY_18106000000,
  TIKTOK_INDUSTRY_18110000000,
  TIKTOK_INDUSTRY_18104000000,
  TIKTOK_INDUSTRY_18101000000,
  TIKTOK_INDUSTRY_18102000000,
  TIKTOK_INDUSTRY_18105000000,
  TIKTOK_INDUSTRY_18108000000,
  TIKTOK_INDUSTRY_18109000000,
  TIKTOK_INDUSTRY_18999000000,
  TIKTOK_INDUSTRY_18112000000,
  TIKTOK_INDUSTRY_18100000000,
  TIKTOK_INDUSTRY_18103000000,
  TIKTOK_INDUSTRY_18107000000,
  TIKTOK_INDUSTRY_18111000000,
  TIKTOK_INDUSTRY_26114000000,
  TIKTOK_INDUSTRY_26112000000,
  TIKTOK_INDUSTRY_26102000000,
  TIKTOK_INDUSTRY_26113000000,
  TIKTOK_INDUSTRY_26108000000,
  TIKTOK_INDUSTRY_26104000000,
  TIKTOK_INDUSTRY_26105000000,
  TIKTOK_INDUSTRY_26111000000,
  TIKTOK_INDUSTRY_26999000000,
  TIKTOK_INDUSTRY_26101000000,
  TIKTOK_INDUSTRY_26106000000,
  TIKTOK_INDUSTRY_26107000000,
  TIKTOK_INDUSTRY_26109000000,
  TIKTOK_INDUSTRY_26103000000,
  TIKTOK_INDUSTRY_26100000000,
  TIKTOK_INDUSTRY_23113000000,
  TIKTOK_INDUSTRY_23114000000,
  TIKTOK_INDUSTRY_23122000000,
  TIKTOK_INDUSTRY_23102000000,
  TIKTOK_INDUSTRY_23126000000,
  TIKTOK_INDUSTRY_23108000000,
  TIKTOK_INDUSTRY_23105000000,
  TIKTOK_INDUSTRY_23111000000,
  TIKTOK_INDUSTRY_23116000000,
  TIKTOK_INDUSTRY_23104000000,
  TIKTOK_INDUSTRY_23128000000,
  TIKTOK_INDUSTRY_23107000000,
  TIKTOK_INDUSTRY_23124000000,
  TIKTOK_INDUSTRY_23125000000,
  TIKTOK_INDUSTRY_23127000000,
  TIKTOK_INDUSTRY_23115000000,
  TIKTOK_INDUSTRY_23106000000,
  TIKTOK_INDUSTRY_23109000000,
  TIKTOK_INDUSTRY_23110000000,
  TIKTOK_INDUSTRY_23100000000,
  TIKTOK_INDUSTRY_23119000000,
  TIKTOK_INDUSTRY_23999000000,
  TIKTOK_INDUSTRY_23129000000,
  TIKTOK_INDUSTRY_23101000000,
  TIKTOK_INDUSTRY_23118000000,
  TIKTOK_INDUSTRY_23130000000,
  TIKTOK_INDUSTRY_23131000000,
  TIKTOK_INDUSTRY_23103000000,
  TIKTOK_INDUSTRY_23134000000,
  TIKTOK_INDUSTRY_23123000000,
  TIKTOK_INDUSTRY_23132000000,
  TIKTOK_INDUSTRY_23133000000,
  TIKTOK_INDUSTRY_23112000000,
  TIKTOK_INDUSTRY_23117000000,
  TIKTOK_INDUSTRY_19999000000,
  TIKTOK_INDUSTRY_19103000000,
  TIKTOK_INDUSTRY_19101000000,
  TIKTOK_INDUSTRY_19102000000,
  TIKTOK_INDUSTRY_19105000000,
  TIKTOK_INDUSTRY_19106000000,
  TIKTOK_INDUSTRY_19104000000,
  TIKTOK_INDUSTRY_19100000000,
  TIKTOK_INDUSTRY_28100000000,
  TIKTOK_INDUSTRY_28101000000,
  TIKTOK_INDUSTRY_15100000000,
  TIKTOK_INDUSTRY_15105000000,
  TIKTOK_INDUSTRY_15103000000,
  TIKTOK_INDUSTRY_15101000000,
  TIKTOK_INDUSTRY_15102000000,
  TIKTOK_INDUSTRY_15104000000,
  TIKTOK_INDUSTRY_15106000000,
  TIKTOK_INDUSTRY_15107000000,
  TIKTOK_INDUSTRY_15999000000,
  TIKTOK_INDUSTRY_17103000000,
  TIKTOK_INDUSTRY_17999000000,
  TIKTOK_INDUSTRY_17105000000,
  TIKTOK_INDUSTRY_17106000000,
  TIKTOK_INDUSTRY_11111000000,
  TIKTOK_INDUSTRY_11110000000,
  TIKTOK_INDUSTRY_11101000000,
  TIKTOK_INDUSTRY_11103000000,
  TIKTOK_INDUSTRY_11102000000,
  TIKTOK_INDUSTRY_11100000000,
  TIKTOK_INDUSTRY_11107000000,
  TIKTOK_INDUSTRY_11112000000,
  TIKTOK_INDUSTRY_11104000000,
  TIKTOK_INDUSTRY_11108000000,
  TIKTOK_INDUSTRY_11106000000,
  TIKTOK_INDUSTRY_11999000000,
  TIKTOK_INDUSTRY_11105000000,
  TIKTOK_INDUSTRY_11109000000,
  META_ATTRIBUTION_WINDOW_TITLE,
  META_ATTRIBUTION_WINDOW_DESCRIPTION,
  META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_7D_CLICK,
  META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_1D_CLICK,
  META_ATTRIBUTION_WINDOW_DEFAULT_OPTION,
  META_ATTRIBUTION_ENGAGED_VIEW_LABEL,
  WHITE_LABEL_TITLE,
  WHITE_LABEL_BUY,
  WHITE_LABEL_PRICE_PER_MONTH,
  WHITE_LABEL_DIALOG_BODY,
  WHITE_LABEL_NO_SETUP_FEE,
  WHITE_LABEL_AFTER_PAYMENT,
  WHITE_LABEL_APP_SUMO_CONFIRM,
  WHITE_LABEL_ONLY_OWNER,
  WHITE_LABEL_STATUS_PENDING_BRANDING,
  WHITE_LABEL_STATUS_CONFIGURING,
  WHITE_LABEL_STATUS_ACTIVE,
  WHITE_LABEL_STATUS_REVERT_PENDING,
  WHITE_LABEL_ALREADY_ACTIVE,
  WHITE_LABEL_COMPLETE_BRAND,
  WHITE_LABEL_EDIT_BRAND,
  WHITE_LABEL_FORM_TITLE,
  WHITE_LABEL_FORM_INTRO,
  WHITE_LABEL_FORM_SECTION_GENERAL,
  WHITE_LABEL_FORM_SECTION_VISUAL,
  WHITE_LABEL_FORM_SECTION_VISUAL_HELP,
  WHITE_LABEL_FORM_SECTION_COLORS,
  WHITE_LABEL_FORM_SECTION_COLORS_HELP,
  WHITE_LABEL_FORM_SECTION_DOMAIN,
  WHITE_LABEL_FORM_BADGE_REQUIRED,
  WHITE_LABEL_FORM_BADGE_OPTIONAL,
  WHITE_LABEL_FORM_DROP_TITLE,
  WHITE_LABEL_FORM_DROP_HINT,
  WHITE_LABEL_FORM_INVALID_FILE,
  WHITE_LABEL_FORM_DOMAIN_BLOCKED,
  WHITE_LABEL_FORM_DOMAIN_INVALID,
  WHITE_LABEL_FORM_COLOR_INVALID,
  WHITE_LABEL_FORM_NAME_INVALID,
  WHITE_LABEL_FORM_NOTES_INVALID,
  WHITE_LABEL_FORM_LOGO_NAV_HELP,
  WHITE_LABEL_FORM_LOGO_LOGIN_HELP,
  WHITE_LABEL_FORM_FAVICON_CAPTION,
  WHITE_LABEL_FORM_FAVICON_HELP,
  WHITE_LABEL_FORM_NAME_PLACEHOLDER,
  WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER,
  WHITE_LABEL_FORM_NOTES_PLACEHOLDER,
  WHITE_LABEL_FORM_COLOR_PRIMARY,
  WHITE_LABEL_FORM_COLOR_SECONDARY,
  WHITE_LABEL_FORM_COLOR_BUTTONS,
  WHITE_LABEL_FORM_NAME_BUSINESS,
  WHITE_LABEL_FORM_LOGO,
  WHITE_LABEL_FORM_LOGO_NAVBAR,
  WHITE_LABEL_FORM_LOGO_LOGIN,
  WHITE_LABEL_FORM_FAVICON,
  WHITE_LABEL_FORM_PRIMARY_COLOR,
  WHITE_LABEL_FORM_SECONDARY_COLOR,
  WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR,
  WHITE_LABEL_FORM_DESIRED_DOMAIN,
  WHITE_LABEL_FORM_DOMAIN_HELP,
  WHITE_LABEL_FORM_NOTES,
  WHITE_LABEL_FORM_SUBMIT,
  WHITE_LABEL_FORM_SUBMITTED,
  WHITE_LABEL_CONFIRMING_PAYMENT,
  WHITE_LABEL_CHECKOUT_CANCELLED,
  WHITE_LABEL_NOT_ELIGIBLE,
  WHITE_LABEL_ERROR_ALREADY_ACTIVE,
  WHITE_LABEL_NOT_PURCHASED,
  WHITE_LABEL_INVALID_BRANDING,
  WHITE_LABEL_INVALID_TRANSITION,
  AGENCY_ACCOUNT_LINKING_PICKER_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONSENT,
  AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP,
  AGENCY_ACCOUNT_LINKING_CONSENT_INFO,
  AGENCY_ACCOUNT_LINKING_CARD_TITLE,
  AGENCY_ACCOUNT_LINKING_CARD_BODY,
  AGENCY_ACCOUNT_LINKING_ENABLE,
  AGENCY_ACCOUNT_LINKING_NOT_NOW,
  AGENCY_ACCOUNT_LINKING_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY,
  AGENCY_ACCOUNT_LINKING_CONFIRM,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER,
  AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL,
  AGENCY_ACCOUNT_LINKING_TOAST_LATER,
  AGENCY_ACCOUNT_LINKING_PLATFORM_META,
  AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE,
  AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_LINKING,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC,
  AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT,
  AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP,
  AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN,
  AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING,
  AGENCY_ACCOUNT_LINKING_COLUMN_STATUS,
  AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS,
  AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED,
  AGENCY_ACCOUNT_LINKING_STATUS_PENDING,
  AGENCY_ACCOUNT_LINKING_STATUS_FAILED,
  AGENCY_ACCOUNT_LINKING_STATUS_LINKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN,
  AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS,
  AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT,
  AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE,
  AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED,
  AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC,
  ADLE_CARD_WAITLIST_EYEBROW,
  ADLE_CARD_WAITLIST_TITLE,
  ADLE_CARD_WAITLIST_SUBTITLE,
  ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS,
  ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE,
  ADLE_CARD_WAITLIST_FEATURE_CASHBACK,
  ADLE_CARD_WAITLIST_FEATURE_NO_FEES,
  ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES,
  ADLE_CARD_WAITLIST_FEATURE_TOP_UPS,
  ADLE_CARD_WAITLIST_EMAIL_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER,
  ADLE_CARD_WAITLIST_CTA,
  ADLE_CARD_WAITLIST_NOT_NOW,
  ADLE_CARD_WAITLIST_DISCLAIMER,
  ADLE_CARD_WAITLIST_SUCCESS_TITLE,
  ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION,
  ADLE_CARD_WAITLIST_SUBMIT_ERROR,
  ADLE_CARD_WAITLIST_BANNER,
  ADLE_CARD_WAITLIST_BANNER_LINK,
  ADLE_CARD_WAITLIST_CARD_ARIA,
  ADLE_CARD_WAITLIST_CARD_VIRTUAL,
  ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK,
  OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST,
  ADLE_CARD_WAITLIST_ADMIN_TOTAL,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M,
  ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE,
} from "../keysTranslations";

const translation = {
  /*COMMON*/
  [SEARCH]: "Buscar",
  [LOADING_INFORMATION]: "Cargando información",
  [LOADING_SUGGESTED_INFORMATION]:
    "Buscando creadores sugeridos, puede tardar un poco",
  [LOADING_SIMILAR_PROFILES_INFORMATION]: "Cargando perfiles de referencia",
  [LOADING_REPORT_INFORMATION]: "Cargando reporte",
  [LOADING_DOWNLOAD_PROFILES]: "Descargando perfiles",
  [LOADING_CONTENT]: "Cargando contenido",
  [LOADING_CONFIGURATION]: "Cargando configuración",
  [LOADING_PLAN_INFORMATION]: "Cargando información de los planes",
  [UPDATING_INFORMATION]: "Actualizando información",
  [INFORMATION_INVALID_ACCESS]: "No puedes acceder a esta información",
  [EMPTY_CONTENT_SHOW]: "No hay contenido para mostrar",
  [EMPTY_SIMILAR_PROFILES_SHOW]: "No se encontraron perfiles de referencia",
  [NO_MORE_RESULTS_TO_SHOW]: "No hay más resultados para mostrar",
  [EMPTY_RESULTS_SHOW]: "No se encontraron resultados",
  [EMPTY_RESULTS_SHOW_ON_THIS_PAGE]:
    "No se encontraron resultados en esta página",
  [EMPTY_QUESTIONS_SHOW]: "No se encontraron preguntas",
  [EMPTY_ANALYTICS]:
    "No se pudieron extraer las analíticas de esta publicación, contacta con soporte o a tu asesor.",
  [EMPTY_KEYWORDS]: "No se encontraron palabras clave",
  [ADVANCED_CONFIGURATION]: "Configuración avanzada",
  [WAIT]: "Espera",
  [COLLABORATIONS]: "Colaboraciones",
  [COLLABORATION]: "Colaboración",
  [ALL]: "Todos",
  [DEACTIVATE]: "Desactivar",
  [ACTIVATE]: "Activar",
  [DEACTIVATED]: "Desactivada",
  [ACTIVATED]: "Activado",
  [ACTIVE]: "Activada",
  [BRAND]: "Marca",
  [WARNING]: "Advertencia",
  [INFORMATION]: "Información",
  [CATEGORY]: "Categoría",
  [CATEGORIES]: "Categorías",
  [PRODUCT]: "Producto",
  [PRODUCTS]: "Productos",
  [ERROR]: "Error",
  [ACTIONS]: "Acciones",
  [STATUS]: "Status",
  [CITIES]: "Ciudades",
  [UNKNOWN_FORMAT]: "Formato desconocido",
  [ERROR_DESCRIPTION_GENERIC]: "{{message}}",
  [READY]: "Hecho",
  [FIELD_HAS_NO_VALUE_TO_COPY]: "Este campo no tiene un valor para copiar",
  [HELP]: "Ayuda",
  [GO]: "Ir",
  [GO_TO_PROFILE]: "Ir al perfil",
  [GO_TO_ACCOUNT]: "Ir a cuenta",
  [PROFILE]: "Perfil",
  [LOGOUT]: "Cerrar sesión",
  [CLIENT]: "Cliente",
  [NAME]: "Nombre",
  [ADDRESS]: "Dirección",
  [IDENTIFICATION_NUMBER]: "Número de identificación",
  [PHONE_NUMBER]: "Teléfono",
  [EMAIL]: "Correo electrónico",
  [NOTIFICATIONS]: "Notificaciones",
  [CONTENT]: "Contenido",
  [ANALYTIC]: "Analitíca",
  [ANALYTICS]: "Analitícas",
  [COMMENTS]: "Comentarios",
  [COMMENT]: "Comentario",
  [SHOW_COMMENTS]: "Mostrar comentarios",
  [EMPTY_COMMENTS]: "No hay comentarios",
  [REVIEWS]: "Reseñas",
  [REVIEW]: "Reseña",
  [SHOW_REVIEWS]: "Mostrar reseña",
  [EMPTY_REVIEWS]: "No hay reseñas",
  [SCORE]: "Puntaje",
  [QUALITY_AUDIENCE]: "Calidad de audiencia",
  [QUALITY_CONTENT]: "Calidad de contenido",
  [AUDIENCE]: "Audiencia",
  [AUDIENCE_TITLE_EXPLANATION]: "¿Qué es la audiencia?",
  [AUDIENCE_EXPLANATION]:
    "La audiencia es el número de personas que siguen o estas suscritas al perfil del creador de contenido. Audiencias grandes tienen un mejor alcance o reach en cada publicación pero generalmente la tasa de interacción o engagement es menor a medida que aumenta la audiencia.",
  [ENGAGEMENT]: "Engagement",
  [ENGAGEMENT_TITLE_EXPLANATION]: "¿Qué es el engagement?",
  [ENGAGEMENT_EXPLANATION]:
    "El engagement o tasa de interacción es la cantidad de personas que interactúe con el contenido publicado, ya sea un like, un comentario, un share o save y otras acciones dependiendo de la plataforma. Si quieres estimar cuantas personas van a interactuar con el contenido, multiplicas la audiencia por el engagement y lo divides en 100.",
  [FOLLOWERS]: "Seguidores",
  [AVG_LIKES]: "Promedio likes",
  [POST]: "Publicar",
  [AVG_COMMENTS]: "Promedio comentarios",
  [AVG_VIEWS]: "Promedio visualizaciones",
  [RECORDS_IN_TABLE]: "Registros",
  [SHOP_DEACTIVATE_ALERT_DESCRIPTION]:
    "Tu tienda ha sido desactivada. Contacta a soporte si necesitas ayuda.",
  [PAGE_IN_TABLE]: "Página",
  [UPDATE]: "Actualizar",
  [MALES]: "Hombres",
  [MALE]: "Hombre",
  [FEMALES]: "Mujeres",
  [FEMALE]: "Mujer",
  [STORE]: "Tienda",
  [SELECT_STORE]: "Selecciona una tienda",
  [EMPTY_STORES]: "No hay tiendas creadas",
  [ORDER]: "Orden",
  [NEW_ORDER]: "Nueva orden",
  [NEW]: "Nuevo",
  [SECOND]: "Segundo",
  [SECONDS]: "Segundos",
  [MINUTE]: "Minuto",
  [MINUTES]: "Minutos",
  [MINUTE_LETTER_COUNT_DOWN]: "min",
  [HOUR]: "Hora",
  [HOURS]: "Horas",
  [HOUR_LETTER_COUNT_DOWN]: "h",
  [DAY]: "Día",
  [DAYS]: "Días",
  [DAY_LETTER_COUNT_DOWN]: "d",
  [WEEK]: "Semana",
  [WEEKS]: "Semanas",
  [WEEK_LETTER_COUNT_DOWN]: "sem",
  [MONTH]: "Mes",
  [MONTHS]: "Meses",
  [CALENDAR_MONTH]: "Mes",
  [CALENDAR_WEEK]: "Semana",
  [CALENDAR_DAY]: "Día",
  [CALENDAR_TODAY]: "Hoy",
  [CALENDAR_TOMORROW]: "Mañana",
  [CALENDAR_NEXT]: "Siguiente",
  [CALENDAR_PREVIOUS]: "Anterior",
  [CALENDAR_AGENDA]: "Agenda",
  [CALENDAR_SHOW_MORE]: "+ {{total}} más",
  [VIEW_CALENDAR]: "Ver Calendario",
  [POST_TITLE]: "Publicaciones",
  [CALENDAR_POST_TITLE]: "Publicación",
  [CALENDAR_STORIES_TITLE]: "Historia",
  [CALENDAR_REELS_TITLE]: "Reel",
  [CALENDAR_MULTIPLE_POST_TITLE]: "Publicación - Múltiples Redes",
  [CALENDAR_INVALID_DATE_ERROR]:
    "Por favor, selecciona una fecha y hora futura para programar tu publicación.",
  [EVENT_DETAILS_DESCRIPTION]: "Descripción",
  [EVENT_DETAILS_DATE_AND_TIME]: "Fecha y hora",
  [EVENT_DETAILS_SOCIAL_NETWORK]: "Red social",
  [EVENT_DETAILS_STATUS]: "Estado",
  [EVENT_DETAILS_STATUS_DRAFT]: "Borrador",
  [EVENT_DETAILS_STATUS_SCHEDULED]: "Programado",
  [EVENT_DETAILS_STATUS_PUBLISHED]: "Publicado",
  [GALLERY_MAX_SELECTIONS_REACHED]:
    "Puedes seleccionar hasta {{limit}} contenidos.",
  [GALLERY_PUBLISHED_ON_PLATFORMS]: "Publicado en {{platforms}}",
  [GALLERY_PLATFORM_STATUSES_LABEL]: "Estados de publicación",
  [GALLERY_STATUS_PUBLISHED_DIRECT]: "Publicado directamente el {{date}}",
  [GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN]: "Publicado directamente",
  [GALLERY_STATUS_SCHEDULED]: "Agendado para {{date}}",
  [GALLERY_STATUS_SCHEDULED_UNKNOWN]: "Agendado",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE]: "Publicado mediante agenda el {{date}}",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN]: "Publicado mediante agenda",
  [GALLERY_STATUS_FAILED]: "Falló el {{date}}",
  [GALLERY_STATUS_FAILED_UNKNOWN]: "Falló",
  [GALLERY_STATUS_PUBLISHED_LEGACY]: "Publicado",
  [SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED]:
    "Esta plataforma ya se publicó y no se puede retirar",
  [EVENT_DETAILS_STATUS_FAILED]: "Error al Publicar",
  [EVENT_DETAILS_NETWORK_INSTAGRAM]: "Instagram",
  [EVENT_DETAILS_NETWORK_FACEBOOK]: "Facebook",
  [EVENT_DETAILS_NETWORK_TIKTOK]: "TikTok",
  [EVENT_DETAILS_NETWORK_LINKEDIN]: "LinkedIn",
  [EVENT_DETAILS_NETWORK_YOUTUBE]: "YouTube",
  [EVENT_DETAILS_CONTENT]: "Contenido",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE]: "¿Deseas reintentar la publicación?",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION]:
    "Vas a reintentar la publicación en {{platforms}}.",
  [ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL]:
    "Plataformas y errores del reintento de publicación",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM]: "Plataforma",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE]: "Mensaje",
  [ORGANIC_PUBLISH_RETRY_ERROR]:
    "No se pudo publicar en algunas plataformas. Revisa los errores e inténtalo de nuevo.",
  [ORGANIC_PUBLISH_PARTIAL_STATUS]: "Publicado parcialmente",
  [QUESTION]: "Pregunta",
  [QUESTIONS]: "Preguntas",
  [CONTENT_CREATOR]: "Creador de contenido",
  [ADD]: "Agregar",
  [MONDAY]: "Lunes",
  [TUESDAY]: "Martes",
  [WEDNESDAY]: "Miercoles",
  [THURSDAY]: "Jueves",
  [FRIDAY]: "Viernes",
  [SATURDAY]: "Sábado",
  [SUNDAY]: "Domingo",
  [SELECT_A_OPTION]: "Selecciona una opción",
  [FILE_SELECTED]: "Archivo seleccionado: {{fileName}}",
  [YES]: "Sí",
  [NO]: "No",
  [IMAGES]: "Imágenes",
  [VIDEOS]: "Videos",
  [OK]: "Ok",
  [FILTER]: "Filtrar",
  [SUPER_ADMIN]: "Super Administrador",
  [ADMIN]: "Administrador",
  [OPERATOR]: "Operador",
  [TOTAL]: "Total",
  [NO_HAVE]: "No hay",
  [NO_ADDED]: "No agregados",
  [SUPPORT]: "Soporte",
  [CONTACT_US]: "Contáctanos",
  [ONE]: "Uno",
  [TWO]: "Dos",
  [THREE]: "Tres",
  [ANY]: "Cualquiera",
  [GENDER]: "Género",
  [REVISIONS]: "Revisiones",
  [CURRENT_CONTENT]: "Contenido actual",
  [CURRENT_CONTENT_EMPTY]:
    "No hay contenido actual, espera a que el creador lo suba",
  [NO_SEND_CONTENT_FEEDBACK]: "El creador no envió contenido del feedback",
  [USERS]: "Usuarios",
  [ANONYMOUS_USER]: "Usuario Anónimo",
  [STORES]: "Tiendas",
  [PLAN]: "Plan",
  [AUTOMATIC_RENOVATION]: "Renovación automática",
  [START_DATE_AND_END_DATE_VALIDATION]:
    "La fecha de inicio no puede ser mayor a la fecha de finalización",
  [PREVIOUS_PERIOD]: "Período anterior",
  [LOADING_CONFIGURATION_METRICS]: "Cargando configuración de métricas",
  [EDIT]: "Editar",
  [THIS_CREATOR_IS_FAVORITE]: "Es favorito",
  [ADD_TO_FAVORITES]: "Agregar a favoritos",
  [REMOVE_FROM_FAVORITES]: "Quitar de favoritos",
  [SPANISH]: "Español",
  [ENGLISH]: "Inglés",
  [PORTUGUESE]: "Portugués",
  [FRENCH]: "Francés",
  [RUSSIAN]: "Ruso",
  [JAPANESE]: "Japonés",
  [MANDARIN]: "Mandarín",
  [HINDI]: "Hindi",
  [ARABIC]: "Árabe",
  [BENGALI]: "Bengalí",
  [PUNJABI]: "Punjabi",
  [GERMAN]: "Alemán",
  [JAVANESE]: "Javanés",
  [KOREAN]: "Coreano",
  [INDONESIAN]: "Indonesio",
  [TURKISH]: "Turco",
  [BULGARIAN]: "Búlgaro",
  [SLOVAK]: "Eslovaco",
  [CROATIAN]: "Croata",
  [DANISH]: "Danés",
  [UKRAINIAN]: "Ucraniano",
  [ENGLISH_US]: "Inglés (EE.UU.)",
  [ENGLISH_UK]: "Inglés (Reino Unido)",
  [SPANISH_SPAIN]: "Español (España)",
  [PORTUGUESE_BRAZIL]: "Portugués (Brasil)",
  [PORTUGUESE_PORTUGAL]: "Portugués (Portugal)",
  [FRENCH_FRANCE]: "Francés (Francia)",
  [FRENCH_CANADA]: "Francés (Canadá)",
  [TRADITIONAL_CHINESE_HONG_KONG]: "Chino tradicional (Hong Kong)",
  [TRADITIONAL_CHINESE_TAIWAN]: "Chino tradicional (Taiwán)",
  [JAPANESE_KANSAI]: "Japonés (Kansai)",
  [NORWEGIAN_BOKMAL]: "Noruego (Bokmål)",
  [NORWEGIAN_NYNORSK]: "Noruego (Nynorsk)",
  [CATALAN]: "Catalán",
  [CZECH]: "Checo",
  [WELSH]: "Galés",
  [BASQUE]: "Euskera",
  [FINNISH]: "Finlandés",
  [GALICIAN]: "Gallego",
  [HUNGARIAN]: "Húngaro",
  [ITALIAN]: "Italiano",
  [DUTCH]: "Holandés",
  [FRISIAN]: "Frisón",
  [POLISH]: "Polaco",
  [ROMANIAN]: "Rumano",
  [SLOVENIAN]: "Esloveno",
  [SWEDISH]: "Sueco",
  [FLEMISH]: "Flamenco",
  [ESPERANTO]: "Esperanto",
  [ESTONIAN]: "Estonio",
  [FAROESE]: "Feroés",
  [GREEK]: "Griego",
  [ICELANDIC]: "Islandés",
  [IRISH]: "Irlandés",
  [LATVIAN]: "Letón",
  [LITHUANIAN]: "Lituano",
  [MACEDONIAN]: "Macedonio",
  [THAI]: "Tailandés",
  [VIETNAMESE]: "Vietnamita",
  [KHMER]: "Jemer",
  [FILIPINO]: "Filipino",
  [MALAY]: "Malayo",
  [GUJARATI]: "Gujarati",
  [KANNADA]: "Canarés",
  [TAMIL]: "Tamil",
  [TELUGU]: "Telugu",
  [MALAYALAM]: "Malayalam",
  [URDU]: "Urdu",
  [HEBREW]: "Hebreo",
  [PERSIAN]: "Persa",
  [NORTHERN_KURDISH_KURMANJI]: "Kurdo del norte (Kurmanji)",
  [ARMENIAN]: "Armenio",
  [AZERBAIJANI]: "Azerbaiyano",
  [BELARUSIAN]: "Bielorruso",
  [BOSNIAN]: "Bosnio",
  [GEORGIAN]: "Georgiano",
  [KAZAKH]: "Kazajo",
  [MONGOLIAN]: "Mongol",
  [SERBIAN]: "Serbio",
  [TAJIK]: "Tayiko",
  [UZBEK]: "Uzbeko",
  [AFRIKAANS]: "Afrikáans",
  [SWAHILI]: "Suajili",
  [ALBANIAN]: "Albanés",
  [CEBUANO]: "Cebuano",
  [GUARANI]: "Guaraní",
  [MARATHI]: "Maratí",
  [NEPALI]: "Nepalí",
  [PASHTO]: "Pastún",
  [SINHALA]: "Cingalés",
  [CHINESE]: "Chino",
  [ASSAMESE]: "Asamés",
  [HARYANAVI]: "Haryanví",
  [BIHARI]: "Biharí",
  [ORIYA]: "Oriya",
  [RAJASTHANI]: "Rajasthani",
  [NORWEGIAN]: "Noruego",
  [VIEW]: "Ver",
  [ACCEPTED]: "Aceptadas",
  [PENDING]: "Pendientes",
  [ARE_YOU_SURE]: "¿Estás seguro?",
  [ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT]:
    "¿Estás seguro de desconectar esta cuenta?",
  [CHANGE]: "Cambio",
  [REPORT_REQUESTS]: "Reporte solicitudes",
  [REQUESTS_ACCEPTED]: "Aceptadas",
  [REQUESTS_REJECTED]: "Rechazadas",
  [REQUESTS_ACTIVE]: "Solicitudes activas",
  [CODE]: "Código",
  [IS_AUTOMATIC]: "Es automática",
  [REDEEMED]: "Redimidas",
  [EXPIRED]: "Expiradas",
  [REDEEMED_SINGULAR]: "Redimida",
  [EXPIRED_SINGULAR]: "Expirada",
  [REJECTED]: "Rechazadas",
  [ROLE]: "Rol",
  [UNKNOWN]: "Desconocido",
  [RIGHT]: "Derecha",
  [LEFT]: "Izquierda",
  [LOGO]: "Logo",
  [LOGO_DESCRIPTION]:
    "Para obtener mejores resultados, usa un logo sin transparencia, con fondo sólido que haga contraste con los elementos del logo.",
  [CANCEL_ANYTIME]: "Cancela en cualquier momento",
  [ADD_BRAND]: "Agregar marca",
  [DATE]: "Fecha",
  [NAME_BUSINESS_BOT]: "Ana de {{NAME_BUSINESS}}",
  [SERVICE_FEE]: "Tarifa de servicio",
  [TOTAL_PAYMENT]: "Pago total",
  [LAST_COLLABORATION]: "Última colaboración",
  [PERSONALIZED_INSTRUCTIONS]: "Instrucciones personalizadas",
  [EMPTY_REQUESTS]: "Aún no tienes solicitudes",
  [EMPTY_CAMPAIGNS]: "Aún no tienes campañas",
  [EMPTY_ORDERS]: "Aún no tienes colaboraciones",
  [EMPTY_REDEEM_CODES]: "Aún no tienes códigos redimidos",
  [EMPTY_USERS]: "Aún no tienes usuarios creados",
  [EMPTY_CONTACTS]: "Aún no tienes contactos creados",
  [EMPTY_INVOICES]: "Aún no tienes facturas creadas",
  [EMPTY_APPLICANTS_PENDING]: "Aún no tienes aplicantes pendientes",
  [EMPTY_APPLICANTS_ACCEPTED]: "Aún no has aceptado aplicantes",
  [EMPTY_ADS_CAMPAIGNS]: "Aún no tienes campañas publicitarias",
  [TARGET_CAMPAIGN]: "Segmentación",
  [LOCATIONS]: "Ubicaciones",
  [GENDERS]: "Géneros",
  [AGES]: "Edades",
  [PLATFORMS]: "Plataformas",
  [PLATFORM]: "Plataforma",
  [REPORTS]: "Reporte",
  [PREVIOUS_PERIOD]: "Período anterior",
  [IMPRESSIONS]: "Impresiones",
  [CLICKS]: "Clicks",
  [CTR]: "CTR",
  [CPA]: "CPA",
  [CLICK]: "Clicks",
  [CPM]: "CPM",
  [CPC]: "CPC",
  [RESULTS]: "Resultados",
  [SPEND]: "Gasto",
  [PERIOD]: "Periodo",
  [AVERAGE]: "Promedio",
  [TYPE_LEAST_CHARACTERS]: "Debes escribir al menos {{value}} caracteres",
  [LOADING]: "Cargando",
  [OBJECTIVE]: "Objetivo",
  [AWARENESS]: "Reconocimiento",
  [TRAFFIC]: "Tráfico",
  [INTERACTIONS]: "Interacciones",
  [LEADS]: "Leads",
  [DOWNLOADS]: "Descargas",
  [SALES]: "Ventas",
  [META_CAMPAIGN]: "Campaña de Meta",
  [TIKTOK_CAMPAIGN]: "Campaña de TikTok",
  [CONTENT_TO_ADVERTISE]: "Contenido",
  [EMPTY_TRACKING_IDS_META]: "No tienes Meta pixels creados",
  [EMPTY_TRACKING_IDS_LINKEDIN]: "No tienes LinkedIn pixels creados",
  [FINISHED]: "Finalizada",
  [TIKTOK_BUSINESS]: "TikTok Business",
  [EMPTY_TRACKING_IDS_TIKTOK]: "No tienes pixels de TikTok creados",
  [TIKTOK_PRIVACY_LEVEL_LABEL]: "Nivel de privacidad",
  [TIKTOK_ACCOUNT_LABEL]: "Cuenta de TikTok",
  [TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE]: "Público para todos",
  [TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS]:
    "Amigos que se siguen mutuamente",
  [TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR]: "Seguidores del creador",
  [TIKTOK_PRIVACY_LEVEL_SELF_ONLY]: "Solo yo",
  [TIKTOK_DISABLE_DUET_LABEL]: "Deshabilitar Duetos",
  [TIKTOK_DISABLE_DUET_DESCRIPTION]:
    "Si está activado, otros usuarios de TikTok no podrán hacer Duetos con esta publicación",
  [TIKTOK_DISABLE_STITCH_LABEL]: "Deshabilitar la función Pegar",
  [TIKTOK_DISABLE_STITCH_DESCRIPTION]:
    "Si está activado, otros usuarios de TikTok no podrán hacer Stitches con esta publicación",
  [TIKTOK_DISABLE_COMMENT_LABEL]: "Deshabilitar comentarios",
  [TIKTOK_AUTO_ADD_MUSIC_LABEL]: "Agregar música automáticamente",
  [TIKTOK_DISABLE_COMMENT_DESCRIPTION]:
    "Si está activado, otros usuarios de TikTok no podrán comentar en esta publicación",
  [TIKTOK_IS_AIGC_LABEL]: "Contenido generado por IA",
  [TIKTOK_IS_AIGC_DESCRIPTION]:
    "Marca esta opción si el video es contenido generado por IA. El video será etiquetado como generado por IA",
  [SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS]:
    "Ha pasado poco tiempo desde que activaste la campaña, las estadísticas pueden tardar en actualizarse",
  [SHOPIFY]: "Shopify",
  [WOOCOMMERCE]: "Woocommerce",
  [FOLLOWERS_ABBREVIATED]: "FLL",
  [ENGAGEMENT_ABBREVIATED]: "ER",
  [ADD_NEW_STYLE]: "Agrega nuevo estilo",
  [WANTS_SOCIAL_MEDIA_POST]: "Quiero exposición en redes sociales",
  [DOES_NOT_WANTS_SOCIAL_MEDIA_POST]: "No quiero exposición en redes sociales",
  [EXPLANATION_SEND_ONE_REVISION]: "Solo podrás enviar una revisión",
  [I_NEED_HELP]: "Necesito ayuda",
  [REVISION_OPTION_GOOD]: "¡Increíble! Pero tengo una duda",
  [REVISION_OPTION_REGULAR]: "Está bien, pero falta algo",
  [REVISION_OPTION_BAD]: "Esto no me sirve",
  [WHY_THESE_RECOMMENDED_SETTINGS]: "¿Por qué estos ajustes recomendados?",
  [PIXEL_REQUIRED]: "Pixel requerido",
  [DRAFT]: "Borrador",
  [CANVA]: "Canva",
  [CONNECTED_ACCOUNTS]: "Cuentas conectadas",
  [CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS]: "Conectar más plataformas",
  [CONNECTED_ACCOUNTS_BUTTON_CONNECT]: "Conectar",
  [CONNECTED_ACCOUNTS_EMPTY_HINT]:
    "Aún no tienes cuentas conectadas. Usa el botón de agregar para añadir una.",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT]: "{{count}} cuentas",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR]: "1 cuenta",
  [CONNECTED_ACCOUNTS_PLATFORM_META]: "Meta",
  [CONNECTED_ACCOUNTS_PLATFORM_GOOGLE]: "Google Ads",
  [CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS]: "TikTok",
  [CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN]: "LinkedIn",
  [CONNECTED_ACCOUNTS_ACCORDION_EXPAND]: "Ver cuentas conectadas",
  [SLIDE_MENU_COLLAPSE]: "Contraer menú",
  [SLIDE_MENU_EXPAND]: "Expandir menú",
  [CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE]: "Ocultar cuentas conectadas",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE]:
    "Configuración por Defecto de Campaña",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE]: "Guardar Configuración",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS]:
    "La configuración por defecto se guardó correctamente",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR]:
    "No se pudo guardar la configuración por defecto. Inténtalo de nuevo.",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING]:
    "Cargando configuración guardada...",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL]: "Formato de Anuncio",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL]: "Aplicación",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL]:
    "Promoción de Aplicación",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL]: "Tipo de Campaña",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL]:
    "Catálogo para Instalación",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL]: "Catálogo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL]: "Enlace Profundo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL]:
    "Tipo de Destino",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL]:
    "URL de Destino",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL]:
    "Cuentas e Identidades",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL]: "Merchant Center",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL]: "Objetivo de Campaña",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL]:
    "Tipo de Campaña TikTok",
  [CAMPAIGN]: "Campaña",
  [ASSETS_GROUP]: "Grupo de activos",
  [AD_GROUP]: "Grupo de anuncios",
  [AD]: "Anuncio",
  [NUMBER_ITEM]: "N° {{value}}",
  [TITLES]: "Títulos",
  [TITLES_META]: "Textos Principales",
  [TITLE]: "Título",
  [LONG_HEADLINES]: "Titulares Largos",
  [HEADLINES]: "Titulares",
  [DESCRIPTIONS]: "Descripciones",
  [COMING_SOON]: "Muy pronto",
  [ENTER_CODE]: "Ingresa el código",
  [WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE]:
    "Le enviaremos un código de verificación a su teléfono, puede tardar hasta un minuto en llegar.",
  [MODIFY_PHONE_NUMBER]: "Modificar teléfono",
  [OTP_VERIFICATION_TITLE]: "Código de verificación",
  [OTP_VERIFICATION_EMAIL_SENT]:
    "Hemos enviado un codigo de 6 digitos a {{emailMasked}}.",
  [OTP_BACK_TO_EMAIL]: "Volver al correo",
  [META_TOGGLE_DESCRIPTION]: "Facebook, Instagram y Red de Audiencia",
  [GOOGLE_TOGGLE_DESCRIPTION]:
    "Buscador de Google. Próximamente: YouTube y Red de Display",
  [TIKTOK_TOGGLE_DESCRIPTION]: "Feed y Buscador de TikTok",
  [LINKEDIN_TOGGLE_DESCRIPTION]: "Feed, Buscador y Chat de LinkedIn",
  [NOT_AVAILABLE]: "No disponible",
  [EDIT_INSTRUCTIONS]: "Editar instrucciones",
  [PROMPT]: "Instrucciones",
  [TYPE]: "Tipo",
  [RETENTION_DAYS]: "Días de retención",
  [ERRORS]: "Errores",
  [DELIVERY_STATUS]: "Estado de entrega",
  [OPERATION_STATUS]: "Estado de operación",
  [MOST_POPULAR]: "Más popular",
  [MANUAL_SEGMENTATION]: "Segmentación manual",
  [RE_TARGETING_SEGMENTATION]: "Audiencias personalizadas",
  [IDENTITIES_TIK_TOK_EMPTY]: "No tienes identidades de TikTok creadas",
  [ADD_NEW_IDENTITY]: "Agregar nueva identidad",
  [GENERAL_INFORMATION]: "Información general",
  [CONTEXT]: "Contexto",
  [CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED]: "La campaña nunca ha sido activada",
  [LOADING_METRICS_FROM_PLATFORMS]: "Cargando métricas...",
  [HOW_IS_YOUR_CAMPAIGN_GOING]: "Recomendaciones de esta Semana",
  [AN_ERROR_OCCURRED_GETTING_THE_REPORT]:
    "Ocurrió un error al generar el reporte, intenta de nuevo más tarde.",
  [AD_ACCOUNTS]: "Cuentas publicitarias",
  [FACEBOOK_PAGES]: "Páginas de Facebook",
  [INSTAGRAM_ACCOUNTS]: "Cuentas  de Instagram",
  [LAST_UPDATE]: "Última actualización",
  [LAST_RECORDED_EVENT_ON]: "Último evento registrado en",
  [NEVER]: "Nunca",
  [PIXEL_HAS_NO_RECORDED_EVENTS]: "El pixel no tiene eventos registrados",
  [IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE]:
    "En unos segundos se activarán tus nuevos beneficios ",
  [RETRIEVING_GENERAL_INFORMATION]:
    "Estamos recuperando la información general de tu cuenta",
  [RETRIEVING_YOUTUBE_CHANNEL]: "Obteniendo canal de YouTube",
  [RETRIEVING_TIKTOK_PROFILE]: "Recuperando perfil de TikTok",
  [RETRIEVING_AD_ACCOUNTS]:
    "Estamos recuperando el listado de cuentas publicitarias",
  [RETRIEVING_FACEBOOK_PAGES]:
    "Estamos recuperando el listado de páginas de Facebook",
  [RETRIEVING_INSTAGRAM_ACCOUNTS]:
    "Estamos recuperando el listado de cuentas de Instagram",
  [ENDING_CONNECTION]: "Finalizando conexión",
  [ESTABLISHING_CONNECTION_WITH_PLATFORM]:
    "Estableciendo conexión con {{platform}}",
  [RETRIEVING_AUTHORIZATION_DATA]: "Recuperando datos de autorización",
  [OPENING_AUTHORIZATION_WINDOW]: "Abriendo ventana de autorización",
  [CONNECTING_CANVA_VERIFYING_AUTHORIZATION]:
    "Verificando la autorización con Canva",
  [CONNECTING_CANVA_LINKING_ACCOUNT]: "Vinculando tu cuenta de Canva",
  [VERIFYING_YOUR_SESSION]: "Verificando tu sesión, por favor espera",
  [GETTING_REQUIRED_INFORMATION]: "Obteniendo información requerida",
  [VERIFYING_PLATFORMS_INFORMATION]:
    "Verificando información de las plataformas",
  [CREATING_CAMPAIGN]: "Creando campaña",
  [CREATING_AD_GROUPS]: "Creando grupos de anuncios",
  [UPLOADING_CONTENTS]: "Subiendo contenido",
  [CREATING_ADS]: "Creando anuncios",
  [SAVING_INFORMATION]: "Guardando información",
  [INACTIVE]: "Inactivo",
  [CUSTOM_EVENT]: "Evento Personalizado",
  [FAST]: "Rápido",
  [EASY]: "Fácil",
  [AUTOMATED]: "Automatizado",
  [FULL_CONTROL]: "Control total",
  [CUSTOMIZE]: "Personalizado",
  [TAILORED]: "A la medida",
  [RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION]:
    "Con audiencias personalizadas activadas, la segmentación manual no es necesaria",
  [CAMPAIGN_CREATED]: "Campaña creada",
  [CAMPAIGN_UPDATED]: "Campaña actualizada",
  [CREATIFY_VIDEO_PREVIEW_CLARIFICATION]:
    "Esta es una vista previa del video. Podría presentar errores de sincronización que se corregirán en la versión final",
  [CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION]:
    "El video no se pudo renderizar debido a un error. Por favor, contáctanos a través del chat de soporte para solucionar este problema y continuar con la campaña",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN]:
    "Estamos renderizando el contenido final. Una vez listo, publicaremos tu campaña",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION]:
    "Estamos renderizando el contenido final. Una vez listo, se descargará automáticamente",
  [COPY]: "Copia",
  [GENERATING_VIDEO_MESSAGE]: "Generando video",
  [TASK_ALERT_ESTIMATED_TIME]: "Tiempo estimado: {{estimatedTime}}",
  [DO_YOU_HAVE_DISCOUNT_CODE]: "¿Tienes un código de descuento?",
  [DISCOUNT_VALUE]: "Valor de descuento",
  [NORMAL_PRICE]: "Precio normal",
  [CONTENT_NUMERATION]: "Contenido {{value}}",
  [WE_CANT_GET_AVATARS]:
    "No pudimos obtener los avatares, por favor intenta de nuevo más tarde",
  [CONTENT_GENERATOR]: "Generador de Contenido",
  [SELECT_BACKGROUND_CONTENT]: "Contenido de Fondo",
  [SELECT_BACKGROUND_CONTENT_CLARIFICATION]:
    "Debes seleccionar al menos 3 contenidos",
  [CUSTOM]: "Personalizado",
  [GETTING_CREATIFY_VIDEO_DATA]: "Obteniendo datos del vídeo",
  [CREDITS]: "Créditos",
  [COINS]: "Monedas",
  [CREDITS_VALUE]: "{{value,number}} Créditos",
  [COST_OF_ACTION]: "Costo de la Acción",
  [COST_OF_CAMPAIGN]: "Costo de Campaña",
  [COST_OF_RESIZE]: "Costo de Redimensiones",
  [CURRENT]: "Actual",
  [CURRENT_BALANCE]: "Saldo Actual",
  [BALANCE_AFTER]: "Saldo Después de la Acción",
  [COINS_VALUE]: "{{value,number}} Monedas",
  [PER_MONTH]: "Por mes",
  [ACTION_CONFIRM_TEXT]:
    "Vas a gastar {{cost,number}} {{type}} realizando esta acción",
  [CURRENT_USAGE_TYPE]: "{{type}} actuales",
  [YOUR_TRIAL_CREDITS_END]: "Tus créditos de prueba vencen el {{date,short}}",
  [YOUR_TRIAL_COINS_END]: "Tus monedas de prueba vencen el {{date,short}}",
  [YOUR_TRIAL_END]: "Tu periodo de prueba ha finalizado",
  [CREATE_DEACTIVATED]: "Crearla desactivada",
  [CREATE_ACTIVATED]: "Crearla activada",
  [EMPTY_TRACKING_IDS_GOOGLE]: "No tienes Google tags creados",
  [REST_CAMPAIGNS]: "Te quedan {{value,number}} campañas para crear",
  [REST_CREATIVES]: "Te quedan {{value,number}} creativos para generar",
  [REST_VIDEOS]: "Te quedan {{value,number}} videos para generar",
  [REST_CREATIVE_SINGULAR]: "Te queda {{value,number}} creativo para generar",
  [REST_VIDEO_SINGULAR]: "Te queda {{value,number}} video para generar",
  [REST_CREDITS]: "Te quedan {{value,number}} créditos",
  [CREATIVES_REMAINING_SHORT]: "Te quedan {{value,number}} creativos",
  [VIDEOS_REMAINING_SHORT]: "Te quedan {{value,number}} videos",
  [CREATIVES_REMAINING_SHORT_SINGULAR]: "Te queda {{value,number}} creativo",
  [SUGGESTED_CREATIVES_COUNT]:
    "Número de Creativos Sugeridos: {{count,number}}",
  [SUGGESTED_CREATIVES_PROGRESS]:
    "{{current,number}}/{{total,number}} sugeridos",
  [VIDEOS_REMAINING_SHORT_SINGULAR]: "Te queda {{value,number}} video",
  [CREDITS_EXPLANATION]: `Con tu plan puedes generar campañas publicitarias, que incluyen:<br/>
  • Gestión multiplataforma.<br/>
  • Segmentación de audiencia por IA.<br/>
  • Selector de ubicaciones por IA.<br/>
  • Textos y copys con IA.<br/>
  • Informes y análisis avanzados con IA.`,
  [COINS_EXPLANATION]: `Las monedas se usan principalmente para generar contenido audiovisual, por ejemplo:<br/>
  • Renderizar o descargar un vídeo generado por IA`,
  [META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION]: `Se llevará a los usuarios al perfil de Instagram seleccionado anteriormente`,
  [ADVERTISER]: "Administrador",
  [MARKETER]: "Media Buyer",
  [VIEWER]: "Viewer",
  [DESIGNER]: "Diseñador",
  [DELETED]: "Eliminado",
  [PASSWORD_CLARIFICATION_IN_EDIT_USER]:
    "Deja en blanco si no deseas cambiarla",
  [CREATED_AT]: "Creada el",
  [CREATED_BY]: "Creada por",
  [MONTHLY]: "Mensual",
  [QUARTERLY]: "Trimestral",
  [SEMIYEARLY]: "Semestral",
  [YEARLY]: "Anual",
  [CPA_CLARIFICATION]:
    "El CPA (Costo por acción) es el costo que has pagado por cada acción que realiza un usuario en función del objetivo de tu campaña. A continuación, se muestran las acciones por las que estás pagando en esta campaña.",
  [MAIN_STATISTIC_CPM_CLARIFICATION]:
    "(CPM) Pagas por cada 1.000 impresiones de tu anuncio, para aumentar la conciencia de tu marca.",
  [MAIN_STATISTIC_CLICK_CLARIFICATION]:
    "(Click) Pagas por cada clic que recibe tu anuncio, para aumentar el tráfico a tu sitio web.",
  [MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION]:
    "(Interacción en la publicación) Pagas por cada interacción que recibe publicación (me gustas, comentarios, compartidos, guardados, etc.), para aumentar la interacción de tu contenido.",
  [MAIN_STATISTIC_LEAD_CLARIFICATION]:
    "(Lead) Pagas por cada cliente potencial que se registra en tu sitio web.",
  [MAIN_STATISTIC_PURCHASE_CLARIFICATION]:
    "(Compra) Pagas por cada compra que se realiza en tu sitio web.",
  [MAIN_STATISTIC_AD_RECALL_CLARIFICATION]:
    "(Recuerdo de anuncio) Pagas por cada persona que recuerda haber visto tu anuncio, para aumentar la conciencia de tu marca.",
  [MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION]:
    "(Vista de video) Pagas por cada reproducción de al menos 6 segundos en tu video publicitario.",
  [MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION]:
    "(Visita a perfil de Instagram) Pagas por cada visita al perfil de Instagram seleccionado anteriormente.",
  [MAIN_STATISTIC_VALUE_CPM_CLARIFICATION]:
    "{{value,number}} impresiones. Pagas por cada 1.000 impresiones de tu anuncio, para aumentar la conciencia de tu marca.",
  [MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION]:
    "{{value,number}} clics. Pagas por cada clic que recibe tu anuncio, para aumentar el tráfico a tu sitio web.",
  [MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION]:
    "{{value,number}} interacciones. Pagas por cada interacción que recibe publicación (me gustas, comentarios, compartidos, guardados, etc.), para aumentar la interacción de tu contenido.",
  [MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION]:
    "{{value,number}} leads. Pagas por cada cliente potencial que se registra en tu sitio web.",
  [MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION]:
    "{{value,number}} compras. Pagas por cada compra que se realiza en tu sitio web.",
  [MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION]:
    "{{value,number}} recuerdos de anuncio. Pagas por cada persona que recuerda haber visto tu anuncio, para aumentar la conciencia de tu marca.",
  [MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION]:
    "{{value,number}} vistas de video. Pagas por cada reproducción de al menos 6 segundos en tu video publicitario.",
  [MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION]:
    "{{value,number}} visitas al perfil de Instagram. Pagas por cada visita al perfil de Instagram seleccionado anteriormente.",
  [ANALYZING_CAMPAIGN_STATISTICS]: "Analizando estadísticas de la campaña",
  [COMPARING_RESULTS_OBTAINED]: "Comparando resultados obtenidos",
  [GENERATING_OPTIMIZATIONS]: "Generando optimizaciones",
  [CAMPAIGN_OPTIMIZED_NAME]: "Optimizada",
  [CAMPAIGN_OPTIMIZED]: "Campaña optimizada",
  [CAMPAIGN_OPTIMIZED_GENERATED]: "Campaña optimizada generada",
  [APPLYING_OPTIMIZATIONS]: "Aplicando optimizaciones",
  [IMPRESSIONS_BY_PLATFORM]: "Impresiones por plataforma",
  [CLICKS_BY_PLATFORM]: "Clicks por plataforma",
  [MAIN_ACTIONS_BY_PLATFORM]: "Resultados por plataforma",
  [CONCLUSION]: "Conclusión",
  [RECOMMENDATIONS]: "Recomendaciones",
  [DAY_COUNT]: "Día {{value,number}}",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY]: "Diariamente",
  [WEEK_COUNT]: "Semana {{value,number}}",
  [EMPTY_STATISTICS_FOR_DETAILED_REPORT]:
    "No hay suficientes datos y estadísticas para generar un reporte",
  [LOCATIONS_TIK_TOK_EMPTY]:
    "No se encontraron ubicaciones relevantes, puede que no estén disponibles en TikTok o especificamente para el país de tu cuenta. Más información <a href='https://ads.tiktok.com/help/article/placements-available-locations?aadvid=7375164243290914833' target='_blank' style='text-decoration: underline'>aquí</a>",
  [PRODUCT_OR_SERVICE_CONTEXT]: "Producto o servicio a promocionar",
  [TARGET_AUDIENCE_CONTEXT]: "Público objetivo al que deseas llegar",
  [GREETING]: "Saludo",
  [FIRST_USER_MESSAGE]: "Primer Mensaje del Usuario",
  [IS_CAROUSEL]: "Es carrusel",
  [CARD]: "Tarjeta",
  [FORM]: "Formulario",
  [FORMS]: "Formularios",
  [ANSWER]: "Respuesta",
  [ANSWERS]: "Respuestas",
  [GOOGLE_PHRASE_KEYWORD]: "Concordancia de frases",
  [GOOGLE_PHRASE_KEYWORD_EXPLANATION]: `Mostrará anuncios cuando la busqueda de un usuario incluya al menos el significado de su palabra clave. El formato de este tipo es la palabra clave entre comillas ("palabra clave")`,
  [GOOGLE_EXACT_KEYWORD]: "Concordancia exacta",
  [GOOGLE_EXACT_KEYWORD_EXPLANATION]:
    "Mostrará anuncios cuando la busqueda de un usuario incluye la palabra clave exacta o una variante cercana que incluya el significado o la intención. El formato de este tipo es la palabra clave entre corchetes ([palabra clave])",
  [GOOGLE_BROAD_KEYWORD]: "Concordancia amplia",
  [GOOGLE_BROAD_KEYWORD_EXPLANATION]:
    "Mostrará anuncios cuando la busqueda de un usuario incluye sinónimos, variantes e intenciones similares a la palabra clave. El formato de este tipo es la palabra clave sin nada más (keyword)",
  [GOOGLE_KEYWORDS_EXPLANATION]: `Las palabras clave son términos o frases que se utilizan para mostrar anuncios a las personas que buscan algo en línea. Existen tres tipos de palabras clave: <br/><br/>
  <strong>Concordancia exacta:</strong> Mostrará anuncios cuando la busqueda de un usuario incluye la palabra clave exacta o una variante cercana que incluya el significado o la intención. El formato de este tipo es la palabra clave entre corchetes ([palabra clave])<br/><br/>
  <strong>Concordancia de frases:</strong> Mostrará anuncios cuando la busqueda de un usuario incluya al menos el significado de su palabra clave. El formato de este tipo es la palabra clave entre comillas ("palabra clave")<br/><br/>
  <strong>Concordancia amplia:</strong> Mostrará anuncios cuando la busqueda de un usuario incluye sinónimos, variantes e intenciones similares a la palabra clave. El formato de este tipo es la palabra clave sin nada más (keyword)`,
  [GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION]: `Las palabras clave negativas son términos o frases que se utilizan en publicidad digital para evitar que los anuncios se muestren en búsquedas irrelevantes. Al agregar palabras clave negativas, se impide que los anuncios aparezcan cuando los usuarios buscan esos términos específicos, lo que ayuda a mejorar la relevancia de los anuncios, reducir costos y aumentar la tasa de conversión. Existen tres tipos de palabras clave: <br/><br/>
  <strong>Concordancia exacta:</strong> Mostrará anuncios cuando la busqueda de un usuario incluye la palabra clave exacta o una variante cercana que incluya el significado o la intención. El formato de este tipo es la palabra clave entre corchetes ([palabra clave])<br/><br/>
  <strong>Concordancia de frases:</strong> Mostrará anuncios cuando la busqueda de un usuario incluya al menos el significado de su palabra clave. El formato de este tipo es la palabra clave entre comillas ("palabra clave")<br/><br/>
  <strong>Concordancia amplia:</strong> Mostrará anuncios cuando la busqueda de un usuario incluye sinónimos, variantes e intenciones similares a la palabra clave. El formato de este tipo es la palabra clave sin nada más (keyword)`,
  [GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL]: "Tipo de Grupo de Anuncios",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD]: "Estándar",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_DSA]: "Anuncios Dinámicos de Búsqueda",
  [GOOGLE_WEBPAGE_CRITERIA_TITLE]: "Criterios de Página Web",
  [GOOGLE_WEBPAGE_CRITERIA_EXPLANATION]:
    "Define qué páginas de tu sitio indexado pueden mostrar anuncios en este grupo (por ejemplo URL igual a o URL contiene). Añade al menos un criterio.",
  [GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL]: "Regla",
  [GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL]: "URL o texto",
  [GOOGLE_WEBPAGE_CRITERION_URL_EQUALS]: "URL igual a",
  [GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS]: "URL contiene",
  [FIELD_WEBPAGE_CRITERIA_REQUIRED]:
    "Añade al menos un criterio de página para grupos de anuncios DSA.",
  [FIELD_WEBPAGE_CRITERIA_REPEATED]:
    "Criterios de página duplicados: {{value}}",
  [GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS]:
    "Los grupos DSA usan criterios de página en lugar de palabras clave positivas.",
  [GOOGLE_DSA_SETTINGS_TITLE]:
    "Configuración de anuncios dinámicos de búsqueda",
  [GOOGLE_DSA_SETTINGS_EXPLANATION]:
    "Obligatorio cuando algún grupo de anuncios usa Anuncios dinámicos de búsqueda. Google usa este dominio para generar anuncios automáticamente.",
  [GOOGLE_DSA_DOMAIN_LABEL]: "Dominio",
  [GOOGLE_DSA_LANGUAGE_LABEL]: "Idioma",
  [GOOGLE_WEBPAGES_NOT_ADDED]: "No hay criterios de página añadidos",
  [GOOGLE_WEBPAGE_ADD_TITLE]: "Añadir URL",
  [GOOGLE_WEBPAGE_EDIT_TITLE]: "Editar URL",
  [GOOGLE_WEBPAGE_URL_LABEL]: "URL",
  [COLUMN_NAME_URL]: "URL",
  [ALERT_DELETE_WEBPAGE_TITLE]: "¿Eliminar página web?",
  [ALERT_DELETE_WEBPAGE_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar este criterio de página?",
  [ALERT_DELETE_WEBPAGES_TITLE]: "¿Eliminar páginas web?",
  [ALERT_DELETE_WEBPAGES_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar {{value}} criterios de página?",
  [GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH]: "Búsqueda de Google",
  [GOOGLE_NETWORK_SETTING_SEARCH_NETWORK]: "Red de búsquedas de Google",
  [GOOGLE_NETWORK_SETTING_CONTENT_NETWORK]: "Red de Display de Google",
  [GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK]:
    "Red de búsqueda de socios de Google",
  [TOP_KEYWORDS]: "Top Keywords",
  [BETA]: "Beta",
  [PROCESSING_MEDIA_TO_USE]: "Procesando el contenido para usarlo",
  [SAVING_MEDIA]: "Guardando el contenido",
  [TUTORIAL]: "Tutorial",
  [SELECT_RANGE_DATE]: "Selecciona un rango de fechas",
  [TO]: "a",
  [MONTH_COUNT]: "Mes {{value,number}}",
  [WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN]:
    "Describe cómo deseas enfocar la campaña. Ejemplo: Esta campaña busca destacar el producto X como una solución práctica para equipos que necesitan ahorrar tiempo y reducir tareas manuales.",
  [TITLE_CAMPAIGN_INSTRUCTIONS]: "Temática o Instrucciones de Campaña",
  [DOCUMENTS_ATTACHMENT_LABEL]: "Agregar archivos",
  [FILE_UPLOADED]: "CARGADO",
  [ADD_PLATFORMS]: "Agregar Plataformas",
  [ERROR_GENERATING_CAMPAIGN]: "Ocurrió un error generando la campaña",
  [THIS_ITEM_HAS_ERRORS]: "Esta sección tiene errores",
  [INDIVIDUAL]: "Individual",
  [CAROUSEL]: "Carrusel",
  [RADIUS]: "Radio",
  [AROUND]: "Alrededor",
  [ADVANTAGE_ENHANCES_ACTIVE_COUNT]: "{{active}}/{{total}} Mejoras activas",
  [WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS]: "Sincronizando datos",
  [OPTIONAL]: "Opcional",
  [KEYWORDS_NOT_ADDED]: "No hay palabras clave añadidas",
  [KEYWORDS_NEGATIVE_NOT_ADDED]: "No hay palabras clave negativas añadidas",
  [ENTER_ONE_KEYWORD_PER_LINE]: "Ingresa una palabra clave por linea",
  [KEYWORDS]: "Palabras clave",
  [KEYWORDS_NEGATIVE]: "Palabras clave negativas",
  [TOTAL_IMPRESSIONS]: "Impresiones Totales",
  [TOTAL_CLICKS]: "Clicks Totales",
  [TOTAL_CLICK]: "Click total",
  [TOTAL_RESULTS]: "Resultados Totales",
  [TOTAL_SPEND]: "Gasto Total",
  [AVERAGE_CTR]: "CTR Promedio",
  [TOTAL_ROAS_GOOGLE]: "Google ROAS",
  [TOTAL_ROAS_TIK_TOK]: "TikTok ROAS",
  [TOTAL_ROAS_META]: "Meta ROAS",
  [CUSTOM_AUDIENCES]: "Audiencias personalizadas",
  [CREATIVE]: "Creativo",
  [SELECTED]: "Seleccionadas",
  [ROAS]: "ROAS",
  [FORECAST]: "Forecast",
  [ACTION]: "Acción",
  [DELETE]: "Eliminar",
  [INSIGHTS]: "Insights",
  [INSIGHT]: "Insight",
  [CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT]:
    "Aquí puedes cambiar el creativo para aplicar el insight",
  [PRESS_ENTER_TO_ADD_OPTION]: "Presiona enter para añadir",
  [GOOGLE_SEARCH]: "Google Search",
  [GOOGLE_P_MAX]: "Google PMax",
  [GOOGLE_APP]: "Google App Install",
  [YOUTUBE_VIDEO_LINK]: "YouTube Video URL",
  [DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT]:
    "¿No tienes el vídeo subido a YouTube? Súbelo ahora",
  [YOUTUBE_VIDEO_SOURCE_YOUTUBE]: "YouTube",
  [YOUTUBE_VIDEO_SOURCE_GALLERY]: "Galería",
  [YOUTUBE_VIDEO_SOURCE_URL]: "URL",
  [MODAL_GALLERY_YOUTUBE_TITLE]: "Seleccionar Vídeos de YouTube",
  [MODAL_GALLERY_YOUTUBE_EMPTY]:
    "No se encontraron vídeos públicos en este canal",
  [BUTTON_SELECT_FROM_YOUTUBE]: "Seleccionar de YouTube",
  [BUTTON_PUBLISH_VIDEO_ON_YOUTUBE]: "Publicar Vídeo en YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE]: "Subir Vídeo a YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "El vídeo debe durar entre {{min}} y {{max}} segundos. Selecciona otro vídeo.",
  [REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `Al menos una imagen cuadrada (Medidas recomendadas 1200px x 1200px)<br/>
Al menos una imagen horizontal (Medidas recomendadas 1200px x 628px)`,
  [REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE]:
    "<b>Al menos una imagen cuadrada</b> (Medidas recomendadas 1200px x 1200px)",
  [REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE]:
    "<b>Al menos una imagen horizontal</b> (Medidas recomendadas 1200px x 628px)",
  [REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `La duración del video debe ser de mínimo 10 segundos y máximo 60 segundos.`,
  [CAMPAIGNS_NOT_FOUND]: "No se encontraron campañas",
  [CAMPAIGNS_TABLE_EXPAND_ROW]: "Desplegar grupos de anuncios",
  [CAMPAIGNS_TABLE_COLLAPSE_ROW]: "Contraer grupos de anuncios",
  [CAMPAIGNS_TABLE_EXPAND_GROUP]: "Desplegar anuncios",
  [CAMPAIGNS_TABLE_COLLAPSE_GROUP]: "Contraer anuncios",
  [CAMPAIGNS_TABLE_TREE_EMPTY]:
    "Esta campaña no tiene grupos de anuncios ni anuncios",
  [CAMPAIGNS_TABLE_TREE_ERROR]: "No se pudieron cargar los grupos de anuncios",
  [CAMPAIGNS_TABLE_TREE_METRICS_ERROR]:
    "No se pudieron cargar las métricas de los grupos y anuncios",
  [CAMPAIGNS_TABLE_TREE_ADS_EMPTY]: "Este grupo no tiene anuncios",
  [CAMPAIGNS_TABLE_SHOW_MORE_ADS]: "Ver {{count}} más",
  [CAMPAIGN_SELECTED]: "Campaña seleccionada",
  [ALREADY_IMPORTED]: "Ya existe",
  [CREATE_A_CAMPAIGN]: "Crea una Campaña",
  [CREATE_A_CAMPAIGN_FOR_BRAND_NAME]: "Crea una Campaña para {{value}}",
  [COPY_VALUE_IN_OTHER_ADS]: "Copiar valor en otros anuncios",
  [COPY_VALUES_IN_OTHER_ADS]: "Copiar valores en otros anuncios",
  [COPY_VALUE_IN_OTHER_ADGROUPS]: "Copiar valor en otros grupos",
  [COPY_VALUES_IN_OTHER_ADGROUPS]: "Copiar valores en otros grupos",
  [GETTING_METRICS]: "Obteniendo métricas",
  [GENERATING_REPORT]: "Generando reporte",
  [EXPORT_COPIES_TO_GOOGLE_DRIVE]: "Exportar textos a Google Drive",
  [COPIES_OF_AD]: "Textos de anuncio",
  [ALL_COPIES_OF_PLATFORM]: "Todos los textos de {{platform}}",
  [CONFIGURED_SITE_LINKS]: "{{value,number}} enlaces de sitio configurados",
  [FIRST_USER_MESSAGE_BRAND_SETUP]:
    "Has configurado correctamente tu marca, ahora puedes crear contenido para tu marca y lanzar campañas publicitarias",
  [DATA_TYPE_CONTACT_INFORMATION_OPTION]:
    "Emails, Teléfonos y/o Direcciones de correo",
  [DATA_TYPE_CRM_ID_OPTION]: "IDs de usuario",
  [ALL_CUSTOMERS]: "Todos los clientes",
  [PURCHASERS]: "Compradores",
  [HIGH_VALUE_CUSTOMERS]: "Clientes de alto valor",
  [DISENGAGED_CUSTOMERS]: "Clientes desenganchados",
  [QUALIFIED_LEADS]: "Leads calificados",
  [CONVERTED_LEADS]: "Leads convertidos",
  [PAID_SUBSCRIBERS]: "Suscriptores pagos",
  [LOYALTY_SIGN_UPS]: "Suscriptores de lealtad",
  [CART_ABANDONERS]: "Carritos abandonados",
  [NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE]:
    "No se encontraron encabezados válidos en el archivo subido, por favor no modifiques los encabezados de la plantilla",
  [WITH_OUT_PLAN]: "Sin plan",
  [CONFIRMATION_USAGE_TEXT]: "¿Estás seguro de realizar esta acción?",
  [SQUARE_FORMAT]: "Formato cuadrado",
  [VERTICAL_FORMAT]: "Formato vertical",
  [HORIZONTAL_FORMAT]: "Formato horizontal",
  [RESIZE_TO_SQUARE]: "Redimensionar a Cuadrado",
  [RESIZE_TO_VERTICAL]: "Redimensionar a Vertical",
  [RESIZE_TO_HORIZONTAL]: "Redimensionar a Horizontal",
  [RESIZE_TO_FEED]: "Redimensionar a 4:5 (Instagram)",
  [RESIZE_CUSTOM]: "Redimensión Personalizada",
  [MODAL_RESIZE_CUSTOM_TITLE]: "Redimensionar Imagen",
  [MODAL_RESIZE_CUSTOM_DESCRIPTION]:
    "Indica el ancho y alto en píxeles para redimensionar la imagen.",
  [MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL]: "Tamaño predefinido",
  [ERROR_RESIZE_DIMENSION_INVALID]: "Ingresa un valor válido mayor que 0",
  [ERROR_RESIZE_DIMENSION_MAX_EDGE]: "Máximo {{max, number}} px por lado",
  [ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX]:
    "Debe ser múltiplo de 16. Sugerido:",
  [ERROR_RESIZE_DIMENSION_OR]: "o",
  [ERROR_RESIZE_TOTAL_TOO_SMALL]:
    "{{total, number}} px² — demasiado pequeño. Mínimo {{min, number}} px² totales.",
  [ERROR_RESIZE_TOTAL_TOO_LARGE]:
    "{{total, number}} px² — demasiado grande. Máximo {{max, number}} px² totales.",
  [ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX]:
    "La proporción debe ser 3:1 o menor.",
  [ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION]:
    "Escoge alguna de las siguientes opciones:",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX]: "Ajustar ancho a",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX]: "(mantener alto)",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX]: "Ajustar alto a",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX]: "(mantener ancho)",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID]:
    "El ancho y el alto deben ser números positivos.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16]:
    "El ancho debe ser múltiplo de 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16]:
    "El alto debe ser múltiplo de 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED]:
    "El tamaño personalizado supera el máximo de {{max, number}} px por lado.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED]:
    "La proporción del tamaño personalizado debe ser 3:1 o menor.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS]:
    "El tamaño personalizado es demasiado pequeño. Mínimo {{min, number}} px² totales.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS]:
    "El tamaño personalizado es demasiado grande. Máximo {{max, number}} px² totales.",
  [BUTTON_RESIZE_IMAGE]: "Redimensionar",
  [RESIZE_MENU_LABEL]: "Redimensionar",
  [RESIZING_IMAGES_BATCH_MESSAGE]: "Redimensionando imágenes",
  [MULTI_FORMAT_RESIZE_FORMATS_COUNT]: "{{count}} formatos",
  [MULTI_FORMAT_RESIZE_CREDITS_COUNT]: "{{count}} créditos",
  [MULTI_FORMAT_RESIZE_ONE_FORMAT]: "1 formato",
  [MULTI_FORMAT_RESIZE_ONE_CREDIT]: "1 crédito",
  [MODAL_BATCH_IMAGE_EDIT_TITLE]: "Edita tus Imágenes",
  [MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL]: "Versión {{version, number}}",
  [MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER]:
    "Escribe la instrucción para todos...",
  [MODAL_BATCH_IMAGE_EDIT_GENERATE]: "Generar",
  [MODAL_BATCH_IMAGE_EDIT_APPLY]: "Aplicar",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING]: "Pendiente",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS]: "Listo",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR]: "Error",
  [MODAL_BATCH_IMAGE_EDIT_RETRY]: "Reintentar",
  [MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE]: "Falló",
  [MODAL_BATCH_IMAGE_EDIT_EXPAND]: "Expandir",
  [MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID]: "Volver al grid",
  [MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION]: "Editar con IA",
  [MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT]: "Creativo en edición por lotes",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE]:
    "¿Cómo quieres guardar estas imágenes?",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "Puedes reemplazar las imágenes originales o crear nuevas versiones con tus cambios.",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Guardar como Nuevas",
  [MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON]: "Reemplazar",
  [EDIT_WITH_CANVA]: "Editar con Canva",
  [EDIT_WITH_IA]: "Editar",
  [ANIMATE_IMAGE_WITH_AI]: "Animar Imagen con IA",
  [ANIMATE]: "Animar",
  [ANIMATE_IMAGE_CONFIRMATION_TITLE]: "Información",
  [ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION]:
    "Se gastarán 15 créditos para realizar esta acción. ¿Deseas continuar?",
  [MODAL_ANIMATE_IMAGE_PREVIEW_TITLE]: "Animar Imagen con IA",
  [MODAL_ANIMATE_IMAGE_PROMPT_LABEL]: "Instrucciones de animación (opcional)",
  [MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER]:
    "ej. mueve suavemente los productos, agrega una ondulación suave en los colores de fondo...",
  [MODAL_ANIMATE_IMAGE_PROMPT_HELPER]:
    "Déjalo vacío para una animación natural por defecto.",
  [MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH]:
    "Máximo {{max}} caracteres ({{current}}/{{max}})",
  [ANIMATE_IMAGE_OUTRO_LABEL]: "Video de outro (opcional)",
  [ANIMATE_IMAGE_OUTRO_HELPER]: "Se añade al final de cada video generado.",
  [ANIMATE_IMAGE_OUTRO_NONE]: "Sin video de outro.",
  [ANIMATE_IMAGE_SAVE_OUTRO]: "Guardar video de outro",
  [ANIMATE_IMAGE_SAVE_OUTRO_TITLE]: "Guardar video de outro",
  [ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS]: "Video de outro guardado",
  [ANIMATE_IMAGE_SAVE_OUTRO_ERROR]: "No se pudo guardar el video de outro.",
  [ANIMATE_IMAGE_OUTRO_FILE]: "Seleccionar video",
  [ANIMATE_IMAGE_OUTRO_FILE_HINT]:
    "MP4, MOV o WEBM. Máximo {{seconds}} segundos y {{size}} MB.",
  [ANIMATE_IMAGE_IMPORT_OUTRO]: "Videos de outro",
  [ANIMATE_IMAGE_IMPORT_OUTRO_TITLE]: "Videos de outro",
  [ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY]: "No hay videos de outro guardados.",
  [ANIMATE_IMAGE_IMPORT_OUTRO_ERROR]:
    "No se pudieron cargar los videos de outro.",
  [ANIMATE_IMAGE_DELETE_OUTRO]: "Eliminar video de outro",
  [ANIMATE_IMAGE_DELETE_OUTRO_ERROR]: "No se pudo eliminar el video de outro.",
  [ANIMATE_IMAGE_OUTRO_CLEAR]: "Quitar outro",
  [ANIMATE_IMAGE_OUTRO_TOO_LARGE]:
    "El video supera el tamaño máximo de {{size}} MB.",
  [ANIMATE_IMAGE_OUTRO_TOO_LONG]: "El video supera los {{seconds}} segundos.",
  [ANIMATE_IMAGE_OUTRO_INVALID_TYPE]:
    "El archivo debe ser un video MP4, MOV o WEBM.",
  [ANIMATE_IMAGE_USE_SELECTED]: "Usar",
  [SELECT_CONTENT_CONFIRMATION_TEXT]: "¿Deseas seleccionar este contenido?",
  [FORMAT_OPTIONS_TOOLTIP]: "Opciones de formato",
  [CHANGES]: "Cambios",
  [EMPTY_CHANGES]: "No hay cambios para mostrar",
  [AD_GROUPS]: "Grupos de anuncios",
  [ADS]: "Anuncios",
  [ASSETS_GROUPS]: "Grupos de activos",
  [ADDED]: "Agregó",
  [REMOVED]: "Eliminó",
  [IT_WAS_CREATED]: "Se creó",
  [HISTORICAL_CHANGES]: "Cambios históricos",
  [LOG_GROUP_AUDIENCE_NETWORK]: "Audience Network",
  [LOG_GROUP_FEEDS]: "Feeds",
  [LOG_GROUP_REELS_STORIES]: "Reels/Stories",
  [STATUS_DEACTIVATED]: "Desactivado",
  [STATUS_ACTIVE]: "Activo",
  [STATUS_FINISHED]: "Finalizado",
  [N_NUMBER_SELECTED]: "{{value,number}} Seleccionados",
  [FILTER_BY_STATUS]: "Filtrar por estado",
  [SELECT_CATALOG_IN_CAMPAIGN_LEVEL]:
    "Primero elecciona un catálogo en la configuración",
  [INTRO_CARD]: "Tarjeta de introducción",
  [CATALOG_CARD]: "Tarjeta de catálogo",
  [PROFILE_CARD]: "Tarjeta de perfil",
  [SINGLE_IMAGE]: "Imagen única",
  [SLIDES_SHOW]: "Diapositivas",
  [MODIFY_CATALOG_LABELS]: "Modificar etiquetas de catálogo",
  [MODIFY_PRODUCT_TAGS]: "Modificar etiquetas de producto",
  [SOLID]: "Sólido",
  [TRANSPARENT]: "Transparente",
  [AUTOMATIC_LABELS]: "Etiquetas automáticas",
  [MANUAL_LABEL]: "Etiqueta manual",
  [RECTANGLE]: "Rectángulo",
  [PILL]: "Pill",
  [CIRCLE]: "Círculo",
  [TRIANGLE]: "Triángulo",
  [TOP_LEFT]: "Arriba a la izquierda",
  [TOP_RIGHT]: "Arriba a la derecha",
  [BOTTOM_LEFT]: "Abajo a la izquierda",
  [BOTTOM_RIGHT]: "Abajo a la derecha",
  [AUTOMATICALLY_TAG_PRODUCTS]: "Mostrar etiquetas de productos",
  [INSTANT_EXPERIENCE]: "Experiencia instantánea",
  [FILTER_BY_NAME]: "Filtrar por nombre",
  [ALL_PRODUCTS]: "Todos los productos",
  [USE_A_SELECTION_OF_PRODUCTS]: "Usar una selección de productos",
  [SELECT_PRODUCTS_BY]: "Seleccionar productos por",
  [CONDITION]: "Condición",
  [PRODUCT_TYPE]: "Tipo de producto",
  [CHANNEL]: "Canal",
  [CUSTOM_LABEL]: "Etiqueta personalizada",
  [CONDITION_NEW]: "Nuevo",
  [CONDITION_USED]: "Usado",
  [CONDITION_REFURBISHED]: "Reacondicionado",
  [CHANNEL_ONLINE]: "En línea",
  [CHANNEL_LOCAL]: "Local",
  [ITEM_ID]: "Item ID",
  [SELECT_ALL]: "Seleccionar todos",
  [RECOMMENDED_ACTIONS]: "Acciones recomendadas",
  [DAY_SLASH_TIME]: "Día/Hora",
  [DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD]:
    "Arrastra el mouse para seleccionar el periodo de tiempo",
  [SELECTED_TIME_PERIOD]: "Periodo de tiempo seleccionado",
  [NO_SELECTION]: "No hay selección",
  [USER_TIMEZONE]: "Zona horaria del usuario",
  [AD_ACCOUNT_TIMEZONE]: "Zona horaria de la cuenta publicitaria",
  [GOOGLE_ORIGIN_APP]: "Aplicación",
  [GOOGLE_ORIGIN_CALL_FROM_ADS]: "Llamada Desde Anuncios",
  [GOOGLE_ORIGIN_GOOGLE_HOSTED]: "Alojado Por Google",
  [GOOGLE_ORIGIN_STORE]: "Tienda",
  [GOOGLE_ORIGIN_WEBSITE]: "Sitio Web",
  [GOOGLE_ORIGIN_YOUTUBE_HOSTED]: "Alojado Por YouTube",
  [GOOGLE_CATEGORY_ADD_TO_CART]: "Agregar Al Carrito",
  [GOOGLE_CATEGORY_BEGIN_CHECKOUT]: "Iniciar Compra",
  [GOOGLE_CATEGORY_BOOK_APPOINTMENT]: "Reservar Cita",
  [GOOGLE_CATEGORY_CONTACT]: "Contacto",
  [GOOGLE_CATEGORY_CONVERTED_LEAD]: "Lead Convertido",
  [GOOGLE_CATEGORY_DEFAULT]: "Predeterminado",
  [GOOGLE_CATEGORY_DOWNLOAD]: "Descarga",
  [GOOGLE_CATEGORY_ENGAGEMENT]: "Compromiso",
  [GOOGLE_CATEGORY_GET_DIRECTIONS]: "Obtener Direcciones",
  [GOOGLE_CATEGORY_IMPORTED_LEAD]: "Lead Importado",
  [GOOGLE_CATEGORY_OUTBOUND_CLICK]: "Clic Saliente",
  [GOOGLE_CATEGORY_PAGE_VIEW]: "Vista De Página",
  [GOOGLE_CATEGORY_PHONE_CALL_LEAD]: "Lead Por Llamada Telefónica",
  [GOOGLE_CATEGORY_PURCHASE]: "Compra",
  [GOOGLE_CATEGORY_QUALIFIED_LEAD]: "Lead Calificado",
  [GOOGLE_CATEGORY_REQUEST_QUOTE]: "Solicitar Cotización",
  [GOOGLE_CATEGORY_SIGNUP]: "Registro",
  [GOOGLE_CATEGORY_STORE_SALE]: "Venta En Tienda",
  [GOOGLE_CATEGORY_STORE_VISIT]: "Visita A Tienda",
  [GOOGLE_CATEGORY_SUBMIT_LEAD_FORM]: "Enviar Formulario De Lead",
  [GOOGLE_CATEGORY_SUBSCRIBE_PAID]: "Suscripción Pagada",
  [TRACKING_WEBSITE_EVENTS]: "Eventos de Sitio Web",
  [TRACKING_EVENTS]: "Seguimiento de Eventos",
  [VALID]: "Válida",
  [INVALID]: "Inválida",
  [NOT_READY]: "No Lista",
  [INSIGHT_APPLIED]: "Insight Aplicado",
  [INSIGHT_DISCARDED]: "Insight Descartado",
  [MAXIMIZE_CONVERSIONS]: "Maximizar Conversiones",
  [MAXIMIZE_CONVERSION_VALUE]: "Maximizar Valor de Conversión",
  [IN_CURRENCY]: "en {{currency}}",
  [TARGET_CPA_EXPLANATION]:
    "Establece el costo promedio que deseas pagar por cada resultado.",
  [BID_GOAL_EXPLANATION]:
    "Define la cantidad máxima que estás dispuesto a pagar por cada puja.",
  [OPTIMIZATION_GOAL_CONVERSATIONS]: "Pagarás por Conversaciones.",
  [OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE]: "Pagarás por Visitas al Perfil.",
  [OPTIMIZATION_GOAL_LINK_CLICKS]: "Pagarás por Clics.",
  [OPTIMIZATION_GOAL_THRUPLAY]: "Pagarás por Reproducciones Completas.",
  [OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS]:
    "Pagarás por Visitas a la Página de Destino.",
  [OPTIMIZATION_GOAL_OPTION_REACH]: "Alcance",
  [OPTIMIZATION_GOAL_OPTION_THRUPLAY]:
    "Mayor tiempo de visualización de vídeo (ThruPlay)",
  [OPTIMIZATION_GOAL_OPTION_LINK_CLICKS]: "Clics en el enlace",
  [OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS]:
    "Visitas a la página de destino",
  [OPTIMIZATION_GOAL_PLACEHOLDER]: "Optimizar Para",
  [OPTIMIZATION_GOAL_POST_ENGAGEMENT]: "Pagarás por Interacción.",
  [OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS]: "Pagarás por Conversiones.",
  [OPTIMIZATION_GOAL_LEAD_GENERATION]: "Pagarás por Generación de Leads.",
  [OPTIMIZATION_GOAL_APP_INSTALLS]: "Pagarás por Instalaciones de Aplicación.",
  [OPTIMIZATION_GOAL_CPM]: "Pagarás por Mil Impresiones.",
  [OPTIMIZATION_GOAL_CLICK_TO_APP]: "Pagarás por Clics a la Aplicación.",
  [OPTIMIZATION_GOAL_CONVERSION_IN_APP]:
    "Pagarás por Conversiones en la Aplicación.",
  [SYNCING_INFORMATION_NO_EDIT_CLARIFICATION]:
    "Sincronizando campaña, espera antes hacer cambios",
  [WAIT_FOR_CAMPAIGN_SYNC]: "Espera a que se sincronice la campaña",
  [BRAND_GUIDELINES_ENABLED_CLARIFICATION]:
    "Está activo los lineamientos de marca para esta campaña, por lo que no puedes modificar este campo directamente.",
  [METRICS]: "Métricas",
  [TIMES_EVERY]: "Veces Cada",
  [FREQUENCY_CAP_EXPLANATION]:
    "Como máximo, intentaremos mantenerse por debajo de {{value}} impresiones cada {{interval}} días",
  [FREQUENCY_TARGET_EXPLANATION]:
    "Para ayudar a lograr tu objetivo, intentaremos entregar aproximadamente {{value}} impresiones cada {{interval}} días.",
  [TARGET]: "Objetivo",
  [TARGET_FREQUENCY_EXPLANATION]:
    "El número promedio de veces que quieres que la gente vea tus anuncios",
  [CAP]: "Máximo",
  [CAP_FREQUENCY_EXPLANATION]:
    "El número máximo de veces que quieres que la gente vea tus anuncios",
  [FREQUENCY_SPECS_CONTROL_PLACEHOLDER]: "Control de Frecuencia",
  [FREQUENCY_SPECS_CAP_EXPLANATION]:
    "El número máximo de veces que quieres que la gente vea tus anuncios",
  [FREQUENCY_SPECS_CAP_DESCRIPTION]:
    "Como máximo, nuestro objetivo será mantenernos por debajo de {{maxFrequency}} impresiones cada {{intervalDays}} días",
  [RESERVATION_ESTIMATES]: "Estimaciones de Reservación",
  [AUDIENCE_ESTIMATES]: "Estimaciones de Audiencia",
  [LOADING_LOCATIONS_IN_MAP]: "Cargando Ubicaciones en el Mapa",
  [EXPORTING_LOCATIONS_TO_FORM]: "Configurando Ubicaciones...",
  [SUGGESTED_LOCATIONS_TITLE]: "Ubicaciones Sugeridas",
  [LOADING_SUGGESTED_LOCATIONS]: "Cargando Ubicaciones Sugeridas...",
  [SUGGESTED_LOCATIONS_COUNT]: "{{count}} sugeridas",
  [ADD_ALL_LOCATIONS]: "Agregar todas",
  [ESTIMATED_DAILY_REACH]: "Alcance Diario Estimado",
  [AVERAGE_AUDIENCE_SIZE]: "Tamaño de Audiencia Promedio",
  [NO_ESTIMATION_AVAILABLE]: "Estimación no Disponible",
  [ALL_USERS]: "Todos los Usuarios",
  [ALL_TIME]: "Todo el Tiempo",
  [APPLY_OPTIMIZATIONS_WITH_NAME]: `Aplicar la optimización "{{value}}"`,
  [DISCONNECTED_ACCOUNT]: "Cuenta Desconectada",
  [CAMPAIGN_ALREADY_BEING_CREATED]:
    "La campaña ya se está creando desde otro dispositivo/pestaña",
  [CAMPAIGN_ALREADY_BEING_UPDATED]:
    "La campaña ya se está actualizando desde otro dispositivo/pestaña",
  [UNKNOWN_VALUE]: "Valor Desconocido",
  [VIDEO]: "Video",
  [IMAGE]: "Imagen",
  [CAMPAIGNS]: "Campañas",
  [TEXT_IN_IMAGE]: "Texto en la Imagen",
  [VIDEO_LANGUAGE]: "Lenguaje del Video",
  [LOGO_IN_IMAGE]: "Logo en la Imagen",
  [LOGO_IN_VIDEO]: "Logo en el Video",
  [LOGO_IN_VIDEO_DESCRIPTION_LEAD]: "El logo aparecerá al final del video.",
  [I_DONT_HAVE_A_WEBSITE]: "No tengo un sitio web",
  [SET_UP_BRAND]: "Configurar Marca",
  [OVERLAPS_WITH]: "Se superpone a",
  [GENERATION_FAILED]: "Generación Fallida",
  [YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS]:
    "Tu campaña tiene algunas desaprobaciones",
  [ANALYZING_CONTENT]:
    "Analizando el contenido para generar recomendaciones ...",
  [CONTENT_WARNING_TITLE]: "Advertencia de Contenido",
  [CONTENT_RECOMMENDATIONS_SUBTITLE]:
    "Recomendamos agregar los siguientes formatos de contenido para mejor rendimiento",
  [CONTENT_RECOMMENDATIONS]: "Recomendaciones de Contenido",
  [CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA]:
    "Usar esta recomendación en Crear con IA",
  [NO_CONTENT_RECOMMENDATIONS]:
    "No se encontraron recomendaciones de contenido",
  [CONTENT_RECOMMENDATIONS_BANNER_TITLE]: "Recomendaciones de Contenidos",
  [CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION]:
    "Detectamos ángulos creativos que le podrían funcionar a tu campaña. Genéralos en un clic.",
  [CONTENT_RECOMMENDATIONS_VIEW_ALL]: "Ver todas ({{count,number}})",
  [CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS]:
    "{{completed,number}} de {{total,number}} generadas",
  [CONTENT_RECOMMENDATION_GENERATED]: "Generada",
  [CONTENT_RECOMMENDATION_GENERATE_ARIA]: "Generar: {{text}}",
  [CONTENT_RECOMMENDATIONS_ALL_COMPLETED]:
    "¡Listo! Agregaste todas las recomendaciones",
  [BAD]: "Malo",
  [REGULAR]: "Regular",
  [GOOD]: "Bueno",
  [VERY_GOOD]: "Muy Bueno",
  [EXCELLENT]: "Excelente",
  [FIELD]: "Campo",
  [ID_PLATFORM]: "{{value}} ID",

  /*PAYMENTS*/
  [SELECT_PAYMENT_METHOD]: "Seleccionar Método de Pago",
  [ADD_PAYMENT_METHOD]: "Agregar Método de Pago",
  [PAYMENT_METHOD]: "Método de Pago",
  [PAYMENT_METHODS]: "Métodos de Pago",
  [PAYMENT_METHODS_EMPTY]: "No hay métodos de pago, añade uno",
  [MAIN_PAYMENT_METHOD]: "Método de Pago Principal",
  [OTHERS_PAYMENT_METHODS]: "Otros Métodos de Pago",
  [OTHERS_PAYMENT_METHODS_EMPTY]: "No hay métodos de pago adicionales",
  [PAYMENT_METHODS_SECURE]: "Tus métodos de pago estarán seguros",
  [PAYMENT_METHODS_SECURE_EXPLANATION]:
    "Tu información de pago nunca estará expuesta y podrás modificarla cuando quieras",
  [PAYMENT_METHODS_ENCRYPTED]: "Encriptado de extremo a extremo",
  [PAYMENT_SUCCESSFUL]: "Pago exitoso",
  [UPGRADE_SUBSCRIPTION_SUCCESSFUL]: "Suscripción Actualizada Exitosamente",
  [PRICE_TO_BE_PAID]: "Precio a pagar",
  [PAY]: "Pagar",
  [ADD_CARD]: "Añadir tarjeta",
  [VERIFY_SUBSCRIPTION_TITLE]: "No Pudimos Verificar Tu Suscripción",
  [VERIFY_SUBSCRIPTION_DESCRIPTION]:
    "Nuestro proveedor no pudo verificar y sincronizar tu suscripción. Por favor vuelve a ingresar los datos con los que hiciste la compra. No se te cobrará nada y tus datos estarán seguros.",
  [VERIFY_SUBSCRIPTION_CTA]: "Verificar",
  [SAVE_CONFIGURATION]: "Guardar configuración",
  [CARD_INFORMATION_EXPLANATION_TITLE]: "Información recolectada de tu tarjeta",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE]: "Número de la tarjeta",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION]:
    "El número de la tarjeta consta de 16 dígitos y eetán separados en grupos de 4, se encuentran en el frente de la tarjeta.",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE]: "Fecha de Vencimiento",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION]:
    "Se puede encontrar en la parte delantera o trasera de la tarjeta, consta de 4 o a veces 3 números, su formato es MM/YY (Mes en número/Últimos dos números del año).",
  [CARD_INFORMATION_CVV_EXPLANATION_TITLE]: "Código de Seguridad (CVV)",
  [CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION]:
    "Generalmente se encuentra en la parte trasera, a veces en la delantera, consta de 4 o 3 números y su función es para validar la tarjeta.",
  [YOU_WILL_PAY]: "Pagarás",
  [ACCEPT_TERMS_PAY]: `Acepta los términos y condiciones de {{NAME_BUSINESS}}`,
  [DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE]:
    "¿Estás seguro de borrar este método de pago?",
  [QUANTITY_TO_PAY]: "Cantidad a pagar",

  /*FIELDS PLACEHOLDERS*/
  [NAME_PLACEHOLDER]: "Nombre",
  [EMAIL_PLACEHOLDER]: "Correo electrónico",
  [PASSWORD_PLACEHOLDER]: "Contraseña",
  [PASSWORD_CONFIRMATION_PLACEHOLDER]: "Repite la contraseña",
  [SELECT_BUSINESS_PLACEHOLDER]: "Selecciona una empresa",
  [NAME_BUSINESS_PLACEHOLDER]: "Nombre de la Empresa",
  [SELECT_BRANDS_PLACEHOLDER]: "Selecciona las marcas",
  [MAIN_BRAND_PLACEHOLDER]: "Marca principal",
  [SELECT_BRAND_PLACEHOLDER]: "Selecciona una marca",
  [SELECT_STORE_PLACEHOLDER]: "Selecciona una tienda",
  [NAME_AND_LAST_NAME_PLACEHOLDER]: "Nombres y apellidos",
  [SELECT_TYPE_PLAN_PLACEHOLDER]: "Tipo de plan",
  [COST_COLLABORATION_PLACEHOLDER]: "Costo por colaboración",
  [CREDITS_PLACEHOLDER]: `{{NAME_BUSINESS}} Credits`,
  [TRIAL_DAYS_PLACEHOLDER]: "Días de prueba",
  [TYPE_PACKAGE_PLACEHOLDER]: "Tipo de planes",
  [PRICE_BASIC_PLACEHOLDER]: "Costo por suscripción basic",
  [COST_COLLABORATION_BASIC_PLACEHOLDER]: "Costo por colaboración basic",
  [PRICE_PRO_PLACEHOLDER]: "Costo por suscripción pro",
  [COST_COLLABORATION_PRO_PLACEHOLDER]: "Costo por colaboración pro",
  [PRICE_GROWTH_PLACEHOLDER]: "Costo por suscripción growth",
  [COST_COLLABORATION_GROWTH_PLACEHOLDER]: "Costo por colaboración growth",
  [COMMERCIAL_PLACEHOLDER]: "Comercial",
  [BUSINESS_NAME_PLACEHOLDER]: "Nombre",
  [BUSINESS_DESCRIPTION_PLACEHOLDER]: "Descripción",
  [BUSINESS_TEXT_STYLE_PLACEHOLDER]: "Tono de Comunicación",
  [BUSINESS_LOOK_AND_FEEL_PLACEHOLDER]: "Estilo de Marca",
  [LOOK_AND_FEEL_PLACEHOLDER]: "Estilo",
  [BUSINESS_OFFERING_PLACEHOLDER]: "Oferta",
  [BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER]: "Productos Físicos",
  [BUSINESS_OFFERING_SERVICES_PLACEHOLDER]: "Servicios",
  [DESCRIPTION_OPTIONAL_PLACEHOLDER]: "Descripción (opcional)",
  [PRICE_PLACEHOLDER]: "Precio",
  [CURRENCY_PLACEHOLDER]: "Moneda",
  [IS_RECURRENCE_PLACEHOLDER]: "El cobro es",
  [RECURRENCE_PLACEHOLDER]: "Recurrencia",
  [SELECT_CAMPAIGN_PLACEHOLDER]: "Selecciona una campaña",
  [SELECT_UGC_CONTENT_FORMAT]: "Selecciona un estilo del contenido",
  [SELECT_SOME_OPTIONS]: "Selecciona algunas opciones",
  [OBJECTIVE_PLACEHOLDER]: "Objetivo",
  [PLATFORMS_PLACEHOLDER]: "Plataformas",
  [PLATFORM_PLACEHOLDER]: "Plataforma",
  [BUDGET_PLACEHOLDER]: "Presupuesto",
  [DAILY_BUDGET_PLACEHOLDER]: "Presupuesto Diario en {{currency}}",
  [LIFETIME_BUDGET_PLACEHOLDER]: "Presupuesto Total en {{currency}}",
  [LOCATIONS_PLACEHOLDER]: "Ubicaciones",
  [EXCLUDED_LOCATIONS_PLACEHOLDER]: "Ubicaciones Excluidas",
  [AGE_RANGE_PLACEHOLDER]: "Rangos de Edad",
  [GENDERS_PLACEHOLDER]: "Géneros",
  [INTERESTS_PLACEHOLDER]: "Intereses",
  [INDUSTRIES_PLACEHOLDER]: "Industrias",
  [JOB_FUNCTIONS_PLACEHOLDER]: "Funciones de Trabajo",
  [SENIORITIES_PLACEHOLDER]: "Niveles de Antigüedad",
  [JOB_TITLES_PLACEHOLDER]: "Títulos de Trabajo",
  [COMPANY_SIZES_PLACEHOLDER]: "Tamaños de Empresa",
  [COMPANIES_PLACEHOLDER]: "Empresas",
  [DEGREES_PLACEHOLDER]: "Títulos Académicos",
  [FIELDS_OF_STUDY_PLACEHOLDER]: "Campos de Estudio",
  [SCHOOLS_PLACEHOLDER]: "Escuelas",
  [SKILLS_PLACEHOLDER]: "Habilidades",
  [MEMBER_TRAITS_PLACEHOLDER]: "Características de Miembros",
  [MEMBER_BEHAVIORS_PLACEHOLDER]: "Comportamientos de Miembros",
  [MEMBER_GROUPS_PLACEHOLDER]: "Grupos de Miembros",

  [DEGREES_SEARCH_PLACEHOLDER]:
    "p.ej. Bachelor of Computer Engineering, Master of Data Science",
  [FIELDS_OF_STUDY_SEARCH_PLACEHOLDER]:
    "p.ej. Computer Science, Marketing, Business Administration",
  [INTERESTS_SEARCH_PLACEHOLDER]:
    "p.ej. Software Development, Digital Marketing, Business Consulting",
  [SCHOOLS_SEARCH_PLACEHOLDER]:
    "p.ej. Harvard University, Stanford University, MIT",
  [SKILLS_SEARCH_PLACEHOLDER]:
    "p.ej. Project Management, Python, Microsoft Excel",
  [COMPANIES_SEARCH_PLACEHOLDER]: "p.ej. Microsoft, Meta, Google, Stripe",
  [INDUSTRIES_SEARCH_PLACEHOLDER]:
    "p.ej. Software Development, Financial Services, Healthcare",
  [COMPANY_SIZES_SEARCH_PLACEHOLDER]: "p.ej. 11-50 empleados, 51-200 empleados",
  [JOB_FUNCTIONS_SEARCH_PLACEHOLDER]: "p.ej. Marketing, Engineering, Sales",
  [JOB_TITLES_SEARCH_PLACEHOLDER]:
    "p.ej. Software Engineer, Project Manager, Designer",
  [SENIORITIES_SEARCH_PLACEHOLDER]: "p.ej. Senior, Manager, Director",
  [MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER]:
    "p.ej. Job Seekers, Recently Promoted, Frequent Travelers",

  [LINKEDIN_STAFF_COUNT_MYSELF_ONLY]: "Solo yo",
  [LINKEDIN_STAFF_COUNT_2_10]: "2-10 empleados",
  [LINKEDIN_STAFF_COUNT_11_50]: "11-50 empleados",
  [LINKEDIN_STAFF_COUNT_51_200]: "51-200 empleados",
  [LINKEDIN_STAFF_COUNT_201_500]: "201-500 empleados",
  [LINKEDIN_STAFF_COUNT_501_1000]: "501-1.000 empleados",
  [LINKEDIN_STAFF_COUNT_1001_5000]: "1.001-5.000 empleados",
  [LINKEDIN_STAFF_COUNT_5001_10000]: "5.001-10.000 empleados",
  [LINKEDIN_STAFF_COUNT_10001_PLUS]: "10.001+ empleados",

  [LINKEDIN_JOB_FUNCTION_ACCOUNTING]: "Contabilidad",
  [LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE]: "Administrativo",
  [LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN]: "Arte y Diseño",
  [LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT]: "Desarrollo de Negocios",
  [LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES]:
    "Servicios Comunitarios y Sociales",
  [LINKEDIN_JOB_FUNCTION_CONSULTING]: "Consultoría",
  [LINKEDIN_JOB_FUNCTION_EDUCATION]: "Educación",
  [LINKEDIN_JOB_FUNCTION_ENGINEERING]: "Ingeniería",
  [LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP]: "Emprendimiento",
  [LINKEDIN_JOB_FUNCTION_FINANCE]: "Finanzas",
  [LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES]: "Servicios de Salud",
  [LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES]: "Recursos Humanos",
  [LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY]:
    "Tecnología de la Información",
  [LINKEDIN_JOB_FUNCTION_LEGAL]: "Legal",
  [LINKEDIN_JOB_FUNCTION_MARKETING]: "Marketing",
  [LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION]: "Medios y Comunicación",
  [LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES]:
    "Servicios Militares y de Protección",
  [LINKEDIN_JOB_FUNCTION_OPERATIONS]: "Operaciones",
  [LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT]: "Gestión de Producto",
  [LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT]:
    "Gestión de Programas y Proyectos",
  [LINKEDIN_JOB_FUNCTION_PURCHASING]: "Compras",
  [LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE]: "Aseguramiento de Calidad",
  [LINKEDIN_JOB_FUNCTION_REAL_ESTATE]: "Bienes Raíces",
  [LINKEDIN_JOB_FUNCTION_RESEARCH]: "Investigación",
  [LINKEDIN_JOB_FUNCTION_SALES]: "Ventas",
  [LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT]:
    "Éxito y Soporte al Cliente",

  [LINKEDIN_SENIORITY_UNPAID]: "No remunerado",
  [LINKEDIN_SENIORITY_TRAINING]: "Formación",
  [LINKEDIN_SENIORITY_ENTRY]: "Principiante",
  [LINKEDIN_SENIORITY_SENIOR]: "Senior",
  [LINKEDIN_SENIORITY_MANAGER]: "Gerente",
  [LINKEDIN_SENIORITY_DIRECTOR]: "Director",
  [LINKEDIN_SENIORITY_VP]: "VP",
  [LINKEDIN_SENIORITY_CXO]: "CXO",
  [LINKEDIN_SENIORITY_PARTNER]: "Socio",
  [LINKEDIN_SENIORITY_OWNER]: "Propietario",

  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS]: "Viajeros Frecuentes",
  [LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS]: "Buscadores de Empleo",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION]: "Abiertos a la Educación",
  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS]: "Contribuidores Frecuentes",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED]: "Recientemente Reubicados",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED]: "Recientemente Ascendidos",
  [LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS]: "Cambio de Carrera",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS]:
    "Recientemente Cambiaron de Trabajo",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION]: "Abiertos a Reubicación",
  [LINKEDIN_MEMBER_BEHAVIOR_EXPAT]: "Expatriado",
  [LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS]: "Usuarios Móviles",
  [LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS]:
    "Usuarios de Escritorio/Portátil",
  [LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS]:
    "Viajeros Frecuentes Nacionales",
  [LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS]:
    "Viajeros Frecuentes Internacionales",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC]:
    "Recientemente Reubicados (Nacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL]:
    "Recientemente Reubicados (Internacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC]:
    "Abiertos a Reubicación (Nacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL]:
    "Abiertos a Reubicación (Internacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS]: "Usuarios Android",
  [LINKEDIN_MEMBER_BEHAVIOR_WINDOWS]: "Windows",
  [LINKEDIN_MEMBER_BEHAVIOR_MAC]: "Mac",
  [LINKEDIN_MEMBER_BEHAVIOR_LINUX]: "Linux",

  [AUDIENCE_ATTRIBUTES_PLACEHOLDER]: "Atributos de la Audiencia",
  [BEHAVIORS_PLACEHOLDER]: "Comportamientos",
  [DEMOGRAPHICS_PLACEHOLDER]: "Demografía",
  [DEMOGRAPHICS_BASIC_PLACEHOLDER]: "Demografía Básica",
  [BUDGET_CONFIGURATION_PLACEHOLDER]: "Configuración de Presupuesto",
  [BUDGET_CAMPAIGN_DATES_PLACEHOLDER]: "Fechas de Campaña",
  [DESTINATION_TYPE_PLACEHOLDER]: "Ubicación de la Conversión",
  [CUSTOM_AUDIENCES_PLACEHOLDER]: "Audiencias personalizadas",
  [CUSTOM_PLACEMENTS_PLACEHOLDER]: "Custom placements",
  [EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER]:
    "Audiencias personalizadas excluidas",
  [KEYWORDS_PLACEHOLDER]: "Palabras Clave",
  [KEYWORDS_NEGATIVE_PLACEHOLDER]: "Palabras Clave Negativas",
  [DESCRIPTION_PLACEHOLDER]: "Descripción",
  [LONG_HEADLINE_PLACEHOLDER]: "Titular Largo",
  [TRACKING_META_ID_PLACEHOLDER]: "Meta Pixel ID",
  [TRACKING_TIKTOK_ID_PLACEHOLDER]: "TikTok Pixel ID",
  [TRACKING_GOOGLE_ID_PLACEHOLDER]: "Google Tag ID",
  [TRACKING_LINKEDIN_ID_PLACEHOLDER]: "LinkedIn Pixel ID",
  [TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER]: "Meta Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER]: "TikTok Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER]: "Google Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER]: "LinkedIn Tracking Event",
  [DESTINATION_URL_PLACEHOLDER]: "URL de Redirección",
  [DEEP_LINK_PLACEHOLDER]: "Enlace Profundo",
  [CREATOR_BODY_BUILD_PLACEHOLDER]: "Tipo de cuerpo",
  [CREATOR_CLOTHING_STYLE_PLACEHOLDER]: "Estilo de vestimenta",
  [CREATOR_CONTENT_STYLE_PLACEHOLDER]: "Estilo de contenido",
  [CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER]: "Características distintivas",
  [CALL_TO_ACTION_PLACEHOLDER]: "Call to Action",
  [CHOOSE_AN_ADDRESS_PLACEHOLDER]: "Escoge una Dirección",
  [CALL_TO_ACTIONS_PLACEHOLDER]: "Call to Actions",
  [ADS_CAMPAIGN_CONTEXT]: "¿De qué se trata tu campaña?",
  [TYPE_BUDGET_PLACEHOLDER]: "Tipo de Presupuesto",
  [TITLE_PLACEHOLDER]: "Título",
  [HEADLINE_PLACEHOLDER]: "Titular",
  [WEBSITE_URL_PLACEHOLDER]: "Sitio Web",
  [LANGUAGE_CAMPAIGN_PLACEHOLDER]: "Idioma de la campaña",
  [LANGUAGE_PLACEHOLDER]: "Idioma",
  [VERIFICATION_CODE_PLACEHOLDER]: "Código de verificación",
  [TYPE_PLACEHOLDER]: "Tipo",
  [RETENTION_DAYS_PLACEHOLDER]: "Retención del público (En días)",
  [IDENTITY_TIK_TOK_PLACEHOLDER]: "Identidad de TikTok",
  [PROFILE_IMAGE_PLACEHOLDER]: "Imagen de perfil",
  [PROFILE_NAME_PLACEHOLDER]: "Nombre del perfil",
  [AD_ACCOUNT_META_PLACEHOLDER]: "Cuenta Publicitaria de Meta",
  [AD_ACCOUNT_TIKTOK_PLACEHOLDER]: "Cuenta Publicitaria de TikTok",
  [AD_ACCOUNT_GOOGLE_PLACEHOLDER]: "Cuenta Publicitaria de Google",
  [AD_ACCOUNT_LINKEDIN_PLACEHOLDER]: "Cuenta Publicitaria de LinkedIn",
  [LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER]: "Cuenta de LinkedIn",
  [LINKEDIN_PUBLISH_AS_PERSONAL_LABEL]: "Personal",
  [LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL]: "Página de empresa",
  [PAGE_FACEBOOK_PLACEHOLDER]: "Página de Facebook",
  [INSTAGRAM_ACCOUNT_PLACEHOLDER]: "Cuenta de Instagram",
  [USE_FB_PAGE_AS_IG]: "Usar Página de Facebook como Instagram",
  [YOUTUBE_ACCOUNT_PLACEHOLDER]: "Cuenta de YouTube",
  [YOUTUBE_PRIVACY_LEVEL_PUBLIC]: "Público",
  [YOUTUBE_PRIVACY_LEVEL_UNLISTED]: "No listado",
  [YOUTUBE_PRIVACY_LEVEL_PRIVATE]: "Privado",
  [YOUTUBE_PRIVACY_LEVEL_LABEL]: "Nivel de privacidad",
  [YOUTUBE_TITLE_LABEL]: "Título",
  [YOUTUBE_DESCRIPTION_LABEL]: "Descripción",
  [YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL]: "Notificar a suscriptores",
  [YOUTUBE_MADE_FOR_KIDS_LABEL]: "Hecho para niños",
  [FORMAT_PLACEHOLDER]: "Formato",
  [ADVERTISER_SELECTOR_BRANDS_COUNT]: "{{count}} marcas",
  [ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE]: "{{count}} marca",
  [ADVERTISER_SELECTOR_NO_RESULTS]: "Sin resultados",
  [ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER]: "Buscar marca…",
  [ADVERTISER_SELECTOR_TRY_ANOTHER_NAME]: "Intenta con otro nombre",
  [ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON]: "Configurar Límites",
  [SELECT_ADVERTISER_ID_PLACEHOLDER]: "Anunciante",
  [SOCIAL_NETWORK_URL_PLACEHOLDER]: "URL de tu Red Social",
  [DISCOUNT_CODE_PLACEHOLDER]: "Código de Descuento",
  [BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER]:
    "URL del Perfil de Instagram de tu Marca",
  [INSTAGRAM_PROFILE_URL_PLACEHOLDER]: "URL del Perfil de Instagram",
  [SCRIPT_PLACEHOLDER]: "Guión",
  [CAMPAIGN_TYPE_PLACEHOLDER]: "Tipo de Campaña",
  [META_DESTINATION_TYPE_PLACEHOLDER]: "Ubicación de la Conversión",
  [ROLE_PLACEHOLDER]: "Rol",
  [WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER]: "Número de WhatsApp Business",
  [WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER]: "Plantilla de Mensaje de Bienvenida",
  [MESSAGE_TEMPLATE_UNSUPPORTED_TITLE]:
    "Plantilla no compatible con la plataforma",
  [MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION]:
    "Esta plantilla incluye un formulario creado directamente en Meta. No es posible editarla desde aquí, pero se mantendrá tal cual al guardar los cambios del anuncio.",
  [GREETING_MESSAGE_PLACEHOLDER]: "Mensaje de saludo",
  [CUSTOMER_TYPE_MESSAGE_PLACEHOLDER]: "Tipo de mensaje del usuario",
  [CUSTOMER_TYPE_PREFILL_MESSAGE]: "Mensaje Prellenado",
  [CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE]: "Preguntas Rápidas",
  [CUSTOMER_TEXT_PLACEHOLDER]: "Mensaje prellenado del usuario",
  [CUSTOMER_TEXTS_PLACEHOLDER]: "Pregunta rápida {{value}} del usuario",
  [LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS]: "Textos del cliente",
  [INSTANT_FORM_PLACEHOLDER]: "Formulario Instantáneo",
  [TIKTOK_LEAD_DESTINATION_WEBSITE]: "Sitio web",
  [TIKTOK_LEAD_DESTINATION_INSTANT_FORM]: "Formulario Instantáneo",
  [TIKTOK_INSTANT_FORM_EDITOR_HINT]:
    "El formulario se crea en el editor de TikTok. Para cambiar las preguntas hay que crear otro formulario y reemplazarlo en el anuncio.",
  [TIKTOK_INSTANT_FORM_CREATE]: "Crear formulario",
  [TIKTOK_INSTANT_FORM_EDITOR_FAILED]:
    "No se pudo abrir el editor. Habilita las ventanas emergentes de este sitio e intenta crear el formulario de nuevo. Si el problema continúa, contacta a soporte desde el chat de ayuda de la derecha.",
  [INTEGRATION_MISSING_PERMISSION]:
    "Tu integración no tiene los permisos suficientes para esta funcionalidad, por favor reconecta tu cuenta de {{platform}}.",
  [TIKTOK_INSTANT_FORM_LOCKED_DESTINATION]:
    "El destino de un conjunto ya publicado no se puede cambiar. Crea otro conjunto.",
  [TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT]:
    "El carrusel requiere que el conjunto incluya la ubicación TikTok.",
  [TIKTOK_INSTANT_FORM_PREVIEW_NAME]: "Formulario: {{name}}",
  [CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION]:
    "¿A dónde deben ir los leads?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION]:
    "Elige un formulario instantáneo. Puedes dejarlo vacío y seleccionarlo después.",
  [ENTER_ANSWER_PLACEHOLDER]: "Ingresa tu respuesta",
  [WHY_WOULD_IT_WORK]: "¿Por qué funcionaría?",
  [INSTANT_FORM_SECTION_FORM_TYPE]: "Tipo de formulario",
  [INSTANT_FORM_SECTION_INTRO]: "Introducción",
  [INSTANT_FORM_SECTION_QUESTIONS]: "Preguntas",
  [INSTANT_FORM_SECTION_END]: "Finalización",
  [INSTANT_FORM_FIELD_HEADLINE]: "Etiqueta",
  [INSTANT_FORM_FIELD_DESCRIPTION]: "Descripción",
  [INSTANT_FORM_FIELD_CTA]: "CTA",
  [CONVERSION_ACTIONS_PLACEHOLDER]: "Acciones de Conversión",
  [SEARCH_KEYWORDS_PLACEHOLDER]: "Busca palabras clave",
  [IMAGES_OF_CAMPAIGN_PLACEHOLDER]: "Imágenes",
  [VIDEOS_OF_CAMPAIGN_PLACEHOLDER]: "Videos",
  [LOGO_OF_THE_BRAND_PLACEHOLDER]: "Logo de la marca",
  [LOGO_URLS_PLACEHOLDER]: "Logos de la Marca",
  [NETWORK_DISPLAY_SETTING_PLACEHOLDER]:
    "¿Dónde quieres que Google muestre tu anuncio?",
  [GOOGLE_AI_MAX_ENABLE_QUESTION]: "¿Quieres habilitar Google AI Max?",
  [GOOGLE_AI_MAX_ACTIVATED]: "Activado",
  [GOOGLE_AI_MAX_DEACTIVATED]: "Desactivado",
  [REPORT_BREAKDOWN_PLACEHOLDER]: "Desglose del reporte",
  [ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]: "¿En qué consistirá tu campaña?",
  [ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER]: "Idioma de la Campaña",
  [ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER]: "Selecciona un Idioma",
  [ADS_CAMPAIGN_LOCATION_PLACEHOLDER]: "¿A qué ubicaciones quieres dirigirte?",
  [ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER]:
    "¿En qué plataformas correrá tu campaña?",
  [SOCIAL_NETWORKS_PLACEHOLDER]: "Redes Sociales",
  [BUSINESS_COMPETITORS_PLACEHOLDER]: "Competidores",
  [FIND_A_LOCATION_PLACEHOLDER]: "Buscar una ubicación",
  [CREATIVE_TYPE_PLACEHOLDER]: "Tipo de Creativo",
  [ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER]: "Mejoras Advantage del Creativo",
  [SITE_LINKS_PLACEHOLDER]: "Enlaces de Sitio",
  [SITE_LINK_PLACEHOLDER]: "Enlace de Sitio",
  [SITE_LINK_TEXT_PLACEHOLDER]: "Nombre",
  [SITE_LINK_DESCRIPTION_PLACEHOLDER]: "Descripción",
  [SITE_LINK_FINAL_URL_PLACEHOLDER]: "URL Final",
  [SITE_LINK_DESCRIPTIONS_PLACEHOLDER]: "Descripciones",
  [CALLOUTS_PLACEHOLDER]: "Llamadas a la Acción",
  [CALLOUT_TEXT_PLACEHOLDER]: "Llamada a la acción",
  [KEYWORD_PLACEHOLDER]: "Palabra Clave",
  [KEYWORD_MATCH_TYPE_PLACEHOLDER]: "Tipo de Concordancia",
  [FROM_PLACEHOLDER]: "Desde",
  [SEARCH_THEMES_PLACEHOLDER]: "Temas de búsqueda",
  [STATUS_PLACEHOLDER]: "Estado",
  [USE_CAMPAIGN_BUDGET_PLACEHOLDER]: "Presupuesto a Nivel de Campaña (CBO)",
  [DESTINATION_TYPE_AD_PLACEHOLDER]: "Destino",
  [DATA_TYPE_PLACEHOLDER]: "Tipo de datos",
  [CUSTOMER_TYPES_PLACEHOLDER]: "Tipos de clientes",
  [FIRST_NAME_PLACEHOLDER]: "Nombre",
  [LAST_NAME_PLACEHOLDER]: "Apellido",
  [COUNTRY_CODE_PLACEHOLDER]: "Código de país",
  [POSTAL_CODE_PLACEHOLDER]: "Código postal",
  [PHONE_PLACEHOLDER]: "Teléfono",
  [BUSINESS_LOGO]: "Logo de la marca",
  [SELECT_RANGE_DATE_PLACEHOLDER]: "Selecciona un Rango de Fechas",
  [MEDIA_URLS_PLACEHOLDER]: "Creativo",
  [CATALOG_PLACEHOLDER]: "Catálogo",
  [PROMOTED_PRODUCTS_PLACEHOLDER]: "Productos Promocionados",
  [PRODUCT_SET]: "Conjunto de Productos",
  [PRODUCT_SET_PLACEHOLDER]: "Conjunto de Productos",
  [PRODUCT_CONFIGURATION_PLACEHOLDER]: "Configuración de Productos",
  [PRODUCT_LIST]: "Lista de Productos",
  [PRODUCT_LIST_PLACEHOLDER]: "Lista de Productos",
  [BUTTON_ADD_PRODUCTS]: "Agregar Productos",
  [MODAL_PRODUCT_LIST_TIKTOK_TITLE]: "Seleccionar Productos",
  [MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION]:
    "Elige los productos que quieres promocionar en este anuncio.",
  [SEARCH_PRODUCT_PLACEHOLDER]: "Buscar Productos",
  [IS_CATALOG_CAMPAIGN_PLACEHOLDER]: "Campaña de Catálogo",
  [BRAND_PLACEHOLDER]: "Marca",
  [RETAILER_ID_PLACEHOLDER]: "ID de la tienda",
  [SHORT_DESCRIPTION_PLACEHOLDER]: "Descripción corta",
  [CURRENT_PRICE_PLACEHOLDER]: "Precio actual",
  [UNIT_PRICE_PLACEHOLDER]: "Precio unitario",
  [CUSTOM_LABEL_NUMBER_PLACEHOLDER]: "Etiqueta personalizada {{value}}",
  [CUSTOM_NUMBER_PLACEHOLDER]: "Número personalizado {{value}}",
  [URL_PLACEHOLDER]: "URL",
  [CREATIVE_FROM_PLACEHOLDER]: "Creativo de",
  [EDIT_CREATIVE_TOOLS_PLACEHOLDER]: "Mejoras de Creativo",
  [OVERLAY_TYPE_PLACEHOLDER]: "Tipo de superposición",
  [OVERLAY_POSITION_PLACEHOLDER]: "Posición de la superposición",
  [OVERLAY_SHAPE_PLACEHOLDER]: "Forma de la superposición",
  [OVERLAY_COLOR_PLACEHOLDER]: "Color de la superposición",
  [OVERLAY_OPACITY_PLACEHOLDER]: "Opacidad de la superposición",
  [OVERLAY_FONT_PLACEHOLDER]: "Fuente de la superposición",
  [PRICE_LABEL_PLACEHOLDER]: "Precio",
  [AUTO_SHOW_LABEL_PLACEHOLDER]: "Etiqueta de auto mostrar",
  [LABEL_TEXT_PLACEHOLDER]: "Texto de la etiqueta",
  [STRIKETHROUGH_PRICE_PLACEHOLDER]: "Precio con descuento",
  [PERCENTAGE_OFF_PLACEHOLDER]: "Porcentaje de descuento",
  [FREE_SHIPPING_PLACEHOLDER]: "Envío gratis",
  [OVERLAY_TEXT_COLOR_PLACEHOLDER]: "Color del texto",
  [OVERLAY_TEXT_FONT_PLACEHOLDER]: "Fuente del texto",
  [ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT]:
    "Mostrar etiqueta solo cuando pueda aumentar el engagement",
  [APP_PLACEHOLDER]: "App",
  [ANDROID_DEEP_LINK_PLACEHOLDER]: "Enlace Profundo de Android",
  [IOS_DEEP_LINK_PLACEHOLDER]: "Enlace Profundo de iOS",
  [INSTANT_EXPERIENCE_PLACEHOLDER]: "Experiencia instantánea",
  [DEEP_DESTINATION_APP_URL_PLACEHOLDER]: "Enlace Profundo de la App",
  [CUSTOM_STORE_LISTING_ID_PLACEHOLDER]: "ID de la tienda personalizada",
  [CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER]:
    "ID de la Página de Producto Personalizada",
  [IOS_14_CAMPAIGN_PLACEHOLDER]:
    "Dirigirse a dispositivos iOS 14 y superiores (Recomendado)",
  [UTM_PARAMETERS_PLACEHOLDER]: "Parámetros UTM",
  [MERCHANT_CENTER_ID_PLACEHOLDER]: "ID del Merchant Center",
  [PRODUCTS_TO_PROMOTE_PLACEHOLDER]: "Productos a promocionar",
  [ADS_SCHEDULE_PLACEHOLDER]: "Correr anuncios en un horario",
  [ADS_SCHEDULE_ALWAYS_ON]: "Siempre activo",
  [TIMEZONE_PLACEHOLDER]: "Zona horaria",
  [AD_SCHEDULE_PLACEHOLDER]: "Programación de Anuncios",
  [SEARCH_BY_NAME_PLACEHOLDER]: "Buscar por nombre",
  [PLACEMENTS_PLACEHOLDER]: "Ubicaciones",
  [DEVICES_PLACEHOLDER]: "Dispositivos",
  [CREATIVE_SOURCE_PLACEHOLDER]: "Fuente del Creativo",
  [MANUAL_UPLOAD_PLACEHOLDER]: "Subida Manual",
  [FROM_CATALOG]: "Desde catálogo",
  [MANUAL_UPLOAD]: "Subida manual",
  [PUBLICATION_DESCRIPTION]: "Descripción de la publicación",
  [ADVANTAGE_CATALOG_PLACEHOLDER]: "Catálogo Advantage",
  [DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER]:
    "Configuración de destino de enlace profundo",
  [COVER_CONTENT_PLACEHOLDER]: "Contenido de la portada",
  [SEARCH_PLACEHOLDER]: "Search",
  [OFFLINE_EVENTS_PLACEHOLDER]: "Eventos sin Conexión",
  [SIZE_FOR_DISPLAY_PLACEHOLDER]: "Tamaño para Display",
  [SIZE_FOR_SEARCH_PLACEHOLDER]: "Tamaño para Search",
  [SIZE_PLACEHOLDER]: "Tamaño",
  [MAXIMUM_COST_PER_CLICK_PLACEHOLDER]: "Costo Máximo por Clic",
  [TARGET_CPA_PLACEHOLDER]: "Costo por Conversión Objetivo",
  [BID_CONTROL_PLACEHOLDER]: "Control de Puja",
  [HIGHEST_VOLUME_PLACEHOLDER]: "Mayor Volumen",
  [TARGET_ROAS_PLACEHOLDER]: "Retorno de Inversión Objetivo",
  [BIDDING_STRATEGY_TYPE_PLACEHOLDER]: "Tipo de Estrategia de Puja",
  [ADVERTISERS_AVAILABLE_PLACEHOLDER]: "Anunciantes a los que tiene acceso",
  [BUYING_TYPE_PLACEHOLDER]: "Tipo de Compra",
  [SEARCH_SPECIFIC_LOCATION_PLACEHOLDER]: "Busca una ubicación especifica",
  [LANGUAGES_PLACEHOLDER]: "Idiomas",
  [FREQUENCY_CONTROL_PLACEHOLDER]: "Control de Frecuencia",
  [FILTER_BY_USERS_PLACEHOLDER]: "Filtrar por Usuario",
  [FILTER_BY_DATES_PLACEHOLDER]: "Filtrar por Fechas",
  [TRACKING_OFFLINE_EVENTS_PLACEHOLDER]: "Eventos sin Conexión",
  [PRESETS_DATE_PLACEHOLDER]: "Rangos Preestablecidos",
  [ASPECT_RATIO_PLACEHOLDER]: "Dimensiones",
  [DATE_RANGE_PRESET_CUSTOM]: "Personalizado",
  [MIN_DAILY_BUDGET_PLACEHOLDER]: "Gasto Diario Mínimo",
  [MAX_DAILY_BUDGET_PLACEHOLDER]: "Gasto Diario Máximo",
  [MIN_TOTAL_BUDGET_PLACEHOLDER]: "Gasto Total Mínimo",
  [MAX_TOTAL_BUDGET_PLACEHOLDER]: "Gasto Total Máximo",
  [DARK_POST_PLACEHOLDER]: "Modo Solo Anuncios",
  [DARK_POST_DESCRIPTION_PLACEHOLDER]:
    "Si activas esta opción, tus anuncios solo aparecerán como anuncios y no en tu perfil de TikTok. Si la desactivas, también se publicarán como un post en tu perfil.",

  //EXAMPLES
  [ADS_CAMPAIGN_CONTEXT_EXAMPLE]:
    "Escribe un párrafo detallando el producto o servicio que quieres promocionar, a qué público objetivo deseas llegar y qué objetivo deseas alcanzar con tu campaña",
  [ADS_CAMPAIGN_LOCATION_EXAMPLE]:
    "Escribe un prompt y dale enter (ej.: “principales ciudades de Estados Unidos”) o busca un lugar",
  [SEARCH_SPECIFIC_LOCATION_EXAMPLE]:
    "Busca por nombre o coordenadas (en el formato: latitud, longitud)",
  [SOCIAL_NETWORK_EXAMPLE]: "https://www.instagram.com/tumarca",

  /*OPTIONS SELECT*/
  [PLAN_PAY_PER_USE]: "Suscripción pago por uso",
  [PLAN_PACKAGE]: "Licencia de paquete",
  [PLAN_REGULAR]: "Planes regulares (Basic y Pro)",
  [PLAN_ENTERPRISE]: "Enterprise",
  [ADD_NEW_OPTION]: `Agregar "{{value}}"`,
  [RECURRENT_OPTION]: "Recurrente",
  [RECURRING_DAYS]: "Cada día",
  [RECURRING_WEEKS]: "Cada semana",
  [RECURRING_MONTHS]: "Cada mes",
  [RECURRING_YEARS]: "Cada año",
  [ASPECT_RATIO_9_16]: "Vertical (9:16)",
  [ASPECT_RATIO_16_9]: "Horizontal (16:9)",
  [ASPECT_RATIO_1_1]: "Cuadrado (1:1)",
  [ASPECT_RATIO_4_5]: "Instagram Feed (4:5)",

  /*PLANS*/
  [PLAN_PAY_PER_USE_NAME]: "Plan pago por uso",
  [PLAN_PACKAGE_NAME]: "Plan {{value}}",

  /*FIELDS VALIDATIONS*/
  [FIELD_REQUIRED]: "Este campo es requerido",
  [FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS]:
    "Debes seleccionar al menos {{value}} productos",
  [FIELDS_REQUIRED]: "Todos los campos son requeridos",
  [FIELD_NUMERIC]: "El campo debe ser numérico",
  [FIELD_TEXT]: "El campo solo debe tener letras",
  [FIELD_ALPHANUMERIC]: "El campo solo debe tener letras y números",
  [FIELD_MIN_LENGTH]: "Mínimo {{value}} caracteres",
  [FIELD_MAX_LENGTH]: "Máximo {{value}} caracteres",
  [FIELD_MAX_LENGTH_SHORT]: "Máximo {{value}} caracteres",
  [FIELD_FILE_VALID_REQUIRED]:
    "Debes seleccionar un archivo alguno de estos formatos: {{value}}",
  [FIELD_FILE_MAX_SIZE]:
    "El archivo es muy grande, por favor selecciona uno con un tamaño menor a {{value}}{{type}}",
  [FIELD_MEDIA_FILE_MIN_DIMENSIONS]:
    "El contenido seleccionado es de baja resolución, por favor selecciona un contenido con al menos {{width}}px de ancho y {{height}}px de alto",
  [FIELD_IMAGE_REQUIRED]: "Debes seleccionar una imagen de formato valido",
  [FIELD_IMAGE_FORMAT_VALID]:
    "La imagen es muy grande, por favor selecciona una con un tamaño menor a {{value}}{{type}}",
  [FIELD_IMAGE_SIZE_VALID]: "No se ha seleccionado ninguna imagen",
  [FIELD_FILE_REQUIRED]:
    "El archivo es muy grande, por favor selecciona uno con un tamaño menor a {{value}}{{type}}",
  [FIELD_FILE_SIZE_VALID]: "No se ha seleccionado ningún archivo",
  [FIELD_URL_VALID]: "La URL debe ser válida",
  [FIELD_URL_ADLE_APP_DOMAIN]: "El enlace debe ser del dominio app.adle.ai",
  [FIELD_URL_VALID_WITH_PROTOCOL]:
    "La URL debe ser válida y contener un protocolo (https:// o http://)",
  [FIELD_URL_HTTPS_VALID]: "La URL debe incluir https://",
  [FIELD_URL_REPEATED]: "Esta URL ya ha sido agregada",
  [FIELD_EMAIL_VALID]: "El correo electrónico debe ser válido",
  [FIELD_EMAIL_REGISTERED]: "El correo electrónico ya está registrado",
  [FIELD_SPACES_VALID]: "No se permiten espacios en blanco",
  [FIELD_PHONE_VALID]: "El número de celular debe ser válido",
  [FIELD_ALL_REQUIRED]: "Todos los campos son requeridos",
  [FIELD_BOTH_PASSWORD_REQUIRED]: "Ambas contraseñas son requeridas",
  [FIELD_PASSWORDS_NO_MATCH]: "Las contraseñas no coinciden",
  [FIELD_PASSWORD_MIN_LENGTH]: "La contraseña debe tener al menos 6 caracteres",
  [FIELD_PASSWORD_CHANGE_MIN_LENGTH]:
    "Si vas a cambiar la contraseña, debe de ser de al menos de 6 caracteres",
  [FIELD_PASSWORD_INSECURE]:
    "La contraseña debe tener al menos 6 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial",
  [FIELD_NUMBER_NEGATIVE]: "El número no puede ser negativo",
  [FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD]:
    "Con creativos dinámicos solo se permite 1 anuncio en el conjunto de anuncios.",
  [FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "Con presupuesto de campaña, si algún grupo de anuncios tiene la programación de anuncios configurada, todos deben tenerla configurada. Configúrala también en este grupo.",
  [FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "Con presupuesto de campaña, si algún grupo de anuncios tiene objetivo de puja definido, todos deben tenerlo. Configúralo también en este grupo.",
  [FIELD_EMAIL_REQUIRED]: "El correo electrónico es requerido",
  [FIELD_SEARCH_CHATS_MORE_3_CHARACTERS]:
    "Escribe más de 3 caracteres para buscar nuevos chats",
  [FIELD_NUMBER_0_OR_NEGATIVE]: "El número no puede ser 0 o negativo",
  [FIELD_NUMBER_100_GREATER]: "El número no puede ser mayor a 100",
  [FIELD_NUMBER_LESS_THAN]: "El número no puede ser menor a {{value}}",
  [FIELD_NUMBER_GREATER_THAN]: "El número no puede ser mayor a {{value}}",
  [FIELD_CREDITS_NOT_BE_NEGATIVE]: `Los {{NAME_BUSINESS}} Credits no pueden ser negativos`,
  [FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE]:
    "El precio por colaboración no puede ser negativo",
  [FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE]:
    "Los meses de prueba no pueden ser negativos",
  [FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE]:
    "Los días de prueba no pueden ser negativos",
  [FIELD_PLAN_PRICES_NOT_BE_NEGATIVE]:
    "Los precios de los planes no pueden ser negativos",
  [FIELD_STAFF_IS_REQUIRED]: "Debes seleccionar un staff",
  [FIELD_BOTH_DATES_REQUIRED]: "Ambas fechas son requeridas",
  [FIELD_START_DATE_GREATER_THAN_END_DATE]:
    "La fecha inicial no puede ser mayor a la fecha final",
  [FIELD_END_DATE_GREATER_NOW]:
    "La fecha de finalización no puede ser menor a la fecha actual",
  [FIELD_START_DATE_LESS_THAN_NOW]:
    "La fecha de inicio no puede ser menor a la fecha actual",
  [FIELD_END_DATE_LESS_THAN_NOW]:
    "La fecha de finalización no puede ser menor a la fecha actual",
  [FIELD_DATE_IN_PAST]: "La fecha no puede ser en el pasado",
  [FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE]:
    "La fecha debe ser al menos 15 minutos en el futuro",
  [FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE]:
    "La fecha debe ser al menos 5 minutos en el futuro",
  [FIELD_MIN_AMOUNT_PAY]:
    "El monto a pagar no puede ser menor a {{value,currency}}",
  [FIELD_ACCESS_TOKEN_SHOPIFY_VALID]:
    "El token de acceso de Shopify no tiene el formato correcto, generalmente empieza con shpat_ seguido de caracteres aleatorios",
  [FIELD_NAME_REQUIRED]: "El nombre es requerido",
  [FIELD_OBJECTIVE_REQUIRED]: "El objetivo es requerido",
  [FIELD_PLATFORMS_REQUIRED]: "Las plataformas son requeridas",
  [FIELD_PLATFORM_REQUIRED]: "La plataforma es requerida",
  [FIELD_TYPE_BUDGET_REQUIRED]: "El tipo de presupuesto es requerido",
  [FIELD_BUDGET_REQUIRED]: "El presupuesto es requerido",
  [FIELD_CURRENCY_MIN_VALUE]:
    "El valor no puede ser menor a {{value,currency}}",
  [FIELD_LOCATIONS_REQUIRED]: "Las ubicaciones son requeridas",
  [FIELD_GENDERS_REQUIRED]: "Los géneros son requeridos",
  [FIELD_INTERESTS_REQUIRED]: "Los intereses son requeridos",
  [FIELD_BEHAVIORS_REQUIRED]: "Los comportamientos son requeridos",
  [FIELD_DESCRIPTION_REQUIRED]: "La descripción es requerida",
  [FIELD_VIDEO_REQUIRED]: "El video es requerido",
  [FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE]:
    "El creativo debe ser un vídeo, no una imagen",
  [FIELD_META_TRACKING_ID_REQUIRED]: "El Meta pixel es requerido",
  [FIELD_DESTINATION_URL_REQUIRED]: "La URL de destino es requerida",
  [FIELD_WEBSITE_URL_REQUIRED]: "La URL del sitio web es requerida",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED]:
    "La URL de destino no se encuentra configurada los pixels seleccionados",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL]:
    "La URL de destino no se encuentra configurada con el pixel seleccionado, si continúas puede que no se registren algunas estadísticas",
  [FIELD_TIKTOK_TRACKING_ID_REQUIRED]: "El TikTok pixel es requerido",
  [FIELD_MIN_LENGTH_SELECT]: "Debes seleccionar al menos {{value}} opciones",
  [FIELD_MAX_LENGTH_SELECT]: "Debes seleccionar máximo {{value}} opciones",
  [FIELD_CONTENT_REQUIRED]: "El contenido es requerido",
  [FIELD_START_AND_END_DATES_REQUIRED]:
    "Las fechas de inicio y fin son requeridas",
  [FIELD_LANGUAGE_REQUIRED]: "El idioma es requerido",
  [FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE]:
    "Selecciona un Call to action valido para este objetivo",
  [FIELD_TRACKING_IDS_REQUIRED]: "Los pixels son requeridos",
  [FIELD_AD_ACCOUNTS_REQUIRED]: "Las cuentas publicitarias son requeridas",
  [FIELD_CONTENT_IS_BEING_PROCESSED]: "El contenido está siendo procesado",
  [FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR]:
    "El presupuesto no puede ser menor a {{value,number}} {{currency}}",
  [FIELD_MIN_DAILY_BUDGET]:
    "El presupuesto diario no puede ser menor a {{value,number}} {{currency}}",
  [FIELD_MIN_BUDGET]:
    "El presupuesto no puede ser menor a {{value,number}} {{currency}}",
  [FIELD_URL_INSTAGRAM]: "La URL debe ser de Instagram",
  [FIELD_MIN_CONTENT]: "Debes seleccionar al menos {{value}} contenidos",
  [FIELD_MAX_CONTENT]: "Debes seleccionar máximo {{value}} contenidos",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK]:
    "La URL a donde quieres llevar el tráfico no puede ser una de Facebook",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM]: `Para llevar el trafico hacia Instagram, escoge "Tráfico" como objetivo de campaña y "Perfil de Instagram" como ubicación de conversión`,
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP]:
    "La URL a donde quieres llevar el tráfico no puede ser una de WhatsApp",
  [FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un formato para generar la vista previa del anuncio",
  [FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un Call to action para generar la vista previa del anuncio",
  [FIELD_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una página de Facebook en la configuración para generar la vista previa del anuncio",
  [FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar la página de Facebook del patrocinador del anuncio en colaboración para generar la vista previa del anuncio",
  [FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una cuenta de Instagram en la configuración para generar la vista previa del anuncio",
  [FIELD_APP_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una app en el grupo de anuncios para generar la  vista previa del anuncio",
  [FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una identidad de TikTok en la configuración para generar la vista previa del anuncio",
  [FIELD_POST_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un post de Facebook o Instagram para generar la vista previa del anuncio",
  [FIELD_ADDRESS_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una dirección para generar la vista previa del anuncio",
  [FIELD_MIN_CARDS_AD_CAROUSEL]:
    "Debes crear al menos {{value}} tarjetas para usar un anuncio de carrusel",
  [FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS]:
    "El texto solo debe tener letras, números, puntos y comas",
  [FIELD_TEXT_REPEATED]: "El texto no puede ser repetido",
  [FIELD_IMAGES_REPEATED]: "No puedes utilizar imágenes repetidas",
  [FIELD_VIDEOS_REPEATED]: "No puedes utilizar videos repetidos",
  [FIELD_KEYWORDS_REPEATED]: "Hay palabras clave repetidas: {{value}}",
  [FIELD_KEYWORDS_MAX_LENGTH]:
    "Estas palabras clave superan el máximo de {{value}} caracteres: {{keywords}}",
  [FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW]:
    "Debes crear al menos dos tarjetas para generar la vista previa",
  [FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED]:
    "Hay palabras clave repetidas entre las palabras clave y las palabras clave negativas: {{value}}",
  [FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE]:
    "La campaña debe estar al menos un día activa",
  [FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST]:
    "Esta palabra clave ya existe en tu lista",
  [FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un contenido para tu anuncio",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT]:
    "Una vez creado el anuncio, no podrás cambiar el contenido",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED]:
    "Para cambiar el contenido, debes crear un nuevo anuncio",
  [META_AD_PREVIEW_AD_BLOCKER_NOTICE]:
    "Si la vista previa no se muestra o no se renderiza bien, comprueba si tienes un bloqueador de anuncios activo y desactívalo para esta página.",
  [FIELD_START_DATE_REQUIRED]: "La fecha de inicio es requerida",
  [FIELD_VIDEO_YOUTUBE_URL_INVALID]:
    "La URL de un video de Youtube debe ser en el formato https://www.youtube.com/watch?v=XXXXXXXX o https://www.youtube.com/shorts/XXXXXXXX",
  [FIELD_MAX_IMAGES_VALID]: "Debes seleccionar un máximo de {{value}} imágenes",
  [FIELD_MAX_VIDEOS_YOUTUBE_VALID]:
    "Debes ingresar un máximo de {{value}} videos",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC]: "Este video de YouTube no es público",
  [FIELD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "Este video de YouTube no cumple con la duración requerida",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID]:
    "Este video de YouTube no es público y no cumple con la duración requerida",
  [FIELD_MIN_TEXTS_VALID]: "Debes ingresar al menos {{value}} textos",
  [FIELD_MAX_TEXTS_VALID]: "Debes ingresar un máximo de {{value}} textos",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW]: "No pueden haber títulos vacíos",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK]:
    "El título es requerido y debe tener entre 1 y 100 caracteres.",
  [FIELD_HEADLINES_REQUIRED_AD_PREVIEW]: "No pueden haber titulares vacíos",
  [FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW]:
    "No pueden haber descripciones vacías",
  [FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una experiencia instantánea para generar la vista previa del anuncio",
  [FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un conjunto de productos para generar la vista previa del anuncio",
  [FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION]:
    "Debes seleccionar al menos una inclusión o una exclusión",
  [FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar un contenido en la tarjeta de introducción para generar la vista previa del anuncio",
  [FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED]:
    "Facebook profile feed requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED]:
    "Facebook Marketplace requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED]:
    "Messenger inbox requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED]:
    "Facebook Notifications requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED]:
    "Facebook Stories requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED]:
    "Audience Network native, banner e interstitial requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED]:
    "Audience Network rewarded videos requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED]:
    "Ads on Facebook Reels requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED]:
    "Facebook in-stream videos requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED]:
    "Facebook search results requiere que Facebook Feed esté seleccionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED]:
    "Facebook Stories requiere que Instagram Stories esté seleccionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED]:
    "Instagram profile feed requiere que Instagram feed esté seleccionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED]:
    "Instagram search results requiere que Instagram feed esté seleccionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED]:
    "Instagram Explore requiere que Instagram feed esté seleccionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED]:
    "Instagram Explore home requiere que tanto Instagram feed como Instagram Explore estén seleccionados.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED]:
    "Instagram profile reels requiere que Instagram Reels esté seleccionado.",
  [FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una URL de destino para generar la vista previa del anuncio",
  [FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una URL de destino en cada tarjeta de tu carrusel para generar la vista previa del anuncio",
  [FIELD_IMAGES_MIN_REQUIRED]: "Debes seleccionar al menos {{value}} imágenes",
  [FIELD_ESTIMATION_ID_REQUIRED]:
    "Debes esperar a que se genere la estimación antes de reservarla",
  [FIELD_ESTIMATION_BUDGET_REQUIRED]:
    "Debes ingresar un presupuesto para generar la estimación",
  [FIELD_ESTIMATION_START_END_DATE_REQUIRED]:
    "Debes seleccionar fechas de inicio y fin para generar la estimación",
  [FIELD_ESTIMATION_FREQUENCY_REQUIRED]:
    "Debes configurar la frecuencia para generar la estimación",
  [FIELD_ESTIMATION_LOCATION_REQUIRED]:
    "Debes seleccionar al menos una ubicación para generar la estimación",
  [FIELD_SEARCH_THEMES_MAX_WORDS]:
    "Los siguientes temas de búsqueda tienen más de {{value}} palabras: {{items}}",
  [FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW]:
    "Debes seleccionar una canción para tu anuncio",
  [FIELD_CONSECUTIVE_UPPERCASE]:
    "No se permiten {{value}} letras consecutivas en mayúsculas",
  [FIELD_EMOJI_NOT_ALLOWED]: "No se permiten emojis",

  [REQUEST_REJECT_CONFIRMATION_DESCRIPTION]:
    "¿Deseas marcar este contenido como rechazado y cerrar el reporte?",
  [REQUEST_APPROVE_CONFIRMATION_DESCRIPTION]:
    "¿Deseas aprobar este reporte y reembolsar los créditos al anunciante?",
  [REQUEST_REJECTED]: "Solicitud Rechazada",
  [REQUEST_REJECTED_DESCRIPTION]:
    "Se rechazó correctamente la solicitud del creador de contenido {{influencerName}}",
  [REPORTED_CONTENT_STATUS_REJECTED]: "Rechazado",
  [REPORTED_CONTENT_STATUS_PENDING]: "Pendiente",
  [REPORTED_CONTENT_STATUS_APPROVED]: "Aprobado",
  [LIST_OF_CREATORS]: "Listado de creadores",

  /*MODAL COMMERCIAL*/
  [MODAL_COMMERCIAL_TITLE_CREATE]: "Crear comercial",
  [MODAL_COMMERCIAL_TITLE_EDIT]: "Comercial {{value}}",
  [MODAL_COMMERCIAL_CREATE_COMMERCIAL]: "Crear comercial",
  [MODAL_COMMERCIAL_ALREADY_EXIST]: "Un comercial con este nombre ya existe",

  /*MODAL CREATE PAYMENT LINK*/
  [MODAL_CREATE_PAYMENT_LINK_TITLE]: "Crear link de pago",
  [MODAL_CREATE_PAYMENT_LINK_DESCRIPTION]:
    "Crea un link de pago para esta marca, esto creará una suscripción enterprise.",
  [MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL]: "Modal de Creación de Link de Pago",
  [MODAL_CREATE_PAYMENT_LINK_LINKS]: "Links de Pago",
  [MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY]: "No hay links de pago",
  [MODAL_CREATE_PAYMENT_LINK_NAME]: "Pago {{value}}",

  /*MODAL HELP VIDEO AND FAQ*/
  [WARNING_MOBILE_TUTORIAL]:
    "Para una mejor experiencia, realizar el tutorial desde tu computadora o laptop",
  [FAQ_DESCRIPTION]:
    "Aquí encontrarás las preguntas más frecuentes de nuestros usuarios,puedes buscarlas por palabras o frases claves.",
  [FAQ_QUESTION_WHAT_IS_BUZZLY]: `¿Qué es {{NAME_BUSINESS}}?`,
  [FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION]: `{{NAME_BUSINESS}} es la primera plataforma que permite a las pequeñas empresas ofrecer productos gratuitos o con descuento a los creadores de contenidos a cambio de exposición en las redes sociales. Al mismo tiempo, los creadores pueden acceder a una amplia variedad de productos y servicios directamente de sus marcas favoritas a través de nuestra aplicación móvil.`,
  [FAQ_QUESTION_WHAT_IS_REQUEST]: "¿Qué es una solicitud?",
  [FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION]:
    "Una solicitud es una petición que hace un creador de contenido para que le envíes una invitación a colaborar con tu marca.",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION]: "¿Qué es una publicación?",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION]: `Una publicación es la colaboración que se generó cuando el creador de contenido redimió una invitación en tu tienda. Una publicación puede tener los siguientes estados: <br><br>
  <strong>Publicación Pendiente:</strong> El creador de contenido redimió la invitación pero aún no ha publicado nada en sus redes sociales.<br>
  <strong>Analítica Pendiente:</strong> El creador de contenido ya publicó el contenido de tu marca en sus redes sociales y lo subió, pero aún no está disponible las analíticas.<br>
  <strong>Verificar:</strong> El creador ya subió las analíticas y ya puedes revisar los resultados de la colaboración para poder darle una calificación al creador.<br>
  <strong>Verificada:</strong> Ya calificaste la colaboración con base en el contenido y las analíticas generadas.<br>
  <strong>Feedback:</strong> El creador tuvo algún problema con tus productos o servicios, no se genera una colaboración, puedes invitarlo de nuevo.<br>
  `,
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN]: "¿Qué es una campaña?",
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION]: `Una campaña es una forma de colaboración con los creadores mucho más estructurada, donde puedes asignar un presupuesto, un objetivo, tipo de contenidos y con cuales características específicas para que los creadores de contenido puedan postularse. Una vez se postulen puedes ir aceptando o rechazando creadores para tu campaña.`,
  [FAQ_QUESTION_WHAT_IS_ORDER]: "¿Qué es una orden?",
  [FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION]: `Una orden es una solicitud de productos o servicios que hace un creador de contenido a tu marca vía delivery. Una orden puede tener los siguientes estados: <br><br>
  <strong>Por aceptar:</strong> El creador de contenido ya solicitó los productos o servicios pero debes aceptar la orden y asignarle un tiempo de procesamiento.<br>
  <strong>En proceso:</strong> Ya aceptaste la orden y estás procesando los productos o servicios para enviarlos al creador de contenido cuando esté listo, asignándole la información de envío.<br>
  <strong>Por entregar:</strong> Ya enviaste los productos o servicios al creador de contenido y solo falta que le sea entregado.<br>
  `,
  [FAQ_QUESTION_WHAT_IS_STORE]: "¿Qué es una tienda?",
  [FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION]:
    "Una tienda es una sucursal física donde los creadores de contenido pueden redimir las invitaciones que les envías para obtener productos o servicios de tu marca y generar contenido desde tus instalaciones.",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS]: "¿Cuáles roles existen?",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION]: `Puedes crear diferentes usuarios para que accedan a tu panel de marca, existen dos roles: <br><br>
  <strong>Administrador:</strong> El administrador puede gestionar todo las invitaciones a creadores de contenidos, solicitudes, embajadores, ordenes, campañas, etc. También puede modificar la información de tu marca y crear más usuarios.<br>
  <strong>Operador:</strong> El operador es el que se encarga de recibir al creador si asistirá a una de tus tiendas, por lo que podrá efectuar la redención del código, gestionar las ordenes en sus tres estados y ver el menú.<br>
  `,
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS]:
    "¿Le entrego los productos y debo hacer algo adicional en la plataforma?",
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION]: `No debes hacer nada adicional. Únicamente ingresas el código en la sección de "Redimir Código", verificas el valor de la invitación y le entregas los productos.<br><br>
    
  <strong>1.</strong> Selecciona la tienda en la parte superior derecha.<br>
  <strong>2.</strong> Ingresa el código que te suministra el creador de contenido en el momento que llega a la tienda..<br>
  <strong>3.</strong> Valida código y su respectivo valor.`,
  [FAQ_QUESTION_MUST_CALL_ADMIN]:
    "¿Debo llamar al propietario del negocio a verificar las invitaciones?",
  [FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION]:
    "No te debes comunicar. Si cuando ingresas el código, la plataforma te lo acepta, eso quiere decir que el propietario del negocio, tu jefe directo o el administrador; ya le hizo una invitación a ese Creador de Contenido anteriormente y está aprobado por esa persona.",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE]:
    "¿Qué pasa si el creador de contenido redime el código y no completa el valor total de la invitación?",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION]:
    "Una vez redimen, el código se expira automáticamente, esto quiere decir que ese código no funciona para una siguiente ocasión",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS]:
    "¿Cuáles son las diferencias entre la modalidad de canje y las campañas pagas?",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION]: `La diferencia principal es que en la <strong>modalidad de canje</strong>, los creadores de contenido tienen más libertad para elegir cómo hacer el contenido, generando una colaboración más orgánica y natural. En cambio, en las <strong>campañas pagas</strong>, las marcas pueden establecer reglas más estrictas sobre cómo se debe hacer el contenido y el creador debe seguir esos lineamientos para aprobarse el contenido.`,
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS]:
    "¿Cómo puedo asegurarme de que los creadores comprendan y acepten los términos del canje?",
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION]: `Para asegurarse de que los creadores de contenido comprendan y acepten los términos del canje, puedes hacer lo siguiente:<br><br>
    <strong>1.</strong> Revisar el perfil y las métricas del creador para saber si el contenido que generalmente hace está alineado con lo que buscas.<br>
    <strong>2.</strong> El comentario de la invitación debe ser claro y fácil de entender.<br>
    <strong>3.</strong> Una vez envíes la invitación, puedes enviarle un mensaje al creador de contenido para establecer una comunicación más directa y aclarar cualquier duda que tenga para hacer el contenido.<br>
    `,

  /*MODAL BRAND SETUP*/
  [MODAL_BRAND_SETUP_TITLE]:
    "¿Deseas reconfigurar y actualizar la información de tu marca?",
  [MODAL_BRAND_SETUP_DESCRIPTION]:
    "Los siguientes usuarios serán afectados por este cambio:",
  [BRAND_SETUP_EXTRACTION_WARNING_MESSAGE]:
    "No logramos extraer algunos datos. Esto se debe a que algunas páginas utilizan mecanismos que bloquean el acceso automatizado a la información, por lo que tendrás que ingresar la información manualmente.",
  [BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION]:
    "Analizando tu sitio web para entender tu marca...",
  [BRAND_SETUP_LOADING_ANALYZING_BRAND]:
    "Analizando tono, propuesta de valor y elementos clave de tu marca...",
  [BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE]:
    "Construyendo el perfil de tu marca...",
  [BRAND_SETUP_LOADING_FINALIZING_DETAILS]:
    "Organizando toda la información para completar tu configuración...",
  [BRAND_SETUP_GENERATION_PROMPT_LABEL]: "Enfoque o contexto extra (opcional)",
  [BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER]:
    "Ejemplo: enfócate en la prueba de 14 días, habla a dueños de tiendas y evita claims de descuento",
  [BRAND_SETUP_GENERATION_ATTACH_PDF]: "Adjuntar un PDF",
  [BRAND_SETUP_GENERATION_PDF_HINT]:
    "Opcional. Un PDF, hasta 20 MB. Se analiza junto con tu sitio web y tus notas.",
  [BRAND_SETUP_GENERATION_REMOVE_PDF]: "Quitar {{name}}",
  [BRAND_SETUP_GENERATION_PDF_INVALID]: "Usa un archivo PDF.",
  [BRAND_SETUP_GENERATION_PDF_TOO_LARGE]:
    "El PDF debe pesar {{maxMb}} MB o menos.",
  [BRAND_SETUP_GENERATION_SHOW_ADVANCED]: "Agregar un PDF o contexto extra",
  [BRAND_SETUP_GENERATION_HIDE_ADVANCED]: "Ocultar PDF y contexto extra",
  [BRAND_SETUP_VERSION_CURRENT]: "Actual",
  [BRAND_SETUP_VERSION_LABEL]:
    "V{{versionNumber}} - {{date, dd/MM/yyyy HH:mm}}",
  [BRAND_SETUP_VERSION_PLACEHOLDER]: "Versión",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE]: "Identidad Visual",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION]:
    "Todo lo que define cómo se ve tu marca",
  [BRAND_SETUP_GROUP_AUDIENCE_TITLE]: "Audiencia y Competidores",
  [BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION]:
    "A quién le hablas y en qué contexto",
  [BRAND_SETUP_GROUP_COPY_TITLE]: "Mensaje de Marca",
  [BRAND_SETUP_GROUP_COPY_DESCRIPTION]:
    "Cómo habla tu marca y qué valor ofreces",
  [BRAND_INSIGHTS_TAB_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_DESCRIPTION]:
    "Descubre los aprendizajes que la IA identificó a partir de los resultados de tus campañas. Aplícalos a la configuración de tu marca.",
  [BRAND_INSIGHTS_POSITIVE_TITLE]: "Repetir",
  [BRAND_INSIGHTS_NEGATIVE_TITLE]: "Evitar",
  [BRAND_INSIGHTS_POSITIVE_SUBTITLE]:
    "Estrategias que ya están funcionando. Haz más de esto.",
  [BRAND_INSIGHTS_NEGATIVE_SUBTITLE]:
    "Estrategias que no están funcionando. Evita repetirlas.",
  [BRAND_INSIGHTS_TOPIC_ANGLE]: "Ángulo",
  [BRAND_INSIGHTS_TOPIC_COPY]: "Copy",
  [BRAND_INSIGHTS_TOPIC_CTA]: "CTA",
  [BRAND_INSIGHTS_TOPIC_TONE]: "Tono",
  [BRAND_INSIGHTS_TOPIC_AESTHETIC]: "Estética",
  [BRAND_INSIGHTS_TOPIC_VALUE_PROP]: "Propuesta de valor",
  [BRAND_INSIGHTS_EMPTY]: "Aún no hay aprendizajes para tu marca",
  [BRAND_INSIGHTS_REVIEW_CHANGE]: "Revisar",
  [BRAND_INSIGHTS_DISMISS]: "Descartar",
  [BRAND_INSIGHTS_DISMISS_ALERT_TITLE]: "¿Estás seguro?",
  [BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION]:
    "Se descartará este aprendizaje y no podrás recuperarlo.",
  [BRAND_INSIGHTS_COUNT]: "{{count}} aprendizajes",
  [BRAND_INSIGHTS_UNREAD_ONE]: "1 Nuevo",
  [BRAND_INSIGHTS_UNREAD_OTHER]: "{{count}} Nuevos",
  [BRAND_INSIGHTS_APPLY_TITLE]: "Aplicar Cambio",
  [BRAND_INSIGHTS_APPLY_LOADING]:
    "La IA está proponiendo un cambio a la configuración de tu marca.",
  [BRAND_INSIGHTS_APPLY_CONFIRM]: "Aplicar",
  [BRAND_INSIGHTS_APPLY_CANCEL]: "Cancelar",
  [BRAND_INSIGHTS_APPLY_REJECTED]:
    "No se pudo proponer un cambio seguro en la configuración de marca.",
  [BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG]:
    "Este insight ya está reflejado en la configuración de tu marca.",
  [BRAND_INSIGHTS_APPLY_UNMAPPABLE]:
    "Este insight no encaja en ningún campo de la configuración de tu marca, ya que es algo operativo o de cómo administrar tus campañas.",
  [BRAND_INSIGHTS_APPLY_REWRITE]:
    "No pudimos generar una propuesta. Inténtalo de nuevo.",
  [BRAND_INSIGHTS_APPLY_RETRY]:
    "No pudimos generar una propuesta. Inténtalo de nuevo.",
  [BRAND_INSIGHTS_APPLY_TIMEOUT]:
    "La propuesta está tardando más de lo normal. Inténtalo de nuevo en unos minutos.",
  [BRAND_INSIGHTS_APPLY_FIELD]: "Campo",
  [BRAND_INSIGHTS_APPLY_RESULT_TITLE]: "Cómo queda el campo",
  [BRAND_INSIGHTS_APPLY_SHOW_FULL]: "Ver texto completo",
  [BRAND_INSIGHTS_APPLY_SHOW_CHANGES]: "Ver solo los cambios",
  [BRAND_INSIGHTS_APPLY_NO_CHANGES]:
    "La propuesta no cambia nada en el campo actual.",
  [BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED]: "[…{{count}} palabras sin cambios…]",

  [LIST_CREATORS_WITH_AUDIENCE_SIMILAR]:
    "Listado de creadores con audiencias similares",
  [AUDIENCE_INFORMATION]: "Información de la audiencia",
  [AUDIENCE_CREDIBILITY]: "Credibilidad de la audiencia",
  [AUDIENCE_CREDIBILITY_TITLE_EXPLANATION]:
    "¿Qué es la credibilidad de la audiencia?",
  [AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION]:
    "La credibilidad de la audiencia es un indicador que determina el porcentaje de seguidores que son perfiles reales o validos, es decir, se excluyen bots o perfiles fraudulentos. Entre mayor sea el porcentaje más confiable será la audiencia del creador de contenido.",
  [AUDIENCE_BY_COUNTRY]: "Audiencia por país",
  [AUDIENCE_BY_CITIES]: "Audiencia por ciudades",
  [AUDIENCE_BY_BRAND_AFFINITY]: "Afinidad de marcas",
  [AUDIENCE_BY_INTERESTS]: "Intereses",
  [AUDIENCE_BY_DISTRIBUTION_AGE]: "Distribución de edades y géneros",
  [AUDIENCE_BY_PERCENTAGE_GENDERS]: "Porcentaje de géneros",
  [AUDIENCE_BY_SIMILAR_AUDIENCE]: "Perfiles similares",
  [AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND]:
    "No se encontraron perfiles similares",
  [GALLERY_CONTENT_BUZZLY]: `Portafolio`,

  /* LIST MENU*/
  [MENU_CONNECTED_ACCOUNTS]: "Cuentas conectadas",
  [MENU_PLATFORM]: "Canje",
  [MENU_MEDIA]: "Contenido",
  [MENU_SERVICES]: "Herramientas",
  [MENU_ACTIONS]: "Gestión",
  [MENU_CONFIGURATION]: "Configuración",
  [MENU_ADMINISTRATION]: "Administración",
  [SUB_MENU_CREATORS]: "Creadores",
  [SUB_MENU_PUBLICATIONS]: "Colaboraciones",
  [SUB_MENU_EVENTS]: "Eventos",
  [SUB_MENU_CAMPAIGNS]: "Campañas",
  [SUB_MENU_ADS_CAMPAIGNS]: "{{NAME_BUSINESS}} Ads",
  [SUB_MENU_REPORTS]: "Reportes",
  [SUB_MENU_DISCOVERY]: "Explorar",
  [SUB_MENU_SOCIAL_FEED]: "Social feed",
  [SUB_MENU_GALLERY]: "Galería",
  [SUB_MENU_REDEEM_CODE]: "Redimir código",
  [SUB_MENU_ORDERS]: "Órdenes",
  [SUB_MENU_ACCOUNT]: "Cuenta",
  [SUB_MENU_STORES]: "Mis tiendas",
  [SUB_MENU_MENU]: "Catálogo",
  [SUB_MENU_USERS]: "Usuarios",
  [SUB_MENU_BILLING_AND_PAYMENTS]: "Facturación",
  [SUB_MENU_BILLING_DASHBOARD]: "Pagos",
  [SUB_MENU_BILLING_DATA]: "Información",
  [SUB_MENU_USERS_OWNER]: "Usuarios",
  [SUB_MENU_BRANDS]: "Marcas",
  [SUB_MENU_BRAND_SIGNUPS]: "Registros de marcas",
  [SUB_MENU_CREATORS_OWNER]: "Creadores",
  [SUB_MENU_CREATORS_EXTERNALS]: "Creadores externos",
  [SUB_MENU_PAY_CREATORS]: "Pagos a creadores",
  [SUB_MENU_CREATOR_SIGNUPS]: "Registro de creadores",
  [SUB_MENU_CONTENTS]: "Contenidos",
  [SUB_MENU_DELIVERIES]: "Deliveries",
  [SUB_MENU_CONTENT_APPLICATION]: "Aplicación de contenido",
  [SUB_MENU_REPORTS_OWNER]: "Reportes",
  [SUB_MENU_FEEDBACK]: "Feedback",
  [SUB_MENU_PAYMENTS_FAILED]: "Pagos fallidos",

  /*DATE*/
  [MONTH_SHORT]: "{{date,monthTextShort}}",
  [DATE_DAY_AND_MONTH_SHORT]: "{{date, day}} {{date,monthTextShort}}",
  [DATE_HOUR]: "{{date, hour}}",
  [DATE_SHORT]: "{{date, day}} de {{date, monthText}}, {{date, year}}",
  [DATE_SHORT_2]: "{{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [DATE_RELATIVE]: "{{date, relative}}",
  [DATE_SHORT_LOCALIZED]: "{{date, short}}",
  [DATE_LONG]: "{{date, day}}/{{date,month}}/{{date,year}} {{date,hour}}",
  [DATE_LONG_TEXT]:
    "{{date,dayText}} {{date, day}} de {{date,monthText}} de {{date,year}}",
  [DATE_LONG_TEXT_2]:
    "{{date,dayTextLong}} {{date, day}} de {{date,monthText}} de {{date,year}}",
  [DATE_LONG_TEXT_WITH_HOUR]:
    "{{date,dayText}} {{date, day}} de {{date,monthText}} de {{date,year}} {{date,hour}}",
  [DATE_LONG_LOCALIZED]: "{{date, long}}",
  [DATE_DISTANCE]: "{{date, ago}}",
  [RENEWED_ON]: "Se renuevan el: {{date,short}}",
  [EXPIRE_ON]: "Expiran el: {{date,short}}",
  [LAST_UPDATE_DATE]: "Última actualización: {{date, short}}",
  [LAST_UPDATE_DATE_SHORT]:
    "Actualizado el {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [PUBLISHED_DATE]: "Publicado: {{date, short}}",

  /*CURRENCY*/
  [VALUE_WITH_CURRENCY]: "{{value,number}} {{currency}}",
  [VALUE_WITH_PERCENTAGE]: "{{value, number}}%",
  [NUMBER_CURRENCY]: "{{value,currency}}",
  [VALUE_SUBSCRIPTION_3_DAYS_FREE]: "3 días gratis",
  [VALUE_SUBSCRIPTION_MONTHLY]: "{{value,number}} {{currency}}/mes",
  [VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT]:
    "Pago único anual de {{value,number}} {{currency}}",
  [VALUE_SUBSCRIPTION_PRORATED]: "{{value,currency}} ahora",
  [VALUE_SUBSCRIPTION_AFTER_PRORATED]:
    "{{value,currency}}/mes desde el {{date,short}}",
  [VALUE_EXPRESSED_IN]: "Valor expresado en {{currency}}",
  [VALUE_NUMBER]: "{{value,number}}",
  [VALUE_WITH_CURRENCY_MANUAL_FORMAT]: "${{value,number}} {{currency}}",

  /*BUTTON*/
  [BUTTON_RETRY]: "Reintentar",
  [BUTTON_RETRY_PUBLISHING]: "Reintentar Publicación",
  [BUTTON_INVITE]: "Invitar",
  [BUTTON_VIEW_INVITE]: "Ver invitación",
  [BUTTON_EDIT_INVITE]: "Editar invitación",
  [BUTTON_CANCEL_INVITE]: "Cancelar invitación",
  [BUTTON_VIEW_REQUEST]: "Ver solicitud",
  [BUTTON_START_NOW]: "Iniciar ahora",
  [BUTTON_REJECT_REQUEST]: "Rechazar solicitud",
  [BUTTON_ORDER_IN_PROCESS]: "Orden en proceso",
  [BUTTON_VIEW_COLLABORATION]: "Ver colaboración",
  [BUTTON_VIEW_METRICS]: "Ver métricas",
  [BUTTON_VIEW_REPORT]: "Ver reporte",
  [BUTTON_INIT_CHAT]: "Enviar mensaje",
  [BUTTON_ADD_REFERENCE_PROFILE]: "Agregar perfil de referencia",
  [BUTTON_USE_AS_REFERENCE_PROFILE]: "Usar como perfil de referencia",
  [BUTTON_ADD_AS_REFERENCE]: "Agregar como referencia",
  [BUTTON_ADDED]: "Agregado",
  [BUTTON_DOWNLOAD]: "Descargar",
  [BUTTON_DOWNLOAD_PDF]: "Descargar PDF",
  [BUTTON_CALCULATE]: "Calcular",
  [BUTTON_ENTERPRISE_CALCULATE]: "Calcular para empresarial",
  [BUTTON_REDEEM_CODE]: "Redimir",
  [BUTTON_ADD_STORE]: "Agregar tienda",
  [BUTTON_SEARCH]: "Buscar",
  [BUTTON_ACCEPT_ORDER]: "Aceptar orden",
  [BUTTON_REJECT_ORDER]: "Rechazar orden",
  [BUTTON_READY_ORDER]: "Orden lista",
  [BUTTON_DELIVER_ORDER]: "Orden entregada",
  [BUTTON_CANCEL]: "Cancelar",
  [BUTTON_DISCARD]: "Descartar",
  [BUTTON_VIEW]: "Ver",
  [BUTTON_CREATE_CAMPAIGN]: "Crear",
  [BUTTON_CREATE_CAMPAIGN2]: "Crear Campaña",
  [BUTTON_LAUNCH_AD]: "Lanzar Ad",
  [BUTTON_CREATE_CONTENT]: "Crear Contenido",
  [BUTTON_SAVE_PROGRESS]: "Guardar progreso",
  [BUTTON_NEXT]: "Siguiente",
  [BUTTON_PREVIOUS]: "Regresar",
  [BUTTON_ADVANCED_CONFIGURATION]: "Configuración avanzada",
  [BUTTON_FINISH]: "Finalizar",
  [BUTTON_URL]: "URL",
  [BUTTON_UPLOAD]: "Subir",
  [BUTTON_UPLOAD_FILES]: "Subir Archivos",
  [BUTTON_UPLOAD_FOLDER]: "Subir Carpeta",
  [BUTTON_UPLOAD_CONTENT]: "Subir contenido",
  [BUTTON_UPLOAD_DOCUMENT]: "Subir documento",
  [BUTTON_REMOVE_CONTENT]: "Eliminar contenido",
  [DELETE_CONTENT_CONFIRMATION_TITLE]: "Eliminar Contenido",
  [DELETE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar este contenido? Esta acción es definitiva y no podrás deshacerla.",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE]:
    "Eliminar contenidos seleccionados",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar {{count}} contenidos seleccionados? Esta acción es definitiva y no podrás deshacerla.",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE]: "Eliminar Contenido Agendado",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de que deseas eliminar este contenido agendado? Si continúas, se eliminará del calendario y no se realizará la publicación programada.",
  [DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION]:
    "No se pudo eliminar este contenido agendado.",
  [DELETE_SCHEDULED_CONTENT_SUCCESS]:
    "Publicación programada eliminada correctamente",
  [BUTTON_DELETE_CONTENT]: "Eliminar",
  [BUTTON_FINISHED_CAMPAIGN]: "Finalizar campaña",
  [BUTTON_SAVE_CAMPAIGN]: "Guardar campaña",
  [BUTTON_DEACTIVATE_CAMPAIGN]: "Desactivar campaña",
  [BUTTON_ACTIVATE_CAMPAIGN]: "Activar campaña",
  [BUTTON_SEND_INVITE]: "Enviar invitación",
  [BUTTON_REJECT]: "Rechazar",
  [BUTTON_ACCEPT]: "Aceptar",
  [BUTTON_ACCEPT_AND_PAY]: "Pagar ahora",
  [BUTTON_ASSIGN_INVITE]: "Asignar invitación",
  [BUTTON_REVIEW_CONTENT]: "Revisar contenido",
  [BUTTON_VIEW_PRELIMINARY_CONTENT]: "Revisar",
  [BUTTON_VIEW_APPLICANT]: "Ver aplicante",
  [BUTTON_REVIEW]: "Calificar",
  [BUTTON_ACCEPT_CONTENT]: "Aceptar contenido",
  [BUTTON_REJECT_CONTENT]: "Rechazar y no Reembolsar",
  [BUTTON_SEND_REVIEW]: "Mandar revisiones",
  [BUTTON_CONTINUE]: "Continuar",
  [BUTTON_SIGN_UP]: "Registrarse",
  [BUTTON_CONTINUOUS]: "Continua",
  [BUTTON_CONTINUE_WITHOUT_CHANGES]: "Continuar sin Cambios",
  [BUTTON_RESIZE_AND_CONTINUE]: "Redimensionar y Publicar",
  [BUTTON_UNDERSTOOD]: "Entendido",
  [BUTTON_MORE_QUESTIONS]: "Tengo más preguntas",
  [BUTTON_INIT_TUTORIAL]: "Iniciar tutorial",
  [BUTTON_PAYMENTS]: "Pagos",
  [BUTTON_BROADCAST]: "Broadcast",
  [BUTTON_SAVE]: "Guardar",
  [BUTTON_SEND_MESSAGE]: "Chatear ahora",
  [BUTTON_UPLOAD_FILE]: "Subir archivo",
  [BUTTON_REMOVE_FILE]: "Eliminar archivo",
  [BUTTON_VERIFY_PUBLICATION]: "Verificar publicación",
  [BUTTON_SEE_PUBLICATION_ON]: "Ver en {{value}}",
  [BUTTON_METRICS_READY]: "Métricas listas",
  [BUTTON_UPLOAD_TIKTOK]: "Subir en TikTok",
  [BUTTON_VIEW_PROFILE]: "Ver perfil",
  [BUTTON_GENERATE_DESCRIPTION]: "Generar descripción",
  [BUTTON_GENERATE_COMMENT]: "Generar comentario",
  [BUTTON_UPLOAD_IMAGE]: "Subir imagen",
  [BUTTON_REMOVE_IMAGE]: "Eliminar imagen",
  [BUTTON_SAVE_CHANGES]: "Guardar cambios",
  [BUTTON_UPLOAD_VIDEO]: "Subir vídeo",
  [BUTTON_REMOVE_VIDEO]: "Eliminar vídeo",
  [BUTTON_DISCONNECT]: "Desconectar",
  [BUTTON_CONNECT_TIKTOK]: "Conectar TikTok",
  [BUTTON_CONNECT_TIKTOK_BUSINESS]: "Conectar TikTok Business",
  [BUTTON_BE_ECOMMERCE]: "Siempre abierto",
  [BUTTON_NOT_BE_ECOMMERCE]: "Editar horarios",
  [BUTTON_ADD_TURN]: "Agregar turno",
  [BUTTON_DELETE]: "Eliminar",
  [BUTTON_ARCHIVE_CAMPAIGN]: "Archivar",
  [BUTTON_CREATE]: "Crear",
  [BUTTON_CONNECT_WOOCOMMERCE]: "Conectar WooCommerce",
  [BUTTON_CREATE_USER]: "Crear usuario",
  [BUTTON_CREATE_ACCOUNT]: "Crear Cuenta",
  [MODAL_CREATE_ACCOUNT_TITLE]: "¿Cuál es tu correo electrónico?",
  [MODAL_CREATE_ACCOUNT_DESCRIPTION]:
    "Vincula tu cuenta con un correo electrónico y contraseña para mantener tu acceso.",
  [BUTTON_CREATE_CONTACT]: "Crear contacto",
  [BUTTON_VIEW_DETAILS]: "Ver detalles",
  [BUTTON_DOWNLOAD_INVOICE]: "Descargar factura",
  [BUTTON_CLOSE]: "Cerrar",
  [BUTTON_UPLOAD_CATALOG]: "Subir catálogo",
  [BUTTON_COPY_CATALOG]: "Copiar catálogo",
  [BUTTON_DOWNLOAD_FORMAT]: "Descargar formato",
  [BUTTON_DUPLICATE]: "Duplicar",
  [BUTTON_DUPLICATE_IN_SAME_GROUP]: "En el mismo grupo",
  [BUTTON_DUPLICATE_IN_OTHER_AD_GROUP]:
    "Otra campaña o grupo de esta u otra campaña",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE]: "Duplicar tu Anuncio",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION]:
    "Selecciona la campaña y el grupo de anuncios destino donde se duplicará el anuncio.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este anuncio en otra campaña te sacará de la campaña actual. Los cambios no publicados o no guardados de la campaña actual se perderán.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL]: "Campaña",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER]: "Selecciona una campaña",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL]: "Grupo de anuncios",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER]:
    "Selecciona un grupo de anuncios",
  [DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS]:
    "No hay grupos de anuncios disponibles para esta campaña",
  [BUTTON_DUPLICATE_IN_SAME_CAMPAIGN]: "En la misma campaña",
  [BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN]: "En otra campaña",
  [DUPLICATE_AD_GROUP_MODAL_TITLE]: "Duplicar tu Grupo de Anuncios",
  [DUPLICATE_AD_GROUP_MODAL_DESCRIPTION]:
    "Selecciona la campaña destino donde se duplicará el grupo de anuncios.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este grupo de anuncios en otra campaña te sacará de la campaña actual. Los cambios no publicados o no guardados de la campaña actual se perderán.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH]:
    "La campaña seleccionada no comparte el mismo objetivo o tipo de campaña. Selecciona una campaña con el mismo objetivo o tipo.",
  [DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH]:
    "La campaña seleccionada no comparte el mismo formato de anuncio. Selecciona una campaña con el mismo formato.",
  [DUPLICATE_ASSETS_GROUP_MODAL_TITLE]: "Duplicar tu Grupo de Recursos",
  [DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION]:
    "Selecciona la campaña destino donde se duplicará el grupo de recursos.",
  [DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este grupo de recursos en otra campaña te sacará de la campaña actual. Los cambios no publicados o no guardados de la campaña actual se perderán.",
  [BUTTON_EDIT]: "Editar",
  [BUTTON_MOVE_OTHER_CATEGORY]: "Mover a otra categoría",
  [BUTTON_COPY]: "Copiar",
  [BUTTON_REGISTER]: "Registrarse",
  [BUTTON_NO_HAVE_DOCUMENT]: "No tengo este documento",
  [BUTTON_UPLOAD_AFTER]: "Subir después",
  [BUTTON_INVITED]: "Invitado",
  [BUTTON_YES_I_SURE]: "Sí, estoy seguro",
  [BUTTON_SEND_REVISION]: "Enviar revisión",
  [BUTTON_APPROVE_CONTENT]: "Reembolsar Creditos",
  [BUTTON_UPLOAD_INSTAGRAM]: "Subir en Instagram",
  [BUTTON_CONNECT_INSTAGRAM]: "Conectar Instagram",
  [BUTTON_RELOAD_PAGE]: "Recargar página",
  [BUTTON_REPLACE_IMAGE]: "Reemplazar imagen",
  [BUTTON_GENERATE_CONTENT]: "Generar contenido",
  [BUTTON_REGENERATE_CONTENT]: "Regenerar contenido",
  [BUTTON_REGENERATE_TEXT]: "Regenerar textos",
  [BUTTON_UPLOAD_LOGO]: "Subir Logo",
  [BUTTON_REPLACE_LOGO]: "Reemplazar logo",
  [BUTTON_UPLOAD_BACKGROUND]: "Subir fondo",
  [BUTTON_REPLACE_BACKGROUND]: "Reemplazar fondo",
  [BUTTON_REMOVE_BACKGROUND]: "Eliminar fondo",
  [BUTTON_GENERATE_OTHER]: "Regenerar",
  [BUTTON_SUBSCRIBE_NOW]: "Suscribirse",
  [BUTTON_ADD_SHOP]: "Agregar tienda",
  [BUTTON_DOWNLOAD_REPORT]: "Descargar reporte",
  [BUTTON_PASS_TO_SUBSCRIPTION_BASIC]: "Cambiar a suscripción basic",
  [BUTTON_EXTEND]: "Extender",
  [BUTTON_ARCHIVE]: "Archivar",
  [BUTTON_UNARCHIVE]: "Desarchivar",
  [BUTTON_CREATE_TRANSACTION]: "Crear transacción",
  [BUTTON_UPDATE_STATISTICS]: "Actualizar estadísticas",
  [BUTTON_SEND_PAYMENT]: "Enviar pago",
  [BUTTON_CREATOR_CHAT]: "Chat de Creadores",
  [BUTTON_SEND_FILE]: "Enviar archivo",
  [BUTTON_SEE_MORE]: "Ver más",
  [BUTTON_SEE_LESS]: "Ver menos",
  [BUTTON_SEND]: "Enviar",
  [BUTTON_YOU_HAVE_DOUBTS]: "¿Tienes preguntas? Contáctanos",
  [BUTTON_WATCH_DEMO]: "Ver Demo",
  [BUTTON_SAVE_CONTENT]: "Guardar contenido",
  [BUTTON_SEND_BROADCAST]: "Enviar broadcast",
  [BUTTON_ADD_CONTENT]: "Agregar Contenido",
  [BUTTON_ADD_SELECTED_CONTENT]: "Agregar Contenido",
  [BUTTON_SEE_ALL_APPLICANTS]: "Ver todos los aplicantes",
  [BUTTON_GO_BACK]: "Ir atrás",
  [BUTTON_DISCARD]: "Descartar",
  [BUTTON_CLEAR_FILTERS]: "Limpiar filtros",
  [BUTTON_TIKTOK_BILLING]: "Facturación de TikTok",
  [BUTTON_META_BILLING]: "Facturación de Meta",
  [BUTTON_REPLACE_CONTENT]: "Reemplazar",
  [BUTTON_CHANGE_CONTENT]: "Cambiar Contenido",
  [BUTTON_EDIT_CONTENT]: "Editar",
  [BUTTON_CHANGE_SLIDE]: "Cambiar Slide",
  [PLATFORM_ONLY_ACCEPTS_VIDEOS]: "{{platform}} solo acepta videos",
  [BUTTON_SELECT_VIDEO]: "Seleccionar un Vídeo",
  [BUTTON_REPLACE_VIDEO]: "Reemplazar Vídeo",
  [BUTTON_SELECT_THIS_CONTENT]: "Seleccionar este Contenido",
  [BUTTON_REMOVE_SELECTION]: "Eliminar Selección",
  [BUTTON_RECHARGE_BALANCE]: "Recargar Saldo",
  [BUTTON_CONNECT_SHOPIFY]: "Conectar Shopify",
  [BUTTON_CONNECT_META]: "Conectar Meta",
  [BUTTON_CONTACT_AN_ADVISOR]: "Necesito Ayuda",
  [BUTTON_GENERATE_SCRIPT]: "Generar Guión",
  [BUTTON_VIEW_INVOICE]: "Ver Factura",
  [BUTTON_ADJUST_PREFERENCES]: "Ajustar Preferencias",
  [BUTTON_GENERATE_AGAIN]: "Generar de Nuevo",
  [BUTTON_CREATE_ADS_CAMPAIGN]: "Crear Campaña",
  [BUTTON_EDIT_BUDGET]: "Editar Presupuesto",
  [BUTTON_PUBLISH_CAMPAIGN]: "Publicar Campaña",
  [BUTTON_START_CHAT]: "Chatear ahora",
  [BUTTON_SELECT_CONTENT]: "Seleccionar contenido",
  [BUTTON_SELECT_DOCUMENT]: "Seleccionar documentos",
  [BUTTON_SELECT_POST]: "Seleccionar Publicación",
  [BUTTON_CREATE_WITH_CANVA]: "Crear con Canva",
  [BUTTON_CREATE_WITH_IA]: "Crear",
  [BUTTON_CONNECT_CANVA]: "Conectar Canva",
  [BUTTON_USE_THIS_CONTENT]: "Usar este Contenido",
  [BUTTON_CONNECT_GOOGLE]: "Conectar Google",
  [BUTTON_CONNECT_GOOGLE_DRIVE]: "Conectar Google Drive",
  [BUTTON_SELECT]: "Seleccionar",
  [BUTTON_DESELECT]: "Deseleccionar",
  [BUTTON_SEND_CODE]: "Enviar Código",
  [BUTTON_VERIFY_CODE]: "Verificar",
  [BUTTON_RESEND_CODE]: "Reenviar",
  [BUTTON_CONNECTED]: "Conectado",
  [BUTTON_DISCONNECTED]: "Desconectado",
  [BUTTON_ADD_RE_TARGETING]: "Añadir Audiencia",
  [BUTTON_BUY_PLAN]: "Comprar {{value}}",
  [BUTTON_ADD]: "Agregar",
  [BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS]: "Subir desde Redes Sociales",
  [BUTTON_UPDATE]: "Actualizar",
  [BUTTON_CONNECT_ACCOUNT]: "Conectar Cuenta",
  [BUTTON_REPLACE]: "Reemplazar",
  [BUTTON_SUPPORT]: "Soporte",
  [BUTTON_CANCEL_SUBSCRIPTION]: "Cancelar Suscripción",
  [BUTTON_REACTIVATE_SUBSCRIPTION]: "Reactivar Suscripción",
  [BUTTON_CHANGE_PAYMENT_METHODS]: "Cambiar Método de Pago",
  [BUTTON_DELETE_PLATFORM]: "Eliminar Plataforma",
  [BUTTON_GENERATE_WITH_AI]: "Generar con IA",
  [BUTTON_SELECT_AVATAR]: "Seleccionar Avatar",
  [BUTTON_CHANGE_AVATAR]: "Cambiar Avatar",
  [BUTTON_CONTACT_US]: "Contáctanos",
  [BUTTON_GENERATE_RANDOM]: "Generar Aleatorio",
  [BUTTON_GENERATE]: "Generar",
  [BUTTON_REGISTER_WITH_GOOGLE]: "Registrarse con Google",
  [BUTTON_LOG_IN_WITH_GOOGLE]: "Acceder con Google",
  [BUTTON_CHANGE_LOGO]: "Cambiar Logo",
  [BUTTON_DELETE_LOGO]: "Borrar Logo",
  [BUTTON_UPGRADE_PLAN]: "Actualizar a {{value}}",
  [BUTTON_UPGRADE_PLAN_2]: "Actualizar Plan",
  [LABEL_CURRENT_SUBSCRIPTION_PLAN]: "Plan Actual",
  [BUTTON_UPGRADE_TO_PAID_PLAN]: "Cambiar a un Plan de Pago",
  [BUTTON_BOOK_A_DEMO]: "Agendar un Demo",
  [BUTTON_APPLY_OPTIMIZATIONS]: "Aplicar Optimizaciones",
  [BUTTON_OPTIMIZATION_APPLIED]: "Optimización Aplicada",
  [BUTTON_DISCARD_OPTIMIZATIONS]: "Descartar Optimizaciones",
  [BUTTON_CHANGES_APPLIED]: "Cambios Aplicados",
  [BUTTON_APPLY_CHANGES]: "Aplicar Cambios",
  [BUTTON_PREVIEW_CHANGES]: "Revisar Cambios",
  [BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION]:
    "¿Estás seguro que deseas descartar las optimizaciones?",
  [BUTTON_CREATE_TEMPLATE]: "Crear Plantilla",
  [BUTTON_EDIT_TEMPLATE]: "Editar Plantilla",
  [BUTTON_VIEW_DETAILED_REPORT]: "Ver reporte detallado",
  [BUTTON_SELECT_INSTANT_FORM]: "Seleccionar Formulario",
  [BUTTON_RECONNECT_ACCOUNT]: "Reconectar cuenta",
  [BUTTON_RECONNECT]: "Reconectar",
  [BUTTON_ADD_CONVERSION_ACTION]: "Agregar acción de conversión",
  [BUTTON_FILTER]: "Filtrar",
  [BUTTON_CONNECT_LINKEDIN]: "Conectar LinkedIn",
  [BUTTON_REMOVE]: "Eliminar",
  [BUTTON_TRY_AGAIN]: "Intentar de Nuevo",
  [BUTTON_PUBLISH_CHANGES]: "Publicar Cambios",
  [BUTTON_ANALYZE]: "Analizar",
  [BUTTON_DROP_PIN]: "Marcar Pin",
  [BUTTON_EDIT_PLACEMENTS]: "Editar ubicaciones",
  [BUTTON_EDIT_ADVANTAGE_ENHANCES]: "Editar mejoras advantage",
  [BUTTON_COMPLETE_INFORMATION]: "Completar Información",
  [BUTTON_ADD_KEYWORDS]: "Agregar",
  [BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS]:
    "Seleccionar publicación de redes sociales",
  [BUTTON_CREATE_NEW]: "Crear uno nuevo",
  [BUTTON_PREVIEW_OPTIMIZATION]: "Revisar Optimización",
  [BUTTON_CHANGE_CREATIVE]: "Cambiar Creativo",
  [BUTTON_APPLIED]: "Aplicado",
  [BUTTON_SKIP]: "Omitir",
  [BUTTON_ADD_VIDEO]: "Agregar video",
  [BUTTON_CREATE_FROM_SCRATCH]: "Crear con IA",
  [BUTTON_CREATE_FROM_TEMPLATES]: "Desde Plantillas",
  [BUTTON_IMPORT_FROM_PLATFORM]: "Importar",
  [BUTTON_IMPORT_FROM_GOOGLE_DRIVE]: "Importar Desde Google Drive",
  [BUTTON_IMPORT_CAMPAIGN]: "Importar Campaña",
  [BUTTON_DUPLICATE_FROM_PLATFORM]: "Duplicar",
  [BUTTON_DUPLICATE_CAMPAIGN]: "Duplicar Campaña",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE]: "Duplicar Campaña",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION]:
    "Selecciona una campaña de tu plataforma para duplicar su estructura como borrador",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE]: "Campaña Duplicada",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "La estructura de la campaña se duplicó como borrador. Revísala y publícala cuando estés listo.",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "Solo puedes importar campañas de {{types}}.",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "Solo puedes duplicar campañas de {{types}}.",
  [BUTTON_SAVE_AND_PUBLISH]: "Publicar Cambios",
  [BUTTON_ADD_SITE_LINK]: "Agregar enlace de sitio",
  [BUTTON_EDIT_SITE_LINKS]: "Editar enlaces de sitio",
  [BUTTON_SELECT_CSV_FILE]: "Subir archivo CSV",
  [BUTTON_DOWNLOAD_TEMPLATE]: "Descargar plantilla",
  [BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY]: "Subir desde Biblioteca de Google",
  [BUTTON_MARK_AS_DONE]: "Marcar como hecho",
  [BUTTON_SELECT_INSTANT_EXPERIENCE]: "Seleccionar experiencia",
  [BUTTON_VIEW_ACTION]: "Ver acción",
  [BUTTON_CREATE_CUSTOM_AUDIENCE]: "Crear Audiencia",
  [BUTTON_CLEAR_ALL]: "Borrar Todo",
  [BUTTON_RESET_TO_BASIC_METRICS]: "Mostrar Métricas Básicas",
  [BUTTON_GO_TO_BILLING]: "Ir a Facturación",
  [BUTTON_WHY_THIS_RECOMMENDATION]: "¿Por qué esta recomendación?",
  [BUTTON_CLEAR_DATES]: "Limpiar Fechas",
  [BUTTON_NEW_CAMPAIGN]: "Nueva Campaña",
  [BUTTON_DISCONNECT_ACCOUNT]: "Desconectar Cuenta",
  [BUTTON_SELECT_ALL]: "Seleccionar Todas",
  [BUTTON_DESELECT_ALL]: "Deseleccionar Todas",
  [BUTTON_USE_SAVED_AUDIENCE]: "Usar Audiencia Guardada",
  [BUTTON_ADD_PRODUCT]: "Agregar Producto",
  [BUTTON_ADD_SERVICE]: "Agregar Servicio",

  /*CATEGORIES*/
  [NEW_CREATORS_CATEGORY]: "Nuevos creadores",
  [FAVORITES_CATEGORY]: "Favoritos",
  [TOP_RATED_CATEGORY]: "Mejor calificados",

  //VERSION
  [NEW_VERSION_TITLE]: "¡Nueva versión disponible!",
  [NEW_VERSION_DESCRIPTION]:
    "Hemos lanzado una actualización de nuestra web que podría generar conflictos con tu versión actual. Te recomendamos recargar la página para obtener la última versión y evitar posibles errores.",

  [DESCRIPTION_SEND_MESSAGE]: "Chatea con este creador",
  [DESCRIPTION_SEND_PAYMENT]: "Envia un pago de forma segura",

  [MODAL_PAY_CREATOR_AMOUNT_LABEL]: "Cantidad a pagar",

  /*PAGES*/

  //CREATORS
  [CREATORS_TITLE]: "Creadores de Contenido",
  [CREATOR_DESCRIPTION]:
    "Encuentra y filtra creadores para colaborar en canje, enviar mensajes y pagos",
  [SEARCH_BAR_TEXT_CREATORS]: "Busca por nombre de usuario",
  [TAB_CREATORS]: "Creadores",
  [TAB_REQUESTS]: "Solicitudes",
  [TAB_SUGGESTED]: "Para ti",
  [CREATORS_SUGGESTED_EMPTY]:
    "No se encontraron creadores sugeridos, ajusta tus preferencias para encontrar creadores",
  [CREATORS_TABLE_COLUMN_NAME]: "Nombre",
  [CREATORS_TABLE_COLUMN_CITY]: "Ciudad",
  [CREATORS_TABLE_COLUMN_AUDIENCE]: "Audiencia",
  [CREATORS_TABLE_COLUMN_ENGAGEMENT]: "Engagement",
  [CREATORS_TABLE_COLUMN_DATE]: "Fecha",
  [CREATORS_TABLE_COLUMN_CATEGORIES]: "Categorias",
  [CREATORS_TABLE_COLUMN_SCORE]: "Puntuación",
  [CREATORS_TABLE_COLUMN_ACTIVITY]: "Actividad",
  [DISCOVER_NEW_CREATORS]: "Descubre nuevos creadores",

  [RECURRENT_FIELDS_DEFAULT_TITLE]:
    "¿Cada cuánto quieres invitar a este creador?",
  [RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER]: "Cada",
  [RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION]: "El valor mínimo es {{value}}",
  [RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION]:
    "La recurrencia máxima es de {{months}} meses o {{weeks}} semanas",
  [RECURRENT_FIELD_FREQUENCY_PLACEHOLDER]: "Escoge una opción",
  [RECURRENT_FIELD_DAY_AN_PLACEHOLDER]: "Un",
  [RECURRENT_FIELD_DAY_ALL_PLACEHOLDER]: "Todos los",
  [MODAL_BROADCAST_ARIAL_LABEL]: "Modal de Broadcast",
  [MODAL_BROADCAST_TITLE]: "Envía un Broadcast",
  [MODAL_BROADCAST_DESCRIPTION]: "Envíale un mensaje a todos tus embajadores",
  [MODAL_BROADCAST_SELECT_USER_PLACEHOLDER]: "Selecciona los usuarios",
  [MODAL_BROADCAST_SELECT_USER_REQUIRED]:
    "Debes seleccionar al menos un usuario",
  [MODAL_BROADCAST_MESSAGE_PLACEHOLDER]: "Mensaje",
  [BROADCAST_MESSAGE_SENT]: "Mensaje global enviado",
  [MODAL_BROADCAST_CONFIRM_TITLE]: "Enviar Broadcast",
  [MODAL_BROADCAST_CONFIRM_DESCRIPTION]:
    "¿Estás seguro que deseas enviar un mensaje a todos tus embajadores?",

  //PUBLICATIONS
  [PUBLICATIONS_TITLE]: "Colaboraciones",
  [PUBLICATIONS_DESCRIPTION]:
    "Revisa las colaboraciones que han realizado los creadores de contenido sobre tus productos",
  [PUBLICATIONS_TABLE_ARIA_LABEL]: "Tabla de Colaboraciones",
  [PUBLICATIONS_TABLE_COLUMN_DATE]: "Fecha",
  [PUBLICATION_STATUS_PENDING_CONTENT]: "Contenido Pendiente",
  [PUBLICATION_STATUS_PENDING_APPROVAL]: "Calificar",
  [PUBLICATION_STATUS_PENDING]: "Publicación pendiente",
  [PUBLICATION_STATUS_PENDING_SOCIAL]: "Publicación pendiente",
  [PUBLICATIONS_STATUS_PENDING_ANALYTICS]: "Analítica pendiente",
  [PUBLICATIONS_STATUS_SENT]: "Calificar",
  [PUBLICATIONS_STATUS_FEEDBACK]: "Feedback",
  [PUBLICATIONS_STATUS_VERIFIED]: "Verificada",

  //PUBLICATION
  [ADS_CONFIGURATION_APPS_TITLE]: "Configuración de Apps",
  [ADS_CONFIGURATION_DESTINATION_TITLE]: "Configuración de Destino",
  [PUBLICATION_TITLE]: "Publicación",
  [NUMBER_PUBLICATION]: "N° Publicación",
  [FEEDBACK_TITLE]: "Feedback",
  [PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION]:
    "Ahora puedes continuar con el tutorial de tiendas.",
  [PUBLICATION_FINISH_DESCRIPTION]:
    "Has completado el tutorial de la plataforma, ahora ya sabes como generar invitaciones.",
  [FEEDBACK_PLACEHOLDER]: "¿Cómo fue tu experiencia usando la plataforma?",
  [FEEDBACK_REASON_ABOUT]: "Review negativa sobre {{reason}}",
  [FEEDBACK_REASON]: "Motivo de la review negativa",
  [FEEDBACK_COMMENT]: "Comentario",
  [ANALYTICS_EXPLANATION_TITLE]: "¿Cómo interpretar las analíticas?",
  [ANALYTICS_EXPLANATION_DESCRIPTION]:
    " En las analíticas podrás determinar si el contenido que publicó el creador de contenido sobre tu marca generó uno resultados según tus criterios.",
  [ANALYTICS_EXPLANATION_DESCRIPTION_2]:
    "Las analíticas generalmente se dividen en diferentes secciones de información, pero las más importantes son las de resumen e interacciones. A continuación una explicación de los diferentes datos que tienen estas secciones.",
  [ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION]:
    "• <b>Cuentas alcanzadas</b>: son las diferentes cuentas de la red social a las que llegó la publicación en cuestión, se pueden dividir en seguidores y no seguidores, haciendo referencia a que sigan o no al creador de contenido.",
  [ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION]:
    "• <b>Cuentas que interactuaron</b>: son las cuentas que tuvieron algún tipo de interacción con la publicación, por ejemplo respuestas a las historias o veces que se compartió por parte de otros usuarios.",
  [ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION]:
    "• <b>Toques en etiquetas o stickers</b>: son el número de veces que se interactúo con la etiqueta o sticker de alguna publicación, por lo que los usuarios pudieron ver el perfil de tu marca.",
  [ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION]:
    "• <b>Navegación</b>: describe el comportamiento que tuvieron los usuarios con el contenido que el creador de contenido publicó, si abandonó la historia, si pasó a la siguiente sin esperar el tiempo de finalización, si se esperó todo el tiempo determinado de la historia o si retrocedió para ver la historia otra vez.",
  [RECURRENT_VALUE_NOT_FOUND]:
    "No se pudo obtener la recurrencia de la invitación por alguna razón, cambia los valores.",
  [MODAL_REVIEW_ARIA_LABEL]: "Modal para hacer review a un influencer",
  [MODAL_REVIEW_DISCLAIMER]:
    "Tu calificación no será compartida con el creador de contenido.",
  [MODAL_REVIEW_SCORE_PLACEHOLDER]:
    "Califica de 1 a 5 los resultados de este creador según tus expectativas.",
  [MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER]:
    "Califica la calidad y producción del contenido publicado.",
  [MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE]:
    "La calificación mínima del contenido es de 1 estrellas",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE]:
    "¿Cómo interpretar el contenido?",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION]:
    "Dale una calificación al creador de contenido basado en la calidad de la publicación - imagenes, texto o videos acerca de tu marca. Una estrella siendo que no estas satisfecho con el contenido y no lo vas a usar o descargar y cinco siendo que estas totalmente satisfech@ con el contenido y lo vas a usar y volver a publicar en tus canales o redes.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER]:
    "Califica el alcance y el engagement del contenido publicado.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE]:
    "La calificación mínima de las estadísticas es de 1 estrellas",
  [MODAL_REVIEW_COMMENT_PLACEHOLDER]:
    "Describe qué te pareció el contenido y el alcance de este creador",
  [REVISION_COUNT]: "Revisión {{count}}",
  [UPLOAD_NEW_CONTENT]: "Sube nuevo contenido",
  [ADD_URL_PUBLICATION]: "Agrega URL",

  //ADS CAMPAIGNS
  [ADS_CAMPAIGNS_TITLE]: "Campañas",
  [ADS_CAMPAIGNS_TITLE_DASHBOARD]: "Campañas",
  [ADS_CAMPAIGNS_DESCRIPTION]: "Gestiona y analiza tus campañas publicitarias",

  //ADS CAMPAIGN
  [ADS_CAMPAIGN_PREVIEW]: "Vista previa",
  [ADS_CAMPAIGN_TITLE]: "Información de la campaña",
  [ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE]: "Anuncio de {{platform}}",
  [ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE]:
    "Información del presupuesto general",
  [ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE]: "Información de Segmentación",
  [ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE]: "Audiencia Guardada",
  [ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE]:
    "Configuración adicional",
  [ADS_CAMPAIGN_HAS_BEEN_FINISHED]: "Esta campaña ha finalizado",
  [ADS_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campaña activada",
  [ADS_CAMPAIGN_HAS_BEEN_SAVE]: "Campaña guardada",
  [ADS_CAMPAIGN_HAS_BEEN_DUPLICATE]: "Campaña duplicada",
  [ADS_CAMPAIGN_USE_GENERAL_BUDGET]: "Usar un presupuesto general de campaña",
  [ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE]:
    "Configuración de Marca",
  [ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE]:
    "Configuración de Assets",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE]:
    "Información del Presupuesto",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL]: "Configuración General",
  [ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE]:
    "Información del grupo de anuncios",
  [ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE]:
    "Configuración Adicional",
  [ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE]: "Configuración de textos",
  [ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE]: "Configuración de Productos",
  [ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE]: "Configuración de App",
  [ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE]: "Configuración de Productos",

  //PRODUCT SET AUDIENCE BUILDER
  [PRODUCT_SET_AUDIENCE_BUILDER_TITLE]: "Reglas de Audiencia",
  [PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE]:
    "Encuentra clientes potenciales incluso si no han interactuado con tu negocio.",
  [PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE]:
    "Retarget ads to people who interacted with your products on and off Meta Platforms.",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT]:
    "Buscar clientes nuevos",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT]:
    "Volver a dirigirse a una audiencia",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE]: "Combinación personalizada",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE]:
    "Interacciones de audiencia",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON]:
    "Agregar inclusión",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE]: "Pero no",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON]:
    "Agregar exclusión",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST]: "En los últimos",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS]: "días",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL]:
    "Vistas o agregadas al carrito pero no compradas",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promueve productos de {{value}} a personas que vieron o agregaron esos productos al carrito en los últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL]:
    "Agregadas al carrito pero no compradas",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promueve productos de {{value}} a personas que agregaron esos productos al carrito en los últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL]:
    "Venta sugerida de productos",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION]:
    "Promueve {{value}} a personas que vieron o agregaron productos al carrito del conjunto de productos inferior en los últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Productos vistos o agregados al carrito desde:",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL]:
    "Venta cruzada de productos",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION]:
    "Promueve {{value}} a personas que compraron del conjunto de productos inferior en los últimos",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Productos comprados desde:",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL]:
    "Productos con los que se interactuó desde:",

  [MODAL_ERRORS_CAMPAIGNS_TITLE]: "Ups! Algo salió mal",
  [MODAL_ERRORS_CAMPAIGNS_DESCRIPTION]: "Ocurrió un error al crear la campaña",

  //CREATE ADS CAMPAIGN
  //posibble values for mode: quick and advanced
  [CREATE_ADS_CAMPAIGN_MODE_QUESTION]: "Elija el tipo de campaña",
  [CREATE_ADS_CAMPAIGN_NAME_QUESTION]: "¿Cuál será el nombre de tu campaña?",
  [CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER]: "Nueva colección de verano",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION]:
    "¿Cuál es el objetivo de tu campaña?",
  [CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION]:
    "¿Qué tipo de aplicación quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_TYPE_QUESTION]: "¿Qué tipo de campaña quieres crear?",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION]:
    "El objetivo de tu campaña es importante para que tus anuncios se muestren de la mejor manera posible.",
  [CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION]:
    "¿Dónde quieres generar la conversión?",
  [CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION]:
    "¿Cuál es el CPA objetivo de tu campaña?",
  [CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION]:
    "¿A qué sitio web quieres redirigir el tráfico de tu campaña?",
  [CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION]:
    "¿Cuál es el enlace profundo de tu app?",
  [CREATE_ADS_CAMPAIGN_DATES_QUESTION]:
    "¿Cuándo iniciará y terminará tu campaña?",
  [CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION]:
    "¿Qué formato de anuncio quieres usar?",
  [CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION]:
    "¿Cuál es la URL de tu sitio web?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION]:
    "¿En qué cuenta publicitaria deseas crear la campaña?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION]:
    "¿En qué cuentas publicitarias deseas crear la campaña?",
  [CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION]:
    "¿Qué cuentas mostrarán tus anuncios?",
  [META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT]:
    "Después podrás afinar las ubicaciones donde quieras mostrar tus anuncios (por ejemplo, solo Instagram o solo Facebook).",
  [MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION]:
    "¿Seguro que quieres salir? Tu configuración no se guardará.",
  [MODAL_CLOSE_UNSAVED_CONFIRM]: "Salir",
  [META_ADAPT_PLACEMENTS_CONFIRM_TITLE]:
    "¿Adaptamos tus imágenes a más formatos?",
  [META_ADAPT_PLACEMENTS_CONFIRM_TEXT]:
    "Podemos generar versiones cuadradas y verticales de tus imágenes para mostrarlas mejor en feeds, stories y reels. Esto consume créditos de creativos adicionales.",
  [META_ADAPT_PLACEMENTS_CONFIRM_YES]: "Sí, adaptar",
  [META_ADAPT_PLACEMENTS_CONFIRM_NO]: "No, continuar",
  [META_ADAPT_PLACEMENTS_CHECKBOX_LABEL]:
    "Redimensionar imágenes para adaptarse a todas las ubicaciones verticales y cuadradas.",
  [META_ADAPT_PLACEMENTS_CHECKBOX_COST]: "(Te costará {{count}} créditos)",
  [CREATE_ADS_CAMPAIGN_CATALOG_QUESTION]:
    "¿Qué catálogo deseas usar para crear la campaña?",
  [CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION]:
    "¿Deseas usar un catálogo para esta campaña?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION]:
    "¿Qué tipo de campaña deseas crear?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE]: "Website",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP]: "App",
  [CREATE_ADS_CAMPAIGN_APP_ID_QUESTION]: "¿Qué aplicación quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_TRACKING_QUESTION]:
    "¿Con qué pixel deseas rastrear tu campaña?",
  [CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION]:
    "¿Con qué píxeles deseas rastrear tu campaña?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION]:
    "¿Qué evento de Meta quieres rastrear en tu web?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION]:
    "¿Qué eventos de Meta quieres rastrear en tu web?",
  [CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION]:
    "¿En qué plataforma deseas crear los anuncios?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION]:
    "¿Qué tipo de campaña quieres crear?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL]:
    "Campaña diaria (presupuesto diario)",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL]:
    "Campaña con fechas definidas (presupuesto total)",
  [CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION]:
    "¿Cuál será el presupuesto máximo DIARIO de tu campaña?",
  [CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION]:
    "¿Cuál será el presupuesto máximo de tu campaña?",
  [CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION]:
    "No pagarás nada hasta que publiques tu campaña.",
  [CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER]: "Ingresa un valor",
  [CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION]:
    "¿Cuándo iniciará y terminará tu campaña?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION]:
    "¿A qué ubicaciones quiere dirigirse?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER]:
    "Describe un lugar o conjunto de ubicaciones",
  [CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION]:
    "¿Cuál es el rango de edad de la audiencia que verá tus anuncios?",
  [CREATE_ADS_CAMPAIGN_GENDERS_QUESTION]:
    "¿A qué géneros deseas que se muestren tus anuncios?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION]:
    "¿Qué intereses deseas que tenga la audiencia que verá tus anuncios?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER]:
    "Ropa de playa, vacaciones, verano",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION]:
    "¿Qué comportamientos deseas que tenga la audiencia que verá tus anuncios?",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER]:
    "Compradores de ropa de playa, viajeros frecuentes",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION]:
    "¿Qué demografía deseas que tenga la audiencia que verá tus anuncios?",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER]:
    "Recién comprometidos, cumpleaños próximo, aniversario próximo",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION]:
    "¿Qué texto acompañará tu anuncio?",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "La nueva colección de verano ya está aquí, eleva tu estilo en la playa con nuestras prendas. ¡Descúbrelas ahora!",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION]: "Háblanos sobre tu campaña",
  [CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION]: `Escribe un párrafo detallando cuál es el producto o servicio que deseas promocionar, cuál es el mensaje principal y a qué público objetivo deseas llegar.`,
  [CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]:
    "Mi campaña es para promocionar mi nueva colección de verano que acabo de lanzar. Esta colección es perfecta para las vacaciones en la playa, con trajes de baño, pantalones cortos y accesorios de playa. Es ideal para aquellos hombres y mujeres que buscan un look fresco y moderno.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION]:
    "¿Cuál es el producto o servicio que quieres promocionar y cuales son sus atributos principales?",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION]:
    "Escribe un párrafo detallando el producto o servicio que deseas promocionar, cuáles son sus atributos principales y qué lo hace resaltar.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER]:
    "Mi producto son unos trajes de baño con un diseño moderno y fresco. Está hecho de material de alta calidad y es perfecto para resaltar en la playa.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION]:
    "¿A qué público le quieres mostrar el anuncio?",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION]:
    "Escribe un párrafo detallando el público objetivo al que deseas llegar y qué características deben tener.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER]:
    "Mi público objetivo son hombres y mujeres de 18 a 35 años que les gusta la playa y la moda, que les gusta lucir modernos y frescos.",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION]: "Háblanos sobre tu marca",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION]:
    "Escribe un párrafo detallando cómo se llama tu marca, de qué se trata, qué productos o servicios ofreces y qué la hace resaltar.",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER]:
    "Mi marca se llama 'Beachwear', es una tienda de ropa y accesorios de playa. Ofrecemos una amplia variedad de productos con un diseño moderno y fresco que se adapta a las tendencias actuales. Nuestro productos son de alta calidad y buscan que resalten en la playa.",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION]:
    "¿Cuál es el perfil de Instagram de tu marca?",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER]:
    "https://www.instagram.com/tumarca",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION]:
    "¿Qué contenidos quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION]:
    "¿Qué contenidos quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION]:
    "¿Qué documentos quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION]:
    "¿Qué publicaciones quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION]:
    "¿Qué productos quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT]:
    "Agrega contenido de los productos que quieras promocionar. <b>Cada contenido que añadas será un anuncio independiente dentro de la campaña</b> y podrás editar los formatos más adelante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE]:
    "Agrega contenido de los productos que quieras promocionar. Podrás editar los formatos más adelante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE]:
    "Agrega contenido de los servicios que quieras promocionar. Podrás editar los formatos más adelante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE]:
    "Agrega contenido de los servicios que quieras promocionar. <b>Cada contenido que añadas será un anuncio independiente dentro de la campaña</b> y podrás editar los formatos más adelante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL]:
    "Sube un contenido por anuncio. Luego podrás elegir otros formatos.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS]:
    "Sube un documento por anuncio (PDF, PPT o DOC). Cada documento será un anuncio independiente.",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING]:
    "Cargando vista previa del documento",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR]:
    "No se pudo mostrar la vista previa del documento",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT]: "Vista previa de {{fileName}}",
  [LINKEDIN_DOCUMENT_PREVIEW_PREV]: "Página anterior",
  [LINKEDIN_DOCUMENT_PREVIEW_NEXT]: "Página siguiente",
  [LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT]: "{{current}} / {{total}}",
  [LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB]: "Abrir en una pestaña nueva",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL]:
    "Por ahora, selecciona solo las primeras imágenes de los carruseles que quieras subir. Luego podrás agregar el resto.",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION]: "¿Qué tipo de campaña deseas crear?",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR]: "Singular",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE]: "Múltiple",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION]:
    "Agrega los productos que quieres promocionar",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION]:
    "Para cada producto, agrega el link de destino y los contenidos creativos.",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION]:
    "Agrega los servicios que quieres promocionar",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION]:
    "Para cada servicio, agrega el link de destino y los contenidos creativos.",
  [PRODUCT_URL_PLACEHOLDER]: "URL del producto",
  [SERVICE_URL_PLACEHOLDER]: "URL o página de destino",
  [PRODUCT_LABEL]: "Producto {{number}}",
  [SERVICE_LABEL]: "Servicio {{number}}",
  [PRODUCT_FIELDS_REQUIRED]:
    "Todos los campos son requeridos en el producto {{number}}",
  [SERVICE_FIELDS_REQUIRED]:
    "Todos los campos son requeridos en el servicio {{number}}",
  [PRODUCT_URL_INVALID]: "La URL del producto {{number}} es inválida",
  [SERVICE_URL_INVALID]: "La URL del servicio {{number}} es inválida",
  [MEDIA_URLS_TAB_SINGULAR_PRODUCT]: "Un solo producto",
  [MEDIA_URLS_TAB_SINGULAR_SERVICE]: "Un solo servicio",
  [MEDIA_URLS_TAB_MULTIPLE_PRODUCTS]: "Varios productos",
  [MEDIA_URLS_TAB_MULTIPLE_SERVICES]: "Varios servicios",
  [MEDIA_URLS_MODE_EXPLANATION_PRODUCTS]:
    "Decide si esta campaña se enfocará en un solo producto o en varios. Cada producto puede tener su propio link y creativos.",
  [MEDIA_URLS_MODE_EXPLANATION_SERVICES]:
    "Decide si esta campaña se enfocará en un solo servicio o en varios. Cada servicio puede tener su propio link y creativos.",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION]:
    "¿Qué acción de conversión quieres rastrear?",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION]:
    "Selecciona la acción de conversión que quieres rastrear en tu campaña.",
  [CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION]:
    "Definiendo la estrategia de tu campaña...",
  [CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION]:
    "Analizando datos para detectar oportunidades de alto impacto...",
  [CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS]:
    "Construyendo una estrategia publicitaria optimizada...",
  [CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS]:
    "Preparando tu campaña para su revisión...",
  [CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM]:
    "Creando formulario instantáneo",
  [CREATE_ADS_CAMPAIGN_INTRO_TITLE]: "{{NAME_BUSINESS}} IA",
  [CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION]:
    "Una solución poderosa para la creación, optimización y gestión de tus campañas en múltiples plataformas",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN]:
    "Crea campañas publicitarias en minutos",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI]:
    "Optimiza tus campañas con IA",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE]:
    "Gestiona tus campañas de forma sencilla",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE]:
    "Analiza el rendimiento de tus campañas",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE]:
    "¡Y mucho más! Todo en un solo lugar.",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION]:
    "¿Qué esperas para comenzar? ¡Crea tu campaña ahora!",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON]: "Crear campaña",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE]:
    "- ¿Cuál es el producto o servicio que deseas promocionar?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE]:
    "- ¿Cuál es el mensaje principal que quieres comunicar?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION]:
    "- ¿A qué público objetivo deseas llegar?",
  [CREATE_ADS_LANGUAGE_QUESTION]: "¿En qué idioma estará tu campaña?",
  [CREATE_ADS_PLATFORMS_QUESTION]:
    "¿En qué plataformas deseas publicar tu campaña?",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE]: "Campaña Rápida",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION]:
    "Inteligencia artificial para principiantes. Configuración rápida y sencilla con las mejores prácticas automatizadas",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE]: "Avanzado",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION]:
    "Configura tu campaña, selecciona objetivos, eventos de conversión y cuentas publicitarias",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION]: "¿Qué videos quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION]:
    "Selecciona los videos que quieres promocionar en tu campaña",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION]:
    "¿Qué imágenes quieres promocionar?",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION]:
    "Selecciona las imágenes que quieres promocionar en tu campaña",
  [CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION]: "Proyección de campaña",
  [CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION]:
    "¿Quieres promocionar un productos en esta campaña?",

  // ADS CAMPAIGN REPORTS
  [ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE]: "Métricas Actuales",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW]: "Resumen",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS]: "Estadísticas",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS]: "Métricas",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS]:
    "Activos de Mayor Rendimiento",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS]: "Insights",
  [ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS]: "Tendencias del rendimiento",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM]: "Costo por mil impresiones",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC]: "Costo por clic",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA]: "Costo por acción",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP]:
    "Mejor grupo de activos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP]:
    "Mejor grupo de anuncios",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD]: "Mejor creativo",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE]:
    "Título más visto",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION]:
    "Descripción más vista",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS]:
    "Palabras clave principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS]: "Videos principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES]: "Imágenes principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES]: "Titulares principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES]:
    "Titulares largos principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS]:
    "Descripciones principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN]:
    "Desglose de Audiencia",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING]: "Mayor rendimiento",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL]: "Rango",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO]: "Reproducir video",

  //ADS CAMPAIGNS LOGS
  [ADS_CAMPAIGNS_LOGS_TITLE]: "Historial de Cambios",
  [ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE]: "Contexto de la Campaña",
  [BUTTON_REVERT_CHANGE]: "Revertir",
  [REVERT_CHANGE_CONFIRM_TITLE]: "¿Revertir Cambio?",
  [REVERT_CHANGE_CONFIRM_TEXT]:
    "Este cambio se aplicará al borrador. Deberás guardar o publicar para aplicarlo en la plataforma.",
  [REVERT_CHANGE_SUCCESS]: "Cambio Revertido Correctamente",
  [REVERT_CHANGE_ERROR]: "No se pudo Revertir el Cambio",

  // SETTINGS
  [SETTINGS_TITLE]: "Configuración",
  [API_KEYS_TAB_TITLE]: "API keys",
  [BYOK_SETTINGS_DESCRIPTION]:
    "Configura tus propias llaves de proveedor y elige si por defecto el uso de IA debe cobrarse con tus llaves o con credits.",
  [BYOK_DEFAULT_PAYMENT_MODE_LABEL]: "Modo de Uso por Defecto",
  [BYOK_DEFAULT_PAYMENT_MODE_HELPER]:
    "Cuando BYOK está seleccionado, {{NAME_BUSINESS}} usará tu key compatible del proveedor. Si falta una key requerida, la acción hará fallback automático a credits.",
  [BYOK_PAYMENT_MODE_CREDITS]: "Credits",
  [BYOK_PAYMENT_MODE_BYOK]: "Bring your own key",
  [BYOK_CONFIGURED_PREVIEW]: "Key configurada: {{preview}}",
  [BYOK_NOT_CONFIGURED]: "Aún no hay ninguna key configurada.",
  [BYOK_PROVIDER_INPUT_LABEL]: "API key de {{provider}}",
  [BYOK_PROVIDER_INPUT_PLACEHOLDER]: "Pega una nueva API key",
  [BYOK_SAVE_BUTTON]: "Guardar configuración",
  [BYOK_SAVING_BUTTON]: "Guardando...",
  [BYOK_SAVE_SUCCESS_TITLE]: "API keys actualizadas",
  [BYOK_SAVE_SUCCESS_DESCRIPTION]:
    "La configuración BYOK fue guardada correctamente.",
  [BYOK_SAVE_ERROR]:
    "No se pudo guardar la configuración BYOK. Inténtalo de nuevo.",
  [BYOK_PROVIDER_KEYS_TITLE]: "Llaves de proveedor",
  [BYOK_PROVIDERS_COUNTER]: "{{configured}} de {{total}} configuradas",
  [BYOK_KEY_CONFIGURED_STATUS]: "Llave configurada",
  [BYOK_NO_KEY_CONFIGURED_STATUS]: "Sin llave configurada",
  [BYOK_REPLACE_KEY]: "Reemplazar llave",
  [BYOK_DELETE_KEY]: "Eliminar llave",
  [BYOK_DELETE_KEY_TITLE]: "Eliminar API key",
  [BYOK_DELETE_KEY_DESCRIPTION]:
    "¿Eliminar la API key de {{provider}}? {{NAME_BUSINESS}} usará credits como respaldo para ese proveedor.",
  [BYOK_DELETE_KEY_ERROR]:
    "No se pudo eliminar esta API key. Inténtalo de nuevo.",
  [BYOK_DELETE_KEY_SUCCESS_TITLE]: "API key eliminada",
  [BYOK_DELETE_KEY_SUCCESS_DESCRIPTION]:
    "La API key de {{provider}} se eliminó de tu configuración BYOK.",
  [BYOK_KEY_ENCRYPTED_NOTICE]:
    "Tu llave se almacena cifrada de forma segura. Nunca se mostrará en texto plano.",
  [BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION]:
    "Elige cómo se cobra por defecto el uso de IA en todos los proveedores.",
  [BYOK_PROVIDERS_WILL_BE_USED]: "Proveedores que se usarán:",
  [BYOK_CONFIGURE_MISSING_PROVIDERS]: "Configurar proveedores faltantes",
  [MODAL_API_KEYS_ARIA_LABEL]: "Configuración de API keys",

  // CAMPAIGNS
  [CAMPAIGNS_TITLE]: "Campañas",
  [CAMPAIGNS_DESCRIPTION]:
    "Crea tu campaña, selecciona & paga a los aplicantes y aprueba el contenido",
  [CAMPAIGNS_SEARCHBAR_PLACEHOLDER]: "Buscar campañas",
  [CAMPAIGNS_TABLE_COLUMN_NAME]: "Nombre",
  [CAMPAIGNS_TABLE_COLUMN_PLATFORMS]: "Plataformas",
  [CAMPAIGNS_TABLE_COLUMN_STATUS]: "Status",
  [CAMPAIGN_ACTIVATE]: "Activar campaña",
  [CAMPAIGN_DEACTIVATE]: "Desactivar campaña",
  [CAMPAIGN_ACTIVATE_TIME_CONFIRMATION]:
    "¿Estás seguro que deseas activar esta campaña? Tu campaña estará activa durante un mínimo de 24 horas",
  [CAMPAIGN_DEACTIVATE_TIME]:
    "Debes esperar 24 horas para desactivar la campaña desde su última activación",
  [CAMPAIGN_FINISHED_TIME]:
    "Debes esperar 24 horas para finalizar la campaña desde su última activación",
  [CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED]:
    "No puedes desactivar la campaña hasta que todos los aplicantes aceptados hayan entregado su contenido",
  [CAMPAIGN_FINISH_APPLICANTS_ACCEPTED]:
    "No puedes finalizar la campaña hasta que todos los aplicantes aceptados hayan entregado su contenido",
  [CAMPAIGN_ACTIVATE_FIELDS_REQUIRED]:
    "Esta campaña tiene campos requeridos vacíos, para activarlos completalos",
  [CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR]:
    "El presupuesto por cada creador de contenido no debe ser menor a {{value,currency}}",
  [CAMPAIGN_ACTIVATE_TRAFFIC_LINK]:
    "El link de tráfico debe ser una URL valida",
  [CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM]:
    "El usuario de Instagram es requerido si harás una colaboración",
  [CAMPAIGN_ACTIVATE_ATTACHMENT_LINK]:
    "El link de referencia de la campaña debe ingresar una URL valida",
  [CAMPAIGN_FINISHED_CONFIRMATION]: "¿Estás seguro de finalizar esta campaña?",
  [CAMPAIGN_HAS_BEEN_FINISHED]: "Esta campaña ha sido finalizada",
  [CAMPAIGN_FINISH_ONBOARDING]:
    "Has terminado el tutorial, ahora sabes como generar colaboraciones más personalizadas con creadores de contenido.",

  // CAMPAIGN DETAIL
  [CAMPAIGN_DETAIL_TITLE]: "Campaña {{name}}",
  [CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE]: "Participantes",
  [CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE]: "Solicitudes",
  [CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE]: "Invitados",
  [CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE]: "Creadores invitados",
  [CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE]: "Información de la campaña",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION]:
    "Tu pago ha sido exitoso, ahora debes esperar que {{influencerName}} genere el contenido para tu aprobación",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION]:
    "Adicionalmente puedes enviarle una invitación en canje de productos al creador de contenido para que pueda acceder a tus productos de forma gratuita",
  [CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION]:
    "¿Estás seguro de rechazar este aplicante?",
  [CAMPAIGN_FIELDS_REQUIRED]:
    "Los campos que no son configuración avanzada son requeridos",
  [CAMPAIGN_NAME_PLACEHOLDER]: "Nombre de la campaña",
  [CAMPAIGN_DESCRIPTION_PLACEHOLDER]: "Descripción de la campaña",
  [CAMPAIGN_GOAL_PLACEHOLDER]: "Objetivo de la campaña",
  [CAMPAIGN_BUDGET_PLACEHOLDER]: "Presupuesto individual por cada contenido",
  [CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "Con contenido publicado en redes sociales",
  [CAMPAIGN_PLATFORMS_PLACEHOLDER]: "Plataformas para tu campaña",
  [CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER]:
    "Tipo de contenido para tu campaña",
  [CAMPAIGN_TYPE_CONTENT_PLACEHOLDER]: "Formatos para tu campaña",
  [CAMPAIGN_COPY_POST_PLACEHOLDER]:
    "Copy que acompañará el contenido (Opcional)",
  [CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]:
    "Link hacia donde quieres llevar el tráfico",
  [CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER]:
    "Quiero que el contenido se publique con un colaboración de Instagram",
  [CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Principales atributos del producto a comunicar",
  [CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]:
    "Mensaje a comunicar con el contenido",
  [CAMPAIGN_DATES_START_DATE_PLACEHOLDER]: "Fecha de inicio de la campaña",
  [CAMPAIGN_DATES_END_DATE_PLACEHOLDER]: "Fecha de finalización de la campaña",
  [CAMPAIGN_REPOST_PLACEHOLDER]:
    "¿Deseas que el creador de contenido etiquete tu perfil?",
  [CAMPAIGN_REPOST_PLACEHOLDER_ITEM]: "Usuario de {{platform}}",
  [CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]:
    "Ciudades de interés para impactar con tu campaña",
  [CAMPAIGN_AGE_RANGE_PLACEHOLDER]:
    "Rango de edades que deben tener los creadores de contenido para tu campaña",
  [CAMPAIGN_BRIEF_PLACEHOLDER]: "Brief de la Marca",
  [CAMPAIGN_BRIEF_DESCRIPTION]:
    "Es un pequeño documento creativo con toda la información detallada y guía de acción para la campaña, debe estar en formato PDF.",
  [CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER]:
    "Referencia de Contenido de la Campaña",
  [CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "Una imagen o vídeo que sirva como referencia para los creadores de contenido de cómo será la campaña",
  [CAMPAIGN_ATTACHMENT_LINK_TITLE]: "Referencia en Link de la Campaña",
  [CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "Un enlace a otra página con contenido que sirva como referencia para los creadores de contenido de cómo será la campaña",
  [CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "Link de referencia",
  [CAMPAIGN_GENDERS_PLACEHOLDER]: "Generos para la campaña",
  [CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "Perfil(es) que pueden servir de referencia",
  [CAMPAIGN_HASHTAG_PLACEHOLDER]: "#Hashtag de tu campaña",
  [CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]: "Tono del mensaje de tu campaña",
  [CAMPAIGN_ENVIRONMENT_PLACEHOLDER]: "Entorno donde se hará el contenido",
  [CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]:
    "Colores que deben salir en el contenido",
  [CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]:
    "Colores que NO deben salir en el contenido",
  [CAMPAIGN_KEY_WORDS_PLACEHOLDER]: "Palabras clave de tu campaña",
  [CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER]:
    "Que NO se debe decir durante la campaña",
  [CAMPAIGN_OUTFIT_PLACEHOLDER]: "Vestimenta recomendada",

  //CREATE CAMPAIGN
  [CREATE_CAMPAIGN_QUESTION]: "Pregunta {{question}}",
  [CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER]: `Al crear una campaña, estás aceptando los Términos y Condiciones de {{NAME_BUSINESS}}`,
  [CREATE_CAMPAIGN_NAME_EXAMPLE]: "Campaña de ejemplo",
  [CREATE_CAMPAIGN_NAME_REQUIRED]: "El nombre es requerido",
  [CREATE_CAMPAIGN_DESCRIPTION_REQUIRED]: "La descripción es requerida",
  [CREATE_CAMPAIGN_BUDGET_REQUIRED]: "El presupuesto es requerido",
  [CREATE_CAMPAIGN_BUDGET_MIN_VALUE]:
    "El presupuesto por cada creador de contenido no debe ser menor a {{value,currency}}",
  [CREATE_CAMPAIGN_PLATFORMS_REQUIRED]:
    "Debes seleccionar al menos una plataforma",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA]:
    "Debes seleccionar al menos un tipo de contenido",
  [CREATE_CAMPAIGN_TYPE_CONTENT]: "Debes seleccionar al menos un formato",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED]:
    "El link hacia donde se quiere llevar el trafico es requerido",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_VALID]:
    "El link hacia donde se quiere llevar el trafico debe ser una URL valida",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED]:
    "Los atributos de los productos son requeridos",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED]:
    "El mensaje a comunicar con el contenido es requerido",
  [CREATE_CAMPAIGN_DATES_REQUIRED]: "Ambas fechas son requeridas",
  [CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION]:
    "Como harás una colaboración en Instagram, es requerido el username de Instagram",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED]: "Las ciudades son requeridas",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK]: "La URL debe ser valida",
  [CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campaña activada",
  [CREATE_CAMPAIGN_HAS_BEEN_SAVE]: "Campaña guardada",
  [CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED]:
    "Para guardar el progreso debes al menos ingresar el nombre de la campaña",
  [CREATE_CAMPAIGN_SAVE_PROGRESS]: "Tu progreso ha sido guardado",
  [CREATE_CAMPAIGN_NAME_QUESTION]: "¿Cuál será el nombre de tu campaña?",
  [CREATE_CAMPAIGN_NAME_PLACEHOLDER]: "Nueva colección X de zapatos",
  [CREATE_CAMPAIGN_DESCRIPTION_QUESTION]:
    "¡Crea una descripción llamativa y clara de tu campaña para que los creadores se animen a participar!",
  [CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "La colección de zapatos X que revolucionará el mercado del calzado",
  [CREATE_CAMPAIGN_GOAL_QUESTION]: "¿Cuál es el objetivo de tu campaña?",
  [CREATE_CAMPAIGN_GOAL_PLACEHOLDER]: "Selecciona una opción",
  [CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION]: "Reconocimiento de marca",
  [CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION]: "Interacciones",
  [CREATE_CAMPAIGN_GOAL_LEADS_OPTION]: "Leads",
  [CREATE_CAMPAIGN_GOAL_SALES_OPTION]: "Conversión de venta",
  [CREATE_CAMPAIGN_GOAL_REQUIRED]: "Debes seleccionar un objetivo",
  [CREATE_CAMPAIGN_BUDGET_QUESTION]:
    "¿Cuánto estás dispuesto a pagar a cada creador de contenido?",
  [CREATE_CAMPAIGN_BUDGET_DESCRIPTION]:
    "En función a la cantidad de creadores que necesitas ({{quantity}}), te sugerimos un presupuesto de {{budget,currency}}",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION]: "Tipo de campaña",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION]:
    "La mención en redes significa que los creadores publicarán el contenido mencionando tu cuenta, si seleccionas que no, simplemente se te entregará el contenido.",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "Selecciona una opción",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION]:
    "UGC - Obtén solo el contenido para que tú lo publiques",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED]:
    "Debes seleccionar una opción",
  [CREATE_CAMPAIGN_PLATFORMS]:
    "¿Cuáles serán las plataformas que quieres para tu campaña?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION]:
    "¿Cuál será el tipo de contenido para tu campaña?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION]:
    "¿Cuál será el formato para tu campaña?",
  [CREATE_CAMPAIGN_COPYWRITING_QUESTION]: `¿Cuál sería el texto "copy" que acompañaría el contenido? (Opcional)`,
  [CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER]:
    "¡Se ha lanzado la nueva colección de Zapatos X, atrévete a probarlos!",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION]:
    "¿Cuál es el link hacia donde quieres llevar el tráfico?",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]: "https://www.tusitioweb.com/",
  [CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION]:
    "¿Quieres que el contenido se publique con una colaboración de Instagram?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION]:
    "¿Cuales son los principales atributos del producto o servicio a comunicar con el contenido?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Novedoso, revolucionario, original, singular, etc.",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION]:
    "¿Cuál es el mensaje a comunicar con el contenido?",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]:
    "Se debe comunicar que no hay algún producto igual en el mercado, porque es una nueva tendencia",
  [CREATE_CAMPAIGN_DATES_QUESTION]:
    "¿Cuál será la fecha de inicio y de finalización de tu campaña?",
  [CREATE_CAMPAIGN_DATES_DESCRIPTION]:
    "La duración de la campaña debe ser de mínimo una semana, por eso hay un espacio obligatorio entre la fecha de inicio y la de finalización, además de que se debe crear con una semana de antelación.",
  [CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER]:
    "Fecha de inicio de la campaña",
  [CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER]:
    "Fecha de finalización de la campaña",
  [CREATE_CAMPAIGN_REPOST_QUESTION]:
    "Si quieres que el creador de contenido etiquete tu perfil digita el @. De lo contrario, haz click en siguiente",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION]:
    "¿Cuáles son las ciudades de interes donde quieres impactar con tu campaña?",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]: "Selecciona las ciudades",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION]: "Todas",
  [CREATE_CAMPAIGN_AGE_RANGE_QUESTION]:
    "¿Cuál es el rango de edades que deben tener los creadores de contenido para tu campaña?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION]:
    "¿Qué estilo de contenido quieres para tu campaña?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER]: "Selecciona un estilo",
  [CREATE_CAMPAIGN_BRIEF_QUESTION]: "Sube el brief de la marca",
  [CREATE_CAMPAIGN_BRIEF_DESCRIPTION]:
    "Es un pequeño documento creativo con toda la información detallada y guía de acción para la campaña, debe estar en formato PDF.",
  [CREATE_CAMPAIGN_UPLOAD_BRIEF]: "Subir brief",
  [CREATE_CAMPAIGN_REMOVED_BRIEF]: "Eliminar brief",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION]:
    "Sube una referencia de contenido de la campaña",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "Una imagen o vídeo que sirva como referencia para los creadores de contenido de cómo será la campaña.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION]:
    "Sube una referencia en link de contenido de la campaña",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "Un enlace a otra página con contenido que sirva como referencia para los creadores de contenido de cómo será la campaña.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "https://www.tumarca.com/",
  [CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION]:
    "¿Qué generos necesitas para tu campaña?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION]:
    "¿Tienes @ perfil(es) que nos puedan servir de referencia?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "@xavi, @laura, @daniel, @maria, etc.",
  [CREATE_CAMPAIGN_HASHTAG_QUESTION]: "¿Cuál será el hashtag de tu campaña?",
  [CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER]: "#ZapatosXTrend",
  [CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION]:
    "¿Cómo debe ser el tono del mensaje de tu campaña?",
  [CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]:
    "Serio, jocoso, tranquilo, libre, etc.",
  [CREATE_CAMPAIGN_ENVIRONMENT_QUESTION]:
    "¿Cómo debe ser el entorno donde se hará el contenido?",
  [CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER]:
    "Hogareño, natural, comercial, libre, etc",
  [CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION]:
    "¿Qué colores deben salir en el contenido?",
  [CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]: "Azul and white",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION]:
    "¿Qué colores NO pueden salir en el contenido?",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]: "Rojo y negro",
  [CREATE_CAMPAIGN_KEY_WORDS_QUESTION]:
    "¿Cuáles son las palabras claves de tu campaña?",
  [CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER]:
    "Revolucionario, tendencia, novedoso, etc.",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION]:
    "¿Qué NO se debe decir durante la campaña?",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER]:
    "Palabras, detalles, referencia a otras marcas, etc",
  [CREATE_CAMPAIGN_OUTFIT_QUESTION]: "¿Hay alguna vestimenta recomendada?",
  [CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER]: "Qué se debe o no mostrar en el físico",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE]:
    "¡Listo! Aquí está tu guión del contenido",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING]:
    "Estamos generando un guión de contenido para tu campaña...",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL]:
    "Guión de campaña",

  //APPLICANTS
  [APPLICANTS_STATUS_PENDING]: "Pendiente",
  [APPLICANTS_STATUS_ACCEPTED]: "Contenido Pendiente",
  [APPLICANTS_STATUS_REJECTED]: "Rechazado",
  [APPLICANTS_STATUS_CONTENT_SUBMITTED]: "Contenido por Revisar",
  [APPLICANTS_STATUS_CONTENT_REVISIONS]: "Comentario Enviado",
  [APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL]:
    "Pendiente de Publicación a Redes",
  [APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS]: "Pendiente de Analítica",
  [APPLICANTS_STATUS_DELIVERED]: "Contenido Listo",
  [APPLICANT_CONTENT_OF_CREATOR]: "Contenido de {{influencerName}}",
  [APPLICANT_REVISION_PLACEHOLDER]:
    "Manda una revisión al creador de contenido",

  //REPORTS SHOP
  [START_DATE_PLACEHOLDER]: "Fecha de Inicio",
  [END_DATE_PLACEHOLDER]: "Fecha de Finalización",
  [LIKES]: "Likes",
  [SHARES]: "Compartidos",

  //GALLERY
  [GALLERY_TITLE]: "Contenido",
  [MODAL_GALLERY_ARIA_LABEL]: "Modal de galería de contenido de la marca",
  [MODAL_GALLERY_EMPTY_CONTENT]: "Aún no hay contenido en la galería",
  [SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Selecciona una plataforma y una cuenta para cargar el contenido",
  [SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Selecciona una Cuenta de YouTube para cargar el Contenido",
  [MODAL_GALLERY_NO_MORE_CONTENT]: "No hay más contenido para mostrar",
  [MODAL_FILTERS_LABEL]: "Filtros",

  // ADGROUP PLACEMENTS
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE]:
    "Ubicaciones Advantage+ (recomendado)",
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION]:
    "Usa las ubicaciones Advantage+ para maximizar tu presupuesto y ayudar a mostrar tus anuncios a más personas.",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL]: "Ubicaciones Manuales",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION]:
    "Elige manualmente las ubicaciones donde quieres mostrar tu anuncio. Cuantas más ubicaciones selecciones, más oportunidades tendrás de llegar a tu público objetivo.",

  //MODAL_MEDIA
  [MODAL_MEDIA_ARIA_LABEL]: "Modal de media",

  //MODAL UPLOAD TIKTOK
  [MODAL_UPLOAD_TIKTOK_ARIA_LABEL]: "Subir video a TikTok",
  [MODAL_UPLOAD_TIKTOK_TITLE]: "Subir video a TikTok",
  [MODAL_UPLOAD_FAILED_GET_CONFIGURATION]:
    "Ocurrió un error al obtener la configuración, intenta más tarde o contacta a soporte.",
  [MODAL_UPLOAD_CONTENT_UPLOADED]: "¡Contenido subido!",
  [MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION]:
    "El video se ha subido correctamente a TikTok, aparecerá en tu perfil en unos instantes",
  [MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION]:
    "No se pudo recuperar la información de la colaboración, contacta con soporte",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL]: "Descripción",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER]:
    "Recuerda añadir una descripción llamativa de tu vídeo, etiquetar a los usuarios que salen en él y añadir hashtags relevantes.",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL]: "¿Quién puede ver este video?",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION]: "Público",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION]: "Seguidores",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION]: "Solo yo",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER]: "Permitir a los usuarios",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION]: "Comentar",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION]: "Dúos",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION]: "Recortar",

  //MODAL MAP RADIUS
  [MARKER_LIST]: "Listado de Marcadores",
  [MARKER_NUMBER_LIST]: "Marcador #{{value}}",
  [MARKER_TYPE]: "Tipo",
  [MARKER_LNG]: "Lng",
  [MARKER_LAT]: "Lat",
  [MARKER_RADIUS]: "Radio",

  //MODAL PREVIEW OPTIMIZATION
  [MODAL_PREVIEW_OPTIMIZATIONS_TITLE]: "Aplicar Cambios",
  [MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION]:
    "Revisa y aprueba los cambios que se aplicarán a tu campaña",
  [WHY_THIS_OPTIMIZATION]: "¿Por qué esta optimización?",

  //MODAL STEP DATA
  [MODAL_STEP_DATA_TITLE]: "Información a modificar",

  //MODAL MESSAGE TEMPLATE
  [MODAL_MESSAGE_TEMPLATE_TITLE]: "Crea una plantilla de mensaje",
  [MODAL_MESSAGE_TEMPLATE_DESCRIPTION]:
    "Establece una configuración de mensajes cuando los usuarios hagan click en tu anuncio.",

  //MODAL PRODUCT TAGS META
  [MODAL_PRODUCT_TAGS_TITLE_META]: "Etiquetas de producto",
  [MODAL_PRODUCT_TAGS_DESCRIPTION_META]:
    "Habilita esta opción para mostrar una etiqueta de información de tus productos en tu anuncio",

  //MODAL CATALOG LABELS
  [MODAL_CATALOG_LABELS_TITLE]: "Etiquetas de catálogo",
  [MODAL_CATALOG_LABELS_DESCRIPTION]:
    "Configura etiquetas de catálogo para tu anuncio",

  //MODAL SITE LINKS
  [MODAL_SITE_LINKS_TITLE]: "Enlaces de Sitio",
  [MODAL_SITE_LINKS_DESCRIPTION]:
    "Configura los enlaces de sitio para tu anuncio",
  [MODAL_SITE_LINK_TITLE]: "Etiqueta",
  [MODAL_SITE_LINK_IMAGE_URL]: "Miniatura",
  [MODAL_SITE_LINK_URL]: "URL",

  //MODAL INSTANT FORMS LIST
  [MODAL_INSTANT_FORMS_LIST_TITLE]: "Formularios Instantáneos",
  [MODAL_INSTANT_FORMS_LIST_DESCRIPTION]:
    "Selecciona el formulario que quieres usar para capturar clientes potenciales.",
  [MODAL_INSTANT_FORMS_EMPTY_TEXT]: "No hay formularios instantáneos creados",

  //MODAL LEAD FORMS LIST
  [MODAL_LEAD_FORMS_LIST_TITLE]: "Formularios",
  [MODAL_LEAD_FORMS_LIST_DESCRIPTION]:
    "Selecciona un formulario de clientes potenciales para tu anuncio. Un formulario que no esté en inglés solo sirve en campañas del mismo idioma.",
  [MODAL_LEAD_FORMS_EMPTY_TEXT]:
    "No hay formularios de clientes potenciales creados",
  [MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT]: "Duplicar y editar",
  [MODAL_LEAD_FORMS_VIEW]: "Ver",
  [MODAL_LEAD_FORMS_COPY_NAME_PREFIX]: "Copia de",

  //MODAL CREATE LEAD FORM
  [MODAL_CREATE_LEAD_FORM_TITLE]: "Crear Formulario",
  [MODAL_VIEW_LEAD_FORM_TITLE]: "Ver Formulario",
  [INSTANT_FORM_PREVIEW_MORE]: "+{{count}} más",
  [MODAL_CREATE_LEAD_FORM_DESCRIPTION]:
    "Crea un formulario de LinkedIn para capturar clientes potenciales en tu campaña",
  [MODAL_VIEW_LEAD_FORM_DESCRIPTION]:
    "Consulta los datos del formulario. En esta vista no se puede editar ni crear.",
  [MODAL_VIEW_LEAD_FORM_LOAD_ERROR]:
    "No pudimos cargar los detalles del formulario. Intenta de nuevo en unos minutos.",
  [MODAL_CREATE_LEAD_FORM_LOCALE_WARNING]:
    "Un formulario que no esté en inglés solo sirve en campañas del mismo idioma",
  [MODAL_CREATE_LEAD_FORM_NAME]: "Nombre del formulario",
  [MODAL_CREATE_LEAD_FORM_HEADLINE]: "Titular",
  [MODAL_CREATE_LEAD_FORM_DETAILS]: "Detalles",
  [MODAL_CREATE_LEAD_FORM_SECTION_FORM]: "Detalles del formulario",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONTACT]: "Detalles del contacto",
  [MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY]: "Privacidad de datos",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION]: "Confirmación",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS]: "Campos de perfil",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME]: "Nombre",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME]: "Apellido",
  [MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL]: "Correo electrónico",
  [MODAL_CREATE_LEAD_FORM_PROFILE_PHONE]: "Teléfono",
  [MODAL_CREATE_LEAD_FORM_PROFILE_CITY]: "Ciudad",
  [MODAL_CREATE_LEAD_FORM_PROFILE_STATE]: "Estado",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY]: "País",
  [MODAL_CREATE_LEAD_FORM_PROFILE_ZIP]: "Código postal",
  [MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE]: "Cargo",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY]: "Empresa",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN]: "URL del perfil de LinkedIn",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS]: "Preguntas personalizadas",
  [MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION]:
    "Agregar pregunta personalizada",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT]:
    "Prefiere opción múltiple sobre texto de una línea cuando sea posible. Los campos de perfil y las preguntas personalizadas no pueden sumar más de 12.",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TITLE]: "Pregunta",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE]: "Tipo de pregunta",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT]: "Texto de una línea",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE]: "Opción múltiple",
  [MODAL_CREATE_LEAD_FORM_ADD_OPTION]: "Agregar opción",
  [MODAL_CREATE_LEAD_FORM_OPTION]: "Opción",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL]: "URL de política de privacidad",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT]:
    "Texto de política de privacidad",
  [MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE]: "Mensaje de agradecimiento",
  [MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL]: "URL de destino",
  [MODAL_CREATE_LEAD_FORM_CTA]: "Llamada a la acción de agradecimiento",
  [MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE]:
    "Visitar sitio de la empresa",
  [MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE]: "Más información",
  [MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW]: "Ver ahora",
  [MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW]: "Descargar ahora",
  [MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW]: "Probar ahora",
  [MODAL_CREATE_LEAD_FORM_MIN_OPTIONS]: "Agrega entre 2 y 15 opciones",
  [MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS]:
    "Los campos de perfil y las preguntas personalizadas no pueden sumar más de 12",

  //MODAL CREATE INSTANT FORM
  [MODAL_CREATE_INSTANT_FORM_TITLE]: "Crea un formulario instantáneo",
  [MODAL_CREATE_INSTANT_FORM_DESCRIPTION]:
    "Crea un formulario para capturar clientes potenciales",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME]: "Más volumen",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION]:
    "Crea un formulario rápido de completar y enviar desde el móvil.",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT]: "Mayor intención",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION]:
    "Agrega un paso para que las personas revisen y confirmen sus datos antes de enviarlos.",
  [MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE]:
    "Título de la página de preguntas",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS]: "Información de contacto",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME]: "Nombre completo",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL]:
    "Correo electrónico del trabajo",
  [MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS]:
    "La información de contacto y las preguntas personalizadas no pueden sumar más de {{value}}",
  [MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT]: "Texto del enlace",
  [MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION]: "Acción adicional",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE]: "Ir al sitio web",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION]:
    "Comparte una URL para que las personas visiten tu sitio web.",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME]: "Agendar cita",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION]:
    "Permite que las personas abran tu Calendly u otro enlace de agenda para reservar un horario.",
  [MODAL_CREATE_INSTANT_FORM_WEBSITE_URL]: "URL del sitio web",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK]: "Enlace de agenda",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER]:
    "Proveedor detectado: {{provider}}",
  [MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT]:
    "En Facebook el calendario se muestra dentro del formulario. En Instagram se abre en el navegador de la app.",
  [MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT]: "Texto del botón",
  [LEAD_FORM_RECOMMENDATION_GENERATING]: "Generando formulario recomendado...",
  [LEAD_FORM_RECOMMENDATION_CANCEL]: "Cancelar recomendación",
  [LEAD_FORM_RECOMMENDATION_FAILED]:
    "No pudimos generar el formulario recomendado. Puedes completarlo manualmente.",
  [LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING]:
    "La campaña se está generando. Puedes completar el formulario manualmente.",

  //MODAL INSTANT EXPERIENCE LIST
  [MODAL_INSTANT_EXPERIENCE_LIST_TITLE]: "Experiencias instantáneas",
  [MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION]:
    "Selecciona la experiencia instantánea que quieres usar en tu anuncio.",
  [MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT]:
    "No hay experiencias instantáneas creadas",

  //MODAL EDIT PRODUCTS CONFIGURATION
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE]: "Configuración de productos",
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION]:
    "Edita la configuración de productos que quieres promocionar en tu anuncio",
  [PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION]:
    "Los cambios o productos nuevos pueden tardar hasta 24 horas en sincronizarse y aparecer acá.",
  [CATEGORY_ANIMALS_PET_SUPPLIES]: "Insumos para animales y mascotas",
  [CATEGORY_ARTS_ENTERTAINMENT]: "Arte y entretenimiento",
  [CATEGORY_BUSINESS_INDUSTRIAL]: "Industria y negocios",
  [CATEGORY_CAMERAS_OPTICS]: "Cámaras y dispositivos ópticos",
  [CATEGORY_CLOTHING_ACCESSORIES]: "Ropa y accesorios",
  [CATEGORY_ELECTRONICS]: "Electrónica",
  [CATEGORY_FOOD_BEVERAGES]: "Comida, bebidas y tabaco",
  [CATEGORY_FURNITURE]: "Muebles",
  [CATEGORY_HEALTH_BEAUTY]: "Salud y belleza",
  [CATEGORY_HOME_GARDEN]: "Casa y jardín",
  [CATEGORY_BABY_TODDLER]: "Bebés y niños pequeños",
  [CATEGORY_HARDWARE]: "Ferretería",
  [CATEGORY_MATURE]: "Mayores de edad",
  [CATEGORY_MEDIA]: "Medios",
  [CATEGORY_VEHICLES_PARTS]: "Vehículos y repuestos",
  [CATEGORY_OFFICE_SUPPLIES]: "Insumos de oficina",
  [CATEGORY_SPORTING_GOODS]: "Artículos deportivos",
  [CATEGORY_TOYS_GAMES]: "Juguetes y juegos",
  [CATEGORY_SOFTWARE]: "Software",
  [CATEGORY_LUGGAGE_BAGS]: "Equipaje y bolsos",
  [CATEGORY_RELIGIOUS_CEREMONIAL]: "Religión y ceremonias",

  //MODAL EDIT PLACEMENTS META
  [MODAL_EDIT_PLACEMENTS_META_TITLE]: "Editar Ubicaciones",
  [MODAL_EDIT_PLACEMENTS_META_DESCRIPTION]:
    "Edita el creativo para cada ubicación específica",
  [MODAL_EDIT_GROUP_CREATIVE_META_TITLE]: "Editar creativo de ubicación",
  [MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION]:
    "Ajusta el creativo para este grupo de ubicaciones",
  [PLACEMENT_META_USE]: "Usar",
  [PLACEMENT_META_RESIZE]: "Redimensionar",
  [PLACEMENT_META_SELECT_OTHER_CONTENT]: "Seleccionar otro contenido",

  //MODAL EDIT ADVANTAGE ENHANCES META
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE]: "Mejoras Advantage de Creativo",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION]:
    "Permite que Meta aplique estas mejoras en tus anuncios cuando sus predicciones determinen que ayudará a mejorar el rendimiento al máximo. Las mejoras activadas se mostrarán en menos del 5% de las impresiones que tenga sus anuncios.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE]: "Mejoras estándar",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION]: `Conjunto de mejoras que pueden incluir: <br/>
    <ol>
    <li>- Ajuste automatico de la relación de aspecto del anuncio</li>    
    <li>- Aplicación de plantillas en determinadas ubicaciones para mejor visibilidad</li>    
    <li>- Mostrar comentarios relevantes debajo del anuncio</li>    
    </ol>`,
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE]: "Recorte automático",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION]:
    "Se ajustará la relación de aspecto del anuncio cuando sea probable mejorar el rendimiento.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE]:
    "Optimización de texto",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION]:
    "Se ajustará automáticamente la relación de aspecto del anuncio cuando sea probable mejorar el rendimiento.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE]:
    "Comentario relevante",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION]:
    "Se mostrará el comentario más relevante debajo del anuncio en Facebook e Instagram.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE]: "Mejorar CTA",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION]:
    "Se enlazarán frases clave de las fuentes del anuncio con la CTA. Podrás revisarlas antes de publicar.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE]:
    "Superposiciones de texto",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION]:
    "Se añadirán superposiciones de texto junto a tu contenido cuando sea probable mejorar el rendimiento.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE]:
    "Animación de imagen",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION]:
    "Se añadirán movimientos (paneo, zoom, rotación, etc.) y se convertirán en videos cortos.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE]: "Transformación 3D",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION]:
    "Se añadirá movimiento 3D y profundidad a la imagen cuando sea probable mejorar el rendimiento.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE]:
    "Ajuste de brillo y contraste",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION]:
    "Se ajustarán el brillo y el contraste de la imagen cuando sea probable mejorar el rendimiento. La imagen mostrada no representa tu anuncio.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE]:
    "Mejoras visuales de video",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION]:
    "Se añadirán mejoras de color y nitidez para que el video sea más atractivo.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE]:
    "Automatización de Descripción",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION]:
    "Elegiremos dinámicamente cuándo mostrar la descripción de tu carrusel.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE]: "Tarjeta de Perfil",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION]:
    "Añadiremos una tarjeta al final con la foto de perfil de tu página.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE]: "Carrusel a Video",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION]:
    "Mostramos anuncios con múltiples imágenes como una presentación de video cuando es probable que aumente el rendimiento.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE]: "Orden de Medios",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION]:
    "Mostraremos automáticamente primero la tarjeta con mejor rendimiento.",

  //MODAL KEYWORDS
  [MODAL_EDIT_KEYWORD_TITLE]: "Editar Palabra Clave",
  [MODAL_ADD_KEYWORDS_TITLE]: "Añadir Palabras Claves",

  //MODAL IMPORT ADS CAMPAIGN
  [MODAL_IMPORT_ADS_CAMPAIGN_TITLE]: "Importar Campaña",
  [MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION]:
    "Selecciona una campaña para importar",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE]: "Importación Exitosa",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "La campaña se importó correctamente. Las campañas importadas son de solo lectura, pero puedes consultar métricas y generar reportes.",
  [ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION]:
    "Las campañas importadas son de solo lectura, pero puedes consultar métricas y generar reportes.",

  //MODAL UPLOAD INSTAGRAM
  [MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL]: "Subir contenido a Instagram",
  [MODAL_UPLOAD_INSTAGRAM_TITLE]: "Subir contenido a Instagram",
  [MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION]:
    "El contenido se ha subido correctamente a Instagram, aparecerá en tu perfil en unos instantes",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL]: "Descripción",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER]:
    "Recuerda añadir una descripción llamativa de tu contenido, etiquetar a los usuarios que salen en él y añadir hashtags relevantes.",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL]: "Tipo",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL]: "Publicación",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL]: "Historia",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL]: "Reel",

  //MODAL CANVA
  [MODAL_CANVA_ARIA_LABEL]: "Modal para diseñar en Canva",
  [MODAL_CANVA_TITLE]: "Diseña en Canva",
  [MODAL_CANVA_DESCRIPTION]:
    "Genera creativos diseños para usar en {{NAME_BUSINESS}}",
  [MODAL_CANVA_CREATING_DESIGN]:
    "Estamos generando un área de diseño, espera un momento",
  [MODAL_CANVA_DESIGN_NOT_CREATED]:
    "Ocurrió un error y no se pudo crear un área de diseño",
  [MODAL_CANVA_DESIGN_NOT_RETRIEVED]:
    "Ocurrió un error y no se pudo recuperar el diseño",
  [MODAL_CANVA_IS_EDITING_IN_CANVA]:
    "Vuelve a {{NAME_BUSINESS}} cuando termines de editar tu contenido en Canva",
  [MODAL_CANVA_IS_GETTING_YOUR_DESIGN]:
    "Estamos recuperando tu diseño más reciente",
  [MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN]:
    "Estamos exportando tu diseño final",
  [MODAL_CANVA_INFORMATION_SAVE_DESIGN]:
    "Una vez termines de editar tu contenido en canva, cierra la pestaña y se cargará automáticamente aquí.",
  [MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION]:
    "Solo puedes importar imágenes desde Canva. No puedes importar videos.",
  [MODAL_CANVA_IMAGE_CONFIG_TITLE]: "Crear Contenido con Canva",
  [MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION]:
    "Selecciona el tipo de contenido y sus dimensiones",
  [MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL]: "Formato de Contenido",
  [MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL]: "Ancho (px)",
  [MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL]: "Alto (px)",
  [MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON]: "Crear diseño",
  [MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON]: "Cancelar",
  [MODAL_CANVA_ACCOUNT_LABEL]: "Cuenta de Canva",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL]: "Cuenta de Google Drive",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE]: "Importar Desde Google Drive",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION]:
    "Selecciona la cuenta de Google Drive desde la que deseas importar",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON]: "Continuar",
  [GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR]:
    "Configurando selector de archivos...",
  [GOOGLE_DRIVE_OPENING_SELECTOR]: "Abriendo selector de Google Drive...",
  [GOOGLE_DRIVE_IMPORTING_FILES]: "Importando archivos desde Google Drive...",
  [MODAL_CANVA_FOLDER_LABEL]: "Carpetas de Canva",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON]: "Editar",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE]: "Editar con Canva",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION]:
    "Selecciona la cuenta con la que deseas editar",
  [MODAL_CANVA_DISCONNECT_TITLE]: "Desconectar Cuenta de Canva",
  [MODAL_CANVA_DISCONNECT_DESCRIPTION]:
    "Selecciona la cuenta que deseas desconectar",
  [MODAL_CANVA_DISCONNECT_BUTTON]: "Desconectar",
  [IMAGE_TYPE_PORTRAIT_LABEL]: "Vertical",
  [IMAGE_TYPE_LANDSCAPE_LABEL]: "Horizontal",
  [IMAGE_TYPE_SQUARE_LABEL]: "Cuadrada",
  [ERROR_WIDTH_RANGE]: "El ancho debe estar entre 100 y 5000 píxeles",
  [ERROR_HEIGHT_RANGE]: "El alto debe estar entre 100 y 5000 píxeles",

  //MODAL VERIFY INTEGRATION SCOPES
  [MODAL_VERIFY_INTEGRATION_SCOPES_TITLE]: "Faltan Algunos Permisos",
  [MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION]:
    "Detectamos que a una o más conexiones les faltan permisos necesarios para acceder a nuevas funcionalidades de la plataforma. Reconéctalas a continuación.",

  //MODAL CUSTOM AUDIENCES
  [MODAL_CUSTOM_AUDIENCES_ARIA_LABEL]:
    "Configuración de audiencias personalizadas",
  [MODAL_CUSTOM_AUDIENCES_TITLE]: "Configuración de Audiencias Personalizadas",
  [MODAL_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Configura una audiencia personalizada para llegar a un grupo específico de personas",
  [MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT]: "No hay audiencias creadas",

  //MODAL CUSTOM AUDIENCES EXCLUDE
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL]:
    "Configuración de audiencias excluidas",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE]:
    "Configuración de Audiencias Excluidas",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Configura una audiencia personalizada para excluir a un grupo específico de personas",

  //MODAL SAVED AUDIENCES
  [MODAL_SAVED_AUDIENCES_TITLE]: "Audiencias Guardadas",
  [MODAL_SAVED_AUDIENCES_DESCRIPTION]:
    "Carga una audiencia guardada para usar en tu campaña",

  //MODAL CREATE CUSTOM AUDIENCE
  [MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL]:
    "Configuración de audiencia personalizada",
  [MODAL_CREATE_CUSTOM_AUDIENCE_TITLE]:
    "Configuración de audiencia personalizada",
  [MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION]:
    "Configura una nueva audiencia personalizada",
  [MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST]:
    "Sube un archivo CSV con la lista de tus clientes",

  //MODAL CREATE IDENTITY TIKTOK BUSINESS
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE]:
    "Crear una identidad de TikTok",
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION]:
    "Crea una identidad para tus anuncios en TikTok. Esta identidad (nombre y logo) se mostrará como perfil en tus anuncios para que los usuarios puedan identificar tu marca",
  [TIKTOK_CREATE_AD_ACCOUNT_OPTION]: "Crear Cuenta Publicitaria",
  [TIKTOK_CREDIT_BANNER_EYEBROW]: "Crédito en TikTok",
  [TIKTOK_CREDIT_BANNER_TITLE]:
    "de tu gasto publicitario como crédito en TikTok durante 12 meses",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX]: "Solo tienes que",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT]:
    "crear tu cuenta publicitaria de TikTok en {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BANNER_CTA]: "Crear mi cuenta de TikTok en {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BADGE_TOOLTIP]:
    "Esta cuenta fue creada en {{NAME_BUSINESS}}: recibes el 4% de tu gasto publicitario como crédito en TikTok durante 12 meses.",
  [AD_ACCOUNT_CREATED_FROM_BUSINESS]: "Creada desde {{NAME_BUSINESS}}",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE]: "Crear Cuenta Publicitaria de TikTok",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION]:
    "Elige el Business Center donde se creará la cuenta e ingresa los datos del anunciante.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER]: "Business Center",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME]: "Nombre de la cuenta publicitaria",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY]: "Nombre de la empresa",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY]: "Industria",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY]: "País de registro de la empresa",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY]: "Moneda",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER]:
    "Debe coincidir con la moneda del Business Center",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE]: "Zona horaria",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE]:
    "Es recomendable que entres a TikTok Ads Manager, ya que es posible que TikTok te solicite algunos datos que solo se llenan allí, como alguna verificación o añadir un método de pago. Cuando TikTok apruebe tu cuenta, podrás usarla en {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT]:
    "Obtén el 4% de tu gasto publicitario como crédito en TikTok durante 12 meses con la cuenta que crees desde {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS]:
    "No encontramos ningún Business Center. Conecta tu cuenta de TikTok para continuar.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE]: "Cuenta Publicitaria Creada",

  [GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW]: "Guía",
  [GUIDE_TIKTOK_AD_ACCOUNT_TITLE]: "Crear una Cuenta Publicitaria de TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_INTRO]:
    "Crea la cuenta publicitaria en {{NAME_BUSINESS}}. TikTok todavía tiene que aprobar la cuenta y los datos de pago antes de que puedas publicar anuncios.",
  [GUIDE_TIKTOK_AD_ACCOUNT_BACK]: "Volver a cuentas de anuncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_LINK]: "Ver la guía",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP]: "Paso {{step}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS]: "Configuración",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS]: "Cuentas de anuncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT]: "Conectar TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE]: "Crear Cuenta Publicitaria",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER]: "TikTok Ads Manager",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE]:
    "Abre cuentas de anuncios y conecta TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY]:
    "Abre Configuración en el menú lateral y entra en Cuentas de anuncios. En Conectar más plataformas, haz clic en Conectar TikTok y termina la autorización de TikTok for Business.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT]:
    "Configuración en cuentas de anuncios, con el botón Conectar TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT]:
    "Ventana de autorización de TikTok for Business para confirmar permisos",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE]: "Elige Crear Cuenta Publicitaria",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY]:
    "Abre la cuenta de TikTok conectada. En la lista de cuenta publicitaria de TikTok, selecciona Crear Cuenta Publicitaria.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT]:
    "Selector de cuenta publicitaria de TikTok con Crear Cuenta Publicitaria",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE]: "Ingresa los datos del anunciante",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY]:
    "Elige el Business Center. Luego ingresa el nombre de la cuenta publicitaria, el nombre de la empresa, la industria, el país de registro, la moneda y la zona horaria. La moneda tiene que coincidir con la del Business Center. Haz clic en Crear.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT]:
    "Formulario para crear una cuenta publicitaria de TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE]:
    "Completa la cuenta en TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY]:
    "Crear la cuenta no termina la configuración. Abre ___TIKTOK_BUSINESS___, entra en la cuenta nueva y agrega lo que TikTok pide. Si ya completaste esto antes, es probable que TikTok no vuelva a pedírtelo.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE]: "Ya Puedes Lanzar Una Campaña",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY]:
    "Una vez hayas completado todos los pasos y verificado en ___TIKTOK_BUSINESS___ que no requieres pasos adicionales, ya puedes lanzar campañas desde {{NAME_BUSINESS}}.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT]:
    "Modal para crear una campaña en {{NAME_BUSINESS}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE]: "Obligatorio en TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE]: "Sitio web",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING]: "Dirección de facturación",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT]: "Método de pago",

  //MODAL MAIN GENERATE SOCIAL MEDIA CONTENT
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]:
    "Modal para generar el contenido de la semana",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: `Generador de feeds`,
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]:
    "Genera tu contenido semanal para redes sociales con un clic",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL]:
    "¿Qué quieres comunicar con este contenido?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER]:
    "Deseo comunicar que mis productos/marca es todo lo que el usuario necesita",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL]: "URL de tu sitio web",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL]:
    "¿Quieres que los contenidos tengan texto?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT]: "Todos con texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT]: "Algunos con texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT]: "Ninguno con texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL]: "Idioma",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL]: "Tonos",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL]: "Color de texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL]:
    "Color de fondo",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL]: "Con texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL]: "Fuente",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL]:
    "Alineación del texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL]:
    "Alineación del logo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE]: "Galería de contenido",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY]:
    "Aún no hay contenido, agregálo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION]:
    "Subir desde el Dispositivo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION]: `Subir desde {{NAME_BUSINESS}}`,
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED]:
    "Debes seleccionar al menos un día",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON]:
    "Programar Contenido",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT]:
    "Contenido programado",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE]:
    "Ya hay un contenido para esta fecha, por favor selecciona otra",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY]:
    "Este contenido se publicará de inmediato",

  //MODAL CONNECT ACCOUNTS
  [MODAL_CONNECT_ACCOUNTS_TITLE]: "Conecta tus cuentas",
  [MODAL_CONNECT_ACCOUNTS_DESCRIPTION]:
    "Para publicar esta campaña debes conectar tu cuentas cuentas publicitarias",

  //MODAL GENERATE SOCIAL MEDIA CONTENT
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]:
    "Modal para generar contenido",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: "Genera contenido",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL]: "Elige el tono",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION]:
    "Top cinco",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION]:
    "Educacional",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION]:
    "Frases famosas",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION]:
    "Datos curiosos",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION]:
    "Rimas o poemas",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION]: "Humor",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL]: "Texto de la imagen",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]:
    "Descripción del contenido",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT]:
    "No hay contenido generado",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT]:
    "Generando contenido",

  //REDEEM CODE
  [REDEEM_CODE_TITLE]: "Redimir Código",
  [REDEEM_CODE_DESCRIPTION]:
    "Ingresa el código que te suministra el creador de contenido para validar el valor y realizar el canje de producto",
  [REDEEM_CODE_SEARCHBAR_PLACEHOLDER]: "Escribe un código",
  [REDEEM_CODE_TABLE_COLUMN_CODE]: "Código",
  [REDEEM_CODE_TABLE_COLUMN_DATE]: "Fecha de redención",
  [REDEEM_CODE_TABLE_COLUMN_VALUE]: "Valor",
  [REDEEM_CODE_TABLE_COLUMN_TERMS]: "Términos y condiciones",
  [CODE_REDEEMED]: "Código redimido",
  [VALUE_CODE_REDEEMED]: "Valor: {{value,currency}}",
  [VALUE_GENERAL_CODE_REDEEMED]: "Valor: {{value}}%",
  [CODE_NO_EXIST]: "Este código no existe",
  [CODE_NO_REDEEM_BEFORE_DATE]:
    "Aún no se puede reclamar este código, lo puede hacer a partir del {{date,short}}",

  //ORDERS
  [ORDERS_TITLE]: "Órdenes",
  [ORDERS_DESCRIPTION]:
    "Gestiona las órdenes que realizan los creadores de contenido",
  [ORDERS_REMEMBER_MARK_AS_DELIVERED]:
    "Recuerda marcar tu pedido como 'Entregado' para que el creador pueda subir tu contenido.",
  [ORDERS_SEARCHBAR_PLACEHOLDER]: "Buscar por n° de orden",
  [ORDERS_TAB_TO_BE_ACCEPTED]: "Por aceptar",
  [ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION]:
    "Aquí verás nuevas órdenes de los creadores de contenido invitados. Acéptalas para confirmar que las procesarás.",
  [ORDERS_TAB_IN_PREPARATION]: "Procesando",
  [ORDERS_TAB_IN_PREPARATION_DESCRIPTION]:
    "Aquí verás las órdenes a procesar por tu lado. Al expirar el tiempo, un delivery estará atento para recogerla.",
  [ORDERS_TAB_TO_BE_DELIVERED]: "Por entregar",
  [ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION]:
    "Aquí verás las órdenes listas de tu lado para que un delivery las pueda recoger.",
  [DELIVERY_INTERN]: "Propio",
  [DELIVERY_INTERN_ON_THE_WAY]: "Delivery interno en camino",
  [DELIVERY_ON_THE_WAY]: "Delivery {{delivery}} en camino",
  [ORDER_ID]: "Pedido #{{id}}",
  [ORDER_ACCEPTED]: "Orden aceptada",
  [ORDER_ACCEPTED_DESCRIPTION]:
    "La orden ha sido aceptada y se ha movido a procesando",
  [ORDER_READY]: "Orden lista",
  [ORDER_READY_DESCRIPTION]:
    "La orden está lista y se ha movido a por entregar",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION]:
    "¿Estás seguro que el pedido ya fue entregado?",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON]: "Entregar pedido",
  [ORDER_CANCELLED_CONFIRMATION]:
    "¿Estás seguro que deseas cancelar el pedido?",
  [ORDER_CANCELLED_CONFIRMATION_BUTTON]: "Cancelar pedido",
  [ORDER_DELIVERED]: "Orden entregada",
  [ORDER_DELIVERED_DESCRIPTION]: "La orden ya fue entregada al usuario",
  [DELIVERY_SELECTED]: "¡Delivery seleccionado!",
  [DELIVERY_SELECTED_DESCRIPTION]:
    "Se ha seleccionado el delivery {{delivery}} para esta orden",
  [ORDER_REJECTED]: "Orden rechazada",
  [ORDER_REJECTED_DESCRIPTION]: "La orden ha sido rechazada",
  [ORDER_TOTAL_VALUE]: "Valor total",
  [ORDER_TOTAL_VALUE_DISCOUNT]: "Con {{value}}% descuento",
  [ORDER_LIST_OF_PRODUCTS]: "Lista de productos",
  [ORDER_OPTIONS]: "Opciones",
  [ORDER_TIME_PREPARATION_TITLE]: "Indica el tiempo de entrega de la orden",
  [MIN_VALUE_PREPARATION_ORDER]:
    "Este es el tiempo mínimo en procesar esta orden",
  [MAX_VALUE_PREPARATION_ORDER]:
    "Este es el tiempo máximo en procesar esta orden",
  [INVALID_TIME_PREPARATION]: "Debes escoger un tipo de tiempo valido",
  [TIME_PREPARATION_VALUES_VALIDATION]:
    "Debes escoger un tiempo mayor a {{min}} o menor a {{max}}",
  [GUIDE_NUMBER]: "Número de guía",
  [GUIDE_NUMBER_REQUIRED]: "El número de guía es requerido",
  [DELIVERY_TYPE_DUPLICATE]: "Ya existe un delivery con este nombre",
  [SELECT_DELIVERY_TYPE]: "Selecciona un Delivery",
  [SELECT_DELIVERY_TYPE_OTHER]: "Otro delivery",
  [DELIVERY_DATA]: "Datos del delivery",
  [OWN_DELIVERY]: "Mensajero propio",

  //EVENTS
  [EVENT_NO_EXIST]: "El evento no existe",
  [EVENT_DISABLED]: "El evento {{event}} no está activo",
  [EVENT_HAS_FIELDS_REQUIRED]:
    "Esta evento tiene campos requeridos vacíos, para activarlos completalos",
  [EVENT_RECURRENT_REQUIRED]: "El tipo de recursión es requerido",

  //ACCOUNT
  [ACCOUNT_TITLE]: "Mi Cuenta",
  [ACCOUNT_DESCRIPTION]: "Diligencia la información de tu empresa",

  //COMPANY INFORMATION
  [COMPANY_INFORMATION_TITLE]: "Configura tu marca",
  [COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE]:
    "Ya existe una subcategoría con este nombre",
  [COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER]: "Tipo de Identificación",
  [COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER]: "Número de identificación",
  [COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH]:
    "El número de identificación debe tener al menos {{value}} dígitos",
  [COMPANY_INFORMATION_ID_NUMBER_TYPE]:
    "El número de identificación solo debe tener dígitos, en caso de ser NIT debe contener un guión y el dígito de verificación",
  [COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER]: "Razón social",
  [COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER]: "Nombre de la marca",
  [COMPANY_INFORMATION_ADDRESS_PLACEHOLDER]: "Dirección registrada",
  [COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER]: "Valor del ticket promedio",
  [COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE]:
    "El valor del ticket promedio debe ser de al menos {{value,currency}}",
  [COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER]: "Red social principal",
  [COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER]:
    "Red social secundaria",
  [COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER]: "Página web de tu marca",
  [COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER]:
    "URL a donde quieres llevar el tráfico",
  [COMPANY_INFORMATION_CATEGORY_PLACEHOLDER]: "Categorías",
  [COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER]: "Celular del administrador",
  [COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER]: "URL para reservas",
  [COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER]: "Subir logo de la marca",
  [COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER]:
    "Esto ayudará a que los clientes o mensajeros identifiquen tu marca.",
  [COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER]: "Subir imagen de portada",
  [COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER]:
    "Esto aumentará la visibilidad. Usa imágenes horizontales o con una relación de aspecto 16:9 para una mejor visualización.",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER]:
    "Subir documento regulatorio",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER]:
    "Documento regulatorio para venta de alimentos (por ejemplo Invima, FDA)",
  [COMPANY_INFORMATION_VIEW_DOCUMENT]: "Ver documento",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE]: "Código de descuento general",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION]: `El código de descuento general es un código que los creadores de {{NAME_BUSINESS}} pueden usar para comprar tus productos como cualquier otro cliente, por lo que no se generará una colaboración.`,
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1]:
    "Si guardas un porcentaje de descuento y tienes una integración e-commerce se creará una código de descuento con ese porcentaje.",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2]:
    "Si quitas el porcentaje de descuento, tienes una integración e-commerce y tenías un código general previamente creador, se desactivará.",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER]:
    "Porcentaje de descuento",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER]:
    "Código de descuento",
  [COMPANY_INFORMATION_SHOP_ID_COPIED]: "Shop ID copiado",
  [COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION]:
    "Ahora deberás llenar toda la información de tu marca en esta sección de cuenta.",
  [COMPANY_INFORMATION_SAVED]: "Información de la empresa guardada",

  //PLATFORMS CONNECT
  [PLATFORMS_CONNECTED_TITLE]: "Conecta tus cuentas",
  [PLATFORMS_CONNECTED_INSTAGRAM_FAILED]: "No se pudo conectar con Instagram",
  [PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE]:
    "Tu navegador bloqueó la conexión con Meta. Suele pasar por un bloqueador de anuncios, una extensión de privacidad o una red/firewall corporativo.",
  [PLATFORMS_CONNECTED_META_BLOCKED_TITLE]:
    "No pudimos abrir el inicio de sesión de Meta",
  [PLATFORMS_CONNECTED_META_POPUP_BLOCKED]:
    "La ventana de Meta no se abrió o se cerró antes de terminar. Suele pasar cuando el navegador bloquea ventanas emergentes o una extensión de privacidad interfiere.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER]:
    "Desactiva el bloqueador de anuncios y las extensiones de privacidad para esta página.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS]:
    "Permite las ventanas emergentes para esta página.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY]:
    "Recarga la página e inténtalo de nuevo.",
  [PLATFORMS_TOKEN_EXPIRED]:
    "Tu token ha expirado, por favor reconecta tu cuenta",
  [AD_ACCOUNTS_TITLE]: "Cuentas de anuncios",

  //BRAND SETUP
  [BRAND_SETUP_TITLE]: "Configura tu marca",

  //SCHEDULE
  [SCHEDULE_TITLE]: "Horarios",
  [SCHEDULE_ECOMMERCE_ALERT_TITLE]: "¿Estás seguro?",
  [SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION]:
    "Esto hará que el horario de tu marca sea 24/7",
  [SCHEDULE_ONE_DAY_WITH_TURN]: "Al menos un día debe tener un turno",
  [SCHEDULE_EMPTY_TURN]: "No puede haber turnos vacíos",
  [SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION]:
    "La hora de apertura no puede ser mayor a la de cierre",
  [SCHEDULE_MAX_CLOSE_HOUR]:
    "La hora no puede ser mayor a 23:59, usa 00:00 en lugar de 24:00",
  [SCHEDULE_TABLE_ARIA_LABEL]: "Tabla de Horarios",
  [SCHEDULE_TABLE_COLUMN_OPEN]: "Abre",
  [SCHEDULE_TABLE_COLUMN_CLOSE]: "Cierra",
  [SCHEDULE_SAVED]: "Horario guardado",

  //LEGAL REPRESENTATIVE
  [LEGAL_REPRESENTATIVE_TITLE]: "Información del representante legal",
  [LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER]: "Nombres",
  [LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER]: "Apellidos",
  [LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER]: "Tipo de Identificación",
  [LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER]: "Número de Identificación",
  [LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER]: "Celular",
  [LEGAL_REPRESENTATIVE_SAVED]: "Información del representante legal guardada",

  //PASSWORD
  [PASSWORD_TITLE]: "Cambiar contraseña",
  [PASSWORD_CURRENT_PASSWORD_PLACEHOLDER]: "Contraseña actual",
  [PASSWORD_NEW_PASSWORD_PLACEHOLDER]: "Contraseña nueva",
  [PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER]: "Repite la contraseña nueva",
  [PASSWORD_FORMAT_DESCRIPTION]: "Formato de la contraseña:",
  [PASSWORD_FORMAT_SUGGESTION1]: "Al menos 6 caracteres",
  [PASSWORD_FORMAT_SUGGESTION2]: "Al menos una letra mayúscula",
  [PASSWORD_FORMAT_SUGGESTION3]: "Al menos una letra minúscula",
  [PASSWORD_FORMAT_SUGGESTION4]: "Al menos un número",
  [PASSWORD_INSECURE]:
    "La contraseña no es segura, ten en cuenta las recomendaciones",
  [PASSWORDS_NOT_MATCH]: "Las contraseñas nuevas no coinciden",
  [PASSWORD_CHANGED]: "Contraseña cambiada",
  [PASSWORD_CURRENT_INVALID]: "La contraseña actual no es correcta",
  [PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS]:
    "La cuenta se ha deshabilitado temporalmente por muchos intentos fallidos, inténtalo de nuevo más tarde.",

  //STORES
  [MODAL_STORE_ARIA_LABEL]: "Modal de tienda",
  [MODAL_STORE_TITLE]: "Crea una tienda",
  [MODAL_STORE_TITLE_EDIT]: "Edita una tienda",
  [MODAL_STORE_DESCRIPTION]:
    "Crea una tienda que es un punto de venta físico o virtual de marca.",
  [MODAL_STORE_DESCRIPTION_EDIT]: "Edita una tienda que hayas creado.",
  [MODAL_STORE_TYPE_PLACEHOLDER]: "Tipo de tienda",
  [MODAL_STORE_TYPE_REGULAR_OPTION]: "Regular",
  [MODAL_STORE_HOW_TO_INTEGRATE_STORE]: `¿Como integrar mi tienda de {{value}} con {{NAME_BUSINESS}}?`,
  [MODAL_STORE_NAME_PLACEHOLDER]: "Nombre de la tienda",
  [MODAL_STORE_DESCRIPTION_PLACEHOLDER]: "Descripción",
  [MODAL_STORE_ADDRESS_PLACEHOLDER]: "Dirección",
  [MODAL_STORE_CITY_PLACEHOLDER]: "Ciudad",
  [MODAL_STORE_PHONE_PLACEHOLDER]: "Celular",
  [MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER]: "Link de tu tienda {{value}}",
  [MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER]: "Nombre de la tienda en Shopify",
  [MODAL_STORE_LOOK_NAME_SHOPIFY]: "Mira el nombre de tu tienda",
  [MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT]:
    "El nombre de tu tienda es el que aparecerá en la URL a la que se te redirige, deberás copiar el fragmento que está antes de <strong>.myshopify.com</strong>. Por ejemplo, si te redirige a la URL https://<strong>testclapps</strong>.myshopify.com el nombre de la tienda es <strong>testclapps</strong>.",
  [MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER]: `AccessToken para {{NAME_BUSINESS}}`,
  [MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER]: "Dar envío gratis",
  [MODAL_STORE_CITIES_PLACEHOLDER]: "Selecciona las ciudades",
  [MODAL_STORE_ORDERS_METHODS_PLACEHOLDER]:
    "Selecciona métodos para la entrega de tus productos",
  [MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION]: "Delivery",
  [MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION]: "En tienda",
  [MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER]:
    "Disponibilidad de tus productos",
  [MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION]:
    "Nacional (Todas las ciudades)",
  [MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION]:
    "Local (Solo en la ciudad seleccionada)",
  [MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER]: "Radio de cobertura en kilometros",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY]: "Integrar Shopify",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY]:
    "Conecta tu tienda de Shopify con {{NAME_BUSINESS}} para facilitar la gestión de tus invitaciones y canjes.",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY]: "Integrar Shopify",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY]:
    "Se deshabilitarán todas las funcionalidades de gestión de invitaciones y canjes  de Shopify",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrar Woocommerce",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE]:
    "Conecta tu tienda de Woocommerce con {{NAME_BUSINESS}} para facilitar la gestión de tus invitaciones y canjes.",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrar Woocommerce",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE]:
    "Se deshabilitarán todas las funcionalidades de gestión de invitaciones y canjes  de Woocommerce",

  //MENU
  [MENU_TITLE]: "Catálogo",
  [MENU_DESCRIPTION]: "Crea el catálogo de los productos de tu marca",
  [MENU_EMPTY_STORES]: "No tienes una tienda creada para agregar un catálogo",
  [MODAL_COPY_MENU_ARIA_LABEL]: "Modal para copiar catálogo",
  [MODAL_COPY_MENU_TITLE]: "Copiar catálogo",
  [MODAL_COPY_MENU_DESCRIPTION]: "Copia el catálogo de una tienda a otra",
  [MODAL_COPY_MENU_SAME_STORE]:
    "No puede copiar un catálogo para la misma tienda",
  [MODAL_COPY_MENU_CONFIRM_ALERT_TITLE]:
    "¿Estás seguro de copiar este catálogo?",
  [MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "Esta acción sobreescribirá el catálogo que esté en la tienda destino.",
  [MODAL_COPY_MENU_COPIED]: "Catálogo copiado",
  [SELECT_CATALOG]: "Selecciona un catálogo",
  [MODAL_UPLOAD_MENU_ARIA_LABEL]: "Modal para subir catálogo",
  [MODAL_UPLOAD_MENU_TITLE]: "Subir catálogo",
  [MODAL_UPLOAD_MENU_DESCRIPTION]:
    "Selecciona la tienda a la que quieres subir el catálogo",
  [MODAL_UPLOAD_MENU_FILE_PLACEHOLDER]:
    "Para subir un cátalogo deberás hacerlo desde un formato excel con la extensión xlsx, respetando la plantilla de las columnas.",
  [MODAL_UPLOAD_MENU_ERROR_FORMAT]:
    "Se ha encontrado un error en el formato; por favor no modifiques la estructura de la plantilla ni dejes campos requeridos vacíos",
  [MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT]:
    "El precio de un producto debe de ser {{value,number}} en adelante",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE]:
    "¿Estás seguro de subir este catálogo?",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "Esta acción borrará el catálogo existente y lo reemplazará.",
  [MODAL_UPLOAD_MENU_UPLOADED]: "Catálogo subido",
  [MENU_ADD_CATEGORY]: "Agregar categoría",
  [MENU_CATEGORY_NAME_PLACEHOLDER]: "Nombre de categoría",
  [MENU_CATEGORY_REQUIRED]: "Debes ingresar un nombre de categoría",
  [MENU_ADD_PRODUCT]: "Agregar producto",
  [MENU_PRODUCT_MIN_VALUE]:
    "El precio debe de ser {{value,number}} en adelante",
  [MENU_CREATE_PRODUCT_TITLE]: "Crea el producto base",
  [MENU_PRODUCT_NAME_PLACEHOLDER]: "Nombre",
  [MENU_PRODUCT_DESCRIPTION_PLACEHOLDER]: "Descripción",
  [MENU_PRODUCT_PRICE_PLACEHOLDER]: "Precio",
  [MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER]: "Tipo de producto",
  [MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION]:
    "Este producto no es apto para el público en general (es nocivo o para mayores de 18 años)",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE]: "Opciones de producto",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION]:
    "Agrega opciones y customización de este producto",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER]:
    "Agrega categoría de opción de producto",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER]:
    "¿Es obligatorio?",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER]: "Agrega opción de producto",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER]:
    "El minimo de opciones no puede ser mayor al maximo",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER]:
    "El minimo o máximo de opciones no puede ser menor a 0",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER]: "Nombre",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER]: "Opciones mínimas",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER]: "Opciones máximas",
  [MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER]: "Nombre",
  [MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER]: "Precio",
  [MODAL_MOVE_PRODUCT_ARIA_LABEL]:
    "Modal para mover un producto a otra categoría",
  [MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE]:
    "Selecciona la categoría a la que quieres mover el producto",
  [MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED]: "Debes seleccionar una categoría",
  [MODAL_MOVE_PRODUCT_BUTTON]: "Mover Producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL]:
    "Modal para copiar una categoría de opción de producto a otro producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE]:
    "Selecciona la categoría de producto que contiene la categoría de opción de producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE]:
    " Selecciona el producto que contiene la categoría de opción de producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE]:
    "Selecciona la categoría de opción de producto que quieres copiar",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER]:
    "Categoría de opción de producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED]:
    "Debes seleccionar una categoría",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED]:
    "Debes seleccionar un producto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED]:
    "Debes seleccionar una categoría de opción de producto",
  [MENU_ONBOARDING_TEST_CATEGORY]: "Categoría de prueba",
  [MENU_ONBOARDING_TEST_PRODUCT]: "Producto de prueba",
  [MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION]: "Descripción de prueba",
  [MENU_ONBOARDING_FINISH_DESCRIPTION]:
    "Has completado el tutorial de creación de menú, ahora ya sabes como gestionar tu cátalogo.",
  [MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION]:
    "Ahora deberás llenar toda la información de tu marca en esta sección de cuenta.",
  [MENU_CATEGORY_DUPLICATE]: "Categoría duplicada",
  [MENU_CATEGORY_DUPLICATE_DESCRIPTION]:
    "Una categoría con este nombre ya existe",
  [MENU_CATEGORY_CREATED]: "Categoría creada",
  [MENU_CATEGORY_SAVED]: "Categoría guardada",
  [MENU_CATEGORY_DELETE_CONFIRMATION_TITLE]: "Eliminar categoría",
  [MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de eliminar esta categoría?",
  [MENU_CATEGORY_DELETING]: "Eliminando categoría",
  [MENU_CATEGORY_DELETED]: "Categoría eliminada",
  [MENU_PRODUCT_DUPLICATE]: "Producto duplicado",
  [MENU_PRODUCT_DUPLICATE_DESCRIPTION]: "Un producto con este nombre ya existe",
  [MENU_PRODUCT_CREATED]: "Producto creado",
  [MENU_PRODUCT_SAVED]: "Producto guardado",
  [MENU_PRODUCT_DELETE_CONFIRMATION_TITLE]: "Eliminar producto",
  [MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar este producto?",
  [MENU_PRODUCT_DELETING]: "Eliminando producto",
  [MENU_PRODUCT_DELETED]: "Producto eliminado",
  [MENU_PRODUCT_MOVE_SAME_CATEGORY]:
    "No se puede mover el producto a la misma categoría",
  [MENU_PRODUCT_MOVED]: "Producto movido",
  [MENU_PRODUCT_CHANGE_STATUS]: "Producto {{status}}",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE]:
    "Categoría de opción de producto duplicada",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION]:
    "Una categoría de opción de producto con este nombre ya existe",
  [MENU_ACCOMPANIMENT_TYPE_COPIED]: "Categoría de opción de producto copiado",
  [MENU_ACCOMPANIMENT_DUPLICATED]: "Opción de producto duplicado",
  [MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION]:
    "Una opción de producto con este nombre ya existe",

  //USERS
  [USERS_TITLE]: "Usuarios",
  [USERS_DESCRIPTION]:
    "Crea los usuarios que te ayudaran a gestionar tu negocio",
  [USERS_TABS_ARIA_LABEL]: "tabs de usuarios y contactos",
  [USERS_PORTAL_TAB]: "Usuarios",
  [USERS_CONTACTS_TAB]: "Contactos",
  [USERS_EMAIL_DUPLICATE]:
    "El correo electrónico ya está en uso por otro usuario",
  [USERS_USER_CREATED]: "Usuario creado",
  [USERS_USER_SAVED]: "Usuario guardado",
  [USERS_USER_DELETE_CONFIRMATION_TITLE]:
    "¿Estás seguro de que quieres eliminar este usuario?",
  [USERS_USER_DELETE_CONFIRMATION_DESCRIPTION]:
    "Una vez eliminado, no podrás recuperarlo",
  [USERS_USER_DELETING]: "Borrando usuario",
  [USERS_USER_DELETED]: "Usuario eliminado",
  [USERS_LIMIT_REACHED]: "Límite de Usuarios Alcanzado",
  [ADVERTISERS_LIMIT_REACHED]:
    "Has alcanzado el límite de marcas. Actualiza tu plan para agregar más.",
  [USERS_ONBOARDING_FINISH]:
    "Ahora ya sabes cuáles son los roles que existen y para que sirve cada uno",
  [USERS_USER_SEARCH_BAR_PLACEHOLDER]: "Buscar usuario",
  [USERS_TABLE_ARIA_LABEL]: "Tabla de Usuarios",
  [USERS_TABLE_COLUMN_NAME]: "Nombre",
  [USERS_TABLE_COLUMN_EMAIL]: "Email",
  [USERS_TABLE_COLUMN_STORE]: "Tienda",
  [USERS_TABLE_COLUMN_ROLE]: "Rol",
  [MODAL_USER_ARIA_LABEL]: "Modal de crear usuario",
  [MODAL_USER_TITLE]: "Crear Usuario",
  [MODAL_USER_TITLE_EDIT]: "Editar Usuario",
  [MODAL_USER_DESCRIPTION]:
    "Crea un usuario para que pueda acceder a {{NAME_BUSINESS}}.",
  [MODAL_USER_DESCRIPTION_EDIT]:
    "Edita un usuario que tiene acceso a {{NAME_BUSINESS}}.",
  [MODAL_USER_NAME_PLACEHOLDER]: "Nombres y Apellidos",
  [MODAL_USER_ROLE_PLACEHOLDER]: "Rol del Usuario",
  [MODAL_USER_ROLE_OPERATOR_EXPLANATION]:
    "Personas que gestionan las acciones > Redimir Código y Órdenes, y se aseguran de activar o desactivar los productos según el inventario.",
  [MODAL_USER_STORE_PLACEHOLDER]: "Escoge una tienda",
  [MODAL_USER_PASSWORD_PLACEHOLDER]: "Contraseña",
  [MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER]: "Repetir contraseña",
  [USERS_CONTACT_CREATED]: "Contacto creado",
  [USERS_CONTACT_SAVED]: "Contacto guardado",
  [USERS_CONTACT_DELETE_CONFIRMATION_TITLE]:
    "¿Estás seguro de que quieres eliminar este contacto?",
  [USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION]:
    "Una vez eliminado, no podrás recuperarlo",
  [USERS_CONTACT_DELETED]: "Contacto Eliminado",
  [USERS_CONTACT_SEARCH_BAR_PLACEHOLDER]: "Buscar contacto",
  [USERS_CONTACT_TABLE_ARIA_LABEL]: "Tabla de Contacto",
  [USERS_CONTACT_TABLE_COLUMN_PHONE]: "Celular",
  [MODAL_CONTACT_ARIA_LABEL]: "Modal de crear contacto",
  [MODAL_CONTACT_TITLE]: "Crea un contacto",
  [MODAL_CONTACT_TITLE_EDIT]: "Edita un contacto",
  [MODAL_CONTACT_DESCRIPTION]:
    "Crea un contacto para que {{NAME_BUSINESS}} se comunique contigo.",
  [MODAL_CONTACT_DESCRIPTION_EDIT]: "Edita un contacto que hayas creado.",
  [MODAL_CONTACT_PHONE_PLACEHOLDER]: "Celular de contacto",

  //BILLING AND PAYMENTS
  [STORAGE_USAGE_TITLE]: "Almacenamiento",
  [STORAGE_USAGE_LABEL]: "{{value}} {{unit}} de {{maxValue}} GB",
  [STORAGE_FULL_TITLE]: "Almacenamiento insuficiente",
  [STORAGE_FULL_MESSAGE]:
    "Alcanzaste el límite de almacenamiento. Para guardar más contenido, sube de plan o borra contenido existente.",
  [STORAGE_FULL_BUTTON_DELETE]: "Borrar Contenido",
  [STORAGE_FULL_BUTTON_UPGRADE]: "Subir de Plan",
  [BILLING_AND_PAYMENTS_TITLE]: "Facturación",
  [BILLING_AND_PAYMENTS_DESCRIPTION]:
    "Conoce tu plan comercial y gestiona los pagos de las facturas",
  [BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL]: "Tabla de códigos redimidos",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE]: "Fecha de pago",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE]: "Fecha de vencimiento",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE]: "Valor",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON]: "Motivo",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS]: "Estado",
  [PAYMENT_REASON_COLLABORATION]: "Pago por colaboración",
  [PAYMENT_REASON_APPLICANT]: "Pago por aplicante",
  [PAYMENT_REASON_CLAPP_CREDITS]: "Pago por créditos",
  [PAYMENT_REASON_SUBSCRIPTION_PRO]: `Suscripción {{NAME_BUSINESS}} Pro`,
  [PAYMENT_REASON_PACKAGE]: "Plan {{name}}",
  [PAYMENT_REASON_PLAN]: "Plan {{name}}",
  [PAYMENT_PAID]: "Pagada",
  [PAYMENT_PENDING]: "Pendiente",
  [MODAL_INVOICE_ARIA_LABEL]: "Modal de detalle de factura",
  [MODAL_INVOICE_TITLE]: "Factura No. {{value}}",
  [MODAL_INVOICE_DISCLAIMER]:
    "Si crees que hay un error en la facturación, puedes comunicarte con soporte para recibir un atención detallada.",
  [MODAL_INVOICE_CREDITS]: "Pago por créditos",
  [MODAL_INVOICE_NUMBER_CREDITS]: "Número de créditos",
  [PURCHASE_CREDITS]: "Compra de Créditos",
  [PURCHASE_VIDEOS]: "Compra de videos",
  [PURCHASE_X_CREDITS]: "Compra de {{value}} créditos",
  [MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS]:
    "{{credits}} colaboraciones con medios y publicidad",
  [MODAL_INVOICE_SUBSCRIPTION]:
    "Pago de suscripción {{name}}, periodo del {{startDate, short}} al {{endDate, short}}",
  [MODAL_INVOICE_LICENSE]:
    "Pago de licencia {{name}}, periodo del {{startDate, short}} al {{endDate, short}}",
  [MODAL_INVOICE_COLLABORATION]: "Pago por canje de contenido",
  [MODAL_INVOICE_APPLICANT]: "Pago a aplicante de campaña",
  [MODAL_INVOICE_FEE]: "Fee {{value}}%",
  [MODAL_INVOICE_IVA]: "IVA {{value}}%",
  [MODAL_INVOICE_ORDER_TO_COLLECT]: "Orden a Cobrar",
  [MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID]: "Campaña",
  [MODAL_PAY_INVOICE_ARIA_LABEL]: "Modal de pago de factura",
  [MODAL_PAY_INVOICE_TITLE]: "Pagar Factura  No. {{value}} ",
  [MODAL_PAY_INVOICE_WILL_PAY]: "Pagarás {{value,currency}}",
  [MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE]:
    "Tienes una factura pendiente, por: {{value}} {{currency}}, por concepto de: {{concept}}",
  [MODAL_PAY_SUBSCRIPTION_PAY_NOW]: "Pagar Ahora",
  [MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE]:
    "Pago Pendiente de {{value}} {{currency}}",
  [BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION]:
    "Realiza el pago antes del {{limitDate}}, para evitar que se eliminen el contenido de la galería y tus campañas de {{NAME_BUSINESS}} (y de las plataformas publicitarias conectadas).",
  [BILLING_AND_PAYMENT_PLAN_DEACTIVATE]: "Tu plan está inactivo",
  [BILLING_AND_PAYMENT_PLAN_CANCELLED]: "Tu plan ha sido cancelado",
  [BILLING_AND_PAYMENT_PLAN_TRIAL]: "Prueba",
  [BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION]: `Tienes activo un plan de prueba para que conozcas los beneficios de usar {{NAME_BUSINESS}}`,
  [BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN]: "Cambia tu plan ahora",
  [BILLING_AND_PAYMENT_ACTIVATE_PLAN]: "Activar plan",
  [BILLING_AND_PAYMENT_SELECT_PLAN]: "Selecciona un plan",
  [BILLING_AND_PAYMENT_NO_HAVE_PLAN]: "-",
  [BILLING_AND_PAYMENT_PLAN_EXPIRED]: `Tu plan de prueba ha expirado, agrega un método de pago y activa tu plan ahora para seguir utilizando {{NAME_BUSINESS}}.`,
  [BILLING_AND_PAYMENT_PLAN_NAME]: "Plan {{name}}",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE]: "Pago por uso",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST]:
    "{{value,currency}} por canje",
  [BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS]:
    "¿Qué beneficios obtienes con este plan?",
  [BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS]: "Mostrar beneficios",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1]:
    "Accede a nuestro catálogo de creadores de contenido.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2]:
    "Exhibe tus productos y/o servicios a audiencias entre 5 mil y 2 millones de personas en Intagram, TikTok y YouTube.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3]:
    "Analiza los perfiles, verifica la calidad y autenticidad de sus contenidos, obtén información sobre su audiencia.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4]:
    "Automatiza canje de productos y/o servicios (invitaciones y solicitudes).",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5]: "Automatiza campañas pagas.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6]:
    "Descarga el contenido en la plataforma y úsalo en tus redes sociales, página web y otros canales de marketing.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME]: "Plan {{name}}",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE]: "Cambia tu plan ahora",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION]:
    "Aún no has seleccionado un plan, por ahora se te cobrará por {{value,currency}} por cada colaboración que se realice.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE]:
    "Agrega un método de pago para activar tu plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED]: `Tu plan de prueba ha expirado, selecciona un plan para seguir utilizando {{NAME_BUSINESS}}.`,
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE]: "-",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE]: "Activar Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE]: "Seleccionar Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE]: "Cancelar Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS]:
    "¿Qué beneficios obtienes con este plan?",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} por colaboración",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER]:
    " * Las suscripciones se renuevan automáticamente cada mes, si deseas cancelar o cambiar tu plan debes contactar a soporte con 5 días de anticipación.",
  [MODAL_SELECT_PACKAGE_ARIA_LABEL]: "Modal de selección de plan",
  [MODAL_SELECT_CREDITS_ARIA_LABEL]: "Modal de selección de créditos",
  [MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED]:
    "El plan y método de pago son necesarios",
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH]: "¡Sube a Grotwh!",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE]:
    "¿Estás listo para que tu marca sea vista por miles de personas?",
  [MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY]: `Descubre {{NAME_BUSINESS}}`,
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION]:
    "Con el plan growth podrás acceder a más beneficios",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION]:
    "Descubre la plataforma que llevará a tu marca al siguiente nivel de reconocimiento en redes sociales.",
  [MODAL_SELECT_PACKAGE_VALUE_EXPRESSED]:
    "Los valores están expresados en {{currency}}",
  [MODAL_SELECT_PACKAGE_PRICE]: "{{value,currency}}/mes",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE]: "Fee Licencia y Contenido",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE]: "Fee Licencia ({{period}} meses)",
  [MODAL_SELECT_PACKAGE_LICENSED_PRICE]:
    "{{value,currency}} por {{period}} meses",
  [MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE]: "Contenido",
  [MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH]:
    "Se te cobrará {{value,currency}} por subir a growth",
  [MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT]: "Según requerimiento",
  [MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME]: "Comprar {{value}}",
  [MODAL_SELECT_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} por colaboración",
  [MODAL_SELECT_PACKAGE_COST_CONTENT]: "{{value,currency}} por contenido",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS]:
    "Chat directo con creadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION]: "Curación de contenido",
  [MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR]:
    "• Colabora con creadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS]:
    "• Analiza métricas de audiencia, alcance y engagement",
  [MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS]: "• Lanza campañas",
  [MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT]:
    "• Descarga contenido para tu feed de redes sociales",
  [MODAL_SELECT_PACKAGE_BENEFIT_CATALOG]:
    "• Acceso al catálogo de creadores de contenido",
  [MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION]:
    "• Automatización canje de productos por contenido",
  [MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS]:
    "• Soporte de ayuda por tickets",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC]: `• Todos los beneficios del Plan Basic`,
  [MODAL_SELECT_PACKAGE_BENEFIT_KAM]:
    "• KAM - Account Manager (Consultoría estratégica)",
  [MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT]: "• Volumen de contenidos",
  [MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY]:
    "• Descubre y analiza las métricas de cualquier perfil de IG o TikTok",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM]:
    "• Publicación directa a IG o TikTok",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT]: "• Chat directo con creadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING]:
    "• Asistente de marketing con inteligencia artificial 24/7",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH]:
    "• Todos los beneficios del Plan Growth",
  [MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED]: "• Marcas ilimitadas",
  [MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS]:
    "• Integraciones personalizadas (WhatsApp, páginas web)",
  [MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL]:
    "• Implementaciones tecnológicas",
  [MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT]: "• Soporte prioritario",
  [MODAL_SUBSCRIPTION_PRO_ARIA_LABEL]: "Modal para pagar suscripción pro",
  [MODAL_SUBSCRIPTION_PRO_TITLE_HERO]: `¿Estás listo para desbloquear herramientas para mejorar tus colaboraciones?`,
  [MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO]: `{{NAME_BUSINESS}} Pro te dará acceso a funcionalidades que te ayudarán a mejorar tus colaboraciones con creadores.`,
  [MODAL_SUBSCRIPTION_PRO_TITLE]: `{{NAME_BUSINESS}} Pro`,
  [MODAL_SUBSCRIPTION_PRO_SUB_HEADER]: "Más funcionalidades",
  [MODAL_SUBSCRIPTION_PRO_BENEFIT_1]:
    "• Iniciar chats directos con creadores que no son embajadores",
  [MODAL_SUBSCRIPTION_PRO_BUY_BUTTON]: `Comprar {{NAME_BUSINESS}} Pro`,

  //PACKAGES
  [ADS_SUBSCRIPTION_TITLE]: "Suscripción {{value}}",
  [SPEND_FEE]: "Tarifa de Gasto Publicitario",
  [ADS_SUBSCRIPTION_DESCRIPTION]:
    "Con tu suscripción podrás acceder a nuestras herramientas de generación de campañas y contenido impulsada por IA",

  //PRICING
  [PRICING_HERO_TITLE_PACKAGES]: "Crea, lanza y optimiza anuncios en segundos",
  [PRICING_HERO_TITLE_CREDITS]: "Crea, lanza y optimiza anuncios en segundos",
  [PRICING_HERO_DESCRIPTION]: "",
  [PRICING_APPSUMO_CREDITS_STACK_TITLE]: "Tus créditos se acumulan",
  [PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION]:
    "Los créditos mensuales de tu plan se añadirán a tus créditos actuales de AppSumo.",
  [PRICING_CREDIT_USAGE_TITLE]: "¿Cómo se usan los créditos?",
  [PRICING_CREDIT_USAGE_CAMPAIGN]: "campaña de anuncios",
  [PRICING_CREDIT_USAGE_IMAGE]: "imagen generada por IA",
  [PRICING_CREDIT_USAGE_VIDEO]: "video generado por IA",
  [PRICING_CREDIT_USAGE_ANIMATE_IMAGE]: "imagen animada con IA",
  [PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS]: "análisis de capas de imagen",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT]: "reporte personalizado (CSV)",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK]: "reporte personalizado (PPTX/PDF)",
  [PRICING_CREDIT_USAGE_OPTIMIZATION]: "mensaje al agente de IA",
  [PRICING_CREDIT_USAGE_SCHEDULED_POST]: "publicación agendada",
  [PRICING_CREDIT_USAGE_PER]: "por",
  [PRICING_CREDIT_USAGE_CREDIT]: "crédito",
  [PRICING_CREDIT_USAGE_CREDITS]: "créditos",
  [CREDIT_COST_ITEM]: "{{credits}} {{creditWord}} por {{action}}",
  [ADS_SUBSCRIPTION_CREDITS_BENEFIT]: "{{value,number}} Créditos",
  [ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT]: "{{value,number}}/m Créditos",
  [ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT]: "{{value,number}}/t Créditos",
  [ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT]:
    "{{value,number}}/s Créditos",
  [ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT]: "{{value,number}}/a Créditos",
  [ADS_SUBSCRIPTION_COINS_BENEFIT]: "{{value,number}} Monedas",
  [ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS]: "Campañas de Meta y TikTok",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS]: "{{value}} campañas multiplataforma",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN]: "{{value}} campaña multiplataforma",
  [ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM]:
    "Número de campañas personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS]: "{{value}} anunciantes",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISER]: "{{value}} marca",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM]:
    "Número de anunciantes personalizado",
  [TOTAL_ADVERTISERS_COUNT]: "{{value}} Anunciantes",
  [TOTAL_ADVERTISER_COUNT]: "{{value}} Anunciante",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES]: "{{value}} contenidos",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS]:
    "{{value}} Vídeos IA (Listos para Publicar)",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH]:
    "{{value,number}} créditos / mes",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI]: "{{value}} videos con IA",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO]: "Hasta {{value}} marcas",
  [ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO]: "Hasta {{value}} usuarios",
  [ADS_SUBSCRIPTION_BENEFIT_USER]: "{{value}} usuario",
  [ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS]:
    "Publicaciones a redes ilimitadas",
  [ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL]:
    "Soporte por chat + email prioritario",
  [ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL]: "White-label opcional",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM]:
    "Número de contenidos personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS]: "Hasta {{value}} optimizaciones",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS]: "Creación de campañas con IA",
  [ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION]:
    "Segmentación de audiencia por IA",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT]: "Contenido generado por IA",
  [ADS_SUBSCRIPTION_BENEFIT_POSTS]:
    "Publicación y programación en redes sociales",
  [ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS]:
    "Informes y análisis avanzados por IA",
  [ADS_SUBSCRIPTION_BENEFIT_USERS]: "Hasta {{value}} usuario(s)",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE]: "{{value}} GB de almacenamiento",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM]: "Almacenamiento personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT]: "Soporte por Correo Electrónico",
  [ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT]: "Soporte por Chat",
  [ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT]: "Soporte Prioritario",
  [ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER]:
    "Marketer de cuenta dedicado",

  //BILLING DATA
  [BILLING_DATA_TITLE]: "Datos de Facturación",
  [BILLING_DATA_DESCRIPTION]:
    "Completa los datos que se usarán para emitir las facturas",
  [BILLING_DATA_SAVED]: "Datos de facturación guardados",
  [BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION]: "Información personal",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER]:
    "Tipo de persona",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION]:
    "Persona natural",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION]:
    "Persona jurídica",
  [BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER]: "Razón social",
  [BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER]: "Nombres",
  [BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER]: "Apellidos",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER]:
    "Tipo de identificación",
  [BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER]:
    "Número de identificación",
  [BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION]: "Información de contacto",
  [BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER]:
    "Correo electrónico (Facturación)",
  [BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER]: "Dirección",
  [BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER]: "Número de celular",

  [MODAL_FREE_TRIAL_TITLE]: "¡Inicia tu prueba gratis de 3 días!",
  [MODAL_FREE_TRIAL_DESCRIPTION]:
    "Colabora en canje, campañas, envia pagos y chatea con creadores de contenido.",
  [MODAL_FREE_TRIAL_CAPTION]: "Empieza ahora gratis",
  [MODAL_FREE_TRIAL_BUTTON]: "Probar GRATIS",
  [MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION]:
    "Desbloqueaste tu prueba gratis, súbete a {{NAME_BUSINESS}} Pro para empezar a trabajar con creadores de contenido.",

  [TRIAL_CONFIGURING_EXPERIENCE]: "Configurando tu experiencia...",
  [TRIAL_PREPARING_PLATFORM]:
    "Estamos preparando todo para que puedas probar la plataforma al instante.",
  [TRIAL_RETRY_ACCESS]: "Reintentar Acceso",

  [BLOCK_PAYMENT_FAILED_TITLE]: "Tu pago falló",
  [BLOCK_TRIAL_END_TITLE]: "Tu periodo de prueba ha finalizado",
  [BLOCK_PACKAGE_DESCRIPTION]:
    "Activa tu plan para colaborar con creadores, publicar campañas, analizar métricas y descargar contenido para tu feed de redes sociales",
  [BLOCK_PACKAGE_TITLE]: "Plan desactivado",
  [BLOCK_PLAN_BUTTON]: "Ir a panel de facturación",
  [BLOCK_PLAN_BUTTON_ACTIVATE_PLAN]: "Activar plan",
  [BLOCK_TRIAL_ACTIVE_TITLE]: "Prueba gratis está activa",
  [BLOCK_TRIAL_ACTIVE_DESCRIPTION]:
    "Activa tu plan para desbloquear todo el potencial de {{NAME_BUSINESS}}",
  [BLOCK_TRIAL_ACTIVE_BUTTON]: "Activar plan",
  [BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE]:
    "Tu cuenta está inactiva, por favor comunícate con tu administrador.",

  [MODAL_DISSATISFACTION_COLLABORATION_TITLE]:
    "Sabemos que no estás satisfecho",
  [MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION]:
    " Lamentamos que la colaboración no haya sido satisfactoria. Es por eso que te ofrecemos la próxima colaboración gratis.",
  [MODAL_DISSATISFACTION_COLLABORATION_BUTTON]: "Recibir 1 crédito",
  [MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT]:
    " *Un crédito equivale a una colaboración gratuita, se aplicará en la próxima colaboración que realices.",
  [MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED]: "Recibiste un crédito",

  [MODAL_BUY_CREDITS_ARIA_LABEL]: `Modal para comprar {{NAME_BUSINESS}} créditos`,
  [MODAL_BUY_CREDITS_TITLE]: "Comprar créditos",
  [MODAL_BUY_CREDITS_DESCRIPTION]:
    "Un crédito equivale a una publicación en canje de un creador",
  [MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION]:
    "Cada canje exitoso tiene un costo de {{value,currency}}",
  [MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY]:
    "¿Cuántos créditos quieres comprar?",
  [MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME]:
    "Tus créditos se redimirán en un estimado de {{value}} meses",
  [MODAL_BUY_CREDITS_ADDITIONAL_CREDITS]:
    "¡Te regalaremos {{value}} crédito(s)!",
  [MODAL_BUY_CREDITS_LAST_TEXT_PAY]: "El pago total será de {{value,currency}}",
  [MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE]:
    "{{credits}} Créditos por {{value,currency}}",
  [MODAL_BUY_CREDITS_GIFT_CREDITS]:
    "(Te regalamos {{creditsGift}} por comprar más de {{creditsBuy}})",
  [MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED]:
    "El número de créditos y método de pago es necesario",
  [MODAL_BUY_CREDITS_NEGATIVE]: "El número de créditos no puede ser menor a 1",
  [MODAL_BUY_CREDITS_PURCHASED]: "Compra de Créditos Exitosa",
  [MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION]:
    "Hemos completado la transacción con éxito. Tus créditos ya se encuentran disponibles en tu cuenta.",
  [MODAL_BUY_VIDEOS_PURCHASED]: "Compra de Videos Exitosa",
  [MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION]:
    "Hemos completado la transacción con éxito. Los videos que compraste ya están disponibles en tu cuenta.",
  [BUY_CREDITS]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_TITLE]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_ARIA_LABEL]: "Modal para comprar créditos",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE]:
    "Cómo funciona la compra de créditos",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1]:
    "Los créditos de una sola vez cuestan 50% más que los créditos recurrentes.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2]:
    "Los créditos no utilizados se reiniciarán al finalizar tu período de facturación actual.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3]:
    "¿Quieres una mejor tarifa o un límite más alto?",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK]: "Actualiza tu plan",
  [MODAL_PURCHASE_CREDITS_SELECT_AMOUNT]: "Selecciona un Paquete",
  [MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT]:
    "La cantidad mínima de créditos que puedes comprar es {{minCredits}}.",
  [MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER]:
    "Ingresar cantidad personalizada",
  [MODAL_PURCHASE_CREDITS_UPGRADE_PLAN]: "Actualizar Plan",
  [MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY]:
    "Pagarás ${{amount}} USD por {{credits}} Créditos",
  [MODAL_PURCHASE_CREDITS_CREDITS_LABEL]: "{{credits}} créditos",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT]: "${{price}} por crédito",
  [MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE]: "Paquetes de Créditos",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE]: "Paquetes de Videos",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE]:
    "Vídeos listos para publicar, con guion estructurado, audio y subtítulos incluidos.",
  [MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES]:
    "Idiomas soportados:",
  [MODAL_PURCHASE_CREDITS_VIDEOS_LABEL]: "{{videos}} Vídeos IA",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO]: "${{price}} USD c/u",
  [MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON]: "Comprar videos",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE]: "Ejemplos de Vídeo",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE]: "Ejemplo {{number}}",

  [VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE]: "Créditos de Vídeo Insuficientes",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO]:
    "No tienes créditos de vídeo suficientes para la operación. Para adquirir créditos, selecciona una de las siguientes opciones:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION]:
    "Para adquirir créditos, selecciona una de las siguientes opciones:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE]: "Comprar Créditos",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE]: "Subir de Plan",

  //MODAL ADD BRAND SUPER ADMIN
  [MODAL_ADD_BRAND_SUPER_ADMIN_TITLE]: "Agregar Marca",

  //MODAL UPLOAD CUSTOM AUDIENCES GOOGLE
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE]: "Carga tu audiencia",
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION]:
    "Sube un archivo CSV para crear una audiencia personalizada",

  //MODAL INSTANT EXPERIENCE CREATE
  [MODAL_INSTANT_EXPERIENCE_CREATE_TITLE]: "Crea una Experiencia Instantánea",
  [MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION]:
    "Configura tu experiencia instantánea personalizada.",

  //LOGIN
  [FORGOT_PASSWORD]: "¿Olvidaste tu contraseña?",
  [NO_HAVE_ACCOUNT]: "¿No tienes cuenta?",
  [REGISTER_HERE]: "Regístrate",
  [ALREADY_HAVE_AN_ACCOUNT]: "¿Ya tienes una cuenta?",
  [LOG_IN]: "Acceder",
  [RESET_PASSWORD_EMAIL_SENT]:
    "Hemos enviado un correo electrónico para con un enlace para que puedas restablecer tu contraseña.",

  //AUTH LAYOUT (MARKETING PANEL)
  [AUTH_LAYOUT_HERO_TITLE]: "Potencia tu Marketing",
  [AUTH_LAYOUT_HERO_DESCRIPTION]:
    "La plataforma de marketing con IA para crear, programar y analizar tu contenido con facilidad.",
  [AUTH_LAYOUT_PREVIEW_PLACEHOLDER]: "Aquí verás una vista previa de tu panel.",
  [AUTH_LAYOUT_PREVIEW_IMAGE_ALT]:
    "Vista previa del panel de {{NAME_BUSINESS}} con campañas, métricas y listado de campañas",
  [AUTH_LAYOUT_FEATURE_AI_TITLE]: "Campañas con IA",
  [AUTH_LAYOUT_FEATURE_AI_DESCRIPTION]: "Automatiza tu marketing con IA.",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE]: "Analíticas que importan",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION]:
    "Mide resultados y convierte datos en decisiones claras.",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE]: "Programación inteligente",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION]:
    "Planifica y publica en tus canales desde un solo lugar.",

  //RESET PASSWORD
  [RESET_PASSWORD]: "Restablecer contraseña",
  [RESET_PASSWORD_GET_TOKEN_FAILED]:
    "No pudimos obtener el token para restablecer la contraseña, intenta abriendo de nuevo el enlace envíado a tu correo o vuelve darle click al botón de Olvidaste tu contraseña.",
  [RESET_PASSWORD_SAVED]: "Contraseña cambiada",

  //COMPLETE REGISTRATION
  [SET_PASSWORD]: "Establece tu Contraseña",

  //REGISTER
  [REGISTER_COUNTRY_ANSWER]: "¿En cuál país está tu marca?",
  [REGISTER_COUNTRY_PLACEHOLDER]: "País",
  [REGISTER_NAME_ANSWER]: "¿Cuál es tu nombre?",
  [REGISTER_PHONE_ANSWER]: "¿Cuál es tu número de celular?",
  [REGISTER_EMAIL_ANSWER]: "¿Cuál es tu correo electrónico?",
  [REGISTER_PASSWORD_ANSWER]: "Crea una contraseña",
  [REGISTER_BUSINESS_NAME_ANSWER]: "¿Cuál es el nombre de tu marca?",
  [REGISTER_CATEGORY_ANSWER]: "¿Cuál es la categoría de tu marca?",
  [REGISTER_SOCIAL_NETWORK_ANSWER]:
    "¿Cuál es la red social principal de tu marca?",
  [REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION]:
    "Ingresa el @‌usuario de tu red social.",
  [REGISTER_WEBSITE_ANSWER]: "¿Cuál es la página web de tu marca?",
  [REGISTER_WEBSITE_ANSWER_DESCRIPTION]:
    "Ingresa el link de tu IG u otra red social si no tienes página web.",
  [REGISTER_MONTHLY_SALES_ANSWER]:
    "¿Cuál es la facturación mensual de tu marca?",
  [REGISTER_BUDGET_MARKETING_ANSWER]:
    "¿De cuánto es el presupuesto mensual de marketing de tu marca?",
  [REGISTER_EMPLOYEES_ANSWER]: "¿Cuántos empleados tiene tu marca?",
  [REGISTER_PRODUCT_AVAILABILITY_ANSWER]:
    "¿Cuál es la disponibilidad de tus productos?",
  [REGISTER_RUT_ANSWER]: "Sube el documento de constitución de tu empresa",
  [REGISTER_INVIMA_ANSWER]:
    "Sube el registro de autoridad sanitaria de tu marca",
  [REGISTER_ICA_ANSWER]:
    "Sube el registro de autoridad de productos para animales de tu marca",
  [REGISTER_YOU_MEET_ANSWER]: "¿Dónde nos conociste?",
  [REGISTER_WRITE_PLACEHOLDER]: "Escribe tu respuesta aquí",
  [REGISTER_SELECT_PLACEHOLDER]: "Selecciona una opción",
  [REGISTER_COUNTRY_REQUIRED]: "Debes seleccionar tu país",
  [REGISTER_NAME_REQUIRED]: "Debes escribir tu nombre",
  [REGISTER_PHONE_REQUIRED]: "Debes escribir tu número de celular",
  [REGISTER_PHONE_NUMERIC_REQUIRED]: "El número de celular no es válido",
  [REGISTER_BUSINESS_NAME_REQUIRED]: "Debes escribir el nombre de tu marca",
  [REGISTER_CATEGORY_REQUIRED]: "Debes seleccionar una categoría",
  [REGISTER_SOCIAL_NETWORK_REQUIRED]:
    "El @ de tu red social debe tener al menos 3 caracteres",
  [REGISTER_WEB_SITE_REQUIRED]:
    "Debes escribir el link a la página web de tu marca",
  [REGISTER_MONTHLY_SALES_REQUIRED]:
    "Debes seleccionar la facturación mensual de tu marca",
  [REGISTER_BUDGET_MARKETING_REQUIRED]:
    "Debes seleccionar el presupuesto mensual de marketing de tu marca",
  [REGISTER_EMPLOYEES_REQUIRED]:
    "Debes seleccionar el número de empleados de tu marca",
  [REGISTER_PRODUCT_AVAILABILITY_REQUIRED]:
    "Debes seleccionar la disponibilidad de tus productos",
  [REGISTER_RUT_REQUIRED]:
    "Debes seleccionar el RUT o documento de constitución de empresa",
  [REGISTER_INVIMA_REQUIRED]:
    "Debes seleccionar el registro INVIMA de tu marca",
  [REGISTER_ICA_REQUIRED]: "Debes seleccionar el registro ICA de tu marca",
  [REGISTER_YOU_MEET_REQUIRED]:
    "Debes seleccionar una opción de donde nos conociste",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE]: "Lo sentimos",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION]:
    "No podemos continuar con el proceso si no cuentas con los documentos requeridos, te invitamos a que retomes el proceso cuando los tengas.",
  [REGISTER_REGISTERED_ALERT_DESCRIPTION]:
    "Estamos analizando tu información, te enviaremos un correo una vez tu marca sea aprobada",
  [PLEASE_SELECT_COUNTRY]: "Por favor selecciona un país",
  [REGISTER_PROFILE_CREATOR_CITIES_ANSWER]:
    "¿De qué ciudades quieres encontrar creadores para trabajar?",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER]:
    "¿En qué plataformas de redes sociales o contenido quieres encontrar creadores para trabajar?",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER]:
    "¿Qué tipo de contenido quieres que haga tu creador ideal?",
  [REGISTER_PROFILE_CREATOR_GENDER_ANSWER]:
    "¿Con creadores de qué género te interesa colaborar?",
  [REGISTER_PROFILE_CREATOR_AGE_ANSWER]:
    "¿Con creadores de qué edades te interesa colaborar?",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD]:
    "¿Qué tipo de cuerpo quieres que tenga tu creador ideal?",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE]:
    "¿Qué estilo de vestimenta quieres que tenga tu creador ideal?",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES]:
    "¿Qué características distintivas quieres que tenga tu creador ideal?",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE]:
    "¿Qué estilo de contenido quieres que tenga tu creador ideal?",
  [REGISTER_PROFILE_CREATOR_CITIES_REQUIRED]:
    "Debes seleccionar al menos una ciudad",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED]:
    "Debes seleccionar al menos una plataforma",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED]:
    "Debes seleccionar mínimo tres categorías",
  [REGISTER_PROFILE_CREATOR_GENDER_REQUIRED]:
    "Debes seleccionar al menos un género",
  [REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED]:
    "Debes seleccionar mínimo dos rangos de edad",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED]:
    "Debes seleccionar al menos dos tipos de cuerpo",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED]:
    "Debes seleccionar al menos tres estilos de vestimenta",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED]:
    "Debes seleccionar al menos tres características distintivas",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED]:
    "Debes seleccionar al menos tres estilos de contenido",

  //CHATS
  [CHAT_ERROR_SENT_MESSAGE]:
    "Lo siento, hubo un fallo interno, intenta más tarde.",
  [CHAT_DO_PAYMENT]: "Realizar pago",
  [CHAT_WRITE_QUESTION_HERE]: "Escribe una pregunta",
  [CHAT_WRITE_MESSAGE_HERE]: "Escribe un mensaje",
  [CHAT_EMAIL_NO_PERMITTED]: "No se permiten enviar correos electrónicos",
  [ONE_SECOND_AGO]: "Hace un segundo",
  [CHAT_FIRST_MESSAGE_BOT]:
    "Hola, soy Ana, asesora experta en la plataforma.\n¿En qué puedo ayudarte hoy?",
  [CHAT_NO_MORE]: "No hay más chats",
  [CHAT_DO_A_QUESTION]: "Haz una pregunta",
  [CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN]: "Envía un mensaje",
  [CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION]:
    "Dame un resumen conciso de mi campaña y si debo hacer algún cambio en este momento.",
  [CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS]:
    "Analizando tu campaña para darte sugerencias...",
  [CHAT_BOT_NAME]: "Agente de Marketing",
  [CHAT_BOT_DESCRIPTION]: "Pregunta sobre tu campaña",
  [CHAT_BOT_WELCOME_MESSAGE]: "¿Qué te gustaría optimizar hoy?",
  [CHAT_BOT_WELCOME_DESCRIPTION]:
    "También puedes pedirme cambios en textos, de segmentación, etc.",
  [CHAT_BOT_WELCOME_MESSAGE_STATISTICS]:
    "¿Qué te gustaría saber sobre tu campaña?",
  [CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS]:
    "Puedes preguntarme sobre métricas, segmentación, presupuestos, costos y más.",
  [CHAT_BOT_WELCOME_MESSAGE_OWNER]: "¿En qué necesitas ayuda?",
  [CHAT_BOT_WELCOME_DESCRIPTION_OWNER]:
    "Pregunta sobre tus clientes, marcas, planes y facturación.",
  [CHAT_ASK_A_QUESTION_OWNER]: "Pregunta sobre tu panel...",
  [CHAT_REASONING_ANALYZING_USER_MESSAGE]: "Analizando mensaje del usuario",
  [CHAT_REASONING_PROCESSING_CAMPAIGN_DATA]: "Procesando datos de la campaña",
  [CHAT_REASONING_GETTING_PERFORMANCE_METRICS]:
    "Obteniendo métricas de rendimiento",
  [CHAT_REASONING_ANALYZING_BEST_PRACTICES]: "Analizando mejores prácticas",
  [CHAT_REASONING_GENERATING_RECOMMENDATIONS]: "Generando recomendaciones",
  [CHAT_THINKING]: "Pensando",

  //SUMMARY TEXT (CHAT)
  [CHAT_SUMMARY_OVERVIEW_TEXT]:
    "¿Cómo fue el performance general en {{platforms}} entre las fechas {{startDateTime}} al {{endDateTime}}? Dame un párrafo conciso detallando el performance.",

  //NOFITICATIONS
  [NOTIFICATIONS_TITLE]: "Notificaciones",
  [NOTIFICATIONS_MARK_READS]: "Marcar como leídas",
  [NOTIFICATIONS_EMPTY]: "No tienes notificaciones",
  [NOTIFICATIONS_NO_MORE]: "No tienes más notificaciones",
  [NOTIFICATIONS_CHECK_NOTIFICATION]: "Revisar",

  //TRANSACTIONS
  [TRANSACTION_CONCEPT_LABEL]: "Concepto",
  [TRANSACTION_TYPE]: "Tipo",
  [TRANSACTION_TYPE_CREDIT]: "Crédito",
  [TRANSACTION_TYPE_DEBIT]: "Débito",
  [TRANSACTION_STATUS]: "Estado",
  [TRANSACTION_STATUS_PENDING]: "Pendiente",
  [TRANSACTION_STATUS_PENDING_RELEASE]: "Pendiente de liberar",
  [TRANSACTION_STATUS_IN_PROCESS_RELEASE]: "En proceso de liberación",
  [TRANSACTION_STATUS_RELEASED]: "Liberado",
  [TRANSACTION_STATUS_PENDING_SENT]: "Pendiente de enviar",
  [TRANSACTION_IN_TRANSIT]: "En tránsito",
  [TRANSACTION_STATUS_PAID]: "Pagado",
  [TRANSACTION_WAS_PAID]: "Se pagó",
  [MODAL_CREATE_TRANSACTION]: "Crea una transacción a un creador",
  [MODAL_CREATE_TRANSACTION_AMOUNT_LABEL]: "Monto (USD)",
  [MODAL_CREATE_TRANSACTION_CONCEPT_LABEL]: "Concepto",
  [MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT]: "Aplicante",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ORDER]: "Órden",
  [MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL]: "Referido",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ID]: "ID del concepto (Opcional)",

  //CONTENT
  [CONTENT_TITLE]: "Contenido de marcas",

  //CONTENT APPLICATION
  [CONTENT_APPLICATION_TITLE]: "Aplicación de contenido",
  [CONTENT_APPLICATION_ACCEPT_TITLE]: "Aceptar aplicación",
  [CONTENT_APPLICATION_ACCEPT_DESCRIPTION]:
    "Al aceptar esta aplicación, el usuario se podrá registrar como creador de contenido",
  [CONTENT_APPLICATION_REJECT_TITLE]: "Rechazar aplicación",
  [CONTENT_APPLICATION_REJECT_DESCRIPTION]:
    "Al rechazar estar aplicación, el usuario no podrá registrarse como creador de contenido",

  //REPORTS
  [REPORTS_TITLE]: "Reportes",
  [REPORTS_DESCRIPTION]:
    "Aquí encontrarás las estadísticas generales del ecosistema de {{NAME_BUSINESS}}",
  [REPORTS_ERROR_GENERATING]:
    "Algo salió mal con la generación de estadísticas, por favor inténtalo de nuevo.",
  [REPORTS_REQUESTS_ACTIVE]: "Solicitudes activas",
  [REPORTS_REQUESTS_INACTIVE]: "Solicitudes inactivas",
  [REPORTS_TYPE_USERS]: "Tipo de usuario",
  [REPORTS_NUMBER_USERS]: "Número de usuarios",
  [REPORTS_TYPE_ORDER]: "Tipo de orden",
  [REPORTS_NUMBER_ORDER]: "Número de ordenes",
  [REPORTS_MODAL_DESCRIPTION]:
    "Aquí encontrarás los reportes de distintas categorías",
  [REPORTS_MODAL_ONLY_BRANDS_ACTIVE]: "Solo tiendas activas",
  [REPORTS_MODAL_TYPE_REPORT_LABEL]: "Tipo de reporte",
  [REPORTS_MODAL_TYPE_REPORT_BRANDS]: "Marcas",
  [REPORTS_MODAL_TYPE_REPORT_CREATORS]: "Creadores",
  [REPORTS_MODAL_TYPE_REPORT_ORDERS]: "Órdenes",

  //SHOPIFY TERMS
  [INTEGRATIONS_TERMS_TITLE]: `Política de Privacidad de {{NAME_BUSINESS}} con Integraciones`,
  [INTEGRATIONS_TERMS_DESCRIPTION]: "Última actualización: {{date,short}}",
  [INTEGRATIONS_TERMS_CONTENT]: `
  <strong>1. Información recopilada</strong>

  En {{NAME_BUSINESS}}, respetamos la privacidad de nuestros usuarios y clientes. A través de nuestra integración con plataformas, recopilamos información limitada y específica únicamente para el funcionamiento técnico de nuestra aplicación. Los datos que recopilamos incluyen:

  Nombre de la tienda de la plataforma: Utilizamos esta información para identificar la tienda y facilitar la ejecución de acciones específicas dentro de la plataforma.

  Token de autorización: Utilizamos un token de autorización proporcionado por los comerciantes de la plataforma para realizar las solicitudes técnicas necesarias para el monitoreo de cambios de estado de entregas y la ejecución de acciones según sea necesario.

  <strong>2. Uso de la información</strong>

  Es importante destacar que no almacenamos ningún dato personal ni información identificable de los comerciantes o sus clientes. La información recopilada se utiliza únicamente para la ejecución técnica de la aplicación {{NAME_BUSINESS}} en la plataforma. No se utiliza con ningún otro fin y no se almacena en nuestras bases de datos.

  <strong>3. Retención de datos</strong>

  En línea con nuestra política de no almacenamiento de datos, no retenemos ninguna información de los comerciantes o sus clientes. Cualquier información recibida se utiliza en tiempo real y se descarta inmediatamente después de su uso.

  <strong>4. Contacto</strong>

  Si tienes alguna pregunta o inquietud sobre nuestra política de privacidad, no dudes en ponerte en contacto con nosotros en ${EMAIL_SUPPORT}.
  `,

  [AUTH_TIKTOK_VERIFICATION_LOADING]: "Verificando tu cuenta de TikTok",
  [AUTH_TIKTOK_VERIFICATION_SUCCESS]: "Tu cuenta de TikTok ha sido verificada",
  [AUTH_TIKTOK_VERIFICATION_FAILED]:
    "Ocurrió un error. No pudimos verificar tu cuenta de TikTok",

  //COLUMN NAMES
  [COLUMN_NAME_BRAND]: "Marca",
  [COLUMN_NAME_AGENCY]: "Agencia",
  [COLUMN_NAME_ADVERTISER]: "Anunciante",
  [COLUMN_NAME_USER]: "Usuario",
  [COLUMN_NAME_CATEGORY]: "Categoría",
  [COLUMN_NAME_IS_LOGGED]: "Se logeó",
  [COLUMN_NAME_IS_ACTIVE]: "Está Activa",
  [COLUMN_NAME_PACKAGE]: "Paquete",
  [COLUMN_NAME_EMAIL]: "Correo",
  [COLUMN_NAME_NAME]: "Nombre",
  [COLUMN_NAME_PHONE]: "Telefono",
  [COLUMN_NAME_STAFF]: "Staff",
  [COLUMN_NAME_ACCEPTED]: "Aceptado",
  [COLUMN_NAME_MONTHLY_SALES]: "Ventas por mes",
  [COLUMN_NAME_BUDGET_MARKETING]: "Presupuesto marketing",
  [COLUMN_NAME_EMPLOYEES]: "Trabajadores",
  [COLUMN_NAME_PRODUCT_AVAILABILITY]: "Disponibilidad de productos",
  [COLUMN_NAME_SOCIAL_NETWORK]: "Red social",
  [COLUMN_NAME_WEB_SITE]: "Website",
  [COLUMN_NAME_YOU_MEET]: "Donde nos conoció",
  [COLUMN_NAME_DATE]: "Fecha",
  [COLUMN_NAME_PLAN]: "Plan",
  [COLUMN_NAME_PAYMENT_METHOD]: "Método de pago",
  [COLUMN_NAME_COST_COLLABORATION]: "Costo por colaboración",
  [COLUMN_NAME_CREDITS]: "Créditos",
  [COLUMN_NAME_COUNTRY]: "País",
  [COLUMN_NAME_CREATOR_NAME]: "Nombre",
  [COLUMN_NAME_CREATOR_PLATFORM]: "Plataforma",
  [COLUMN_NAME_CITY]: "Ciudad",
  [COLUMN_NAME_AUDIENCE]: "Audiencia",
  [COLUMN_NAME_ENGAGEMENT]: "Engagement",
  [COLUMN_NAME_CATEGORIES]: "Categorías",
  [COLUMN_NAME_SCORE]: "Puntuación",
  [COLUMN_NAME_ACTIVITY]: "Actividad",
  [COLUMN_NAME_ACTIONS]: "Acciones",
  [COLUMN_NAME_ACTION]: "Acción",
  [COLUMN_NAME_STATUS]: "Estado",
  [COLUMN_NAME_REDEEMED_DATE]: "Redimida el",
  [COLUMN_NAME_TERMS]: "Términos",
  [COLUMN_NAME_TYPE]: "Tipo",
  [COLUMN_NAME_ADDRESS]: "Dirección",
  [COLUMN_NAME_STORE]: "Tienda",
  [COLUMN_NAME_ROLE]: "Rol",
  [COLUMN_NAME_PAID_DATE]: "Pagada el",
  [COLUMN_NAME_DUE_DATE]: "Vence el",
  [COLUMN_NAME_REASON]: "Razón",
  [COLUMN_NAME_VALUE]: "Valor",
  [COLUMN_NAME_ID]: "ID",
  [COLUMN_NAME_CREATOR]: "Creador",
  [COLUMN_NAME_CREATED_DATE]: "Creado el",
  [COLUMN_NAME_ACCEPTED_DATE]: "Aceptado el",
  [COLUMN_NAME_DETAILS]: "Detalles",
  [COLUMN_NAME_DELIVERY]: "Delivery",
  [COLUMN_NAME_CODE_VERIFICATION]: "Código de verificación",
  [COLUMN_NAME_ACCOUNT_NAME]: "Nombre de cuenta",
  [COLUMN_NAME_IS_HIDDEN]: "Oculto",
  [COLUMN_NAME_COMMENT]: "Comentario",
  [COLUMN_NAME_URLS]: "Urls",
  [COLUMN_NAME_KEYWORD]: "Keyword",
  [COLUMN_NAME_SEARCH_TERM]: "Término de Búsqueda",
  [GOOGLE_SEARCH_TERMS_TITLE]: "Términos de Búsqueda",
  [GOOGLE_SEARCH_TERMS_DESCRIPTION]:
    "Son las consultas exactas que escribieron los usuarios en Google y activaron tus anuncios. Cada fila muestra qué palabra clave las desencadenó.",
  [GOOGLE_SEARCH_TERMS_EMPTY]: "Aún no hay términos de búsqueda",
  [SEARCH_TERM_MATCH_TYPE_BROAD]: "Concordancia amplia",
  [SEARCH_TERM_MATCH_TYPE_PHRASE]: "Concordancia de frase",
  [SEARCH_TERM_MATCH_TYPE_EXACT]: "Concordancia exacta",
  [SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE]:
    "Concordancia de frase (variante cercana)",
  [SEARCH_TERM_MATCH_TYPE_NEAR_EXACT]: "Concordancia exacta (variante cercana)",
  [SEARCH_TERM_MATCH_TYPE_AI_MAX]: "AI Max",
  [COLUMN_NAME_IMPRESSIONS]: "Impresiones",
  [COLUMN_NAME_CLICKS]: "Clicks",
  [COLUMN_NAME_CONFIGURE_COLUMNS]: "Mostrar Columnas",
  [COLUMN_NAME_CTR]: "CTR",
  [COLUMN_NAME_CONVERSIONS]: "Conversiones",
  [COLUMN_NAME_CPA]: "CPA",
  [COLUMN_NAME_CPM]: "CPM",
  [COLUMN_NAME_CPC]: "CPC",
  [COLUMN_NAME_SPEND]: "Gasto",
  [COLUMN_NAME_MATCH_TYPE]: "Tipo de Concordancia",
  [COLUMN_NAME_PLATFORM]: "Plataformas",
  [COLUMN_NAME_RESULTS]: "Resultados",
  [COLUMN_NAME_FIELD]: "Campo",
  [COLUMN_NAME_CURRENT_VALUE]: "Valor actual",
  [COLUMN_NAME_NEW_VALUE]: "Valor nuevo",
  [COLUMN_NAME_CAMPAIGN]: "Campaña",
  [COLUMN_NAME_BUDGET]: "Presupuesto",
  [COLUMN_NAME_CREATED_BY]: "Creado por",
  [CAMPAIGNS_TABLE_ARIA_LABEL]: "Tabla de campañas publicitarias",
  [CAMPAIGNS_TABLE_TITLE]: "Listado de campañas",
  [CAMPAIGNS_STATUS_DRAFT]: "Borrador",
  [CAMPAIGNS_STATUS_FINISHED]: "Finalizado",
  [CAMPAIGNS_STATUS_DELETED]: "Eliminada",
  [CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE]: "Filtrar columnas",
  [COLUMN_NAME_ENTITY]: "Entidad",

  //ALERTS
  [ALERT_PLATFORM_STATUS_BANNER]:
    "{{platform}} está experimentando problemas técnicos. Algunas funciones pueden verse afectadas temporalmente",
  [ALERT_IMAGE_PROVIDER_STATUS_BANNER]:
    "El proveedor de generación/edición de imágenes está experimentando problemas técnicos. Esta funcionalidad puede verse afectada temporalmente",
  [ALERT_VIDEO_PROVIDER_STATUS_BANNER]:
    "El proveedor de generación de videos está experimentando problemas técnicos. Esta funcionalidad puede verse afectada temporalmente",
  [ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER]:
    "El proveedor de generación de campañas está experimentando problemas técnicos. Esta funcionalidad puede verse afectada temporalmente",
  [ALERT_REBRAND_BANNER]:
    "Buzzly ahora es Adle. La misma plataforma de marketing con IA, nueva identidad.",
  [ALERT_REBRAND_BANNER_DISCORD_BODY]:
    "Únete a la comunidad oficial de Adle en Discord.",
  [DISCORD_LINK]: "Unirse a Discord",
  [ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY]:
    "<margin>🌮</margin> Early Sumolings: ya tienes tus créditos bonus. <underline>Comparte tu experiencia en AppSumo 💛</underline>",
  [ALERT_REBRAND_BANNER_AFFILIATE_BODY]:
    "<margin>💸</margin> Genera ingresos con nuestro programa de afiliados.",
  [ALERT_REBRAND_BANNER_AFFILIATE_LINK]: "Aplica Ahora 💸",
  [APPSUMO_REVIEW_BANNER_LINK]: "Dejar Reseña",
  [ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS]: "Mensaje anterior del banner",
  [ALERT_REBRAND_BANNER_CAROUSEL_NEXT]: "Siguiente mensaje del banner",
  [MODAL_REBRAND_ADLE_TITLE]: "Buzzly ahora es Adle",
  [MODAL_REBRAND_ADLE_DESCRIPTION]:
    "Buzzly está migrando su marca a Adle. Será la misma plataforma de marketing con IA, con una nueva identidad.",
  [MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON]: "Ir a Adle",
  [ALERT_INACTIVE_SHOP_TITLE]: "Marca desactivada",
  [ALERT_INACTIVE_SHOP_DESCRIPTION]:
    "Activa la marca para seguir usando la plataforma",
  [ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION]:
    "No puedes ejecutar esta acción porque no tienes los permisos suficientes",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN]: "Crear campaña en {{platform}}",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION]:
    "¿Deseas crear una campaña en {{platform}} con la misma configuración que esta campaña?",
  [ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM]:
    "Si recargas tu cuenta, ten en cuenta que el saldo puede verse tardar unos minutos en verse reflejado y habilitarse de nuevo esta opción.",
  [ALERT_DESCRIPTION_DISCONNECT_FACEBOOK]:
    "Se deshabilitarán todas las funcionalidades de crear y gestionar campañas en Meta y publicar directamente a Instagram.",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK]:
    "Se deshabilitarán todas las funcionalidades de publicar directamente a TikTok",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS]:
    "Se deshabilitarán todas las funcionalidades de crear y gestionar campañas de TikTok",
  [ALERT_DESCRIPTION_DISCONNECT_LINKEDIN]:
    "Se deshabilitarán todas las funcionalidades de crear y gestionar campañas de LinkedIn",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE]: "¿Estás seguro?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION]:
    "Crearás una campaña con los siguientes presupuestos para cada plataforma:",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE]: "¿Estás seguro?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE]:
    "Se crearán grupos de anuncios con los siguientes nuevos presupuestos para cada plataforma",
  [ALERT_DESCRIPTION_DISCONNECT_CANVA]:
    "Se deshabilitarán todas las funcionalidades de crear contenido o editar con Canva",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE]: "Conexión exitosa",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION]:
    "Tu cuenta de TikTok ha sido conectada exitosamente, ahora necesitas crear una identidad para mostrar tus anuncios",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE]: "Conecta tu cuenta",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION]:
    "Para poder crear una campaña necesitas conectar tu cuenta",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION]: "¿Estás seguro?",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION]:
    "Al cancelar tu suscripción, perderás acceso a todas las funcionalidades de la plataforma",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE]: "Suscripción Cancelada",
  [ALERT_CANCEL_PLAN_TITLE]: "Plan Cancelado",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION]:
    "La renovación automática de tu suscripción ha sido cancelada, tu servicio seguirá activo hasta {{date, day}} de {{date, monthText}}, {{date, year}}",
  [ALERT_REACTIVATE_SUBSCRIPTION_TITLE]: "Suscripción Reactivada",
  [ALERT_PAYMENT_METHOD_CHANGED_TITLE]:
    "Tu método de pago ha cambiado correctamente",
  [ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION]:
    "Con {{NAME_BUSINESS}} tus cuentas estarán seguras. Somos una plataforma verificada y auditada por {{platform}}, lo que te permite gestionar y desconectar tus cuentas en cualquier momento.",
  [ALERT_POPUP_BLOCKED_TITLE]: "Permitir Ventanas Emergentes",
  [ALERT_POPUP_BLOCKED_DESCRIPTION]:
    "Detectamos que tienes bloqueadas las ventanas emergentes para este sitio web. Por favor, habilita las ventanas emergentes e inténtalo de nuevo.",
  [ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION]:
    "Ya no publicarás una campaña en {{platform}}",
  [ALERT_DUPLICATE_CAMPAIGN_TITLE]: "Duplicar Campaña",
  [ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION]:
    "Se creará una campaña con esta misma configuración, pero podrás editarla antes de publicarla.",
  [ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE]:
    "¿Quieres desactivar y eliminar esta campaña?",
  [ALERT_DELETE_CAMPAIGN_TITLE]: "¿Estás seguro de eliminar esta campaña?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE]: "¿Estás seguro de archivar esta campaña?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE]:
    "¿Quieres desactivar y archivar esta campaña?",
  [ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION]:
    "Esta campaña ya ha sido generada y se descontó de tu plan. Al archivarla, no podrás recuperarla y no se eliminará el gasto",
  [ALERT_DELETE_CAMPAIGN_DESCRIPTION]:
    "Se eliminará la campaña de {{platform}}. No podrás recuperar la información ni volver a crear una campaña de {{platform}} en este grupo de campañas.",
  [ALERT_DELETE_ELEMENT_TITLE]: "¿Estás seguro?",
  [ALERT_DELETE_ELEMENT_DESCRIPTION]:
    "Si eliminas este elemento, no podrás recuperar la información.",
  [ALERT_DELETE_CAMPAIGN_ERROR_TITLE]: "Error al eliminar la campaña",
  [ALERT_DELETE_CAMPAIGN_ERROR_TEXT]:
    "No se pudo eliminar la campaña, inténtalo de nuevo",
  [ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE]:
    "Elige si quieres que tu campaña se cree en estado activo o inactivo",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE]: "No tienes una cuenta registrada",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION]:
    "Para poder registrarte necesitas agendar un demo con nosotros.",
  [ALERT_DESCRIPTION_DISCONNECT_GOOGLE]:
    "Se deshabilitarán todas las funcionalidades de crear y gestionar campañas de Google Ads",
  [ALERT_CONNECT_GOOGLE_BETA_TITLE]: "Conecta tu cuenta de Google Ads",
  [ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION]:
    "Esta funcionalidad está en <strong>BETA</strong>. A continuación, verás cómo conectar tu cuenta de Google Ads.",
  [ALERT_FILL_BRAND_SETUP_TITLE]: "Completa la información de tu marca",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN]:
    "Llena la información de tu marca para generar una campaña con IA",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES]:
    "Llena la información de tu marca para generar creativos con IA",
  [ALERT_DELETE_KEYWORD_TITLE]: "Eliminar palabra clave",
  [ALERT_DELETE_KEYWORD_DESCRIPTION]:
    "¿Estás seguro de querer eliminar esta palabra clave?",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE]:
    "Espera",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION]:
    "Si realizas este cambio, los contenidos que hayas seleccionado para tus anuncios se deseleccionarán",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE]: "¿Estás seguro?",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION]:
    "Al utilizar creativos dinámicos se aplicarán las siguientes limitaciones:<br><br><ul><li>Solo se podrá tener 1 Anuncio. (Se eliminarán los restantes si tienes más de uno)</li><br/><li>Solo podrás utilizar Website o Formularios Instantáneos como ubicación de conversión del grupo de anuncios</li><br/></ul>Estas correcciones se aplicarán de forma automática si continúas.",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE]: "¿Estás seguro?",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION]:
    "Al dejar de utilizar creativos dinámicos, se aplicarán los siguientes cambios:<br><br><ul><li>Se reiniciará tu único anuncio, dejando únicamente el primer creativo y el primer call to action</li></ul>",
  [ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE]: "Espera",
  [ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION]: `Al cambiar de cuenta publicitaria se resetearán algunas configuraciones seleccionadas de tu campaña:<br/><br/>

Pixel<br/>
Formulario instantaneo<br/>
Número de WhatsApp<br/>
Audiencias personalizadas<br/>
Presupuestos`,
  [ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION]: `Al cambiar de cuenta publicitaria se resetearán algunas configuraciones seleccionadas de tu campaña:<br/><br/>

Identidad de TikTok<br/>
Pixel<br/>
Presupuestos`,
  [ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION]: `Al cambiar de cuenta publicitaria se resetearán algunas configuraciones seleccionadas de tu campaña:<br/><br/>

Acciones de conversión<br/>
Presupuesto`,
  [ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION]: `Al cambiar de cuenta publicitaria se resetearán algunas configuraciones seleccionadas de tu campaña:<br/><br/>

Audiencias personalizadas<br/>
Formulario instantáneo<br/>
Presupuesto`,
  [ALERT_DELETE_KEYWORDS_TITLE]: "Eliminar palabras clave",
  [ALERT_DELETE_KEYWORDS_DESCRIPTION]:
    "¿Estás seguro de querer eliminar {{value}} palabras clave?",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE]: "Espera",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION]:
    "Uno o más grupos de anuncios tienen audiencias personalizadas configuradas, si seleccionas audiencias personalizadas a nivel de campaña, se deseleccionarán las configuraciones de audiencias personalizadas de los grupos de anuncios.",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE]: "Espera",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION]:
    "Hay una o más audiencias personalizadas configuradas a nivel de campaña, si seleccionas audiencias personalizadas a nivel de grupo, se deseleccionarán las configuraciones de audiencias personalizadas de la campaña.",
  [SUGGESTION_BUDGET_TITLE]: "Sugerencia de Presupuesto",
  [SUGGESTION_BUDGET_TEXT]:
    "Has extendido la fecha de finalización de este grupo de anuncios, te recomendamos incrementar el presupuesto total, para mantener una relacion igual",
  [SUGGESTION_BUDGET_PREVIOUS]: "Presupuesto Anterior",
  [SUGGESTION_BUDGET_CURRENT]: "Presupuesto Sugerido",
  [SUGGESTION_BUDGET_APPLY]: "Aplicar Sugerencia",
  [SUGGESTION_BUDGET_CANCEL]: "Cancelar",
  [SUGGESTION_BUDGET_MINIMUM]: "Presupuesto Mínimo",
  [ALERT_CHANGE_ADVERTISER_TITLE]: "Cambiaste al anunciante {{businessName}}",
  [ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION]:
    "No se pudo redimensionar esta imagen, por favor inténtalo de nuevo.",

  //OPTIONS UGC FORMATS
  [OPTION_UGC_FORMAT_GRWM]: "GRWM (Get Ready With Me)",
  [OPTION_UGC_FORMAT_GRWM_EXPLANATION]:
    "Este tipo de contenido involucra a creadores de contenido compartiendo su rutina de preparación, ya sea para el día a día o para eventos especiales. Los espectadores pueden ver cómo el creador se maquilla, peina y elige su vestuario, mientras habla de diversos temas de manera informal.",
  [OPTION_UGC_FORMAT_OODT]: "OOTD (Outfit of the Day)",
  [OPTION_UGC_FORMAT_OODT_EXPLANATION]:
    "En estos videos o publicaciones, los creadores muestran el atuendo que han elegido para el día. Es popular entre entusiastas de la moda y puede incluir detalles sobre dónde compraron la ropa, cómo la combinan con otros elementos y consejos de estilo.",
  [OPTION_UGC_FORMAT_HAULS]: "Hauls",
  [OPTION_UGC_FORMAT_HAULS_EXPLANATION]:
    "Los 'hauls' son videos o series de fotos donde los creadores muestran una colección de productos que han comprado recientemente, que pueden incluir moda, belleza, tecnología, etc. A menudo, comparten sus primeras impresiones sobre estos productos y pueden incluir demostraciones de uso.",
  [OPTION_UGC_FORMAT_DIYS]: "Tutorials/DIYs",
  [OPTION_UGC_FORMAT_DIYS_EXPLANATION]:
    "Tutoriales o 'Do It Yourself' (Hazlo Tú Mismo) son guías paso a paso creadas por usuarios que muestran cómo hacer algo, desde recetas de cocina hasta proyectos de manualidades y trucos de belleza. Estos contenidos son educativos y buscan enseñar habilidades de manera fácil y accesible.",
  [OPTION_UGC_FORMAT_UNBOXING]: "Unboxing",
  [OPTION_UGC_FORMAT_UNBOXING_EXPLANATION]:
    "En estos videos, los creadores abren productos nuevos frente a la cámara para mostrar su contenido y dar una primera impresión. Son comunes en tecnología, juguetes, cosméticos y más, ayudando a los espectadores a decidir si desean comprar esos productos.",
  [OPTION_UGC_FORMAT_CHALLENGES]: "Challenges",
  [OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION]:
    "Los retos o 'challenges' son actividades en las que los creadores participan para entretener a sus seguidores. Estos pueden variar desde retos de comida, juegos, actividades físicas hasta retos de moda, como crear un atuendo con elementos específicos.",
  [OPTION_UGC_FORMAT_REVIEWS]: "Reviews/Testimonios",
  [OPTION_UGC_FORMAT_REVIEWS_EXPLANATION]:
    "Los creadores comparten sus opiniones y experiencias detalladas sobre un producto o servicio específico. Estas reseñas ayudan a otros usuarios a formarse una opinión antes de hacer una compra.",
  [OPTION_UGC_FORMAT_VLOGS]: "Vlogs",
  [OPTION_UGC_FORMAT_VLOGS_EXPLANATION]:
    "Los vlogs son diarios en video donde los creadores comparten aspectos de su vida diaria, viajes, eventos especiales, etc. Son personales y permiten a los espectadores sentir una conexión más cercana con el creador.",
  [OPTION_UGC_FORMAT_QA]: "Q&A (Questions and Answers)",
  [OPTION_UGC_FORMAT_QA_EXPLANATION]:
    "En un formato de preguntas y respuestas, los creadores interactúan directamente con su audiencia respondiendo preguntas que estos han enviado previamente. Esto ayuda a construir una relación más personal y directa con los seguidores.",
  [OPTION_UGC_FORMAT_STORYTIME]: "Storytime",
  [OPTION_UGC_FORMAT_STORYTIME_EXPLANATION]:
    "Estos son videos o posts en los que los creadores narran historias personales o experiencias significativas. Son atractivos debido a su aspecto narrativo y a menudo incluyen lecciones o moralejas.",
  [OPTION_UGC_FORMAT_ROOM_TOURS]: "Room Tours",
  [OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION]:
    "Los creadores muestran su espacio personal, como su dormitorio, estudio o casa entera. Estos videos son populares porque permiten a los seguidores obtener ideas de decoración y sentir una cercanía con el estilo de vida del creador.",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG]: "What's in My Bag?",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION]:
    "En este tipo de contenido, los creadores revelan lo que llevan en sus bolsos o mochilas diariamente. Es popular especialmente entre celebridades y personas influyentes en la moda y belleza, ya que ofrece un vistazo a sus esenciales personales.",
  [OPTION_UGC_FORMAT_COOKING]: "Cooking/Baking Recipes",
  [OPTION_UGC_FORMAT_COOKING_EXPLANATION]:
    "Los creadores comparten recetas y procesos de cocina o repostería en forma de videos o posts. Estos contenidos son útiles para quienes buscan nuevas ideas de comidas y disfrutan del aspecto visual y explicativo de la cocina.",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES]: "Fitness Routines",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION]:
    "Los influencers de fitness comparten sus rutinas de ejercicios, consejos de salud y jornadas de bienestar. Estos videos son motivacionales y educativos, ayudando a los seguidores a mantenerse activos y saludables.",
  [OPTION_UGC_FORMAT_ASMR]: "ASMR (Autonomous Sensory Meridian Response):",
  [OPTION_UGC_FORMAT_ASMR_EXPLANATION]:
    "Los videos de ASMR están diseñados para provocar una sensación relajante en los espectadores a través de sonidos suaves y movimientos meticulosos. Son muy populares para la relajación y el manejo del estrés.",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME]: "Plan With Me",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION]:
    "En estos videos, los creadores muestran cómo organizan su agenda o planificador semanal, compartiendo técnicas de gestión del tiempo y decoración de sus planificadores. Es ideal para los amantes de la papelería y la organización personal.",
  [OPTION_UGC_FORMAT_MUKBANG]: "Mukbang",
  [OPTION_UGC_FORMAT_MUKBANG_EXPLANATION]:
    "Originado en Corea del Sur, en estos videos los creadores comen grandes cantidades de comida mientras interactúan con su audiencia. Se ha popularizado globalmente como una forma de compañía virtual durante las comidas.",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE]: "Day in the Life",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION]:
    "Los creadores comparten un video que documenta un día típico en su vida, mostrando desde la mañana hasta la noche. Esto da a los seguidores una visión completa de sus actividades cotidianas y su estilo de vida.",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES]: "Behind the Scenes",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION]:
    "Estos videos ofrecen una mirada detrás de cámaras en la vida de los creadores, incluyendo cómo preparan sus contenidos, gestionan negocios, o incluso eventos especiales a los que asisten.",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES]: "Travel Diaries",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION]:
    "En diarios de viaje, los creadores comparten experiencias, consejos y aventuras de sus viajes. Estos videos o posts son atractivos para quienes buscan inspiración para viajar o aprender sobre nuevas culturas.",

  //ERRORS
  [SOMETHING_ERROR_GENERATING_STATISTICS]:
    "Algo salió mal con la generación de estadísticas, por favor inténtalo de nuevo.",
  [AUTH_SENT_EMAIL_RESET_PASSWORD]:
    "Se ha enviado un correo para restablecer la contraseña",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TITLE]: "Te Diste de Baja Correctamente",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TEXT]:
    "Ya no recibirás correos en esta dirección.",
  [EMAIL_UNSUBSCRIBE_ERROR_TITLE]: "No Se Pudo Completar la Baja",
  [EMAIL_UNSUBSCRIBE_ERROR_TEXT]:
    "No pudimos procesar tu solicitud. El enlace puede ser inválido o haber expirado.",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN]: "{{nameBusiness}} - Inicio de sesión",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER]:
    "{{nameBusiness}} - Inicio de sesión Admin",
  [AUTH_LOGIN_OWNER_CHIP_LABEL]: "Acceso Owner",
  [AUTH_LOGIN_OWNER_SUBMIT]: "Acceso Owner",
  [AUTH_LOGIN_OWNER_NOT_OWNER]: "¿No eres owner?",
  [AUTH_LOGIN_OWNER_GO_TO_LOGIN]: "Acceder",
  [AUTH_PAGE_DOCUMENT_TITLE_REGISTER]: "{{nameBusiness}} - Registro",
  [AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD]:
    "{{nameBusiness}} - Restablecer contraseña",
  [AUTH_PAGE_BRANDING_LOGO_ALT]: "Logotipo",
  [AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER]:
    "Este correo ya está registrado. Inicia sesión abajo con tu contraseña o recupérala si la olvidaste.",
  [ACCOUNT_ROLE_INVALID]:
    "Esta cuenta no tiene un rol válido para iniciar sesión",
  [ERROR_INTERNAL]: "Error interno, intenta de nuevo más tarde",
  [AUTH_INVALID_PASSWORD]: "La contraseña no es válida",
  [AUTH_WRONG_PASSWORD]: "El correo o contraseña es incorrecto",
  [AUTH_MANY_REQUESTS]:
    "Demasiados intentos fallidos, intenta de nuevo más tarde",
  [AUTH_USER_NOT_FOUND]: "El correo o contraseña es incorrecto",
  [AUTH_EMAIL_ALREADY_EXISTS]: "El correo electrónico ya está en uso",
  [PHONE_ALREADY_REGISTERED]: "Este número de teléfono ya está registrado",
  [AUTH_INVALID_VERIFICATION_CODE]: "El código de verificación no es válido",
  [AUTH_INVALID_APP_CREDENTIAL]: "Número de telefono invalido",
  [STRIPE_CARD_DECLINED]:
    "La tarjeta ha sido rechazada. Verifica la información o validez de la tarjeta o usa una tarjeta diferente",
  [STRIPE_EXPIRED_CARD]:
    "La tarjeta ha caducado. Verifica la fecha de vencimiento o usa una tarjeta diferente",
  [STRIPE_INCORRECT_CVC]:
    "El código de seguridad de la tarjeta es incorrecto. Verifica el código de seguridad de la tarjeta o usa una tarjeta diferente",
  [STRIPE_PROCESSING_ERROR]:
    "Ocurrió un error al procesar la tarjeta. Vuelve a intentarlo más tarde o prueba con otro método de pago",
  [STRIPE_INCORRECT_NUMBER]:
    "El número de tarjeta es incorrecto. Verifica el número de la tarjeta o usa una tarjeta diferente",
  [STRIPE_GENERIC_DECLINE]:
    "La tarjeta fue rechazada por un motivo desconocido",
  [STRIPE_INSUFFICIENT_FUNDS]:
    "La tarjeta no tiene fondos suficientes para completar la compra o para el cobro de verificación",
  [STRIPE_LOST_CARD]:
    "El pago fue rechazado porque la tarjeta se reportó perdida",
  [STRIPE_STOLEN_CARD]:
    "El pago fue rechazado porque la tarjeta fue reportada como robada",
  [STRIPE_PROFILE_NOT_FOUND]: "Este perfil no existe",
  [STRIPE_INTENT_AUTH_FAILURE]: "La autenticación de la tarjeta falló",
  [NIT_VALID]: "Número de identificación",
  [BUSINESS_NAME_VALID]: "Razón social de la empresa",
  [BRAND_NAME_VALID]: "Nombre de la marca",
  [ADDRESS_VALID]: "Dirección de la empresa",
  [CATEGORY_VALID]: "Categoría",
  [SUBCATEGORIES_VALID]: "Sub categorías",
  [SHORT_DESCRIPTION_VALID]: "Descripción corta de la empresa",
  [ORDERS_METHODS_VALID]: "Métodos de entrega de pedidos",
  [LOGO_IMG_VALID]: "Logo de la empresa",
  [COVER_IMG_VALID]: "Imagen de portada",
  [SCHEDULE_VALID]: "Horarios de atención de la empresa",
  [STORES_VALID]: "Al menos una tienda creada y que esté activa",
  [IS_PLAN_ACTIVE_VALID]: "Debes tener un plan activo",
  [MENUS_VALID]:
    "Debes tener al menos una categoría con al menos un producto creado en el menú",
  [DEFAULT_PAYMENT_METHOD_VALID]:
    "Debes tener una tarjeta por defecto añadida o créditos comprados",
  [HAS_DEBT_VALID]: "No debes tener pagos pendientes",
  [SUBSCRIPTION_PLAN_VALID]: "Debes tener un plan activo",
  [MISSING_PARAMETERS]: "No se enviaron los parámetros requeridos.",
  [PASSWORD_INVALID]: "Contraseña inválida.",
  [INVALID_SEARCH]: "Búsqueda inválida.",
  [USER_ID_REQUIRED]: "UserID es requerido.",
  [SHOP_ID_REQUIRED]: "ShopID es requerido.",
  [LAST_USER_NOT_DELETED]:
    "No puedes eliminar todos los usuarios; debes dejar al menos uno.",
  [PLAN_TRIAL_USER_USED]: "Ya se usó el periodo de prueba para este usuario.",
  [ORDERS_NOT_FOUND_IN_INTERVAL]:
    "No se encontraron órdeenes en el intervalo de fechas seleccionado.",
  [TYPE_REPORT_NOT_FOUND]: "No se encontró el tipo de reporte.",
  [SHOP_NOT_FOUND]: "Marca no encontrada.",
  [PAYMENT_MODEL_INVALID]: "Modelo de pago inválido.",
  [SHOP_NOT_HAS_SOCIAL_NETWORK]: "La marca no tiene una red social asociada.",
  [NO_VALID_PLATFORM_FOUND]: "No se encontró una plataforma válida.",
  [GETTING_STATISTICS]:
    "Error obteniendo estadísticas, por favor intenta de nuevo más tarde o contacta soporte.",
  [SHOP_BUSINESS_NAME_NOT_FOUND]: "No se encontró el nombre de la marca.",
  [REFERENCE_PROFILES_REQUIRED]: "No se encontró perfiles de referencia.",
  [DECRYPTING_PASSWORD]: "Error obteniendo contraseña.",
  [USER_ID_AND_PAYMENT_ID]: "El UserID y paymentID son requeridos.",
  [MESSAGES_REQUIRED]: "Los mensajes requeridos.",
  [PLAN_IS_NO_ACTIVE]: "El plan no está activo.",
  [USER_BANNED]: "Este usuario está baneado.",
  [GETTING_LOCALES]:
    "Error obteniendo archivos locales, por favor intenta de nuevo más tarde o contacta soporte.",
  [GETTING_PROFILE]:
    "Error obteniendo los datos del perfil, por favor intenta de nuevo más tarde o contacta soporte.",
  [PRODUCTS_NOT_SENT]: "No se enviaron los productos.",
  [ACCOUNT_NOT_FOUND]: "No se encontró la cuenta.",
  [COLLECTING_INFORMATION_RETRY_AFTER]:
    "Error recolectando la información, por favor intenta de nuevo más tarde o contacta soporte.",
  [ERROR_OCCURRED]:
    "Ocurrió un error inesperado, por favor intenta de nuevo más tarde",
  [FREE_BOT_MESSAGES_LIMIT_REACHED]:
    "Llegaste al límite de {{limit}} mensajes gratis de hoy con el agente. Se restablece mañana.",
  [TEXT_REGENERATION_LIMIT_REACHED]:
    "Esta campaña ya usó las {{limit}} regeneraciones de texto gratis.",
  [REFERENCE_VIDEO_ANALYSIS_UNAVAILABLE]:
    "Por ahora no está disponible el servicio de anuncio de referencia porque nuestro proveedor de análisis de video no está disponible. Inténtalo más tarde.",
  [ACTION_COULD_NOT_BE_COMPLETED]:
    "No se pudo concretar esta acción debido a un error de nuestro proveedor, por favor intenta de nuevo más tarde.",
  [PLATFORM_NOT_SENT]: "No se envió la plataforma.",
  [PLATFORM_APP_REQUEST_LIMIT_REACHED]:
    "Esta plataforma tiene una demanda muy alta y está limitando las solicitudes temporalmente. Algunas funciones pueden verse afectadas.",
  [VERIFICATION_CODE_NOT_FOUND]: "No se encontró el código de verificación.",
  [VERIFICATION_CODE_INCORRECT]: "El código de verificación es incorrecto.",
  [REGISTRATION_EMAIL_NOT_VERIFIED]:
    "El correo electrónico no está verificado.",
  [ORDER_NOT_FOUND]: "No se encontró la orden.",
  [TYPE_OR_PATH_NOT_SENT]: "El archivo o la ruta no se enviaron.",
  [ID_OR_PATH_NOT_SENT]: "El ID del archivo o la ruta no se enviaron.",
  [IDS_NOT_SENT]: "Los IDs no se enviaron",
  [ANALYTIC_URL_NOT_SENT]: "La URL de la analítica no se envió.",
  [ANALYTIC_URL_INVALID]: "La URL de la analítica es inválida.",
  [EXTRACTING_ANALYTICS]:
    "Error extrayendo la analítica, por favor intenta de nuevo más tarde o contacta soporte.",
  [CREDENTIALS_INVALID]: "Credenciales inválidas.",
  [COLLABORATION_PRICE_NOT_BE_NEGATIVE]:
    "El precio de la colaboración no puede ser negativo.",
  [CREDITS_NOT_BE_NEGATIVE]: "Los créditos no pueden ser negativos.",
  [PACKAGES_PRICES_NOT_BE_NEGATIVE]:
    "El precio de los planes no puede ser negativo.",
  [ROL_REQUIRED]: "El rol es requerido.",
  [SHOP_ID_AND_STORE_ID_REQUIRED]: "ShopID y storeID son requeridos.",
  [PASSWORD_MUST_BE_6_CHARACTERS]:
    "La contraseña debe tener al menos 6 caracteres.",
  [ALL_USERS_NOT_DELETE]:
    "No puedes eliminar todos los usuarios; debes dejar al menos uno.",
  [SHOP_APPLICANT_NOT_FOUND]: "No se encontró la aplicación de la marca.",
  [USER_PASSWORD_NOT_FOUND]: "No se encontró la contraseña del usuario.",
  [PLAN_NOT_FOUND]: "No se encontró el plan.",
  [SUBSCRIPTION_NOT_CREATED]: "No se creó la suscripción.",
  [ID_SUBSCRIPTION_NOT_FOUND]: "El ID de la suscripción no se encontró.",
  [SUBSCRIPTION_REACTIVATE]: "Suscripción reactivada.",
  [CUSTOMER_ID_NOT_FOUND]: "No se encontró el customerID.",
  [APPLICANT_NOT_FOUND]: "No sé encontró el aplicante.",
  [SHOP_COUNTRY_NOT_FOUND]: "No sé encontró el país de la marca.",
  [FINAL_PRICE_NOT_FOUND]: "No se pudo obtener el precio final.",
  [PAYMENT_FAILED]: "Pago fallido",
  [CREDITS_MUST_BE_GREATER_THAN_ZERO]: "Los créditos deben ser mayores a 0.",
  [CSRF_INVALID]: "CSRF inválido",
  [INTEGRATION_INFORMATION_NOT_FOUND]:
    "No se encontró información de la integración.",
  [MODAL_INTEGRATION_NOT_FOUND_TITLE]: "Reconectar tus Cuentas",
  [MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION]:
    "Existe un error con la cuenta conectada actualmente. Reconecta la cuenta actual o conecta una nueva desde el seleccionador que aparece al final de la tabla, luego elige la cuenta que debe usar cada campaña. La integración que conectes debe tener acceso a la cuenta publicitaria de la campaña.",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM]: "Plataforma",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN]: "Campaña",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT]: "Cuenta Publicitaria",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON]: "Motivo",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION]: "Integración",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED]:
    "No se puede resolver la campaña asociada.",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING]: "Cargando...",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR]:
    "Error al cargar datos de la campaña.",
  [MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER]:
    "Selecciona una integración",
  [MODAL_INTEGRATION_NOT_FOUND_SAVE]: "Guardar",
  [GETTING_VIDEO]: "Error obteniendo el vídeo.",
  [UPLOAD_URL_NOT_FOUND]: "No se encontró la URL de subida.",
  [UPLOADING_VIDEO]: "Error subiendo el vídeo.",
  [STORE_NOT_FOUND]: "No se encontró la tienda.",
  [NAME_REQUIRED]: "El nombre es requerido.",
  [PRICE_REQUIRED]: "El precio es requerido.",
  [CURRENCY_REQUIRED]: "La moneda es requerida.",
  [RECURRING_REQUIRED]: "La recurrencia es requerida.",
  [CREATING_PRODUCT]: "Error creando el producto.",
  [CREATING_PRICE]: "Error creado el precio.",
  [CREATING_PAYMENT_LINK]: "Error creando el link de pago.",
  [GETTING_PAYMENT_LINK]: "Error obteniendo el link de pago.",
  [TOKEN_INVALID]: "Token invalido",
  [TOKEN_EXPIRED]: "El token expiró",
  [IG_ACCOUNT_NOT_FOUND]:
    "No se encontró una cuenta de Instagram vinculada a una página de Facebook. Por favor, asegúrate de haber seleccionado una cuenta de Instagram durante la integración o vincula una e intenta de nuevo.",
  [IG_DATA_NOT_FOUND]: "Información de Instagram no encontrada",
  [REVIEW_NOT_FOUND]: "No se encontró la review para esta colaboración",
  [REVIEW_IS_NOT_ONE_START]:
    "La review de esta colaboración no es igual a 1 estrella, no se te puede dar un crédito",
  [DISSATISFACTION_CREDIT_ALREADY_EXISTS]:
    "Ya se ha asignado un crédito gratis para esta colaboración",
  [META_INTEGRATION_UNLINKED_PAGES_ERROR]:
    "Es posible que no tengas vinculada tu cuenta de Instagram a tu página de Facebook o Meta Business. Por favor vincula tus cuentas para poder continuar.",
  [PAYMENT_METHOD_NOT_FOUND]:
    "No tienes un método de pago agregado, por favor agrega uno para continuar.",
  [HAS_PENDING_PAYMENTS]:
    "Tienes facturas pendientes, por favor realiza el pago para continuar.",
  [NO_IMAGES_FOUND_ON_PAGE]: "No se encontraron imágenes en la página",
  [NO_CREATE_DISCOUNT_SHOPIFY]:
    "Obtuvimos un error por parte de Shopify durante la integración, asegúrate de haber seleccionado los alcances 'read_price_rules', 'write_price_rules', 'write_discounts' y 'read_discounts' durante los pasos de la integración.",
  [NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY]:
    "Obtuvimos un error por parte de Shopify durante la integración, asegúrate de haber seleccionado el alcance 'read_orders' durante los pasos de la integración.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY]:
    "Obtuvimos un error por parte de Shopify durante la integración, asegúrate de haber seleccionado el alcance 'read_fulfillments' durante los pasos de la integración.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY]:
    "Obtuvimos un error por parte de Shopify durante la integración, asegúrate de haber seleccionado el alcance 'read_fulfillments' durante los pasos de la integración.",
  [GETTING_INFORMATION_FROM_SHOPIFY_URL]:
    "Error obteniendo la configuración de Shopify, por favor asegúrate de que la URL sea correcta y que el acceso a la tienda sea publico.",
  [RATE_DAILY_LIMIT_AI]:
    "Has alcanzado el límite diario de uso de funcionalidades de inteligencia artificial. Por favor, inténtalo de nuevo mañana.",
  [RATE_DAILY_LIMIT_AI_CHAT]:
    "Has alcanzado el límite de {{NAME_BUSINESS}} Help por hoy. Por favor, inténtalo de nuevo mañana.",
  [PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META]:
    "Los permisos o la configuración de tu cuenta cambiaron, inténtalo de nuevo. Si el error persiste, desconecta y vuelve a conectar la cuenta.",
  [ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS]:
    "Tu cuenta de Instagram no es del tipo Business o no seleccionaste todos los permisos, por favor cambia tu cuenta a business e intenta de nuevo. Si el error persiste desconecta y conecta de nuevo la cuenta.",
  [FACEBOOK_PAGE_ID_NOT_FOUND]:
    "No se encontró una página de Facebook vinculada. Por favor, asegúrate de haber seleccionado una página durante la integración o vincula una e intenta de nuevo.",
  [META_BUSINESS_ACCOUNT_NOT_FOUND]:
    "No se encontró una cuenta de negocio vinculada. Por favor, asegúrate de haber seleccionado una cuenta de negocio durante la integración o vincula una e intenta de nuevo.",
  [IG_BUSINESS_ACCOUNT_NOT_FOUND]: `No se encontró una cuenta de Instagram de Creador o de Negocio vinculada a la página de Facebook que seleccionaste, sigue este paso a paso para vincular una cuenta de Instagram.
    <ol>
     <li style="text-align: left">
      Ingresa al <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/" target="_blank">Centro de Negocios de Meta</a>
     </li>
     <li style="text-align: left">
      Busca y selecciona la página de Facebook que quieres conectar
     </li>
     <li style="text-align: left">
      En la nueva interfaz dale clic en "Conectar Activos"
     </li>
     <li style="text-align: left">
      En la nueva ventana dale click en "Conectar cuenta de Instagram"
     </li>
     <li style="text-align: left">
      En la nueva ventana conectate a tu cuenta de Instagram y finaliza la conexión
     </li>
     <li style="text-align: left">
      Una vez terminada la conexión, intenta conectar de nuevo tu cuenta en nuestra plataforma
     </li>
    </ol>
    `,
  [ACCOUNT_TIKTOK_AUTH_NOT_MATCH]:
    "No pudimos verificar tu cuenta, por favor inténtalo de nuevo.",
  [ACCOUNT_TOKEN_META_NOT_FOUND]:
    "No pudimos encontrar la información de tu integración con Meta, intenta de nuevo o reconecta tu cuenta.",
  [ACCOUNT_ID_BUSINESS_META_NOT_FOUND]:
    "No encontramos una cuenta Business de Meta vinculada a tu cuenta, por favor intenta de nuevo o vincula una cuenta Business.",
  [OBJECTIVE_CAMPAIGN_META_INVALID]:
    "El objetivo de la campaña seleccionado no es válido.",
  [SPECIAL_CATEGORY_CAMPAIGN_META_INVALID]:
    "El tipo de categoría especial seleccionado no es válido.",
  [CAMPAIGN_META_NOT_DELETED]:
    "No se pudo eliminar la campaña, intenta de nuevo.",
  [CAMPAIGN_META_NOT_CREATED]: "No se pudo crear la campaña, intenta de nuevo.",
  [ADS_CAMPAIGN_NOT_FOUND]: "No se encontró la campaña de anuncios.",
  [NO_PIXELS_FOUND]:
    "No se encontraron píxeles asociados a tu cuenta de Meta, por favor crea uno e inténtalo de nuevo.",
  [NO_PIXELS_ACTIVE]:
    "No tienes un píxel activo asociado a tu cuenta de Meta, por favor activa uno e inténtalo de nuevo.",
  [CAMPAIGN_META_NOT_FOUND]: "No se encontró la campaña en Meta.",
  [CAMPAIGN_META_NOT_UPDATED]:
    "No se pudo actualizar la campaña, intenta de nuevo.",
  [CAMPAIGN_AD_SET_META_NOT_CREATED]:
    "No se pudo crear el conjunto de anuncios, intenta de nuevo.",
  [CAMPAIGN_AD_SET_META_NOT_UPDATED]:
    "No se pudo actualizar el conjunto de anuncios, intenta de nuevo.",
  [CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT]:
    "Ocurrió un error actualizando la información, por favor intenta de nuevo en unos segundos.",
  [CAMPAIGN_MEDIA_META_NOT_CREATED]:
    "No se pudo subir el vídeo de la campaña, intenta de nuevo.",
  [CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND]:
    "No se encontró la miniatura del vídeo de la campaña.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_CREATED]:
    "No se puedo crear la plantilla creativa del anuncio, intenta de nuevo.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED]:
    "No se pudo actualizar la plantilla creativa del anuncio, intenta de nuevo.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_FOUND]:
    "No se encontró la plantilla creativa del anuncio.",
  [CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND]:
    "No se pudo recuperar el formulario de WhatsApp de este anuncio. Intenta de nuevo más tarde.",
  [CAMPAIGN_AD_META_NOT_CREATED]:
    "No se pudo crear el anuncio, intenta de nuevo.",
  [CAMPAIGN_AD_META_NOT_UPDATED]:
    "No se pudo actualizar el anuncio, intenta de nuevo.",
  [CAMPAIGN_METRICS_META_NOT_FOUND]:
    "No se encontraron las métricas de la campaña.",
  [CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "No tienes saldo suficiente para crear una campaña, por favor recarga tu cuenta y vuelve a intentarlo.",
  [ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "No tienes saldo suficiente para activar la campaña, por favor recarga tu cuenta y vuelve a intentarlo.",
  [CAMPAIGN_AUDIENCE_IS_TOO_NARROW]:
    "Tu audiencia objetivo es muy pequeña, intenta cambiar tus criterios de segmentación para alcanzar una audiencia más ampliar.",
  [CAMPAIGN_BUDGET_IS_TOO_LOW]: "Tu presupuesto diario es muy bajo.",
  [IDENTITY_NOT_FOUND]:
    "No encontramos un perfil de TikTok vinculado a tu cuenta de TikTok Business, por favor vincula un perfil e intenta de nuevo.",
  [VIDEO_ERROR_LOW_RESOLUTION]:
    "El video tiene una resolución muy baja, intenta subir un video con una resolución mayor.",
  [VIDEO_ERROR_NO_BACKGROUND_AUDIO]:
    "El vídeo no tiene audio o el audio es muy bajo, intenta subir un vídeo con un audio claro y audible.",
  [VIDEO_ERROR_ASPECT_RATIO]:
    "El video no tiene un aspecto permitido, intenta subir un vídeo con un aspecto de 1:1 (cuadrado), 9:16 (vertical) o 16:9(horizontal).",
  [VIDEO_ERROR_BLACK_EDGE]:
    "El vídeo tiene franjas negras o bordes, intenta subir un vídeo sin bordes.",
  [VIDEO_ERROR_ILLEGAL_DURATION]:
    "El video tiene una duración no permitida, intenta subir un video con una duración entre 5 y 60 segundos.",
  [ERROR_GETTING_URL_INFORMATION_BY_PROTECTED]:
    "No pudimos obtener la información de tu sitio web. Algunas páginas utilizan mecanismos que bloquean el acceso automatizado (anti-crawlers), por lo que tendrás que ingresar la información manualmente.",
  [META_ERROR_GETTING_USER_INFORMATION]:
    "Error obteniendo la información del usuario",
  [META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION]:
    "Error obteniendo la información de las cuentas de publicitarias",
  [META_ERROR_GETTING_ACCOUNTS_INFORMATION]:
    "Error obteniendo la información de las cuentas",
  [META_AD_ACCOUNT_IS_NOT_ACTIVE]:
    "La cuenta publicitaria de Meta está deshabilitada",
  [META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD]:
    "La cuenta publicitaria de Meta no tiene un método de pago valido asociado",
  [META_OAUTH_PERMISSIONS_ERROR]: `No tienes acceso a alguno de los recursos que intentas usar, verifica lo siguiente:<br/>
    <ul style="text-align: left">
      <li>Que tengas seleccionada la cuenta publicitaria correcta</li>
      <li>Que tu cuenta publicitaria esté activa, tenga un método de pago válido asociado y no tenga pagos pendientes</li>
      <li>Que tengas correctamente acceso a pixels, catálogos o posts (si seleccionaste)</li>
    </ul>`,
  [META_ACCOUNT_AUTHENTICATION_REQUIRED]: `Meta te exige verificar tu cuenta antes de crear o modificar anuncios. Completa la verificación en el Administrador de anuncios de Meta e intenta publicar de nuevo en {{NAME_BUSINESS}}.<br/>
    <ol style="text-align: left; padding-left: 1.25em; margin: 0.5em 0 0;">
      <li style="text-align: left; margin-bottom: 0.35em;">Abre el <a style="color:inherit" href="https://adsmanager.facebook.com/adsmanager/manage/campaigns" target="_blank">Administrador de anuncios de Meta</a></li>
      <li style="text-align: left; margin-bottom: 0.35em;">En el selector de cuentas (arriba a la izquierda), busca y selecciona la cuenta publicitaria que usas para esta campaña en {{NAME_BUSINESS}}</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Haz clic en <strong>Crear</strong> para iniciar una campaña, elige cualquier objetivo y rellena datos ficticios</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Cuando esté creada la estructura, abre el anuncio desde el panel izquierdo</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Puede que ya veas una alerta en rojo para autenticarte; si aparece, síguela. Si no, continúa con el siguiente paso</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Completa los datos de campaña y anuncio hasta poder pulsar <strong>Publicar</strong> (abajo a la derecha). Al intentar publicar, Meta debería pedirte autenticarte</li>
      <li style="text-align: left; margin-bottom: 0;">Tras autenticarte, intenta publicar de nuevo en {{NAME_BUSINESS}}. Si sigues sin poder o no viste la alerta, contacta a soporte</li>
    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_TIK_TOK]: `No se encontró una cuenta publicitaria asociada a la cuenta que quieres conectar, sigue este paso a paso para crear una e intenta de nuevo.<br/>
     <ol>
      <li style="text-align: left">
      Ingresa al <a style="color:inherit" href="https://business.tiktok.com/select" target="_blank">centro de negocios</a>
      </li>
      <li style="text-align: left">
      Selecciona una cuenta de negocios
      </li>
      <li style="text-align: left">
      En el menú izquierdo busca la opción de "Cuentas de Anunciantes" y dale click
      </li>
      <li style="text-align: left">
      En la parte superior encontrarás un botón de "Agregar cuenta de anunciante", dale click y sigue los pasos
      </li>
      <li style="text-align: left">
      Cuando termines de crearla, intenta conectar de nuevo tu cuenta en nuestra plataforma
      </li>
    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_GOOGLE]: `No se encontró una cuenta publicitaria asociada a la cuenta que quieres conectar, sigue este paso a paso para crear una e intenta de nuevo.<br/>
     <ol>
      <li style="text-align: left">
      Ingresa al  <a style="color:inherit" href="https://ads.google.com/aw" target="_blank">Google Ads Manager</a>
      </li>
      <li style="text-align: left">
      Verifica que esté seleccionada la cuenta correcta de Google en la parte superior derecha, si no lo está, dale click en cambiar cuenta en la parte central de la pantalla.
      </li>
      <li style="text-align: left">
      Una vez seleccionada la cuenta correcta, verifica que tu cuenta tenga acceso a una cuenta publicitaria valida, si no es así, dale click en "Nueva cuenta de Google Ads" en la parte central de la pantalla y sigue los pasos para crear una.
      </li>
      <li style="text-align: left">
      Cuando termines de crearla, intenta conectar de nuevo tu cuenta en nuestra plataforma
      </li>
    </ol>`,
  [CURRENCY_MISMATCH]:
    "Detectamos un error en la moneda de tu cuenta publicitaria, por favor intenta de nuevo más tarde.",
  [ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK]: `Tu cuenta negocio no tiene una moneda asignada, sigue este paso a paso para asignarla e intenta de nuevo. <br/>
    <ol>
      <li style="text-align: left">
      Ingresa al <a style="color:inherit" href="https://business.tiktok.com/select" target="_blank">centro de negocios</a>
      </li>
      <li style="text-align: left">
      Selecciona una cuenta de negocios
      </li>
      <li style="text-align: left">
      En el menú izquierdo busca la opción de "Configuración de Negocio" y dale click
      </li>
      <li style="text-align: left">
      En la parte superior encontrarás la opción de configurar tu negocio, dale click y sigue los pasos para configurar todo tu negocio, incluida la moneda
      </li>
      <li style="text-align: left">
      Cuando termines de configurar tu negocio, intenta conectar de nuevo tu cuenta en nuestra plataforma
      </li>
    </ol>
    `,
  [ERROR_GETTING_URL_META_DATA_AND_IMAGES]:
    "No pudimos obtener información de tu sitio web. Asegúrate de que la URL sea válida, que sea accesible y contenga imágenes.",
  [ADVERTISER_ID_TO_CHANGE_NO_PERMISSION]:
    "No tienes permiso para cambiar a este anunciante.",
  [CANNOT_DELETE_MAIN_ADVERTISER]:
    "No se puede eliminar esta marca, debido a que es la marca principal de la agencia. Por favor, selecciona una marca diferente.",
  [DISCOUNT_CODE_NOT_FOUND]: "Código de descuento no encontrado",
  [DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT]:
    "Código no aplicable a este producto",
  [SCRIPT_IS_TOO_SHORT]:
    "El guión es muy corto, intenta agregar más información",
  [WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED]:
    "No pudimos analizar tu sitio web y red social, por favor verifica las urls o sube el contenido manualmente e intenta de nuevo",
  [EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM]:
    "Se encontró una inconsistencia con el correo electrónico proporcionado, por favor intenta de nuevo",
  [OAUTH_IN_WINDOW_NO_COMPLETED]:
    "No sé completó el proceso de autenticación, por favor intenta de nuevo",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE]: "Cuenta Conectada",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT]:
    "Tu cuenta se conectó correctamente.",
  [ERROR_PROCESSING_REQUEST]:
    "Ocurrió procesando esta solicitud. Por favor intenta de nuevo",
  [ERROR_PROCESSING_CAMPAIGNS]:
    "Ocurrió un error al procesar las campañas. Por favor inténtalo de nuevo.",
  [ERROR_ANALYZING_LINK_CREATIFY]:
    "No pudimos analizar este enlace. Verifica la URL e inténtalo de nuevo.",
  [GENERATE_AI_FREE_VIDEO_LIMIT]:
    "Has alcanzado el límite gratuito de generación de videos con IA.",
  [NOT_HAVE_ENOUGH_USAGE_VALUE]:
    "No tienes suficientes créditos para esta acción.",
  [USAGE_VALUE_NOT_FOUND]: "No se encontró la información de uso.",
  [FAL_AI_CREDENTIALS_INVALID]:
    "Tu clave API de Fal AI no es válida o la cuenta no tiene saldo.",
  [HEYGEN_CREDENTIALS_INVALID]:
    "Tu clave API de HeyGen no es válida o la cuenta no tiene saldo.",
  [ERROR_NETWORK_CONNECTION]:
    "Ocurrió un error de conexión a la red de internet, por favor intenta de nuevo",
  [ERROR_ON_AD_ID_OF_AD_GROUP_ID]:
    "En el Anuncio N°{{adID}} del Grupo de Anuncios N°{{adGroupID}}",
  [ERROR_ON_AD_GROUP_ID]: "En el Grupo de Anuncios N°{{adGroupID}}",
  [ERROR_ON_ASSETS_GROUP_ID]: "En el Grupo de Recursos N°{{assetsGroupID}}",
  [REQUEST_TIME_OUT]:
    "Ocurrió un error inesperado, por favor intenta de nuevo en unos segundos",
  [TIME_OUT_FOR_PROVIDER]:
    "Ocurrió un error con nuestro proveedor de vídeo, por favor intenta de nuevo más tarde.",
  [FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER]: `Tu página de Facebook debe tener un número de WhatsApp conectado para poder continuar. Sigue este paso a paso para conectarlo e intenta de nuevo.<br/>
    <ol>
      <li style="text-align: left">
        Ingresa a la <a style="color:inherit" href="https://www.facebook.com/settings/?tab=linked_whatsapp" target="_blank">configuración de tu página de Facebook</a>
      </li>
      <li style="text-align: left">
        Ingresa el número de WhatsApp que deseas conectar
      </li>
      <li style="text-align: left">
        Dale click en Enviar código de WhatsApp
      </li>
      <li style="text-align: left">
        Ingresa el código que recibiste en tu WhatsApp
      </li>
      <li style="text-align: left">
        Dale click en Confirmar
      </li>
      <li style="text-align: left">
        Una vez termines de conectar tu número de WhatsApp, intenta de nuevo. Si el error persiste es posible que necesites reconectar tu cuenta de Meta en nuestra plataform
      </li>
    </ol>`,
  [YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP]: `Tu página de Facebook no se encuentra dentro del portafolio de negocios al que pertenece el número de WhatsApp Business que intentas utilizar. Sigue este paso a paso para conectarlo e intenta de nuevo.<br/>
  <ol>
    <li style="text-align: left">
      Ingresa al <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/?business_id={{businessID}}" target="_blank">Portafolio de Negocios en la sección de páginas</a>
    </li>
    <li style="text-align: left">
      Dale click al botón de Agregar que se encuentra en la parte superior derecha
    </li>
    <li style="text-align: left">
      Selecciona la opción de Agregar una página de Facebook existente
    </li>
    <li style="text-align: left">
      Ingresa el nombre o el link de tu página de Facebook, usando el link es más acertada la búsqueda de tu página. Selecciona tu página Facebook una vez aparezca en la lista
    </li>
    <li style="text-align: left">
      Dale click al botón de Siguiente hasta que llegues al último paso. Marcarás la casilla para que aceptes los términos de Meta y luego click a Reclamar Página e Instagram
    </li>
    <li style="text-align: left">
      Una vez termines de conectar tu página de Facebook a tu portafolio de negocios, intenta de nuevo. Si el error persiste es posible que necesites reconectar tu cuenta de Meta en nuestra plataforma
    </li>
  </ol>
  `,
  [ERROR_WITH_MOBILE_PROVIDER]:
    "Ocurrió un error con tu proveedor de telefonía, por favor intenta de nuevo más tarde",
  [ERROR_CREATING_INSTANT_EXPERIENCE]:
    "Ocurrió un error al crear la experiencia instantánea, por favor intenta de nuevo",
  [CAMPAIGN_REQUEST_ABORTED]:
    "La solicitud de la campaña ha sido abortada por alcanzar el límite de tiempo de espera, contacta con soporte.",
  [APP_URL_NOT_FOUND]:
    "La app seleccionada no tiene un link valido en la tienda de aplicaciones seleccionada",
  [ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE]:
    "No se pudo recuperar la información para duplicar la campaña, intenta de nuevo",
  [INVALID_APP_DEEP_LINK]:
    "El enlace ingresado no es un deep link válido asociado a una aplicación.",
  [GENERATION_VIDEO_REJECTED]:
    "Tus instrucciones de contenido violan las políticas de seguridad de contenido. Intenta de nuevo modificando tus instrucciones.",
  [VIDEO_INPUT_REAL_PERSON_REJECTED]:
    "La imagen de entrada incluye a una persona real y el proveedor de video no puede procesarla. Usa una imagen del producto o de la marca sin personas reales e inténtalo de nuevo.",
  [IMAGE_LAYERS_CONTENT_POLICY_VIOLATION]:
    "No se pudo separar tu contenido en capas porque puede estar violando las políticas de contenido.",
  [AI_PROVIDER_CREDENTIALS_INVALID]:
    "Tu API key de {{provider}} no es válida o la cuenta no tiene saldo. Revisa tu API key en Configuración e inténtalo de nuevo.",
  [AI_PROVIDER_CREDENTIALS_INVALID_GENERIC]:
    "Una API key de tus proveedores no es válida o la cuenta no tiene saldo. Revisa tu API key en Configuración e inténtalo de nuevo.",
  [AI_REQUEST_TIMEOUT]:
    "Ocurrió un error con nuestro proveedor de IA, por favor intenta de nuevo más tarde.",
  [IMAGES_MODERATION_BLOCKED]:
    "Tus instrucciones de contenido violan las políticas de seguridad de contenido. Intenta de nuevo modificando tus instrucciones.",
  [MALFORMED_FUNCTION_CALL]:
    "No se pudo realizar esta acción, por favor intenta con una instrucción diferente.",
  [VIDEO_GENERATION_FAILED_BY_PROVIDER]:
    "El video no se generó debido a un error interno, por favor intenta de nuevo más tarde.",
  [AI_RATE_LIMITED]:
    "Nuestro proveedor de IA está recibiendo demasiadas solicitudes, por favor intenta de nuevo más tarde.",
  [AI_PROVIDER_UNAVAILABLE]:
    "Nuestro proveedor de IA no está disponible en este momento, por favor intenta de nuevo más tarde.",
  [AI_GENERATION_FAILED]:
    "No se pudo completar la generación con nuestro proveedor de IA, por favor intenta de nuevo más tarde.",
  [AGENT_REQUEST_COULD_NOT_BE_PROCESSED]:
    'No pude procesar tu solicitud. Por favor, intenta de nuevo. Si el error persiste, contacta al equipo de soporte a través del botón de "Obtén Ayuda".',
  [CREDITS_RETURNED_SUFFIX]:
    "Debido a este error, tus créditos han sido devueltos.",
  [CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR]:
    "Ocurrió un error inesperado con nuestro proveedor de imagen, por favor intenta de nuevo más tarde.",
  [CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR]:
    "Ocurrió un error inesperado con nuestro proveedor de video, por favor intenta de nuevo más tarde.",
  [CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR]:
    "Ocurrió un error inesperado con nuestro proveedor de IA, por favor intenta de nuevo más tarde.",
  [CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR]:
    "Ocurrió un error con nuestro proveedor de imagen, por favor intenta de nuevo más tarde.",
  [CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR]:
    "Ocurrió un error con nuestro proveedor de video, por favor intenta de nuevo más tarde.",
  [CREATIVE_TIMEOUT_AI_PROVIDER_ERROR]:
    "Ocurrió un error con nuestro proveedor de IA, por favor intenta de nuevo más tarde.",
  [INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW]:
    "No se puede actualizar el estado del creativo mientras se encuentre en revisión, intenta de nuevo más tarde",

  //ERROR COMPONENT
  [ERROR_COMPONENT_TITLE]: "¡Oops! Parece que ocurrió un error",
  [ERROR_COMPONENT_DESCRIPTION]:
    "Esto puede ser causado por un error técnico. Intenta de nuevo recargando la página, si el error persiste contacta a soporte.",
  [ERROR_COMPONENT_BUTTON_RELOAD_PAGE]: "Recargar página",
  [ERROR_COMPONENT_CURRENT_ROUTE]: "Ruta actual {{value}}",

  //CATEGORIES
  [RESTAURANTS]: "Gastronomía",
  [FOODS]: "Alimentos",
  [TRAVEL]: "Viajes y Turismo",
  [ENTERTAINMENT]: "Entretenimiento",
  [TECHNOLOGY]: "Tecnología",
  [FITNESS]: "Fitness",
  [FASHION]: "Moda",
  [BEAUTY]: "Salud y Belleza",
  [PETS]: "Pets",
  [HOME]: "Home Decor",

  //SUBCATEGORIES
  [RESTAURANTS_SUBCATEGORY_FOOD]: "Comida",
  [RESTAURANTS_SUBCATEGORY_DRINKS]: "Bebidas",
  [RESTAURANTS_SUBCATEGORY_DESSERTS]: "Postres",
  [RESTAURANTS_SUBCATEGORY_COFFEE]: "Café",
  [RESTAURANTS_SUBCATEGORY_HOT_DRINKS]: "Bebidas calientes",
  [RESTAURANTS_SUBCATEGORY_COLD_DRINKS]: "Bebidas frías",
  [RESTAURANTS_SUBCATEGORY_SOFT_DRINKS]: "Bebidas gaseosas",
  [RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS]: "Bebidas congeladas",
  [RESTAURANTS_SUBCATEGORY_SUSHI]: "Sushi",
  [RESTAURANTS_SUBCATEGORY_ASIAN]: "Asiatica",
  [RESTAURANTS_SUBCATEGORY_JAPANESE]: "Japonesa",
  [RESTAURANTS_SUBCATEGORY_CHINESE]: "China",
  [RESTAURANTS_SUBCATEGORY_ITALIAN]: "Italiana",
  [RESTAURANTS_SUBCATEGORY_MEXICAN]: "Mexicana",
  [RESTAURANTS_SUBCATEGORY_HEALTHY]: "Saludable",
  [RESTAURANTS_SUBCATEGORY_VEGAN]: "Vegana",
  [RESTAURANTS_SUBCATEGORY_VEGETARIAN]: "Vegetariana",
  [FOODS_SUBCATEGORY_SEASONINGS]: "Condimentos",
  [FOODS_SUBCATEGORY_FOOD]: "Alimentos",
  [FOODS_SUBCATEGORY_GRANOLA]: "Granolas",
  [FOODS_SUBCATEGORY_DRIED_FRUITS]: "Frutos deshidratados",
  [FOODS_SUBCATEGORY_HEALTHY]: "Healthy",
  [TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM]: "Turismo de sol y playa",
  [TRAVEL_SUBCATEGORY_RURAL_TOURISM]: "Turismo rural",
  [TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM]: "Turismo gastronómico",
  [TRAVEL_SUBCATEGORY_NATURE_TOURISM]: "Turismo de naturaleza",
  [TRAVEL_SUBCATEGORY_CULTURAL_TOURISM]: "Turismo cultural",
  [TRAVEL_SUBCATEGORY_HEALTH_TOURISM]: "Turismo de salud",
  [ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT]: "Entretenimiento",
  [TECHNOLOGY_SUBCATEGORY_PHONES]: "Celulares",
  [TECHNOLOGY_SUBCATEGORY_COMPUTERS]: "Computadores",
  [TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES]: "Consolas de Videojuegos",
  [TECHNOLOGY_SUBCATEGORY_ACCESSORIES]: "Accesorios",
  [TECHNOLOGY_SUBCATEGORY_PERIPHERALS]: "Perifericos",
  [TECHNOLOGY_SUBCATEGORY_ELECTRONICS]: "Electrónica",
  [FITNESS_SUBCATEGORY_SPORTSWEAR]: "Ropa deportiva",
  [FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES]: "Accesorios deportivos",
  [FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS]: "Suplementos alimenticios",
  [FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT]: "Equipos de entrenamiento",
  [FASHION_SUBCATEGORY_HAUTE_COUTURE]: "Moda de alta costura",
  [FASHION_SUBCATEGORY_HIPSTER]: "Moda hipster",
  [FASHION_SUBCATEGORY_CASUAL]: "Moda casual",
  [FASHION_SUBCATEGORY_CLASSIC]: "Moda clásica",
  [FASHION_SUBCATEGORY_ROMANTIC]: "Moda romántica",
  [FASHION_SUBCATEGORY_SPORTSWEAR]: "Moda deportiva",
  [FASHION_SUBCATEGORY_PREPPY]: "Moda preppy",
  [FASHION_SUBCATEGORY_GRUNGE]: "Moda grunge",
  [FASHION_SUBCATEGORY_VINTAGE]: "Moda vintage",
  [BEAUTY_SUBCATEGORY_COSMETICS]: "Cosméticos",
  [BEAUTY_SUBCATEGORY_EYE_CARE]: "Cuidado de los ojos",
  [BEAUTY_SUBCATEGORY_FEMININE_HYGIENE]: "Higiene femenina",
  [BEAUTY_SUBCATEGORY_FIRST_AID]: "Primeros auxilios",
  [BEAUTY_SUBCATEGORY_HAIR_CARE]: "Cuidado del cabello",
  [BEAUTY_SUBCATEGORY_MEDICAL_DEVICES]: "Dispositivos y aparatos médicos",
  [BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT]: "Equipo para movilidad",
  [BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS]: "Suplementos nutricionales",
  [BEAUTY_SUBCATEGORY_MEDICATIONS]: "Medicamentos",
  [BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE]: "Higiene personal",
  [BEAUTY_SUBCATEGORY_SCALES]: "Balanzas",
  [BEAUTY_SUBCATEGORY_SKIN_CARE]: "Cuidado de la piel",
  [BEAUTY_SUBCATEGORY_VITAMINS]: "Vitaminas",
  [BEAUTY_SUBCATEGORY_FACIAL_TISSUES]: "Pañuelos faciales",
  [PETS_SUBCATEGORY_FOOD]: "Comida",
  [PETS_SUBCATEGORY_COSMETICS]: "Cosméticos",
  [PETS_SUBCATEGORY_ACCESSORIES]: "Accesorios",
  [PETS_SUBCATEGORY_CLOTHING]: "Ropa",
  [PETS_SUBCATEGORY_MEDICATIONS]: "Medicamentos",
  [HOME_SUBCATEGORY_TEXTILES_CARPETS]: "Textiles y Alfombras",
  [HOME_SUBCATEGORY_ART_PRINTS]: "Arte y Grabados",
  [HOME_SUBCATEGORY_STORAGE_ORGANIZATION]: "Almacenamiento y Organización",
  [HOME_SUBCATEGORY_PLANT_DECOR]: "Decoraciones con Plantas",
  [HOME_SUBCATEGORY_CURTAINS_BLINDS]: "Cortinas y Persianas",

  //OPTIONS
  [BODY_BUILD_THIN]: "Delgado",
  [BODY_BUILD_AVERAGE]: "Promedio",
  [BODY_BUILD_WIDE]: "Ancho",
  [BODY_BUILD_MUSCULAR]: "Musculoso",
  [BODY_BUILD_CURVY]: "Curvilíneo",
  [BODY_BUILD_ATHLETIC]: "Atlético",

  [CLOTHING_STYLE_CASUAL]: "Casual",
  [CLOTHING_STYLE_FORMAL]: "Formal",
  [CLOTHING_STYLE_SPORTY]: "Deportivo",
  [CLOTHING_STYLE_BUSINESS]: "Negocios",
  [CLOTHING_STYLE_ELEGANT]: "Elegante",
  [CLOTHING_STYLE_TRENDY]: "De moda",
  [CLOTHING_STYLE_STREETWEAR]: "Úrbano",
  [CLOTHING_STYLE_TRADITIONAL]: "Tradicional",
  [CLOTHING_STYLE_VINTAGE]: "Vintage",
  [CLOTHING_STYLE_BOHEMIAN]: "Bohemio",
  [CLOTHING_STYLE_HIPSTER]: "Hipster",
  [CLOTHING_STYLE_PUNK]: "Punk",
  [CLOTHING_STYLE_GOTHIC]: "Gótico",

  [DISTINGUISHING_FEATURES_TATTOOS]: "Tatuajes",
  [DISTINGUISHING_FEATURES_SCARS]: "Cicatrices",
  [DISTINGUISHING_FEATURES_BIRTHMARKS]: "Manchas de nacimiento",
  [DISTINGUISHING_FEATURES_FRECKLES]: "Pecas",
  [DISTINGUISHING_FEATURES_MOLES]: "Lunares",
  [DISTINGUISHING_FEATURES_PIERCINGS]: "Piercings",
  [DISTINGUISHING_FEATURES_DIMPLES]: "Hoyuelos",
  [DISTINGUISHING_FEATURES_WRINKLES]: "Arrugas",
  [DISTINGUISHING_FEATURES_GLASSES]: "Gafas",
  [DISTINGUISHING_FEATURES_BRACES]: "Frenillos",
  [DISTINGUISHING_FEATURES_MAKEUP]: "Maquillaje",
  [DISTINGUISHING_FEATURES_HAIR_ACCESSORIES]: "Accesorios para el cabello",
  [DISTINGUISHING_FEATURES_BEARD]: "Barba",
  [DISTINGUISHING_FEATURES_MUSTACHE]: "Bigote",

  [CONTENT_STYLE_ELEGANT]: "Elegante",
  [CONTENT_STYLE_AESTHETIC]: "Estético",
  [CONTENT_STYLE_RAW]: "Crudo",
  [CONTENT_STYLE_MINIMALISTIC]: "Minimalista",
  [CONTENT_STYLE_ARTISTIC]: "Artístico",
  [CONTENT_STYLE_VINTAGE]: "Vintage",
  [CONTENT_STYLE_MODERN]: "Moderno",
  [CONTENT_STYLE_PLAYFUL]: "Juguetón",
  [CONTENT_STYLE_RUSTIC]: "Rústico",
  [CONTENT_STYLE_MONOCHROMATIC]: "Monocromático",

  [EMPLOYEES_2_10]: "2-10 Empleados",
  [EMPLOYEES_10_20]: "10-20 Empleados",
  [EMPLOYEES_20_50]: "20-50 Empleados",
  [EMPLOYEES_50_100]: "50-100 Empleados",
  [EMPLOYEES_100_THAN]: "100+ Empleados",

  [PRODUCT_AVAILABILITY_LOCAL]: "Local (Ciudad)",
  [PRODUCT_AVAILABILITY_NATIONAL]: "Nacional",
  [PRODUCT_AVAILABILITY_INTERNATIONAL]: "Internacional",

  [META]: "Meta",
  [META_FACEBOOK_AND_INSTAGRAM]: "Meta (Facebook e Instagram)",
  [INSTAGRAM]: "Instagram",
  [FACEBOOK]: "Facebook",
  [TIKTOK]: "TikTok",
  [LINKEDIN]: "LinkedIn",
  [GOOGLE]: "Google",
  [YOUTUBE]: "YouTube",
  [X]: "X",
  [THREADS]: "Threads",
  [DARK_KITCHEN]: "Cocinas ocultas",
  [WHATSAPP]: "WhatsApp",
  [ORGANIC]: "Orgánico",
  [OTHERS]: "Otros",

  [ADS_CAMPAIGN_APP_PROMOTION_ANDROID]: "Android",
  [ADS_CAMPAIGN_APP_PROMOTION_IOS]: "Apple iOS 14+",
  [APP_STORE_ANDROID]: "Android",
  [APP_STORE_IOS]: "iOS",
  [APP_STORE_PLACEHOLDER]: "Selecciona la Tienda de Aplicaciones",
  [ADS_CAMPAIGN_APP_PROMOTION_BOTH]: "Android y Apple iOS 14-",

  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS]: "Reconocimiento",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC]: "Tráfico",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT]: "Interacción",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS]: "Clientes Potenciales",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN]: "Formulario Instantáneo",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION]: "Promoción de una Aplicación",
  [ADS_CAMPAIGN_OBJECTIVE_SALES]: "Ventas",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS]: "Visualizaciones de Video",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS]: "Conversiones del Sitio Web",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL]: "Instalación de Aplicación",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING]: "Retargeting de Usuarios",
  [ADS_CAMPAIGN_TYPE_SEARCH]: "Búsqueda",
  [ADS_CAMPAIGN_TYPE_APP]: "Instalación de Aplicación",
  [ADS_CAMPAIGN_TYPE_SHOPPING]: "Compras",
  [ADS_CAMPAIGN_TYPE_VIDEO]: "Vídeos",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY]: "Presupuesto diario",
  [ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME]: "Presupuesto total",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU]: "Ver menú",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW]: "Comprar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP]: "Registrarse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE]: "Suscribirse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE]: "Ver más",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW]: "Aplicar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY]: "Aplicar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE]: "Ver Cotización",
  [ADS_CAMPAIGN_CALL_TO_ACTION_JOIN]: "Unirse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND]: "Asistir",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO]: "Solicitar Demo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE]: "Ver Más",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER]: "Registrarse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW]: "Reservar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW]: "Llamar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US]: "Contáctanos",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD]: "Descargar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT]:
    "Desbloquear documento completo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS]: "Obtener direcciones",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE]: "Obtener cotización",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES]: "Obtener horarios",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE]: "Más información",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE]:
    "Enviar mensaje de WhatsApp",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW]: "Escuchar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE]: "Enviar mensaje",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM]:
    "Enviar mensaje Instagram",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW]: "Ordenar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME]: "Solicitar tiempo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SAVE]: "Guardar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER]: "Obtener oferta",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS]: "Obtener promociones",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS]: "Obtener acceso",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES]: "Obtener actualizaciones",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW]: "Consultar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS]: "Comprar boletos",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME]: "Jugar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE]: "Explorar más",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW]: "Instalar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP]: "Usar aplicación",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW]: "Mirar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE]: "Leer ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW]: "Ver ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED]: "Me interesa",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW]: "Comprar entradas ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW]: "Me interesa",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW]: "Pre-ordenar ahora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE]: "Visitar tienda",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE]: "Ver perfil",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC]: "Dinámico",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE]: "Sitio web",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST]: "Lista de clientes",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO]: "Agregar información de pago",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART]: "Agregar al carrito",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST]: "Agregar a la lista de deseos",
  [ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION]: "Completar registro",
  [ADS_CAMPAIGN_CUSTOM_EVENT_DONATE]: "Donar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT]: "Iniciar pago",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE]: "Comprar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH]: "Buscar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL]: "Iniciar prueba",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE]: "Suscribirse",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT]: "Contactar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT]: "Personalizar producto",
  [ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION]: "Encontrar ubicación",
  [ADS_CAMPAIGN_CUSTOM_EVENT_LEAD]: "Generar cliente potencial",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE]: "Agendar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION]: "Enviar solicitud",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW]: "Ver contenido",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM]: "Enviar formulario",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER]: "Realizar pedido",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON]: "Hacer clic en el botón",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD]: "Facebook Feed",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY]: "Facebook Story",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE]: "Facebook Reels",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY]: "Instagram Story",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL]: "Instagram Reel",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED]: "Instagram Feed",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD]: "Instagram Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH]: "Búsqueda de Google",
  [ADS_META_DESTINATION_TYPE_NONE]: "Ninguno",
  [ADS_META_DESTINATION_TYPE_WEBSITE]: "Sitio Web",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE]: "Sitio Web y Tienda Física",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP]: "Sitio Web y Aplicación",
  [ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE]:
    "Sitio Web, Aplicación y Tienda Física",
  [ADS_META_DESTINATION_TYPE_CATALOG]: "Catálogo",
  [ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE]: "Perfil de Instagram",
  [ADS_META_DESTINATION_TYPE_ON_VIDEO]: "En el vídeo",
  [ADS_META_DESTINATION_TYPE_ON_POST]: "En la publicación",
  [ADS_META_DESTINATION_TYPE_WHATSAPP]: "WhatsApp",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM]: "Mensajes en Instagram",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER]: "Mensaje en Messenger",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER]:
    "Mensajes en Instagram y Messenger",
  [ADS_META_DESTINATION_TYPE_INSTANT_FORM]: "Formulario Instantáneo",
  [ADS_META_DESTINATION_TYPE_GOOGLE_PLAY]: "Google Play",
  [ADS_META_DESTINATION_TYPE_APP_STORE]: "App Store",
  [ADS_META_DESTINATION_TYPE_APP]: "Aplicación",
  [ADS_CAMPAIGN_BUYING_TYPE_RESERVED]: "Reserva",
  [ADS_CAMPAIGN_BUYING_TYPE_AUCTION]: "Subasta",

  [ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION]: "Activación",
  [ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION]: "Inicio de descarga",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION]: "Registro",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION]: "Compra",
  [ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION]: "Ordenar en la aplicación",
  [ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION]: "Carrito en la aplicación",
  [ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION]: "Detalle en la aplicación",
  [ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION]: "Apertura del día siguiente",
  [ADS_TIKTOK_APP_EVENT_LOGIN_OPTION]: "Iniciar sesión",
  [ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION]: "Lanzar aplicación",
  [ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION]: "Completar tutorial",
  [ADS_TIKTOK_APP_EVENT_SEARCH_OPTION]: "Búsqueda",
  [ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION]: "Iniciar prueba",
  [ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION]: "Suscribirse",

  [ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY]: "Semanalmente",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY]: "Mensualmente",

  [KEYWORD_BROAD_MATCH_TYPE_OPTION]: "Concordancia amplia",
  [KEYWORD_PHRASE_MATCH_TYPE_OPTION]: "Concordancia de frase",
  [KEYWORD_EXACT_MATCH_TYPE_OPTION]: "Concordancia exacta",
  [KEYWORD_TYPE_NORMAL]: "Palabra Clave",
  [KEYWORD_TYPE_NEGATIVE]: "Palabra Clave Negativa",

  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK]:
    "Abrir el enlace profundo en la aplicación móvil o dirigir al navegador web",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK]:
    "Abrir el enlace profundo en la aplicación móvil o dirigir a la tienda de aplicaciones",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY]:
    "Abrir el enlace profundo en el navegador web móvil",
  [ADS_CAMPAIGN_META_FALLBACK_CATALOG]:
    "Usar la configuración de destino del enlace desde el catálogo",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL]: "Destino a Web",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL]:
    "Destino a App con Respaldo a Website",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL]:
    "Destino a App con Respaldo a AppStore",
  [DESTINATION_FALLBACK_CONFIGURATION_TITLE]:
    "Configuración de Destino Fallback",

  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION]: "Creativo Dinámico",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION]:
    "Meta creará automáticamente combinaciones de tus contenidos y textos a las que es probable que tu audiencia responda.",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK]:
    "Acerca del creativo dinámico",

  [ADS_CAMPAIGN_META_AD_SETUP]: "Configuración de Anuncio",
  [ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD]: "Crear Anuncio",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_POST]: "Usar Publicación",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD]: "Usar Anuncio Existente",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT]:
    "Solo podrás escoger anuncios con configuraciones compatibles y no podrás modificar ningún campo del anuncio original.",
  [MODAL_META_REUSE_CREATIVES_TITLE]: "Anuncios Existentes",
  [MODAL_META_REUSE_CREATIVES_DESCRIPTION]:
    "Selecciona un anuncio creado previamente para conservar el engagement generado",
  [MODAL_META_REUSE_CREATIVES_EMPTY]: "No hay creativos reutilizables todavía.",
  [MODAL_META_REUSE_CREATIVES_VALID]: "Compatible",
  [MODAL_META_REUSE_CREATIVES_INVALID]: "No compatible",
  [MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE]: "Filtrar por el contenido actual",
  [MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE]: "Filtrar por el contenido actual",
  [MODAL_META_REUSE_CREATIVES_CLEAR_FILTER]: "Mostrar todos los creativos",
  [MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN]: "Optimization goal distinto",
  [MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN]: "Optimization goal distinto",
  [MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY]: "Compatibilidad",
  [MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS]: "Textos",
  [MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT]: "Engagement",

  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION]: "Partnership",
  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE]: "Activar anuncio de colaboración",
  [ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER]: "Orden de identidades",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST]: "Primero {{name}}",
  [ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK]: "socio",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST]:
    "Primero mi marca (página/Instagram de la campaña)",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL]:
    "Primero el partner (creador)",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE]: "Página Facebook del partner",
  [ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING]:
    "Asegúrate de que {{name}} tenga aprobada tu solicitud para publicar anuncios en colaboración. De lo contrario, tus anuncios no se entregarán.",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM]:
    "Cuenta Instagram del partner",

  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION]:
    "¿Tu campaña pertenece a alguna categoría especial de anuncios?",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION]:
    "Selecciona las categorías que correspondan (opcional; esto puede limitar ciertos tipos de segmentación)",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER]:
    "Categorías Especiales",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Vivienda",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Empleo",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES]:
    "Productos y servicios financieros",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS]:
    "Temas, elecciones y política",

  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER]:
    "Categorías especiales de anuncios",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Vivienda",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Empleo",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT]: "Crédito",

  [LESS_500K]: "Menos de $500.000",
  [BETWEEN_500K_1M]: "$500.000 - $1.000.000",
  [BETWEEN_1M_2_5M]: "$1.000.000 - $2.500.000",
  [BETWEEN_2_5M_5M]: "$2.500.000 - $5.000.000",
  [MORE_5M]: "Más de $5.000.000",
  [LESS_1M]: "Menos de $1.000.000",
  [BETWEEN_1M_5M]: "$1.000.000 - $5.000.000",
  [BETWEEN_5M_15M]: "$5.000.000 - $15.000.000",
  [BETWEEN_15M_30M]: "$15.000.000 - $30.000.000",
  [BETWEEN_30M_100M]: "$30.000.000 - $100.000.000",
  [MORE_100M]: "Más de $100.000.000",
  [LESS_150]: "Menos de $150",
  [BETWEEN_150_250]: "$150 - $250",
  [BETWEEN_250_650]: "$250 - $650",
  [BETWEEN_650_1250]: "$650 - $1.250",
  [MORE_1250]: "Más de $1.250",
  [LESS_250]: "Menos de $250",
  [BETWEEN_250_1250]: "$250 - $1.250",
  [BETWEEN_1250_3750]: "$1.250 - $3.750",
  [BETWEEN_3750_7500]: "$3.750 - $7.500",
  [BETWEEN_7500_25K]: "$7.500 - $25.000",
  [MORE_25K]: "Más de $25.000",
  [LESS_1000]: "Menos de $1.000",
  [BETWEEN_1000_5000]: "$1.000 - $5.000",
  [BETWEEN_5000_15K]: "$5.000 - $15.000",
  [BETWEEN_15K_30K]: "$15.000 - $30.000",
  [BETWEEN_30K_60K]: "$30.000 - $60.000",
  [MORE_60K]: "Más de $60.000",
  [BETWEEN_1000_2000]: "$1.000 - $2.000",
  [BETWEEN_2000_5000]: "$2.000 - $5.000",
  [BETWEEN_5000_10K]: "$5.000 - $10.000",
  [MORE_10K]: "Más de $10.000",

  [DOCUMENT_CC]: "Cédula de ciudadanía",
  [DOCUMENT_CE]: "Cédula de extranjería",
  [DOCUMENT_NUIP]: "NUIP",
  [DOCUMENT_NIT]: "NIT",
  [DOCUMENT_CI]: "Cédula de identidad",
  [DOCUMENT_PASSPORT]: "Pasaporte",
  [DOCUMENT_EIN]: "EIN",
  [DOCUMENT_RUC]: "RUC",
  [DOCUMENT_ID]: "ID",
  [DOCUMENT_ID_EMIRATES]: "ID de Emiratos",
  [DOCUMENT_TRN]: "TRN",

  //EXPLANATIONS TOOLTIP
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de reconocimiento?",
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de recordarlos. Este objetivo es ideal para aumentar la notoriedad de tu marca o producto.<br><br>
    Bueno para:<br>
    <li><strong>Alcance:</strong> Alcanza a personas que tienen más probabilidades de que les interese tu marca.</li>
    <li><strong>Conciencia de marca:</strong> Alcanza a personas que tienen más probabilidades de recordar tu marca.</li>
    <li><strong>Vistas de vídeo:</strong> Alcanza a personas que tienen más probabilidades de ver tu video.</li>
    <li><strong>Conocimiento de la ubicación de tu tienda:</strong> Alcanza a personas utilizando la ubicación física de tu negocio, organización o conjunto de tiendas.</li>
    `,
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de tráfico?",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de hacer clic en ellos. Este objetivo es ideal para aumentar el tráfico a tu sitio web o aplicación.<br><br>
    Bueno para:<br>
    <li><strong>Link clicks:</strong> Consigue que las personas hagan clic en un enlace a tu sitio web, aplicación o evento de Facebook.</li>
    <li><strong>Visitas a página:</strong> Consigue que las personas vean el contenido de tu página.</li>
    <li><strong>Visitas a perfil de Instagram:</strong> Consigue que las personas visiten tu perfil de Instagram.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de interacciones?",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de interactuar con ellos. Este objetivo es ideal para aumentar los comentarios, me gusta, compartidos y clics en tu anuncio.<br><br>
    Bueno para:<br>
    <li><strong>Vistas de vídeo:</strong> Alcanza a personas que tienen más probabilidades de ver tu video.</li>
    <li><strong>Engagement en publicación:</strong> Consigue que las personas interactúen con tus publicaciones.</li>
    <li><strong>Conversiones:</strong> Consigue que las personas vean contenido, contacten tu negocio, añadan a una lista de deseos o realicen otra acción en tu sitio web o aplicación.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de clientes potenciales?",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de proporcionar información de contacto. Este objetivo es ideal para aumentar los registros de clientes potenciales.<br><br>
    Bueno para:<br>
    <li><strong>Formularios instantaneos:</strong> Encuentra personas dispuestas a compartir su información de contacto y otros detalles completando un formulario.</li>
    <li><strong>Conversiones:</strong> Consigue que las personas compartan su información de contacto, completen un formulario de registro, envíen una solicitud o realicen otra acción en tu sitio web o aplicación.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de promoción de aplicaciones?",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de descargar tu aplicación. Este objetivo es ideal para aumentar las descargas de tu aplicación.<br><br>
    Bueno para:<br>
    <li><strong>Instalación de aplicaciones:</strong> Consigue que las personas descarguen e instalen tu aplicación.</li>
    <li><strong>Eventos de aplicaciones:</strong> Conseguir que los usuarios realicen compras dentro de la aplicación o realicen otras acciones dentro de tu aplicación.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION]:
    "¿Qué es el objetivo de ventas?",
  [ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION]: `Los anuncios se mostrarán a personas que tienen más probabilidades de realizar una compra. Este objetivo es ideal para aumentar las ventas de tu producto o servicio.<br><br>
    Bueno para:<br>
    <li><strong>Conversiones:</strong> Consigue que las personas añadan un artículo a su carrito, realicen una compra, inicien una suscripción o realicen otra acción en tu sitio web o aplicación.</li>
    <li><strong>Ventas por catálogo:</strong> Consigue que las personas compren productos o servicios de tu catálogo.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION]:
    "Visualizaciones de Video",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION]: `Muestra tus anuncios de video a personas que tienen más probabilidades de verlos. Este objetivo es ideal para aumentar las visualizaciones de video y la interacción.<br><br>
    Bueno para:<br>
    <li><strong>Contenido de video:</strong> Promueve contenido de video para aumentar las visualizaciones y la interacción.</li>
    <li><strong>Reconocimiento de marca:</strong> Usa el video para generar reconocimiento de marca y llegar a una audiencia más amplia.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION]:
    "Conversiones del Sitio Web",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION]: `Muestra anuncios a personas que tienen más probabilidades de realizar acciones valiosas en tu sitio web. Este objetivo es ideal para impulsar conversiones y ventas.<br><br>
    Bueno para:<br>
    <li><strong>Conversiones:</strong> Consigue que las personas completen acciones valiosas en tu sitio web, como compras, registros o envíos de formularios.</li>
    <li><strong>Ventas:</strong> Impulsa las ventas y los ingresos dirigiendo a personas que probablemente conviertan.</li>`,
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX]: "Performance Max",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION]:
    "¿Qué es un tipo de campaña Performance Max?",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION]:
    "Las campañas Performance Max utilizan el aprendizaje automático de Google para mostrar los anuncios en todos los canales de Google Ads, maximizando las conversiones o el valor de conversión dentro de tu presupuesto objetivo.",
  [ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION]:
    "¿Qué es un tipo de campaña de instalación de app?",
  [ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION]:
    "Las campañas de instalación de app están diseñadas para promover la descarga e instalación de aplicaciones móviles en Google Play Store o App Store.",
  [ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION]:
    "¿Qué es un tipo de campaña de búsqueda?",
  [ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION]:
    "Los anuncios de búsqueda se muestran a personas interesadas en el momento justo en la Búsqueda de Google.",
  [ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION]:
    "¿Qué es un tipo de campaña de compras?",
  [ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION]:
    "Los anuncios de compras se muestran a compradores mientras exploran qué comprar en línea.",
  [ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION]:
    "¿Qué es un tipo de campaña de video?",
  [ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION]:
    "Los anuncios de vídeo se muestran antes, durante o después de un vídeo en YouTube.",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION]:
    "¿Que significa un tipo de presupuesto diario?",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION]:
    "El presupuesto diario es la cantidad máxima que estás dispuesto a gastar por día en tu campaña. La red social intentará no superar este límite, pero puede gastar un poco más en días en los que haya más oportunidades para mostrar tus anuncios.",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION]:
    "¿Qué significa un tipo de presupuesto de total?",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION]:
    "El presupuesto total es la cantidad máxima que estás dispuesto a gastar en toda tu campaña. La red social intentará no superar este límite, pero puede gastar un poco más en días en los que haya más oportunidades para mostrar tus anuncios.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION]:
    "¿Qué es una audiencia personalizada de sitio web?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION]:
    "Una audiencia personalizada de sitio web se crea a partir de las personas que visitan tu sitio web o realizan acciones específicas en él.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION]:
    "¿Qué es una audiencia personalizada de lista de clientes?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION]:
    "Una audiencia personalizada de lista de clientes se crea a partir de la información de contacto que ya tienes sobre tus clientes, como direcciones de correo electrónico o números de teléfono.",
  [ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION]: "¿Qué es un píxel?",
  [ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION]: `Los píxeles son herramientas que se integran en sitios web y aplicaciones para medir la eficacia de tus anuncios y entender las acciones que los usuarios realizan en tu sitio.<br/><br/>

    Configurar un píxel aumenta la probabilidad de que tus anuncios se dirijan a la audiencia correcta, lo que a su vez maximiza los resultados obtenidos.
    
    <ul>
      <li><a href="https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank">¿Cómo crear y configurar un pixel en Meta?</a></li>
      <li><a href="https://ads.tiktok.com/help/article/get-started-pixel" target="_blank">¿Cómo crear y configurar un pixel en TikTok?</a></li>
    </ul>`,
  [ADVERTISER_ROLE_TITLE_EXPLANATION]: "¿Qué hace un administrador?",
  [ADVERTISER_ROLE_DESCRIPTION_EXPLANATION]: `Los administradores tiene acceso total a todas las funcionalides de la plataforma. <br/><br/>
    • Conectar y desconectar cuentas de plataformas.<br/>
    • Generar, publicar y editar campañas.<br/>
    • Generar reportes.<br/>
    • Crear y editar usuarios.<br/>
    • Ver información de facturación y el plan actual.`,
  [MARKETER_ROLE_TILE_EXPLANATION]: "¿Qué hace un Media Buyer?",
  [MARKETER_ROLE_DESCRIPTION_EXPLANATION]: `Los marketers se encargan mayormente de la creación y publicación de campañas en la plataforma.<br/><br/>
    • Conectar y desconectar cuentas de plataformas.<br/>
    • Generar reportes.<br/>
    • Generar, publicar y editar campañas.<br/>`,
  [VIEWER_ROLE_TITLE_EXPLANATION]: "¿Qué hace un Viewer?",
  [VIEWER_ROLE_DESCRIPTION_EXPLANATION]: `Los viewers tienen acceso a la información de las campañas y los resultados obtenidos. <br/><br/>
    • Ver información de campañas.<br/>
    • Generar reportes.<br/>`,
  [VIEWER_ROLE_READ_ONLY_CAPABILITY]:
    "Los viewers solo pueden ver información; no pueden hacer cambios.",
  [VIEWER_CAPABILITY_VIEW_CAMPAIGNS]: "Ver campañas",
  [VIEWER_CAPABILITY_VIEW_CONTENT]: "Ver contenidos",
  [VIEWER_CAPABILITY_VIEW_CALENDAR]: "Ver calendario",
  [VIEWER_CAPABILITY_VIEW_REPORTS]: "Ver reportes de campaña",
  [DESIGNER_ROLE_TITLE_EXPLANATION]: "¿Qué hace un diseñador?",
  [ROLE_CAPABILITY_CAN_MANAGE_USERS]: "Gestionar usuarios",
  [ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS]: "Conectar cuentas",
  [ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN]: "Generar campañas",
  [ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN]: "Publicar, editar y gestionar campañas",
  [ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT]: "Usar agente de IA",
  [ROLE_CAPABILITY_CAN_EDIT_GALLERY]: "Generar y editar contenido",
  [ROLE_CAPABILITY_CAN_POST]: "Publicar contenido",
  [ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP]: "Configurar marca",
  [ROLE_CAPABILITY_CAN_EDIT_BILLING]: "Editar facturación",

  //ONBOARDING

  //MAIN FUNCTIONALITY
  [MAIN_FUNCTIONALITY_STEP_1]: `Esta es la sección de Creadores de Contenido, aquí encontrarás el listado de creadores que están registrados en {{NAME_BUSINESS}} y que están a disposición de colaborar con tu marca.`,
  [MAIN_FUNCTIONALITY_STEP_2]:
    "Con los filtros podrás buscar creadores de contenido por su nombre de cuenta, categorías, ciudad, número de seguidores, porcentaje de engagement de su audiencia, etc.",
  [MAIN_FUNCTIONALITY_STEP_3]: `Tienes tres secciones para buscar creadores de contenido: <br/><br/>
    <strong>Creadores:</strong> Este es el listado general de todos los creadores registrados en {{NAME_BUSINESS}}.<br/>
    <strong>Para ti:</strong> Este es el listado de los creadores que coinciden con el perfil de creador que te interesa.<br/>
    <strong>Solicitudes:</strong> Este es el listado de los creadores que están interesados en tu marca y te envían una solicitud de colaboración.
    `,
  [MAIN_FUNCTIONALITY_STEP_4]:
    "Esta es la información general del creador, puedes darle click a cada tarjeta para acceder a una información más completa. Dale click a la tarjeta.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_1]:
    "Una vez los creadores rediman sus invitaciones se generarán publicaciones, para ir a la sección publicaciones, dale click en el menú lateral al botón de Publicaciones.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_2]:
    "Las publicaciones pueden tener multiples estados, el primero es Publicación Pendiente, es cuando el creador redimió su invitación pero aún no publicado el contenido que generó.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_3]:
    "El segundo es Analítica Pendiente, es cuando el creador ya publicó el contenido que generó pero aún no publicado la analítica para ver los resultados de la colaboración.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_4]:
    "El tercero es Calificar, es cuando el creador ya publicó el contenido que generó y la analítica, ahora debes revisarlos, darle una calificación al creador y pensar si quieres hacerlo embajador. Dale click al botón Calificar",
  [PUBLICATION_FUNCTIONALITY_STEP_1]:
    "Aquí verás las analíticas y los resultados generados por el contenido del creador de contenido.",
  [PUBLICATION_FUNCTIONALITY_STEP_2]:
    "Aquí verás todo el contenido que el creador de contenido generó para tu marca.",
  [PUBLICATION_FUNCTIONALITY_STEP_3]:
    "Este es el botón para calificar el creador de contenido, dale click al botón Calificar.",
  [REVIEW_FUNCTIONALITY_STEP_1]:
    "Este es el formulario para calificar al creador de contenido, la información de tu calificación no será compartida con el creador.",
  [REVIEW_FUNCTIONALITY_STEP_2]:
    "Puedes calificar el contenido del creador de contenido, en un intervalo de 1 a 5 qué tan bueno fue el contenido generado.",
  [REVIEW_FUNCTIONALITY_STEP_3]:
    "Puedes calificar la analítica del creador de contenido, en un intervalo de 1 a 5 qué tan bueno fue el resultado generado.",
  [REVIEW_FUNCTIONALITY_STEP_4]:
    "Describir en texto como fue la experiencia en general con la colaboración, este texto puede tener mínimo 10 caracteres.",
  [REVIEW_FUNCTIONALITY_STEP_5]:
    "Una vez lleno el formulario, para realizar la calificación debes darle click al botón Finalizar.",
  [MAIN_FUNCTIONALITY_ONBOARDING_FINISH]:
    "Has completado el tutorial de la plataforma, ahora sabes dónde encontrar a los creadores de contenido, ver su información y realizar diferentes acciones con ellos.",

  //MENU FUNCTIONALITY
  [MENU_FUNCTIONALITY_STEP_1]:
    "Aquí podrás seleccionar la tienda para la que quieres gestionar su catálogo.",
  [MENU_FUNCTIONALITY_STEP_2]:
    "Aquí podrás agregar una categoría para organizar tus productos o servicios, dale click al botón y escribe el nombre de la categoría.",
  [MENU_FUNCTIONALITY_STEP_3]:
    "Esta es la nueva categoria que acabas de crear.",
  [MENU_FUNCTIONALITY_STEP_4]: "Aquí podrás agregar un producto o servicio.",
  [MENU_FUNCTIONALITY_STEP_5]:
    "Dale click al botón para subir una imagen para el producto.",
  [MENU_FUNCTIONALITY_STEP_6]:
    "Escribe el nombre del producto y dale siguiente.",
  [MENU_FUNCTIONALITY_STEP_7]:
    "Escribe la descripción del producto y dale siguiente.",
  [MENU_FUNCTIONALITY_STEP_8]:
    "Escribe el precio del producto y dale siguiente.",
  [MENU_FUNCTIONALITY_STEP_9]:
    "Indica si es un producto es nocivo para la salud o para mayores de edad dándole click al cuadro.",
  [MENU_FUNCTIONALITY_STEP_10]:
    "Una vez lleno el formulario, para crear el producto debes darle click al botón Crear.",
  [MENU_FUNCTIONALITY_STEP_11]: "Este es el producto que acabas de crear",
  [MENU_FUNCTIONALITY_STEP_12]:
    "Dale click para  activar/desactivar un producto según tu inventario.",

  //USERS FUNCTIONALITY
  [USERS_FUNCTIONALITY_STEP_1]: "Este es un usuario Administrador.",
  [USERS_FUNCTIONALITY_STEP_2]:
    "El rol administrador tiene acceso a todos las funcionalidades, es decir, es capaz de gestionar invitaciones a creadores, gestionar las publicaciones, modificar información de la marca, gestionar información de pago, etc.",
  [USERS_FUNCTIONALITY_STEP_3]: "Este es un usuario Operador.",
  [USERS_FUNCTIONALITY_STEP_4]:
    "El rol operador tiene acceso únicamente a las funcionalidades de redimir los código de los creadores que lleguen a tu tienda física, de gestionar las órdenes/deliveries que hagan los creadores vía app y activar/desactivar productos según inventario.",

  //MAIN FUNCTIONALITY OPERATOR
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_1]:
    "Con la barra de redención podrás escribir un código e intentar redimirlo. Escribe cualquier código y dale Redimir.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_2]:
    "Aquí está el código que acabas de redimir y el valor de la invitación, este es el valor que se le otorgará al creador de contenido, si lo que pida el creador es mayor al valor de la invitación, se le cobrará el excedente.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_3]: `Esta es la sección de Órdenes, aquí podrás ver el listado de las órdenes que han hecho los creadores de contenido vía delivery por la aplicación de {{NAME_BUSINESS}}. Las órdenes/deliveries tienen 3 estados`,
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_4]:
    "El primero es Por Aceptar, es cuando el creador de contenido hizo un pedido, está esperando que lo aceptes y le asignes un tiempo de procesamiento.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_5]:
    "El segundo es Procesando, es cuando el creador de contenido hizo un pedido, lo aceptaste y le asignaste un tiempo de procesamiento, ahora debes comunicar la preperación del pedido.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_6]:
    "El tercero es Por Entregar, es cuando el pedido que estaba en procesamiento ya está listo y lo despachaste con algún método de entrega, una vez se te notifique la entrega o el creador lo marque como entregado, el pedido desaparecerá de acá.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_7]:
    "¡Acaba de entrar un nuevo pedido, la plataforma comenzará a emitir un sonido hasta que veas el pedido nuevo, dale click para verlo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_8]:
    "Aquí están los productos que pidió el creador de contenido, puedes ver la cantidad y precio de cada producto.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_9]:
    "Aquí está el mensaje que dejó el creador de contenido, puede ser una indicación o recomendación para llevar a cabo la entrega.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_10]:
    "Aquí está el valor total de la orden.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_11]:
    "Aquí está el creador de contenido que hizo el pedido y su información.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_12]:
    "Aquí podrás indicar el tiempo de procesamiento y entrega del pedido, pueden ser minutos, horas, días o semanas.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_13]:
    "Aquí podrás indicar la cantidad de tiempo de procesamiento y entrega del pedido, puedes añadir o restar cantidad de tiempo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_14]:
    "Una vez revisada la información, asignado el tiempo de procesamiento del pedido, puedes darle click al botón de Aceptar Orden para pasarlo a procesando",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_15]:
    "Este es el pedido que acabas de aceptar, se movió de estado.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_16]:
    "Aquí verás cuánto tiempo de procesamiento le queda, dale click para volver a ver los detalles de la orden.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_17]:
    "Una vez el pedido esté listo, deberás asignarle información de entrega.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_18]:
    "Una vez lleno el formulario, para marcar el pedido como listo debes darle click al botón Pedido Listo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_19]:
    "Este es el pedido que acabas de enviar, se movió de estado. Aquí encontrarás la información de entrega que le asignaste al pedido, una vez se te informe que el pedido fue entregado, debes marcarlo como entregado. Dale click ver detalles de la orden",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_20]:
    "Una vez revisada la información y se te haya informado que fue entregado al creador debes marcar el pedido como entregado, para esto debes darle click al botón Pedido Entregado.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_21]:
    "Esta es la sección de Menú, aquí podrás ver el listado de los productos que tiene tu marca en el catálogo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_22]:
    "Acá están el listado de categorías y la categoría de prueba.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_23]:
    "Acá están el listado de productos y el producto de prueba.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_24]:
    "Como operador, solo puedes activar o desactivar productos según veas la disponibilidad de inventario, para desactivar/activar un producto dale click al botón.",

  //CAMPAIGNS FUNCTIONALITY
  [CAMPAIGNS_FUNCTIONALITY_STEP_1]:
    "Esta es la página de Campañas, podrás crear campañas para generar colaboraciones más personalizadas con los creadores.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_2]:
    "Comencemos creando una campaña, dale click a Crear Campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_3]:
    "En el centro de la pantalla irán apareciendo las preguntas para tu campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_4]:
    "En la primera pregunta deberás escribir el nombre de tu campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_5]:
    "Una vez completes la pregunta, dale click al botón Siguiente.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_6]:
    "Una vez le des al botón Siguiente, aparecerá la siguiente pregunta.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_7]:
    "Aquí podrás seleccionar la pregunta que quieras ver, aparecerán solo las que hayas visto.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_8]:
    "El formulario puede ser algo extenso, por lo que puedes guardar el progreso que tengas hasta ahora, dale click a Guardar Progreso.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_9]:
    "Una vez guardes el progreso, serás redirigido a la página de campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_10]:
    "Esta es la sección de aplicantes, aquí podrás ver a los creadores que aplicaron a tu campaña. Podrás ver su información, estadísticas, aceptarlos o rechazarlos.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_11]:
    "Aquí también podrás usar los filtros para ver a los aplicantes que te interesen.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_12]:
    "Este es un creador que aplicó a tu campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_13]:
    "Esta es la sección de creadores invitados, aquí aparecerán los creadores que te interesaron para tu campaña y los invitaste.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_14]:
    "En esta sección encontrarás la información de tu campaña, aquí podrás completar la información que te falta y activar la campaña para que los creadores puedan aplicar.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_15]:
    "Con este botón podrás guardar los cambios de tu campaña y seguirá en estado desactivada, por lo que aún los creadores no podrán aplicar.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_16]:
    "Con este botón podrás activar la campaña, deberás tener toda la información requerida para poder hacerlo, en este estado los creadores podrán aplicar a tu campaña.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_17]:
    "Con este botón podrás dar por finalizada la campaña, ya ningún creador podrá aplicar y no podrás activarla nunca más.",

  //ALERTS
  [SAVE_LOCATION_SET_TITLE]: "Guardar conjunto de ubicaciones",
  [SAVE_LOCATION_SET_NAME_LABEL]: "Nombre del conjunto",
  [SAVE_LOCATION_SET_SAVE_BUTTON]: "Guardar",
  [SAVE_LOCATION_SET_SAVING_BUTTON]: "Guardando...",
  [SAVE_LOCATION_SET_CANCEL_BUTTON]: "Cancelar",
  [PUBLISHING_ALERT_TITLE]: "Publicando Campaña",
  [PUBLISHING_ALERT_ERROR_TITLE]: "Error al Publicar la Campaña",
  [PUBLISHING_ALERT_SUCCESS_TITLE]: "Campaña Publicada Exitosamente",
  [PUBLISHING_ALERT_RETRY_BUTTON]: "Reintentar",
  [GENERATING_CAMPAIGN]: "Generando Campaña",
  [CAMPAIGN_GENERATED_SUCCESS]: "Campaña Generada Exitosamente",
  [CAMPAIGN_GENERATED_ERROR]: "Error al Generar la Campaña",
  [CAMPAIGN_GENERATED_ERROR_DESCRIPTION]:
    "Ocurrió un error al generar la campaña. Por favor, inténtalo de nuevo.",
  [CHANGE_BUYING_TYPE_TO_RESERVED_TITLE]: "Espera",
  [CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION]:
    "Al cambiar a tipo de compra por reserva, se perderán las configuraciones actuales y solo estará disponible el objetivo de Awareness. ¿Deseas continuar?",
  [HIDE_ALERTS]: "Ocultar alertas",
  [SHOW_ALERTS]: "Mostrar alertas",
  [ACTIVITY]: "Actividad",
  [NO_TASKS]: "Aún no hay campañas ni creativos en proceso",
  [NO_TASKS_DESCRIPTION]:
    "Las tareas aparecerán aquí automáticamente cuando inicies una nueva publicación de campaña o generes creativos",
  [GLOBAL_ALERTS_PANEL_TITLE]: "Notificaciones",
  [GLOBAL_ALERTS_EMPTY]: "No hay notificaciones",
  [GLOBAL_ALERTS_EMPTY_DESCRIPTION]:
    "Las novedades aparecerán aquí cuando se publiquen",
  [GLOBAL_ALERTS_BELL_ARIA]: "Notificaciones",
  [RESET_CHAT_ALERT_TITLE]: "¿Estás seguro?",
  [RESET_CHAT_ALERT_DESCRIPTION]: "Se eliminarán todos los mensajes del chat.",
  [DISCARD_OPTIMIZATION_ALERT_TITLE]: "¿Estás seguro?",
  [DISCARD_OPTIMIZATION_ALERT_DESCRIPTION]:
    "Se descartará esta optimización y no podrás recuperarla.",
  [DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION]:
    "Se descartará el creativo generado y no podrás recuperarlo.",
  [DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION]:
    "Se descartará el video generado y no podrás recuperarlo.",
  [DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION]:
    "Se descartará la animación generada y no podrás recuperarla.",
  [DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION]:
    "Se descartará el reporte generado y no podrás recuperarlo.",
  [DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION]:
    "Se descartará el análisis de capas y no podrás recuperarlo.",
  [DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "Este análisis de plantilla se descartará de tu lista de actividad.",
  [DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "Esta producción se descartará de tu lista de actividad.",
  [BUTTON_DISCARD_ALL]: "Descartar Todas",
  [DISCARD_ALL_ACTIVITIES_TITLE]: "¿Descartar Todas las Actividades?",
  [DISCARD_ALL_ACTIVITIES_DESCRIPTION]:
    "Se descartarán las actividades finalizadas y se perderá el acceso a la información desde este lugar. Las actividades que siguen en proceso se mantendrán.",

  // Keys para el modal de sets guardados
  [SAVED_LOCATION_SETS_TITLE]: "Conjuntos de ubicaciones guardados",
  [SAVED_LOCATION_SETS_CLOSE_BUTTON]: "Cerrar",

  [FIELD_OPEN_MAP_RADIUS_SELECT_TITLE]: "Seleccionar Ubicaciones",
  [FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION]:
    "Selecciona ubicaciones para tu campaña.",
  // Keys para los botones principales
  [LOAD_LOCATION_SET_BUTTON]: "Seleccionar ubicaciones",
  [SAVE_LOCATION_SET_BUTTON]: "Guardar ubicaciones",
  [SAVE_LOCATION_SET_SUCCESS]: "Conjunto de ubicaciones guardado",
  [SAVE_LOCATION_SET_ERROR]: "Error al guardar conjunto de ubicaciones",
  [LOAD_LOCATION_SETS_ERROR]: "Error al cargar conjuntos de ubicaciones",
  [SAVE_LOCATION_SET_DUPLICATE_ERROR]:
    "Ya existe un conjunto con las mismas ubicaciones",

  // CUSTOMER ACQUISITION CONFIGURATION
  [CUSTOMER_ACQUISITION_TITLE]: "Adquisición de Clientes",
  [CUSTOMER_ACQUISITION_SWITCH_LABEL]:
    "Ajusta tu oferta para ayudarte a ganar nuevos clientes",
  [CUSTOMER_ACQUISITION_ACCOUNT_LEVEL]: "Usar configuración de nivel de cuenta",
  [CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL]:
    "Usar configuración específica para la campaña",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE]: "Cliente Nuevo",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE]: "Cliente Nuevo de Alto Valor",

  // METRICS NOT FOUND MESSAGE
  [METRICS_NOT_FOUND_MESSAGE]: "Métricas no encontradas",
  [SEARCH_METRICS_PLACEHOLDER]: "Buscar métricas...",
  [CONFIGURE_METRICS]: "Configurar Métricas",
  [GENERAL_METRIC]: "General",

  // MÉTRICAS GENERALES
  [REACH]: "Alcance",
  [FREQUENCY]: "Frecuencia",
  [CPM_METRICS]: "CPM",
  [CPC_METRICS]: "CPC",
  [ESTIMATED_AUDIENCE_SIZE]: "Tamaño Estimado de Audiencia",
  [REACH_AT_TARGET_FREQUENCY]: "Alcance al Frecuencia Objetivo",
  [AUDIENCE_SIZE]: "Tamaño de Audiencia",
  [POTENTIAL_REACH]: "Alcance Potencial",
  [ESTIMATED_DAILY_RESULTS]: "Resultados Diarios Estimados",

  /*METRICAS ESPECIFICAS DE GOOGLE*/
  [ALL_CONVERSIONS]: "Todas las Conversiones",
  [ALL_CONVERSIONS_FROM_INTERACTIONS_RATE]:
    "Tasa de Todas las Conversiones por Interacciones",
  [ALL_CONVERSIONS_VALUE]: "Valor de Todas las Conversiones",
  [APP_EVENT_ADD_TO_CART]: "Eventos de Añadir al Carrito en App",
  [APP_INSTALL]: "Instalaciones de App",
  [AVERAGE_CART_SIZE]: "Tamaño Promedio del Carrito",
  [AVERAGE_COST]: "Costo Promedio",
  [AVERAGE_CPC]: "Costo Promedio por Clic",
  [AVERAGE_ORDER_VALUE_MICROS]: "Valor Promedio del Pedido",
  [CHECKOUT]: "Finalizaciones de Compra",
  [COMMENTS_METRICS]: "Comentarios",
  [CONVERSION_RATE]: "Tasa de Conversión",
  [CONVERSIONS_FROM_INTERACTIONS_RATE]:
    "Tasa de Conversiones por Interacciones",
  [CONVERSIONS_VALUE]: "Valor de Conversiones",
  [COST_OF_GOODS_SOLD_MICROS]: "Costo de Bienes Vendidos",
  [COST_PER_ALL_CONVERSIONS]: "Costo por Todas las Conversiones",
  [COST_PER_APP_EVENT_ADD_TO_CART]: "Costo por Añadir al Carrito en App",
  [COST_PER_APP_INSTALL]: "Costo por Instalación de App",
  [COST_PER_CHECKOUT]: "Costo por Finalización de Compra",
  [COST_PER_CONVERSION]: "Costo por Conversión",
  [COST_PER_PURCHASE]: "Costo por Compra",
  [COST_PER_VIEW_CONTENT]: "Costo por Vista de Contenido",
  [CROSS_DEVICE_CONVERSIONS]: "Conversiones entre Dispositivos",
  [CROSS_DEVICE_CONVERSIONS_VALUE_MICROS]:
    "Valor de Conversiones entre Dispositivos",
  [CROSS_SELL_COST_OF_GOODS_SOLD_MICROS]:
    "Costo de Bienes Vendidos en Venta Cruzada",
  [CROSS_SELL_GROSS_PROFIT_MICROS]: "Beneficio Bruto de Venta Cruzada",
  [CROSS_SELL_REVENUE_MICROS]: "Ingresos de Venta Cruzada",
  [CROSS_SELL_UNITS_SOLD]: "Unidades Vendidas en Venta Cruzada",
  [ENGAGEMENT_RATE]: "Tasa de Engagement",
  [FOLLOWS]: "Seguidores",
  [GROSS_PROFIT_MARGIN]: "Margen de Beneficio Bruto",
  [GROSS_PROFIT_MICROS]: "Beneficio Bruto",
  [INTERACTION_RATE]: "Tasa de Interacción",
  [INTERACTIONS_METRICS]: "Interacciones",
  [LEAD_COST_OF_GOODS_SOLD_MICROS]: "Costo de Bienes Vendidos por Lead",
  [LEAD_GROSS_PROFIT_MICROS]: "Beneficio Bruto por Lead",
  [LEAD_REVENUE_MICROS]: "Ingresos por Lead",
  [LEAD_UNITS_SOLD]: "Unidades Vendidas por Lead",
  [LIKES_METRICS]: "Me gusta",
  [ORDERS_METRICS]: "Pedidos",
  [PROFILE_VISITS]: "Visitas al Perfil",
  [PURCHASE]: "Compras",
  [REVENUE_MICROS]: "Ingresos",
  [SHARES_METRICS]: "Compartidos",
  [VALUE_PER_ALL_CONVERSIONS]: "Valor por Todas las Conversiones",
  [VALUE_PER_CONVERSION]: "Valor por Conversión",
  [VIDEO_VIEWS_P100]: "Visualizaciones Completas de Video",
  [VIEW_CONTENT]: "Vistas de Contenido",
  [VIEW_THROUGH_CONVERSIONS]: "Conversiones por Visualización",

  /*SPECIFICS METRICS META*/
  [ACTION_VALUES]: "Valores de Acción",
  [ACTIONS_METRICS]: "Acciones",
  [COST_PER_ADD_TO_CART_META]: "Costo por Añadir al Carrito",
  [ADD_TO_CART_META]: "Añadir al carrito",
  [COST_PER_WEB_IN_STORE_PURCHASE_META]: "Costo por Compra Web en Tienda",
  [WEB_IN_STORE_PURCHASE_META]: "Compra Web en Tienda",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Costo por Conversión Externa Fb Pixel Búsqueda",
  [OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Conversión Externa Fb Pixel Búsqueda",
  [COST_PER_LINK_CLICK_META]: "Costo por Clic en Enlace",
  [LINK_CLICK_META]: "Clic en Enlace",
  [COST_PER_PAGE_ENGAGEMENT_META]: "Costo por Compromiso de Página",
  [PAGE_ENGAGEMENT_META]: "Compromiso de Página",
  [COST_PER_PURCHASE_META]: "Costo por Compra",
  [PURCHASE_META]: "Compra",
  [COST_PER_LANDING_PAGE_VIEW_META]: "Costo por Vista de Página de Destino",
  [LANDING_PAGE_VIEW_META]: "Vista de Página de Destino",
  [COST_PER_POST_ENGAGEMENT_META]: "Costo por Compromiso de Publicación",
  [POST_ENGAGEMENT_META]: "Compromiso de Publicación",
  [COST_PER_ONSITE_WEB_VIEW_CONTENT_META]:
    "Costo por Vista de Contenido Web en Sitio",
  [ONSITE_WEB_VIEW_CONTENT_META]: "Vista de Contenido Web en Sitio",
  [COST_PER_ONSITE_WEB_ADD_TO_CART_META]:
    "Costo por Añadir al Carrito Web en Sitio",
  [ONSITE_WEB_ADD_TO_CART_META]: "Añadir al Carrito Web en Sitio",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Costo por Conversión Externa Fb Pixel Añadir Info de Pago",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Conversión Externa Fb Pixel Añadir Info de Pago",
  [COST_PER_COMMENT_META]: "Costo por Comentario",
  [COMMENT_META]: "Comentario",
  [COST_PER_ONSITE_WEB_APP_PURCHASE_META]: "Costo por Compra App Web en Sitio",
  [ONSITE_WEB_APP_PURCHASE_META]: "Compra App Web en Sitio",
  [COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Costo por Vista de Contenido Externa Añadir Leads Meta",
  [OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Vista de Contenido Externa Añadir Leads Meta",
  [COST_PER_VIEW_CONTENT_META]: "Costo por Ver Contenido",
  [VIEW_CONTENT_META]: "Ver Contenido",
  [COST_PER_WEB_APP_IN_STORE_PURCHASE_META]:
    "Costo por Compra App Web en Tienda",
  [WEB_APP_IN_STORE_PURCHASE_META]: "Compra App Web en Tienda",
  [COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META]:
    "Costo por Añadir al Carrito App Web en Sitio",
  [ONSITE_WEB_APP_ADD_TO_CART_META]: "Añadir al Carrito App Web en Sitio",
  [COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META]:
    "Costo por Búsqueda Externa Añadir Leads Meta",
  [OFFSITE_SEARCH_ADD_META_LEADS_META]: "Búsqueda Externa Añadir Leads Meta",
  [COST_PER_POST_META]: "Costo por Publicación",
  [POST_META]: "Publicación",
  [COST_PER_ONSITE_CONVERSION_POST_SAVE_META]:
    "Costo por Conversión en Sitio Guardar Publicación",
  [ONSITE_CONVERSION_POST_SAVE_META]: "Conversión en Sitio Guardar Publicación",
  [COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META]:
    "Costo por Inicio de Checkout Web en Sitio",
  [ONSITE_WEB_INITIATE_CHECKOUT_META]: "Inicio de Checkout Web en Sitio",
  [COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META]:
    "Costo por Conversión en Sitio Guardar Neto Publicación",
  [ONSITE_CONVERSION_POST_NET_SAVE_META]:
    "Conversión en Sitio Guardar Neto Publicación",
  [COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META]:
    "Costo por Vista de Contenido App Web en Sitio",
  [ONSITE_WEB_APP_VIEW_CONTENT_META]: "Vista de Contenido App Web en Sitio",
  [COST_PER_POST_INTERACTION_GROSS_META]:
    "Costo por Interacción Bruta de Publicación",
  [POST_INTERACTION_GROSS_META]: "Interacción Bruta de Publicación",
  [COST_PER_ONSITE_WEB_PURCHASE_META]: "Costo por Compra Web en Sitio",
  [ONSITE_WEB_PURCHASE_META]: "Compra Web en Sitio",
  [COST_PER_ADD_PAYMENT_INFO_META]: "Costo por Añadir Info de Pago",
  [ADD_PAYMENT_INFO_META]: "Añadir Info de Pago",
  [COST_PER_SEARCH_META]: "Costo por Búsqueda",
  [SEARCH_META]: "Búsqueda",
  [COST_PER_VIDEO_VIEW_META]: "Costo por Vista de Video",
  [VIDEO_VIEW_META]: "Vista de Video",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Costo por Conversión Externa Fb Pixel Ver Contenido",
  [OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Conversión Externa Fb Pixel Ver Contenido",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Costo por Conversión Externa Fb Pixel Añadir al Carrito",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Conversión Externa Fb Pixel Añadir al Carrito",
  [COST_PER_POST_REACTION_META]: "Costo por Reacción de Publicación",
  [POST_REACTION_META]: "Reacción de Publicación",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Costo por Conversión Externa Fb Pixel Inicio de Checkout",
  [OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Conversión Externa Fb Pixel Inicio de Checkout",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Costo por Conversión Externa Fb Pixel Compra",
  [OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Conversión Externa Fb Pixel Compra",
  [COST_PER_INITIATE_CHECKOUT_META]: "Costo por Inicio de Checkout",
  [INITIATE_CHECKOUT_META]: "Inicio de Checkout",
  [COST_PER_LIKE_META]: "Costo por Me Gusta",
  [LIKE_META]: "Me Gusta",
  [AD_CLICK_ACTIONS]: "Clics en Anuncios",
  [AD_IMPRESSION_ACTIONS]: "Impresiones de Anuncios",
  [AUCTION_BID]: "Puja en Subasta",
  [AUCTION_COMPETITIVENESS]: "Competitividad en Subasta",
  [AUCTION_MAX_COMPETITOR_BID]: "Puja Máxima del Competidor",
  [CANVAS_AVG_VIEW_PERCENT]: "Porcentaje Promedio de Vista de Canvas",
  [CANVAS_AVG_VIEW_TIME]: "Tiempo Promedio de Vista de Canvas",
  [CATALOG_SEGMENT_ACTIONS]: "Acciones de Segmento de Catálogo",
  [CATALOG_SEGMENT_VALUE]: "Valor de Segmento de Catálogo",
  [CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS]:
    "ROAS de Compras Móviles en Segmento de Catálogo",
  [CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS]:
    "ROAS de Compras Omnicanal en Segmento de Catálogo",
  [CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS]:
    "ROAS de Compras Web en Segmento de Catálogo",
  [CONVERSION_VALUES]: "Valores de Conversión",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Compras Móviles de Productos Convertidos",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Valor de Compras Móviles de Productos Convertidos",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE]:
    "Compras Offline de Productos Convertidos",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Valor de Compras Offline de Productos Convertidos",
  [CONVERTED_PRODUCT_OMNI_PURCHASE]:
    "Compras Omnicanal de Productos Convertidos",
  [CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Valores de Compras Omnicanal de Productos Convertidos",
  [CONVERTED_PRODUCT_QUANTITY]: "Cantidad de Productos Convertidos",
  [CONVERTED_PRODUCT_VALUE]: "Valor de Productos Convertidos",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Compras Web de Productos Convertidos",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Valor de Compras Web de Productos Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Compras Móviles de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Valor de Compras Móviles de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE]:
    "Compras Offline de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Valor de Compras Offline de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE]:
    "Compras Omnicanal de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Valores de Compras Omnicanal de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_QUANTITY]:
    "Cantidad de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_VALUE]:
    "Valor de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Compras Web de Productos Promocionados Convertidos",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Valor de Compras Web de Productos Promocionados Convertidos",
  [COST_PER_15SEC_VIDEO_VIEW]: "Costo por Vista de Video de 15 Segundos",
  [COST_PER_15_SEC_VIDEO_VIEW]: "Costo por Vista de Video de 15 Segundos",
  [COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW]:
    "Costo por Vista Continua de Video de 2 Segundos",
  [COST_PER_ACTION_TYPE]: "Costo por Tipo de Acción",
  [COST_PER_AD_CLICK]: "Costo por Clic en Anuncio",
  [COST_PER_DDA_COUNT_BY_CONVS]: "Costo por Conteo DDA por Conversiones",
  [COST_PER_ESTIMATED_AD_RECALLERS]:
    "Costo por Recordatorios Estimados de Anuncios",
  [COST_PER_INLINE_LINK_CLICK]: "Costo por Clic en Enlace Inline",
  [COST_PER_INLINE_POST_ENGAGEMENT]:
    "Costo por Engagement en Publicación Inline",
  [COST_PER_OBJECTIVE_RESULT]: "Costo por Resultado de Objetivo",
  [COST_PER_ONE_THOUSAND_AD_IMPRESSION]:
    "Costo por Mil Impresiones de Anuncios",
  [COST_PER_OUTBOUND_CLICK]: "Costo por Clic Saliente",
  [COST_PER_RESULT]: "Costo por Resultado",
  [COST_PER_THRUPLAY]: "Costo por Reproducción Completa",
  [COST_PER_UNIQUE_ACTION_TYPE]: "Costo por Tipo de Acción Única",
  [COST_PER_UNIQUE_CLICK]: "Costo por Clic Único",
  [COST_PER_UNIQUE_CONVERSION]: "Costo por Conversión Única",
  [COST_PER_UNIQUE_INLINE_LINK_CLICK]: "Costo por Clic Único en Enlace Inline",
  [COST_PER_UNIQUE_OUTBOUND_CLICK]: "Costo por Clic Saliente Único",
  [CPP]: "Costo por Persona",
  [DDA_COUNT_BY_CONVS]: "Conteo DDA por Conversiones",
  [DDA_RESULTS]: "Resultados DDA",
  [ESTIMATED_AD_RECALLERS]: "Recordatorios Estimados de Anuncios",
  [INSTAGRAM_PROFILE_FOLLOW]: "Seguidores de Instagram",
  [FULL_VIEW_IMPRESSIONS]: "Impresiones de Vista Completa",
  [FULL_VIEW_REACH]: "Alcance de Vista Completa",
  [INLINE_LINK_CLICK_CTR]: "CTR de Clics en Enlaces Inline",
  [INLINE_LINK_CLICKS]: "Clics en Enlaces Inline",
  [INLINE_POST_ENGAGEMENT]: "Engagement en Publicaciones Inline",
  [INSTANT_EXPERIENCE_CLICKS_TO_OPEN]:
    "Clics para Abrir Experiencia Instantánea",
  [INSTANT_EXPERIENCE_CLICKS_TO_START]:
    "Clics para Iniciar Experiencia Instantánea",
  [INSTANT_EXPERIENCE_OUTBOUND_CLICKS]:
    "Clics Salientes en Experiencia Instantánea",
  [INTERACTIVE_COMPONENT_TAP]: "Toques en Componente Interactivo",
  [LANDING_PAGE_VIEW_PER_LINK_CLICK]:
    "Vistas de Página de Destino por Clic en Enlace",
  [MARKETING_MESSAGES_DELIVERY_RATE]:
    "Tasa de Entrega de Mensajes de Marketing",
  [OBJECTIVE_RESULT_RATE]: "Tasa de Resultado de Objetivo",
  [OBJECTIVE_RESULTS]: "Resultados de Objetivo",
  [OUTBOUND_CLICKS]: "Clics Salientes",
  [OUTBOUND_CLICKS_CTR]: "CTR de Clics Salientes",
  [PURCHASE_PER_LANDING_PAGE_VIEW]: "Compras por Vista de Página de Destino",
  [QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE]:
    "Tasa de Respuesta Calificada a Pregunta de Calificación",
  [RESULT_RATE]: "Tasa de Resultados",
  [RESULTS_METRICS]: "Resultados",
  [ROAS_METRICS]: "ROAS",
  [SHOPS_ASSISTED_PURCHASES]: "Compras Asistidas en Tiendas",
  [SOCIAL_SPEND]: "Gasto Social",
  [TOTAL_CARD_VIEW]: "Vista Total de Tarjetas",
  [VIDEO_30SEC_WATCHED_ACTIONS]: "Acciones de Vista de Video de 30 Segundos",
  [VIDEO_30_SEC_WATCHED_ACTIONS]: "Acciones de Vista de Video de 30 Segundos",
  [VIDEO_AVG_TIME_WATCHED_ACTIONS]:
    "Acciones de Tiempo Promedio de Vista de Video",
  [VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS]:
    "Acciones de Vista Continua de Video de 2 Segundos",
  [VIDEO_P100_WATCHED_ACTIONS]: "Acciones de Vista de Video al 100%",
  [VIDEO_P25_WATCHED_ACTIONS]: "Acciones de Vista de Video al 25%",
  [VIDEO_P50_WATCHED_ACTIONS]: "Acciones de Vista de Video al 50%",
  [VIDEO_P75_WATCHED_ACTIONS]: "Acciones de Vista de Video al 75%",
  [VIDEO_P95_WATCHED_ACTIONS]: "Acciones de Vista de Video al 95%",
  [VIDEO_PLAY_ACTIONS]: "Acciones de Reproducción de Video",
  [VIDEO_PLAY_CURVE_ACTIONS]: "Acciones de Curva de Reproducción de Video",
  [VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS]:
    "Acciones de Retención de Reproducción de Video de 0 a 15s",
  [VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS]:
    "Acciones de Retención de Reproducción de Video de 20 a 60s",
  [VIDEO_PLAY_RETENTION_GRAPH_ACTIONS]:
    "Acciones de Gráfico de Retención de Reproducción de Video",
  [VIDEO_TIME_WATCHED_ACTIONS]: "Acciones de Tiempo de Vista de Video",
  [WEBSITE_CTR]: "CTR del Sitio Web",
  [WEBSITE_PURCHASE_ROAS]: "ROAS de Compras en Sitio Web",
  [VIDEO_HOOK_RATE]: "Tasa de Enganche del Video",
  [VIDEO_RETENTION_RATE]: "Tasa de Retención del Video",

  /*SPECIFICS METRICS TIKTOK*/
  [BILLED_COST]: "Costo Facturado",
  [GROSS_IMPRESSIONS]: "Impresiones Brutas",
  [CONVERSION_RATE_TIKTOK]: "Tasa de Conversión",
  [RESULT_RATE_TIKTOK]: "Tasa de Resultados",
  [VIDEO_VIEWS_P100_TIKTOK]: "Reproducciones al 100%",
  [AVERAGE_VIDEO_PLAY]: "Reproducción Promedio de Video",
  [ENGAGEMENT_RATE_TIKTOK]: "Tasa de Interacción",
  [FOLLOWS_TIKTOK]: "Seguidores",
  [LIKES_TIKTOK]: "Me Gusta",
  [COMMENTS_TIKTOK]: "Comentarios",
  [SHARES_TIKTOK]: "Compartidas",
  [PROFILE_VISITS_TIKTOK]: "Visitas a Perfil",
  [COMMENTS_LINKEDIN]: "Comentarios",
  [COMPANY_PAGE_CLICKS_LINKEDIN]: "Clics en la Página de Empresa",
  [EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN]:
    "Conversiones en Sitios Web Externos",
  [FOLLOWS_LINKEDIN]: "Seguimientos",
  [FULL_SCREEN_PLAYS_LINKEDIN]: "Reproducciones a Pantalla Completa",
  [LANDING_PAGE_CLICKS_LINKEDIN]: "Clics en la Página de Destino",
  [LIKES_LINKEDIN]: "Recomendaciones",
  [REACTIONS_LINKEDIN]: "Reacciones",
  [RETURN_ON_AD_SPEND_LINKEDIN]: "Retorno de la Inversión Publicitaria",
  [SHARES_LINKEDIN]: "Veces que se ha Compartido",
  [TOTAL_ENGAGEMENTS_LINKEDIN]: "Interacciones Totales",
  [VIDEO_COMPLETIONS_LINKEDIN]: "Visualizaciones Completas del Video",
  [VIDEO_STARTS_LINKEDIN]: "Reproducciones de Video Iniciadas",
  [VIDEO_VIEWS_LINKEDIN]: "Visualizaciones de Video",
  [ONE_CLICK_LEADS_LINKEDIN]: "Leads",
  [ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN]: "Aperturas del formulario",
  [LEAD_FORM_COMPLETION_RATE_LINKEDIN]: "Tasa de completado del formulario",
  [VALID_WORK_EMAIL_LEADS_LINKEDIN]: "Leads con email laboral",
  [DOWNLOAD_CLICKS_LINKEDIN]: "Clics de descarga",
  [DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN]: "Documento al 25%",
  [DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN]: "Documento al 50%",
  [DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN]: "Documento al 75%",
  [DOCUMENT_COMPLETIONS_LINKEDIN]: "Documento al 100%",
  [LIVE_VIEWS]: "Vistas en Vivo",
  [APP_INSTALL_TIKTOK]: "Instalaciones de App",
  [COST_PER_APP_INSTALL_TIKTOK]: "Costo por Instalación de App",
  [REGISTRATION]: "Registros",
  [COST_PER_REGISTRATION]: "Costo por Registro",
  [PURCHASE_TIKTOK]: "Compras",
  [COST_PER_PURCHASE_TIKTOK]: "Costo por Compra",
  [PURCHASE_RATE]: "Tasa de Compra",
  [TOTAL_PURCHASE_VALUE]: "Valor Total de Compras",
  [APP_EVENT_ADD_TO_CART_TIKTOK]: "Eventos de Añadir al Carrito",
  [COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK]:
    "Costo por Evento de Añadir al Carrito",
  [CHECKOUT_TIKTOK]: "Finalizaciones de Compra",
  [COST_PER_CHECKOUT_TIKTOK]: "Costo por Finalización de Compra",
  [VIEW_CONTENT_TIKTOK]: "Visualización de Contenido",
  [COST_PER_VIEW_CONTENT_TIKTOK]: "Costo por Visualización de Contenido",
  [NEXT_DAY_OPEN]: "Aperturas al Día Siguiente",
  [DAY7_RETENTION]: "Retención a 7 Días",
  [CASH_SPEND]: "Gasto en Efectivo",
  [VOUCHER_SPEND]: "Gasto en Cupones",
  [COST_PER_1000_REACHED]: "Costo por 1,000 Alcanzados",
  [CONVERSION_RATE_V2]: "Tasa de Conversión V2",
  [REAL_TIME_CONVERSION]: "Conversiones en Tiempo Real",
  [REAL_TIME_COST_PER_CONVERSION]: "Costo por Conversión en Tiempo Real",
  [REAL_TIME_CONVERSION_RATE]: "Tasa de Conversión en Tiempo Real",
  [REAL_TIME_CONVERSION_RATE_V2]: "Tasa de Conversión en Tiempo Real V2",
  [REAL_TIME_RESULT]: "Resultados en Tiempo Real",
  [REAL_TIME_COST_PER_RESULT]: "Costo por Resultado en Tiempo Real",
  [REAL_TIME_RESULT_RATE]: "Tasa de Resultados en Tiempo Real",
  [SECONDARY_GOAL_RESULT]: "Resultados de Objetivo Secundario",
  [COST_PER_SECONDARY_GOAL_RESULT]:
    "Costo por Resultado de Objetivo Secundario",
  [SECONDARY_GOAL_RESULT_RATE]: "Tasa de Resultados de Objetivo Secundario",
  [VIDEO_PLAY_ACTIONS_TIKTOK]: "Acciones de Reproducción de Video",
  [VIDEO_WATCHED_2S]: "Vistas de 2 Segundos",
  [VIDEO_WATCHED_6S]: "Vistas de 6 Segundos",
  [VIDEO_VIEWS_P25]: "Reproducciones al 25%",
  [VIDEO_VIEWS_P50]: "Reproducciones al 50%",
  [VIDEO_VIEWS_P75]: "Reproducciones al 75%",
  [AVERAGE_VIDEO_PLAY_PER_USER]: "Reproducción Promedio por Usuario",
  [PAID_ENGAGED_VIEW]: "Vistas Comprometidas Pagadas",
  [PAID_ENGAGEMENT_ENGAGED_VIEW]: "Vistas Comprometidas de Interacción Pagada",
  [ENGAGED_VIEW_15S]: "Vistas Comprometidas de 15s",
  [PAID_ENGAGED_VIEW_15S]: "Vistas Comprometidas Pagadas de 15s",
  [PAID_ENGAGEMENT_ENGAGED_VIEW_15S]:
    "Vistas Comprometidas de Interacción Pagada de 15s",
  [CLICKS_ON_MUSIC_DISC]: "Clics en Disco de Música",
  [DUET_CLICKS]: "Clics en Dúo",
  [STITCH_CLICKS]: "Clics en Stitch",
  [SOUND_USAGE_CLICKS]: "Clics de Uso de Sonido",
  [MUSIC_UPLOAD_TITLE]: "Música de Fondo",
  [MUSIC_UPLOAD_BUTTON]: "Subir Música",
  [MUSIC_REMOVE_BUTTON]: "Eliminar Música",
  [MUSIC_UPLOAD_DESCRIPTION]:
    "Sube un archivo de música en formato MP3 para tu anuncio",
  [ANCHOR_CLICKS]: "Clics en Anclaje",
  [ANCHOR_CLICK_RATE]: "Tasa de Clics en Anclaje",
  [CLICKS_ON_HASHTAG_CHALLENGE]: "Clics en Retos de Hashtag",
  [PROFILE_VISITS_RATE]: "Tasa de Visitas a Perfil",
  [TT_PLAYLIST_VISIT]: "Visitas a Playlist",
  [TT_PLAYLIST_VISIT_RATE]: "Tasa de Visitas a Playlist",
  [LIVE_UNIQUE_VIEWS]: "Vistas Únicas en Vivo",
  [LIVE_EFFECTIVE_VIEWS]: "Vistas Efectivas en Vivo",
  [LIVE_PRODUCT_CLICKS]: "Clics en Productos en Vivo",
  [INTERACTIVE_ADD_ON_IMPRESSIONS]: "Impresiones de Complementos Interactivos",
  [INTERACTIVE_ADD_ON_DESTINATION_CLICKS]:
    "Clics de Destino en Complementos Interactivos",
  [INTERACTIVE_ADD_ON_ACTIVITY_CLICKS]:
    "Clics de Actividad en Complementos Interactivos",
  [INTERACTIVE_ADD_ON_OPTION_A_CLICKS]:
    "Clics en Opción A de Complementos Interactivos",
  [INTERACTIVE_ADD_ON_OPTION_B_CLICKS]:
    "Clics en Opción B de Complementos Interactivos",
  [COUNTDOWN_STICKER_RECALL_CLICKS]: "Clics en Calcomería de Cuenta Regresiva",
  [IX_PAGE_DURATION_AVG]: "Duración Promedio de Página IX",
  [IX_PAGE_VIEWRATE_AVG]: "Tasa Promedio de Visualización de Página IX",
  [IX_VIDEO_VIEWS]: "Vistas de Video IX",
  [IX_VIDEO_VIEWS_P25]: "Vistas de Video IX al 25%",
  [IX_VIDEO_VIEWS_P50]: "Vistas de Video IX al 50%",
  [IX_VIDEO_VIEWS_P75]: "Vistas de Video IX al 75%",
  [IX_VIDEO_VIEWS_P100]: "Vistas de Video IX al 100%",
  [IX_AVERAGE_VIDEO_PLAY]: "Reproducción Promedio de Video IX",
  [REAL_TIME_APP_INSTALL]: "Instalaciones de App en Tiempo Real",
  [REAL_TIME_APP_INSTALL_COST]: "Costo de Instalación de App en Tiempo Real",
  [REGISTRATION_RATE]: "Tasa de Registro",
  [TOTAL_REGISTRATION]: "Registros Totales",
  [COST_PER_TOTAL_REGISTRATION]: "Costo por Registro Total",
  [TOTAL_PURCHASE]: "Compras Totales",
  [COST_PER_TOTAL_PURCHASE]: "Costo por Compra Total",
  [VALUE_PER_TOTAL_PURCHASE]: "Valor por Compra Total",
  [TOTAL_ACTIVE_PAY_ROAS]: "ROAS de Pago Activo Total",
  [TOTAL_PURCHASE_ROAS_DAY0]: "ROAS de Compra Total Día 0",
  [TOTAL_PURCHASE_ROAS_DAY2]: "ROAS de Compra Total Día 2",
  [TOTAL_PURCHASE_ROAS_DAY6]: "ROAS de Compra Total Día 6",
  [TOTAL_PURCHASE_VALUE_DAY0]: "Valor Total de Compras Día 0",
  [TOTAL_PURCHASE_VALUE_DAY2]: "Valor Total de Compras Día 2",
  [TOTAL_PURCHASE_VALUE_DAY6]: "Valor Total de Compras Día 6",
  [APP_EVENT_ADD_TO_CART_RATE]: "Tasa de Añadir al Carrito",
  [TOTAL_APP_EVENT_ADD_TO_CART]: "Eventos Totales de Añadir al Carrito",
  [COST_PER_TOTAL_APP_EVENT_ADD_TO_CART]: "Costo por Añadir al Carrito Total",
  [VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART]: "Valor por Añadir al Carrito Total",
  [TOTAL_APP_EVENT_ADD_TO_CART_VALUE]: "Valor Total de Añadir al Carrito",
  [CHECKOUT_RATE]: "Tasa de Finalización de Compra",
  [TOTAL_CHECKOUT]: "Finalizaciones de Compra Totales",
  [COST_PER_TOTAL_CHECKOUT]: "Costo por Finalización de Compra Total",
  [VALUE_PER_CHECKOUT]: "Valor por Finalización de Compra",
  [TOTAL_CHECKOUT_VALUE]: "Valor Total de Finalizaciones de Compra",
  [VIEW_CONTENT_RATE]: "Tasa de Visualización de Contenido",
  [TOTAL_VIEW_CONTENT]: "Visualizaciones de Contenido Totales",
  [COST_PER_TOTAL_VIEW_CONTENT]: "Costo por Visualización de Contenido Total",
  [VALUE_PER_TOTAL_VIEW_CONTENT]: "Valor por Visualización de Contenido Total",
  [TOTAL_VIEW_CONTENT_VALUE]: "Valor Total de Visualizaciones de Contenido",
  [COST_PER_NEXT_DAY_OPEN]: "Costo por Apertura al Día Siguiente",
  [NEXT_DAY_OPEN_RATE]: "Tasa de Apertura al Día Siguiente",
  [TOTAL_NEXT_DAY_OPEN]: "Aperturas Totales al Día Siguiente",
  [COST_PER_TOTAL_NEXT_DAY_OPEN]: "Costo por Apertura Total al Día Siguiente",
  [COST_PER_DAY7_RETENTION]: "Costo por Retención a 7 Días",
  [DAY7_RETENTION_RATE]: "Tasa de Retención a 7 Días",
  [TOTAL_DAY7_RETENTION]: "Retención Total a 7 Días",
  [COST_PER_TOTAL_DAY7_RETENTION]: "Costo por Retención Total a 7 Días",
  [VALUE_PER_TOTAL_DAY7_RETENTION]: "Valor por Retención Total a 7 Días",
  [TOTAL_DAY7_RETENTION_VALUE]: "Valor Total de Retención a 7 Días",
  [ADD_PAYMENT_INFO]: "Añadir Información de Pago",
  [COST_PER_ADD_PAYMENT_INFO]: "Costo por Añadir Información de Pago",
  [ADD_PAYMENT_INFO_RATE]: "Tasa de Añadir Información de Pago",
  [TOTAL_ADD_PAYMENT_INFO]: "Total de Añadir Información de Pago",
  [COST_TOTAL_ADD_PAYMENT_INFO]: "Costo Total de Añadir Información de Pago",
  [ADD_TO_WISHLIST]: "Añadir a Lista de Deseos",
  [COST_PER_ADD_TO_WISHLIST]: "Costo por Añadir a Lista de Deseos",
  [ADD_TO_WISHLIST_RATE]: "Tasa de Añadir a Lista de Deseos",
  [TOTAL_ADD_TO_WISHLIST]: "Total de Añadidos a Lista de Deseos",
  [COST_PER_TOTAL_ADD_TO_WISHLIST]:
    "Costo por Total de Añadidos a Lista de Deseos",
  [VALUE_PER_TOTAL_ADD_TO_WISHLIST]:
    "Valor por Total de Añadidos a Lista de Deseos",
  [TOTAL_ADD_TO_WISHLIST_VALUE]: "Valor Total de Añadidos a Lista de Deseos",
  [LAUNCH_APP]: "Iniciar App",
  [COST_PER_LAUNCH_APP]: "Costo por Iniciar App",
  [LAUNCH_APP_RATE]: "Tasa de Inicio de App",
  [TOTAL_LAUNCH_APP]: "Inicios Totales de App",
  [COST_PER_TOTAL_LAUNCH_APP]: "Costo por Inicio Total de App",
  [COMPLETE_TUTORIAL]: "Completar Tutorial",
  [COST_PER_COMPLETE_TUTORIAL]: "Costo por Completar Tutorial",
  [COMPLETE_TUTORIAL_RATE]: "Tasa de Completar Tutorial",
  [TOTAL_COMPLETE_TUTORIAL]: "Tutoriales Completados Totales",
  [COST_PER_TOTAL_COMPLETE_TUTORIAL]: "Costo por Tutorial Completado Total",
  [VALUE_PER_TOTAL_COMPLETE_TUTORIAL]: "Valor por Tutorial Completado Total",
  [TOTAL_COMPLETE_TUTORIAL_VALUE]: "Valor Total de Tutoriales Completados",
  [CREATE_GROUP]: "Crear Grupo",
  [COST_PER_CREATE_GROUP]: "Costo por Crear Grupo",
  [CREATE_GROUP_RATE]: "Tasa de Creación de Grupo",
  [TOTAL_CREATE_GROUP]: "Grupos Creados Totales",
  [COST_PER_TOTAL_CREATE_GROUP]: "Costo por Creación Total de Grupo",
  [VALUE_PER_TOTAL_CREATE_GROUP]: "Valor por Creación Total de Grupo",
  [TOTAL_CREATE_GROUP_VALUE]: "Valor Total de Grupos Creados",
  [JOIN_GROUP]: "Unirse a Grupo",
  [COST_PER_JOIN_GROUP]: "Costo por Unirse a Grupo",
  [JOIN_GROUP_RATE]: "Tasa de Unión a Grupo",
  [TOTAL_JOIN_GROUP]: "Uniones Totales a Grupo",
  [COST_PER_TOTAL_JOIN_GROUP]: "Costo por Unión Total a Grupo",
  [VALUE_PER_TOTAL_JOIN_GROUP]: "Valor por Unión Total a Grupo",
  [TOTAL_JOIN_GROUP_VALUE]: "Valor Total de Uniones a Grupo",
  [CREATE_GAMEROLE]: "Crear Rol de Juego",
  [COST_PER_CREATE_GAMEROLE]: "Costo por Crear Rol de Juego",
  [CREATE_GAMEROLE_RATE]: "Tasa de Creación de Rol de Juego",
  [TOTAL_CREATE_GAMEROLE]: "Roles de Juego Creados Totales",
  [COST_PER_TOTAL_CREATE_GAMEROLE]: "Costo por Creación Total de Rol de Juego",
  [VALUE_PER_TOTAL_CREATE_GAMEROLE]: "Valor por Creación Total de Rol de Juego",
  [TOTAL_CREATE_GAMEROLE_VALUE]: "Valor Total de Roles de Juego Creados",
  [SPEND_CREDITS]: "Gastar Créditos",
  [COST_PER_SPEND_CREDITS]: "Costo por Gastar Créditos",
  [SPEND_CREDITS_RATE]: "Tasa de Gasto de Créditos",
  [TOTAL_SPEND_CREDITS]: "Créditos Gastados Totales",
  [COST_PER_TOTAL_SPEND_CREDITS]: "Costo por Gasto Total de Créditos",
  [VALUE_PER_TOTAL_SPEND_CREDITS]: "Valor por Gasto Total de Créditos",
  [TOTAL_SPEND_CREDITS_VALUE]: "Valor Total de Créditos Gastados",
  [ACHIEVE_LEVEL]: "Alcanzar Nivel",
  [COST_PER_ACHIEVE_LEVEL]: "Costo por Alcanzar Nivel",
  [ACHIEVE_LEVEL_RATE]: "Tasa de Alcanzar Nivel",
  [TOTAL_ACHIEVE_LEVEL]: "Niveles Alcanzados Totales",
  [COST_PER_TOTAL_ACHIEVE_LEVEL]: "Costo por Nivel Alcanzado Total",
  [VALUE_PER_TOTAL_ACHIEVE_LEVEL]: "Valor por Nivel Alcanzado Total",
  [TOTAL_ACHIEVE_LEVEL_VALUE]: "Valor Total de Niveles Alcanzados",
  [UNLOCK_ACHIEVEMENT]: "Desbloquear Logro",
  [COST_PER_UNLOCK_ACHIEVEMENT]: "Costo por Desbloquear Logro",
  [UNLOCK_ACHIEVEMENT_RATE]: "Tasa de Desbloqueo de Logro",
  [TOTAL_UNLOCK_ACHIEVEMENT]: "Logros Desbloqueados Totales",
  [COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]: "Costo por Logro Desbloqueado Total",
  [VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT]: "Valor por Logro Desbloqueado Total",
  [TOTAL_UNLOCK_ACHIEVEMENT_VALUE]: "Valor Total de Logros Desbloqueados",
  [SALES_LEAD]: "Lead de Ventas",
  [COST_PER_SALES_LEAD]: "Costo por Lead de Ventas",
  [SALES_LEAD_RATE]: "Tasa de Leads de Ventas",
  [TOTAL_SALES_LEAD]: "Leads de Ventas Totales",
  [COST_PER_TOTAL_SALES_LEAD]: "Costo por Lead de Ventas Total",
  [VALUE_PER_TOTAL_SALES_LEAD]: "Valor por Lead de Ventas Total",
  [TOTAL_SALES_LEAD_VALUE]: "Valor Total de Leads de Ventas",
  [IN_APP_AD_CLICK]: "Clic en Anuncio en App",
  [COST_PER_IN_APP_AD_CLICK]: "Costo por Clic en Anuncio en App",
  [IN_APP_AD_CLICK_RATE]: "Tasa de Clics en Anuncios en App",

  [TOTAL_IN_APP_AD_CLICK]: "Clics Totales en Anuncios en App",
  [COST_PER_TOTAL_IN_APP_AD_CLICK]: "Costo por Clic Total en Anuncios en App",
  [VALUE_PER_TOTAL_IN_APP_AD_CLICK]: "Valor por Clic Total en Anuncios en App",
  [TOTAL_IN_APP_AD_CLICK_VALUE]: "Valor Total de Clics en Anuncios en App",
  [IN_APP_AD_IMPR]: "Impresión de Anuncio en App",
  [COST_PER_IN_APP_AD_IMPR]: "Costo por Impresión de Anuncio en App",
  [IN_APP_AD_IMPR_RATE]: "Tasa de Impresiones de Anuncios en App",
  [TOTAL_IN_APP_AD_IMPR]: "Impresiones Totales de Anuncios en App",
  [COST_PER_TOTAL_IN_APP_AD_IMPR]:
    "Costo por Impresión Total de Anuncios en App",
  [VALUE_PER_TOTAL_IN_APP_AD_IMPR]:
    "Valor por Impresión Total de Anuncios en App",
  [TOTAL_IN_APP_AD_IMPR_VALUE]: "Valor Total de Impresiones de Anuncios en App",
  [LOAN_APPLY]: "Solicitud de Préstamo",
  [COST_PER_LOAN_APPLY]: "Costo por Solicitud de Préstamo",
  [LOAN_APPLY_RATE]: "Tasa de Solicitudes de Préstamo",
  [TOTAL_LOAN_APPLY]: "Solicitudes Totales de Préstamo",
  [COST_PER_TOTAL_LOAN_APPLY]: "Costo por Solicitud Total de Préstamo",
  [LOAN_CREDIT]: "Crédito de Préstamo",
  [COST_PER_LOAN_CREDIT]: "Costo por Crédito de Préstamo",
  [LOAN_CREDIT_RATE]: "Tasa de Créditos de Préstamo",
  [TOTAL_LOAN_CREDIT]: "Créditos Totales de Préstamo",
  [COST_PER_TOTAL_LOAN_CREDIT]: "Costo por Crédito Total de Préstamo",
  [LOAN_DISBURSEMENT]: "Desembolso de Préstamo",
  [COST_PER_LOAN_DISBURSEMENT]: "Costo por Desembolso de Préstamo",
  [LOAN_DISBURSEMENT_RATE]: "Tasa de Desembolsos de Préstamo",
  [TOTAL_LOAN_DISBURSEMENT]: "Desembolsos Totales de Préstamo",
  [COST_PER_TOTAL_LOAN_DISBURSEMENT]: "Costo por Desembolso Total de Préstamo",
  [LOGIN]: "Inicio de Sesión",
  [COST_PER_LOGIN]: "Costo por Inicio de Sesión",
  [LOGIN_RATE]: "Tasa de Inicios de Sesión",
  [TOTAL_LOGIN]: "Inicios de Sesión Totales",
  [COST_PER_TOTAL_LOGIN]: "Costo por Inicio de Sesión Total",
  [RATINGS]: "Calificaciones",
  [GALLERY_VIEW_SCORES]: "Ver Puntajes",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE]: "¿Salir del flujo actual?",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION]:
    "Saldrás de la pantalla actual y abrirás la creación de campaña con el contenido seleccionado. Es posible que se pierdan cambios sin guardar.",
  [GALLERY_SELECTED_COUNT_SINGULAR]: "Seleccionada",
  [GALLERY_SELECTED_COUNT_PLURAL]: "Seleccionadas",
  [GALLERY_FOLDERS_ALL]: "Todas",
  [GALLERY_FOLDERS_CREATE_TITLE]: "Crear Carpeta",
  [GALLERY_FOLDERS_NAME]: "Nombre de la Carpeta",
  [GALLERY_FOLDERS_DUPLICATE]: "Ya existe una Carpeta con este Nombre",
  [GALLERY_FOLDERS_CREATE_SUCCESS]: "Carpeta Creada",
  [GALLERY_FOLDERS_MOVE_SUCCESS]: "Contenido Movido a la Carpeta Seleccionada",
  [GALLERY_FOLDERS_CREATE_ERROR]: "No se pudo crear la Carpeta",
  [GALLERY_FOLDERS_MOVE_ERROR]: "No se pudo mover el Contenido",
  [GALLERY_FOLDERS_BAR_ARIA_LABEL]: "Navegación de carpetas de la galería",
  [GALLERY_FOLDERS_NEW_INLINE]: "Nueva carpeta",
  [GALLERY_UPLOAD_FOLDER_EMPTY]:
    "La carpeta no tiene archivos válidos. Formatos permitidos: {{value}}.",
  [GALLERY_FOLDERS_UNASSIGN_SUCCESS]: "Contenido sacado de la carpeta",
  [GALLERY_FOLDERS_UNASSIGN_ERROR]:
    "No se pudo sacar el contenido de la carpeta",
  [GALLERY_FOLDERS_CREATE_IN]: "Crear carpeta en",
  [GALLERY_FOLDERS_MOVE]: "Mover a Carpeta",
  [GALLERY_FOLDERS_MOVE_TITLE]: "Mover a Carpeta",
  [GALLERY_FOLDERS_MOVE_DESCRIPTION]: "Moviendo desde: {{folder}}",
  [GALLERY_FOLDERS_DESTINATION]: "Carpeta de destino",
  [GALLERY_FOLDERS_SELECT]: "Seleccionar carpeta",
  [GALLERY_FOLDERS_DESTINATION_PATH]: "Se guardará en: {{path}}",
  [GALLERY_FOLDERS_RENAME_TITLE]: "Renombrar Carpeta",
  [GALLERY_FOLDERS_RENAME_SUCCESS]: "Carpeta Renombrada",
  [GALLERY_FOLDERS_RENAME_ERROR]: "No se pudo renombrar la carpeta",
  [GALLERY_FOLDERS_RENAME_ARIA_LABEL]: "Renombrar carpeta {{name}}",
  [GALLERY_FOLDERS_DELETE_ARIA_LABEL]: "Eliminar Carpeta {{name}}",
  [GALLERY_FOLDERS_DELETE_TITLE]: "¿Eliminar Carpeta?",
  [GALLERY_FOLDERS_DELETE_TEXT]:
    'Se eliminará la carpeta "{{name}}". Los elementos que contiene no se eliminarán, solo quedarán fuera de la carpeta.',
  [GALLERY_FOLDERS_DELETE_SUCCESS]: "Carpeta Eliminada",
  [GALLERY_FOLDERS_DELETE_ERROR]: "No se pudo eliminar la carpeta",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER]: "Sacar de la Carpeta",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE]: "¿Sacar de la Carpeta?",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT]:
    "Este elemento dejará de pertenecer a esta carpeta, pero no se eliminará.",
  [GALLERY_FILTER_APPROVAL_STATUS]: "Estado de Aprobación",
  [CAMPAIGNS_FOLDER_EMPTY]: "No hay campañas en esta carpeta",
  [CAMPAIGNS_MOVE_SELECTED]: "Mover seleccionadas",
  [CAMPAIGNS_FOLDERS_MOVE]: "Mover Campañas a Carpeta",
  [CAMPAIGNS_FOLDERS_MOVE_TITLE]: "Mover Campañas a Carpeta",
  [CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION]: "Moviendo campañas desde: {{folder}}",
  [CAMPAIGNS_FOLDERS_MOVE_SUCCESS]:
    "Campañas Movidas a la Carpeta Seleccionada",
  [CAMPAIGNS_FOLDERS_MOVE_ERROR]: "No se pudieron mover las campañas",
  [CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS]: "Campañas sacadas de la carpeta",
  [CAMPAIGNS_FOLDERS_UNASSIGN_ERROR]:
    "No se pudieron sacar las campañas de la carpeta",
  [CAMPAIGNS_SELECT_ROW]: "Seleccionar campaña",
  [COST_PER_RATINGS]: "Costo por Calificación",
  [RATINGS_RATE]: "Tasa de Calificaciones",
  [TOTAL_RATINGS]: "Calificaciones Totales",
  [COST_PER_TOTAL_RATINGS]: "Costo por Calificación Total",
  [VALUE_PER_TOTAL_RATINGS]: "Valor por Calificación Total",
  [TOTAL_RATINGS_VALUE]: "Valor Total de Calificaciones",
  [SEARCH_TIKTOK]: "Búsqueda",
  [COST_PER_SEARCH]: "Costo por Búsqueda",
  [SEARCH_RATE]: "Tasa de Búsquedas",
  [TOTAL_SEARCH]: "Búsquedas Totales",
  [COST_PER_TOTAL_SEARCH]: "Costo por Búsqueda Total",
  [START_TRIAL]: "Iniciar Prueba",
  [COST_PER_START_TRIAL]: "Costo por Inicio de Prueba",
  [START_TRIAL_RATE]: "Tasa de Inicios de Prueba",
  [TOTAL_START_TRIAL]: "Inicios Totales de Prueba",
  [COST_PER_TOTAL_START_TRIAL]: "Costo por Inicio Total de Prueba",
  [SUBSCRIBE]: "Suscripción",
  [COST_PER_SUBSCRIBE]: "Costo por Suscripción",
  [SUBSCRIBE_RATE]: "Tasa de Suscripciones",
  [TOTAL_SUBSCRIBE]: "Suscripciones Totales",
  [COST_PER_TOTAL_SUBSCRIBE]: "Costo por Suscripción Total",
  [VALUE_PER_TOTAL_SUBSCRIBE]: "Valor por Suscripción Total",
  [TOTAL_SUBSCRIBE_VALUE]: "Valor Total de Suscripciones",
  [UNIQUE_CUSTOM_APP_EVENTS]: "Eventos Personalizados Únicos en App",
  [COST_PER_UNIQUE_CUSTOM_APP_EVENT]:
    "Costo por Evento Personalizado Único en App",
  [CUSTOM_APP_EVENT_RATE]: "Tasa de Eventos Personalizados en App",
  [CUSTOM_APP_EVENTS]: "Eventos Personalizados en App",
  [COST_PER_CUSTOM_APP_EVENT]: "Costo por Evento Personalizado en App",
  [VALUE_PER_CUSTOM_APP_EVENT]: "Valor por Evento Personalizado en App",
  [CUSTOM_APP_EVENTS_VALUE]: "Valor de Eventos Personalizados en App",
  [UNIQUE_AD_IMPRESSION_EVENTS]: "Eventos Únicos de Impresión de Anuncio",
  [COST_PER_UNIQUE_AD_IMPRESSION_EVENT]:
    "Costo por Evento Único de Impresión de Anuncio",
  [CUSTOMIZED_AD_IMPRESSION_EVENT_RATE]:
    "Tasa Personalizada de Eventos de Impresión de Anuncio",
  [ADS_IMPRESSION_EVENTS]: "Eventos de Impresión de Anuncios",
  [COST_PRE_AD_IMPRESSION_EVENT]: "Costo por Evento de Impresión de Anuncio",
  [VALUE_PER_AD_IMPRESSION_EVENT]: "Valor por Evento de Impresión de Anuncio",
  [TOTAL_AD_IMPRESSION_EVENTS_VALUE]:
    "Valor Total de Eventos de Impresión de Anuncio",
  [TOTAL_AD_IMPRESSION_ROAS]: "ROAS Total de Impresión de Anuncio",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY0]: "ROAS de Ingresos por Impresión Día 0",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY2]: "ROAS de Ingresos por Impresión Día 2",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY6]: "ROAS de Ingresos por Impresión Día 6",
  [AD_IMPRESSION_AD_REVENUE_DAY0]: "Ingresos por Impresión de Anuncio Día 0",
  [AD_IMPRESSION_AD_REVENUE_DAY2]: "Ingresos por Impresión de Anuncio Día 2",
  [AD_IMPRESSION_AD_REVENUE_DAY6]: "Ingresos por Impresión de Anuncio Día 6",
  [COMPLETE_PAYMENT_ROAS]: "ROAS de Pago Completado",
  [COMPLETE_PAYMENT]: "Pago Completado",
  [COST_PER_COMPLETE_PAYMENT]: "Costo por Pago Completado",
  [COMPLETE_PAYMENT_RATE]: "Tasa de Pagos Completados",
  [VALUE_PER_COMPLETE_PAYMENT]: "Valor por Pago Completado",
  [TOTAL_COMPLETE_PAYMENT_RATE]: "Tasa Total de Pagos Completados",
  [TOTAL_LANDING_PAGE_VIEW]: "Vistas Totales de Página de Destino",
  [COST_PER_LANDING_PAGE_VIEW]: "Costo por Vista de Página de Destino",
  [LANDING_PAGE_VIEW_RATE]: "Tasa de Vistas de Página de Destino",
  [TOTAL_PAGEVIEW]: "Vistas Totales de Página",
  [COST_PER_PAGEVIEW]: "Costo por Vista de Página",
  [PAGEVIEW_RATE]: "Tasa de Vistas de Página",
  [AVG_VALUE_PER_PAGEVIEW]: "Valor Promedio por Vista de Página",
  [TOTAL_VALUE_PER_PAGEVIEW]: "Valor Total por Vista de Página",
  [PAGE_BROWSE_VIEW]: "Vista de Navegación de Página",
  [COST_PER_PAGE_BROWSE_VIEW]: "Costo por Vista de Navegación de Página",
  [PAGE_BROWSE_VIEW_RATE]: "Tasa de Vistas de Navegación de Página",
  [TOTAL_PAGE_BROWSE_VIEW_VALUE]:
    "Valor Total de Vistas de Navegación de Página",
  [VALUE_PER_PAGE_BROWSE_VIEW]: "Valor por Vista de Navegación de Página",
  [BUTTON_CLICK]: "Clic en Botón",
  [COST_PER_BUTTON_CLICK]: "Costo por Clic en Botón",
  [BUTTON_CLICK_RATE]: "Tasa de Clics en Botón",
  [VALUE_PER_BUTTON_CLICK]: "Valor por Clic en Botón",
  [TOTAL_BUTTON_CLICK_VALUE]: "Valor Total de Clics en Botón",
  [ONLINE_CONSULT]: "Consulta en Línea",
  [COST_PER_ONLINE_CONSULT]: "Costo por Consulta en Línea",
  [ONLINE_CONSULT_RATE]: "Tasa de Consultas en Línea",
  [VALUE_PER_ONLINE_CONSULT]: "Valor por Consulta en Línea",
  [TOTAL_ONLINE_CONSULT_VALUE]: "Valor Total de Consultas en Línea",
  [USER_REGISTRATION]: "Registro de Usuario",
  [COST_PER_USER_REGISTRATION]: "Costo por Registro de Usuario",
  [USER_REGISTRATION_RATE]: "Tasa de Registros de Usuario",
  [VALUE_PER_USER_REGISTRATION]: "Valor por Registro de Usuario",
  [TOTAL_USER_REGISTRATION_VALUE]: "Valor Total de Registros de Usuario",
  [PAGE_CONTENT_VIEW_EVENTS]: "Eventos de Visualización de Contenido de Página",
  [COST_PER_PAGE_CONTENT_VIEW_EVENT]:
    "Costo por Evento de Visualización de Contenido",
  [PAGE_CONTENT_VIEW_EVENT_RATE]:
    "Tasa de Visualización de Contenido de Página",
  [VALUE_PER_PAGE_CONTENT_VIEW_EVENT]:
    "Valor por Visualización de Contenido de Página",
  [TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE]:
    "Valor Total de Visualizaciones de Contenido",
  [PRODUCT_DETAILS_PAGE_BROWSE]: "Navegación en Página de Detalles de Producto",
  [COST_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Costo por Navegación en Detalles de Producto",
  [PRODUCT_DETAILS_PAGE_BROWSE_RATE]:
    "Tasa de Navegación en Detalles de Producto",
  [VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Valor por Navegación en Detalles de Producto",
  [TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE]:
    "Valor Total de Navegación en Detalles de Producto",
  [WEB_EVENT_ADD_TO_CART]: "Evento Web Añadir al Carrito",
  [COST_PER_WEB_EVENT_ADD_TO_CART]: "Costo por Evento Web Añadir al Carrito",
  [WEB_EVENT_ADD_TO_CART_RATE]: "Tasa de Eventos Web Añadir al Carrito",
  [VALUE_PER_WEB_EVENT_ADD_TO_CART]: "Valor por Evento Web Añadir al Carrito",
  [TOTAL_WEB_EVENT_ADD_TO_CART_VALUE]:
    "Valor Total de Eventos Web Añadir al Carrito",
  [ON_WEB_ORDER]: "Pedido en Web",
  [COST_PER_ON_WEB_ORDER]: "Costo por Pedido en Web",
  [ON_WEB_ORDER_RATE]: "Tasa de Pedidos en Web",
  [VALUE_PER_ON_WEB_ORDER]: "Valor por Pedido en Web",
  [TOTAL_ON_WEB_ORDER_VALUE]: "Valor Total de Pedidos en Web",
  [INITIATE_CHECKOUT]: "Iniciar Pago",
  [COST_PER_INITIATE_CHECKOUT]: "Costo por Inicio de Pago",
  [INITIATE_CHECKOUT_RATE]: "Tasa de Inicios de Pago",
  [VALUE_PER_INITIATE_CHECKOUT]: "Valor por Inicio de Pago",
  [TOTAL_INITIATE_CHECKOUT_VALUE]: "Valor Total de Inicios de Pago",
  [ADD_BILLING]: "Añadir Datos de Facturación",
  [COST_PER_ADD_BILLING]: "Costo por Añadir Datos de Facturación",
  [ADD_BILLING_RATE]: "Tasa de Añadir Datos de Facturación",
  [VALUE_PER_ADD_BILLING]: "Valor por Añadir Datos de Facturación",
  [TOTAL_ADD_BILLING_VALUE]: "Valor Total de Añadir Datos de Facturación",
  [PAGE_EVENT_SEARCH]: "Búsqueda en Eventos de Página",
  [COST_PER_PAGE_EVENT_SEARCH]: "Costo por Búsqueda en Eventos de Página",
  [PAGE_EVENT_SEARCH_RATE]: "Tasa de Búsquedas en Eventos de Página",
  [VALUE_PER_PAGE_EVENT_SEARCH]: "Valor por Búsqueda en Eventos de Página",
  [TOTAL_PAGE_EVENT_SEARCH_VALUE]:
    "Valor Total de Búsquedas en Eventos de Página",
  [FORM_TIKTOK]: "Formulario",
  [COST_PER_FORM]: "Costo por Formulario",
  [FORM_RATE]: "Tasa de Formularios",
  [VALUE_PER_FORM]: "Valor por Formulario",
  [TOTAL_FORM_VALUE]: "Valor Total de Formularios",
  [DOWNLOAD_START]: "Inicio de Descarga",
  [COST_PER_DOWNLOAD_START]: "Costo por Inicio de Descarga",
  [DOWNLOAD_START_RATE]: "Tasa de Inicios de Descarga",
  [VALUE_PER_DOWNLOAD_START]: "Valor por Inicio de Descarga",
  [TOTAL_DOWNLOAD_START_VALUE]: "Valor Total de Inicios de Descarga",
  [ON_WEB_ADD_TO_WISHLIST]: "Añadir a Lista de Deseos en Web",
  [COST_PER_ON_WEB_ADD_TO_WISHLIST]:
    "Costo por Añadir a Lista de Deseos en Web",
  [ON_WEB_ADD_TO_WISHLIST_PER_CLICK]:
    "Añadir a Lista de Deseos por Clic en Web",
  [VALUE_PER_ON_WEB_ADD_TO_WISHLIST]:
    "Valor por Añadir a Lista de Deseos en Web",
  [TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE]:
    "Valor Total de Añadidos a Lista de Deseos en Web",
  [ON_WEB_SUBSCRIBE]: "Suscribirse en Web",
  [COST_PER_ON_WEB_SUBSCRIBE]: "Costo por Suscripción en Web",
  [ON_WEB_SUBSCRIBE_PER_CLICK]: "Suscripciones por Clic en Web",
  [VALUE_PER_ON_WEB_SUBSCRIBE]: "Valor por Suscripción en Web",
  [TOTAL_ON_WEB_SUBSCRIBE_VALUE]: "Valor Total de Suscripciones en Web",
  [WEBSITE_TOTAL_FIND_LOCATION]:
    "Total de Ubicaciones Encontradas en Sitio Web",
  [WEBSITE_COST_PER_FIND_LOCATION]:
    "Costo por Ubicación Encontrada en Sitio Web",
  [WEBSITE_FIND_LOCATION_RATE]: "Tasa de Ubicaciones Encontradas en Sitio Web",
  [WEBSITE_VALUE_PER_FIND_LOCATION]:
    "Valor por Ubicación Encontrada en Sitio Web",
  [WEBSITE_TOTAL_FIND_LOCATION_VALUE]:
    "Valor Total de Ubicaciones Encontradas en Sitio Web",
  [WEBSITE_TOTAL_SCHEDULE]: "Total de Programaciones en Sitio Web",
  [WEBSITE_COST_PER_SCHEDULE]: "Costo por Programación en Sitio Web",
  [WEBSITE_SCHEDULE_RATE]: "Tasa de Programaciones en Sitio Web",
  [WEBSITE_VALUE_PER_SCHEDULE]: "Valor por Programación en Sitio Web",
  [WEBSITE_TOTAL_SCHEDULE_VALUE]: "Valor Total de Programaciones en Sitio Web",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT]:
    "Total de Productos Personalizados en Sitio Web",
  [WEBSITE_COST_PER_CUSTOMIZE_PRODUCT]:
    "Costo por Producto Personalizado en Sitio Web",
  [WEBSITE_CUSTOMIZE_PRODUCT_RATE]:
    "Tasa de Personalización de Productos en Sitio Web",
  [WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT]:
    "Valor por Producto Personalizado en Sitio Web",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Valor Total de Productos Personalizados en Sitio Web",
  [CUSTOM_PAGE_EVENTS]: "Eventos Personalizados de Página",
  [COST_PER_CUSTOM_PAGE_EVENT]: "Costo por Evento Personalizado de Página",
  [CUSTOM_PAGE_EVENT_RATE]: "Tasa de Eventos Personalizados de Página",
  [VALUE_PER_CUSTOM_PAGE_EVENT]: "Valor por Evento Personalizado de Página",
  [CUSTOM_PAGE_EVENTS_VALUE]: "Valor Total de Eventos Personalizados de Página",
  [ONSITE_PURCHASES_ROAS]: "ROAS de Compras en Sitio",
  [ONSITE_TOTAL_PURCHASE]: "Compras Totales en Sitio",
  [ONSITE_COST_PER_PURCHASE]: "Costo por Compra en Sitio",
  [ONSITE_PURCHASE_RATE]: "Tasa de Compras en Sitio",
  [ONSITE_VALUE_PER_PURCHASE]: "Valor por Compra en Sitio",
  [ONSITE_TOTAL_PURCHASE_VALUE]: "Valor Total de Compras en Sitio",
  [ONSITE_TOTAL_CHECKOUT_INITIATION]: "Inicios Totales de Pago en Sitio",
  [ONSITE_COST_PER_CHECKOUT_INITIATION]: "Costo por Inicio de Pago en Sitio",
  [ONSITE_CHECKOUT_INITIATION_RATE]: "Tasa de Inicios de Pago en Sitio",
  [ONSITE_VALUE_PER_CHECKOUT_INITIATION]: "Valor por Inicio de Pago en Sitio",
  [ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE]:
    "Valor Total de Inicios de Pago en Sitio",
  [ONSITE_TOTAL_ADD_TO_CART]: "Total de Añadidos al Carrito en Sitio",
  [ONSITE_COST_PER_ADD_TO_CART]: "Costo por Añadir al Carrito en Sitio",

  [ONSITE_ADD_TO_CART_RATE]: "Tasa de Añadir al Carrito en Sitio",
  [ONSITE_VALUE_PER_ADD_TO_CART]: "Valor por Añadir al Carrito en Sitio",
  [ONSITE_TOTAL_ADD_TO_CART_VALUE]:
    "Valor Total de Añadidos al Carrito en Sitio",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW]:
    "Vistas Totales de Detalles de Producto en Sitio",
  [ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Costo por Vista de Detalles de Producto en Sitio",
  [ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE]:
    "Tasa de Vistas de Detalles de Producto en Sitio",
  [ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Valor por Vista de Detalles de Producto en Sitio",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE]:
    "Valor Total de Vistas de Detalles de Producto en Sitio",
  [ONSITE_ADD_TO_WISHLIST]: "Añadir a Lista de Deseos en Sitio",
  [COST_PER_ONSITE_ADD_TO_WISHLIST]:
    "Costo por Añadir a Lista de Deseos en Sitio",
  [ONSITE_ADD_TO_WISHLIST_RATE]: "Tasa de Añadir a Lista de Deseos en Sitio",
  [VALUE_PER_ONSITE_ADD_TO_WISHLIST]:
    "Valor por Añadir a Lista de Deseos en Sitio",
  [TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE]:
    "Valor Total de Añadidos a Lista de Deseos en Sitio",
  [ONSITE_ADD_BILLING]: "Añadir Datos de Facturación en Sitio",
  [COST_PER_ONSITE_ADD_BILLING]:
    "Costo por Añadir Datos de Facturación en Sitio",
  [ONSITE_ADD_BILLING_RATE]: "Tasa de Añadir Datos de Facturación en Sitio",
  [VALUE_PER_ONSITE_ADD_BILLING]:
    "Valor por Añadir Datos de Facturación en Sitio",
  [TOTAL_ONSITE_ADD_BILLING_VALUE]:
    "Valor Total de Añadir Datos de Facturación en Sitio",
  [ONSITE_FORM]: "Formulario en Sitio",
  [COST_PER_ONSITE_FORM]: "Costo por Formulario en Sitio",
  [ONSITE_FORM_RATE]: "Tasa de Formularios en Sitio",
  [VALUE_PER_ONSITE_FORM]: "Valor por Formulario en Sitio",
  [TOTAL_ONSITE_FORM_VALUE]: "Valor Total de Formularios en Sitio",
  [ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION]:
    "Envíos de Formulario Filtrados Totales en Sitio",
  [ONSITE_DOWNLOAD_START]: "Inicio de Descarga en Sitio",
  [COST_PER_ONSITE_DOWNLOAD_START]: "Costo por Inicio de Descarga en Sitio",
  [ONSITE_DOWNLOAD_START_RATE]: "Tasa de Inicios de Descarga en Sitio",
  [ONSITE_DESTINATION_VISITS]: "Visitas a Destino en Sitio",
  [COST_PER_ONSITE_DESTINATION_VISIT]: "Costo por Visita a Destino en Sitio",
  [ONSITE_DESTINATION_VISIT_RATE]: "Tasa de Visitas a Destino en Sitio",
  [IX_PAGE_VIEW_COUNT]: "Recuento de Vistas de Página IX",
  [COST_PER_IX_PAGE_VIEW_COUNT]: "Costo por Recuento de Vistas de Página IX",
  [IX_PAGE_VIEW_COUNT_RATE]: "Tasa de Recuento de Vistas de Página IX",
  [IX_BUTTON_CLICK_COUNT]: "Recuento de Clics en Botón IX",
  [COST_PER_IX_BUTTON_CLICK_COUNT]: "Costo por Recuento de Clics en Botón IX",
  [IX_BUTTON_CLICK_COUNT_RATE]: "Tasa de Recuento de Clics en Botón IX",
  [IX_PRODUCT_CLICK_COUNT]: "Recuento de Clics en Producto IX",
  [COST_PER_IX_PRODUCT_CLICK_COUNT]:
    "Costo por Recuento de Clics en Producto IX",
  [IX_PRODUCT_CLICK_COUNT_RATE]: "Tasa de Recuento de Clics en Producto IX",
  [OFFLINE_TOTAL_CRM_EVENTS]: "Eventos CRM Totales Offline",
  [OFFLINE_COST_PER_CRM_EVENT]: "Costo por Evento CRM Offline",
  [OFFLINE_CRM_EVENT_RATE]: "Tasa de Eventos CRM Offline",
  [OFFLINE_VALUE_PER_CRM_EVENT]: "Valor por Evento CRM Offline",
  [OFFLINE_CRM_EVENT_VALUE]: "Valor de Eventos CRM Offline",
  [OFFLINE_SHOPPING_EVENTS]: "Eventos de Compra Offline",
  [COST_PER_OFFLINE_SHOPPING_EVENT]: "Costo por Evento de Compra Offline",
  [OFFLINE_SHOPPING_EVENT_RATE]: "Tasa de Eventos de Compra Offline",
  [VALUE_PER_OFFLINE_SHOPPING_EVENT]: "Valor por Evento de Compra Offline",
  [OFFLINE_SHOPPING_EVENTS_VALUE]: "Valor de Eventos de Compra Offline",
  [OFFLINE_SHOPPING_EVENTS_ROAS]: "ROAS de Eventos de Compra Offline",
  [OFFLINE_CONTACT_EVENTS]: "Eventos de Contacto Offline",
  [COST_PER_OFFLINE_CONTACT_EVENT]: "Costo por Evento de Contacto Offline",
  [OFFLINE_CONTACT_EVENT_RATE]: "Tasa de Eventos de Contacto Offline",
  [VALUE_PER_OFFLINE_CONTACT_EVENT]: "Valor por Evento de Contacto Offline",
  [OFFLINE_CONTACT_EVENTS_VALUE]: "Valor de Eventos de Contacto Offline",
  [OFFLINE_SUBSCRIBE_EVENTS]: "Eventos de Suscripción Offline",
  [COST_PER_OFFLINE_SUBSCRIBE_EVENT]: "Costo por Evento de Suscripción Offline",
  [OFFLINE_SUBSCRIBE_EVENT_RATE]: "Tasa de Eventos de Suscripción Offline",
  [VALUE_PER_OFFLINE_SUBSCRIBE_EVENT]:
    "Valor por Evento de Suscripción Offline",
  [OFFLINE_SUBSCRIBE_EVENTS_VALUE]: "Valor de Eventos de Suscripción Offline",
  [OFFLINE_FORM_EVENTS]: "Eventos de Formulario Offline",
  [COST_PER_OFFLINE_FORM_EVENT]: "Costo por Evento de Formulario Offline",
  [OFFLINE_FORM_EVENT_RATE]: "Tasa de Eventos de Formulario Offline",
  [VALUE_PER_OFFLINE_FORM_EVENT]: "Valor por Evento de Formulario Offline",
  [OFFLINE_FORM_EVENTS_VALUE]: "Valor de Eventos de Formulario Offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS]: "Eventos de Añadir Info de Pago Offline",
  [COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Costo por Evento de Añadir Info de Pago Offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE]:
    "Tasa de Eventos de Añadir Info de Pago Offline",
  [VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Valor por Evento de Añadir Info de Pago Offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE]:
    "Valor de Eventos de Añadir Info de Pago Offline",
  [OFFLINE_ADD_TO_CART_EVENTS]: "Eventos de Añadir al Carrito Offline",
  [COST_PER_OFFLINE_ADD_TO_CART_EVENT]:
    "Costo por Evento de Añadir al Carrito Offline",
  [OFFLINE_ADD_TO_CART_EVENT_RATE]:
    "Tasa de Eventos de Añadir al Carrito Offline",
  [VALUE_PER_OFFLINE_ADD_TO_CART_EVENT]:
    "Valor por Evento de Añadir al Carrito Offline",
  [OFFLINE_ADD_TO_CART_EVENTS_VALUE]:
    "Valor de Eventos de Añadir al Carrito Offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS]:
    "Eventos de Añadir a Lista de Deseos Offline",
  [COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Costo por Evento de Añadir a Lista de Deseos Offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENT_RATE]:
    "Tasa de Eventos de Añadir a Lista de Deseos Offline",
  [VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Valor por Evento de Añadir a Lista de Deseos Offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE]:
    "Valor de Eventos de Añadir a Lista de Deseos Offline",
  [OFFLINE_CLICK_BUTTON_EVENTS]: "Eventos de Clic en Botón Offline",
  [COST_PER_OFFLINE_CLICK_BUTTON_EVENT]:
    "Costo por Evento de Clic en Botón Offline",
  [OFFLINE_CLICK_BUTTON_EVENT_RATE]: "Tasa de Eventos de Clic en Botón Offline",
  [VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT]:
    "Valor por Evento de Clic en Botón Offline",
  [OFFLINE_CLICK_BUTTON_EVENTS_VALUE]:
    "Valor de Eventos de Clic en Botón Offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS]:
    "Eventos de Registro Completo Offline",
  [COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Costo por Evento de Registro Completo Offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE]:
    "Tasa de Eventos de Registro Completo Offline",
  [VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Valor por Evento de Registro Completo Offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE]:
    "Valor de Eventos de Registro Completo Offline",
  [OFFLINE_DOWNLOAD_EVENTS]: "Eventos de Descarga Offline",
  [COST_PER_OFFLINE_DOWNLOAD_EVENT]: "Costo por Evento de Descarga Offline",
  [OFFLINE_DOWNLOAD_EVENT_RATE]: "Tasa de Eventos de Descarga Offline",
  [VALUE_PER_OFFLINE_DOWNLOAD_EVENT]: "Valor por Evento de Descarga Offline",
  [OFFLINE_DOWNLOAD_EVENTS_VALUE]: "Valor de Eventos de Descarga Offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS]: "Eventos de Inicio de Pago Offline",
  [COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Costo por Evento de Inicio de Pago Offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENT_RATE]:
    "Tasa de Eventos de Inicio de Pago Offline",
  [VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Valor por Evento de Inicio de Pago Offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE]:
    "Valor de Eventos de Inicio de Pago Offline",
  [OFFLINE_PLACE_ORDER_EVENTS]: "Eventos de Realizar Pedido Offline",
  [COST_PER_OFFLINE_PLACE_ORDER_EVENT]:
    "Costo por Evento de Realizar Pedido Offline",
  [OFFLINE_PLACE_ORDER_EVENT_RATE]:
    "Tasa de Eventos de Realizar Pedido Offline",
  [VALUE_PER_OFFLINE_PLACE_ORDER_EVENT]:
    "Valor por Evento de Realizar Pedido Offline",
  [OFFLINE_PLACE_ORDER_EVENTS_VALUE]:
    "Valor de Eventos de Realizar Pedido Offline",
  [OFFLINE_SEARCH_EVENTS]: "Eventos de Búsqueda Offline",
  [COST_PER_OFFLINE_SEARCH_EVENT]: "Costo por Evento de Búsqueda Offline",
  [OFFLINE_SEARCH_EVENT_RATE]: "Tasa de Eventos de Búsqueda Offline",
  [VALUE_PER_OFFLINE_SEARCH_EVENT]: "Valor por Evento de Búsqueda Offline",
  [OFFLINE_SEARCH_EVENTS_VALUE]: "Valor de Eventos de Búsqueda Offline",
  [OFFLINE_VIEW_CONTENT_EVENTS]: "Eventos de Ver Contenido Offline",
  [COST_PER_OFFLINE_VIEW_CONTENT_EVENT]:
    "Costo por Evento de Ver Contenido Offline",
  [OFFLINE_VIEW_CONTENT_EVENT_RATE]: "Tasa de Eventos de Ver Contenido Offline",
  [VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT]:
    "Valor por Evento de Ver Contenido Offline",
  [OFFLINE_VIEW_CONTENT_EVENTS_VALUE]:
    "Valor de Eventos de Ver Contenido Offline",
  [OFFLINE_PREFERRED_LEADS]: "Leads Preferidos Offline",
  [OFFLINE_COST_PER_PREFERRED_LEAD]: "Costo por Lead Preferido Offline",
  [OFFLINE_PREFERRED_LEAD_RATE]: "Tasa de Leads Preferidos Offline",
  [OFFLINE_TOTAL_FIND_LOCATION]: "Ubicaciones Encontradas Totales Offline",
  [OFFLINE_COST_PER_FIND_LOCATION]: "Costo por Ubicación Encontrada Offline",
  [OFFLINE_FIND_LOCATION_RATE]: "Tasa de Ubicaciones Encontradas Offline",
  [OFFLINE_VALUE_PER_FIND_LOCATION]: "Valor por Ubicación Encontrada Offline",
  [OFFLINE_TOTAL_FIND_LOCATION_VALUE]:
    "Valor Total de Ubicaciones Encontradas Offline",
  [OFFLINE_TOTAL_SCHEDULE]: "Programaciones Totales Offline",
  [OFFLINE_COST_PER_SCHEDULE]: "Costo por Programación Offline",
  [OFFLINE_SCHEDULE_RATE]: "Tasa de Programaciones Offline",
  [OFFLINE_VALUE_PER_SCHEDULE]: "Valor por Programación Offline",
  [OFFLINE_TOTAL_SCHEDULE_VALUE]: "Valor Total de Programaciones Offline",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT]: "Productos Personalizados Totales Offline",
  [OFFLINE_COST_PER_CUSTOMIZE_PRODUCT]:
    "Costo por Producto Personalizado Offline",
  [OFFLINE_CUSTOMIZE_PRODUCT_RATE]:
    "Tasa de Personalización de Productos Offline",
  [OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT]:
    "Valor por Producto Personalizado Offline",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Valor Total de Productos Personalizados Offline",
  [OFFLINE_TOTAL_CUSTOM_EVENTS]: "Eventos Personalizados Totales Offline",
  [OFFLINE_COST_PER_CUSTOM_EVENT]: "Costo por Evento Personalizado Offline",
  [OFFLINE_CUSTOM_EVENT_RATE]: "Tasa de Eventos Personalizados Offline",
  [OFFLINE_VALUE_PER_CUSTOM_EVENT]: "Valor por Evento Personalizado Offline",
  [OFFLINE_TOTAL_CUSTOM_EVENT_VALUE]:
    "Valor Total de Eventos Personalizados Offline",
  [MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Conversaciones Totales por Mensaje Directo de TikTok",
  [MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Costo por Conversación por Mensaje Directo de TikTok",
  [MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE]:
    "Tasa de Conversación por Mensaje Directo de TikTok",
  [MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Conversaciones Totales por App de Mensajería Instantánea",
  [MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Costo por Conversación por App de Mensajería Instantánea",
  [MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP]:
    "Tasa de Conversación por App de Mensajería Instantánea",
  [ONSITE_SHOPPING_ROAS]: "ROAS de Compras en Sitio",
  [ONSITE_SHOPPING]: "Compra en Sitio",
  [COST_PER_ONSITE_SHOPPING]: "Costo por Compra en Sitio",
  [ONSITE_SHOPPING_RATE]: "Tasa de Compras en Sitio",
  [VALUE_PER_ONSITE_SHOPPING]: "Valor por Compra en Sitio",
  [TOTAL_ONSITE_SHOPPING_VALUE]: "Valor Total de Compras en Sitio",
  [SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION]:
    "Compras Totales por Envío de Pedido en Tienda",
  [SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION]:
    "Ingresos Brutos por Envío de Pedido en Tienda",
  [SHOP_TOTAL_ITEMS_PURCHASED]: "Artículos Totales Comprados en Tienda",
  [ONSITE_INITIATE_CHECKOUT_COUNT]: "Recuento de Inicios de Pago en Sitio",
  [COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Costo por Recuento de Inicios de Pago en Sitio",
  [ONSITE_INITIATE_CHECKOUT_COUNT_RATE]:
    "Tasa de Recuento de Inicios de Pago en Sitio",
  [VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Valor por Recuento de Inicios de Pago en Sitio",
  [TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE]:
    "Valor Total de Recuento de Inicios de Pago en Sitio",
  [ONSITE_ON_WEB_DETAIL]: "Detalles en Web en Sitio",
  [COST_PER_ONSITE_ON_WEB_DETAIL]: "Costo por Detalle en Web en Sitio",
  [ONSITE_ON_WEB_DETAIL_RATE]: "Tasa de Detalles en Web en Sitio",
  [VALUE_PER_ONSITE_ON_WEB_DETAIL]: "Valor por Detalle en Web en Sitio",
  [TOTAL_ONSITE_ON_WEB_DETAIL_VALUE]: "Valor Total de Detalles en Web en Sitio",
  [ONSITE_ON_WEB_CART]: "Carrito en Web en Sitio",
  [COST_PER_ONSITE_ON_WEB_CART]: "Costo por Carrito en Web en Sitio",
  [ONSITE_ON_WEB_CART_RATE]: "Tasa de Carritos en Web en Sitio",
  [VALUE_PER_ONSITE_ON_WEB_CART]: "Valor por Carrito en Web en Sitio",
  [TOTAL_ONSITE_ON_WEB_CART_VALUE]: "Valor Total de Carritos en Web en Sitio",
  [VTA_CONVERSION]: "Conversión VTA",
  [COST_PER_VTA_CONVERSION]: "Costo por Conversión VTA",
  [CTA_CONVERSION]: "Conversión CTA",
  [COST_PER_CTA_CONVERSION]: "Costo por Conversión CTA",
  [ENGAGED_VIEW_THROUGH_CONVERSIONS]:
    "Conversiones por Visualización Comprometida",
  [COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION]:
    "Costo por Conversión por Visualización Comprometida",
  [VTA_APP_INSTALL]: "Instalación de App VTA",
  [COST_PER_VTA_APP_INSTALL]: "Costo por Instalación de App VTA",
  [CTA_APP_INSTALL]: "Instalación de App CTA",
  [COST_PER_CTA_APP_INSTALL]: "Costo por Instalación de App CTA",
  [EVTA_APP_INSTALL]: "Instalación de App EVTA",
  [COST_PER_EVTA_APP_INSTALL]: "Costo por Instalación de App EVTA",
  [VTA_REGISTRATION]: "Registro VTA",
  [COST_PER_VTA_REGISTRATION]: "Costo por Registro VTA",
  [CTA_REGISTRATION]: "Registro CTA",
  [COST_PER_CTA_REGISTRATION]: "Costo por Registro CTA",
  [EVTA_REGISTRATION]: "Registro EVTA",
  [COST_PER_EVTA_REGISTRATION]: "Costo por Registro EVTA",
  [VTA_PURCHASE]: "Compra VTA",
  [COST_PER_VTA_PURCHASE]: "Costo por Compra VTA",
  [CTA_PURCHASE]: "Compra CTA",
  [COST_PER_CTA_PURCHASE]: "Costo por Compra CTA",
  [EVTA_PURCHASE]: "Compra EVTA",
  [COST_PER_EVTA_PURCHASE]: "Costo por Compra EVTA",
  [VTA_COMPLETE_PAYMENT]: "Pago Completado VTA",
  [COST_PER_VTA_PAYMENTS_COMPLETED]: "Costo por Pagos Completados VTA",
  [EVTA_PAYMENTS_COMPLETED]: "Pagos Completados EVTA",
  [COST_PER_EVTA_PAYMENTS_COMPLETED]: "Costo por Pagos Completados EVTA",
  [VTA_COMPLETE_PAYMENT_VALUE]: "Valor de Pago Completado VTA",
  [VTA_COMPLETE_PAYMENT_ROAS]: "ROAS de Pago Completado VTA",

  [SKAN_RESULT]: "Resultado SKAN",
  [SKAN_COST_PER_RESULT]: "Costo por Resultado SKAN",
  [SKAN_RESULT_RATE]: "Tasa de Resultados SKAN",
  [SKAN_CONVERSION]: "Conversión SKAN",
  [SKAN_COST_PER_CONVERSION]: "Costo por Conversión SKAN",
  [SKAN_CONVERSION_RATE]: "Tasa de Conversión SKAN",
  [SKAN_CONVERSION_RATE_V2]: "Tasa de Conversión SKAN V2",
  [SKAN_CLICK_TIME_CONVERSION]: "Conversión en Tiempo de Clic SKAN",
  [SKAN_CLICK_TIME_COST_PER_CONVERSION]:
    "Costo por Conversión en Tiempo de Clic SKAN",
  [SKAN_CLICK_TIME_CONVERSION_RATE]:
    "Tasa de Conversión en Tiempo de Clic SKAN",
  [SKAN_CLICK_TIME_CONVERSION_RATE_V2]:
    "Tasa de Conversión en Tiempo de Clic SKAN V2",
  [SKAN_APP_INSTALL]: "Instalación de App SKAN",
  [SKAN_COST_PER_APP_INSTALL]: "Costo por Instalación de App SKAN",
  [SKAN_APP_INSTALL_WITHHELD]: "Instalación de App SKAN Retenida",
  [SKAN_REGISTRATION]: "Registro SKAN",
  [SKAN_COST_PER_REGISTRATION]: "Costo por Registro SKAN",
  [SKAN_REGISTRATION_RATE]: "Tasa de Registros SKAN",
  [SKAN_TOTAL_REGISTRATION]: "Registros Totales SKAN",
  [SKAN_COST_PER_TOTAL_REGISTRATION]: "Costo por Registro Total SKAN",
  [SKAN_PURCHASE]: "Compra SKAN",
  [SKAN_COST_PER_PURCHASE]: "Costo por Compra SKAN",
  [SKAN_PURCHASE_RATE]: "Tasa de Compras SKAN",
  [SKAN_TOTAL_PURCHASE]: "Compras Totales SKAN",
  [SKAN_COST_PER_TOTAL_PURCHASE]: "Costo por Compra Total SKAN",
  [SKAN_TOTAL_PURCHASE_VALUE]: "Valor Total de Compras SKAN",
  [SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS]:
    "ROAS de Pago Activo Repetitivo Total SKAN",
  [SKAN_ADD_TO_CART]: "Añadir al Carrito SKAN",
  [SKAN_COST_PER_ADD_TO_CART]: "Costo por Añadir al Carrito SKAN",
  [SKAN_ADD_TO_CART_RATE]: "Tasa de Añadir al Carrito SKAN",
  [SKAN_TOTAL_ADD_TO_CART]: "Añadidos Totales al Carrito SKAN",
  [SKAN_COST_PER_TOTAL_ADD_TO_CART]: "Costo por Añadir Total al Carrito SKAN",
  [SKAN_TOTAL_ADD_TO_CART_VALUE]: "Valor Total de Añadidos al Carrito SKAN",
  [SKAN_CHECKOUT]: "Finalizar Compra SKAN",
  [SKAN_COST_PER_CHECKOUT]: "Costo por Finalizar Compra SKAN",
  [SKAN_CHECKOUT_RATE]: "Tasa de Finalización de Compra SKAN",
  [SKAN_TOTAL_CHECKOUT]: "Finalizaciones Totales de Compra SKAN",
  [SKAN_COST_PER_TOTAL_CHECKOUT]: "Costo por Finalización Total de Compra SKAN",
  [SKAN_TOTAL_CHECKOUT_VALUE]: "Valor Total de Finalizaciones de Compra SKAN",
  [SKAN_VIEW_CONTENT]: "Ver Contenido SKAN",
  [SKAN_COST_PER_VIEW_CONTENT]: "Costo por Ver Contenido SKAN",
  [SKAN_VIEW_CONTENT_RATE]: "Tasa de Visualización de Contenido SKAN",
  [SKAN_TOTAL_VIEW_CONTENT]: "Visualizaciones Totales de Contenido SKAN",
  [SKAN_COST_PER_TOTAL_VIEW_CONTENT]:
    "Costo por Visualización Total de Contenido SKAN",
  [SKAN_TOTAL_VIEW_CONTENT_VALUE]:
    "Valor Total de Visualizaciones de Contenido SKAN",
  [SKAN_ADD_PAYMENT_INFO]: "Añadir Información de Pago SKAN",
  [SKAN_COST_PER_ADD_PAYMENT_INFO]: "Costo por Añadir Información de Pago SKAN",
  [SKAN_ADD_PAYMENT_INFO_RATE]: "Tasa de Añadir Información de Pago SKAN",
  [SKAN_TOTAL_ADD_PAYMENT_INFO]: "Total de Añadir Información de Pago SKAN",
  [SKAN_COST_TOTAL_ADD_PAYMENT_INFO]:
    "Costo Total de Añadir Información de Pago SKAN",
  [SKAN_ADD_TO_WISHLIST]: "Añadir a Lista de Deseos SKAN",
  [SKAN_COST_PER_ADD_TO_WISHLIST]: "Costo por Añadir a Lista de Deseos SKAN",
  [SKAN_ADD_TO_WISHLIST_RATE]: "Tasa de Añadir a Lista de Deseos SKAN",
  [SKAN_TOTAL_ADD_TO_WISHLIST]: "Total de Añadidos a Lista de Deseos SKAN",
  [SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST]:
    "Costo por Total de Añadidos a Lista de Deseos SKAN",
  [SKAN_TOTAL_ADD_TO_WISHLIST_VALUE]:
    "Valor Total de Añadidos a Lista de Deseos SKAN",
  [SKAN_LAUNCH_APP]: "Iniciar App SKAN",
  [SKAN_COST_PER_LAUNCH_APP]: "Costo por Iniciar App SKAN",
  [SKAN_LAUNCH_APP_RATE]: "Tasa de Inicio de App SKAN",
  [SKAN_TOTAL_LAUNCH_APP]: "Inicios Totales de App SKAN",
  [SKAN_COST_PER_TOTAL_LAUNCH_APP]: "Costo por Inicio Total de App SKAN",
  [SKAN_COMPLETE_TUTORIAL]: "Completar Tutorial SKAN",
  [SKAN_COST_PER_COMPLETE_TUTORIAL]: "Costo por Completar Tutorial SKAN",
  [SKAN_COMPLETE_TUTORIAL_RATE]: "Tasa de Completar Tutorial SKAN",
  [SKAN_TOTAL_COMPLETE_TUTORIAL]: "Tutoriales Completados Totales SKAN",
  [SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL]:
    "Costo por Tutorial Completado Total SKAN",
  [SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE]:
    "Valor Total de Tutoriales Completados SKAN",
  [SKAN_CREATE_GROUP]: "Crear Grupo SKAN",
  [SKAN_COST_PER_CREATE_GROUP]: "Costo por Crear Grupo SKAN",
  [SKAN_CREATE_GROUP_RATE]: "Tasa de Creación de Grupo SKAN",
  [SKAN_TOTAL_CREATE_GROUP]: "Grupos Creados Totales SKAN",
  [SKAN_COST_PER_TOTAL_CREATE_GROUP]: "Costo por Creación Total de Grupo SKAN",
  [SKAN_TOTAL_CREATE_GROUP_VALUE]: "Valor Total de Grupos Creados SKAN",
  [SKAN_JOIN_GROUP]: "Unirse a Grupo SKAN",
  [SKAN_COST_PER_JOIN_GROUP]: "Costo por Unirse a Grupo SKAN",
  [SKAN_JOIN_GROUP_RATE]: "Tasa de Unión a Grupo SKAN",
  [SKAN_TOTAL_JOIN_GROUP]: "Uniones Totales a Grupo SKAN",
  [SKAN_COST_PER_TOTAL_JOIN_GROUP]: "Costo por Unión Total a Grupo SKAN",
  [SKAN_TOTAL_JOIN_GROUP_VALUE]: "Valor Total de Uniones a Grupo SKAN",
  [SKAN_CREATE_GAMEROLE]: "Crear Rol de Juego SKAN",
  [SKAN_COST_PER_CREATE_GAMEROLE]: "Costo por Crear Rol de Juego SKAN",
  [SKAN_CREATE_GAMEROLE_RATE]: "Tasa de Creación de Rol de Juego SKAN",
  [SKAN_TOTAL_CREATE_GAMEROLE]: "Roles de Juego Creados Totales SKAN",
  [SKAN_COST_PER_TOTAL_CREATE_GAMEROLE]:
    "Costo por Creación Total de Rol de Juego SKAN",
  [SKAN_TOTAL_CREATE_GAMEROLE_VALUE]:
    "Valor Total de Roles de Juego Creados SKAN",
  [SKAN_SPEND_CREDITS]: "Gastar Créditos SKAN",
  [SKAN_COST_PER_SPEND_CREDITS]: "Costo por Gastar Créditos SKAN",
  [SKAN_SPEND_CREDITS_RATE]: "Tasa de Gasto de Créditos SKAN",
  [SKAN_TOTAL_SPEND_CREDITS]: "Créditos Gastados Totales SKAN",
  [SKAN_COST_PER_TOTAL_SPEND_CREDITS]: "Costo por Gasto Total de Créditos SKAN",
  [SKAN_TOTAL_SPEND_CREDITS_VALUE]: "Valor Total de Créditos Gastados SKAN",
  [SKAN_ACHIEVE_LEVEL]: "Alcanzar Nivel SKAN",
  [SKAN_COST_PER_ACHIEVE_LEVEL]: "Costo por Alcanzar Nivel SKAN",
  [SKAN_ACHIEVE_LEVEL_RATE]: "Tasa de Alcanzar Nivel SKAN",
  [SKAN_TOTAL_ACHIEVE_LEVEL]: "Niveles Alcanzados Totales SKAN",
  [SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL]: "Costo por Nivel Alcanzado Total SKAN",
  [SKAN_TOTAL_ACHIEVE_LEVEL_VALUE]: "Valor Total de Niveles Alcanzados SKAN",
  [SKAN_UNLOCK_ACHIEVEMENT]: "Desbloquear Logro SKAN",
  [SKAN_COST_PER_UNLOCK_ACHIEVEMENT]: "Costo por Desbloquear Logro SKAN",
  [SKAN_UNLOCK_ACHIEVEMENT_RATE]: "Tasa de Desbloqueo de Logro SKAN",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT]: "Logros Desbloqueados Totales SKAN",
  [SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]:
    "Costo por Logro Desbloqueado Total SKAN",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE]:
    "Valor Total de Logros Desbloqueados SKAN",
  [SKAN_SALES_LEAD]: "Lead de Ventas SKAN",
  [SKAN_COST_PER_SALES_LEAD]: "Costo por Lead de Ventas SKAN",
  [SKAN_SALES_LEAD_RATE]: "Tasa de Leads de Ventas SKAN",
  [SKAN_TOTAL_SALES_LEAD]: "Leads de Ventas Totales SKAN",
  [SKAN_COST_PER_TOTAL_SALES_LEAD]: "Costo por Lead de Ventas Total SKAN",
  [SKAN_TOTAL_SALES_LEAD_VALUE]: "Valor Total de Leads de Ventas SKAN",
  [SKAN_IN_APP_AD_CLICK]: "Clic en Anuncio en App SKAN",
  [SKAN_COST_PER_IN_APP_AD_CLICK]: "Costo por Clic en Anuncio en App SKAN",
  [SKAN_IN_APP_AD_CLICK_RATE]: "Tasa de Clics en Anuncios en App SKAN",
  [SKAN_TOTAL_IN_APP_AD_CLICK]: "Clics Totales en Anuncios en App SKAN",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK]:
    "Costo por Clic Total en Anuncios en App SKAN",
  [SKAN_TOTAL_IN_APP_AD_CLICK_VALUE]:
    "Valor Total de Clics en Anuncios en App SKAN",
  [SKAN_IN_APP_AD_IMPR]: "Impresión de Anuncio en App SKAN",
  [SKAN_COST_PER_IN_APP_AD_IMPR]: "Costo por Impresión de Anuncio en App SKAN",
  [SKAN_IN_APP_AD_IMPR_RATE]: "Tasa de Impresiones de Anuncios en App SKAN",
  [SKAN_TOTAL_IN_APP_AD_IMPR]: "Impresiones Totales de Anuncios en App SKAN",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR]:
    "Costo por Impresión Total de Anuncios en App SKAN",
  [SKAN_TOTAL_IN_APP_AD_IMPR_VALUE]:
    "Valor Total de Impresiones de Anuncios en App SKAN",
  [SKAN_LOAN_APPLY]: "Solicitar Préstamo SKAN",
  [SKAN_COST_PER_LOAN_APPLY]: "Costo por Solicitar Préstamo SKAN",
  [SKAN_LOAN_APPLY_RATE]: "Tasa de Solicitudes de Préstamo SKAN",
  [SKAN_TOTAL_LOAN_APPLY]: "Solicitudes Totales de Préstamo SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_APPLY]:
    "Costo por Solicitud Total de Préstamo SKAN",
  [SKAN_LOAN_CREDIT]: "Crédito de Préstamo SKAN",
  [SKAN_COST_PER_LOAN_CREDIT]: "Costo por Crédito de Préstamo SKAN",
  [SKAN_LOAN_CREDIT_RATE]: "Tasa de Créditos de Préstamo SKAN",
  [SKAN_TOTAL_LOAN_CREDIT]: "Créditos Totales de Préstamo SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_CREDIT]: "Costo por Crédito Total de Préstamo SKAN",
  [SKAN_LOAN_DISBURSEMENT]: "Desembolso de Préstamo SKAN",
  [SKAN_COST_PER_LOAN_DISBURSEMENT]: "Costo por Desembolso de Préstamo SKAN",
  [SKAN_LOAN_DISBURSEMENT_RATE]: "Tasa de Desembolsos de Préstamo SKAN",
  [SKAN_TOTAL_LOAN_DISBURSEMENT]: "Desembolsos Totales de Préstamo SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT]:
    "Costo por Desembolso Total de Préstamo SKAN",
  [SKAN_LOGIN]: "Iniciar Sesión SKAN",
  [SKAN_COST_PER_LOGIN]: "Costo por Iniciar Sesión SKAN",
  [SKAN_LOGIN_RATE]: "Tasa de Inicios de Sesión SKAN",
  [SKAN_TOTAL_LOGIN]: "Inicios de Sesión Totales SKAN",
  [SKAN_COST_PER_TOTAL_LOGIN]: "Costo por Inicio de Sesión Total SKAN",
  [SKAN_RATINGS]: "Calificaciones SKAN",
  [SKAN_COST_PER_RATINGS]: "Costo por Calificación SKAN",
  [SKAN_RATINGS_RATE]: "Tasa de Calificaciones SKAN",
  [SKAN_TOTAL_RATINGS]: "Calificaciones Totales SKAN",
  [SKAN_COST_PER_TOTAL_RATINGS]: "Costo por Calificación Total SKAN",
  [SKAN_TOTAL_RATINGS_VALUE]: "Valor Total de Calificaciones SKAN",
  [SKAN_SEARCH]: "Búsqueda SKAN",
  [SKAN_COST_PER_SEARCH]: "Costo por Búsqueda SKAN",
  [SKAN_SEARCH_RATE]: "Tasa de Búsquedas SKAN",
  [SKAN_TOTAL_SEARCH]: "Búsquedas Totales SKAN",
  [SKAN_COST_PER_TOTAL_SEARCH]: "Costo por Búsqueda Total SKAN",
  [SKAN_START_TRIAL]: "Iniciar Prueba SKAN",
  [SKAN_COST_PER_START_TRIAL]: "Costo por Inicio de Prueba SKAN",
  [SKAN_START_TRIAL_RATE]: "Tasa de Inicios de Prueba SKAN",
  [SKAN_TOTAL_START_TRIAL]: "Inicios Totales de Prueba SKAN",
  [SKAN_COST_PER_TOTAL_START_TRIAL]: "Costo por Inicio Total de Prueba SKAN",
  [SKAN_SUBSCRIBE]: "Suscripción SKAN",
  [SKAN_COST_PER_SUBSCRIBE]: "Costo por Suscripción SKAN",
  [SKAN_SUBSCRIBE_RATE]: "Tasa de Suscripciones SKAN",
  [SKAN_TOTAL_SUBSCRIBE]: "Suscripciones Totales SKAN",
  [SKAN_COST_PER_TOTAL_SUBSCRIBE]: "Costo por Suscripción Total SKAN",
  [SKAN_TOTAL_SUBSCRIBE_VALUE]: "Valor Total de Suscripciones SKAN",
  [SKAN_VTA_CONVERSION]: "Conversión VTA SKAN",
  [SKAN_COST_PER_VTA_CONVERSION]: "Costo por Conversión VTA SKAN",
  [SKAN_VTA_APP_INSTALL]: "Instalación de App VTA SKAN",
  [SKAN_COST_PER_VTA_APP_INSTALL]: "Costo por Instalación de App VTA SKAN",
  [SKAN_VTA_REGISTRATION]: "Registro VTA SKAN",
  [SKAN_COST_PER_VTA_REGISTRATION]: "Costo por Registro VTA SKAN",
  [SKAN_VTA_PURCHASE]: "Compra VTA SKAN",
  [SKAN_COST_PER_VTA_PURCHASE]: "Costo por Compra VTA SKAN",
  [SKAN_CTA_CONVERSION]: "Conversión CTA SKAN",
  [SKAN_COST_PER_CTA_CONVERSION]: "Costo por Conversión CTA SKAN",
  [SKAN_CTA_APP_INSTALL]: "Instalación de App CTA SKAN",
  [SKAN_COST_PER_CTA_APP_INSTALL]: "Costo por Instalación de App CTA SKAN",
  [SKAN_CTA_REGISTRATION]: "Registro CTA SKAN",
  [SKAN_COST_PER_CTA_REGISTRATION]: "Costo por Registro CTA SKAN",
  [SKAN_CTA_PURCHASE]: "Compra CTA SKAN",
  [SKAN_COST_PER_CTA_PURCHASE]: "Costo por Compra CTA SKAN",

  // OVERVIEW REPORT
  [OVERVIEW_REPORT_GENERATING_SUMMARY]: "Generando resumen...",
  [OVERVIEW_REPORT_SUMMARY_NOT_GENERATED]: "No se pudo generar el resumen",

  // GENERATE PDF
  [REPORT_DATE_GENERATED]:
    "Fecha de Generación: {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [REPORT_GENERATED_BY_BUZZLY_AI]: "Reporte Generado por {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP]: "Generado por {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP_ARIA]:
    "Contenido generado por la IA de {{NAME_BUSINESS}}. Si lo editas, la etiqueta desaparece.",
  [DOWNLOADING_PDF]: "Descargando PDF...",
  [PDF_DOWNLOADED_SUCCESSFULLY]: "PDF descargado exitosamente",
  [OPTIMIZATION]: "Optimización",

  [CHAT_QUESTION_1]: "¿El ROAS mejoró frente a la semana pasada?",
  [CHAT_QUESTION_2]:
    "¿Cómo se compara el CPA promedio con el periodo anterior?",
  [CHAT_QUESTION_3]:
    "¿El presupuesto está bien distribuido entre plataformas o grupos?",
  [CHAT_QUESTION_4]: "¿Qué audiencias rinden mejor en las campañas actuales?",
  [CHAT_QUESTION_5]: "¿Hay grupos de anuncios para pausar o escalar?",
  [CHAT_QUESTION_6]:
    "¿Qué cambios estratégicos sugieren para mejorar el rendimiento?",
  [CHAT_QUESTION_7]: "¿Cómo ha cambiado el CPA recientemente?",
  [CHAT_QUESTION_8]: "¿Cuál es el próximo paso en la optimización de campañas?",
  [CHAT_QUESTION_9]: "¿Hay alertas o tendencias negativas que debamos revisar?",

  //RESERVATION STATUS
  [RESERVATION_STATUS_1]: "La predicción se ha realizado correctamente.",
  [RESERVATION_STATUS_2]: "La predicción todavía se está generando.",
  [RESERVATION_STATUS_3]:
    "No se puede llegar a la audiencia. El alcance es demasiado amplio o el presupuesto es demasiado alto.",
  [RESERVATION_STATUS_4]:
    "Los ajustes de la predicción no son válidos (por ejemplo, la duración).",
  [RESERVATION_STATUS_5]: "Valor de targeting_spec no válido.",
  [RESERVATION_STATUS_6]:
    "El presupuesto o la puja para el alcance especificado son demasiado bajos.",
  [RESERVATION_STATUS_7]:
    "La longitud del conjunto de anuncios es demasiado corta.",
  [RESERVATION_STATUS_8]:
    "La longitud del conjunto de anuncios es demasiado larga.",
  [RESERVATION_STATUS_9]:
    "Falta demasiado tiempo para la fecha de finalización del conjunto de anuncios.",
  [RESERVATION_STATUS_10]: "No se ha especificado el límite de frecuencia.",
  [RESERVATION_STATUS_11]:
    "No se admite la ubicación de anuncios especificada (por ejemplo, combinar la publicación de anuncios en el lateral derecho y en el feed).",
  [RESERVATION_STATUS_12]:
    "Existe algún problema con las fechas (de inicio o finalización) del conjunto de anuncios: la hora de inicio ya ha pasado, las horas especificadas no incluyen la medianoche o las fechas no abarcan un día completo. La fecha de finalización ya ha pasado, supera los 90 días de distancia respecto a la inicial o no termina después de las 6:00.",
  [RESERVATION_STATUS_13]: "No se admite todavía el país objetivo.",
  [RESERVATION_STATUS_14]:
    "Las fechas del conjunto de anuncios incluyen días no disponibles.",
  [RESERVATION_STATUS_15]:
    "No hay suficiente inventario, por lo que no se pueden realizar reservas. Consulta 'Reservar predicciones' para obtener más información.",
  [RESERVATION_STATUS_16]:
    "No se ha conseguido obtener el alcance mínimo necesario para la cuenta. Consulta 'Obtener restricciones de la cuenta'.",
  [RESERVATION_STATUS_17]:
    "El alcance real disponible para esta predicción es menor que el alcance mínimo del país objetivo (normalmente es de 200 000 personas para la mayoría de los países).",
  [RESERVATION_STATUS_18]:
    "La programación de franjas del día que se ha facilitado no es válida.",
  [RESERVATION_STATUS_19]: "No se puede alcanzar el CPM objetivo.",
  [RESERVATION_STATUS_20]:
    "El límite de frecuencia es demasiado bajo para la entrega combinada.",
  [RESERVATION_STATUS_21]:
    "El inventario de anuncios ha cambiado lo suficiente para que la predicción sea inexacta.",
  [RESERVATION_STATUS_23]:
    "El intervalo del límite de frecuencia no se admite en el país objetivo.",
  [RESERVATION_STATUS_24]:
    "El conjunto de anuncios del estudio de lift de la exclusión del grupo de cuentas o campañas no es coherente con la predicción de reserva.",
  [RESERVATION_STATUS_25]:
    "El límite de frecuencia no puede superar el número de días que tu campaña está en circulación.",
  [RESERVATION_STATUS_26]:
    "La audiencia seleccionada está vacía y no se puede usar.",
  [RESERVATION_STATUS_27]:
    "No se permite realizar modificaciones en tu campaña en circulación.",
  [RESERVATION_STATUS_28]:
    "No se puede modificar la campaña en circulación creada con un pedido de inserción.",
  [RESERVATION_STATUS_29]:
    "No se puede modificar la campaña en circulación debido a restricciones de tiempo.",
  [RESERVATION_STATUS_30]:
    "Para editar un conjunto de anuncios de reserva que se encuentra en circulación, elige un presupuesto mayor que el gasto actual.",
  [RESERVATION_STATUS_31]:
    "El estudio de lift del grupo de cuentas o campañas empieza una vez iniciada la campaña.",
  [RESERVATION_STATUS_32]:
    "El estudio de lift del grupo de cuentas o campañas termina antes de que finalice la campaña.",
  [RESERVATION_STATUS_35]:
    "No se puede establecer la hora de inicio de la campaña de reserva en el pasado.",
  [RESERVATION_STATUS_36]:
    "Asegúrate de que la duración del conjunto de anuncios de reserva sea superior a un día y que la hora de inicio o finalización de la campaña sea válida.",
  [RESERVATION_STATUS_37]:
    "Audience Network no admite el objetivo con el tipo de compra de reserva.",
  [RESERVATION_STATUS_39]:
    "La combinación de ubicaciones seleccionada no se puede usar cuando se compra con reserva.",
  [RESERVATION_STATUS_40]:
    "Determinadas versiones de sistemas operativos para móviles no se pueden segmentar con el tipo de compra de reserva.",
  [RESERVATION_STATUS_41]:
    "Los amigos de las conexiones no se pueden segmentar con el tipo de compra de reserva.",
  [RESERVATION_STATUS_42]:
    "Las campañas de reserva no se pueden publicar cuando Audience Network es la única ubicación seleccionada. Selecciona la ubicación de Audience Network con el feed de Facebook o el feed de Instagram como ubicaciones adicionales.",
  [RESERVATION_STATUS_44]: "La reserva no admite Facebook Stories.",
  [RESERVATION_STATUS_45]:
    "Para usar Facebook Stories como ubicación, selecciona también los feeds de Facebook o Instagram Stories.",
  [RESERVATION_STATUS_50]:
    "La combinación de ubicaciones seleccionada no se puede usar cuando se compra con reserva. En el caso de la compra de pedidos de inserción de reserva, asegúrate de que el objetivo sea 'Reproducciones de vídeo'. De lo contrario, para usar la función in-stream de Facebook, selecciona la ubicación de los feeds de Facebook.",
  [RESERVATION_STATUS_53]:
    "La ubicación de vídeo in-stream solo está disponible para las audiencias de Estados Unidos, Reino Unido, Australia, Nueva Zelanda, Irlanda, Tailandia, México, Perú, Francia, Alemania, Argentina, Colombia, España, Chile, Ecuador, República Dominicana, Guatemala, Bolivia, Honduras, El Salvador, Noruega, Suecia, Países Bajos, Bélgica, Polonia, Portugal, Dinamarca, India, Malasia, Filipinas, Indonesia y Vietnam. Para continuar, edita la audiencia para incluir solo a personas de esos países.",
  [RESERVATION_STATUS_60]:
    "Para usar Facebook Marketplace, selecciona la ubicación de los feeds de Facebook.",
  [RESERVATION_STATUS_66]:
    "La ubicación de la columna derecha de Facebook no se puede combinar con otras ubicaciones.",
  [RESERVATION_STATUS_69]:
    "Si quieres que el anuncio se muestre en la sección Explorar de Instagram, también tendrás que seleccionar el feed de Instagram como ubicación.",
  [RESERVATION_STATUS_100]:
    "Error del sistema, no es culpa del usuario. Reintentar.",

  // MODAL WELCOME
  [MODAL_WELCOME_TITLE]: "¡Bienvenido a {{NAME_BUSINESS}}!",
  [MODAL_WELCOME_SUBTITLE]: "Tu suscripción ha sido activada correctamente",
  [MODAL_WELCOME_PLAN_NAME]: "Plan {{planName}}",
  [MODAL_WELCOME_BUTTON]: "Configura tu Marca",

  // MODAL REDIRECT BRAND SETUP
  [MODAL_REDIRECT_BRAND_SETUP_TITLE]: "Bienvenido a {{NAME_BUSINESS}}",
  [MODAL_REDIRECT_BRAND_SETUP_SUBTITLE]:
    "Para empezar a utilizar {{NAME_BUSINESS}} debes configurar tu marca",
  [MODAL_REDIRECT_BRAND_SETUP_BUTTON]: "Configurar tu Marca",

  // MODAL SUCCESS BRAND SETUP
  [MODAL_SUCCESS_BRAND_SETUP_TITLE]: "¡Tu Marca Está Lista!",
  [MODAL_SUCCESS_BRAND_SETUP_SUBTITLE]: "Elige tu próximo paso",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE]: "Lanzar Campañas",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION]:
    "Crea campañas publicitarias con IA, incluyendo textos, creatividades y segmentación para mejores resultados.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE]: "Generar Anuncios",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION]:
    "Genera vídeos e imágenes con IA, listos para publicar y adaptados a tu marca.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE]: "Publicar en Redes",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION]:
    "Publica tus posts orgánicos en múltiples plataformas al instante o déjalos programados para más tarde.",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_START]: "Comenzar",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER]: "Lo haré más tarde",

  // ONBOARDING CHECKLIST
  [ONBOARDING_CHECKLIST_HEADER_TITLE]: "Primeros Pasos",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE]: "Configura tu marca",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE]: "Crea tus primeros creativos",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE]: "Publica en tus redes sociales",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE]: "Crea tu primera campaña",
  [ONBOARDING_CHECKLIST_FOOTER_COMPLETED]:
    "Excelente trabajo, ya puedes comenzar a crear",
  [ONBOARDING_CHECKLIST_SUBTITLE]:
    "Completa estos pasos para desbloquear todo el potencial.",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION]:
    "Agrega el nombre, logo y colores de tu marca para personalizar tu experiencia.",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION]:
    "Diseña creativos y copys listos para publicar.",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION]:
    "Conecta tus redes sociales y publica tu contenido.",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION]:
    "Lanza y administra tu primera campaña publicitaria.",
  [ONBOARDING_CHECKLIST_PROGRESS_COMPLETED]:
    "{{completed}}/{{total}} Completados",
  [ONBOARDING_CHECKLIST_SKIP_GUIDE]: "Omitir Guía",

  // CONNECTION PROGRESS MODAL
  [CONNECTING_TO_PLATFORM]: "Como Conectar Mi Cuenta De {{platform}}",
  [CONNECTING_TO_PLATFORM_DESCRIPTION]:
    "Asegúrate de tener permisos de administrador en tu cuenta de {{platform}} antes de continuar",

  // MODAL CANCEL SUBSCRIPTION
  [MODAL_CANCEL_SUBSCRIPTION_TITLE]: "Cancelar Suscripción",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE]:
    "Tu suscripción seguirá activa hasta el final del período de facturación actual. Hasta entonces conservas acceso a todas las funciones y a los créditos de tu plan.",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING]:
    "⚠️ Al finalizar el período, se <bold>eliminarán</bold> de forma <bold>permanente</bold> tus campañas y todo el contenido de tu galería.",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON]: "Cancelar Plan",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE]:
    "Motivo de cancelación (mínimo {{minChars}} caracteres):",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER]:
    "Por favor, explica brevemente el motivo de la cancelación de tu suscripción...",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT]:
    "✓ Cumple el mínimo requerido",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS]:
    "{{charCount}}/{{minChars}} caracteres mínimos",
  [MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE]:
    "Todas las campañas se eliminarán de manera permanente en {{NAME_BUSINESS}} y en las plataformas publicitarias conectadas. El contenido de la galería también se borrará. Esta acción es irreversible y no podrás recuperarlas. ¿Deseas continuar?",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER]:
    "Oferta por tiempo limitado",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE]:
    "⚠️ Esto eliminará todo tu trabajo",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO]:
    "A los 15 días hábiles de finalizado el período se eliminarán de forma <boldDanger>permanente</boldDanger> e <boldDanger>irrecuperable</boldDanger>:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS]:
    "Tus campañas gestionadas desde {{NAME_BUSINESS}}, que quedarán pausadas",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY]:
    "Todo el contenido de tu galería: imágenes, videos, carouseles, animaciones, plantillas etc.",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA]:
    "Tu data, configuraciones de marca, audiencias y reportes",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS]:
    "Las conexiones API con Meta, Google, TikTok y LinkedIn",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO]:
    "Antes de <boldDanger>cancelar</boldDanger>, te recomendamos:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY]:
    "Descargar el contenido de tu galería, una vez descargado es tuyo de forma permanente",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS]:
    "Exportar los reportes que quieras conservar",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS]:
    "Duplicar en la plataforma publicitaria las campañas que quieras mantener activas",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY]:
    "Esta acción no se puede deshacer. {{NAME_BUSINESS}} no conserva copia de respaldo.",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT]:
    "Para confirmar, escribe <boldDanger>ELIMINAR</boldDanger> abajo",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD]: "ELIMINAR",
  [BUTTON_KEEP_MY_ACCOUNT]: "Conservar mi cuenta",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO]:
    "Mantén tu contenido y campañas activas con esta oferta de tiempo limitado.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE]:
    "A partir del {{date,short}}, pagarás {{price}} USD / mes y recibirás {{credits}} créditos.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE]:
    "Pagarás {{price}} USD / mes y recibirás {{credits}} créditos.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS]:
    "Además, recibirás de inmediato 50 créditos gratis.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON]: "Tomar Oferta",
  [MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS]:
    "Oferta Redimida",
  [BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS]: "Cancelar plan y eliminar todo",

  // CANCELLATION REASONS
  [CANCELLATION_REASON_SELECT_LABEL]: "Cuéntanos por qué cancelas",
  [CANCELLATION_REASON_TOO_EXPENSIVE]: "Es demasiado caro",
  [CANCELLATION_REASON_NOT_FREQUENT_USE]: "No lo uso con suficiente frecuencia",
  [CANCELLATION_REASON_BETTER_ALTERNATIVE]: "Encontré una mejor alternativa",
  [CANCELLATION_REASON_TECHNICAL_ISSUES]: "Problemas técnicos o de rendimiento",
  [CANCELLATION_REASON_NOT_MEET_NEEDS]: "No cumple mis necesidades",
  [CANCELLATION_REASON_DIFFICULT_TO_USE]: "Dificultad para usar la plataforma",
  [CANCELLATION_REASON_SITUATION_CHANGED]:
    "Mi situación personal/profesional cambió",
  [CANCELLATION_REASON_TEMPORARY_NEED]: "Solo lo necesitaba temporalmente",
  [CANCELLATION_REASON_SECURITY_CONCERNS]:
    "Preocupaciones de seguridad o privacidad",
  [CANCELLATION_REASON_OTHER]: "Otro motivo",

  // FILTERS GALLERY
  [FILTERS_GALLERY_IMAGE]: "Imágenes",
  [FILTERS_GALLERY_VIDEO]: "Videos",
  [FILTERS_GALLERY_CAROUSEL]: "Carruseles",
  [GALLERY_CREATE_CAROUSEL]: "Crear Carrusel",
  [FILTERS_GALLERY_FEED]: "Feed de Instagram",
  [FILTERS_GALLERY_HORIZONTAL]: "Horizontal",
  [FILTERS_GALLERY_VERTICAL]: "Vertical",
  [FILTERS_GALLERY_SQUARE]: "Cuadrado",
  [FILTERS_GALLERY_TODAY]: "Hoy",
  [FILTERS_GALLERY_WEEK]: "Esta semana",
  [FILTERS_GALLERY_MONTH]: "Este mes",
  [FILTERS_GALLERY_YEAR]: "Este año",
  [FILTERS_GALLERY_RESET_FILTERS]: "Resetear filtros",
  [FILTERS_GALLERY_RESULTS_COUNTER]: "{{count}} de {{total}} elementos",

  // GALLERY CONTENT SOURCES
  [GALLERY_SOURCE_MY_CONTENT]: "Mi Contenido",
  [GALLERY_SOURCE_GOOGLE]: "Importar desde Google",
  [GALLERY_SOURCE_AD_ACCOUNT]: "Importar desde Cuenta Publicitaria",
  [GALLERY_SOURCE_AD_ACCOUNT_EMPTY]:
    "Selecciona una plataforma y cuenta publicitaria para ver creativos",
  [GALLERY_SOURCE_GOOGLE_DRIVE]: "Importar de Google Drive",
  [GALLERY_SOURCE_SOCIAL_POSTS]: "Importar desde Redes Sociales",
  [GALLERY_SOCIAL_POSTS_DESCRIPTION]:
    "Selecciona el post que quieras utilizar. Algunos posts pueden no aparecer si fueron publicados recientemente",
  [GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP]:
    "Este post es un video. No se pudo cargar la vista previa en video, por eso se muestra la miniatura. Si lo usas, el anuncio se publicará igual como video.",
  [GALLERY_SOURCE_CANVA]: "Importar desde Canva",
  [GALLERY_SELECT_SOURCE]: "Contenido",
  [GALLERY_ASSETS_TITLE]: "Recursos",
  [GALLERY_ASSETS_RENAME_TITLE]: "Renombrar Asset",
  [GALLERY_ASSETS_RENAME_SUCCESS]: "Asset Renombrado",
  [GALLERY_ASSETS_RENAME_ERROR]: "No se pudo renombrar el Asset",
  [GALLERY_ASSETS_RENAME_ARIA_LABEL]: "Renombrar Asset {{name}}",
  [GALLERY_ASSETS_NAME_LABEL]: "Nombre del Archivo",
  [GALLERY_UPLOADING_ASSETS]: "Subiendo Assets",
  [GALLERY_GOOGLE_NOT_CONNECTED]:
    "Conecta tu cuenta de Google para acceder a recursos de Google",
  [GALLERY_META_NOT_CONNECTED]:
    "Conecta tu cuenta de Meta para acceder a posts sociales",
  [GALLERY_CONTENT_TYPE]: "Tipo de Contenido",
  [GALLERY_DIMENSIONS]: "Dimensiones",
  [GALLERY_DATE_RANGE]: "Rango de fechas",
  [GALLERY_TITLE_DIMENSIONS]: "{{width}} × {{height}}",

  // CAROUSEL IMAGES MANAGER
  [CAROUSEL_IMAGES_MANAGER_TITLE]: "Imágenes ({{count}}/35)",
  [CAROUSEL_IMAGES_MANAGER_DELETE_ALL]: "Eliminar Todas",
  [CAROUSEL_IMAGES_MANAGER_ADD_IMAGE]: "Agregar Imagen",
  [CAROUSEL_IMAGES_MANAGER_NO_IMAGES]: "No hay imágenes agregadas",
  [CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP]:
    "Dimensiones obligatorias: 1200x628, 640x640 o 720x1280 píxeles",

  // MODAL SHARE INSTAGRAM
  [MODAL_SHARE_TITLE]: "Compartir Contenido",
  [MODAL_SHARE_SELECT_PLATFORMS_TITLE]:
    "Selecciona plataformas en las que quieres publicar",
  [ALERT_SHARE_INSTAGRAM_ERROR]: "Error al Publicar Este Contenido",
  [ALERT_SHARE_SUCCESS]: "Contenido Publicado Exitosamente",
  [ALERT_SHARE_SCHEDULED_SUCCESS]: "La publicación se agendó correctamente",
  [BUTTON_SHARE_MEDIA]: "Publicar",
  [BUTTON_SHARE_LOADING]: "Publicando...",
  [BUTTON_SCHEDULE_MEDIA]: "Agendar Publicación",
  [BUTTON_SCHEDULING_MEDIA]: "Agendando...",
  [BUTTON_PUBLISH_NOW]: "Publicar Ahora",
  [SCHEDULE_DATE_MIN_FUTURE_ERROR]:
    "La fecha debe ser al menos 5 minutos en el futuro",
  [SUGGESTED_PUBLISH_SCHEDULE_LOADING]: "Sugeriendo Horario",
  [DESCRIPTION_INSTAGRAM_LABEL]: "Descripción",
  [DESCRIPTION_INSTAGRAM_GENERATING]: "Generando Descripción",
  [TYPE_CONTENT_INSTAGRAM_LABEL]: "Tipo de Contenido",
  [INSTAGRAM_COLLABORATORS_LABEL]: "Colaboradores",
  [INSTAGRAM_COLLABORATORS_PLACEHOLDER]: "Agregar colaboradores (máx 3)",
  [INSTAGRAM_COLLABORATORS_HELPER]:
    "Ingresa nombres de usuario de Instagram sin @",
  [IMAGE_NO_CONTENT_TO_SHOW]: "No hay contenido para mostrar",
  [NO_SUPPORTED_FILE]: "Tipo de archivo no soportado",

  // MODAL CANVA IMAGE CONFIG
  [MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL]: "Tipo de Contenido",

  // MODAL CREATE WITH IA
  [MODAL_CREATE_WITH_IA_TITLE]: "Genera Creativos",
  [MODAL_CREATE_WITH_IA_SUBTITLE]: "Configuración",
  [MODAL_CREATE_WITH_IA_GENERATED_CREATIVES]: "Creativos Generados",
  [MODAL_CREATE_WITH_IA_UPLOAD_IMAGE]: "Subir Imagen",
  [MODAL_CREATE_WITH_IA_ADD_URL]: "Agregar URL",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY]:
    "No hay recursos adicionales. Configúralos en Brand Setup.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE]:
    "Selecciona los assets adicionales que quieres usar como referencia para generar tus creativos.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA]:
    "Incluir recurso {{number}} en la generación",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA]:
    "Vista previa de imagen del recurso {{number}}",
  [MODAL_CREATE_WITH_IA_EXTRACT_URL]: "Importar desde la URL",
  [MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT]:
    "También puedes importar imágenes cuando añadas una URL arriba.",
  [MODAL_CREATE_WITH_IA_DESCRIPTION]: "Descripción",

  [MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC]: "Configuración Básica",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE]:
    "Imagenes de Referencia",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS]:
    "Fotos del producto",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES]:
    "Imágenes del servicio",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS]:
    "Sube imágenes de tu producto para que la IA las use como referencias visuales.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES]:
    "Sube imágenes que representen tu servicio para que la IA las use como referencias visuales.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL]:
    "Opcional. La IA usa este enlace para los detalles del producto, como el nombre, el precio y las ofertas. Funciona con o sin fotos.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD]:
    "Opcional. Añade fotos subiéndolas, desde la galería o desde la URL del producto. Funcionan con o sin enlace.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL]:
    "Opcional. La IA usa este enlace para los detalles del servicio, como el nombre, el precio y las ofertas. Funciona con o sin imágenes.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD]:
    "Opcional. Añade imágenes subiéndolas, desde la galería o desde la URL del servicio. Funcionan con o sin enlace.",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE]: "Anuncio de Referencia",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP]: "Estilo",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL]: "Subir",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH]: "Competidores",
  [MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP]: "Recursos",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION]:
    "Sube un anuncio de referencia para copiar su layout. Los colores de la marca se aplican sobre esa estructura.",
  [MODAL_CREATE_WITH_IA_REFERENCE_VIDEO_FORCES_CUSTOM]:
    "Con un video de referencia seleccionado, el tipo de video debe ser personalizado",
  [MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION]:
    "¿Deseas generar el contenido sin subir imágenes de referencia del producto?",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE]:
    "Logo requerido para videos",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION]:
    "Sube el logo de tu marca para generar el video.",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION]:
    "Opcional: sube el logo para incluirlo en la pieza publicitaria final. Sin logo, el cierre usará headline y CTA.",
  [MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE]:
    "Límite de {{maxImages}} imágenes de referencia",
  [CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT]: "Fotos de Producto",
  [CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT]:
    "Sube una o más fotos de tu producto que cumplan con los requisitos para un mejor resultado.",
  [CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP]:
    "Añade imágenes del mismo producto, en el mismo color y modelo, desde distintos ángulos y perspectivas para mejores resultados.",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE]: "URL del Servicio",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION]:
    "Agrega imágenes y contenido fácilmente con la URL de tu servicio.",
  [CONFIGURATION_PANEL_WEBSITE_URL_TITLE]: "URL del Producto",
  [CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION]:
    "Agrega imágenes y contenido fácilmente con la URL de tu producto.",
  [CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES]:
    "Asegúrate de que las imágenes cumplan con los requisitos para un mejor resultado.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE]:
    "Requisitos de la imagen para mejores resultados",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO]:
    "Para que el resultado sea de mayor calidad y fidelidad, asegúrate de que tu imagen de referencia cumpla con estos requisitos:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION]:
    "Productos con textos pequeños y/o fondos difusos pueden tener distorsiones imperceptibles.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY]:
    "Calidad alta: Usa imágenes nítidas y claras, sin desenfoque ni pixelación",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT]:
    "Producto prominente: El producto debe ser el elemento principal (ocupar al menos el 60-70% del espacio)",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE]:
    "Tamaño adecuado: El producto debe verse grande y claro, no pequeño o difícil de distinguir",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL]:
    "Una sola variante: Todas las fotos deben ser del mismo producto, color y modelo; cambia solo el ángulo o el encuadre, no el color ni la versión.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE]:
    "Producto completo: El producto debe estar completamente visible, sin partes cortadas o fuera del encuadre",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING]:
    "Bien iluminado: Buena iluminación que permita ver todos los detalles del producto",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE]:
    "Sin personas: para que se enfoque en representar bien el producto y no a las personas",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE]: "Evita:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST]:
    "Productos muy pequeños, cortados, borrosos, o donde el producto no sea el protagonista",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE]: "Ejemplos:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE]:
    "Evita usar imágenes que contengan personas.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS]: "Instrucciones",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_THEME]: "Temática",
  [MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL]:
    "Este campo es opcional y puedes usarlo para añadir instrucciones de generación. Si no se proporcionan, usaremos tu configuración de marca.",
  [MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL]:
    "Describe la temática de tu video. Por ejemplo: Quiero promocionar el descuento de hasta el 20% para este verano.",

  [MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE]: "Listo para crear",
  [MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE]:
    "Configura tus preferencias en el panel lateral",

  // MODAL IMAGE EDIT
  [MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE]: "Edita tu Imagen",
  [MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION]:
    "Describe los cambios que deseas realizar en tu imagen. Puedes pedir mejoras, cambios de estilo, ajustes de color y más.",
  [MODAL_IMAGE_EDIT_TITLE]: "Edita tu Imagen",
  [MODAL_IMAGE_EDIT_SUBTITLE]: "Edita tus imágenes con IA",
  [MODAL_IMAGE_EDIT_PROCESSING_MESSAGE]: "Pensando",
  [MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64]:
    "No se pudo convertir la imagen a base64",
  [MODAL_IMAGE_EDIT_ERROR_EDITING]: "Error al editar la imagen",
  [MODAL_IMAGE_EDIT_ERROR_PROCESSING]: "No se pudo procesar la imagen",
  [MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER]: "Describe los cambios que deseas...",
  [MODAL_IMAGE_EDIT_EDITING_LABEL]: "Editando",
  [MODAL_IMAGE_EDIT_LOADING_LABEL]: "Cargando",
  [MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND]: "Imagen no encontrada",
  [MODAL_IMAGE_EDIT_START_CREATING]: "Comienza a crear tu primera imagen",
  [MODAL_IMAGE_EDIT_IMAGE_ALT]: "Imagen a editar",
  [MODAL_IMAGE_EDIT_VERSION_FORMAT]: "V{{version}} - IMAGEN",
  [MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL]: "Imagen Original",
  [MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL]: "Imagen Editada v{{version}}",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE]: "¿Cómo quieres guardar esta imagen?",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "Puedes reemplazar la imagen original o crear una nueva versión con tus cambios.",
  [MODAL_IMAGE_EDIT_REPLACE_BUTTON]: "Reemplazar",

  // MODAL VIDEO EDITOR
  [MODAL_VIDEO_EDITOR_TITLE]: "Editor de Video",
  [MODAL_VIDEO_EDITOR_EDIT_VIDEO]: "Editar video",
  [MODAL_VIDEO_EDITOR_ADD_VIDEO]: "Agregar video",
  [MODAL_VIDEO_EDITOR_ADD_IMAGE]: "Agregar imagen",
  [MODAL_VIDEO_EDITOR_ADD_AUDIO]: "Agregar audio",
  [MODAL_VIDEO_EDITOR_ADD_SUBTITLES]: "Agregar subtítulos",
  [MODAL_VIDEO_EDITOR_EXPORTING]: "Exportando video...",
  [MODAL_VIDEO_EDITOR_SAVE_ERROR]: "No se pudo guardar el video editado",
  [MODAL_VIDEO_EDITOR_SPLIT_HINT]:
    "Doble clic en una pista para dividir en el playhead",
  [MODAL_VIDEO_EDITOR_ARIA_LABEL]: "Editor de Video",
  [MODAL_VIDEO_EDITOR_TRACK_VIDEO]: "Arrastrar o subir contenido",
  [MODAL_VIDEO_EDITOR_TRACK_IMAGE]: "Agregar elementos",
  [MODAL_VIDEO_EDITOR_TRACK_AUDIO]: "Agregar audio",
  [MODAL_VIDEO_EDITOR_CLIP_DURATION]: "{{count}} s",
  [MODAL_VIDEO_EDITOR_SPLIT_CLIP]: "Dividir",
  [MODAL_VIDEO_EDITOR_CLIP_ACTIONS]: "Acciones del clip",
  [MODAL_VIDEO_EDITOR_BRAND]: "Video",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE]: "Tu video aparecerá aquí",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT]: "Importa un archivo para comenzar",
  [MODAL_VIDEO_EDITOR_DROP_HINT]: "o arrastra y suelta el contenido",
  [MODAL_VIDEO_EDITOR_PLAY]: "Reproducir",
  [MODAL_VIDEO_EDITOR_PAUSE]: "Pausar",
  [MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME]: "Tu proyecto de video",
  [MODAL_VIDEO_EDITOR_TIMELINE_ARIA]: "Línea de tiempo del editor de video",
  [MODAL_VIDEO_EDITOR_TIMELINE_RESIZE]: "Redimensionar línea de tiempo",
  [MODAL_VIDEO_EDITOR_INSERT_START]: "Inicio",
  [MODAL_VIDEO_EDITOR_INSERT_END]: "Final",
  [MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES]: "Analizando subtítulos…",
  [MODAL_VIDEO_EDITOR_TRACK_SUBTITLE]: "Subtítulos",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ARIA]: "Subtítulos",
  [MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE]: "Desactivar",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE]: "Activar",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE]: "¿Cómo quieres guardar este video?",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION]:
    "Puedes reemplazar el video original o crear una nueva versión con tus cambios.",
  [MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR]:
    "No se pudieron analizar los subtítulos",
  [MODAL_VIDEO_EDITOR_PROPERTIES_TITLE]: "Propiedades de Capa",
  [MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY]:
    "Selecciona una Capa en la Línea de Tiempo",
  [MODAL_VIDEO_EDITOR_PROPERTIES_NAME]: "Nombre",
  [MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME]: "Volumen",
  [MODAL_VIDEO_EDITOR_PROPERTIES_MIXED]: "Mixto",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT]: "{{count}} Capas",
  [MODAL_VIDEO_EDITOR_PROPERTIES_POSITION]: "Posición",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SIZE]: "Tamaño",
  [MODAL_VIDEO_EDITOR_PROPERTIES_X]: "X",
  [MODAL_VIDEO_EDITOR_PROPERTIES_Y]: "Y",
  [MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH]: "Ancho",
  [MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT]: "Alto",
  [MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Guardar como Nueva",
  [MODAL_IMAGE_EDIT_WORK_MODE_LABEL]: "Elige cómo trabajar",
  [MODAL_IMAGE_EDIT_GENERATIVE_TITLE]: "Edición con AI",
  [MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION]: "Transforma la imagen completa",
  [MODAL_IMAGE_EDIT_LAYERS_TITLE]: "Edición Manual",
  [MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION]: "Mueve cada elemento por separado",
  [MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW]: "NUEVO",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE]: "Edición Manual",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION]:
    "Analiza la imagen para separar cada elemento y editarlo de forma independiente.",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE]: "No se pudo analizar",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION]:
    "No se pudieron separar las capas de esta imagen. Inténtalo de nuevo.",
  [MODAL_IMAGE_EDIT_LAYERS_ADD]: "Añadir",
  [MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE]: "Elementos del Diseño",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE]: "Imagen",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT]: "Objeto",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT]: "Texto",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO]: "Logo",
  [MODAL_IMAGE_EDIT_LAYERS_BACKGROUND]: "Fondo",
  [MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME]: "Capa {{index}}",
  [MODAL_IMAGE_EDIT_LAYERS_ANALYZING]: "Analizando capas",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE]: "Advertencia",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION]:
    "Si realizas una edición con AI, se perderá la separación por elementos de esta imagen porque se generará una nueva.",
  [MODAL_IMAGE_EDIT_CLOSE_TITLE]: "¿Cerrar el editor?",
  [MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION]:
    "Si cierras ahora, los cambios no guardados se perderán.",
  [ANALYZE_LAYERS_EDIT_TEXT_TITLE]: "Detección de Capas de Texto",
  [ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION]:
    "Editar texto puede generar capas inconsistentes o hacer que se pierdan decoraciones. Puedes volver a agregar manualmente los elementos faltantes si es necesario.",
  [ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON]: "Activar",
  [ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON]: "Desactivar",

  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE]: "Imagen",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO]: "Video",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA]: "Video (Beta)",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL]: "Carrusel",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA]: "Realista",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO]: "Producto",
  [MODAL_CREATE_WITH_IA_LANGUAGE_ES]: "Español",
  [MODAL_CREATE_WITH_IA_LANGUAGE_EN]: "English",
  [MODAL_CREATE_WITH_IA_LANGUAGE_FR]: "Français",
  [MODAL_CREATE_WITH_IA_LANGUAGE_DE]: "Deutsch",
  [MODAL_CREATE_WITH_IA_LANGUAGE_IT]: "Italiano",
  [MODAL_CREATE_WITH_IA_DIMENSION_SQUARE]: "Cuadrada (1200x1200)",
  [MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL]: "Horizontal (1920x1080)",
  [MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL]: "Vertical (1080x1920)",
  [MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE]: "Formato",
  [MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE]: "Tipo",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE]: "Tipo de Video",
  [MODAL_CREATE_WITH_IA_LABEL_LANGUAGE]: "Idioma",
  [MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES]: "Con Subtítulos",
  [MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK]: "Marca de Agua IA",
  [MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION]:
    "Algunas plataformas exigen por regulación incluir una marca de agua en videos generados con IA para identificarlos.",
  [MODAL_SUBTITLE_OPTIONS_TITLE]: "Personaliza tus Subtítulos",
  [MODAL_SUBTITLE_OPTIONS_PERSONALIZE]: "Personalizar Subtítulos",
  [MODAL_SUBTITLE_OPTIONS_FONT_FAMILY]: "Fuente",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE]: "Estilo de Tipografía",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL]: "Normal",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD]: "Negrita",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC]: "Cursiva",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC]: "Negrita y Cursiva",
  [MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR]: "Color del Texto",
  [MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT]: "Resaltar Palabras",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR]: "Color del Resaltado",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE]: "Efecto del Resaltado",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD]: "Por Palabra",
  [MODAL_SUBTITLE_OPTIONS_PRESET]: "Preset",
  [MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT]: "Highlight",
  [MODAL_SUBTITLE_OPTIONS_PRESET_BOXED]: "Cajas",
  [MODAL_SUBTITLE_OPTIONS_BOX_COLOR]: "Color de la Caja",
  [MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND]: "Fondo Detrás del Texto",
  [MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR]: "Color del Fondo",
  [MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL]:
    "Así se vería el subtítulo de mi video",
  [MODAL_CREATE_WITH_IA_LABEL_ACCENT]: "Acento",
  [MODAL_CREATE_WITH_IA_LABEL_LOCATION]: "Localización",
  [MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS]: "Dimensiones",
  [MODAL_CREATE_WITH_IA_LABEL_PLATFORM]: "Optimizar Para",
  [MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT]: "Neutral",
  [MODAL_CREATE_WITH_IA_LABEL_CAROUSEL]: "Carrusel",
  [MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES]: "Número de Imágenes",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES]: "Ej: 3",
  [MODAL_CREATE_WITH_IA_PLATFORM_META]: "Meta",
  [MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK]: "TikTok",
  [MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE]: "Google",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION]:
    "Genera imágenes de modelos femeninas usando mis sandalias en una playa tropical...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO]:
    "Genera un video mostrando mi producto en acción, destacando características clave y beneficios...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL]: "URL de imagen...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL]: "URL del sitio web...",
  [MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE]:
    "Para generar imágenes, debes subir imagenes de tu producto",
  [MODAL_CREATE_WITH_IA_URLS_ADDED]: "URLs agregadas {{count}}",
  [MODAL_CREATE_WITH_IA_IMAGES_COUNT]: "Imágenes del Producto {{count}}",
  [MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT]:
    "Imágenes del servicio {{count}}",
  [MODAL_CREATE_WITH_IA_GENERATING]: "Generando...",
  [MODAL_CREATE_WITH_IA_GENERATE_WITH_AI]: "Generar",
  [MODAL_CREATE_WITH_IA_IMAGES_CREATED]: "{{count}} creativos creados",
  [MODAL_CREATE_WITH_IA_GENERATING_IMAGES]: "Generando creativos...",
  [MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE]: "Puedes salir de la página",
  [`${MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS}_one`]:
    "{{count}} generación en curso",
  [MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS]:
    "{{count}} generaciones en curso",
  [MODAL_CREATE_WITH_IA_GENERATION_FAILED]: "No pudimos generar este contenido",
  [MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS]:
    "Tienes {{count}} generaciones en curso. Espera a que termine alguna para generar otra.",
  [MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE]: "Error cargando imagen",
  [MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT]: "Imagen generada {{index}}",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY]: "Guardar Contenido ({{count}})",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT]: "Guardar Contenido",
  [MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY]: "Guardando...",
  [MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY]: "Contenido Guardado",
  [MODAL_CREATE_WITH_IA_DOWNLOAD_ALL]: "Descargar Todas",
  [MODAL_CREATE_WITH_IA_MORE_VARIATIONS]: "Más Variaciones",
  [MODAL_CREATE_WITH_IA_ARIA_LABEL]: "Modal de creación con IA",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED]: "Configuración Avanzada",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL]: "Formato",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO]: "Formato de video",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER]:
    "Usa uno de estos formatos populares.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE]: "Sin Formato",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP]: "Mensaje de Whatsapp",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY]: "Historia de IG",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY]: "Disculpa",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS]: "Noticia",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST]: "Post de Texto",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD]: "Hilo de Comentarios",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE]: "Captura de Reseña",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE]:
    "Búsqueda y Autocompletar",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST]: "Checklist",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE]: "Captura de Email",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST]:
    "Una opinión en formato de publicación: avatar, nombre y texto. La voz de una persona, no la de un logo.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD]:
    "Una pregunta y varias respuestas apiladas, como en un foro. La prueba social de alguien que no te conoce.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE]:
    "Estrellas, nombre y texto. La prueba social más potente y también la más vigilada por reguladores.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE]:
    "Una barra de búsqueda con la pregunta que tu cliente ya se hace. Tu marca es la respuesta.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST]:
    "Una lista con casillas marcadas y una sin marcar: tu producto es lo que falta.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE]:
    "Una bandeja de entrada con un asunto que engancha. Se lee en medio segundo.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR]:
    "No se pudieron cargar los formatos.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION]: "Explicación",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO]:
    "Para este formato recomendamos las dimensiones {{aspectRatio}}. Cámbialas haciendo click",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION]: "aquí",
  // VIDEO TYPES
  [VIDEO_TYPE_UNBOXING]: "Unboxing",
  [VIDEO_TYPE_PRODUCT_SHOWCASE]: "Product showcase",
  [VIDEO_TYPE_UGC]: "UGC",
  [VIDEO_TYPE_LIFESTYLE]: "Lifestyle",
  [VIDEO_TYPE_TESTIMONIALS_REVIEWS]: "Testimoniales / reseñas",
  [VIDEO_TYPE_TESTIMONIAL]: "Testimonial",
  [VIDEO_TYPE_EMOTIONAL_STORYTELLING]: "Storytelling emocional",
  [VIDEO_TYPE_CASE_STUDY]: "Case study",
  [VIDEO_TYPE_CORPORATE]: "Corporativo",
  [VIDEO_TYPE_SURREAL]: "Surrealista",
  [VIDEO_TYPE_MEGA_CREATIVE]: "Mega Creativo",
  [VIDEO_TYPE_OTHER]: "Personalizado",

  // MAP TRADUCCIONES
  [MAP_TRADUCCIONES_STATUS]: "Estado",
  [MAP_TRADUCCIONES_PLATFORM]: "Plataforma",
  [MAP_TRADUCCIONES_TITLES]: "Títulos",
  [MAP_TRADUCCIONES_CTA]: "Llamada a la acción",
  [MAP_TRADUCCIONES_CTAS]: "Llamadas a la acción",
  [MAP_TRADUCCIONES_CTA_ID]: "ID de llamada a la acción",
  [MAP_TRADUCCIONES_CALL_TO_ACTION]: "CTA",
  [MAP_TRADUCCIONES_CALL_TO_ACTIONS]: "CTAs",
  [MAP_TRADUCCIONES_CALL_TO_ACTION_ID]: "ID de CTA",
  [CAMPAIGN_SYNCING_STATUS]: "Sincronizando",
  [MAP_TRADUCCIONES_MEDIA_URLS]: "URLs de medios",
  [MAP_TRADUCCIONES_MEDIA_DATA]: "datos de medios",
  [MAP_TRADUCCIONES_MUSIC_URL]: "URL de música",
  [MAP_TRADUCCIONES_IS_CAROUSEL]: "es carrusel",
  [MAP_TRADUCCIONES_OBJECTIVE]: "objetivo",
  [MAP_TRADUCCIONES_INTEGRATION_ID]: "ID de integración",
  [MAP_TRADUCCIONES_AD_ACCOUNT_ID]: "ID de cuenta publicitaria",
  [MAP_TRADUCCIONES_PAGE_ID]: "ID de página",
  [MAP_TRADUCCIONES_INSTAGRAM_ID]: "ID de Instagram",
  [MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET]: "usar presupuesto de campaña",
  [MAP_TRADUCCIONES_TYPE_BUDGET]: "tipo de presupuesto",
  [MAP_TRADUCCIONES_BUDGET]: "presupuesto",
  [MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN]: "es campaña de catálogo",
  [MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER]: "número de WhatsApp Business",
  [MAP_TRADUCCIONES_MESSAGE_TEMPLATE]: "plantilla de mensaje",
  [MAP_TRADUCCIONES_INSTANT_FORM]: "Formulario Instantáneo",
  [MAP_TRADUCCIONES_TRACKING_ID]: "ID de seguimiento",
  [MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID]:
    "ID de evento de seguimiento personalizado",
  [MAP_TRADUCCIONES_CATALOG_ID]: "ID de catálogo",
  [MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN]: "es campaña de iOS 14",
  [MAP_TRADUCCIONES_APP_ID]: "ID de app",
  [MAP_TRADUCCIONES_BUYING_TYPE]: "tipo de compra",
  [MAP_TRADUCCIONES_DESCRIPTIONS]: "descripciones",
  [MAP_TRADUCCIONES_ADS]: "anuncios",
  [MAP_TRADUCCIONES_KEYWORDS]: "palabras clave",
  [MAP_TRADUCCIONES_KEYWORDS_NEGATIVE]: "palabras clave negativas",
  [MAP_TRADUCCIONES_START_DATE]: "fecha de inicio",
  [MAP_TRADUCCIONES_END_DATE]: "fecha de fin",
  [MAP_TRADUCCIONES_AGE_RANGE]: "rango de edad",
  [MAP_TRADUCCIONES_GENDERS]: "géneros",
  [MAP_TRADUCCIONES_LOCATIONS]: "ubicaciones",
  [MAP_TRADUCCIONES_INTERESTS]: "intereses",
  [MAP_TRADUCCIONES_BEHAVIORS]: "comportamientos",
  [MAP_TRADUCCIONES_CUSTOM_AUDIENCES]: "audiencias personalizadas",
  [MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES]:
    "audiencias personalizadas excluidas",
  [MAP_TRADUCCIONES_BID_GOAL]: "objetivo de puja",
  [MAP_TRADUCCIONES_OPTIMIZATION_GOAL]: "Optimizar Para",
  [MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID]: "ID de identidad TikTok",
  [MAP_TRADUCCIONES_TYPE]: "tipo",
  [MAP_TRADUCCIONES_ID]: "ID",
  [MAP_TRADUCCIONES_DESTINATION_URL]: "URL de destino",
  [MAP_TRADUCCIONES_BUSINESS_NAME]: "nombre del negocio",
  [MAP_TRADUCCIONES_LOGO_URLS]: "URLs de logotipos",
  [MAP_TRADUCCIONES_IMAGE_URLS]: "URLs de imágenes",
  [MAP_TRADUCCIONES_VIDEO_URLS]: "URLs de videos",
  [MAP_TRADUCCIONES_LONG_HEADLINES]: "titulares largos",
  [MAP_TRADUCCIONES_SEARCH_THEMES]: "temas de búsqueda",

  // MAP TRADUCCIONES STATUS
  [MAP_STATUS_ACTIVE]: "Activo",
  [MAP_STATUS_DEACTIVATED]: "Desactivado",

  [BUTTON_OPTIMIZE_CAMPAIGN]: "Optimizaciones",
  [BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE]:
    "¿Qué recomendaciones me das para mejorar mi campaña?",

  [ADD_CHANGES]: "Se añadirá:",
  [UPDATE_CHANGES]: "Se actualizará:",
  [REMOVE_CHANGES]: "Se eliminará:",

  [OVERVIEW_HOME_STATISTICS]: "Resumen",
  [KPI_TARGET_CPA_ABOVE_PLATFORM]:
    "<bold>{{platform}}</bold> tiene un CPA de {{cpa}} {{currency}} en los últimos 14 días, por encima del objetivo de {{targetCpa}} {{currency}}.",
  [KPI_TARGET_CPA_ALERTS_TITLE]: "Advertencia",
  [OVERVIEW_HOME_STATISTICS_VIEW_MORE]: "Ver más",
  [STATISTICS_ONLY_BUZZLY_CAMPAIGNS]:
    "Solo se contabilizan las campañas creadas desde {{NAME_BUSINESS}}. Las campañas creadas por fuera de la plataforma no serán tenidas en cuenta.",
  [VIEW_SPEND_BREAKDOWN]: "Ver por Plataforma",
  [LIST_TABLE_CAMPAIGNS_TITLE]: "Tus Campañas",
  [DASHBOARD_METRICS_DELAY_WARNING]:
    "Puede haber un retraso de hasta 3 horas entre las métricas que ves en los gestores de anuncios de cada plataforma y las que se muestran en {{NAME_BUSINESS}}.",
  [DASHBOARD_METRICS_DELAY_DISMISS]: "No mostrar de nuevo",
  [TRIAL_CONTENT_CTA_MESSAGE]:
    "¿Te gustó este contenido? Úsalo en cualquiera de estas opciones:",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM]: "Compartir en Instagram",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK]: "Compartir en TikTok",
  [TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS]: "Más Opciones",
  [MODAL_CREATE_WITH_IA_GALLERY_BUTTON]: "Abrir Galería",
  [MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY]: "Ver Competidores",
  [COMPETITOR_SCOPE_MENU_ITEM]: "Competidores",
  [COMPETITOR_SCOPE_MODAL_TITLE]: "Anuncios de Competidores",
  [ALERT_COMPETITOR_SCOPE_TITLE]: "Configura tu Marca",
  [ALERT_COMPETITOR_SCOPE_DESCRIPTION]:
    "Completa la configuración de tu marca para ver los anuncios de tus competidores.",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE]: "Agrega tus Competidores",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION]:
    "Agrega al menos un competidor en la configuración de tu marca para ver sus anuncios.",
  [BUTTON_CONFIGURE_BRAND]: "Configurar Marca",
  [BUTTON_CONFIGURE_COMPETITORS]: "Configurar Competidores",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE]:
    "¿Usar este anuncio como referencia?",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION]:
    "Este anuncio de competidor se usará como referencia de estilo para tu creativo.",
  [MODAL_COMPETITORS_PREPARING_REFERENCE]:
    "Preparando para usarlo como referencia...",
  [MODAL_COMPETITORS_SHOW_FAVORITES_ONLY]: "Ver solo favoritos",
  [MODAL_COMPETITORS_SHOW_ALL_ADS]: "Ver todos los anuncios",
  [MODAL_COMPETITORS_FAVORITES_EMPTY]: "No tienes anuncios favoritos.",
  [MODAL_COMPETITORS_SAVED_TO_FAVORITES]: "Guardado en Favoritos",
  [MODAL_COMPETITORS_SAVED_TO_FOLDER]: "Guardado en {{folder}}",
  [MODAL_COMPETITORS_REMOVED_FROM_FOLDER]: "Eliminado de {{folder}}",
  [MODAL_COMPETITORS_SELECT_FOLDER_TITLE]: "Seleccionar Carpeta",
  [MODAL_COMPETITORS_CHANGE_LOCATION]: "Cambiar",
  [MODAL_COMPETITORS_REMOVED_FROM_FAVORITES]: "Eliminado de favoritos",
  [MODAL_COMPETITORS_ADD_OPTION]: "Agregar Competidor",
  [MODAL_COMPETITORS_EDIT_BUTTON]: "Editar Competidores",
  [MODAL_COMPETITORS_EDIT_TITLE]: "Gestionar competidores",
  [MODAL_COMPETITORS_EDIT_SUBTITLE]:
    "Agrega o elimina marcas que quieras rastrear",
  [MODAL_COMPETITORS_EDIT_COUNT_ARIA]:
    "{{current}} de {{max}} competidores agregados",
  [MODAL_COMPETITORS_STRONG_SIGNAL]: "Señal fuerte",
  [MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL]: "CTA: {{label}}",
  [MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING]:
    "Cargando referencias de competidores...",
  [MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT]:
    "No hay referencias disponibles.",
  [MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL]: "Competidor",
  [MODAL_META_AD_LIBRARY_COMPETITOR_ALL]: "Todos los competidores",
  [MODAL_META_AD_LIBRARY_PLATFORM_ALL]: "Todas las plataformas",
  [MODAL_META_AD_LIBRARY_DURATION_HOURS]: "{{count}} horas activas",
  [MODAL_META_AD_LIBRARY_DURATION_DAYS]: "{{count}} días activos",
  [MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP]: "Solo visualización",
  [MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS]:
    "Buscando tus competidores...",
  [MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS]: "Analizando sus anuncios...",
  [MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY]:
    "Escogiendo los ganadores...",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE]: "Advertencia",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT]:
    "Si sales ahora, el contenido no se guardará.",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS]: "Duración del Video",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS]: "12 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS]: "15 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS]: "20 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS]: "25 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS]: "30 segundos",

  // ALERTS CAMPAIGNS
  [ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL]:
    "Es posible que tu campaña no esté generando impresiones debido a que no tiene un objetivo de marketing configurado. Para verificarlo, ve al Administrador de Anuncios de {{platform}}, busca tu campaña, haz clic en el ícono de configuración y revisa si hay un objetivo de marketing establecido.",
  [ALERT_PIXEL_NOT_FIRED_LABEL]:
    "El píxel configurado en esta campaña no ha registrado eventos en los últimos 7 días.",
  [ALERT_CAMPAIGN_STARTED_LABEL]:
    "Tu campaña lleva más de 2 días activa sin generar impresiones, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_CAMPAIGN_CPA_HIGH_LABEL]:
    "{{platform}} tiene un CPA de {{cpa}} {{currency}} en los últimos 14 días, por encima del objetivo de {{targetCpa}} {{currency}}.",
  [ALERT_AD_ACCOUNT_STATUS_LABEL]:
    "La cuenta publicitaria tiene una advertencia, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER]: "Activar Audiencia Advantage+",
  [IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER]:
    "Permite que Meta amplíe tu segmentación automáticamente hacia audiencias que potencialmente conviertan.",
  [ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL]:
    "Cuenta publicitaria inhabilitada, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL]:
    "Cuenta publicitaria con saldo pendiente sin pagar, es posible que no se estén mostrando los anuncios.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL]:
    "Cuenta publicitaria sin saldo disponible, es posible que no se estén mostrando los anuncios.",
  [ALERT_AD_ACCOUNT_NO_BALANCE_LABEL]:
    "Tu cuenta publicitaria ya no tiene saldo. Es posible que las campañas no se muestren. Revisa el Administrador de Anuncios de {{platform}} para verificarlo.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL]:
    "Cuenta publicitaria bajo revisión por actividad sospechosa, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL]:
    "Cuenta publicitaria está en proceso de un pago pendiente, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL]:
    "Cuenta publicitaria en período de gracia por un pago pendiente, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL]:
    "Cuenta publicitaria en proceso de cierre, consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL]:
    "Cuenta publicitaria cerrada definitivamente. Solo disponible para consultar informacion.",
  [ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL]:
    "Cuenta publicitaria con estado cerrado desconocido. Consulta el Administrador de Anuncios de {{platform}} para información.",
  [ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL]:
    "Cuenta publicitaria restringida o sancionada, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL]:
    "La revisión de la cuenta publicitaria fue rechazada, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL]:
    "La revisión final de la cuenta publicitaria fue rechazada y no puede volver a enviarse. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL]:
    "La revisión de los cambios de la cuenta publicitaria fue rechazada. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL]:
    "Cuenta publicitaria pendiente de revisión, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL]:
    "Cuenta publicitaria pendiente de verificación, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL]:
    "Los cambios de la cuenta publicitaria están pendientes de revisión. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL]:
    "Cuenta publicitaria en espera de una revisión interna, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL]:
    "Cuenta publicitaria pendiente de verificación pública de sus cualificaciones. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL]:
    "Cuenta publicitaria sin cualificaciones verificadas, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL]:
    "El contrato de la cuenta publicitaria aún no está vigente, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL]:
    "Cuenta publicitaria en borrador y todavía no puede mostrar anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL]:
    "Cuenta publicitaria en retención de facturación por un problema con el método de pago o con un pago. Es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL]:
    "La cuenta publicitaria alcanzó su presupuesto total, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL]:
    "La cuenta publicitaria alcanzó su fecha de finalización, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL]:
    "Cuenta publicitaria restringida por políticas, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL]:
    "Cuenta publicitaria en retención interna de la plataforma, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL]:
    "Cuenta publicitaria detenida y no está entregando anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL]:
    "Cuenta publicitaria suspendida, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL]:
    "Cuenta publicitaria cancelada, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL]:
    "La facturación de la cuenta publicitaria está pendiente de aprobación, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL]:
    "La facturación de la cuenta publicitaria fue cancelada, es posible que no se estén mostrando los anuncios. Consulta el Administrador de Anuncios de {{platform}} para más detalles.",
  [ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL]:
    "Ningún producto de tu Merchant Center tiene un estado elegible para esta campaña. Por favor revisa el estado de tus productos ya que esto puede afectar negativamente la entrega de tu campaña.",
  [ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL]:
    "Algunos productos de tu Merchant Center no tienen un estado elegible para esta campaña. Por favor revisa el estado de tus productos ya que esto puede afectar negativamente la entrega de tu campaña.",
  [ALERT_AD_CPA_LOW_LABEL]:
    "El CPA de este anuncio supera en al menos un 30% el CPA promedio de su conjunto de anuncios.",
  [ALERT_AD_CPA_MEDIUM_LABEL]:
    "El CPA de este anuncio supera en al menos un 50% el CPA promedio de su conjunto de anuncios.",
  [ALERT_AD_CPA_HIGH_LABEL]:
    "El CPA de este anuncio es al menos el doble que el CPA promedio de su conjunto de anuncios.",
  [ALERT_ASSET_GROUP_CPA_LOW_LABEL]:
    "El CPA de este Asset Group supera en al menos un 30% el CPA promedio de la campaña.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL]:
    "El CPA de este Asset Group supera en al menos un 50% el CPA promedio de la campaña.",
  [ALERT_ASSET_GROUP_CPA_HIGH_LABEL]:
    "El CPA de este Asset Group duplica o supera el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_LOW_LABEL]:
    "El CPA de este grupo de anuncios supera en al menos un 30% el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_MEDIUM_LABEL]:
    "El CPA de este grupo de anuncios supera en al menos un 50% el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_HIGH_LABEL]:
    "El CPA de este grupo de anuncios duplica o supera el CPA promedio de la campaña.",
  [ALERT_AD_CPA_LOW_TABLE_LABEL]:
    "Un anuncio supera en al menos un 30% el CPA promedio de su conjunto de anuncios.",
  [ALERT_AD_CPA_MEDIUM_TABLE_LABEL]:
    "Un anuncio supera en al menos un 50% el CPA promedio de su conjunto de anuncios.",
  [ALERT_AD_CPA_HIGH_TABLE_LABEL]:
    "Un anuncio duplica el CPA promedio de su conjunto de anuncios.",
  [ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL]:
    "Un Asset Group supera en al menos un 30% el CPA promedio de la campaña.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "Un Asset Group supera en al menos un 50% el CPA promedio de la campaña.",
  [ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL]:
    "Un Asset Group duplica o supera el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL]:
    "Un grupo de anuncios supera en al menos un 30% el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "Un grupo de anuncios supera en al menos un 50% el CPA promedio de la campaña.",
  [ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL]:
    "Un grupo de anuncios duplica o supera el CPA promedio de la campaña.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL]:
    "Este anuncio tiene fatiga creativa media. Conviene ir considerando renovar el creativo.",
  [ALERT_CREATIVE_FATIGUE_HIGH_LABEL]:
    "Este anuncio tiene fatiga creativa alta. Renueva el creativo para recuperar rendimiento.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL]:
    "Un anuncio tiene fatiga creativa media.",
  [ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL]:
    "Un anuncio tiene fatiga creativa alta.",
  [BENEFICIARY_OR_PAYER_NOT_FOUND]:
    "El beneficiario o pagador no fue encontrado, asegúrate de que tienes permisos para leer información del negocio.",
  [DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN]:
    "Esta operación no está permitida para esta campaña",
  [LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED]:
    "Esta cuenta ya ha reclamado los créditos gratis.",
  [CAMPAIGN_IS_GENERATING]:
    "Esta campaña ya se está generando en otra ventana o dispositivo.",
  [INVALID_JOB_TYPE]:
    "El tipo de tarea no es válido o no está soportado. Inténtalo de nuevo o contacta a soporte.",
  [JOB_CANCELLED_OR_FAILED]:
    "No se pudo completar la operación porque la tarea se canceló o falló. Inténtalo de nuevo.",
  [JOB_TIMEOUT]:
    "La operación tardó demasiado en completarse. Inténtalo de nuevo.",
  [CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD]:
    "No se encontraron campañas activas en ese periodo de tiempo para generar un reporte.",

  // CARDS IN CHAT BOT
  [CARD_GENERATE_COPY]: "Generación de Copy",
  [CARD_GENERATE_COPY_DESCRIPTION]: "Crear textos persuasivos para anuncios",
  [CARD_GENERATE_COPY_QUESTION]:
    "Dame sugerencias para mejorar los textos de los anuncios de mi campaña",
  [CARD_GET_CAMPAIGN_LEARNINGS]: "Obtener Aprendizajes de Campaña",
  [CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION]:
    "Conocer lo que funciona y lo que no en tu campaña",
  [CARD_GET_CAMPAIGN_LEARNINGS_QUESTION]:
    "¿Qué aprendizajes puedes darme sobre mi campaña?",
  [CARD_OPTIMIZE_GENERAL]: "Recomendaciones Generales",
  [CARD_OPTIMIZE_GENERAL_DESCRIPTION]:
    "Sugerencias para mejorar el rendimiento general",
  [CARD_OPTIMIZE_GENERAL_QUESTION]:
    "¿Qué recomendaciones me das para mejorar mi campaña?",
  [CARD_MANAGE_BUDGET]: "Gestión de Presupuesto",
  [CARD_MANAGE_BUDGET_DESCRIPTION]: "Optimizar distribución de presupuesto",
  [CARD_MANAGE_BUDGET_QUESTION]:
    "Dame sugerencias para optimizar el presupuesto de mi campaña",

  // Owner dashboard chat cards
  [CARD_OWNER_CLIENT_HEALTH]: "Salud del cliente",
  [CARD_OWNER_CLIENT_HEALTH_DESCRIPTION]:
    "Entender puntajes de salud y cuentas en riesgo",
  [CARD_OWNER_CLIENT_HEALTH_QUESTION]:
    "¿Qué clientes tienen bajo puntaje de salud y qué puedo hacer?",
  [CARD_OWNER_INSIGHTS]: "Insights",
  [CARD_OWNER_INSIGHTS_DESCRIPTION]:
    "Revisa insights y tendencias de la plataforma",
  [CARD_OWNER_INSIGHTS_QUESTION]: "¿Qué insights debería revisar hoy?",
  [CARD_OWNER_ACCOUNTS]: "Cuentas",
  [CARD_OWNER_ACCOUNTS_DESCRIPTION]: "Administra cuentas de clientes y accesos",
  [CARD_OWNER_ACCOUNTS_QUESTION]: "¿Cómo administro las cuentas de clientes?",
  [CARD_OWNER_BILLING]: "Facturación",
  [CARD_OWNER_BILLING_DESCRIPTION]: "Revisa facturación, planes y pagos",
  [CARD_OWNER_BILLING_QUESTION]: "Dame un resumen de facturación y planes",
  [CARD_OWNER_SUPPORT]: "Soporte",
  [CARD_OWNER_SUPPORT_DESCRIPTION]:
    "Obtén ayuda con incidencias de clientes y escalamientos",
  [CARD_OWNER_SUPPORT_QUESTION]:
    "¿Qué incidencias de soporte necesitan atención?",
  [CARD_OWNER_CLIENTS_ACCOUNTS]: "Clientes y cuentas",
  [CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION]:
    "Resumen de clientes, inicios de sesión y actividad",
  [CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION]:
    "Resume mis clientes y su actividad reciente",
  [CARD_OWNER_BRANDS]: "Marcas",
  [CARD_OWNER_BRANDS_DESCRIPTION]: "Gestionar marcas y configuraciones",
  [CARD_OWNER_BRANDS_QUESTION]: "¿Cómo agrego o gestiono marcas en el panel?",
  [CARD_OWNER_PLANS_MRR]: "Planes y MRR",
  [CARD_OWNER_PLANS_MRR_DESCRIPTION]: "Ingresos, planes y uso",
  [CARD_OWNER_PLANS_MRR_QUESTION]: "Dame un resumen del MRR y uso de planes",

  // Date range presets
  [DATE_RANGE_PRESET_TODAY]: "Hoy",
  [DATE_RANGE_PRESET_YESTERDAY]: "Ayer",
  [DATE_RANGE_PRESET_LAST_7]: "Últimos 7 días",
  [DATE_RANGE_PRESET_LAST_14]: "Últimos 14 días",
  [DATE_RANGE_PRESET_LAST_30]: "Últimos 30 días",
  [DATE_RANGE_PRESET_THIS_WEEK]: "Esta semana",
  [DATE_RANGE_PRESET_LAST_WEEK]: "Semana pasada",
  [DATE_RANGE_PRESET_THIS_MONTH]: "Este mes",
  [DATE_RANGE_PRESET_LAST_MONTH]: "Mes pasado",
  [DATE_RANGE_PRESET_THIS_YEAR]: "Este año",
  [DATE_RANGE_PRESET_LAST_YEAR]: "Año pasado",

  [NPS_FORM_TITLE]:
    "¿Qué tan probable es que recomiendes {{NAME_BUSINESS}} a un amigo o compañero?",
  [NPS_LABEL_NOT_LIKELY_AT_ALL]: "No muy probable",
  [NPS_LABEL_EXTREMELY_LIKELY]: "Muy probable",
  [NPS_SAVING_RATING]: "Guardando tu calificación...",
  [NPS_THANK_YOU_TITLE]: "¡Gracias por tu calificación!",
  [NPS_THANK_YOU_DESCRIPTION]:
    "Tu opinión es muy importante para nosotros y nos ayuda a mejorar {{NAME_BUSINESS}}.",

  //MODAL OVERLAP CONFLICTS
  [MODAL_OVERLAP_CONFLICTS_TITLE]: "Algunas Ubicaciones se Superponen",
  [MODAL_OVERLAP_CONFLICTS_DESCRIPTION]:
    "Se detectaron conflictos. Si continúas, eliminaremos ubicaciones superpuestas.",
  [PAGE_NUMBER]: "Página {{number}}",

  //TABLE ADMIN DASHBOARD
  [TABLE_ADMIN_DASHBOARD_CLIENT]: "Cliente",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE]: "Fecha de Renovación",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE]: "{{date, dd/MM/yyyy}}",
  [TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE]: "Origen del Contacto",
  [TABLE_ADMIN_DASHBOARD_HEALTH_SCORE]: "Health Score",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS]: "Campañas",
  [TABLE_ADMIN_DASHBOARD_KPI]: "KPI",
  [TABLE_ADMIN_DASHBOARD_SPEND]: "Gasto (7d)",
  [TABLE_ADMIN_DASHBOARD_CPA]: "CPA (7d)",
  [TABLE_ADMIN_DASHBOARD_TARGET_CPA]: "CPA objetivo",
  [TABLE_ADMIN_DASHBOARD_ROAS]: "ROAS (7d)",
  [TABLE_ADMIN_DASHBOARD_RESULTS]: "Resultados (7d)",
  [TABLE_ADMIN_DASHBOARD_LAST_LOGIN]: "Último Login",
  [TABLE_ADMIN_DASHBOARD_LOGINS]: "Logins (30d)",
  [TABLE_ADMIN_DASHBOARD_USERS]: "Usuarios",
  [TABLE_ADMIN_DASHBOARD_AUTOMATION]: "Optimizaciones (30d)",
  [TABLE_ADMIN_DASHBOARD_MRR]: "MRR",
  [TABLE_ADMIN_DASHBOARD_PLAN]: "Plan",
  [TABLE_ADMIN_DASHBOARD_CREATIVES]: "Creativos",
  [TABLE_ADMIN_DASHBOARD_NPS]: "NPS",
  [TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS]:
    "Creativos IA guardados (30d)",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE]: "{{campaignsActive}} Activas",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE]: "{{campaignsActive}} Activa",
  [TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE]: "Factura vencida",
  [TABLE_ADMIN_DASHBOARD_LOADING_MORE]: "Cargando más clientes...",
  [TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS]:
    "Mostrando {{count}} de {{total}} clientes",
  [TABLE_ADMIN_CREATIVES_UTILIZED]: "{{creativesUsed}} Guardados",
  [TABLE_ADMIN_CREATIVE_UTILIZED]: "{{creativesUsed}} Guardado",
  [TABLE_ADMIN_LAST_LOGIN_DAYS]: "Hace {{days}}d",
  [TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE]: "Razón de cancelación",
  [TABLE_ADMIN_CANCELLATION_REASON_BUTTON]: "Ver razón",
  [TABLE_ADMIN_CANCELLED_BADGE]: "Canceló",
  [TABLE_ADMIN_ADD_ADVERTISER_BUTTON]: "Crear Marca",
  [TABLE_ADMIN_ADD_CREDITS_BUTTON]: "Añadir Créditos",
  [TABLE_ADMIN_ACTIONS_BUTTON]: "Acciones",
  [TABLE_ADMIN_ACTIVATE_PLAN_BUTTON]: "Activar Plan",
  [TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON]: "Desactivar Plan",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE]: "¿Activar el plan?",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE]:
    "Esta acción activará el plan para esta agencia.",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE]: "¿Desactivar el plan?",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE]:
    "Esta acción desactivará el plan para esta agencia.",
  [TABLE_ADMIN_MARK_DEMO_BUTTON]: "Marcar como Cuenta Demo",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE]: "¿Marcar como Cuenta Demo?",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE]:
    "Se marcarán todas las marcas de esta agencia como demo. Dejarán de mostrarse en este listado.",
  [TABLE_ADMIN_CREDITS_USAGE]: "Créditos: {{used,number}} / {{total,number}}",
  [TABLE_ADMIN_PENDING_PAYMENT_BADGE]: "Pago Pendiente",
  [TABLE_ADMIN_PRIORITY_BADGE]: "Prioridad",
  [TABLE_ADMIN_SEND_EMAIL_BUTTON]: "Enviar Correo",
  [TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON]: "Ingresar como Cliente",
  [OWNER_LOGIN_AS_USER_OPTION]: "{{name}} ({{email}})",
  [OWNER_LOGIN_AS_USER_OPTION_EMAIL]: "{{email}}",
  [OWNER_LOGIN_AS_CONNECTING]: "Iniciando sesión como cliente...",
  [OWNER_LOGIN_AS_ERROR_TITLE]: "No se pudo iniciar sesión",
  [OWNER_LOGIN_AS_ERROR_EXPIRED]:
    "Este enlace expiró o ya fue usado. Pide a un admin que genere uno nuevo.",
  [OWNER_LOGIN_AS_ERROR_INVALID]:
    "Este enlace de inicio de sesión no es válido.",
  [OWNER_LOGIN_AS_ERROR_MISSING_PARAMS]:
    "A este enlace le faltan datos requeridos.",
  [OWNER_LOGIN_AS_ERROR_GENERIC]:
    "No pudimos iniciar sesión con este enlace. Inténtalo de nuevo.",
  [OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND]:
    "No se encontró un usuario con ese correo.",
  [OWNER_LOGIN_AS_ERROR_INVALID_EMAIL]: "El correo no es válido.",
  [OWNER_LOGIN_AS_ERROR_FORBIDDEN]:
    "No tienes permiso para iniciar sesión como este usuario.",
  [OWNER_LOGIN_AS_ERROR_UNAUTHORIZED]:
    "No estás autorizado para crear un enlace de acceso al cliente.",
  [SUPPORT_SESSION_BANNER_TITLE]: "Sesión de soporte activa",
  [SUPPORT_SESSION_BANNER_DESCRIPTION]:
    "El equipo de soporte está usando esta cuenta. La sesión se cerrará automáticamente a las {{time}}.",
  [SUPPORT_SESSION_ENDED_TITLE]: "La sesión de soporte terminó",
  [SUPPORT_SESSION_ENDED_DESCRIPTION]:
    "Las sesiones de soporte duran una hora. Si necesitas más tiempo, vuelve a entrar desde el panel de administración.",
  [TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE]: "Enviar Correo",
  [TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL]: "Asunto",
  [TABLE_ADMIN_SEND_EMAIL_BODY_LABEL]: "Mensaje",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL]: "Destinatarios",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER]: "Selecciona destinatarios",
  [TABLE_ADMIN_SEND_EMAIL_SELECT_ALL]: "Seleccionar todos",
  [TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON]: "Enviar",
  [TABLE_ADMIN_SEND_EMAIL_SUCCESS]: "Correo enviado correctamente",
  [TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON]: "Modificar KPI / CPA",
  [TABLE_ADMIN_ENABLE_FEATURES_BUTTON]: "Activar Funcionalidades",
  [TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY]: "Fidelidad Tipográfica",
  [TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT]:
    "Cláusula de permanencia (3 meses)",
  [TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON]: "Modelo de IA para Imágenes",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE]: "Google",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI]: "OpenAI",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM]: "Seedream",
  [MODAL_MODIFY_KPI_CPA_TITLE]: "KPI y CPA objetivo — {{name}}",
  [MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL]: "KPI principal",
  [MODAL_MODIFY_KPI_CPA_TARGET_LABEL]: "CPA objetivo",
  [MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL]: "Moneda",
  [MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS]: "Configuración de KPI y CPA guardada",
  [MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL]:
    "¿Cuántos resultados (del KPI) quieres mensualmente?",
  [MODAL_CAMPAIGN_KPI_CPA_TITLE]: "Metas de la Campaña",
  [MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT]:
    "Configura una meta por plataforma (KPI, resultados semanales, CPA y moneda). Si dejas una plataforma vacía, se usa la meta de la cuenta.",
  [MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL]:
    "¿Cuántos resultados (del KPI) quieres por semana?",
  [ADMIN_KPI_PRIMARY_LEADS]: "Leads",
  [ADMIN_KPI_PRIMARY_SALES]: "Ventas",
  [ADMIN_KPI_PRIMARY_MESSAGES]: "Mensajes",
  [ADMIN_KPI_PRIMARY_INTERACTIONS]: "Interacciones",
  [ADMIN_KPI_PRIMARY_TRAFFIC]: "Tráfico",
  [ADMIN_KPI_PRIMARY_CONVERSIONS]: "Conversiones",
  [ADMIN_KPI_PRIMARY_DOWNLOADS]: "Descargas",
  [ADMIN_KPI_PRIMARY_APP_INSTALLS]: "Instalaciones de app",
  [ADMIN_KPI_PRIMARY_VIDEO_VIEWS]: "Reproducciones de video",
  [ADMIN_KPI_PRIMARY_AWARENESS]: "Notoriedad",
  [ADMIN_KPI_PRIMARY_REACH]: "Alcance",
  [ADMIN_KPI_PRIMARY_ENGAGEMENT]: "Interacción",
  [ADMIN_KPI_PRIMARY_STORE_VISITS]: "Visitas a la tienda",
  [ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS]: "Conversiones en el sitio",
  [ADMIN_KPI_PRIMARY_CATALOG_SALES]: "Ventas de catálogo",
  [ADMIN_KPI_PRIMARY_SIGNUPS]: "Registros",
  [ADMIN_DASHBOARD_TITLE]: "Clientes",
  [OWNER_DASHBOARD_NAV_FORM]: "Formularios",
  [OWNER_DASHBOARD_NAV_REPORTED_CONTENT]: "Contenido Reportado",
  [OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES]: "Códigos",
  [OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS]: "Notificaciones",
  [OWNER_DASHBOARD_NAV_AD_SPEND]: "Inversión publicitaria",
  [OWNER_AD_SPEND_TITLE]: "Inversión publicitaria",
  [OWNER_AD_SPEND_DESCRIPTION]:
    "Gasto total de las campañas lanzadas desde la plataforma, en USD.",
  [OWNER_AD_SPEND_PRESET_HISTORIC]: "Histórico",
  [OWNER_AD_SPEND_PRESET_LAST_7]: "Últimos 7 días",
  [OWNER_AD_SPEND_PRESET_LAST_30]: "Últimos 30 días",
  [OWNER_AD_SPEND_PRESET_LAST_90]: "Últimos 90 días",
  [OWNER_AD_SPEND_PRESET_THIS_MONTH]: "Este mes",
  [OWNER_AD_SPEND_PRESET_LAST_MONTH]: "Mes anterior",
  [OWNER_AD_SPEND_PRESET_CUSTOM]: "Personalizado",
  [OWNER_AD_SPEND_CUSTOM_PENDING]:
    "Selecciona un rango de fechas y guárdalo para actualizar el reporte.",
  [OWNER_AD_SPEND_ACCURACY_WARNING]:
    "El filtrado por fechas anteriores al 15 de octubre de 2026 puede ser inexacto.",
  [OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED]:
    "Incluye {{value}} estimados a partir de estadísticas acumuladas.",
  [OWNER_AD_SPEND_KPI_TOTAL]: "Inversión total",
  [OWNER_AD_SPEND_KPI_ADVERTISERS]: "Anunciantes con inversión",
  [OWNER_AD_SPEND_KPI_COUNTRIES]: "Países",
  [OWNER_AD_SPEND_VS_PREVIOUS_PERIOD]: "Período anterior: {{value}}",
  [OWNER_AD_SPEND_CHART_TITLE]: "Evolución de la inversión por plataforma",
  [OWNER_AD_SPEND_CHART_DAILY]: "Diario",
  [OWNER_AD_SPEND_CHART_MONTHLY]: "Mensual",
  [OWNER_AD_SPEND_PLATFORMS_TITLE]: "Participación por plataforma",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE]: "Cuentas que más invierten",
  [OWNER_AD_SPEND_TOP_COUNTRIES_TITLE]: "Países que más invierten",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA]: "Cuentas que más invierten",
  [OWNER_AD_SPEND_TOP_COUNTRIES_ARIA]: "Países que más invierten",
  [OWNER_AD_SPEND_COLUMN_ADVERTISER]: "Anunciante",
  [OWNER_AD_SPEND_COLUMN_COUNTRY]: "País",
  [OWNER_AD_SPEND_COLUMN_SPEND]: "Inversión",
  [OWNER_AD_SPEND_COLUMN_SHARE]: "% del total",
  [OWNER_AD_SPEND_COLUMN_PLATFORMS]: "Plataformas",
  [OWNER_AD_SPEND_UNASSIGNED_COUNTRY]: "Sin país asignado",
  [OWNER_AD_SPEND_TREND_NEW]: "Nuevo",
  [OWNER_AD_SPEND_ESTIMATED_BADGE]: "Estimado",
  [OWNER_AD_SPEND_EMPTY_TITLE]: "Aún no hay inversión registrada",
  [OWNER_AD_SPEND_EMPTY_DESCRIPTION]:
    "Los datos aparecerán cuando se ejecute la primera recolección diaria.",
  [OWNER_AD_SPEND_MOCK_BADGE]: "Datos simulados",
  [OWNER_DASHBOARD_NAV_CREATE_USER]: "Crear Usuario",
  [OWNER_DASHBOARD_NAV_OPTIONS]: "Opciones",
  [OWNER_GLOBAL_NOTIFICATIONS_TITLE]: "Notificaciones Globales",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE]: "Título",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY]: "Cuerpo",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA]: "CTA",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK]: "Enlace",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER]:
    "Usa una ruta interna como /ads-campaign o una URL https completa. Este enlace es el mismo para todos los idiomas.",
  [OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR]:
    "El CTA en todos los idiomas y el enlace deben completarse juntos.",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON]: "Publicar y enviar correo",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS]: "Notificación publicada.",
  [MODAL_CREATE_OWNER_USER_ARIA_LABEL]: "Modal de crear usuario owner",
  [MODAL_CREATE_OWNER_USER_TITLE]: "Crear Usuario",
  [MODAL_CREATE_OWNER_USER_DESCRIPTION]:
    "Crea un usuario owner con acceso al panel de administración.",
  [MODAL_CREATE_OWNER_USER_SUCCESS]: "Usuario Creado Correctamente",
  [REGISTER_PROMOTIONAL_CODE_LABEL]: "Código promocional (opcional)",
  [REGISTER_PROMOTIONAL_CODE_PLACEHOLDER]: "Introduce tu código",
  [REGISTER_DISCOVERY_SOURCE_LABEL]: "¿Cómo nos conociste?",
  [OWNER_PROMOTIONAL_CODES_CREATE_TITLE]: "Crear código promocional",
  [OWNER_PROMOTIONAL_CODES_CREATE_BUTTON]: "Crear Código",
  [OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE]:
    "Define el código, el límite de canjes y si aplica a giveaways de AppSumo.",
  [OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP]: "Generar código aleatorio",
  [OWNER_PROMOTIONAL_CODES_FIELD_CODE]: "Código",
  [OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS]: "Canjes máximos",
  [OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO]: "Giveaway AppSumo",
  [OWNER_PROMOTIONAL_CODES_FIELD_TIER]: "Nivel AppSumo",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_1]: "Nivel 1",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_2]: "Nivel 2",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_3]: "Nivel 3",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CODE]: "Código",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CREATED]: "Creado",
  [OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED]: "Registros",
  [OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS]: "Canjes máximos",
  [OWNER_PROMOTIONAL_CODES_COLUMN_TYPE]: "Tipo",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO]: "AppSumo",
  [OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX]: " - Tier {{tier}}",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD]: "Estándar",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT]: "Descuento Stripe",
  [OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE]: "Código Stripe",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT]: "Valor del descuento",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE]: "Tipo de descuento",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED]: "Fijo (USD)",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE]: "Porcentaje",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT]:
    "Completa código Stripe, valor y tipo de descuento válidos",
  [PRICING_PROMO_DISCOUNT_APPLIED]: "Precio con descuento aplicado",
  [OWNER_PROMOTIONAL_CODES_COLUMN_STATUS]: "Estado",
  [OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE]: "Activo",
  [OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE]: "Inactivo",
  [OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS]: "Código promocional creado",
  [OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE]:
    "Ya existe un código con este valor",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID]: "Introduce un código válido",
  [PROMOTIONAL_CODE_NOT_FOUND]: "Este código promocional no existe.",
  [PROMOTIONAL_CODE_INACTIVE]: "Este código promocional ya no está activo.",
  [PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED]:
    "Este código promocional ha alcanzado el límite de canjes.",
  [ADMIN_DASHBOARD_SUBTITLE]:
    "Administra el acceso, rendimiento y facturación de tus clientes.",
  [ADMIN_DASHBOARD_SEARCH_PLACEHOLDER]: "Buscar por nombre...",
  [ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER]: "Filtrar por estado",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE]: "Resumen de Salud de Clientes",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY]: "Saludable",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST]: "Watchlist",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK]: "Riesgo de Churn",
  [CREATE_BRAND_BUTTON]: "Crear Marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_BUTTON]: "Añadir Cliente",
  [ANNOTATIONS_SIDEBAR_AGENCY_HEADER]: "Agencia: {{name}}",
  [ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER]: "Marca: {{name}}",
  [ANNOTATIONS_SIDEBAR_EMPTY_TITLE]: "Aún no hay anotaciones",
  [ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE]:
    "Deja notas internas para tu equipo sobre este cliente. Adjunta imágenes, PDFs o videos cuando lo necesites.",
  [ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER]:
    "Escribe una anotación para {{name}}",
  [ANNOTATIONS_SIDEBAR_YOU_LABEL]: "Tú",
  [ANNOTATIONS_SIDEBAR_LOADING]: "Cargando anotaciones...",
  [ANNOTATIONS_SIDEBAR_CLOSE]: "Cerrar anotaciones",
  [ANNOTATIONS_UNREAD_BADGE_ARIA]: "Nuevas anotaciones",
  [ANNOTATIONS_UNREAD_COUNT]: "{{count}} nuevas",
  [ANNOTATIONS_MENTION_ALL]: "Todos",
  [ANNOTATIONS_MENTION_MENU_ARIA]: "Mencionar usuario",
  [ANNOTATIONS_MESSAGE_EDIT]: "Editar",
  [ANNOTATIONS_MESSAGE_DELETE]: "Eliminar",
  [ANNOTATIONS_MESSAGE_DELETE_CONFIRM]:
    "¿Seguro que quieres eliminar esta anotación?",
  [ANNOTATIONS_MESSAGE_EDITING]: "Editando mensaje...",
  [ANNOTATIONS_MESSAGE_CANCEL_EDIT]: "Cancelar edición",
  [ANNOTATIONS_MESSAGE_MENU_ARIA]: "Opciones del mensaje",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE]: "Crear Marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE]:
    "Configura la cuenta básica de la marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL]: "Plan activo",
  [ADMIN_DASHBOARD_USER_CREATED_SUCCESS]: "Usuario creado correctamente",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL]: "¿Es una cuenta de prueba?",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES]: "Sí, es de prueba",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO]: "No es de prueba",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL]: "Tipo de Plan",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL]: "Recurrencia del plan",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL]: "Plan",
  [ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL]: "Tiene Add-on",
  [ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL]: "Funcionalidades",
  [ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL]:
    "Comisión sobre spend (%)",
  [ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL]:
    "ID de Suscripción Stripe (opcional)",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE]: "Crear Marca",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL]: "Nombre de la Marca",
  [ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS]: "Marca Creada Correctamente",
  [DELETE_BRAND_CONFIRMATION_TITLE]: "Eliminar Marca",
  [DELETE_BRAND_CONFIRMATION_DESCRIPTION]:
    "¿Estás seguro de que quieres eliminar «{{brandName}}»? Esta acción es definitiva y no se puede deshacer. Los datos de esta marca se eliminarán de la agencia.",
  [DELETE_BRAND_SUCCESS]: "Marca eliminada correctamente",
  [DELETE_BRAND_ERROR]: "No se pudo eliminar esta marca. Inténtalo de nuevo.",
  [DELETE_BRAND_MAIN_CANNOT_DELETE]:
    "No se puede borrar esta marca porque es la principal.",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE]: "Añadir Créditos",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL]: "Créditos a añadir",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER]: "Ingresa créditos",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR]:
    "Los créditos deben ser mayores o iguales a {{min}}",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR]:
    "Los créditos deben ser menores o iguales a {{max}}",
  [ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS]: "Créditos añadidos correctamente",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE]:
    "Asignación recurrente por marca",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL]: "Límite de créditos",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL]: "Límite de videos",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL]:
    "Consumido en este ciclo: {{value}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT]:
    "Máximo del plan de la agencia: {{max}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT]:
    "Deja el campo vacío para quitar el tope de esta marca.",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL]:
    "Total asignados",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL]:
    "Disponible en el plan",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS]:
    "Asignación de consumo actualizada",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE]:
    "Esta marca alcanzó su límite de consumo asignado",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION]:
    "Contacta a tu administrador para que expanda los límites de esta marca",
  [BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON]: "Editar Límites",
  [BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN]:
    "La suma de asignaciones por marca supera los beneficios del plan de la agencia.",
  [BRAND_USAGE_ALLOCATION_BELOW_CONSUMED]:
    "El límite no puede ser menor que el consumo actual de la marca en este ciclo.",
  [HEALTH_SCORE_LABEL]: "Health Score",

  // GENERATING CREATIVE ALERTS
  [GENERATING_CREATIVE_TITLE]: "Generando Creativos",
  [GENERATING_CREATIVE_SUCCESS]: "Creativos Generados Exitosamente",
  [GENERATING_CREATIVE_ERROR]: "Error al Generar Creativos",
  [ALERT_GENERIC_ERROR_TITLE]: "Ocurrió un Error",
  [GENERATING_CUSTOM_REPORT_MESSAGE]: "Generando Reporte",
  [GENERATING_CUSTOM_REPORT_SUCCESS]: "Reporte Generado Exitosamente",
  [GENERATING_CUSTOM_REPORT_ERROR]: "Error al Generar el Reporte",
  [ANALYZING_IMAGE_LAYERS_MESSAGE]: "Analizando Capas",
  [ANALYZING_IMAGE_LAYERS_SUCCESS]: "Imagen Analizada Exitosamente",
  [ANALYZING_IMAGE_LAYERS_ERROR]: "Error al Analizar las Capas",
  [ANALYZING_CREATIVE_TEMPLATE_MESSAGE]: "Analizando Creativo",
  [ANALYZING_CREATIVE_TEMPLATE_SUCCESS]: "Creativo Analizado Correctamente",
  [ANALYZING_CREATIVE_TEMPLATE_ERROR]: "Error al Analizar el Creativo",
  [PRODUCING_CREATIVE_TEMPLATE_MESSAGE]: "Produciendo Creativos de Plantilla",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE]:
    "Se Está Produciendo la Preview de la Plantilla",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS]:
    "Preview de la Plantilla Producida Correctamente",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR]:
    "Error al Producir la Preview de la Plantilla",
  [PRODUCING_CREATIVE_TEMPLATE_SUCCESS]:
    "Creativos de Plantilla Producidos Correctamente",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL]:
    "Se produjeron {{succeeded}} de {{requested}} creativos",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR]:
    "Se produjo 1 de {{requested}} creativos",
  [PRODUCING_CREATIVE_TEMPLATE_ERROR]:
    "Error al Producir Creativos de Plantilla",
  [EDITING_IMAGE_TITLE]: "Editando Imagen",
  [EDITING_IMAGE_SUCCESS]: "Imagen Editada Exitosamente",
  [EDITING_IMAGE_ERROR]: "Error al Editar Imagen",
  [RESIZING_IMAGE_TITLE]: "Redimensionando Imagen",
  [RESIZING_IMAGE_SUCCESS]: "Imagen Redimensionada Exitosamente",
  [RESIZING_IMAGE_ERROR]: "Error al Redimensionar Imagen",

  [AGENT_LABEL]: "Agente",
  [GO_TO_DASHBOARD]: "Ir al Dashboard",
  [IMAGES_MODERATION_BLOCKED]: "Imágenes bloqueadas por moderación",

  // Accents
  [ACCENT_ES_ARGENTINO]: "Argentino",
  [ACCENT_ES_COLOMBIANO]: "Colombiano",
  [ACCENT_ES_CHILENO]: "Chileno",
  [ACCENT_ES_MEXICANO]: "Mexicano",
  [ACCENT_ES_ESPANOL_ESPANA]: "Español de España",
  [ACCENT_ES_PERUANO]: "Peruano",
  [ACCENT_ES_VENEZOLANO]: "Venezolano",
  [ACCENT_ES_CARIBENO]: "Caribeño",
  [ACCENT_ES_NEUTRAL]: "Neutral",
  [ACCENT_ES_PUERTORRIQUENO]: "Puertorriqueño",

  [ACCENT_EN_AMERICAN]: "Americano",
  [ACCENT_EN_BRITISH]: "Británico",
  [ACCENT_EN_AUSTRALIAN]: "Australiano",
  [ACCENT_EN_NEUTRAL]: "Neutral",
  [PARTNERSHIP]: "Socios",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Imagen",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Video",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carrusel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Documento",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Configuración de anuncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Crear anuncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Usar publicación",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "No se puede usar esta publicación de video porque no hay URL de descarga disponible.",
  [AD_FORMAT_PLACEHOLDER]: "Formato de Anuncio",
  [SELECT_AD_FORMAT_TO_CONTINUE]:
    "Selecciona un formato de anuncio para continuar",

  // Campaign Learnings
  [CAMPAIGN_LEARNINGS_TITLE]: "Aprendizajes de Campaña",
  [CAMPAIGN_LEARNINGS_SUBTITLE]: "Análisis Completo",
  [CAMPAIGN_LEARNINGS_KEY_LEARNINGS]: "Aprendizajes Clave",
  [CAMPAIGN_LEARNINGS_WHAT_WORKED]: "Qué Funcionó",
  [CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK]: "Qué No Funcionó",
  [PLATFORM_META]: "Meta",
  [PLATFORM_GOOGLE]: "Google",

  // BRAND SETUP CONFIRM MODAL
  [MODAL_BRAND_SETUP_CONFIRM_TITLE]:
    "¿Deseas guardar esta configuración de marca?",
  [MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION]:
    "Esta configuración se utilizará como base para la generación de campañas y de piezas publicitarias (imágenes y videos). Verifica que la información sea correcta antes de continuar, no obstante, podrás actualizarla más adelante.",
  [MODAL_BRAND_SETUP_CONFIRM_BUTTON]: "Continuar",
  [MODAL_BRAND_SETUP_REVIEW_BUTTON]: "Revisar",

  // Facebook Modal Upload
  [MODAL_UPLOAD_FACEBOOK_TYPE_LABEL]: "Tipo de Contenido Facebook",
  [TYPE_CONTENT_FACEBOOK_LABEL]: "Tipo de Contenido",
  [MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL]: "Publicación",
  [MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL]: "Historia",
  [MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL]: "Reel",

  // CAROUSEL IMAGES
  [INSTAGRAM_FEED_ASPECT_RATIO_WARNING]:
    "El tamaño de tu imagen no coincide con el formato recomendado para publicaciones de Instagram (Ideal: 4:5). ¿Quieres ajustarla?",
  [CAROUSEL_MIN_IMAGES_WARNING]:
    "Debes seleccionar al menos 2 imágenes para un carrusel",
  [CAROUSEL_MAX_IMAGES_WARNING]: "Puedes seleccionar hasta {{max}} imágenes",
  [CAROUSEL_DRAG_TO_REORDER]:
    "Arrastra las imágenes para cambiar el orden. La primera será la imagen principal.",
  [CAROUSEL_ADD_MORE_IMAGES]: "Agregar más imágenes",
  [CAROUSEL_IMAGES_SELECTED]: "{{count}} imágenes seleccionadas",
  [CAROUSEL_MAIN_IMAGE]: "Principal",

  // TIKTOK
  [TYPE_CONTENT_TIKTOK_LABEL]: "Tipo de Contenido",
  [MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL]: "Post",
  [MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL]: "Video",

  // Unified Carousel translation
  [CONTENT_TYPE_CAROUSEL]: "Carrusel",

  // Creative change — regenerate texts confirmation
  [CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE]:
    "¿Deseas regenerar todos los textos con base al nuevo creativo?",
  [BUTTON_KEEP_TEXTS]: "Mantener textos",
  [REGENERATING_AD_TEXTS_OVERLAY_MESSAGE]: "Regenerando textos…",

  // Content type change confirmation
  [CONFIRM_CHANGE_CONTENT_TYPE_TITLE]:
    "¿Seguro quiere cambiar el tipo de contenido?",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL]:
    "Todas las plataformas pasarán a Carrusel.",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST]:
    "Todas las plataformas pasarán a Post.",

  // PLANS CREDITS
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS]: "{{value,number}} Créditos",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR]: "{{value,number}} créditos/año",
  [APPSUMO_SUBSCRIPTION_TIER_1]: "Tier 1",
  [APPSUMO_SUBSCRIPTION_TIER_2]: "Tier 2",
  [APPSUMO_SUBSCRIPTION_TIER_3]: "Tier 3",
  [VALUE_SUBSCRIPTION_ONE_TIME]: "{{value,number}} {{currency}} (pago único)",
  [BUTTON_APPSUMO_VIEW_PLANS]: "Ver planes en AppSumo",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Imagen",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Video",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carrusel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Documento",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Configuración de anuncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Crear anuncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Usar publicación",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "No se puede usar esta publicación de video porque no hay URL de descarga disponible.",
  [AD_FORMAT_PLACEHOLDER]: "Formato de Anuncio",
  [SELECT_AD_FORMAT_TO_CONTINUE]:
    "Selecciona un formato de anuncio para continuar",

  // CREDIT REWARD MODAL
  [LINKEDIN_ARTICLE_DEFAULT_TEXT]:
    'Desde que integramos {{NAME_BUSINESS}}, nuestra forma de hacer marketing cambió por completo: dejamos de "solo escribir posts" para diseñar ecosistemas de contenido con una estrategia clara, coherente y enfocada en resultados.\n\nLo que antes era un proceso lento hoy es un flujo optimizado 100% con IA: transformamos ideas en campañas inteligentes y creamos contenido multimedia generado por inteligencia artificial. Además, la herramienta eleva el tono y pule el mensaje para que cada palabra cuente, logrando más consistencia, cero estrés creativo y una comunicación que realmente convierte.',
  [CREDIT_REWARD_MODAL_TITLE]: "Obtén Créditos Gratis",
  [CREDIT_REWARD_MODAL_SUBTITLE]:
    "Haz una publicación en LinkedIn y obtén créditos gratis",
  [CREDIT_REWARD_MODAL_ARIA_LABEL]: "Obtén Créditos Gratis",
  [CREDIT_REWARD_MODAL_BUTTON_TEXT]: "Obtén <u><em>Créditos Gratis</em></u>",
  [CREDIT_REWARD_MODAL_REWARD]: "Recompensa",
  [CREDIT_REWARD_MODAL_REWARD_DESCRIPTION]:
    "Después de compartir la publicación",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL]: "Contenido del artículo",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER]:
    "Escribe el contenido del artículo que deseas publicar...",
  [CREDIT_REWARD_MODAL_VERIFICATION_NOTICE]:
    "La publicación será verificada antes de otorgar los créditos",
  [CREDIT_REWARD_MODAL_BUTTON_CANCEL]: "Cancelar",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISH]: "Publicar y Obtener Créditos",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISHING]: "Publicando...",
  [CREDIT_REWARD_MODAL_BUTTON_RETRY]: "Reintentar",
  [CREDIT_REWARD_MODAL_LOADING_TITLE]: "Verificando publicación",
  [CREDIT_REWARD_MODAL_LOADING_DESCRIPTION]:
    "Esto puede tomar unos segundos...",
  [CREDIT_REWARD_MODAL_SUCCESS_TITLE]: "Publicación Exitosa",
  [CREDIT_REWARD_MODAL_SUCCESS_TEXT]:
    "+{{credits}} créditos han sido añadidos a tu cuenta. ¡Gracias por participar!",
  [CREDIT_REWARD_MODAL_ERROR_TITLE]: "Error al Publicar",
  [CREDIT_REWARD_MODAL_ERROR_TEXT]:
    "No se pudieron acreditar los créditos. Por favor, verifica tu publicación e intenta de nuevo.",

  // BRAND SETUP SECTIONS
  [SECTION_COMPETITORS_TITLE]: "Competidores",
  [SECTION_COMPETITORS_SUBTITLE_SINGULAR]: "Marca Identificada",
  [SECTION_COMPETITORS_SUBTITLE_PLURAL]: "Marcas Identificadas",
  [SECTION_SOCIAL_TITLE]: "Redes Sociales",
  [SECTION_SOCIAL_SUBTITLE_SINGULAR]: "Perfil Identificado",
  [SECTION_SOCIAL_SUBTITLE_PLURAL]: "Perfiles Identificados",
  [SECTION_VOICE_TITLE]: "Voz de Marca",
  [SECTION_VOICE_SUBTITLE]: "Tono y Personalidad",
  [SECTION_VOICE_TONE_DESCRIPTION]: "Descripción del Tono",
  [SECTION_VOICE_ATTRIBUTES_LABEL]: "Atributos de Voz (Máx 6)",
  [SECTION_OFFER_TITLE]: "Oferta",
  [SECTION_OFFER_SUBTITLE]: "Tipo de Negocio",
  [SECTION_OFFER_TYPE_LABEL]: "Tipo",
  [SECTION_OFFER_VISUAL_STYLE_LABEL]: "Estilo Visual",
  [SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL]:
    "Propuesta de Valor del Negocio",
  [SECTION_OFFER_DEFAULT_VALUE]: "Servicios",
  [SECTION_COUNTRY_TITLE]: "País",
  [SECTION_COUNTRY_SUBTITLE]: "Ubicación del negocio",
  [SECTION_COUNTRY_LABEL]: "País",
  [SECTION_COUNTRY_DEFAULT_VALUE]: "Selecciona un País",
  [SECTION_TYPOGRAPHY_TITLE]: "Tipografía",
  [SECTION_TYPOGRAPHY_SUBTITLE]: "Sistema de Fuentes",
  [SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL]: "Fuente",
  [SECTION_TYPOGRAPHY_TITLE_FONT_LABEL]: "Fuente Principal",
  [SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL]: "Fuente Secundaria",
  [SECTION_TYPOGRAPHY_BODY_FONT_LABEL]: "Fuente Secundaria",
  [SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY]: "Agregar Tipografía",
  [SECTION_TYPOGRAPHY_FONT_SIZES_LABEL]: "Tamaños de Fuente",
  [SECTION_TYPOGRAPHY_HEADING_LABEL]: "Encabezado",
  [SECTION_TYPOGRAPHY_SUBHEADING_LABEL]: "Subtítulo",
  [SECTION_TYPOGRAPHY_BODY_LABEL]: "Cuerpo",
  [SECTION_TYPOGRAPHY_PX_UNIT]: "px",
  [SECTION_TYPOGRAPHY_GENERATING_PREVIEW]: "Generando Preview",
  [SECTION_TYPOGRAPHY_ADD_FONT]: 'Añadir "{{value}}"',
  [SECTION_LOGO_TITLE]: "Logo",
  [SECTION_LOGO_SUBTITLE]: "Activo principal",
  [SECTION_COLORS_TITLE]: "Identidad Visual",
  [SECTION_COLORS_SUBTITLE]: "Colores y Estilo Visual",
  [SECTION_COLORS_ADD_COLOR]: "Agregar color",
  [SECTION_TARGET_AUDIENCE_TITLE]: "Audiencia Objetivo",
  [SECTION_TARGET_AUDIENCE_SUBTITLE]: "Perfil del Cliente Ideal",
  [SECTION_TARGET_AUDIENCE_ICP_LABEL]: "Perfil del Cliente Ideal",
  [SECTION_PRODUCT_IMAGES_TITLE]: "Productos",
  [SECTION_PRODUCT_IMAGES_SUBTITLE]:
    "Agrega imágenes de tus productos o servicios",
  [BUTTON_UPLOAD_PRODUCT_IMAGES]: "Subir imágenes",
  [BUTTON_DELETE_PRODUCT_IMAGE]: "Eliminar",
  [SECTION_ADDITIONAL_ASSETS_TITLE]: "Recursos Adicionales",
  [SECTION_ADDITIONAL_ASSETS_SUBTITLE]:
    "Añade imágenes de referencia con indicaciones específicas para generar creativos más personalizados.",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL]: "Instrucción de Uso",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER]:
    "Ej: colocar en la esquina inferior derecha como sello de calidad",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED]:
    "La instrucción de uso es obligatoria para cada imagen",
  [BUTTON_UPLOAD_ADDITIONAL_ASSET]: "Añadir Imagen",
  [SECTION_ADDITIONAL_ASSETS_MAX_ERROR]: "Máximo 10 Imágenes Adicionales",
  [SECTION_ADDITIONAL_ASSETS_ASSET_LABEL]: "Recurso {{number}}",
  [SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP]:
    "Has alcanzado el máximo de 10 recursos adicionales",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM]:
    "Se eliminará esta imagen y su instrucción de uso",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE]: "¿Eliminar recurso?",
  [SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR]:
    "Cada recurso debe incluir imagen e instrucción de uso",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL]: "Es condicional",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP]:
    "Actívalo si este recurso solo debe usarse cuando aplique al contexto de la pieza. Si es siempre requerido, déjalo desactivado.",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL]: "Información variable",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP]:
    "Actívalo si este recurso debe personalizarse con la información específica de cada pieza. Si su contenido no cambia, déjalo desactivado.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL]: "Grupo de variantes",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP]:
    "Asigna el mismo nombre de grupo a los recursos que sean alternativas entre sí. Al generar varias piezas se usará una variante distinta en cada una y solo una por pieza. Déjalo vacío si el recurso no tiene alternativas o no requieres que sea diferente en cada pieza.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER]: "Ej. ticket",
  [MODAL_ADDITIONAL_ASSET_TITLE]: "Recurso Adicional",
  [BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE]: "Cambiar Imagen",
  [SECTION_BUYER_PERSONA_TITLE]: "Buyer Persona",
  [SECTION_BUYER_PERSONA_SUBTITLE]: "Perfil del comprador",
  [SECTION_BUYER_PERSONA_LABEL]: "Buyer Persona",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_NAME]: "Nombre",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION]: "Descripción",

  // BRAND SETUP SECTIONS
  [BRAND_SETUP_SECTION_BRAND_NAME]: "Mi Marca",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION]:
    "Esta es la descripción de mi marca. Aquí puedes agregar información adicional sobre tu negocio, sus valores y su misión",
  [BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER]:
    "Escribe aquí el nombre de tu marca",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER]:
    "Escribe aquí de qué se trata tu marca",

  // MODAL EDIT URL PARAMETERS
  [MODAL_EDIT_URL_PARAMETERS_TITLE]: "Editar Parámetros de URL",
  [MODAL_EDIT_URL_PARAMETERS_DESCRIPTION]:
    "Los parámetros de URL pueden ayudarte a recopilar datos de rendimiento para tu campaña.",
  [MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL]: "Parámetros UTM",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL]: "Parámetros personalizados",
  [MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL]: "Vista previa",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME]: "Nombre del parámetro",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE]: "Valor del parámetro",
  [MODAL_EDIT_URL_PARAMETERS_CONFIGURED]:
    "{{count}} parámetros UTM configurados",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY]: "Aplicar",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE]: "Editar parámetros de URL",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED]:
    "Esta clave es reservada. Usa la sección de parámetros UTM para modificarla.",
  [MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL]: "Construir UTMs",
  [URL_EXAMPLE_PLACEHOLDER]: "https://www.tusitioweb.com",

  // MODAL FEEDBACK
  [MODAL_FEEDBACK_TITLE]: "Comparte tu Opinión",
  [MODAL_FEEDBACK_DESCRIPTION]:
    "Ayúdanos a mejorar compartiendo tus pensamientos sobre este contenido.",
  [MODAL_FEEDBACK_PLACEHOLDER]: "Cuéntanos qué piensas...",
  [MODAL_FEEDBACK_LIKE_LABEL]: "Te gustó este contenido",
  [MODAL_FEEDBACK_DISLIKE_LABEL]: "No te gustó este contenido",
  [MODAL_REPORT_CONTENT_TITLE]: "Reportar Contenido",
  [MODAL_REPORT_CONTENT_DESCRIPTION]:
    "Cuéntanos qué problema presenta este contenido para poder revisarlo (solo si presenta errores como deformaciones, fallos visuales o resultados incorrectos).",
  [MODAL_REPORT_CONTENT_PLACEHOLDER]:
    "Escribe la razón o contexto del reporte...",
  [MODAL_REPORT_CONTENT_SUCCESS]: "Reporte enviado correctamente.",
  [BUTTON_REPORT_CONTENT]: "Reportar",

  // ALERTS ANIMATION IMAGE
  [ANIMATING_IMAGE_TITLE]: "Animando Imagen",
  [ANIMATING_IMAGE_SUCCESS]: "Imagen Animada Exitosamente",
  [ANIMATING_IMAGE_ERROR]: "Error al Animar Imagen",
  // COUNTRIES
  [COUNTRY_ANDORRA]: "Andorra",
  [COUNTRY_UNITED_ARAB_EMIRATES]: "Emiratos Árabes Unidos",
  [COUNTRY_AFGHANISTAN]: "Afganistán",
  [COUNTRY_ANTIGUA_AND_BARBUDA]: "Antigua y Barbuda",
  [COUNTRY_ANGUILLA]: "Anguila",
  [COUNTRY_ALBANIA]: "Albania",
  [COUNTRY_ARMENIA]: "Armenia",
  [COUNTRY_ANGOLA]: "Angola",
  [COUNTRY_ANTARCTICA]: "Antártida",
  [COUNTRY_ARGENTINA]: "Argentina",
  [COUNTRY_AMERICAN_SAMOA]: "Samoa Americana",
  [COUNTRY_AUSTRIA]: "Austria",
  [COUNTRY_AUSTRALIA]: "Australia",
  [COUNTRY_ARUBA]: "Aruba",
  [COUNTRY_ALLAND_ISLANDS]: "Islas Åland",
  [COUNTRY_AZERBAIJAN]: "Azerbaiyán",
  [COUNTRY_BOSNIA_AND_HERZEGOVINA]: "Bosnia y Herzegovina",
  [COUNTRY_BARBADOS]: "Barbados",
  [COUNTRY_BANGLADESH]: "Bangladesh",
  [COUNTRY_BELGIUM]: "Bélgica",
  [COUNTRY_BURKINA_FASO]: "Burkina Faso",
  [COUNTRY_BULGARIA]: "Bulgaria",
  [COUNTRY_BAHRAIN]: "Baréin",
  [COUNTRY_BURUNDI]: "Burundi",
  [COUNTRY_BENIN]: "Benín",
  [COUNTRY_SAINT_BARTHELEMY]: "San Bartolomé",
  [COUNTRY_BERMUDA]: "Bermudas",
  [COUNTRY_BRUNEI_DARUSSALAM]: "Brunéi",
  [COUNTRY_BOLIVIA]: "Bolivia",
  [COUNTRY_BRAZIL]: "Brasil",
  [COUNTRY_BAHAMAS]: "Bahamas",
  [COUNTRY_BHUTAN]: "Bután",
  [COUNTRY_BOUVET_ISLAND]: "Isla Bouvet",
  [COUNTRY_BOTSWANA]: "Botsuana",
  [COUNTRY_BELARUS]: "Bielorrusia",
  [COUNTRY_BELIZE]: "Belice",
  [COUNTRY_CANADA]: "Canadá",
  [COUNTRY_COCOS_KEELING_ISLANDS]: "Islas Cocos",
  [COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE]:
    "Congo, República Democrática del",
  [COUNTRY_CENTRAL_AFRICAN_REPUBLIC]: "República Centroafricana",
  [COUNTRY_CONGO_REPUBLIC_OF_THE]: "Congo, República del",
  [COUNTRY_SWITZERLAND]: "Suiza",
  [COUNTRY_COTE_D_IVOIRE]: "Costa de Marfil",
  [COUNTRY_COOK_ISLANDS]: "Islas Cook",
  [COUNTRY_CHILE]: "Chile",
  [COUNTRY_CAMEROON]: "Camerún",
  [COUNTRY_CHINA]: "China",
  [COUNTRY_COLOMBIA]: "Colombia",
  [COUNTRY_COSTA_RICA]: "Costa Rica",
  [COUNTRY_CUBA]: "Cuba",
  [COUNTRY_CAPE_VERDE]: "Cabo Verde",
  [COUNTRY_CURACAO]: "Curazao",
  [COUNTRY_CHRISTMAS_ISLAND]: "Isla de Navidad",
  [COUNTRY_CYPRUS]: "Chipre",
  [COUNTRY_CZECH_REPUBLIC]: "República Checa",
  [COUNTRY_GERMANY]: "Alemania",
  [COUNTRY_DJIBOUTI]: "Yibuti",
  [COUNTRY_DENMARK]: "Dinamarca",
  [COUNTRY_DOMINICA]: "Dominica",
  [COUNTRY_DOMINICAN_REPUBLIC]: "República Dominicana",
  [COUNTRY_ALGERIA]: "Argelia",
  [COUNTRY_ECUADOR]: "Ecuador",
  [COUNTRY_ESTONIA]: "Estonia",
  [COUNTRY_EGYPT]: "Egipto",
  [COUNTRY_WESTERN_SAHARA]: "Sáhara Occidental",
  [COUNTRY_ERITREA]: "Eritrea",
  [COUNTRY_SPAIN]: "España",
  [COUNTRY_ETHIOPIA]: "Etiopía",
  [COUNTRY_FINLAND]: "Finlandia",
  [COUNTRY_FIJI]: "Fiyi",
  [COUNTRY_FALKLAND_ISLANDS_MALVINAS]: "Islas Malvinas",
  [COUNTRY_MICRONESIA_FEDERATED_STATES_OF]: "Micronesia",
  [COUNTRY_FAROE_ISLANDS]: "Islas Feroe",
  [COUNTRY_FRANCE]: "Francia",
  [COUNTRY_GABON]: "Gabón",
  [COUNTRY_UNITED_KINGDOM]: "Reino Unido",
  [COUNTRY_GRENADA]: "Granada",
  [COUNTRY_GEORGIA]: "Georgia",
  [COUNTRY_FRENCH_GUIANA]: "Guayana Francesa",
  [COUNTRY_GUERNSEY]: "Guernsey",
  [COUNTRY_GHANA]: "Ghana",
  [COUNTRY_GIBRALTAR]: "Gibraltar",
  [COUNTRY_GREENLAND]: "Groenlandia",
  [COUNTRY_GAMBIA]: "Gambia",
  [COUNTRY_GUINEA]: "Guinea",
  [COUNTRY_GUADELOUPE]: "Guadalupe",
  [COUNTRY_EQUATORIAL_GUINEA]: "Guinea Ecuatorial",
  [COUNTRY_GREECE]: "Grecia",
  [COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS]:
    "Islas Georgias del Sur y Sandwich del Sur",
  [COUNTRY_GUATEMALA]: "Guatemala",
  [COUNTRY_GUAM]: "Guam",
  [COUNTRY_GUINEA_BISSAU]: "Guinea-Bisáu",
  [COUNTRY_GUYANA]: "Guyana",
  [COUNTRY_HONG_KONG]: "Hong Kong",
  [COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS]: "Islas Heard y McDonald",
  [COUNTRY_HONDURAS]: "Honduras",
  [COUNTRY_CROATIA]: "Croacia",
  [COUNTRY_HAITI]: "Haití",
  [COUNTRY_HUNGARY]: "Hungría",
  [COUNTRY_INDONESIA]: "Indonesia",
  [COUNTRY_IRELAND]: "Irlanda",
  [COUNTRY_ISRAEL]: "Israel",
  [COUNTRY_ISLE_OF_MAN]: "Isla de Man",
  [COUNTRY_INDIA]: "India",
  [COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY]:
    "Territorio Británico del Océano Índico",
  [COUNTRY_IRAQ]: "Irak",
  [COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF]: "Irán",
  [COUNTRY_ICELAND]: "Islandia",
  [COUNTRY_ITALY]: "Italia",
  [COUNTRY_JERSEY]: "Jersey",
  [COUNTRY_JAMAICA]: "Jamaica",
  [COUNTRY_JORDAN]: "Jordania",
  [COUNTRY_JAPAN]: "Japón",
  [COUNTRY_KENYA]: "Kenia",
  [COUNTRY_KYRGYZSTAN]: "Kirguistán",
  [COUNTRY_CAMBODIA]: "Camboya",
  [COUNTRY_KIRIBATI]: "Kiribati",
  [COUNTRY_COMOROS]: "Comoras",
  [COUNTRY_SAINT_KITTS_AND_NEVIS]: "San Cristóbal y Nieves",
  [COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF]: "Corea del Norte",
  [COUNTRY_KOREA_REPUBLIC_OF]: "Corea del Sur",
  [COUNTRY_KUWAIT]: "Kuwait",
  [COUNTRY_CAYMAN_ISLANDS]: "Islas Caimán",
  [COUNTRY_KAZAKHSTAN]: "Kazajistán",
  [COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC]: "Laos",
  [COUNTRY_LEBANON]: "Líbano",
  [COUNTRY_SAINT_LUCIA]: "Santa Lucía",
  [COUNTRY_LIECHTENSTEIN]: "Liechtenstein",
  [COUNTRY_SRI_LANKA]: "Sri Lanka",
  [COUNTRY_LIBERIA]: "Liberia",
  [COUNTRY_LESOTHO]: "Lesoto",
  [COUNTRY_LITHUANIA]: "Lituania",
  [COUNTRY_LUXEMBOURG]: "Luxemburgo",
  [COUNTRY_LATVIA]: "Letonia",
  [COUNTRY_LIBYA]: "Libia",
  [COUNTRY_MOROCCO]: "Marruecos",
  [COUNTRY_MONACO]: "Mónaco",
  [COUNTRY_MOLDOVA_REPUBLIC_OF]: "Moldavia",
  [COUNTRY_MONTENEGRO]: "Montenegro",
  [COUNTRY_SAINT_MARTIN_FRENCH_PART]: "San Martín",
  [COUNTRY_MADAGASCAR]: "Madagascar",
  [COUNTRY_MARSHALL_ISLANDS]: "Islas Marshall",
  [COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF]: "Macedonia del Norte",
  [COUNTRY_MALI]: "Malí",
  [COUNTRY_MYANMAR]: "Birmania",
  [COUNTRY_MONGOLIA]: "Mongolia",
  [COUNTRY_MACAO]: "Macao",
  [COUNTRY_NORTHERN_MARIANA_ISLANDS]: "Islas Marianas del Norte",
  [COUNTRY_MARTINIQUE]: "Martinica",
  [COUNTRY_MAURITANIA]: "Mauritania",
  [COUNTRY_MONTSERRAT]: "Montserrat",
  [COUNTRY_MALTA]: "Malta",
  [COUNTRY_MAURITIUS]: "Mauricio",
  [COUNTRY_MALDIVES]: "Maldivas",
  [COUNTRY_MALAWI]: "Malaui",
  [COUNTRY_MEXICO]: "México",
  [COUNTRY_MALAYSIA]: "Malasia",
  [COUNTRY_MOZAMBIQUE]: "Mozambique",
  [COUNTRY_NAMIBIA]: "Namibia",
  [COUNTRY_NEW_CALEDONIA]: "Nueva Caledonia",
  [COUNTRY_NIGER]: "Níger",
  [COUNTRY_NORFOLK_ISLAND]: "Isla Norfolk",
  [COUNTRY_NIGERIA]: "Nigeria",
  [COUNTRY_NICARAGUA]: "Nicaragua",
  [COUNTRY_NETHERLANDS]: "Países Bajos",
  [COUNTRY_NORWAY]: "Noruega",
  [COUNTRY_NEPAL]: "Nepal",
  [COUNTRY_NAURU]: "Nauru",
  [COUNTRY_NIUE]: "Niue",
  [COUNTRY_NEW_ZEALAND]: "Nueva Zelanda",
  [COUNTRY_OMAN]: "Omán",
  [COUNTRY_PANAMA]: "Panamá",
  [COUNTRY_PERU]: "Perú",
  [COUNTRY_FRENCH_POLYNESIA]: "Polinesia Francesa",
  [COUNTRY_PAPUA_NEW_GUINEA]: "Papúa Nueva Guinea",
  [COUNTRY_PHILIPPINES]: "Filipinas",
  [COUNTRY_PAKISTAN]: "Pakistán",
  [COUNTRY_POLAND]: "Polonia",
  [COUNTRY_SAINT_PIERRE_AND_MIQUELON]: "San Pedro y Miquelón",
  [COUNTRY_PITCAIRN]: "Islas Pitcairn",
  [COUNTRY_PUERTO_RICO]: "Puerto Rico",
  [COUNTRY_PALESTINE_STATE_OF]: "Palestina",
  [COUNTRY_PORTUGAL]: "Portugal",
  [COUNTRY_PALAU]: "Palaos",
  [COUNTRY_PARAGUAY]: "Paraguay",
  [COUNTRY_QATAR]: "Catar",
  [COUNTRY_REUNION]: "Reunión",
  [COUNTRY_ROMANIA]: "Rumania",
  [COUNTRY_SERBIA]: "Serbia",
  [COUNTRY_RUSSIAN_FEDERATION]: "Rusia",
  [COUNTRY_RWANDA]: "Ruanda",
  [COUNTRY_SAUDI_ARABIA]: "Arabia Saudita",
  [COUNTRY_SOLOMON_ISLANDS]: "Islas Salomón",
  [COUNTRY_SEYCHELLES]: "Seychelles",
  [COUNTRY_SUDAN]: "Sudán",
  [COUNTRY_SWEDEN]: "Suecia",
  [COUNTRY_SINGAPORE]: "Singapur",
  [COUNTRY_SAINT_HELENA]: "Santa Elena",
  [COUNTRY_SLOVENIA]: "Eslovenia",
  [COUNTRY_SVALBARD_AND_JAN_MAYEN]: "Svalbard y Jan Mayen",
  [COUNTRY_SLOVAKIA]: "Eslovaquia",
  [COUNTRY_SIERRA_LEONE]: "Sierra Leona",
  [COUNTRY_SAN_MARINO]: "San Marino",
  [COUNTRY_SENEGAL]: "Senegal",
  [COUNTRY_SOMALIA]: "Somalia",
  [COUNTRY_SURINAME]: "Surinam",
  [COUNTRY_SOUTH_SUDAN]: "Sudán del Sur",
  [COUNTRY_SAO_TOME_AND_PRINCIPE]: "Santo Tomé y Príncipe",
  [COUNTRY_EL_SALVADOR]: "El Salvador",
  [COUNTRY_SINT_MAARTEN_DUTCH_PART]: "Sint Maarten",
  [COUNTRY_SYRIAN_ARAB_REPUBLIC]: "Siria",
  [COUNTRY_SWAZILAND]: "Esuatini",
  [COUNTRY_TURKS_AND_CAICOS_ISLANDS]: "Islas Turcas y Caicos",
  [COUNTRY_CHAD]: "Chad",
  [COUNTRY_FRENCH_SOUTHERN_TERRITORIES]: "Territorios Australes Franceses",
  [COUNTRY_TOGO]: "Togo",
  [COUNTRY_THAILAND]: "Tailandia",
  [COUNTRY_TAJIKISTAN]: "Tayikistán",
  [COUNTRY_TOKELAU]: "Tokelau",
  [COUNTRY_TIMOR_LESTE]: "Timor Oriental",
  [COUNTRY_TURKMENISTAN]: "Turkmenistán",
  [COUNTRY_TUNISIA]: "Túnez",
  [COUNTRY_TONGA]: "Tonga",
  [COUNTRY_TURKEY]: "Turquía",
  [COUNTRY_TRINIDAD_AND_TOBAGO]: "Trinidad y Tobago",
  [COUNTRY_TUVALU]: "Tuvalu",
  [COUNTRY_TAIWAN]: "Taiwán",
  [COUNTRY_UNITED_REPUBLIC_OF_TANZANIA]: "Tanzania",
  [COUNTRY_UKRAINE]: "Ucrania",
  [COUNTRY_UGANDA]: "Uganda",
  [COUNTRY_UNITED_STATES]: "Estados Unidos",
  [COUNTRY_URUGUAY]: "Uruguay",
  [COUNTRY_UZBEKISTAN]: "Uzbekistán",
  [COUNTRY_HOLY_SEE_VATICAN_CITY_STATE]: "Santa Sede (Ciudad del Vaticano)",
  [COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES]: "San Vicente y las Granadinas",
  [COUNTRY_VENEZUELA]: "Venezuela",
  [COUNTRY_BRITISH_VIRGIN_ISLANDS]: "Islas Vírgenes Británicas",
  [COUNTRY_US_VIRGIN_ISLANDS]: "Islas Vírgenes de EE.UU.",
  [COUNTRY_VIETNAM]: "Vietnam",
  [COUNTRY_VANUATU]: "Vanuatu",
  [COUNTRY_WALLIS_AND_FUTUNA]: "Wallis y Futuna",
  [COUNTRY_SAMOA]: "Samoa",
  [COUNTRY_KOSOVO]: "Kosovo",
  [COUNTRY_YEMEN]: "Yemen",
  [COUNTRY_MAYOTTE]: "Mayotte",
  [COUNTRY_SOUTH_AFRICA]: "Sudáfrica",
  [COUNTRY_ZAMBIA]: "Zambia",
  [COUNTRY_ZIMBABWE]: "Zimbabue",

  // MODAL CREDITS USAGE DETAILED
  [MODAL_CREDITS_USAGE_DETAILED_TITLE]: "Uso Detallado de Créditos",
  [MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL]: "Uso Detallado de Créditos",
  [MODAL_CREDITS_USAGE_DETAILED_LINK]: "Ver uso detallado",
  [MODAL_CREDITS_USAGE_DETAILED_PERIOD]: "Período: {{from}} — {{to}}",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE]: "Uso por Marca",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE]: "Uso por Usuario",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER]: "Marca",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER]: "Usuario",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT]: "Créditos Gastados",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT]: "Videos",
  [MODAL_CREDITS_USAGE_DETAILED_LOADING]: "Cargando uso de créditos...",
  [MODAL_CREDITS_USAGE_DETAILED_EMPTY]: "Sin gasto registrado en este período",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS]:
    "Total de Créditos: {{value}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE]:
    "Total de Créditos por Grupo",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS]:
    "{{agencyName}}: {{value}} Créditos",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE]:
    "Uso detallado de {{agencyName}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS]:
    "No hay grupos asignados",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING]:
    "Calculando uso de las marcas...",

  // PRE-ACTIVACIÓN
  [PRE_ACTIVATION_BADGE]: "PRE-ACTIVACIÓN",
  [PRE_ACTIVATION_SECTION_CONTACT]: "01 · Datos de contacto",
  [PRE_ACTIVATION_SECTION_01_BUSINESS]: "02 · Tu negocio",
  [PRE_ACTIVATION_SECTION_02_CURRENT_ADS]: "03 · Publicidad actual",
  [PRE_ACTIVATION_SECTION_03_OBJECTIVES]: "04 · Objetivos",
  [PRE_ACTIVATION_SECTION_04_MEETING_ACCESS]: "05 · Accesos para la reunión",
  [PRE_ACTIVATION_HERO_TITLE]: "Cuéntanos sobre<br/>tu <em>negocio</em>",
  [PRE_ACTIVATION_HERO_DESCRIPTION]:
    "Para aprovechar al máximo nuestra reunión de activación, completa este formulario antes de la llamada. Son 10 minutos y nos permite llegar preparados con una estrategia personalizada para ti.",
  [PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY]:
    "Para aprovechar al máximo tu activación, completa este formulario antes de la primera sesión. Son unos 5 minutos y nos permite llegar con tu marca ya configurada en la plataforma.",
  [PRE_ACTIVATION_FIELD_BUSINESS_NAME]: "Nombre de tu empresa o marca",
  [PRE_ACTIVATION_FIELD_AGENCY_NAME]: "Nombre de tu agencia",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME]: "Ej: Agencia Digital Norte",
  [PRE_ACTIVATION_FIELD_FULL_NAME]: "Tu nombre completo",
  [PRE_ACTIVATION_FIELD_EMAIL]: "Email",
  [PRE_ACTIVATION_FIELD_WHATSAPP]: "WhatsApp (con código de país)",
  [PRE_ACTIVATION_FIELD_WHAT_YOU_SELL]:
    "¿Qué vendes? Descríbelo en 2–3 oraciones",
  [PRE_ACTIVATION_HINT_WHAT_YOU_SELL]:
    "Incluye qué lo hace diferente de la competencia.",
  [PRE_ACTIVATION_FIELD_AVERAGE_PRICE]:
    "Precio promedio de tu producto o servicio",
  [PRE_ACTIVATION_HINT_AVERAGE_PRICE]:
    "Por unidad, pack o suscripción mensual. Indica la moneda.",
  [PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER]: "¿Quién es tu cliente ideal?",
  [PRE_ACTIVATION_HINT_IDEAL_CUSTOMER]:
    "Edad, género, intereses, ubicación, nivel socioeconómico.",
  [PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS]: "¿Dónde compra tu cliente?",
  [PRE_ACTIVATION_FIELD_WEBSITE_URL]: "URL de tu sitio web o tienda",
  [PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME]: "Ej: Natura Kids Colombia",
  [PRE_ACTIVATION_PLACEHOLDER_FULL_NAME]: "Nombre y apellido",
  [PRE_ACTIVATION_PLACEHOLDER_EMAIL]: "correo@empresa.com",
  [PRE_ACTIVATION_PLACEHOLDER_WHATSAPP]: "+57 300 123 4567",
  [PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL]:
    "Ej: Vendemos calzado ergonómico infantil que respeta la forma natural del pie. A diferencia de marcas nacionales, tenemos el mismo nivel de calidad que marcas internacionales pero fabricado localmente…",
  [PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE]:
    "Ej: $48.000 COP por par / USD 25 por unidad",
  [PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER]:
    "Ej: Mamás entre 25–45 años, NSE medio-alto, conscientes de la salud infantil, ubicadas en Colombia y México…",
  [PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL]: "https://tutienda.com",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB]: "Tienda web / e-commerce",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA]: "Tienda física",
  [PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP]: "WhatsApp / DM directo",
  [PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE]:
    "Marketplace (Mercado Libre, Amazon, etc.)",
  [PRE_ACTIVATION_SALES_CHANNEL_APP]: "App móvil",
  [PRE_ACTIVATION_FIELD_HAS_ADS]: "¿Ya inviertes en publicidad pagada?",
  [PRE_ACTIVATION_HAS_ADS_SI]: "Sí, tengo campañas activas",
  [PRE_ACTIVATION_HAS_ADS_ANTES]: "Sí, pero no tengo campañas activas ahora",
  [PRE_ACTIVATION_HAS_ADS_NO]: "No, es mi primera vez con publicidad pagada",
  [PRE_ACTIVATION_FIELD_AD_PLATFORMS]:
    "¿En qué plataformas tienes o tuviste campañas?",
  [PRE_ACTIVATION_ADS_PLATFORM_META]: "Meta Ads (Facebook / Instagram)",
  [PRE_ACTIVATION_ADS_PLATFORM_GOOGLE]: "Google Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_TIKTOK]: "TikTok Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_OTHER]: "Otro (LinkedIn, X, Pinterest, etc.)",
  [PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER]: "Especifica la plataforma",
  [PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND]:
    "¿Cuánto inviertes mensualmente en publicidad?",
  [PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND]:
    "Total entre todas las plataformas. Indica la moneda.",
  [PRE_ACTIVATION_FIELD_CURRENT_METRICS]: "Métricas actuales (si las tienes)",
  [PRE_ACTIVATION_HINT_CURRENT_METRICS]:
    "ROAS, CPA, CTR, conversiones por plataforma. No te preocupes si no los tienes a la mano.",
  [PRE_ACTIVATION_FIELD_TARGET_CPA]: "¿Cuál es tu CPA objetivo?",
  [PRE_ACTIVATION_HINT_TARGET_CPA]:
    "¿Cuánto estás dispuesto a pagar por cada venta o lead?",
  [PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES]:
    "¿Qué campañas o mensajes te han funcionado mejor?",
  [PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES]:
    "Formatos (video, imagen, carrusel), audiencias, ángulos creativos, etc. Si no tienes historial, déjalo vacío.",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND]:
    "Ej: USD 700 / mes · $3.000.000 COP / mes · No tengo inversión actual",
  [PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS]:
    "Ej: Meta Ads: ROAS 4.5, CPA $15.000 COP · Google Ads SEARCH: ROAS 5.15, 23 conversiones · No tengo datos todavía",
  [PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA]:
    "Ej: $6.000 COP por compra / USD 15 por lead",
  [PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES]:
    "Ej: Las imágenes estáticas en Instagram con descuento del 20% funcionan mejor que los videos. Las audiencias de mamás 28–40 años convierten mucho mejor…",
  [PRE_ACTIVATION_FIELD_MONTHLY_SALES]:
    "¿Cuáles son tus ventas actuales por mes?",
  [PRE_ACTIVATION_FIELD_SALES_GOAL_60_90]:
    "¿Cuál es tu objetivo de ventas a 60–90 días?",
  [PRE_ACTIVATION_FIELD_BUZZLY_FOCUS]:
    "¿Cuál es tu enfoque principal con Adle?",
  [PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE]:
    "Performance — quiero más ventas y resultados medibles",
  [PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO]:
    "Contenido — quiero generar creativos y anuncios de calidad con IA",
  [PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS]:
    "Ambos — performance y producción de contenido",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL]:
    "¿Tienes material creativo disponible?",
  [PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL]:
    "Fotos del producto, videos, logo en alta calidad, branding, etc.",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO]:
    "Sí, tengo bastante material listo",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO]: "Tengo algo, pero poco",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA]:
    "No, prefiero generarlo todo con IA en Adle",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION]:
    "¿Dónde está tu material creativo?",
  [PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES]:
    "¿Algo más que debamos saber antes de la reunión?",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES]:
    "Ej: 150 pares / mes · $8M COP / mes · 50 leads / mes",
  [PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90]:
    "Ej: 300 pares / mes · $20M COP / mes · 150 leads / mes",
  [PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION]:
    "Ej: Google Drive (te comparto link) · Dropbox · En mi teléfono · Lo tenemos en redes sociales",
  [PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES]:
    "Estacionalidad, lanzamientos próximos, restricciones de presupuesto, algo que no funcionó antes, lo que sea que nos ayude a prepararnos mejor…",
  [PRE_ACTIVATION_MEETING_INTRO]:
    "Para la reunión de activación necesitamos que tengas disponibles los accesos a tus plataformas publicitarias. Sin accesos, no podemos configurar las campañas durante la reunión.",
  [PRE_ACTIVATION_FIELD_MEETING_ACCESS]:
    "¿Cuáles de estos accesos tendrás disponibles para la reunión?",
  [PRE_ACTIVATION_MEETING_ACCESS_META_BM]:
    "Meta Business Manager (administrador)",
  [PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS]: "Google Ads (administrador)",
  [PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS]: "TikTok Ads Manager",
  [PRE_ACTIVATION_MEETING_ACCESS_GA4]: "Google Analytics 4 / GA4",
  [PRE_ACTIVATION_MEETING_ACCESS_PIXEL]: "Meta Pixel instalado en el sitio",
  [PRE_ACTIVATION_MEETING_ACCESS_GTM]: "Google Tag Manager",
  [PRE_ACTIVATION_FIELD_ACCESS_NOT_READY]:
    "¿Hay algún acceso que aún no tienes listo?",
  [PRE_ACTIVATION_HINT_ACCESS_NOT_READY]:
    "Cuéntanos para que podamos ayudarte a resolverlo antes de la reunión.",
  [PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY]:
    "Ej: Google Ads lo gestiona nuestra agencia anterior, estoy coordinando para que me den acceso. El Meta Pixel no sé si está instalado…",
  [PRE_ACTIVATION_ARIA_REQUIRED]: "obligatorio",
  [PRE_ACTIVATION_SUBMIT_BUTTON]: "Enviar formulario →",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE]: "Formulario Enviado",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE]:
    "Tu información se registró correctamente, estaremos contactándote pronto para agendar la reunión de activación.",
  [PRE_ACTIVATION_CONFIDENTIALITY_NOTE]:
    "Tu información es 100% confidencial y solo será usada por el equipo Adle para preparar tu activación.",
  [PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE]: "¿Eres agencia o marca?",
  [PRE_ACTIVATION_HINT_ORGANIZATION_TYPE]:
    "Selecciona el perfil que mejor describe tu operación para mostrarte las preguntas correctas.",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL]: "Agencia",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL]: "Marca",
  [PRE_ACTIVATION_FIELD_JOB_TITLE]: "Cargo / rol",
  [PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE]:
    "Ej: CEO, Media Buyer, Director de Marketing",
  [PRE_ACTIVATION_SECTION_AGENCY_01_BASICS]:
    "02 · Información básica de la agencia",
  [PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE]:
    "03 · La marca para el ejercicio en vivo",
  [PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS]: "04 · Su operación actual",
  [PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS]:
    "05 · Accesos para la llamada",
  [PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT]:
    "¿Cuántas personas del equipo van a usar Adle?",
  [PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT]:
    "Para preparar los asientos y la configuración de usuarios.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT]:
    "Ej: 3 media buyers + 1 director creativo",
  [PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS]:
    "¿Qué plataformas van a operar en Adle?",
  [PRE_ACTIVATION_FIELD_AGENCY_MODULES]: "¿Qué módulos vas a utilizar?",
  [PRE_ACTIVATION_HINT_AGENCY_MODULES]:
    "Selecciona todos los que apliquen. Con esto armamos el contenido de las dos sesiones.",
  [PRE_ACTIVATION_AGENCY_MODULE_CREATIVE]: "Diseño y generación de creativos",
  [PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA]:
    "Implementación y optimización de campañas y paid media",
  [PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL]:
    "Publicaciones a redes sociales",
  [PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS]:
    "Análisis de anuncios de la competencia",
  [PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME]:
    "¿Qué marca de tu portafolio quieres usar en las sesiones?",
  [PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME]:
    "Debe ser una marca real, activa y con activos disponibles.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME]:
    "Ej: Marca X — retail de belleza",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY]:
    "¿Tienen los activos de esa marca listos para compartir — logos, paletas, fotos de producto?",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY]:
    "Así podemos avanzar más rápido durante la sesión en vivo.",
  [PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK]:
    "¿Qué parte del proceso creativo les consume más tiempo hoy?",
  [PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK]:
    "Briefs, producción, adaptaciones, aprobaciones, etc.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK]:
    "Ej: Adaptar creativos a múltiples formatos y marcas consume la mayor parte del tiempo del equipo.",
  [PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION]:
    "¿Están usando alguna herramienta de automatización de pauta actualmente?",
  [PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION]:
    "Reglas, scripts, herramientas de bulk edit, etc.",
  [PRE_ACTIVATION_OPTION_YES]: "Sí",
  [PRE_ACTIVATION_OPTION_NO]: "No",
  [PRE_ACTIVATION_BEFORE_START_LABEL]: "Antes de empezar",
  [PRE_ACTIVATION_BEFORE_START_TITLE]: "Cómo sacarle el máximo a tu activación",
  [PRE_ACTIVATION_BEFORE_START_INTRO]:
    "Son dos sesiones y la segunda construye sobre la primera. No se repiten: lo que no se alcanza a cubrir, no se retoma. Cinco cosas marcan la diferencia.",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE]: "Que asista quien va a operar",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION]:
    "La capacitación no es delegable. Si va una persona y luego le explica al resto, terminan conviviendo dos formas de trabajar. Asegúrate de que quienes vayan a operar la plataforma bloqueen la agenda de las dos sesiones.",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE]:
    "Que la dirección esté en la primera sesión",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION]:
    "Es el punto más importante de esta lista. Cuando el dueño o el director de la agencia entra a la primera sesión, el equipo entiende que Adle es la plataforma con la que se va a operar y no una prueba paralela que se puede abandonar cuando aparezca la primera fricción. Sin esa señal, la gente vuelve a su forma habitual de trabajar a los pocos días y la activación se queda en el aire.\n\nSi además puede acompañar la segunda sesión, mucho mejor: es la que muestra el resultado real y de ahí salen las decisiones de escalar.",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE]:
    "Deja la medición lista antes de la sesión 2",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION]:
    "Ahí lanzamos una campaña real. Si el píxel no está instalado o los eventos de conversión no están configurados, no hay lanzamiento y se reprograma. Encárgaselo a quien lleve la parte técnica de esa marca.",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE]:
    "Ten los accesos y los activos a mano",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION]:
    "Tú conectas tus cuentas en la primera sesión, así que quien asista necesita ser administrador ese día. Ten también a mano los activos de la marca, como logos, paleta, tipografías y fotos de producto, para contrastar en vivo lo que la IA genera desde tu sitio web y corregirlo ahí mismo si hace falta.",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE]:
    "Elige bien la marca del ejercicio",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION]:
    "Todo se hace sobre una sola. Escoge una activa, con activos disponibles y con medición funcionando. Las demás las replicas tú después.",
  [PRE_ACTIVATION_BEFORE_START_CALLOUT]:
    "Si el formulario llega incompleto o los accesos no están listos, la sesión se reprograma sin costo, pero el ciclo de tu plan sigue corriendo desde la fecha de tu primer pago.",
  [PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN]: "LinkedIn Ads",
  [PRE_ACTIVATION_FIELD_AGENCY_PHONE]: "Teléfono",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE]: "+57 300 000 0000",
  [PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE]: "Cargo",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE]: "Ej: Director de medios",
  [PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT]: "Responsable suplente",
  [PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT]:
    "Una segunda persona con capacidad de decisión, a quien podamos escribir si el responsable principal no está disponible",
  [PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT]:
    "¿Quién de la dirección va a acompañar la activación?",
  [PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT]:
    "Su participación en la primera sesión es indispensable. Es la señal de que el equipo puede priorizar la activación",
  [PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY]:
    "Información de la persona responsable de la activación y de los contactos de respaldo.",
  [PRE_ACTIVATION_SECTION_AGENCY_02_TITLE]: "02 · Módulos",
  [PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE]:
    "Alimenta la Sesión 1 · Configuración",
  [PRE_ACTIVATION_SECTION_AGENCY_03_TITLE]: "03 · Tu equipo",
  [PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE]:
    "Alimenta la Sesión 1 · Capacitación",
  [PRE_ACTIVATION_SECTION_AGENCY_04_TITLE]: "04 · La marca del ejercicio",
  [PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE]:
    "Alimenta la Sesión 1 · Configuración base",
  [PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION]:
    "Toda la activación se ejecuta sobre una sola marca. Las demás las configuras tú después, replicando el mismo flujo.",
  [PRE_ACTIVATION_SECTION_AGENCY_05_TITLE]: "05 · Agenda tu primera sesión",
  [PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE]:
    "Sesión 1 · Onboarding y configuración",
  [PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION]:
    "Agenda aquí tu sesión de onboarding. La segunda la coordinamos contigo al cierre de la primera, cuando ya sepamos cómo viene tu configuración.",
  [PRE_ACTIVATION_SECTION_AGENCY_06_TITLE]: "06 · Confirmaciones",
  [PRE_ACTIVATION_SECTION_AGENCY_06_HEADING]: "Antes de enviar",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME]: "Nombre y apellido",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL]: "Email",
  [PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY]:
    "¿Qué tan familiarizado está el equipo con la gestión de pauta?",
  [PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY]:
    "Nos permite ajustar el ritmo y la profundidad de la primera sesión.",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED]:
    "Avanzado — estructuran y optimizan campañas a diario",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE]:
    "Intermedio — lanzan campañas pero no optimizan de forma sistemática",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL]:
    "Inicial — el equipo está aprendiendo paid media",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED]:
    "Mixto — hay perfiles de ambos niveles",
  [PRE_ACTIVATION_AGENCY_TEAM_CALLOUT]:
    "La capacitación no es delegable: quien opera la plataforma es quien se capacita, y debe asistir a las dos sesiones.",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE]: "URL del sitio web de esa marca",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE]:
    "De aquí nuestra IA extrae la identidad visual, el idioma y el contexto de negocio para dejarte la marca preconfigurada antes de la primera sesión",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE]: "https://www.marca.com",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON]: "Agendar mi sesión de onboarding →",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT]:
    "Para agendar la sesión debes completar la información de las secciones anteriores.",
  [PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL]:
    "Modal para agendar la sesión de onboarding",
  [PRE_ACTIVATION_ONBOARDING_MODAL_TITLE]: "Agendar sesión de onboarding",
  [PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION]:
    "Elige fecha y hora para tu sesión de onboarding.",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TITLE]: "Sesión agendada",
  [PRE_ACTIVATION_SCHEDULED_SESSION_DATE]: "Fecha",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TIME]: "Hora",
  [PRE_ACTIVATION_SCHEDULED_SESSION_MISSING]:
    "Esta solicitud no tiene una sesión de onboarding agendada.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND]:
    "Entiendo que la activación cubre una sola marca, y que las demás las configuro yo replicando el mismo flujo.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN]:
    "Entiendo que mi equipo conecta sus propias cuentas publicitarias durante la sesión 1 y conserva su administración.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE]:
    "Entiendo que si la información o los accesos no están listos, la sesión se reprograma sin costo, pero el ciclo de mi plan sigue corriendo desde la fecha del primer pago.",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY]:
    "Tu información se registró correctamente.",
  [OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE]: "Perfil",

  // TIKTOK ADGROUP PLACEMENTS
  [TIKTOK_ADGROUP_PLACEMENTS_TITLE]: "Emplazamientos",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL]: "TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION]:
    "Muestra tus anuncios en TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL]: "Pangle",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION]:
    "Pangle, la red publicitaria de TikTok for Business, permite a los anunciantes llegar a los usuarios en aplicaciones y sitios web que no pertenecen a TikTok.",

  // APPSUMO CALLBACK
  [APPSUMO_CALLBACK_CONNECTING]: "Conectando con AppSumo…",
  [APPSUMO_CALLBACK_ERROR_TITLE]: "Error de conexión",
  [APPSUMO_CALLBACK_ERROR_DESCRIPTION]:
    "Ocurrió un error al conectar tu cuenta de AppSumo. Por favor intenta de nuevo desde AppSumo o contacta a soporte.",
  [APPSUMO_CALLBACK_ERROR_CODE_EXPIRED]:
    "Este enlace ha expirado o ya fue utilizado. Por favor reinicia el proceso desde AppSumo.",
  [APPSUMO_CALLBACK_ERROR_OAUTH_DENIED]:
    "El acceso fue denegado. Por favor intenta de nuevo desde AppSumo.",
  [APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO]: "Volver a AppSumo",
  [APPSUMO_CALLBACK_ERROR_ANOMALOUS]:
    "Ocurrió un error inesperado con tu cuenta. Por favor contacta a soporte.",

  // MODAL PERFORMANCE MARKETING SPECIALIST
  [BUTTON_HIRE_PERFORMANCE_SPECIALIST]: "Contratar Especialista",
  [MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL]:
    "Modal de Especialista en Performance Marketing",
  [MODAL_PERFORMANCE_SPECIALIST_TITLE]: "Especialista en Performance Marketing",
  [MODAL_PERFORMANCE_SPECIALIST_SUBTITLE]:
    "Servicio 100% gestionado por nosotros: Definimos junto a ti los objetivos, nosotros ejecutamos, optimizamos y reportamos.",
  [MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE]: "Qué haremos por ti",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_1]: "Estrategia y definición de KPIs",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_2]:
    "Optimización continua en Meta, Google y TikTok",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_3]:
    "Revisión de tracking, medición y atribución",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_4]:
    "Insights semanales y reporte mensual",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE]: "Precio y condiciones",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN]:
    "USD 499/mes + {{percentage}}% del gasto publicitario mensual",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1]:
    "La inversión en anuncios no está incluida y se paga directamente a las plataformas.",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2]:
    "Cláusula de permanencia de 3 meses.",
  [MODAL_PERFORMANCE_SPECIALIST_CTA]: "Contratar Especialista",

  // MODAL AD HOC SUPPORT
  [MODAL_AD_HOC_SUPPORT_ARIA_LABEL]: "Modal de sesión de soporte",
  [MODAL_AD_HOC_SUPPORT_TITLE]: "Sesión de Soporte",
  [MODAL_AD_HOC_SUPPORT_DESCRIPTION]:
    "Agenda una sesión de soporte con nuestro equipo para potenciar tus resultados.",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE]: "Pago Exitoso",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION]:
    "Has contratado un especialista, el próximo paso es agendar una reunión con nuestro equipo",
  [BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON]: "Agendar Reunión",

  // APPSUMO REGISTER
  [APPSUMO_REGISTER_TITLE]: "Crea tu cuenta",
  [APPSUMO_REGISTER_SUBTITLE]:
    "Completa tu registro para activar tu licencia de AppSumo.",
  [APPSUMO_REGISTER_BUTTON_SUBMIT]: "Crear cuenta",
  [APPSUMO_REGISTER_SESSION_EXPIRED]:
    "Tu sesión ha expirado. Por favor reinicia el proceso desde AppSumo.",
  [APP_SUMO_REACTIVATION_NOT_ELIGIBLE]:
    "Esta cuenta no puede reactivarse por AppSumo. Intenta iniciar sesión o contacta soporte.",
  [APPSUMO_REACTIVATION_OTP_TITLE]: "Reactiva tu cuenta",
  [APPSUMO_REACTIVATION_OTP_EMAIL_SENT]:
    "Enviamos un código de reactivación a {{emailMasked}}.",

  // ENTERPRISE INTAKE
  [ENTERPRISE_INTAKE_BADGE]: "Enterprise Intake",
  [ENTERPRISE_INTAKE_BADGE_AGENCY]: "PROPUESTA ENTERPRISE · AGENCIAS",
  [ENTERPRISE_INTAKE_BADGE_BRAND]: "PROPUESTA ENTERPRISE · MARCAS",
  [ENTERPRISE_INTAKE_HERO_TITLE]: "Formulario Enterprise Intake",
  [ENTERPRISE_INTAKE_HERO_DESCRIPTION]:
    "Con estas respuestas preparamos una propuesta a la medida de tu operación. Tiempo estimado: 5 minutos.",
  [ENTERPRISE_INTAKE_SECTION_01_CONTACT]: "Contacto",
  [ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR]: "Alcance",
  [ENTERPRISE_INTAKE_SECTION_03_USERS]: "Usuarios",
  [ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT]: "Plan",
  [ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES]: "Notas adicionales",
  [ENTERPRISE_INTAKE_ARIA_REQUIRED]: "obligatorio",
  [ENTERPRISE_INTAKE_SUBMIT_BUTTON]: "Enviar formulario →",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE]: "Formulario Enviado",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE]:
    "Tu información se registró correctamente. Prepararemos tu propuesta Enterprise en 24–48 horas y nos pondremos en contacto contigo.",
  [ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE]:
    "Tu información es 100% confidencial y solo será usada por el equipo Adle para preparar tu propuesta Enterprise.",
  [ENTERPRISE_INTAKE_OTHER_OPTION]: "Otro",
  [ENTERPRISE_INTAKE_OTHER_PLACEHOLDER]: "Especifica aquí…",

  [ENTERPRISE_INTAKE_FIELD_FULL_NAME]: "Nombre completo",
  [ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL]: "Email corporativo",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_NAME]: "Empresa",
  [ENTERPRISE_INTAKE_FIELD_JOB_TITLE]: "Cargo",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE]: "Sitio web de la empresa",
  [ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME]: "Ej: María García",
  [ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL]: "Ej: maria@empresa.com",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME]: "Ej: Agencia Digital S.A.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE]: "Ej: Head of Marketing",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE]:
    "Ej: https://www.empresa.com",

  [ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER]:
    "¿Quién toma la decisión final de compra?",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF]: "Yo soy el decisor",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO]:
    "Recopilo la información, otra persona/área decide",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED]:
    "Decisión compartida entre varias áreas",
  [ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS]:
    "¿Actualmente usan otra herramienta o ya son clientes de Adle?",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT]:
    "Somos clientes actuales de Adle (renovación / ampliación)",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH]:
    "Usamos otra herramienta y estamos evaluando cambiarnos",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR]:
    "No usamos ninguna herramienta similar hoy",
  [ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT]:
    "¿En cuántos países / mercados operan?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT]: "Ej: 3",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET]:
    "Si operan en varios mercados, ¿los creativos varían por país/idioma?",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET]:
    "Sí, cada mercado necesita sus propias versiones",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY]:
    "Parcialmente — algunos assets se adaptan por mercado",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL]:
    "No, se usa el mismo material en todos",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE]: "No aplica",

  [ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES]:
    "Puedes marcar varios. Según lo que marques, aparecen las secciones de assets creativos y de campañas.",
  [ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES]:
    "¿Qué módulos de Adle van a utilizar?",
  [ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS]:
    "Módulo 1 · Generación de assets creativos: imágenes, adaptaciones, animaciones y videos",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH]:
    "Módulo 2 · Implementación de campañas: crear y lanzar campañas desde Adle",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT]:
    "Módulo 3 · Monitoreo y optimizaciones: aplicar optimizaciones a las campañas",
  [ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL]:
    "Módulo 6 · Social media: programar publicaciones en redes sociales",
  [ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL]:
    "Objetivo principal que buscan resolver con Adle",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED]:
    "Aumentar velocidad y volumen de creativos",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE]:
    "Mejorar performance / ROI de campañas",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM]:
    "Escalar campañas multiplataforma",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS]:
    "Reducir costos de producción de activos",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS]:
    "Centralizar operación de múltiples marcas/anunciantes",
  [ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND]: "Estable todo el año",
  [ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND]: "Tiene picos de alta demanda",

  [ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS]: "Assets creativos",
  [ENTERPRISE_INTAKE_MODULE1_INTRO]:
    "Aparece y es obligatoria solo si marcaste el Módulo 1. Cada formato y cada frame de carrusel cuenta como una pieza.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT]:
    "¿Cuántas piezas estáticas necesitan al mes?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT]:
    "¿Cuántas marcas o identidades visuales manejarán en el módulo creativo?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT]:
    "¿Cuántas configuraciones de marca INDEPENDIENTES necesitan?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS]:
    "Cada marca o sub-marca con su propio brandbook / identidad visual distinta requiere una configuración independiente para que la IA genere assets alineados. Ej: una marca con 3 sub-marcas visualmente distintas = 3 configuraciones.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG]:
    "En promedio, ¿a cuántos formatos / placements adaptan cada pieza?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE]:
    "Ej: si una imagen se publica en feed, stories y un banner, son 3 formatos. Al operar en varias plataformas este número suele estar entre 3 y 5. Cada adaptación de formato cuenta como una acción independiente.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT]:
    "¿Cuántas adaptaciones / ediciones ADICIONALES hacen al mes? (opcional)",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS]:
    "Ediciones o versiones que no son adaptación de formato — cambios de texto, retoques, etc.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT]:
    "¿Cuántos videos al mes?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS]:
    "Hasta 30 segundos, con guion, audio y subtítulos.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT]:
    "¿Cuántas animaciones al mes?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS]:
    "Movimiento sobre una pieza estática ya aprobada.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL]:
    "¿Cuántas versiones o ajustes hacen por pieza antes de aprobarla?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE]:
    "Cada iteración cuenta como una acción.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION]:
    "¿El volumen creativo varía entre meses?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT]:
    "Si tiene picos: ¿cuántas piezas en un mes ALTO?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH]: "Campañas",
  [ENTERPRISE_INTAKE_MODULE2_INTRO]:
    "Aparece y es obligatoria solo si marcaste el Módulo 2 o el Módulo 3.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT]:
    "¿Cuántas campañas van a implementar al mes, en total?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT]:
    "¿Cuántas cuentas publicitarias / anunciantes conectarán?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS]:
    "Cada campaña se cuenta POR PLATAFORMA. Una campaña en Meta, Google y TikTok cuenta como 3. Indica el total de activaciones por canal.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT]:
    "¿Cuántas optimizaciones en un mes promedio?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS]:
    "Ajustes de rendimiento sobre campañas activas. Considera que cada campaña activa suele requerir varios ajustes al mes para mantener su rendimiento; no subestimes este volumen si gestionan muchas campañas.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION]:
    "¿El volumen de campañas varía entre meses?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT]:
    "Si tiene picos: ¿cuántas campañas en un mes ALTO?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT]:
    "Módulo 3 — Importación de Campañas Paid Media",
  [ENTERPRISE_INTAKE_MODULE3_INTRO]:
    "Responde solo si marcaste este módulo. Si no aplica, salta a la siguiente sección.",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT]:
    "¿Cuántas campañas importarían? (una sola vez, al inicio)",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS]:
    "¿Desde qué plataformas importarían? (marca todas)",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_META]: "Meta",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE]: "Google",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN]: "LinkedIn",

  [ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL]:
    "Módulo 4 — Social Media / Publicaciones Orgánicas",
  [ENTERPRISE_INTAKE_MODULE4_INTRO]:
    "Responde solo si marcaste este módulo. Si no aplica, salta a la siguiente sección.",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS]:
    "¿Cuántas publicaciones orgánicas programan en un mes promedio?",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS]:
    "¿A qué redes programarían? (marca todas)",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM]: "Instagram",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK]: "Facebook",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER]: "X / Twitter",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE]:
    "¿Las publicaciones se crean en Adle o vienen listas?",
  [ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE]:
    "Se crean en Adle (creativo + copy)",
  [ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE]:
    "Vienen listas, Adle solo programa",
  [ENTERPRISE_INTAKE_MODULE4_POST_MIXED]: "Mixto",

  [ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1]:
    "¿Cuántos anunciantes estarán ACTIVOS en Adle durante el primer mes?",
  [ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1]:
    "Los que realmente operarán desde el inicio",
  [ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90]:
    "En los próximos 60–90 días, ¿cuál será el TOTAL de anunciantes que esperan gestionar?",
  [ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90]:
    "Incluye los del mes 1 + los que se sumen después",
  [ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1]:
    "¿Tienen acceso administrador a las cuentas publicitarias a conectar?",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL]: "Sí, a todas",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST]: "A la mayoría",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME]: "A algunas / aún no",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT]:
    "¿Cuántos usuarios necesitan acceso?",
  [ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT]:
    "¿Cómo se gestionará el uso de la capacidad de la plataforma?",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL]:
    "Pool centralizado (todos comparten el total)",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS]:
    "Cuotas asignadas por cuenta / marca",
  [ENTERPRISE_INTAKE_CREDITS_MIXED]: "Mixto",

  [ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE]:
    "Equivalencias de créditos (modelo vigente Adle)",
  [ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE]:
    "Los créditos se renuevan mensualmente y no son acumulables.",
  [ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE]:
    "Si no estás 100% seguro de los volúmenes, elige el rango más cercano. En la llamada de validación ajustamos el estimado.",
  [ENTERPRISE_INTAKE_VOLUME_ZERO]: "0 — no usaré",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS]:
    "Estimado total de créditos a consumir por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS]:
    "Si no estás 100% seguro de los volúmenes, elige el rango más cercano o déjalo en blanco y lo calculamos nosotros",

  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES]:
    "Imágenes con IA estimadas por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES]:
    "Número aproximado de imágenes con IA generadas al mes",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS]:
    "Videos con IA estimados por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS]:
    "Número aproximado de videos con IA generados al mes",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS]:
    "Campañas con IA estimadas por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS]:
    "Número aproximado de campañas con IA creadas al mes",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS]:
    "Optimizaciones con IA estimadas por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS]:
    "Número aproximado de optimizaciones con IA ejecutadas al mes",
  [ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING]:
    "¿Usarán programación de publicaciones orgánicas?",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS]:
    "Publicaciones orgánicas estimadas por mes",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS]:
    "Número aproximado de publicaciones orgánicas programadas al mes",
  [ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS]:
    "¿En qué canales activan campañas? (marca todos)",
  [ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS]:
    "Selecciona todos los que apliquen",
  [ENTERPRISE_INTAKE_CHANNEL_META]: "Meta (Facebook / Instagram)",
  [ENTERPRISE_INTAKE_CHANNEL_GOOGLE]: "Google (Ads / Display)",
  [ENTERPRISE_INTAKE_CHANNEL_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_CHANNEL_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE]:
    "Rango de inversión publicitaria mensual (Ad Spend) que gestionará Adle",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE]:
    "No incluye el costo de la plataforma",
  [ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K]: "Menos de $10k USD",
  [ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K]: "Más de $500k USD",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT]:
    "¿Quién va a gestionar la plataforma?",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT]:
    "Define si se requiere kick-off de capacitación con costo",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM]:
    "Nuestro propio equipo (requiere capacitación / kick-off)",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY]:
    "Un tercero / agencia lo gestiona por nosotros",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES]:
    "Adle opera la plataforma por nosotros",
  [ENTERPRISE_INTAKE_FIELD_WHITE_LABEL]: "¿Requieren white label?",
  [ENTERPRISE_INTAKE_HINT_WHITE_LABEL]:
    "La plataforma con la marca de ustedes. Solo con contrato de 12 meses y se cotiza aparte.",
  [ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL]: "Sí, es indispensable",
  [ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED]:
    "Nos interesa, pero no es indispensable",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED]: "No lo necesitamos",
  [ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE]: "No estoy seguro / lo conversamos",
  [ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE]:
    "¿Tienen una fecha límite o evento que marque urgencia?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE]:
    "Ej: vencimiento de contrato actual, lanzamiento de campaña, presentación a un cliente",
  [ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET]:
    "¿Tienen un presupuesto estimado contemplado para esta herramienta?",
  [ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET]:
    "Nos ayuda a aterrizar la propuesta a su realidad. Es referencial, no un compromiso.",
  [ENTERPRISE_INTAKE_BUDGET_LT_1000]: "Menos de $1,000 USD/mes",
  [ENTERPRISE_INTAKE_BUDGET_1000_2500]: "$1,000 – $2,500 USD/mes",
  [ENTERPRISE_INTAKE_BUDGET_2500_5000]: "$2,500 – $5,000 USD/mes",
  [ENTERPRISE_INTAKE_BUDGET_5000_10000]: "$5,000 – $10,000 USD/mes",
  [ENTERPRISE_INTAKE_BUDGET_GT_10000]: "Más de $10,000 USD/mes",
  [ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED]:
    "Aún no tenemos un presupuesto definido",
  [ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER]: "Prefiero no responder",

  [ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL]:
    "Nivel de soporte y operación requerido",
  [ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY]:
    "Solo tecnología (autogestión + soporte técnico estándar)",
  [ENTERPRISE_INTAKE_SUPPORT_PARTIAL]:
    "Acompañamiento parcial (CSM + adopción / estrategia)",
  [ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION]:
    "Operación completa (Adle ejecuta)",
  [ENTERPRISE_INTAKE_FIELD_CSM_CADENCE]:
    "Cadencia de contacto con el Customer Success Manager (CSM)",
  [ENTERPRISE_INTAKE_CSM_WEEKLY]: "Semanal",
  [ENTERPRISE_INTAKE_CSM_BIWEEKLY]: "Quincenal",
  [ENTERPRISE_INTAKE_CSM_MONTHLY]: "Mensual",
  [ENTERPRISE_INTAKE_CSM_AS_NEEDED]: "Solo cuando sea necesario",
  [ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT]:
    "¿Por cuánto tiempo sería el contrato?",
  [ENTERPRISE_INTAKE_CONTRACT_MONTHLY]: "Mensual (máxima flexibilidad)",
  [ENTERPRISE_INTAKE_CONTRACT_QUARTERLY]: "Trimestral",
  [ENTERPRISE_INTAKE_CONTRACT_ANNUAL]: "Anual (mejor tarifa)",
  [ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE]:
    "Horizonte de implementación deseado",
  [ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE]: "Desde firma hasta Go-Live",
  [ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS]: "0–3 días",
  [ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS]: "4–7 días",
  [ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS]: "8–15 días",
  [ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS]: "16–30 días",
  [ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS]: "Más de 30 días",
  [ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS]:
    "Requerimientos de seguridad / IT",
  [ENTERPRISE_INTAKE_SECURITY_SSO]: "SSO (Single Sign-On) requerido",
  [ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS]: "Logs de auditoría y control de IP",
  [ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE]:
    "No aplica — solo acceso por email y contraseña",

  [ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES]: "¿Algo más que debamos saber?",
  [ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES]:
    "Ej: es para una licitación con fecha límite, integraciones o restricciones de IT.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES]:
    "Ej: es para una licitación con fecha límite, integraciones o restricciones de IT.",
  [ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES]:
    "Con base en tus respuestas, agendaremos una llamada de validación para afinar el estimado antes de la propuesta final.",

  [ENTERPRISE_INTAKE_MODULE_REPORTS]:
    "Módulo 4 · Reportes: visualizar, analizar y descargar",
  [ENTERPRISE_INTAKE_MODULE_COMPETITORS]:
    "Módulo 5 · Competidores: analizar anuncios de la competencia y usarlos como referencia para generar contenido",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT]:
    "¿Cuántas marcas van a configurar en Adle?",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY]:
    "¿Cuántas marcas o anunciantes van a configurar en Adle?",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY]:
    "Cada marca tiene su propia configuración para generar contenido: brandbook, tono y voz, identidad visual, tipografías, colores, buyer persona y audiencia. Si una submarca tiene un estilo distinto, cuenta aparte. Las cuentas publicitarias, páginas de Facebook, perfiles de Instagram y plataformas (Meta, Google, TikTok, LinkedIn) de una misma marca no cuentan aparte. Si solo van a usar el módulo de campañas, cuenta cada anunciante.",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND]:
    "Cada marca tiene su propia configuración para generar contenido: brandbook, tono y voz, identidad visual, tipografías, colores, buyer persona y audiencia. Si una submarca tiene un estilo distinto, cuenta aparte. Las cuentas publicitarias, páginas de Facebook, perfiles de Instagram y plataformas (Meta, Google, TikTok, LinkedIn) de una misma marca no cuentan aparte. Si solo van a usar el módulo de campañas, cuenta cada marca que pauta.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT]: "Número",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND]: "Ej: Marca S.A.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES]:
    "Ej: 100 piezas en 3 formatos son 300 piezas.",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER]:
    "¿Quieren holgura? ¿Para qué generaciones?",
  [ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER]:
    "Margen extra sobre el volumen del mes para ajustes y nuevas versiones: cada ajuste consume lo mismo que generar la pieza de nuevo. Los planes Enterprise suelen tomar 15%. Ej: 100 estáticas con 15% = 115 en el plan.",
  [ENTERPRISE_INTAKE_BUFFER_STATICS]: "Estáticas",
  [ENTERPRISE_INTAKE_BUFFER_ANIMATIONS]: "Animaciones",
  [ENTERPRISE_INTAKE_BUFFER_VIDEOS]: "Videos",
  [ENTERPRISE_INTAKE_BUFFER_NONE]: "No necesitamos holgura",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT]: "¿De cuánto?",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_10]: "10%",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_15]: "15% · recomendado",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_20]: "20%",
  [ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER]: "Ej: 25",
  [ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION]:
    "Aparece y es obligatoria solo si marcaste el Módulo 2 o el Módulo 3.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY]:
    "Sumando todas las plataformas y anunciantes.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND]:
    "Sumando todas las plataformas y marcas.",
  [ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY]:
    "¿Con qué frecuencia optimizan cada campaña?",
  [ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY]:
    "Cada optimización sugerida por la IA que se aplica consume créditos; las que no se aplican y los ajustes manuales no consumen.",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW]:
    "Baja: 1 vez por semana (4 al mes por campaña)",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM]:
    "Media: 2 veces por semana (8 al mes por campaña) · recomendado",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH]:
    "Alta: 3 o más por semana (12 al mes por campaña)",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT]:
    "Quien solo aprueba piezas no necesita usuario.",
  [ENTERPRISE_INTAKE_HINT_CONTRACT_TERM]:
    "Mínimo 6 meses. Con 12 meses la tarifa mensual es menor.",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_6]: "6 meses",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_12]: "12 meses · mejor tarifa",
  [ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON]:
    "¿Quieren que el equipo de Adle gestione la estrategia y la pauta?",
  [ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON]:
    "El add-on de gestión equivale al 15% de la inversión mensual en medios.",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_YES]: "Sí, con el add-on de gestión",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_NO]: "No, nuestro equipo opera la plataforma",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND]:
    "¿Cuánto invierten al mes en medios, sumando todas las plataformas?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND]: "USD al mes",
  [ENTERPRISE_INTAKE_WHITE_LABEL_YES]: "Sí",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NO]: "No",
  [ENTERPRISE_INTAKE_SECTION_PLAN]: "Plan",

  [OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION]: "Pre-activación",
  [OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE]: "Enterprise",

  [OPTION_EMAIL]: "Email",
  [OPTION_META]: "Meta (Instagram o Facebook)",
  [OPTION_GOOGLE]: "Google",
  [OPTION_LINKEDIN]: "LinkedIn",
  [OPTION_LLM]: "LLM (ChatGPT, Grok, Claude, Gemini, etc.)",
  [OPTION_OTHER]: "Otro",

  [GLOBAL_REPORT_TITLE]: "Reportes",
  [GLOBAL_REPORT_DESCRIPTION]:
    "Conoce el rendimiento de tus campañas en el periodo seleccionado.",
  [GLOBAL_REPORT_MENU_GROUP]: "Reportes / Métricas",
  [GLOBAL_REPORT_MENU_ITEM]: "Reportes",
  [GLOBAL_REPORT_PAGE_TITLE]: "Reporte Global de Marca — {{brandName}}",
  [GLOBAL_REPORT_PERIOD_LAST_7_DAYS]: "Últimos 7 días",
  [GLOBAL_REPORT_PERIOD_LAST_14_DAYS]: "Últimos 14 días",
  [GLOBAL_REPORT_PERIOD_LAST_30_DAYS]: "Últimos 30 días",
  [GLOBAL_REPORT_AI_ANALYSIS]: "Agente",
  [GLOBAL_REPORT_OBJECTIVES_BUTTON]: "Objetivos",
  [GLOBAL_REPORT_TOTAL_INVESTMENT]: "Inversión total",
  [GLOBAL_REPORT_AVERAGE_ROAS]: "ROAS promedio",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS]: "Campañas activas",
  [GLOBAL_REPORT_REMAINING_BUDGET]: "Presupuesto restante",
  [GLOBAL_REPORT_BUDGET_EXPIRES_IN]: "Caduca en {{days}} días",
  [GLOBAL_REPORT_PAUSED_CAMPAIGNS]: "{{count}} pausadas",
  [GLOBAL_REPORT_VS_PREVIOUS_WEEK]: "vs semana anterior",
  [GLOBAL_REPORT_AGENT_INSIGHTS]: "Insights",
  [GLOBAL_REPORT_NEW_INSIGHTS]: "{{count}} nuevos",
  [GLOBAL_REPORT_NO_INSIGHTS]:
    "No hay insights disponibles para este periodo. Prueba con un rango de fechas distinto o cuando haya más actividad en tus campañas.",
  [GLOBAL_REPORT_INSIGHTS_ERROR]:
    "No se pudieron generar los insights. Inténtalo de nuevo más tarde.",
  [GLOBAL_REPORT_SUMMARY_TITLE]: "Resumen del periodo",
  [GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT]:
    "¿Cómo fue el performance general del portfolio entre {{startDateTime}} y {{endDateTime}}? Incluye cuántas campañas corrieron o se crearon en el periodo, las métricas agregadas (inversión, ROAS, impresiones, clics) y un párrafo conciso con los hallazgos principales.",
  [GLOBAL_REPORT_INSIGHTS_QUESTION]:
    "Genera insights de portfolio para próximas campañas: qué debo repetir o hacer de nuevo (lo que funcionó), qué debo evitar o dejar de hacer (lo que falló) y advertencias. Básalos en métricas semanales, copy de anuncios (ángulos, hooks, pain points, CTAs, titulares) y registros de cambios. Sé específico y accionable — nada genérico.",
  [GLOBAL_REPORT_GENERATING_SUMMARY]: "Generando resumen...",
  [GLOBAL_REPORT_SUMMARY_NOT_GENERATED]:
    "No se pudo generar el resumen para este periodo.",
  [GLOBAL_REPORT_ASK_QUESTION]: "Pregunta al agente sobre este reporte...",
  [GLOBAL_REPORT_ASK_QUESTION_OPEN]: "Pregúntame sobre tus campañas",
  [GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS]: "Ver todos los insights históricos",
  [GLOBAL_REPORT_AGENT_ACTIONS]: "Resumen de acciones del agente",
  [GLOBAL_REPORT_ACTIONS_PERFORMED]: "Acciones realizadas",
  [GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN]: "{{count}} campañas creadas",
  [GLOBAL_REPORT_ACTION_TYPE_CREATIVES]: "{{count}} imágenes generadas",
  [GLOBAL_REPORT_ACTION_TYPE_VIDEOS]: "{{count}} videos producidos",
  [GLOBAL_REPORT_ACTION_TYPE_MESSAGES]: "{{count}} optimizaciones aplicadas",
  [GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED]:
    "{{count}} optimizaciones aplicadas",
  [GLOBAL_REPORT_ACTION_TYPE_GENERIC]: "{{count}} acciones realizadas",
  [GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE]: "Creativos generados con IA",
  [GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE]: "Videos generados con IA",
  [GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE]:
    "Optimizaciones y mensajes del agente",
  [GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE]: "Actividad registrada",
  [GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD]:
    "No hay acciones registradas en este periodo.",
  [GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD]:
    "No se encontraron campañas para este rango de fechas.",
  [GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD]:
    "No hay actividad de campañas en este periodo.",
  [GLOBAL_REPORT_SELECT_DATES_PROMPT]:
    "Selecciona un rango de fechas para generar tu reporte.",
  [GLOBAL_REPORT_MEASURABLE_KPI_LABEL]: "KPI medible",
  [GLOBAL_REPORT_MEASURABLE_KPI_ALL]: "Todos los resultados",
  [GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI]:
    "Ninguna campaña o plataforma en este periodo mide el KPI seleccionado.",
  [GLOBAL_REPORT_DOWNLOAD_NOT_READY]:
    "El reporte aún se está preparando. Espera un momento antes de descargarlo.",
  [GLOBAL_REPORT_PDF_OPTION]: "Reporte PDF",
  [GLOBAL_REPORT_CUSTOM_OPTION]: "Reporte Personalizado",
  [GLOBAL_REPORT_SERVER_PDF_BUTTON]: "Descargar PDF (servidor)",
  [GLOBAL_REPORT_SERVER_PDF_FOOTER]: "Adle · Reporte de leads · {{dateRange}}",
  [GLOBAL_REPORT_SERVER_PDF_FILE_NAME]: "Reporte_{{dateRange}}.pdf",
  [MODAL_CUSTOM_REPORT_CTA]: "Personalizar Reporte",
  [MODAL_CUSTOM_REPORT_TITLE]: "Generar Reporte Personalizado",
  [MODAL_CUSTOM_REPORT_DESCRIPTION]:
    "Elige una plantilla, el periodo y el formato para generar una presentación con los hallazgos de tus campañas.",
  [MODAL_CUSTOM_REPORT_TEMPLATE]: "Plantilla",
  [MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL]: "General",
  [MODAL_CUSTOM_REPORT_TEMPLATE_SALES]: "Ventas",
  [MODAL_CUSTOM_REPORT_TEMPLATE_LEADS]: "Leads",
  [MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM]: "Personalizado",
  [MODAL_CUSTOM_REPORT_PROMPT]: "Prompt",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER]:
    "Indica en qué quieres enfocar el reporte. Ej: Quiero que el reporte se enfoque en el análisis del rendimiento de los creativos y en qué ángulos de comunicación funcionaron mejor.",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV]:
    "Describe las filas y métricas del CSV. Ej: Campañas y anuncios, desglose semanal, inversión, impresiones, ROAS y unique outbound clicks.",
  [MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT]: "Usar un prompt anterior",
  [MODAL_CUSTOM_REPORT_DATES]: "Fechas",
  [MODAL_CUSTOM_REPORT_FORMAT]: "Formato del reporte",
  [MODAL_CUSTOM_REPORT_LANGUAGE]: "Idioma",
  [MODAL_CUSTOM_REPORT_FORMAT_PDF]: "PDF",
  [MODAL_CUSTOM_REPORT_FORMAT_PPTX]: "Presentación PowerPoint (editable)",
  [MODAL_CUSTOM_REPORT_FORMAT_CSV]: "CSV (Excel)",
  [MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE]:
    "La generación en PDF todavía no está disponible.",
  [MODAL_CUSTOM_REPORT_COLLECTING]: "Recopilando Información",
  [MODAL_CUSTOM_REPORT_ANALYZING]: "Analizando Información",
  [MODAL_CUSTOM_REPORT_RENDERING]: "Preparando Presentación",
  [MODAL_CUSTOM_REPORT_ERROR]:
    "No se pudo generar el reporte. Inténtalo de nuevo.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE]: "Prompts Anteriores",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION]:
    "Elige un prompt guardado o elimínalo de la lista.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY]:
    "Todavía no hay prompts personalizados guardados.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE]: "¿Eliminar este prompt?",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION]:
    "Se va a borrar de tus prompts guardados. Esta acción no se puede deshacer.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE]: "Eliminar prompt",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS]:
    "Recuperando la información de tus campañas",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS]:
    "Obteniendo las estadísticas de rendimiento",
  [GLOBAL_REPORT_HEAVY_LOAD_ANALYZING]: "Analizando la información recolectada",
  [GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS]:
    "Generando insights accionables",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE]: "Campañas activas",
  [GLOBAL_REPORT_CAMPAIGNS_TABLE]: "Campañas",
  [GLOBAL_REPORT_COLUMN_CAMPAIGN]: "Campaña",
  [GLOBAL_REPORT_COLUMN_INVESTMENT]: "Inversión",
  [GLOBAL_REPORT_COLUMN_ROAS]: "ROAS",
  [GLOBAL_REPORT_COLUMN_IMPRESSIONS]: "Impresiones",
  [GLOBAL_REPORT_COLUMN_CTR]: "CTR",
  [GLOBAL_REPORT_COLUMN_STATUS]: "Estado",
  [GLOBAL_REPORT_STATUS_ALERT]: "Alerta",
  [GLOBAL_REPORT_STATUS_OPTIMAL]: "Óptima",
  [GLOBAL_REPORT_STATUS_BRAND]: "Brand",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE]: "Caída de ROAS en Verano Running",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION]:
    "El ROAS cayó de 4.2x a 2.9x en 3 días. Posible saturación de audiencia en el segmento 25–34.",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE]: "Pico de CPC los martes",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION]:
    "El CPC sube 34% los martes por la mañana. Considera ajustar pujas por horario.",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE]:
    "Video 30s supera a imagen estática",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION]:
    "El CTR del video es 2.1x mayor en Meta. Oportunidad de escalar presupuesto en este formato.",
  [GLOBAL_REPORT_ACTION_DATE_TODAY]: "Hoy",
  [GLOBAL_REPORT_ACTION_DATE_YESTERDAY]: "Ayer",
  [GLOBAL_REPORT_ACTION_DATE_MAR_26]: "26 mar",
  [GLOBAL_REPORT_ACTION_DATE_MAR_25]: "25 mar",
  [GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED]: "2 campañas creadas",
  [GLOBAL_REPORT_ACTION_IMAGES_GENERATED]: "5 imágenes generadas",
  [GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED]: "3 videos producidos",
  [GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED]: "1 optimización aplicada",
  [GLOBAL_REPORT_DEFAULT_BRAND_NAME]: "Marca",
  [GLOBAL_REPORT_STATS_TIME_TITLE]: "Evolución",
  [GLOBAL_REPORT_STATS_TIME_SUBTITLE]: "Evolución diaria de gasto y resultados",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE]: "Evolución diaria de resultados",
  [GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE]: "Evolución semanal de resultados",
  [GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE]:
    "Evolución mensual de resultados",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE]:
    "Resultados por día en el periodo",
  [GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE]:
    "Evolución semanal de gasto y resultados",
  [GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE]:
    "Evolución mensual de gasto y resultados",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE]: "Impresiones y CTR",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolución diaria de impresiones y CTR",
  [GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolución semanal de impresiones y CTR",
  [GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolución mensual de impresiones y CTR",
  [GLOBAL_REPORT_STATS_PLATFORM_TITLE]: "Plataformas",
  [GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE]: "Resultados por plataforma",
  [GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE]: "CPA por plataforma",
  [GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE]: "Gasto por plataforma",
  [GLOBAL_REPORT_STATS_CREATIVES_TITLE]: "Anuncios",
  [GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE]:
    "Comparación de anuncios por eficiencia (CPA) y por volumen de resultados",
  [GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE]: "Menor CPA",
  [GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE]:
    "Mayor volumen de resultados",
  [GLOBAL_REPORT_STATS_RADAR_TITLE]: "Perfil multidimensional de campañas",
  [GLOBAL_REPORT_STATS_RADAR_SUBTITLE]:
    "Comparación normalizada de métricas clave por campaña",
  [GLOBAL_REPORT_STATS_BELOW_AVERAGE]: "Por debajo del promedio (escalar)",
  [GLOBAL_REPORT_STATS_ABOVE_AVERAGE]:
    "Por encima del promedio (revisar/pausar)",
  [GLOBAL_REPORT_STATS_NO_DATA]:
    "No hay datos suficientes para mostrar este gráfico.",
  [GLOBAL_REPORT_STATS_SPEND_AXIS]: "Gasto",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS]: "Impresiones",
  [GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION]: "Distribución de gasto",
  [GLOBAL_REPORT_GOALS_TITLE]: "Metas",
  [GLOBAL_REPORT_GOALS_SUBTITLE]:
    "Progreso del volumen mensual de resultados y proyección diaria a 7 días",
  [GLOBAL_REPORT_GOALS_STACKED_TITLE]: "Resultados vs meta mensual",
  [GLOBAL_REPORT_GOALS_STACKED_SUBTITLE]:
    "Suma de resultados en los últimos 30 días frente al volumen mensual configurado",
  [GLOBAL_REPORT_GOALS_PROJECTION_TITLE]: "Proyección de resultados",
  [GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE]: "Proyección de resultados por día",
  [GLOBAL_REPORT_GOALS_ACHIEVED]: "Alcanzado",
  [GLOBAL_REPORT_GOALS_REMAINING]: "Restante",
  [GLOBAL_REPORT_GOALS_EXCEEDED]: "Meta superada en {{count}}",
  [GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL]: "Resultados diarios (real)",
  [GLOBAL_REPORT_GOALS_PROJECTION_FORECAST]: "Resultados diarios (proyección)",
  [GLOBAL_REPORT_GOALS_TARGET_LINE]: "Meta mensual",
  [GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT]:
    "Configura tu KPI para ver metas y proyección.",
  [GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON]: "Configurar KPI",
  [GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT]:
    "Selecciona {{kpi}} como KPI medible para ver metas y proyección.",
  [CAMPAIGN_APPROVAL_PAGE_TITLE]: "Aprobación de campaña",
  [CAMPAIGN_APPROVAL_PAGE_DESCRIPTION]:
    "Revisa los textos y creativos de esta campaña y deja tu aprobación final.",
  [CAMPAIGN_APPROVAL_INVALID_TITLE]: "Este enlace no es válido",
  [CAMPAIGN_APPROVAL_INVALID_DESCRIPTION]:
    "El enlace de aprobación no es válido o ya no está disponible. Pide a tu administrador un enlace nuevo.",
  [CAMPAIGN_APPROVAL_EXPIRED_TITLE]: "Este enlace venció",
  [CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION]:
    "El enlace de aprobación expiró. Pide a tu agencia que te comparta uno nuevo.",
  [CAMPAIGN_APPROVAL_CONTENT_EMPTY]:
    "No hay contenido disponible para revisar en esta campaña.",
  [CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA]:
    "Cargando datos de la campaña",
  [CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparando revisión",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE]: "Comentario general",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION]:
    "Comparte feedback general sobre la campaña antes de aprobarla o rechazarla.",
  [CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER]: "Escribe aquí tu comentario general",
  [CAMPAIGN_APPROVAL_COMMENT_BUTTON]: "Enviar comentario",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE]: "Comentario Específico",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION]:
    "Describe qué cambiar en este texto o creativo.",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER]:
    "Escribe aquí tu comentario específico",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON]: "Agregar comentario",
  [CAMPAIGN_APPROVAL_DECISION_TITLE]: "Decisión final",
  [CAMPAIGN_APPROVAL_DECISION_DESCRIPTION]:
    "Debes dejar un resumen antes de aprobar o rechazar esta versión de la campaña.",
  [CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER]:
    "Escribe un resumen final de tu decisión",
  [CAMPAIGN_APPROVAL_APPROVE_BUTTON]: "Aprobar",
  [CAMPAIGN_APPROVAL_REJECT_BUTTON]: "Rechazar",
  [CAMPAIGN_APPROVAL_TEXTS_TITLE]: "Textos",
  [CAMPAIGN_APPROVAL_DESTINATION_TITLE]: "Destino",
  [CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE]:
    "No pudimos cargar la vista previa de este formulario.",
  [CAMPAIGN_APPROVAL_CREATIVES_TITLE]: "Creativos",
  [CAMPAIGN_APPROVAL_CREATIVE_TITLE]: "Creativo",
  [CAMPAIGN_APPROVAL_SLIDE_LABEL]: "Slide",
  [CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL]: "Título",
  [CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL]: "Headline",
  [CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL]: "Headline largo",
  [CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL]: "Descripción",
  [CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL]: "Creativo",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED]:
    "Esta versión ya fue aprobada. Ya no se pueden enviar más comentarios.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED]:
    "Esta versión ya fue rechazada. Ya no se pueden enviar más comentarios.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED]:
    "Esta versión ya tiene una decisión final. Los comentarios están cerrados.",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_AD]: "Anuncio",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP]: "Grupo de assets",
  [CAMPAIGN_APPROVAL_CONTROLS_TITLE]: "Revisión",
  [CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION]:
    "Activa un enlace público para que tu cliente revise textos y creativos antes de publicar.",
  [CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION]:
    "Activa esta opción si necesitas que tu cliente apruebe los textos y creativos de la campaña. Al activarla, se generará un enlace para compartir con tu cliente y que revise y deje comentarios. No podrás publicar la campaña hasta que tu cliente la apruebe. Esta acción no se puede deshacer.",
  [CAMPAIGN_APPROVAL_STATE_INACTIVE]: "Inactivo",
  [CAMPAIGN_APPROVAL_STATE_ACTIVE]: "Activo",
  [CAMPAIGN_APPROVAL_SHARED_LINK_LABEL]: "Enlace:",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE]: "Enviar a Revisión",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "Se generará un enlace que podrás compartir con tu cliente para que revise la campaña.",
  [CAMPAIGN_APPROVAL_ENABLE_BUTTON]: "Enviar a Revisión",
  [CAMPAIGN_APPROVAL_COPY_LINK_BUTTON]: "Copiar",
  [CAMPAIGN_APPROVAL_COPY_LINK_COPIED]: "Copiado",
  [CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION]:
    "Tu cliente solicitó cambios en la campaña. Revisa sus comentarios, realiza las modificaciones pertinentes, guarda los cambios y vuelve a enviarle el enlace.",
  [CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION]:
    "Tu cliente aprobó la campaña. Ahora puedes publicarla.",
  [CAMPAIGN_APPROVAL_PENDING_DESCRIPTION]:
    "A la espera de la aprobación o solicitud de cambios de tu cliente.",
  [CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON]: "Ver comentarios",
  [CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON]: "Ver revision",
  [CAMPAIGN_APPROVAL_STATUS_PENDING]: "Pendiente",
  [CAMPAIGN_APPROVAL_STATUS_APPROVED]: "Aprobado",
  [CAMPAIGN_APPROVAL_STATUS_REJECTED]: "Cambios Solicitados",
  [GALLERY_CONTENT_APPROVAL_STATUS_REJECTED]: "Cambios",
  [CAMPAIGN_APPROVAL_PANEL_TITLE]: "Cambios Solicitados",
  [CAMPAIGN_APPROVAL_PANEL_DESCRIPTION]:
    "Sigue los comentarios activos de la versión actual y navega al campo correspondiente.",
  [CAMPAIGN_APPROVAL_PANEL_EMPTY]:
    "Todavía no hay comentarios activos para esta versión.",
  [CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE]: "Mostrar comentarios anteriores",
  [CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT]: "Versión actual",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING]: "Revisión en Curso",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED]: "Campaña Aprobada",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED]: "Cambios Solicitados",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING]:
    "Aún no hay comentarios. Sigue el estado de cada revisor.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED]:
    "Campaña aprobada. No hay comentarios pendientes en esta versión.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED]:
    "No hay comentarios activos para esta versión.",
  [CAMPAIGN_APPROVAL_STALE_LABEL]: "Anterior",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE]: "Vista previa del anuncio",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR]:
    "No se pudo cargar la vista previa del anuncio.",
  [CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER]:
    "La publicación está bloqueada hasta que el cliente apruebe esta campaña.",
  [CAMPAIGN_APPROVAL_SEND_FOR_REVIEW]: "Enviar a Revisión",
  [CONTENT_APPROVAL_PAGE_TITLE]: "Aprobación de contenido",
  [CONTENT_APPROVAL_REPLACE_BUTTON]: "Reemplazar",
  [CONTENT_APPROVAL_EDIT_BUTTON]: "Editar",
  [CONTENT_APPROVAL_SAVE_REVISION_BUTTON]: "Guardar cambios",
  [CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION]:
    "Los cambios han sido guardados. Copia y envíale de nuevo el enlace a tu cliente.",
  [CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON]: "Aprobar contenido",
  [CONTENT_APPROVAL_SIDEBAR_TITLE]: "Comentarios",
  [CONTENT_APPROVAL_ALL_GOOD_QUESTION]: "¿El contenido está listo?",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE]: "Enviar a Revisión",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "Se generará un enlace que podrás compartir con tu cliente para que revise el contenido.",
  [CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copia y envíale al cliente el siguiente enlace para que revise el contenido:",
  [CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copia y envíale al cliente el siguiente enlace para que revise la campaña:",
  [APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR]: "o",
  [APPROVAL_REVIEW_EMAIL_LABEL]: "Envíale el link por correo",
  [APPROVAL_EMAIL_SEND_BUTTON]: "Enviar",
  [APPROVAL_EMAIL_SEND_SENT]: "Enviado",
  [APPROVAL_EMAIL_INVALID]: "Correo inválido",
  [APPROVAL_REVIEWER_NOT_FOUND]:
    "No hay ningún revisor con ese correo en esta aprobación.",
  [APPROVAL_ADD_REVIEWER]: "Agregar Revisor",
  [APPROVAL_REVIEWER_LABEL]: "Revisor {{number}}",
  [APPROVAL_REVIEWER_MAX_REACHED]: "Máximo 10 revisores",
  [APPROVAL_REVIEWER_EMAIL_DUPLICATED]:
    "Este correo ya está asignado a un revisor",
  [APPROVAL_REVIEWER_ADDED_SUCCESS]: "Revisor agregado",
  [APPROVAL_REVIEWER_STATUS_PENDING]: "Pendiente",
  [APPROVAL_REVIEWER_STATUS_APPROVED]: "Aprobado",
  [APPROVAL_REVIEWER_STATUS_REJECTED]: "Rechazado",
  [APPROVAL_CURRENT_REVIEWER_LABEL]: "Revisando como {{email}}",
  [APPROVAL_REVIEWING_AS_PREFIX]: "Revisando como",
  [APPROVAL_REVIEWERS_SECTION_LABEL]: "Revisores",
  [APPROVAL_COMMENT_AUTHOR_LABEL]: "{{email}}",
  [CONTENT_APPROVAL_SENT_DATE]: "Enviado el {{date}}",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE]: "Comentarios del cliente",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY]:
    "Tu cliente aún no ha dejado comentarios.",
  [CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY]:
    "Aún no has agregado comentarios.",
  [CONTENT_APPROVAL_COMMENT_PLACEHOLDER]: "Escribe tu comentario aquí...",
  [CONTENT_APPROVAL_REVIEW_LINK_LABEL]: "Enlace de revisión",
  [CONTENT_APPROVAL_STATUS_SECTION_LABEL]: "Estado",
  [CONTENT_APPROVAL_MAIN_CREATIVE_LABEL]: "Creativo principal",
  [CONTENT_APPROVAL_CREATIVE_CARD_TITLE]: "Creativo {{number}}",
  [CONTENT_APPROVAL_CREATIVE_TYPE_LABEL]: "Tipo: {{type}}",
  [CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER]: "Creativo {{number}}",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE]: "¿Aprobar contenido?",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "La agencia recibirá una notificación de que el contenido ha sido aprobado.",
  [CONTENT_APPROVAL_APPROVE_BUTTON]: "Aprobar",
  [CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "Se envió la notificación de aprobación a la agencia.",
  [CONTENT_APPROVAL_CONTENT_APPROVED_TITLE]: "Contenido Aprobado",
  [CONTENT_APPROVAL_COMMENT_SENT_SUCCESS]: "Tu comentario fue enviado",
  [CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON]: "Siguiente Contenido",
  [CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON]: "Otro Comentario",
  [CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED]: "Has revisado todos los contenidos",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION]:
    "Todavía quedan {{count}} contenidos por revisar.",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE]:
    "Todavía queda {{count}} contenido por revisar.",
  [CONTENT_APPROVAL_LOCKED_STATUS_APPROVED]:
    "Este contenido ya fue aprobado. Ya no se pueden enviar más comentarios.",
  [CONTENT_APPROVAL_INVALID_TITLE]: "Este enlace no es válido",
  [CONTENT_APPROVAL_INVALID_DESCRIPTION]:
    "El enlace de aprobación de contenido no es válido o ya no está disponible. Pide a tu administrador un enlace nuevo.",
  [CONTENT_APPROVAL_EXPIRED_TITLE]: "Este enlace venció",
  [CONTENT_APPROVAL_EXPIRED_DESCRIPTION]:
    "El enlace de aprobación de contenido expiró. Pide a tu agencia que te comparta uno nuevo.",
  [CONTENT_APPROVAL_LOADING_VALIDATING_LINK]: "Validando enlace de revisión",
  [CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES]: "Cargando creatividades",
  [CONTENT_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparando revisión",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE]:
    "La campaña aún no está aprobada",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION]:
    "Esta campaña se envió a revisión al cliente y aún no la ha aprobado. ¿Deseas publicarla de todos modos?",
  [CAMPAIGN_APPROVAL_READY_TO_DECIDE]: "¿Listo para decidir?",
  [CAMPAIGN_APPROVAL_COMMENTS_LEFT]: "Has dejado {{count}} comentarios",
  [CAMPAIGN_APPROVAL_AD_SET_LABEL]: "AD SET",
  [CAMPAIGN_APPROVAL_ADS_COUNT]: "{{count}} anuncios",
  [CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE]: "{{count}} anuncio",
  [CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS]: "Selecciona una plataforma",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS]: "{{count}} ad sets",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE]: "{{count}} ad set",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS]: "{{count}} anuncios",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE]: "{{count}} anuncio",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS]: "{{count}} textos",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE]: "{{count}} texto",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES]: "{{count}} creativos",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE]: "{{count}} creativo",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT]: "{{count}} textos",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE]: "{{count}} texto",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT]: "{{count}} creativos",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE]: "{{count}} creativo",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT]: "{{count}} comentarios",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE]: "{{count}} comentario",
  [CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT]:
    "Para rechazar necesitas dejar al menos un comentario en un elemento o escribir uno aquí.",
  [CAMPAIGN_APPROVAL_COMMENT_SEND_HINT]: "Ctrl/⌘ + Enter para enviar",
  [CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON]: "Aprobar campaña",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE]: "¿Aprobar campaña?",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "La agencia recibirá una notificación de que la campaña ha sido aprobada y podrá publicarla",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE]: "¿Rechazar campaña?",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION]:
    "¿Estás seguro de que deseas rechazar esta campaña? La agencia recibirá una notificación.",
  [CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "Se envió la notificación de aprobación a la agencia.",
  [CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS]:
    "Se envió la notificación de rechazo a la agencia.",
  [TEMPLATES_MENU_ITEM]: "Plantillas",
  [TEMPLATES_TITLE]: "Plantillas",
  [TEMPLATE]: "Plantilla",
  [TEMPLATES_SEARCH_PLACEHOLDER]: "Buscar plantillas",
  [TEMPLATES_SEARCH_NO_RESULTS]: "No se encontraron plantillas con ese nombre.",
  [TEMPLATES_SORT_NEWEST_FIRST]: "Más recientes primero",
  [TEMPLATES_SORT_OLDEST_FIRST]: "Más antiguas primero",
  [TEMPLATES_SORT_NAME_ASC]: "Nombre (A–Z)",
  [TEMPLATES_SORT_NAME_DESC]: "Nombre (Z–A)",
  [TEMPLATES_DESCRIPTION]:
    "Crea una plantilla, define capas, grupos y propiedades, o sube un creativo y lo analizaremos por ti.",
  [TEMPLATES_BUTTON_UPLOAD]: "Subir Creativo",
  [TEMPLATES_UPLOAD_FROM_GALLERY]: "Desde Galería",
  [TEMPLATES_UPLOAD_FROM_DEVICE]: "Desde Dispositivo",
  [TEMPLATES_BUTTON_CREATE]: "Crear",
  [TEMPLATES_LAYOUT_KIND_IMAGE]: "Imagen",
  [TEMPLATES_LAYOUT_KIND_CAROUSEL]: "Carrusel",
  [TEMPLATES_CREATE_KIND_TITLE]: "Tipo de plantilla",
  [TEMPLATES_CREATE_KIND_DESCRIPTION]:
    "Elige una imagen única o un carrusel con varias diapositivas.",
  [TEMPLATES_CREATE_KIND_SINGLE]: "Imagen única",
  [TEMPLATES_CREATE_KIND_CAROUSEL]: "Carrusel",
  [TEMPLATES_CREATE_KIND_SLIDE_COUNT]: "Número de diapositivas",
  [TEMPLATES_SLIDE_LABEL]: "Slide {{index}}",
  [TEMPLATES_ADD_SLIDE]: "Añadir",
  [TEMPLATES_DUPLICATE_SLIDE]: "Duplicar slide",
  [TEMPLATES_DELETE_SLIDE]: "Eliminar slide",
  [TEMPLATES_SLIDES_ROW]: "Slides",
  [TEMPLATES_CAROUSEL_TYPE]: "Tipo de Carrusel",
  [TEMPLATES_CONTINUOUS_SETUP_TITLE]: "Configurar Carrusel Continuo",
  [TEMPLATES_CONTINUOUS_SETUP_SLIDES]: "Cantidad de slides",
  [TEMPLATES_CONTINUOUS_SETUP_FORMAT]: "Formato de cada slide",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS]: "Continuo",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL]: "Individual",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP]:
    "Modo individual: cada slide del carrusel se diseña por separado.",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP]:
    "Modo continuo: un solo diseño que se extiende a través de todos los slides.",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT]:
    "Haz clic para volver al modo individual (cada slide se diseña por separado).",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT]:
    "Haz clic para cambiar a modo continuo (un solo diseño a través de los slides).",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED]:
    "Para volver al modo individual (cada slide por separado) no debe haber ninguna capa en la plantilla.",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED]:
    "Para cambiar a modo continuo (un solo diseño a través de los slides) no debe haber ninguna capa en la plantilla.",
  [TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION]:
    "Se eliminará el slide {{index}} con su contenido. Las capas que lo cruzan se recortarán.",
  [TEMPLATES_STRIP_FORMAT_TOO_LARGE]:
    "Este formato supera el tamaño máximo de la tira continua",
  [TEMPLATES_FORMATS_ROW]: "Formatos",
  [TEMPLATES_CAROUSEL_CHIP]: "Carrusel",
  [TEMPLATES_CONTINUOUS_CAROUSEL_CHIP]: "Carrusel continuo",
  [TEMPLATES_EMPTY]: "Todavía no hay plantillas.",
  [TEMPLATES_FOLDER_EMPTY]: "Esta carpeta está vacía.",
  [TEMPLATES_EMPTY_CANVAS_HINT]:
    "Comienza a armar tu creativo por capas o sube una imagen y lo haremos por ti.",
  [TEMPLATES_EMPTY_ADD_LAYER]: "Agregar capa",
  [TEMPLATES_BACKGROUND_LAYER]: "fondo",
  [TEMPLATES_OPEN]: "Abrir",
  [TEMPLATES_DUPLICATE]: "Duplicar",
  [TEMPLATES_DELETE]: "Eliminar",
  [TEMPLATES_SAVE]: "Guardar",
  [TEMPLATES_USAGE_GUIDE]: "Guía de uso",
  [TEMPLATES_GUIDE_PDF_URL]:
    "https://clapp-prod.s3.us-east-1.amazonaws.com/docs/templates-guide/ES.pdf",
  [TEMPLATES_GUIDE_VIDEO_URL]:
    "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/199e35d1-1db1-4878-bc3a-a87484479936.mp4",
  [TEMPLATES_BACK]: "Ir a plantillas",
  [TEMPLATES_NAME]: "Nombre",
  [TEMPLATES_UNTITLED]: "Sin título",
  [TEMPLATES_ZONES]: "Capas",
  [TEMPLATES_LAYERS]: "Capas",
  [TEMPLATES_PROPERTIES]: "Propiedades",
  [TEMPLATES_NO_SELECTION]: "Selecciona una capa para editarla.",
  [TEMPLATES_ADD_LAYER]: "Elemento",
  [TEMPLATES_ZONE_NAME]: "Nombre de Capa",
  [TEMPLATES_LAYER_NAME]: "Nombre de Capa",
  [TEMPLATES_ZONE_TYPE]: "Tipo de Capa",
  [TEMPLATES_ZONE_SOURCE]: "Comportamiento",
  [TEMPLATES_TYPE_TEXT]: "Texto",
  [TEMPLATES_TYPE_IMAGE]: "Imagen",
  [TEMPLATES_TYPE_SHAPE]: "Forma",
  [TEMPLATES_TYPE_GROUP]: "Grupo",
  [TEMPLATES_SOURCE_ASSET]: "Estático",
  [TEMPLATES_SOURCE_DATA]: "Variable",
  [TEMPLATES_SOURCE_GENERATED]: "Generado",
  [TEMPLATES_SOURCE_FIXED]: "Estático",
  [TEMPLATES_SOURCE_COMPUTED]: "Calculado",
  [TEMPLATES_SOURCE_ASSET_HINT]:
    "Siempre usa el mismo texto o imagen para todas las imágenes generadas.",
  [TEMPLATES_SOURCE_DATA_HINT]:
    "Puedes asignar un valor específico para cada imagen generada.",
  [TEMPLATES_SOURCE_GENERATED_HINT]:
    "La IA crea un texto o imagen distinto en cada imagen generada, según las instrucciones.",
  [TEMPLATES_SOURCE_COMPUTED_HINT]:
    "Se calcula con una expresión a partir de otras variables.",
  [TEMPLATES_FIXED_VALUE]: "Valor",
  [TEMPLATES_FIXED_VALUE_PLACEHOLDER]: "Texto",
  [TEMPLATES_LAYER_TEXT]: "Texto",
  [TEMPLATES_STYLE]: "Estilo",
  [TEMPLATES_ORIGIN_TEXT]: "Referencia",
  [TEMPLATES_EXPRESSION]: "Expresión",
  [TEMPLATES_VARIABLE]: "Variable",
  [TEMPLATES_PROMPT]: "Instrucciones",
  [TEMPLATES_GENERATE_PROMPT]: "Generar Instrucciones",
  [TEMPLATES_GENERATE_PROMPT_ERROR]:
    "No se pudieron generar las instrucciones.",
  [TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE]:
    "Agrega un Texto o Imagen de Ejemplo para Generar Instrucciones.",
  [TEMPLATES_SAVE_PROMPT]: "Guardar Instrucciones",
  [TEMPLATES_SAVE_PROMPT_TITLE]: "Guardar Instrucciones",
  [TEMPLATES_SAVE_PROMPT_ERROR]: "No se pudieron guardar las instrucciones.",
  [TEMPLATES_SAVE_PROMPT_SUCCESS]: "Instrucción Guardada",
  [TEMPLATES_IMPORT_PROMPT]: "Importar Instrucciones",
  [TEMPLATES_IMPORT_PROMPT_TITLE]: "Instrucciones Guardadas",
  [TEMPLATES_IMPORT_SELECTED]: "Importar",
  [TEMPLATES_IMPORT_PROMPT_EMPTY]: "No hay instrucciones guardadas.",
  [TEMPLATES_IMPORT_PROMPT_ERROR]: "No se pudieron cargar las instrucciones.",
  [TEMPLATES_DELETE_PROMPT]: "Eliminar Instrucciones",
  [TEMPLATES_DELETE_PROMPT_ERROR]: "No se pudieron eliminar las instrucciones.",
  [TEMPLATES_TRY_LAYER]: "Probar",
  [TEMPLATES_TRY_LAYER_ERROR]: "No se pudo generar la vista previa de la capa.",
  [TEMPLATES_IS_BACKGROUND]: "Fondo",
  [TEMPLATES_NEGATIVE_PROMPT]: "Evitar",
  [TEMPLATES_ASSET_REF]: "Recurso",
  [TEMPLATES_SELECT_ASSET]: "Seleccionar Recurso",
  [TEMPLATES_CHANGE_ASSET]: "Cambiar Recurso",
  [TEMPLATES_FIT]: "Ajuste",
  [TEMPLATES_SHAPE_FILL]: "Relleno",
  [TEMPLATES_SHAPE_RADIUS]: "Radio",
  [TEMPLATES_FONT_SIZE]: "Tamaño",
  [TEMPLATES_FONT_COLOR]: "Color",
  [TEMPLATES_STROKE_WIDTH]: "Contorno",
  [TEMPLATES_STROKE_METRIC]: "Grosor",
  [TEMPLATES_SHADOW]: "Sombra",
  [TEMPLATES_SHADOW_ANGLE]: "Dirección (°)",
  [TEMPLATES_SHADOW_DISTANCE]: "Distancia",
  [TEMPLATES_SHADOW_BLUR]: "Desenfoque",
  [TEMPLATES_PRESETS]: "Presets",
  [TEMPLATES_SHADOW_PRESET_SOFT]: "Suave",
  [TEMPLATES_SHADOW_PRESET_LIFT]: "Elevada",
  [TEMPLATES_SHADOW_PRESET_HARD]: "Dura",
  [TEMPLATES_SHADOW_PRESET_GLOW]: "Resplandor",
  [TEMPLATES_STROKE_COLOR]: "Color del contorno",
  [TEMPLATES_BACKGROUND_PADDING]: "Fondo",
  [TEMPLATES_BACKGROUND_SEPARATION]: "Separación desde la letra",
  [TEMPLATES_BACKGROUND_RADIUS]: "Redondez",
  [TEMPLATES_BACKGROUND_COLOR]: "Color del fondo",
  [TEMPLATES_PAINT_SETTINGS]: "Ajustes",
  [TEMPLATES_HIGHLIGHTS_TITLE]: "Estilos Específicos",
  [TEMPLATES_HIGHLIGHTS_HINT]:
    "Selecciona un fragmento en el texto y cambia color, contorno o fondo para destacarlo. Puedes combinar los tres. Sin selección, los cambios aplican a toda la capa.",
  [TEMPLATES_HIGHLIGHTS_ADD]: "Añadir destacado",
  [TEMPLATES_HIGHLIGHTS_REMOVE]: "Eliminar destacado",
  [TEMPLATES_HIGHLIGHTS_KIND_FILL]: "Letra",
  [TEMPLATES_HIGHLIGHTS_KIND_STROKE]: "Borde",
  [TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND]: "Fondo",
  [TEMPLATES_HIGHLIGHTS_PHRASE]: "Frase de referencia",
  [TEMPLATES_HIGHLIGHTS_PHRASE_INVALID]:
    "La frase debe aparecer en el texto de referencia.",
  [TEMPLATES_HIGHLIGHTS_CAPTURE]: "Seleccionar en el canvas",
  [TEMPLATES_HIGHLIGHTS_CAPTURING]: "Selecciona el texto…",
  [TEMPLATES_INLINE_REPLACEMENTS_TITLE]: "Reemplazar texto por imágenes",
  [TEMPLATES_INLINE_REPLACEMENTS_HINT]:
    "Sustituye una palabra exacta dentro de un texto por una imagen",
  [TEMPLATES_INLINE_REPLACEMENTS_ADD]: "Añadir reemplazo",
  [TEMPLATES_INLINE_REPLACEMENTS_REMOVE]: "Quitar reemplazo",
  [TEMPLATES_INLINE_REPLACEMENTS_PHRASE]: "Palabra",
  [TEMPLATES_LINE_SPACING]: "Espacio entre Líneas",
  [TEMPLATES_LETTER_SPACING]: "Espacio entre Letras",
  [TEMPLATES_FONT_FAMILY]: "Tipografía",
  [TEMPLATES_FONT_FACE]: "Estilo de Fuente",
  [TEMPLATES_TEXT_STYLE]: "Tipo de texto",
  [TEMPLATES_TEXT_STYLE_NORMAL]: "Normal",
  [TEMPLATES_TEXT_STYLE_ITALIC]: "Cursiva",
  [TEMPLATES_TEXT_STYLE_UNDERLINE]: "Subrayado",
  [TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE]: "Cursiva y subrayado",
  [TEMPLATES_ADD_FONT]: "+ Añadir Fuente",
  [TEMPLATES_ADD_FONT_TITLE]: "Añadir Fuente",
  [TEMPLATES_ADD_FONT_NAME]: "Nombre de la fuente",
  [TEMPLATES_ADD_FONT_NAME_HINT]: "Nombre de la familia. Ej: Inter",
  [TEMPLATES_ADD_FONT_MATCH_HINT]: "Se agregará como {{style}} de {{family}}.",
  [TEMPLATES_ADD_FONT_PARSE_FAILED]:
    "No se pudieron leer los metadatos. Escribe el nombre de la familia.",
  [TEMPLATES_ADD_FONT_PARTIAL_ERROR]: "Algunas fuentes no se pudieron subir.",
  [TEMPLATES_ADD_FONT_VARIABLE]: "Fuente variable",
  [TEMPLATES_ADD_FONT_SUMMARY]: "Resumen",
  [TEMPLATES_ADD_FONT_SUMMARY_FAMILY]: "Familia",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLE]: "Estilo",
  [TEMPLATES_ADD_FONT_SUMMARY_KIND]: "Tipo",
  [TEMPLATES_ADD_FONT_SUMMARY_STATIC]: "Fuente estática",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLES]: "Estilos disponibles",
  [TEMPLATES_ADD_FONT_SUMMARY_HINT]:
    "Selecciona uno o varios archivos .ttf, .otf, .woff o .woff2. Los estilos de la misma familia se agrupan en un solo resumen.",
  [TEMPLATES_ADD_FONT_CHANGE_FILE]: "Cambiar archivos",
  [TEMPLATES_ADD_FONT_FILE]: "Archivo",
  [TEMPLATES_ADD_FONT_SELECT_FILE]: "Seleccionar archivos",
  [TEMPLATES_ADD_FONT_ERROR]: "No se pudo subir la fuente.",
  [TEMPLATES_ADD_FONT_INVALID_FILE]: "Usa archivos .ttf, .otf, .woff o .woff2.",
  [TEMPLATES_ADD_FONT_INVALID_NAME]: "El nombre no puede incluir . # $ [ ] /",
  [TEMPLATES_ALIGN]: "Alineación",
  [TEMPLATES_ALIGN_LEFT]: "Izquierda",
  [TEMPLATES_ALIGN_CENTER]: "Centro",
  [TEMPLATES_ALIGN_RIGHT]: "Derecha",
  [TEMPLATES_ALIGN_TOP]: "Arriba",
  [TEMPLATES_ALIGN_MIDDLE]: "Medio",
  [TEMPLATES_ALIGN_BOTTOM]: "Abajo",
  [TEMPLATES_ALIGN_LAYERS]: "Alinear",
  [TEMPLATES_LOCK_LAYER]: "Bloquear",
  [TEMPLATES_UNLOCK_LAYER]: "Desbloquear",
  [TEMPLATES_HIDE_LAYER]: "Ocultar",
  [TEMPLATES_SHOW_LAYER]: "Mostrar",
  [TEMPLATES_ALIGNMENT_GUIDES]: "Guías de alineación",
  [TEMPLATES_GUIDE_OPACITY]: "Opacidad de la guía",
  [TEMPLATES_ORIENTATION]: "Orientación",
  [TEMPLATES_ORIENTATION_HORIZONTAL]: "Horizontal",
  [TEMPLATES_ORIENTATION_VERTICAL]: "Vertical ↓",
  [TEMPLATES_ORIENTATION_VERTICAL_UP]: "Vertical ↑",
  [TEMPLATES_OVERFLOW]: "Si no cabe",
  [TEMPLATES_MAX_LINES]: "Máx. Líneas",
  [TEMPLATES_MIN_LINES]: "Mín. Líneas",
  [TEMPLATES_MIN_FONT]: "Mínimo",
  [TEMPLATES_POSITION]: "Ubicación",
  [TEMPLATES_SIZE]: "Tamaño",
  [TEMPLATES_POS_X]: "X",
  [TEMPLATES_POS_Y]: "Y",
  [TEMPLATES_POS_W]: "W",
  [TEMPLATES_POS_H]: "H",
  [TEMPLATES_FRAME_W]: "Ancho del Marco",
  [TEMPLATES_FRAME_H]: "Alto del Marco",
  [TEMPLATES_CLIP]: "Recortar Contenido",
  [TEMPLATES_HIDE]: "Ocultar",
  [TEMPLATES_SHOW]: "Mostrar",
  [TEMPLATES_MIN_SIZE]: "Tamaño mín.",
  [TEMPLATES_PADDING]: "Safe area",
  [TEMPLATES_DRAW]: "Dibujar capa",
  [TEMPLATES_DRAWING]: "Dibujando",
  [TEMPLATES_DRAW_HINT]:
    "Arrastra sobre el canvas. Con un grupo o una subcapa seleccionada, la nueva capa se crea dentro del grupo.",
  [TEMPLATES_OVERFLOW_SHRINK]: "Encoger",
  [TEMPLATES_OVERFLOW_REJECT]: "Bloquear",
  [TEMPLATES_BACKDROP_NOTE]:
    "Marca la zona; el archivo real de logo o sello se sube después. Esta imagen es solo el fondo del editor.",
  [TEMPLATES_NODE_COUNT]: "{{count}} capas",
  [TEMPLATES_NODE_COUNT_SINGLE]: "{{count}} capa",
  [TEMPLATES_ARTBOARD]: "{{width}}×{{height}}",
  [TEMPLATES_ADD_FORMAT]: "Añadir",
  [TEMPLATES_CUSTOM_FORMAT]: "Personalizado",
  [TEMPLATES_CUSTOM_FORMAT_TITLE]: "Tamaño Personalizado",
  [TEMPLATES_CUSTOM_WIDTH]: "Ancho",
  [TEMPLATES_CUSTOM_HEIGHT]: "Alto",
  [TEMPLATES_CUSTOM_SIZE_INVALID]: "Ingresa un ancho y un alto entre 1 y 8192.",
  [TEMPLATES_EDIT_PREVIOUS]: "Editar anterior",
  [TEMPLATES_NEW_FORMAT_HINT]:
    "Sube una imagen para separarla en capas, o copia las capas del tamaño anterior.",
  [TEMPLATES_REMOVE_FORMAT]: "Quitar tamaño",
  [TEMPLATES_THIS_FORMAT]: "este tamaño",
  [TEMPLATES_UPLOAD_REFERENCE]: "Subir guía",
  [TEMPLATES_CHANGE_REFERENCE]: "Cambiar guía",
  [TEMPLATES_SHOW_GUIDE]: "Mostrar guía",
  [TEMPLATES_HIDE_GUIDE]: "Ocultar guía",
  [TEMPLATES_GUIDE_HINT]:
    "La guía muestra el creativo original semitransparente sobre el lienzo para ver dónde debe ir cada capa.",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE]: "Variables de preview",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION]:
    "Completa las variables e imágenes que necesita esta plantilla.",
  [TEMPLATES_EDITOR_PREVIEW_ERROR]: "No se pudo generar la preview.",
  [TEMPLATES_EDITOR_PREVIEW_TITLE]: "Preview",
  [TEMPLATES_EDITOR_PREVIEW_USED_VALUES]: "Valores usados",
  [TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY]: "Contenido Guardado En Galeria",
  [TEMPLATES_ZOOM_IN]: "Acercar",
  [TEMPLATES_ZOOM_OUT]: "Alejar",
  [TEMPLATES_ZOOM_FIT]: "Ajustar a pantalla",
  [TEMPLATES_TEXT_COLLISION_ONE]: "1 texto puede tapar otra capa",
  [TEMPLATES_TEXT_COLLISION_OTHER]: "{{count}} textos pueden tapar otras capas",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT]: "Texto",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE]: "Imagen",
  [CANVAS_TOOLS_BAR_LABEL]: "Herramientas",
  [CANVAS_TOOL_ERASER]: "Borrar Objeto",
  [CANVAS_TOOL_ERASER_HINT]: "Sombrea el elemento que quieres borrar",
  [CANVAS_TOOL_ERASER_BRUSH_SIZE]: "Tamaño del pincel",
  [CANVAS_TOOL_ERASER_APPLY]: "Borrar",
  [TEMPLATES_UNAUTHORIZED]: "No tienes permiso para editar plantillas.",
  [TEMPLATES_ANALYZING_LOCK]: "Separando tu creativo en capas…",
  [TEMPLATES_SAVE_SUCCESS]: "Plantilla Guardada.",
  [TEMPLATES_DELETE_ERROR]: "No se pudo eliminar la plantilla.",
  [TEMPLATES_UPLOAD_ERROR]: "No se pudo subir la imagen.",
  [TEMPLATES_ANALYZE_ERROR]: "No se pudo analizar el creativo.",
  [TEMPLATES_ANALYZE_IMAGE_TOO_SMALL]:
    "La imagen es demasiado pequeña para separarla en capas. Debe tener una resolución de al menos 1080 x 1080 (HD).",
  [IMAGE_TOO_SMALL_FOR_LAYERIZE]:
    "La imagen es demasiado pequeña para separarla en capas. Debe tener una resolución mínima de 1080 x 1080 (HD).",
  [TEMPLATES_ANALYZE_RETRY]: "Reintentar",
  [TEMPLATES_CREATE_ERROR]: "No se pudo crear la plantilla.",
  [TEMPLATES_SAVE_ERROR]: "No se pudo guardar la plantilla.",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE]:
    "Las variables no coinciden entre tamaños",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL]:
    "Las variables no coinciden entre tamaños del mismo slide",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION]:
    "Todos los tamaños deben tener las mismas variables. Faltan las siguientes variables en los siguientes tamaños:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL]:
    "En cada slide, todos los tamaños deben tener las mismas variables. Faltan las siguientes variables en los siguientes tamaños:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL]:
    "Variables faltantes por tamaño",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT]: "Tamaño",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE]: "Tipo de capa",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE]: "Variable",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE]: "Advertencia",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION]:
    "Estos tamaños tienen zonas transparentes sin cubrir. Puedes completarlas ahora o continuar: si continúas, esas zonas se rellenarán con blanco.",
  [TEMPLATES_CONFIRM_DELETE_TITLE]: "¿Eliminar Plantilla?",
  [TEMPLATES_CONFIRM_DELETE_DESCRIPTION]: "Esta acción no se puede deshacer.",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE]: "¿Quitar tamaño?",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION]:
    "Se eliminará el tamaño {{format}} y todas sus capas. Esta acción no se puede deshacer.",
  [TEMPLATES_CONFIRM_ADD_FORMAT]: "Añadir Formato",
  [TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION]:
    "Recuerda completar toda la configuración del formato inicial para que sea más fácil trabajar en los nuevos formatos.",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND]: "Redimensionar Fondo",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION]:
    "¿Quieres redimensionar la imagen de fondo con IA para que se ajuste al nuevo formato?",
  [TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM]: "Redimensionar",
  [TEMPLATES_AI_RESIZE_BACKGROUND_LOCK]: "Redimensionando el fondo con IA",
  [TEMPLATES_KEEP_EDITING]: "Seguir Editando",
  [TEMPLATES_CLOSE_UNSAVED_DESCRIPTION]:
    "¿Seguro que quieres salir de aquí? Todos los cambios no guardados se perderán.",
  [TEMPLATES_PRODUCE_DRAFT_TITLE]: "Plantilla Incompleta",
  [TEMPLATES_PRODUCE_DRAFT_DESCRIPTION]:
    "Completa la plantilla con un nombre y al menos una capa antes de producir.",
  [TEMPLATES_PRODUCE_DRAFT_COMPLETE]: "Completar",
  [TEMPLATES_SAVE_PRODUCE_TITLE]: "Plantilla Guardada",
  [TEMPLATES_SAVE_BLOCKED_PRODUCING]:
    "Se están produciendo creativos con esta plantilla. Guardar ahora podría causar errores en la producción. Podrás guardar tus cambios en cuanto termine.",
  [TEMPLATES_SAVE_PRODUCE_DESCRIPTION]: "Ahora puedes producir creativos",
  [TEMPLATES_SAVE_PRODUCE_CONFIRM]: "Producir",
  [TEMPLATES_SAVE_PRODUCE_CANCEL]: "Ir Atrás",
  [TEMPLATES_NEW_ZONE]: "capa",
  [TEMPLATES_NEW_LAYER]: "Capa",
  [TEMPLATES_PRODUCE_MENU_ITEM]: "Producir",
  [TEMPLATES_PRODUCE_TITLE]: "Producir",
  [TEMPLATES_PRODUCE_DESCRIPTION]:
    "Elige una plantilla, un idioma y completa las variables de cada fila.",
  [TEMPLATES_PRODUCE_CONFIG_KICKER]: "Configuración",
  [TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL]: "Plantilla seleccionada",
  [TEMPLATES_PRODUCE_VARIABLES_EYEBROW]: "Variables de producción",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT]: "imagen",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT]: "imágenes",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL]: "{{count}} variación",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL]: "{{count}} variaciones",
  [TEMPLATES_PRODUCE_SUMMARY_COST]: "{{count}} {{unit}}",
  [TEMPLATES_PRODUCE_SUMMARY_COST_LABEL]: "Costo",
  [TEMPLATES_PRODUCE_SUMMARY_RATE]: "{{count}} {{unit}} por imagen",
  [TEMPLATES_PRODUCE_SUMMARY_FORMAT]: "Formato {{size}}",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT]: "{{count}} imágenes",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE]: "{{count}} imagen",
  [TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT]: "{{count}} tamaño",
  [TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT]: "{{count}} tamaños",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT]: "{{count}} slide",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT]: "{{count}} slides",
  [TEMPLATES_PRODUCE_ROW_COUNT]: "{{count}} filas",
  [TEMPLATES_PRODUCE_ROW_COUNT_SINGLE]: "{{count}} fila",
  [TEMPLATES_PRODUCE_TEMPLATE]: "Plantilla",
  [TEMPLATES_PRODUCE_CHANGE]: "Cambiar",
  [TEMPLATES_PRODUCE_DIMENSIONS]: "Tamaños",
  [TEMPLATES_PRODUCE_LANGUAGE]: "Idioma",
  [TEMPLATES_PRODUCE_VARIATIONS]: "Número de Variaciones",
  [TEMPLATES_PRODUCE_VARIATIONS_PER_ROW]: "Variaciones por Fila",
  [TEMPLATES_PRODUCE_ROWS]: "Filas",
  [TEMPLATES_PRODUCE_ROWS_HINT]: "Escribe aquí. No hace falta ningún archivo.",
  [TEMPLATES_PRODUCE_ADD_ROW]: "Añadir fila",
  [TEMPLATES_PRODUCE_LOAD_LAST_CONFIG]: "Cargar últimos datos usados",
  [TEMPLATES_PRODUCE_UPLOAD_CSV]: "Subir CSV",
  [TEMPLATES_PRODUCE_DOWNLOAD_FORMAT]: "Descargar CSV",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME]: "{{name}}-variables-ejemplo.csv",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT]: "Ejemplo {{label}}",
  [TEMPLATES_PRODUCE_GENERATE]: "Generar {{count}} imágenes",
  [TEMPLATES_PRODUCE_GENERATE_SINGLE]: "Generar {{count}} imagen",
  [TEMPLATES_PRODUCE_PREVIEW]: "Generar preview",
  [TEMPLATES_PRODUCE_PREVIEW_TOOLTIP]:
    "Genera una imagen de prueba de esta plantilla.",
  [TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE]: "De este slide",
  [TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL]: "De todo el carrusel",
  [TEMPLATES_PRODUCE_SUMMARY]: "Resumen",
  [TEMPLATES_PRODUCE_EMPTY_TEMPLATES]:
    "Todavía no hay plantillas con capas para producir.",
  [TEMPLATES_PRODUCE_EMPTY_VARIABLES]:
    "Esta plantilla no tiene variables para completar.",
  [TEMPLATES_PRODUCE_SELECT_TEMPLATE]: "Selecciona una Plantilla",
  [TEMPLATES_PRODUCE_CSV_TITLE]: "¿Cómo Quieres Cargar el CSV?",
  [TEMPLATES_PRODUCE_CSV_DESCRIPTION]:
    "Puedes reemplazar todas las filas actuales o agregar las del archivo al final.",
  [TEMPLATES_PRODUCE_CSV_REPLACE]: "Reemplazar",
  [TEMPLATES_PRODUCE_CSV_APPEND]: "Agregar",
  [TEMPLATES_PRODUCE_CSV_ERROR]: "No se pudo leer el archivo CSV.",
  [TEMPLATES_PRODUCE_CSV_EMPTY]:
    "El CSV no tiene filas válidas para las variables de esta plantilla.",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE]: "¿Cambiar Plantilla?",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION]:
    "Se borrarán las filas actuales porque las variables pueden cambiar.",
  [TEMPLATES_PRODUCE_VALIDATION_ERROR]:
    "Completa todas las variables. Las celdas con datos faltantes están marcadas en rojo.",
  [TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT]:
    "Cada frase destacada debe coincidir exactamente con el texto de esa fila. Las celdas que no coinciden están marcadas en rojo.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_ROWS]:
    "Agrega al menos una fila antes de generar.",
  [TEMPLATES_PRODUCE_VALIDATION_VARIATIONS]:
    "Ingresa un número entero de al menos 1.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS]:
    "Selecciona al menos un tamaño para generar.",
  [TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS]:
    "Puedes generar un máximo de {{max}} filas por producción. Pediste {{count}}. Reduce las variaciones o las filas.",
  [TEMPLATES_PRODUCE_GENERATE_SUCCESS]:
    "La producción empezó. Puedes salir de esta página; los resultados aparecerán debajo de la tabla y en el panel de actividad.",
  [TEMPLATES_PRODUCE_DELETE_ROW]: "Eliminar fila",
  [TEMPLATES_PRODUCE_COPY_TO_COLUMN]: "Copiar este valor a toda la columna",
  [TEMPLATES_PRODUCE_SELECT_IMAGE]: "Seleccionar imagen",
  [TEMPLATES_PRODUCE_REPLACE_IMAGE]: "Reemplazar imagen",
  [TEMPLATES_PRODUCE_IMAGE_CHECKING]:
    "Verificando que la imagen pueda ser usada",
  [TEMPLATES_PRODUCE_IMAGE_UNUSABLE]:
    "Esta imagen no puede ser descargada debido a un bloqueo. Súbela manualmente.",
  [TEMPLATES_PRODUCE_IMAGES_PROCESSING]:
    "Se están procesando las imágenes entrantes.",
  [TEMPLATES_PRODUCE_IMAGES_UNUSABLE]:
    "Algunas imágenes no pueden ser descargadas para su uso. Verifica la tabla y súbelas manualmente.",
  [TEMPLATES_PRODUCE_DELETE_IMAGE]: "Eliminar imagen",
  [TEMPLATES_PRODUCE_RESULTS]: "Resultados",
  [TEMPLATES_PRODUCE_RUN_TITLE]: "{{date}}",
  [TEMPLATES_PRODUCE_RUN_LEGACY]: "Generaciones anteriores",
  [TEMPLATES_PRODUCE_DELETE_SELECTED]: "Eliminar ({{count}})",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE]:
    "¿Eliminar {{count}} elemento(s) generado(s)?",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT]: "Esta acción no se puede deshacer.",
  [TEMPLATES_PRODUCE_DELETE_ERROR]:
    "No pudimos eliminar los elementos seleccionados.",
  [TEMPLATES_PRODUCE_DOWNLOAD_CONFIG]: "Descargar configuración",
  [TEMPLATES_PRODUCE_CONFIG_FILENAME]: "{{name}}-variables.csv",
  [TEMPLATES_PRODUCE_GENERATING]: "Generando…",
  [TEMPLATES_PRODUCE_ACTIVE_RUN]:
    "Ya hay una producción en curso para este set. Espera a que termine.",
  [TEMPLATES_PRODUCE_EDIT_TITLE]: "Editar Pieza",
  [TEMPLATES_PRODUCE_EDIT_NO_INSTANCE]:
    "Esta pieza no tiene capas para editar. Vuelve a generarla para habilitar la edición.",
  [TEMPLATES_PRODUCE_ADD_TEXT]: "Texto",
  [TEMPLATES_PRODUCE_ADD_IMAGE]: "Imagen",
  [TEMPLATES_PRODUCE_ADD_SHAPE]: "Forma",
  [TEMPLATES_PRODUCE_ADD_GROUP]: "Grupo",
  [TEMPLATES_GROUP_LAYERS]: "Agrupar",
  [TEMPLATES_PRODUCE_SAVE_ERROR]: "No Se Pudo Guardar la Pieza",
  [TEMPLATES_PRODUCE_PARTIAL_SUMMARY]:
    "Se generaron {{succeeded}} de {{requested}}. {{failed}} fallaron.",
  [TEMPLATES_PRODUCE_PARTIAL_TITLE]:
    "Casi listo: {{succeeded}} de {{requested}} creativos generados",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR]:
    "1 creativo no pudo generarse. Puedes intentarlo de nuevo sin repetir los demás.",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL]:
    "{{failed}} creativos no pudieron generarse. Puedes intentarlo de nuevo sin repetir los demás.",
  [TEMPLATES_PRODUCE_RETRY_FAILED]: "Reintentar fallidas",
  [TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR]: "Reintentar fallida",
  [TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL]: "Reintentar fallidas",
  [TEMPLATES_PRODUCE_FAILURE_GENERIC]: "No se pudo generar esta imagen.",
  [TEMPLATES_PRODUCE_FAILURE_BUSY]:
    "El servicio estaba ocupado. Inténtalo de nuevo.",
  [TEMPLATES_PRODUCE_FAILURE_IMAGE]: "No se pudo generar esta imagen.",
  [TEMPLATES_PRODUCE_FAILURE_DATA]: "Faltan datos en esta fila.",
  [INSIGHTS_PAGE_TITLE]: "Insights",
  [INSIGHTS_HEADER_BRAND]: "leds/insights",
  [INSIGHTS_HEADER_HELP]: "¿Necesitas ayuda?",
  [INSIGHTS_CONNECT_STEP_NUMBER]: "Paso 01 / 04",
  [INSIGHTS_CONNECT_TITLE]: "Conecta tu cuenta",
  [INSIGHTS_CONNECT_MUTED]: "de Meta.",
  [INSIGHTS_CONNECT_DESCRIPTION]:
    "Leeremos la información de tus campañas para crear un reporte hecho para tu negocio. Solo pedimos permiso de lectura: no modificamos campañas, presupuestos ni anuncios.",
  [INSIGHTS_CONNECT_CARD_TITLE]: "Cuenta de Meta Ads",
  [INSIGHTS_CONNECT_CARD_SUBTITLE]:
    "Acceso de solo lectura. Sin ediciones ni publicaciones.",
  [INSIGHTS_CONNECT_CTA]: "Conectar con Meta",
  [INSIGHTS_CONNECT_CONNECTING]: "Conectando…",
  [INSIGHTS_CONNECT_CREDENTIALS_NOTE]:
    "Tus credenciales nunca se almacenan y no podemos modificar tu cuenta.",
  [INSIGHTS_CONNECT_ERROR_CANCELLED]:
    "Conexión cancelada. Inténtalo de nuevo cuando quieras.",
  [INSIGHTS_CONNECT_ERROR_FAILED]:
    "No pudimos conectar con Meta. Inténtalo de nuevo.",
  [INSIGHTS_CONNECT_ERROR_SDK]:
    "El login de Meta aún no está listo. Recarga la página e inténtalo de nuevo.",
  [INSIGHTS_CONNECT_ERROR_NO_ACCOUNTS]:
    "Este usuario de Meta no tiene cuentas publicitarias que podamos leer.",
  [INSIGHTS_CONNECT_ERROR_GENERIC]:
    "Algo salió mal al conectar. Inténtalo de nuevo.",
  [INSIGHTS_ACCOUNT_BACK]: "Volver",
  [INSIGHTS_ACCOUNT_STEP_NUMBER]: "Paso 02 / 04",
  [INSIGHTS_ACCOUNT_TITLE]: "Selecciona una",
  [INSIGHTS_ACCOUNT_MUTED]: "cuenta publicitaria.",
  [INSIGHTS_ACCOUNT_DESCRIPTION]:
    "Elige la cuenta que quieres analizar en tu reporte.",
  [INSIGHTS_ACCOUNT_CONTINUE]: "Continuar con {{accountName}}",
  [INSIGHTS_ACCOUNT_EMPTY]: "Esta conexión no devolvió cuentas publicitarias.",
  [INSIGHTS_ACCOUNT_STATUS_ACTIVE]: "Activa",
  [INSIGHTS_ACCOUNT_STATUS_PAUSED]: "Pausada",
  [INSIGHTS_GENERATING_STEP_NUMBER]: "Paso 03 / 04",
  [INSIGHTS_GENERATING_TITLE]: "Estamos generando",
  [INSIGHTS_GENERATING_MUTED]: "tu reporte.",
  [INSIGHTS_GENERATING_DESCRIPTION]:
    "Analizando los datos de {{accountName}}. Esto puede tomar alrededor de un minuto.",
  [INSIGHTS_GENERATING_PROCESSING_LABEL]: "Procesando insights",
  [INSIGHTS_GENERATING_ERROR]:
    "No pudimos generar el reporte. Revisa la conexión e inténtalo de nuevo.",
  [INSIGHTS_GENERATING_RETRY]: "Reintentar",
  [INSIGHTS_DONE_STEP_NUMBER]: "Reporte listo",
  [INSIGHTS_DONE_TITLE]: "Tus oportunidades",
  [INSIGHTS_DONE_MUTED]: "están esperando.",
  [INSIGHTS_DONE_DESCRIPTION]:
    "Ya analizamos {{accountName}}. Descubre los hallazgos que pueden hacer crecer tus campañas.",
  [INSIGHTS_DONE_REPORT_TITLE]: "Reporte de performance",
  [INSIGHTS_DONE_REPORT_SUBTITLE]: "Resumen ejecutivo · {{currency}}",
  [INSIGHTS_DONE_CTA_TITLE]: "¿Quieres saber más?",
  [INSIGHTS_DONE_CTA_DESCRIPTION]:
    "Agenda un demo y revisemos juntos los insights de tu cuenta. Con {{productName}} podrás acceder a las siguientes funcionalidades y mucho más.",
  [INSIGHTS_DONE_SCHEDULE_DEMO]: "Agendar un demo",
  [INSIGHTS_DONE_RESTART]: "Comenzar de nuevo",
  [INSIGHTS_REPORT_WHY]: "Por qué importa",
  [INSIGHTS_REPORT_WHAT_TO_DO]: "Qué hacer",
  [INSIGHTS_REPORT_QUICK_WINS]: "Dos quick wins que puedes ejecutar hoy",
  [INSIGHTS_FEATURES_HEADING]: "Funcionalidades",
  [INSIGHTS_FEATURE_AI_MEDIA_TITLE]: "Generación con IA",
  [INSIGHTS_FEATURE_AI_MEDIA_DESCRIPTION]:
    "Crea imágenes y videos listos para probar nuevas ideas.",
  [INSIGHTS_FEATURE_AI_CAMPAIGNS_TITLE]: "Campañas con IA",
  [INSIGHTS_FEATURE_AI_CAMPAIGNS_DESCRIPTION]:
    "Construye campañas completas a partir de un objetivo.",
  [INSIGHTS_FEATURE_COMPETITORS_TITLE]: "Competidores",
  [INSIGHTS_FEATURE_COMPETITORS_DESCRIPTION]:
    "Entiende qué mensajes y formatos están moviendo el mercado.",
  [INSIGHTS_FEATURE_REPORTS_TITLE]: "Reportes",
  [INSIGHTS_FEATURE_REPORTS_DESCRIPTION]:
    "Analiza el rendimiento de tus campañas y descubre oportunidades de mejora.",
  [AI_COMPETITORS_PAGE_TITLE]: "Análisis de competidores",
  [AI_COMPETITORS_URL_STEP_NUMBER]: "Paso 01 / 04",
  [AI_COMPETITORS_URL_TITLE]: "Analiza",
  [AI_COMPETITORS_URL_MUTED]: "tus competidores",
  [AI_COMPETITORS_URL_DESCRIPTION]:
    "Pega la página web de tu negocio. En segundos te mostramos quién está pautando en tu mercado y con qué anuncios.",
  [AI_COMPETITORS_URL_PLACEHOLDER]: "Pega la página web de tu negocio",
  [AI_COMPETITORS_URL_CTA]: "Ver anuncios de mi competencia",
  [AI_COMPETITORS_URL_INVALID]:
    "Lo que escribiste no parece una URL válida. Revisa que esté bien escrita e inténtalo de nuevo.",
  [AI_COMPETITORS_URL_BLOCKED]:
    "No pudimos obtener la información de tu sitio web. Algunas páginas utilizan mecanismos que bloquean el acceso automatizado (anti-crawlers)",
  [AI_COMPETITORS_URL_NO_COMPETITORS]:
    "No encontramos competidores para esa marca. Prueba con otra URL o un dominio más específico.",
  [AI_COMPETITORS_ANALYZING_STEP_NUMBER]: "Paso 02 / 04",
  [AI_COMPETITORS_ANALYZING_TITLE]: "Estamos leyendo",
  [AI_COMPETITORS_ANALYZING_MUTED]: "tu mercado.",
  [AI_COMPETITORS_ANALYZING_DESCRIPTION]:
    "Identificamos tu marca, categoría y país para sugerirte competidores reales.",
  [AI_COMPETITORS_PROGRESS_FALLBACK]: "Analizando tu página web",
  [AI_COMPETITORS_PROGRESS_REVIEWING_PAGE]: "Revisando tu página",
  [AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS]: "Buscando tus competidores",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS]:
    "Consolidando tus competidores",
  [AI_COMPETITORS_PROGRESS_RESOLVING_ADS]: "Localizando a tus competidores",
  [AI_COMPETITORS_PROGRESS_SEARCHING_ADS]: "Buscando anuncios activos",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS]: "Consolidando los anuncios",
  [AI_COMPETITORS_COMPETITORS_STEP_NUMBER]: "Paso 03 / 04",
  [AI_COMPETITORS_COMPETITORS_TITLE]: "Estos son",
  [AI_COMPETITORS_COMPETITORS_MUTED]: "tus competidores.",
  [AI_COMPETITORS_COMPETITORS_DESCRIPTION]:
    "Elimina los que no apliquen, edita el nombre o pega el dominio de los que te interesan.",
  [AI_COMPETITORS_COMPETITORS_EMPTY]:
    "No encontramos competidores automáticos. Pega el dominio de quienes sí quieres espiar.",
  [AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER]:
    "Pega un dominio, ej. competidor.com",
  [AI_COMPETITORS_COMPETITORS_ADD]: "Agregar",
  [AI_COMPETITORS_COMPETITORS_ADD_INVALID]:
    "Revisa el dominio. Debe verse como marca.com",
  [AI_COMPETITORS_COMPETITORS_NAME_LABEL]: "Nombre",
  [AI_COMPETITORS_COMPETITORS_REMOVE]: "Eliminar",
  [AI_COMPETITORS_COMPETITORS_CTA]: "Buscar sus anuncios",
  [AI_COMPETITORS_COMPETITORS_NEED_ONE]:
    "Agrega al menos un competidor para buscar anuncios.",
  [AI_COMPETITORS_COMPETITORS_ADD_MAX]:
    "Puedes agregar hasta {{max}} competidores.",
  [AI_COMPETITORS_SEARCHING_STEP_NUMBER]: "Paso 04 / 04",
  [AI_COMPETITORS_SEARCHING_TITLE]: "Buscando",
  [AI_COMPETITORS_SEARCHING_MUTED]: "anuncios activos.",
  [AI_COMPETITORS_SEARCHING_ERROR]:
    "No pudimos completar la búsqueda. Inténtalo de nuevo.",
  [AI_COMPETITORS_SEARCHING_RETRY]: "Reintentar",
  [AI_COMPETITORS_RESULTS_STEP_NUMBER]: "Anuncios encontrados",
  [AI_COMPETITORS_RESULTS_TITLE]: "Esto está",
  [AI_COMPETITORS_RESULTS_MUTED]: "pautando tu competencia.",
  [AI_COMPETITORS_RESULTS_SUMMARY]:
    "Encontramos {{adsCount}} anuncios activos de {{competitorCount}} competidores.",
  [AI_COMPETITORS_RESULTS_NO_ADS]: "Sin anuncios activos",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE]:
    "Tu competencia casi no está pautando. Es tu oportunidad.",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY]:
    "Adle puede analizar tu competencia 24/7 y replicar los anuncios que sí funcionan.",
  [AI_COMPETITORS_RESULTS_NO_ADS_CTA]: "Agenda un demo",
  [AI_COMPETITORS_RESULTS_VIEW_MORE]: "Ver más",
  [AI_COMPETITORS_RESULTS_GENERATE]: "Generar Mi Versión",
  [AI_COMPETITORS_RESULTS_LOCKED_COUNT]: "+{{count}} anuncios más",
  [AI_COMPETITORS_RESULTS_DOWNLOAD]: "Descargar",
  [AI_COMPETITORS_RESULTS_FORMAT_IMAGE]: "Imagen",
  [AI_COMPETITORS_RESULTS_FORMAT_VIDEO]: "Video",
  [AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL]: "Carrusel",
  [AI_COMPETITORS_AGENDA_CONFIRM_TITLE]: "Descubre Adle",
  [AI_COMPETITORS_AGENDA_CONFIRM_TEXT]:
    "Te mostramos todos los anuncios de tus competidores y te enseñamos cómo replicarlos en segundos.",
  [AI_COMPETITORS_AGENDA_CONFIRM_CTA]: "Agendar Demo",
  [AI_COMPETITORS_AGENDA_BACK]: "Atrás",
  [AI_COMPETITORS_AGENDA_STEP_NUMBER]: "Siguiente paso",
  [AI_COMPETITORS_AGENDA_TITLE]: "Te mostramos",
  [AI_COMPETITORS_AGENDA_MUTED]: "cómo replicarlos.",
  [AI_COMPETITORS_AGENDA_CONTEXT]:
    "Encontramos {{adsCount}} anuncios activos de {{competitorNames}}. En la llamada te mostramos cómo replicar los que mejor funcionan con {{productName}}.",
  [AI_COMPETITORS_AGENDA_CONTEXT_ZERO]:
    "Tu competencia casi no está pautando: es tu oportunidad. {{productName}} puede analizarla 24/7 y replicar anuncios que funcionan.",
  [AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK]:
    "En la llamada te mostramos cómo replicar los anuncios que mejor funcionan con {{productName}}.",
  [AI_COMPETITORS_THANKS_STEP_NUMBER]: "Agenda confirmada",
  [AI_COMPETITORS_THANKS_TITLE]: "¡Nos vemos",
  [AI_COMPETITORS_THANKS_MUTED]: "en la llamada.",
  [AI_COMPETITORS_THANKS_DESCRIPTION]:
    "Te enviamos la confirmación por correo. En la sesión revisamos los anuncios de tu competencia y cómo replicar los que mejor funcionan.",
  [NEW_FEATURE_CALLOUT_BADGE]: "NUEVA FUNCIÓN",
  [NEW_FEATURE_CALLOUT_CLOSE_ARIA]: "Cerrar",
  [NEW_FEATURE_CALLOUT_DEFAULT_CTA]: "Descubrir",
  [NEW_FEATURE_CALLOUT_INSIGHTS_TITLE]: "Insights",
  [NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION]:
    "Descubre los aprendizajes que la IA identificó en los resultados de tus campañas y aplícalos a la configuración de tu marca.",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE]: "Plantillas",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION]:
    "Genera contenido a partir de plantillas: define las capas o sube un creativo para que lo analicemos por ti.",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE]: "Automatizaciones",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION]:
    "Publica contenido de tu biblioteca automáticamente: elige carpeta, plataformas y frecuencia. Nosotros nos encargamos del resto.",

  // AUTOMATIONS
  [AUTOMATIONS_MENU_TITLE]: "Automatizaciones",
  [AUTOMATIONS_PAGE_TITLE]: "Publicación Automática",
  [AUTOMATIONS_PAGE_DESCRIPTION]:
    "Permite que {{NAME_BUSINESS}} publique automáticamente contenido de tu biblioteca en tus redes sociales conectadas.",
  [BUTTON_NEW_AUTOMATION]: "Nueva",
  [AUTOMATIONS_HERO_TITLE]: "Ahorra tiempo. Sigue publicando.",
  [AUTOMATIONS_HERO_DESCRIPTION]:
    "Selecciona una carpeta, elige tus plataformas y {{NAME_BUSINESS}} se encargará del resto — desde la programación hasta la publicación.",
  [AUTOMATIONS_STATUS_ACTIVE]: "Activa",
  [AUTOMATIONS_STATUS_PAUSED]: "Pausada",
  [AUTOMATIONS_LABEL_FOLDER]: "Carpeta",
  [AUTOMATIONS_LABEL_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_LABEL_FREQUENCY]: "Frecuencia",
  [AUTOMATIONS_LABEL_NEXT_POST]: "Próxima publicación",
  [AUTOMATIONS_MOCK_BRAND_CONTENT]: "Contenido de marca",
  [AUTOMATIONS_MOCK_PRODUCT_LAUNCH]: "Lanzamiento de producto",
  [AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP]: "Liderazgo de pensamiento",
  [AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER]: "Redes sociales septiembre",
  [AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT]: "Todo el contenido",
  [AUTOMATIONS_MOCK_FOLDER_LINKEDIN]: "Contenido LinkedIn",
  [AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY]: "1 publicación al día",
  [AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK]: "5 publicaciones por semana",
  [AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK]: "3 publicaciones por semana",
  [AUTOMATIONS_FREQ_ONE_PER_DAY]: "1 publicación al día",
  [AUTOMATIONS_FREQ_THREE_PER_WEEK]: "3 publicaciones por semana",
  [AUTOMATIONS_FREQ_FOUR_PER_WEEK]: "4 publicaciones por semana",
  [AUTOMATIONS_FREQ_FIVE_PER_WEEK]: "5 publicaciones por semana",
  [AUTOMATIONS_FREQ_SIX_PER_WEEK]: "6 publicaciones por semana",
  [AUTOMATIONS_MOCK_NEXT_TODAY]: "Hoy · 7:00 PM",
  [AUTOMATIONS_MOCK_NEXT_EMPTY]: "—",
  [AUTOMATIONS_MOCK_NEXT_TOMORROW]: "Mañana · 9:00 AM",
  [MODAL_CREATE_AUTOMATION_TITLE]: "Crear Automatización",
  [AUTOMATIONS_STEP_SOURCE]: "Fuente",
  [AUTOMATIONS_STEP_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_STEP_SCHEDULE]: "Programación",
  [AUTOMATIONS_STEP_CONTENT_AI]: "Contenido e IA",
  [AUTOMATIONS_STEP_REVIEW]: "Revisión",
  [AUTOMATIONS_STEP_SOURCE_TITLE]: "Seleccionar fuente de contenido",
  [AUTOMATIONS_STEP_SOURCE_HELP]:
    "Elige qué contenido debe usar {{NAME_BUSINESS}} para la publicación automática.",
  [AUTOMATIONS_SOURCE_ALL_TITLE]: "Todo el contenido (raíz)",
  [AUTOMATIONS_SOURCE_ALL_DESCRIPTION]:
    "Usa todo el contenido de tu biblioteca.",
  [AUTOMATIONS_SOURCE_FOLDER_TITLE]: "Carpeta específica",
  [AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION]:
    "Usa contenido de una carpeta seleccionada.",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS]: "Incluir subcarpetas",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP]:
    "También usa contenido de carpetas anidadas.",
  [AUTOMATIONS_STEP_LANGUAGE_TITLE]: "Idioma",
  [AUTOMATIONS_STEP_LANGUAGE_HELP]:
    "Las descripciones de las publicaciones se generarán en este idioma.",
  [AUTOMATIONS_VALIDATION_LANGUAGE]:
    "Selecciona el idioma de las descripciones para continuar.",
  [AUTOMATIONS_REVIEW_LANGUAGE]: "Idioma",
  [AUTOMATIONS_CONNECT_ACCOUNTS]: "Conectar Cuentas",
  [AUTOMATIONS_STEP_PLATFORMS_TITLE]: "Seleccionar plataformas",
  [AUTOMATIONS_STEP_PLATFORMS_HELP]:
    "Elige las cuentas sociales donde {{NAME_BUSINESS}} puede publicar contenido.",
  [AUTOMATIONS_PLATFORM_CONNECTED]: "Conectada",
  [AUTOMATIONS_STEP_SCHEDULE_TITLE]: "Configurar programación",
  [AUTOMATIONS_STEP_SCHEDULE_HELP]:
    "Indica a {{NAME_BUSINESS}} con qué frecuencia y cuándo publicar.",
  [AUTOMATIONS_SCHEDULE_FREQUENCY]: "Frecuencia",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW]: "Ventana de publicación",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP]:
    "{{NAME_BUSINESS}} sugerirá las mejores horas para publicar dentro de esta ventana de tiempo.",
  [AUTOMATIONS_SCHEDULE_TIMEZONE]: "Zona horaria",
  [AUTOMATIONS_SCHEDULE_VALIDITY]: "Vigencia",
  [AUTOMATIONS_SCHEDULE_VALIDITY_HELP]:
    "Define cuándo inicia y finaliza esta automatización.",
  [AUTOMATIONS_SCHEDULE_START]: "Inicio",
  [AUTOMATIONS_SCHEDULE_START_NOW]: "Empezar ahora",
  [AUTOMATIONS_SCHEDULE_START_NOW_HELP]:
    "La automatización comenzará inmediatamente después de crearla.",
  [AUTOMATIONS_SCHEDULE_START_SCHEDULED]: "Programar inicio",
  [AUTOMATIONS_SCHEDULE_END]: "Finalización",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON]: "Siempre activa",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP]:
    "La automatización continuará hasta que la pauses.",
  [AUTOMATIONS_SCHEDULE_END_SCHEDULED]: "Finalizar en una fecha",
  [AUTOMATIONS_STEP_CONTENT_AI_TITLE]: "Contenido e IA",
  [AUTOMATIONS_STEP_CONTENT_AI_HELP]:
    "Elige cómo {{NAME_BUSINESS}} debe preparar cada publicación antes de publicarla.",
  [AUTOMATIONS_CONTENT_ORIGINAL_TITLE]: "Usar contenido original",
  [AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION]:
    "Publica los recursos seleccionados tal como están.",
  [AUTOMATIONS_CONTENT_AI_TITLE]: "Optimizar con IA de {{NAME_BUSINESS}}",
  [AUTOMATIONS_CONTENT_AI_DESCRIPTION]:
    "Genera descripciones y adapta el contenido para cada plataforma.",
  [AUTOMATIONS_AI_NOTE_TITLE]: "La asistencia de IA está lista",
  [AUTOMATIONS_AI_NOTE_DESCRIPTION]:
    "{{NAME_BUSINESS}} mantendrá la voz de tu marca consistente.",
  [AUTOMATIONS_STEP_REVIEW_TITLE]: "Revisar automatización",
  [AUTOMATIONS_STEP_REVIEW_HELP]:
    "Revisa tu configuración antes de crear esta automatización.",
  [AUTOMATIONS_REVIEW_SOURCE]: "Fuente",
  [AUTOMATIONS_REVIEW_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_REVIEW_SCHEDULE]: "Programación",
  [AUTOMATIONS_REVIEW_VALIDITY]: "Vigencia",
  [AUTOMATIONS_REVIEW_VALIDITY_VALUE]: "{{start}} · {{end}}",
  [AUTOMATIONS_REVIEW_VALIDITY_START_NOW]: "Empieza ahora",
  [AUTOMATIONS_REVIEW_VALIDITY_START_AT]: "Empieza el {{datetime}}",
  [AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON]: "Siempre activa",
  [AUTOMATIONS_REVIEW_VALIDITY_END_AT]: "Finaliza el {{datetime}}",
  [AUTOMATIONS_REVIEW_NAME]: "Nombre",
  [AUTOMATIONS_REVIEW_CONTENT_AI]: "Contenido generado por IA",
  [AUTOMATIONS_DEFAULT_NAME]: "Automatización {{date}}",
  [AUTOMATIONS_BUTTON_BACK]: "Atrás",
  [AUTOMATIONS_BUTTON_CREATE]: "Crear",
  [AUTOMATIONS_BUTTON_SAVE]: "Guardar cambios",
  [AUTOMATIONS_REVIEW_SCHEDULE_VALUE]:
    "{{frequency}} · {{startTime}} – {{endTime}}",
  [AUTOMATIONS_STATUS_WAITING]: "Esperando contenido",
  [AUTOMATIONS_STATUS_SCHEDULING]: "Programando",
  [AUTOMATIONS_STATUS_ATTENTION]: "Requiere atención",
  [AUTOMATIONS_STATUS_OFF]: "Apagada",
  [AUTOMATIONS_STATUS_ENDED]: "Finalizada",
  [AUTOMATIONS_MENU_EDIT]: "Editar",
  [AUTOMATIONS_MENU_VIEW_CALENDAR]: "Ver calendario",
  [AUTOMATIONS_MENU_TURN_OFF]: "Apagar",
  [AUTOMATIONS_TURN_OFF_TITLE]: "¿Apagar la publicación automática?",
  [AUTOMATIONS_TURN_OFF_DESCRIPTION]:
    "Las publicaciones ya programadas no se eliminarán automáticamente. {{NAME_BUSINESS}} dejará de crear nuevas publicaciones automáticas.",
  [AUTOMATIONS_TURN_OFF_CONFIRM]: "Apagar",
  [AUTOMATIONS_WAITING_BANNER]:
    "Automatización en pausa — no hay contenido compatible sin publicar.",
  [AUTOMATIONS_ATTENTION_BANNER]:
    "Una o más cuentas sociales requieren atención. El resto de plataformas seguirá publicando.",
  [AUTOMATIONS_VALIDATION_FOLDER]: "Selecciona una carpeta para continuar.",
  [AUTOMATIONS_VALIDATION_ACCOUNTS]:
    "Selecciona al menos una cuenta conectada.",
  [AUTOMATIONS_VALIDATION_WINDOW]:
    "El inicio de la ventana de publicación debe ser anterior al final.",
  [AUTOMATIONS_VALIDATION_START_REQUIRED]:
    "Selecciona una fecha y hora de inicio.",
  [AUTOMATIONS_VALIDATION_START_FUTURE]:
    "La fecha de inicio debe ser ahora o en el futuro.",
  [AUTOMATIONS_VALIDATION_END_REQUIRED]:
    "Selecciona una fecha y hora de finalización.",
  [AUTOMATIONS_VALIDATION_END_FUTURE]:
    "La fecha de finalización debe ser futura.",
  [AUTOMATIONS_VALIDATION_END_AFTER_START]:
    "La fecha de finalización debe ser posterior al inicio.",
  [AUTOMATIONS_HERO_QUEUED]: "En cola",
  [AUTOMATIONS_HERO_PUBLISHED]: "Publicadas esta semana",
  [AUTOMATIONS_HERO_FAILED]: "Fallidas",
  [AUTOMATIONS_HERO_NEXT]: "Próxima publicación",
  [AUTOMATIONS_NEXT_NONE]: "—",
  [AUTOMATIONS_REMAINING_CONTENT]: "{{count}} restantes",
  [CALENDAR_SOURCE_AUTOMATED]: "Automática",
  [CALENDAR_ACTIVE_AUTOMATIONS]: "Automatizaciones Activas ({{count}})",
  [CALENDAR_AUTOMATION_ENDS]: "Finaliza el {{date}}",
  [CALENDAR_AUTOMATION_FOLDER]: "{{folder}}",
  [CALENDAR_SOURCE_MANUAL]: "Manual",
  [EVENT_DETAILS_AUTOMATION]: "Automatización",
  [EVENT_DETAILS_ACCOUNT]: "Cuenta",
  [MODAL_EDIT_AUTOMATION_TITLE]: "Editar automatización",
  [AUTOMATIONS_NO_PERMISSION]:
    "Puedes ver las automatizaciones, pero no puedes modificarlas.",
  [OPTIMISTIC_SWITCH_FAILURE_BODY]:
    "No se pudo {{action}} {{name}} debido al siguiente error:",
  [OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT]:
    "Ocurrió un problema actualizando el último estado que intentaste cambiar.",
  [OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN]: "encender la campaña",
  [OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN]: "apagar la campaña",
  [OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP]: "encender el grupo de assets",
  [OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP]: "apagar el grupo de assets",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP]: "encender el ad group",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP]: "apagar el ad group",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD]: "encender el anuncio",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD]: "apagar el anuncio",
  [OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION]: "reanudar la automatización",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION]: "pausar la automatización",
  [OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE]: "activar el código",
  [OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE]: "desactivar el código",
  [CREATE_CAMPAIGN_WIZARD_ARIA]: "Crear campaña",
  [CREATE_CAMPAIGN_SETUP_TITLE]: "Crear campaña",
  [CREATE_CAMPAIGN_SETUP_DESCRIPTION]:
    "Elige el idioma, las ubicaciones y una plataforma. La temática es opcional.",
  [CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP]:
    "Agrega contexto o archivos opcionales para que la campaña coincida con tu objetivo.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP]:
    "Elige el idioma de los anuncios, textos y recomendaciones.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP]:
    "Selecciona las ubicaciones donde debe correr esta campaña.",
  [CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP]:
    "Elige una plataforma para continuar. Puedes volver atrás y cambiarla después.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE]: "Exclusiones de {{adAccountName}}",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION]:
    "Aplica diferentes tipos de exclusiones a nivel de cuenta. Estas se aplicarán de manera común a todas las campañas actuales y futuras de la cuenta.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS]: "Canales Excluidos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS]: "Videos Excluidos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES]: "Categorías Excluidas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS]: "Apps Excluidas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES]: "Categorías Excluidas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING]: "Cargando Configuración",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW]: "Aún no hay datos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS]: "Exclusiones de la cuenta",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS]: "Keywords Negativas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE]: "YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS]: "Apps",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD]: "Keyword",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS]:
    "La keyword tiene caracteres no permitidos (., -, /, y otros símbolos)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX]:
    'La concordancia debe cerrar bien: [palabra] o "palabra". No uses comillas simples',
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE]: "Concordancia",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD]: "Amplia",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE]: "De frase",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT]: "Exacta",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL]: "Canal de YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID]:
    "Usa un link de canal de YouTube (youtube.com/channel/..., /@usuario, /c/... o /user/...)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO]: "Video de YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES]: "Categorías",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID]: "ID de la app",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME]: "Nombre",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES]: "Buscar categoría",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY]: "Todavía no hay exclusiones",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED]: "Exclusiones guardadas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR]:
    "No se pudieron guardar las exclusiones",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR]:
    "No se pudo cargar la configuración de la cuenta",
  [GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD]:
    "Contenido fuera de la primera pantalla",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES]:
    "Contenido para familias y Made for Kids",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING]:
    "Juegos de lucha",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE]:
    "Juegos para adultos",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE]:
    "Salud sensible",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED]:
    "Salud de fuente no determinada",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT]:
    "Noticias recientes",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE]:
    "Noticias sensibles",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED]:
    "Noticias de fuentes no destacadas",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS]: "Política",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION]: "Religión",
  [GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO]: "Video insertado",
  [GOOGLE_ADS_CONTENT_LABEL_JUVENILE]: "Contenido grotesco o bizarro",
  [GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO]: "Video en directo",
  [GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN]: "Dominio sin sitio web",
  [GOOGLE_ADS_CONTENT_LABEL_PROFANITY]: "Lenguaje soez",
  [GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE]:
    "Contenido sexualmente sugerente",
  [GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES]: "Temas sociales sensibles",
  [GOOGLE_ADS_CONTENT_LABEL_TRAGEDY]: "Muerte y tragedia",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO]: "Video",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED]: "Video sin clasificar",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G]:
    "Clasificación G (apta para todo público)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA]:
    "Clasificación MA (solo adultos)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG]:
    "Clasificación PG (se recomienda supervisión de los padres)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T]:
    "Clasificación T (adolescentes)",
  [FEATURE_ADDON_PAYWALL_TITLE]: "Mejora esta función",
  [FEATURE_ADDON_PAYWALL_DESCRIPTION]:
    "Alcanzaste el límite gratuito de esta función AppSumo. Elige un plan mensual para continuar.",
  [FEATURE_ADDON_PAYWALL_CURRENT_LIMIT]: "Límite actual: {{limit}}",
  [FEATURE_ADDON_PAYWALL_TIER_CTA]: "Suscribirse",
  [FEATURE_ADDON_PAYWALL_CLOSE]: "Cerrar",
  [FEATURE_ADDON_PAYWALL_FREE]: "Gratis",
  [FEATURE_ADDON_PAYWALL_INCLUDED]: "Tu cuenta ya incluye {{benefits}}",
  [FEATURE_ADDON_INCLUDED_AUTOMATIONS]:
    "{{capacity}} para publicar en {{platforms}} hasta {{count}} veces por semana",
  [FEATURE_ADDON_INCLUDED_TEMPLATES]:
    "{{capacity}} y generar hasta {{produceLimit}} piezas a la vez",
  [FEATURE_ADDON_INCLUDED_COMPETITORS]:
    "ver {{visibility}} anuncios en {{platforms}}, guardar 1 favorito y generar 1 versión",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE]: "1 favorito o versión al mes",
  [FEATURE_ADDON_PAYWALL_CURRENT]: "Actual",
  [FEATURE_ADDON_PAYWALL_PER_MONTH]: "USD/mes",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS]:
    "Hasta {{limit}} automatizaciones en tu cuenta",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE]: "1 automatización",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES]:
    "Hasta {{limit}} plantillas en tu cuenta",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE]: "1 plantilla",
  [FEATURE_ADDON_BENEFIT_ACTIONS]:
    "Guardar o genera hasta {{limit}} anuncios al mes",
  [FEATURE_ADDON_BENEFIT_ACTIONS_ONE]: "Guardar o genera una variación",
  [FEATURE_ADDON_BENEFIT_VISIBILITY]:
    "Ver {{limit}} anuncios de tus competidores",
  [FEATURE_ADDON_BENEFIT_VISIBILITY_ALL]:
    "Ver todos los anuncios de tus competidores",
  [FEATURE_ADDON_PAYWALL_TIER_NAME]: "Tier {{index}}",
  [FEATURE_ADDON_HERO_AUTOMATIONS]:
    "Automatiza la publicación de contenido en tus redes sociales.",
  [FEATURE_ADDON_HERO_TEMPLATES]:
    "Genera contenido a partir de plantillas definidas por ti.",
  [FEATURE_ADDON_HERO_COMPETITORS]:
    "Revisa y genera variaciones de los anuncios que le funcionan a tu competencia.",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH]:
    "Publica en Facebook, Instagram, Youtube, TikTok y LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE]:
    "Sugerir el mejor día y hora para cada tipo de post",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS]:
    "Define capas, grupos y propiedades",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE]: "Separar un creativo en capas",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE]:
    "Guarda anuncios y genera tu versión",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE]:
    "Revisa anuncios de tu competencia en Meta, Google y LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS]: "Publica en {{platforms}}",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY]:
    "Hasta {{count}} publicaciones multiplataforma por semana por automatización",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM]:
    "Publicación multiplataforma",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY]:
    "Una misma publicación en varias plataformas a la vez cuenta como solo 1 publicación.",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE]:
    "Genera hasta {{limit}} piezas a la vez",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS]: "Anuncios en {{platforms}}",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES]:
    "Guarda hasta {{limit}} favoritos al mes",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE]: "Guarda 1 favorito",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE]: "Genera tu versión",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE]: "Genera 1 versión",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL]:
    "Hasta {{limit}} favoritos o versiones al mes",
  [FEATURE_ADDON_NAME_AUTOMATIONS]: "Automatizaciones",
  [FEATURE_ADDON_NAME_TEMPLATES]: "Plantillas",
  [FEATURE_ADDON_NAME_COMPETITORS]: "Competidores",
  [FEATURE_ADDON_UNPAID_TITLE]: "Falló el pago de {{feature}} {{tier}}",
  [FEATURE_ADDON_UNPAID_PERIOD]:
    "Pago de {{feature}} {{tier}}, periodo del {{startDate, short}} al {{endDate, short}}",
  [FEATURE_ADDON_UNPAID_AMOUNT]: "Pago pendiente de {{value}} {{currency}}",
  [FEATURE_ADDON_BILLING_TITLE]: "Add-ons",
  [FEATURE_ADDON_BILLING_RENEWS]: "Se renueva el {{date, short}}",
  [FEATURE_ADDON_BILLING_CANCELS]: "Se cancela el {{date, short}}",
  [FEATURE_ADDON_BILLING_UPGRADE]: "Subir de plan",
  [FEATURE_ADDON_BILLING_CANCEL_TITLE]: "¿Cancelar este addon?",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE]: "⚠️ Esto cancelará el add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM]: "Cancelar add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP]: "Conservar add-on",
  [FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION]:
    "Seguirás con este addon hasta el {{date, day}} de {{date, monthText}}, {{date, year}}. Después pasas al plan gratis y perderás acceso a los beneficios de tu plan pago.",
  [FEATURE_ADDON_BILLING_CANCELLED_TITLE]: "Cancelación programada",
  [FEATURE_ADDON_BILLING_REACTIVATED_TITLE]: "Addon reactivado",
  [FEATURE_ADDON_BILLING_MENU]: "Opciones del addon",
  [EXTRA_SEATS_MANAGE]: "Gestionar",
  [EXTRA_SEATS_MODAL_TITLE]: "Usuarios del Equipo Adicionales",
  [EXTRA_SEATS_MODAL_SUBTITLE]:
    "Tu plan incluye {{planUsers}} usuarios. Los adicionales cuestan {{price}}/mes c/u.",
  [EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE]:
    "Tu plan incluye {{planUsers}} usuarios.",
  [EXTRA_SEATS_QUANTITY_LABEL]: "Usuarios adicionales",
  [EXTRA_SEATS_DELTA_USERS_ONE]: "{{count}} usuario × {{price}}",
  [EXTRA_SEATS_DELTA_USERS]: "{{count}} usuarios × {{price}}",
  [EXTRA_SEATS_AMOUNT_PER_MONTH]: "{{amount}}/mes",
  [EXTRA_SEATS_DUE_TODAY_LABEL]: "Hoy pagarás",
  [EXTRA_SEATS_PRORATION_TODAY]:
    "Prorrateo hoy ({{start, d MMM}} → {{end, d MMM}})",
  [EXTRA_SEATS_NEXT_TOTAL_FROM]: "Desde el {{date, d MMM}}",
  [EXTRA_SEATS_NEXT_TOTAL_MONTHLY]: "Cada mes",
  [EXTRA_SEATS_MONTHLY_TOTAL]: "Total mensual",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE]:
    "Mantienes tu usuario adicional hasta el fin del ciclo.",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE]:
    "Mantienes tus {{count}} usuarios hasta el fin del ciclo.",
  [EXTRA_SEATS_PRORATION_NOTE]:
    "Pagas solo por los días que quedan de este ciclo. Próximo cobro: {{date, d MMM}} · {{amount}}",
  [EXTRA_SEATS_NO_CHARGE_NOTE]: "No hay cargo hoy.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE]:
    "Tienes {{used}} miembros activos. Quita uno en {{section}} antes de bajar.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK]:
    "Tienes {{used}} miembros activos. Quita {{count}} en {{section}} antes de bajar.",
  [EXTRA_SEATS_REDUCE_BLOCKED_ONE]: "Quita uno en {{section}} antes de bajar.",
  [EXTRA_SEATS_REDUCE_BLOCKED]:
    "Quita {{count}} en {{section}} antes de bajar.",
  [EXTRA_SEATS_CONFIRM]: "Confirmar",
  [EXTRA_SEATS_ADDED]:
    "Usuario adicional agregado. Ya puedes crear el usuario.",
  [EXTRA_SEATS_CHECKOUT_CANCELLED]:
    "Pago cancelado. No se agregó ningún usuario adicional.",
  [EXTRA_SEATS_CHECKOUT_INCOMPLETE]:
    "El pago no se completó. No se agregó ningún usuario adicional.",
  [EXTRA_SEATS_BILLING_ROW_TITLE]: "Usuarios del Equipo Adicionales",
  [EXTRA_SEATS_QUANTITY_BADGE]: "{{n}} Usuarios Adicionales",
  [EXTRA_SEATS_REDUCE_NOTICE]:
    "Tus usuarios adicionales bajarán a {{n}} el {{date, short}}. No hay reembolso del período actual.",
  [EXTRA_SEATS_CANCEL_NOTICE]:
    "Los usuarios adicionales se cancelarán el {{date, short}}.",
  [EXTRA_SEATS_CHANGE_SAVED]: "Usuarios adicionales actualizados.",
  [EXTRA_SEATS_FORBIDDEN]:
    "No tienes permiso para cambiar los usuarios adicionales.",
  [EXTRA_SEATS_DECREASE]: "Menos usuarios adicionales",
  [EXTRA_SEATS_INCREASE]: "Más usuarios adicionales",
  [EXTRA_SEATS_RETRY]:
    "No pudimos actualizar los usuarios adicionales. Intenta de nuevo.",
  [EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE]:
    "No puedes reactivar los usuarios adicionales con tu plan actual.",
  [EXTRA_SEATS_CHECKOUT_FORBIDDEN]:
    "Este pago no corresponde a usuarios adicionales.",
  [EXTRA_SEATS_MISSING_AGENCY]:
    "No encontramos la agencia de esta cuenta, así que los usuarios adicionales no están disponibles.",
  [SEAT_LIMIT_REACHED]: "Llegaste al límite de usuarios de tu plan.",
  [SEATS_QUANTITY_CHANGED]:
    "Tus usuarios adicionales cambiaron. Revisa e intenta de nuevo.",
  [SEATS_OPERATION_IN_PROGRESS]:
    "Hay otro cambio en curso. Intenta de nuevo en un minuto.",
  [SEATS_UNPAID]:
    "Tus usuarios adicionales tienen una factura pendiente. Actualiza tu método de pago para agregar más.",
  [SEATS_QUANTITY_OUT_OF_RANGE]:
    "Puedes elegir entre {{min}} y {{max}} usuarios adicionales.",
  [SEATS_NOT_ELIGIBLE]:
    "Los usuarios adicionales no están disponibles para esta cuenta.",
  [SEATS_PRICE_NOT_CONFIGURED]:
    "Los usuarios adicionales no están disponibles en este momento.",
  [SEATS_SUBSCRIPTION_NOT_FOUND]:
    "No encontramos la suscripción de usuarios adicionales.",
  [BUTTON_BULK_CREATE_CAMPAIGNS]: "Generación Masiva",
  [BULK_CAMPAIGNS_DESCRIPTION]:
    "Sube el brief de tus campañas y Adle se encargará de detectar todas las campañas y la estructura que quieres generar.",
  [BULK_CAMPAIGNS_SUMMARY]:
    "Encontramos un total de {{campaigns}} campañas a generar, con hasta {{maxAdGroups}} grupos de anuncios dentro de cada una.",
  [BULK_CAMPAIGNS_LIST_TITLE]: "Campañas que se generarán",
  [BULK_CAMPAIGNS_GENERATE]: "Generar campañas",
  [BULK_CAMPAIGNS_GENERATING]: "Generando campañas...",
  [BULK_CAMPAIGNS_ALERT_ANALYZING]: "Analizando el Documento de Campañas...",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS]:
    "Documento Analizado. Revisa las Campañas a Generar",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR]: "No Pudimos Analizar el Documento",
  [BULK_CAMPAIGNS_ALERT_GENERATING]: "Generando {{count}} Campañas...",
  [BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS]: "{{count}} Campañas Generadas",
  [BULK_CAMPAIGNS_ALERT_GENERATION_ERROR]: "No Pudimos Generar las Campañas",
  [BULK_CAMPAIGNS_GENERATE_ERROR]:
    "No pudimos generar las campañas. Inténtalo de nuevo.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED]:
    "La plataforma {{platform}} no está disponible para la generación masiva.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED]:
    "No pudimos detectar la plataforma de este documento.",
  [BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED]:
    "Este tipo de campaña no está disponible para la generación masiva.",
  [BULK_CAMPAIGNS_TITLE]: "Genera Campañas en Masa",
  [BULK_CAMPAIGNS_DROP_TITLE]:
    "Suelta tu archivo aquí o haz clic para buscarlo",
  [BULK_CAMPAIGNS_DROP_FORMATS]:
    "Excel (.xlsx), CSV, TSV, PDF, Markdown o TXT. Hasta 7 MB",
  [BULK_CAMPAIGNS_ANALYZING]: "Analizando {{fileName}}",
  [BULK_CAMPAIGNS_FILE_NOT_SUPPORTED]:
    "Este tipo de archivo no es compatible. Usa Excel (.xlsx), CSV, TSV, PDF, Markdown o TXT.",
  [BULK_CAMPAIGNS_FILE_TOO_LARGE]:
    "El archivo es demasiado grande. El tamaño máximo es 7 MB.",
  [BULK_CAMPAIGNS_EXTRACT_ERROR]:
    "No pudimos leer la estructura de este archivo. Inténtalo de nuevo o usa otro archivo.",
  [BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR]:
    "No pudimos cargar los contenidos. Inténtalo de nuevo.",
  [BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND]:
    "No encontramos ninguna estructura de campaña en este archivo.",
  [BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE]: "Elegir otro archivo",
  [CAMPAIGN_AGENT_WELCOME_TITLE]: "Puedo aplicar cambios a tu campaña por ti",
  [CAMPAIGN_AGENT_WELCOME_SUBTITLE]:
    "Pídeme una mejora, revisa lo que te propongo y aplícalo con un clic. Nada se publica hasta que tú lo decidas.",
  [CAMPAIGN_AGENT_STEP_ASK]: "Pide",
  [CAMPAIGN_AGENT_STEP_REVIEW]: "Revisa",
  [CAMPAIGN_AGENT_STEP_APPLY]: "Aplica",
  [CAMPAIGN_AGENT_WELCOME_HINT]:
    "También puedes escribirme el cambio que quieres, por ejemplo: “Cambia la edad de la audiencia a 25 a 45 años”.",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER]: "Pídeme un cambio para tu campaña",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1]:
    "Auméntame un 20% el presupuesto de la campaña",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2]:
    "Reescribe los textos integrando la promoción del 20% de descuento",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3]:
    "Escribe títulos más cortos y directos para mis anuncios",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4]:
    "Cambia la audiencia a personas de 25 a 40 años",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5]:
    "Cambia el CTA de todos los anuncios a “Comprar ahora”",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6]:
    "Agrega intereses de fitness y vida saludable a la audiencia",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE]: "Analiza resultados y propón ajustes",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION]:
    "Detecto qué funciona y preparo cambios",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION]:
    "Analiza los resultados de mi campaña y prepara cambios concretos que puedas aplicar.",
  [CAMPAIGN_AGENT_CARD_IMPROVE_TITLE]: "Mejora mi campaña",
  [CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION]:
    "Reviso segmentación, textos y configuración",
  [CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION]:
    "Revisa mi campaña y prepara los cambios que más pueden mejorar sus resultados.",
  [CAMPAIGN_AGENT_CARD_BUDGET_TITLE]: "Ajusta mi presupuesto",
  [CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION]:
    "Propongo cómo distribuir mejor tu inversión",
  [CAMPAIGN_AGENT_CARD_BUDGET_QUESTION]:
    "Revisa el presupuesto de mi campaña y prepara los cambios para optimizarlo.",
  [CAMPAIGN_AGENT_CARD_COPY_TITLE]: "Reescribe mis anuncios",
  [CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION]:
    "Escribo textos nuevos listos para aplicar",
  [CAMPAIGN_AGENT_CARD_COPY_QUESTION]:
    "Escribe textos nuevos para los anuncios de mi campaña y déjalos listos para aplicar.",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE]: "1 mejora lista para aplicar",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY]:
    "{{count}} mejoras listas para aplicar",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION]:
    "Revisa cada una y aplícala a tu campaña con un clic. Nada se publica hasta que tú lo decidas.",
  [CAMPAIGN_AGENT_CHANGES_COUNT_ONE]: "1 cambio",
  [CAMPAIGN_AGENT_CHANGES_COUNT_MANY]: "{{count}} cambios",
  [CAMPAIGN_AGENT_CREATIVE_BADGE]: "Creatividad",
  [CAMPAIGN_AGENT_SUMMARY_TITLE]: "Lo que voy a cambiar",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUE]: "Nuevo valor: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUES]: "{{count}} nuevos valores",
  [CAMPAIGN_AGENT_SUMMARY_ADD_ONE]: "Agrega: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_ADD_MANY]: "Agrega {{count}} elementos",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE]: "Quita: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM]: "Quita 1 elemento",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY]: "Quita {{count}} elementos",
  [CAMPAIGN_AGENT_SUMMARY_CREATE]: "Crea: {{name}}",
  [CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED]: "Crea uno nuevo",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE]:
    "Te llevo al anuncio para cambiar la imagen o el video",
  [CAMPAIGN_AGENT_SUMMARY_MORE_ONE]: "+1 cambio más",
  [CAMPAIGN_AGENT_SUMMARY_MORE_MANY]: "+{{count}} cambios más",
  [CAMPAIGN_AGENT_SUMMARY_FOOTNOTE]:
    "Verás el detalle completo antes de aplicar.",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE]:
    "Al hacer clic aplico los cambios y te llevo al anuncio para elegir la nueva creatividad.",
  [CAMPAIGN_AGENT_SUMMARY_MANUAL]:
    "Este cambio no puedo aplicarlo por ti. Te explico cómo hacerlo.",
  [BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY]: "Revisar y aplicar",
  [BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD]: "Aplicar e ir al anuncio",
  [BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION]: "Ver recomendación",
  [BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES]: "Ver Cambios",
  [CAMPAIGN_AGENT_APPLIED_BADGE]: "Aplicado",
  [CAMPAIGN_AGENT_APPLIED_CAPTION]:
    "Aplicado en el editor. Publica los cambios para activarlo.",
  [CAMPAIGN_AGENT_DONE_CAPTION]: "Marcado como hecho.",
  [CAMPAIGN_AGENT_DISCARDED_BADGE]: "Descartado",
  [CAMPAIGN_AGENT_DISCARDED_CAPTION]:
    "Descartaste esta mejora. No se aplicó ningún cambio.",
  [CAMPAIGN_AGENT_RESULT_APPLIED_TITLE]: "Cambios aplicados en tu campaña",
  [CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION]:
    "Apliqué “{{title}}” en el editor. Para que se vea en tus anuncios, publica los cambios.",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE]: "Apliqué parte de los cambios",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION]:
    "Apliqué {{applied}} de {{total}} cambios de “{{title}}”. Revisa los demás en el editor o pídeme una alternativa. Recuerda publicar los cambios.",
  [CAMPAIGN_AGENT_RESULT_FAILED_TITLE]: "No pude aplicar los cambios",
  [CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION]:
    "Algo impidió aplicar “{{title}}” en tu campaña. No se hizo ningún cambio. Puedo proponerte una alternativa.",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE]: "Te llevé al anuncio",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION]:
    "Elige o genera la nueva creatividad para “{{title}}” desde la vista previa del anuncio. Luego publica los cambios.",
  [BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH]: "Ir a publicar",
  [BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT]: "Ver siguiente mejora",
  [BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE]: "Pedir una alternativa",
  [CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE]:
    "No se pudo aplicar “{{title}}” en mi campaña. Propón una alternativa que sí puedas aplicar.",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE]: "¿Qué más puedo mejorar?",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE]:
    "¿Qué otro cambio me recomiendas aplicar a esta campaña?",
  [CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE]: "Ajustar presupuesto",
  [CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE]: "Mejorar textos",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP]: "Pídele al agente cambios para tu campaña",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE]:
    "Tienes 1 mejora lista para aplicar",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY]:
    "Tienes {{count}} mejoras listas para aplicar",
  [PAYWALL_INSUFFICIENT_CREDITS_TITLE]: "¡Se te acabaron los créditos!",
  [PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE]:
    "No puedes ejecutar más acciones por el momento.",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE]: "Mejora tu plan",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION]:
    "Accede a más créditos y más funciones subiendo tu plan.",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE]: "O compra créditos",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION]:
    "Si solo necesitas un impulso, elige un paquete de créditos.",
  [PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL]:
    "Créditos agotados: mejora tu plan o compra créditos",
  [BULK_CAMPAIGNS_CONTENTS_COUNTER]: "{{count}}/{{limit}}",
  [BULK_PLATFORM_GOOGLE]: "Google",
  [BULK_PLATFORM_META]: "Meta",
  [BULK_PLATFORM_TIKTOK]: "TikTok",
  [BULK_PLATFORM_LINKEDIN]: "LinkedIn",
  [BULK_FIELD_INSTAGRAM]: "Instagram",
  [BULK_CAMPAIGNS_EMPTY_FILE]:
    "El archivo está vacío. Elige un archivo con contenido.",
  [BULK_CAMPAIGNS_TOO_MANY_CONTENTS]:
    "Puedes seleccionar hasta {{limit}} contenidos.",
  [BULK_CAMPAIGNS_ANALYZE]: "Analizar",
  [BULK_CAMPAIGNS_CANCEL_ANALYSIS]: "Cancelar análisis",
  [BULK_CAMPAIGNS_STALE]:
    "Cambiaste el archivo o los contenidos. El análisis anterior ya no aplica. Vuelve a analizar.",
  [BULK_CAMPAIGNS_SELECT_CONTENTS]: "Seleccionar contenidos",
  [BULK_CAMPAIGNS_CONTENTS_HINT]:
    "Si la plataforma necesita creativos y no eliges ninguno, los anuncios se crearán vacíos.",
  [BULK_CAMPAIGNS_REMOVE_CONTENT]: "Quitar contenido",
  [BULK_CAMPAIGNS_FILE_READY]: "{{fileName}} ({{size}})",
  [BULK_CAMPAIGNS_REPLACE_FILE]: "Suelta otro archivo para reemplazarlo.",
  [BULK_CAMPAIGNS_RESULT_CREATED]: "Campañas creadas: {{count}}",
  [BULK_CAMPAIGNS_RESULT_FAILED]: "Campañas que no se crearon: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED]: "Referencias limpiadas: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL]:
    "Se limpió {{field}} en la campaña {{campaign}}.",
  [BULK_CAMPAIGNS_RESULT_TITLE]: "Resultado",
  [BULK_CAMPAIGNS_VIEW_CAMPAIGNS]: "Ver campañas",
  [`${BULK_CAMPAIGNS_SUMMARY_COUNT}_one`]:
    "Encontramos {{count}} campaña para generar.",
  [BULK_CAMPAIGNS_SUMMARY_COUNT]:
    "Encontramos {{count}} campañas para generar.",
  [BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE]:
    "No hay cuentas publicitarias disponibles para crear estas campañas. No se creó ningún borrador y no se usaron créditos.",
  [BULK_FIELD_PRIMARY_TEXT]: "Texto principal",
  [BULK_FIELD_HEADLINE]: "Título",
  [BULK_FIELD_LONG_HEADLINE]: "Título largo",
  [BULK_FIELD_SEARCH_THEME]: "Tema de búsqueda",
  [BULK_FIELD_CALL_TO_ACTION]: "Llamada a la acción",
  [BULK_FIELD_TITLES]: "Títulos",
  [BULK_FIELD_HEADLINES]: "Títulos",
  [BULK_FIELD_LONG_HEADLINES]: "Títulos largos",
  [BULK_FIELD_DESCRIPTIONS]: "Descripciones",
  [BULK_FIELD_KEYWORDS]: "Palabras clave",
  [BULK_FIELD_KEYWORDS_NEGATIVE]: "Palabras clave negativas",
  [BULK_FIELD_DESTINATION_URL]: "URL de destino",
  [BULK_FIELD_DAILY_BUDGET]: "Presupuesto diario",
  [BULK_FIELD_LANGUAGE]: "Idioma",
  [BULK_FIELD_OBJECTIVE]: "Objetivo",
  [BULK_FIELD_SEARCH_THEMES]: "Temas de búsqueda",
  [BULK_FIELD_CALLOUTS]: "Frases destacadas",
  [BULK_FIELD_AUDIENCE]: "Audiencia",
  [BULK_FIELD_PAGE]: "Página",
  [BULK_FIELD_IDENTITY]: "Identidad",
  [BULK_FIELD_APP]: "Aplicación",
  [BULK_FIELD_APP_STORE]: "Tienda de aplicaciones",
  [BULK_FIELD_AD_FORMAT]: "Formato del anuncio",
  [BULK_FIELD_ACCOUNT]: "Cuenta publicitaria",
  [BULK_FIELD_MERCHANT]: "Merchant Center",
  [BULK_FIELD_LOCATIONS]: "Ubicaciones",
  [TIKTOK_INDUSTRY_22102000000]: "Ropa y accesorios / Bolsos",
  [TIKTOK_INDUSTRY_22101000000]: "Ropa y accesorios / Accesorios de vestir",
  [TIKTOK_INDUSTRY_22107000000]: "Ropa y accesorios / Joyería de alta gama",
  [TIKTOK_INDUSTRY_22108000000]: "Ropa y accesorios / Ropa de hombre",
  [TIKTOK_INDUSTRY_22109000000]: "Ropa y accesorios / Calzado de hombre",
  [TIKTOK_INDUSTRY_22106000000]: "Ropa y accesorios / Joyería",
  [TIKTOK_INDUSTRY_22999000000]: "Ropa y accesorios / Otros",
  [TIKTOK_INDUSTRY_22112000000]:
    "Ropa y accesorios / Ropa tradicional y ceremonial",
  [TIKTOK_INDUSTRY_22105000000]: "Ropa y accesorios / Relojes",
  [TIKTOK_INDUSTRY_22113000000]: "Ropa y accesorios / Dispositivos vestibles",
  [TIKTOK_INDUSTRY_22110000000]: "Ropa y accesorios / Ropa de mujer",
  [TIKTOK_INDUSTRY_22111000000]: "Ropa y accesorios / Calzado de mujer",
  [TIKTOK_INDUSTRY_16105000000]: "Electrodomésticos / Dispositivos digitales",
  [TIKTOK_INDUSTRY_16104000000]:
    "Electrodomésticos / Electrodomésticos del hogar",
  [TIKTOK_INDUSTRY_16101000000]: "Electrodomésticos / Cocina y baño",
  [TIKTOK_INDUSTRY_16102000000]:
    "Electrodomésticos / Grandes electrodomésticos",
  [TIKTOK_INDUSTRY_16999000000]: "Electrodomésticos / Otros",
  [TIKTOK_INDUSTRY_16100000000]: "Electrodomésticos / Cuidado personal",
  [TIKTOK_INDUSTRY_20101000000]: "Apps / Reproductores de audio y video",
  [TIKTOK_INDUSTRY_20110000000]: "Apps / Negocios y productividad",
  [TIKTOK_INDUSTRY_20104000000]: "Apps / Educación",
  [TIKTOK_INDUSTRY_20106000000]: "Apps / Servicios financieros",
  [TIKTOK_INDUSTRY_20109000000]: "Apps / Salud y fitness",
  [TIKTOK_INDUSTRY_20107000000]: "Apps / Vida y ocio",
  [TIKTOK_INDUSTRY_20102000000]: "Apps / Noticias y lectura",
  [TIKTOK_INDUSTRY_20105000000]: "Apps / Compras en línea",
  [TIKTOK_INDUSTRY_20999000000]: "Apps / Otras apps",
  [TIKTOK_INDUSTRY_20111000000]: "Apps / Crianza",
  [TIKTOK_INDUSTRY_20103000000]: "Apps / Fotografía",
  [TIKTOK_INDUSTRY_20100000000]: "Apps / Redes sociales",
  [TIKTOK_INDUSTRY_20108000000]: "Apps / Viajes",
  [TIKTOK_INDUSTRY_20112000000]: "Apps / Utilidades",
  [TIKTOK_INDUSTRY_12104000000]:
    "Bebés, niños y maternidad / Ropa de cama para bebé",
  [TIKTOK_INDUSTRY_12108000000]:
    "Bebés, niños y maternidad / Artículos de alimentación",
  [TIKTOK_INDUSTRY_12100000000]: "Bebés, niños y maternidad / Comida para bebé",
  [TIKTOK_INDUSTRY_12102000000]: "Bebés, niños y maternidad / Fórmula infantil",
  [TIKTOK_INDUSTRY_12110000000]: "Bebés, niños y maternidad / Higiene del bebé",
  [TIKTOK_INDUSTRY_12105000000]: "Bebés, niños y maternidad / Calzado de bebé",
  [TIKTOK_INDUSTRY_12107000000]: "Bebés, niños y maternidad / Sillas de auto",
  [TIKTOK_INDUSTRY_12109000000]: "Bebés, niños y maternidad / Ropa infantil",
  [TIKTOK_INDUSTRY_12103000000]:
    "Bebés, niños y maternidad / Pañales y toallitas",
  [TIKTOK_INDUSTRY_12999000000]: "Bebés, niños y maternidad / Otros",
  [TIKTOK_INDUSTRY_12101000000]:
    "Bebés, niños y maternidad / Cochecitos y cunas",
  [TIKTOK_INDUSTRY_12106000000]: "Bebés, niños y maternidad / Juguetes",
  [TIKTOK_INDUSTRY_14105000000]:
    "Belleza y cuidado personal / Medicina estética",
  [TIKTOK_INDUSTRY_14104000000]: "Belleza y cuidado personal / Cosméticos",
  [TIKTOK_INDUSTRY_14107000000]:
    "Belleza y cuidado personal / Cuidado femenino",
  [TIKTOK_INDUSTRY_14106000000]:
    "Belleza y cuidado personal / Fragancias y perfumes",
  [TIKTOK_INDUSTRY_14101000000]:
    "Belleza y cuidado personal / Cuidado del cabello",
  [TIKTOK_INDUSTRY_14100000000]: "Belleza y cuidado personal / Cuidado bucal",
  [TIKTOK_INDUSTRY_14999000000]: "Belleza y cuidado personal / Otros",
  [TIKTOK_INDUSTRY_14103000000]:
    "Belleza y cuidado personal / Cuidado de la piel",
  [TIKTOK_INDUSTRY_14102000000]:
    "Belleza y cuidado personal / Pelucas y peinados",
  [TIKTOK_INDUSTRY_24108000000]:
    "Servicios empresariales / Agricultura, silvicultura, ganadería y pesca",
  [TIKTOK_INDUSTRY_24118000000]: "Servicios empresariales / Subastas",
  [TIKTOK_INDUSTRY_24105000000]:
    "Servicios empresariales / Materiales químicos",
  [TIKTOK_INDUSTRY_24103000000]:
    "Servicios empresariales / Ingeniería de construcción",
  [TIKTOK_INDUSTRY_24104000000]:
    "Servicios empresariales / Electrónica y electricidad",
  [TIKTOK_INDUSTRY_24109000000]:
    "Servicios empresariales / Ahorro energético y medio ambiente",
  [TIKTOK_INDUSTRY_24114000000]: "Servicios empresariales / Exposiciones",
  [TIKTOK_INDUSTRY_24107000000]: "Servicios empresariales / Franquicias",
  [TIKTOK_INDUSTRY_24120000000]:
    "Servicios empresariales / Emprendimiento individual",
  [TIKTOK_INDUSTRY_24119000000]:
    "Servicios empresariales / Planificación y gestión de inversiones",
  [TIKTOK_INDUSTRY_24116000000]: "Servicios empresariales / Servicios de TI",
  [TIKTOK_INDUSTRY_24117000000]: "Servicios empresariales / Servicios legales",
  [TIKTOK_INDUSTRY_24111000000]: "Servicios empresariales / Logística",
  [TIKTOK_INDUSTRY_24106000000]:
    "Servicios empresariales / Maquinaria y equipos",
  [TIKTOK_INDUSTRY_24112000000]:
    "Servicios empresariales / Marketing y publicidad",
  [TIKTOK_INDUSTRY_24101000000]:
    "Servicios empresariales / Equipos y suministros de oficina",
  [TIKTOK_INDUSTRY_24999000000]: "Servicios empresariales / Otros",
  [TIKTOK_INDUSTRY_24113000000]:
    "Servicios empresariales / Consultoría profesional",
  [TIKTOK_INDUSTRY_24100000000]:
    "Servicios empresariales / Bienes raíces y alquileres",
  [TIKTOK_INDUSTRY_24102000000]:
    "Servicios empresariales / Reclutamiento y búsqueda de empleo",
  [TIKTOK_INDUSTRY_24110000000]: "Servicios empresariales / Seguridad",
  [TIKTOK_INDUSTRY_24115000000]:
    "Servicios empresariales / Externalización de servicios",
  [TIKTOK_INDUSTRY_30100000000]:
    "Comercio electrónico (no app) / Grandes superficies",
  [TIKTOK_INDUSTRY_30102000000]:
    "Comercio electrónico (no app) / Grandes plataformas",
  [TIKTOK_INDUSTRY_30101000000]:
    "Comercio electrónico (no app) / Plataformas pequeñas y medianas",
  [TIKTOK_INDUSTRY_10100000000]: "Educación / Primera infancia y preescolar",
  [TIKTOK_INDUSTRY_10102000000]: "Educación / Educación superior",
  [TIKTOK_INDUSTRY_10105000000]: "Educación / Idiomas",
  [TIKTOK_INDUSTRY_10106000000]: "Educación / Formación no académica (hobbies)",
  [TIKTOK_INDUSTRY_10999000000]: "Educación / Otra educación",
  [TIKTOK_INDUSTRY_10103000000]: "Educación / Educación en el extranjero",
  [TIKTOK_INDUSTRY_10101000000]: "Educación / Primaria, secundaria y K-12",
  [TIKTOK_INDUSTRY_10104000000]: "Educación / Formación profesional",
  [TIKTOK_INDUSTRY_13100000000]: "Servicios financieros / Bancos comerciales",
  [TIKTOK_INDUSTRY_13108000000]: "Servicios financieros / Burós de crédito",
  [TIKTOK_INDUSTRY_13117000000]: "Servicios financieros / Tarjetas de crédito",
  [TIKTOK_INDUSTRY_13115000000]:
    "Servicios financieros / Financiación colectiva",
  [TIKTOK_INDUSTRY_13116000000]: "Servicios financieros / Criptomonedas",
  [TIKTOK_INDUSTRY_13112000000]: "Servicios financieros / Divisas",
  [TIKTOK_INDUSTRY_13107000000]: "Servicios financieros / Fondos",
  [TIKTOK_INDUSTRY_13104000000]: "Servicios financieros / Garantías",
  [TIKTOK_INDUSTRY_13102000000]: "Servicios financieros / Seguros",
  [TIKTOK_INDUSTRY_13110000000]:
    "Servicios financieros / Asesoría de inversión",
  [TIKTOK_INDUSTRY_13111000000]: "Servicios financieros / Préstamos",
  [TIKTOK_INDUSTRY_13109000000]: "Servicios financieros / Microfinanzas",
  [TIKTOK_INDUSTRY_13999000000]: "Servicios financieros / Otros",
  [TIKTOK_INDUSTRY_13105000000]: "Servicios financieros / Casas de empeño",
  [TIKTOK_INDUSTRY_13113000000]: "Servicios financieros / Metales preciosos",
  [TIKTOK_INDUSTRY_13101000000]: "Servicios financieros / Valores",
  [TIKTOK_INDUSTRY_13114000000]: "Servicios financieros / Pagos de terceros",
  [TIKTOK_INDUSTRY_1310300000]: "Servicios financieros / Fideicomisos",
  [TIKTOK_INDUSTRY_27103000000]: "Alimentos y bebidas / Bebidas alcohólicas",
  [TIKTOK_INDUSTRY_27104000000]: "Alimentos y bebidas / Cocina y recetas",
  [TIKTOK_INDUSTRY_27100000000]: "Alimentos y bebidas / Gastronomía",
  [TIKTOK_INDUSTRY_27101000000]:
    "Alimentos y bebidas / Alimentos y productos frescos",
  [TIKTOK_INDUSTRY_27102000000]: "Alimentos y bebidas / Bebidas sin alcohol",
  [TIKTOK_INDUSTRY_27999000000]: "Alimentos y bebidas / Otros",
  [TIKTOK_INDUSTRY_25301000000]: "Juegos / Acción",
  [TIKTOK_INDUSTRY_25302000000]: "Juegos / Casino",
  [TIKTOK_INDUSTRY_25300000000]: "Juegos / Hipercasual",
  [TIKTOK_INDUSTRY_25313000000]: "Juegos / Infantiles",
  [TIKTOK_INDUSTRY_25303000000]: "Juegos / Match",
  [TIKTOK_INDUSTRY_25999000000]: "Juegos / Otros",
  [TIKTOK_INDUSTRY_25311000000]: "Juegos / Fiesta",
  [TIKTOK_INDUSTRY_25304000000]: "Juegos / Puzles",
  [TIKTOK_INDUSTRY_25305000000]: "Juegos / Carreras",
  [TIKTOK_INDUSTRY_25306000000]: "Juegos / Rol",
  [TIKTOK_INDUSTRY_25307000000]: "Juegos / Disparos",
  [TIKTOK_INDUSTRY_25308000000]: "Juegos / Simulación",
  [TIKTOK_INDUSTRY_25309000000]: "Juegos / Deportes",
  [TIKTOK_INDUSTRY_25310000000]: "Juegos / Estrategia",
  [TIKTOK_INDUSTRY_25312000000]: "Juegos / Mesa",
  [TIKTOK_INDUSTRY_29102000000]: "Salud / Suplementos",
  [TIKTOK_INDUSTRY_29101000000]: "Salud / Información médica",
  [TIKTOK_INDUSTRY_29100000000]: "Salud / Servicios médicos",
  [TIKTOK_INDUSTRY_29103000000]: "Salud / Medicamentos",
  [TIKTOK_INDUSTRY_29999000000]: "Salud / Otra salud",
  [TIKTOK_INDUSTRY_21102000000]:
    "Mejoras del hogar / Materiales de construcción e iluminación",
  [TIKTOK_INDUSTRY_21101000000]: "Mejoras del hogar / Muebles",
  [TIKTOK_INDUSTRY_21103000000]:
    "Mejoras del hogar / Ferretería y electricidad",
  [TIKTOK_INDUSTRY_21104000000]: "Mejoras del hogar / Decoración",
  [TIKTOK_INDUSTRY_21100000000]: "Mejoras del hogar / Diseño de interiores",
  [TIKTOK_INDUSTRY_21999000000]: "Mejoras del hogar / Otras",
  [TIKTOK_INDUSTRY_21105000000]: "Mejoras del hogar / Regletas y enchufes",
  [TIKTOK_INDUSTRY_18106000000]: "Productos del hogar / Aparatos de limpieza",
  [TIKTOK_INDUSTRY_18110000000]: "Productos del hogar / Artículos de limpieza",
  [TIKTOK_INDUSTRY_18104000000]: "Productos del hogar / Accesorios de café",
  [TIKTOK_INDUSTRY_18101000000]: "Productos del hogar / Esenciales diarios",
  [TIKTOK_INDUSTRY_18102000000]: "Productos del hogar / Vasos y cristalería",
  [TIKTOK_INDUSTRY_18105000000]: "Productos del hogar / Accesorios de cocina",
  [TIKTOK_INDUSTRY_18108000000]: "Productos del hogar / Lavandería",
  [TIKTOK_INDUSTRY_18109000000]: "Productos del hogar / Cuidado del cuero",
  [TIKTOK_INDUSTRY_18999000000]: "Productos del hogar / Otros",
  [TIKTOK_INDUSTRY_18112000000]: "Productos del hogar / Control de plagas",
  [TIKTOK_INDUSTRY_18100000000]: "Productos del hogar / Almacenamiento",
  [TIKTOK_INDUSTRY_18103000000]: "Productos del hogar / Juegos de té",
  [TIKTOK_INDUSTRY_18107000000]: "Productos del hogar / Pañuelos y toallitas",
  [TIKTOK_INDUSTRY_18111000000]: "Productos del hogar / Juguetes",
  [TIKTOK_INDUSTRY_26114000000]:
    "Servicios cotidianos / Belleza y cuidado personal",
  [TIKTOK_INDUSTRY_26112000000]:
    "Servicios cotidianos / Servicios al consumidor",
  [TIKTOK_INDUSTRY_26102000000]:
    "Servicios cotidianos / Citas y emparejamiento",
  [TIKTOK_INDUSTRY_26113000000]: "Servicios cotidianos / Ejercicio y fitness",
  [TIKTOK_INDUSTRY_26108000000]: "Servicios cotidianos / Jardinería",
  [TIKTOK_INDUSTRY_26104000000]: "Servicios cotidianos / Regalos y flores",
  [TIKTOK_INDUSTRY_26105000000]: "Servicios cotidianos / Limpieza del hogar",
  [TIKTOK_INDUSTRY_26111000000]: "Servicios cotidianos / Servicios de internet",
  [TIKTOK_INDUSTRY_26999000000]: "Servicios cotidianos / Otros",
  [TIKTOK_INDUSTRY_26101000000]: "Servicios cotidianos / Fotografía",
  [TIKTOK_INDUSTRY_26106000000]: "Servicios cotidianos / Compras",
  [TIKTOK_INDUSTRY_26107000000]: "Servicios cotidianos / Venta de segunda mano",
  [TIKTOK_INDUSTRY_26109000000]: "Servicios cotidianos / Pago de servicios",
  [TIKTOK_INDUSTRY_26103000000]: "Servicios cotidianos / Celebraciones de boda",
  [TIKTOK_INDUSTRY_26100000000]: "Servicios cotidianos / Fotografía de bodas",
  [TIKTOK_INDUSTRY_23113000000]: "Noticias y entretenimiento / Anime",
  [TIKTOK_INDUSTRY_23114000000]: "Noticias y entretenimiento / Astrología",
  [TIKTOK_INDUSTRY_23122000000]:
    "Noticias y entretenimiento / Belleza y cuidado personal",
  [TIKTOK_INDUSTRY_23102000000]:
    "Noticias y entretenimiento / Negocios y economía",
  [TIKTOK_INDUSTRY_23126000000]:
    "Noticias y entretenimiento / Información de autos",
  [TIKTOK_INDUSTRY_23108000000]:
    "Noticias y entretenimiento / Famosos y chismes",
  [TIKTOK_INDUSTRY_23105000000]:
    "Noticias y entretenimiento / Caridad y bienestar público",
  [TIKTOK_INDUSTRY_23111000000]:
    "Noticias y entretenimiento / Coleccionables y antigüedades",
  [TIKTOK_INDUSTRY_23116000000]: "Noticias y entretenimiento / Cultura y arte",
  [TIKTOK_INDUSTRY_23104000000]:
    "Noticias y entretenimiento / Cultura e historia",
  [TIKTOK_INDUSTRY_23128000000]:
    "Noticias y entretenimiento / Información de comercio electrónico",
  [TIKTOK_INDUSTRY_23107000000]: "Noticias y entretenimiento / Medio ambiente",
  [TIKTOK_INDUSTRY_23124000000]: "Noticias y entretenimiento / Comida y cocina",
  [TIKTOK_INDUSTRY_23125000000]:
    "Noticias y entretenimiento / Juegos y software de utilidades",
  [TIKTOK_INDUSTRY_23127000000]:
    "Noticias y entretenimiento / Información general",
  [TIKTOK_INDUSTRY_23115000000]: "Noticias y entretenimiento / Humor",
  [TIKTOK_INDUSTRY_23106000000]: "Noticias y entretenimiento / Derecho",
  [TIKTOK_INDUSTRY_23109000000]: "Noticias y entretenimiento / Estilo de vida",
  [TIKTOK_INDUSTRY_23110000000]: "Noticias y entretenimiento / Eventos en vivo",
  [TIKTOK_INDUSTRY_23100000000]: "Noticias y entretenimiento / Militar",
  [TIKTOK_INDUSTRY_23119000000]: "Noticias y entretenimiento / Películas",
  [TIKTOK_INDUSTRY_23999000000]: "Noticias y entretenimiento / Otros",
  [TIKTOK_INDUSTRY_23129000000]:
    "Noticias y entretenimiento / Información de mascotas",
  [TIKTOK_INDUSTRY_23101000000]: "Noticias y entretenimiento / Política",
  [TIKTOK_INDUSTRY_23118000000]: "Noticias y entretenimiento / Lectura",
  [TIKTOK_INDUSTRY_23130000000]:
    "Noticias y entretenimiento / Información inmobiliaria",
  [TIKTOK_INDUSTRY_23131000000]: "Noticias y entretenimiento / Relaciones",
  [TIKTOK_INDUSTRY_23103000000]:
    "Noticias y entretenimiento / Ciencia y tecnología",
  [TIKTOK_INDUSTRY_23134000000]:
    "Noticias y entretenimiento / Promoción de cuentas en redes",
  [TIKTOK_INDUSTRY_23123000000]:
    "Noticias y entretenimiento / Deportes y fitness",
  [TIKTOK_INDUSTRY_23132000000]:
    "Noticias y entretenimiento / Sitios de streaming",
  [TIKTOK_INDUSTRY_23133000000]:
    "Noticias y entretenimiento / Información turística",
  [TIKTOK_INDUSTRY_23112000000]:
    "Noticias y entretenimiento / Series y dramas de TV",
  [TIKTOK_INDUSTRY_23117000000]:
    "Noticias y entretenimiento / Programas de variedades",
  [TIKTOK_INDUSTRY_19999000000]: "Mascotas / Otras",
  [TIKTOK_INDUSTRY_19103000000]: "Mascotas / Estética",
  [TIKTOK_INDUSTRY_19101000000]: "Mascotas / Salud",
  [TIKTOK_INDUSTRY_19102000000]: "Mascotas / Productos para el hogar",
  [TIKTOK_INDUSTRY_19105000000]: "Mascotas / Juguetes",
  [TIKTOK_INDUSTRY_19106000000]: "Mascotas / Accesorios de viaje",
  [TIKTOK_INDUSTRY_19104000000]: "Mascotas / Premios",
  [TIKTOK_INDUSTRY_19100000000]: "Mascotas / Alimento",
  [TIKTOK_INDUSTRY_28100000000]: "Deportes y aire libre / Equipo de exterior",
  [TIKTOK_INDUSTRY_28101000000]: "Deportes y aire libre / Deportes y equipo",
  [TIKTOK_INDUSTRY_15100000000]: "Tecnología y electrónica / Teléfonos móviles",
  [TIKTOK_INDUSTRY_15105000000]:
    "Tecnología y electrónica / Accesorios de computadora",
  [TIKTOK_INDUSTRY_15103000000]:
    "Tecnología y electrónica / Reparación de computadoras",
  [TIKTOK_INDUSTRY_15101000000]: "Tecnología y electrónica / Computadoras",
  [TIKTOK_INDUSTRY_15102000000]:
    "Tecnología y electrónica / Componentes de computadora",
  [TIKTOK_INDUSTRY_15104000000]:
    "Tecnología y electrónica / Dispositivos de juego",
  [TIKTOK_INDUSTRY_15106000000]: "Tecnología y electrónica / Productos de red",
  [TIKTOK_INDUSTRY_15107000000]: "Tecnología y electrónica / Equipo de oficina",
  [TIKTOK_INDUSTRY_15999000000]: "Tecnología y electrónica / Otros",
  [TIKTOK_INDUSTRY_17103000000]: "Viajes / Hoteles y alojamiento",
  [TIKTOK_INDUSTRY_17999000000]: "Viajes / Otros",
  [TIKTOK_INDUSTRY_17105000000]: "Viajes / Tours y atracciones",
  [TIKTOK_INDUSTRY_17106000000]: "Viajes / Agencias y servicios de viaje",
  [TIKTOK_INDUSTRY_11111000000]:
    "Vehículos y transporte / Accesorios para vehículos de 2 y 3 ruedas",
  [TIKTOK_INDUSTRY_11110000000]: "Vehículos y transporte / Aviones",
  [TIKTOK_INDUSTRY_11101000000]: "Vehículos y transporte / Accesorios de auto",
  [TIKTOK_INDUSTRY_11103000000]: "Vehículos y transporte / Repuestos de auto",
  [TIKTOK_INDUSTRY_11102000000]: "Vehículos y transporte / Servicios de auto",
  [TIKTOK_INDUSTRY_11100000000]: "Vehículos y transporte / Autos",
  [TIKTOK_INDUSTRY_11107000000]: "Vehículos y transporte / Bicicletas",
  [TIKTOK_INDUSTRY_11112000000]: "Vehículos y transporte / Concesionarios",
  [TIKTOK_INDUSTRY_11104000000]: "Vehículos y transporte / Alquiler de autos",
  [TIKTOK_INDUSTRY_11108000000]:
    "Vehículos y transporte / Patinetes eléctricos",
  [TIKTOK_INDUSTRY_11106000000]: "Vehículos y transporte / Motos",
  [TIKTOK_INDUSTRY_11999000000]: "Vehículos y transporte / Otros",
  [TIKTOK_INDUSTRY_11105000000]: "Vehículos y transporte / Autos usados",
  [TIKTOK_INDUSTRY_11109000000]: "Vehículos y transporte / Vehículos acuáticos",
  [META_ATTRIBUTION_WINDOW_TITLE]: "Ventana de atribución",
  [META_ATTRIBUTION_WINDOW_DESCRIPTION]:
    "Define cuántos días después de un clic o de ver el anuncio Meta le atribuye una conversión a este conjunto de anuncios.",
  [META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW]:
    "Clic de 7 días + visualización de 1 día",
  [META_ATTRIBUTION_WINDOW_7D_CLICK]: "Clic de 7 días",
  [META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW]:
    "Clic de 1 día + visualización de 1 día",
  [META_ATTRIBUTION_WINDOW_1D_CLICK]: "Clic de 1 día",
  [META_ATTRIBUTION_WINDOW_DEFAULT_OPTION]: "{{window}} (predeterminada)",
  [META_ATTRIBUTION_ENGAGED_VIEW_LABEL]:
    "Incluir visualización con interacción de 1 día (personas que interactuaron con el anuncio o vieron al menos 5 segundos del video)",
  [WHITE_LABEL_TITLE]: "White-label",
  [WHITE_LABEL_BUY]: "Comprar",
  [WHITE_LABEL_PRICE_PER_MONTH]: "{{price}}/mes",
  [WHITE_LABEL_DIALOG_BODY]:
    "Tu propia marca en la plataforma: logo, colores, dominio y correos sin la marca Adle.",
  [WHITE_LABEL_NO_SETUP_FEE]:
    "Sin costo de instalación. Cancela cuando quieras.",
  [WHITE_LABEL_AFTER_PAYMENT]:
    "Después del pago completas tu marca y nuestro equipo la configura.",
  [WHITE_LABEL_APP_SUMO_CONFIRM]:
    "Esta compra se hará a nivel de agencia y se cobrará mensualmente aparte de tu licencia AppSumo. ¿Continuar?",
  [WHITE_LABEL_ONLY_OWNER]: "Solo el dueño de la cuenta puede comprar.",
  [WHITE_LABEL_STATUS_PENDING_BRANDING]: "Completa tu marca",
  [WHITE_LABEL_STATUS_CONFIGURING]: "En configuración",
  [WHITE_LABEL_STATUS_ACTIVE]: "Activo",
  [WHITE_LABEL_STATUS_REVERT_PENDING]: "Cancelado",
  [WHITE_LABEL_ALREADY_ACTIVE]: "Ya activo",
  [WHITE_LABEL_COMPLETE_BRAND]: "Completar marca",
  [WHITE_LABEL_EDIT_BRAND]: "Editar marca",
  [WHITE_LABEL_FORM_TITLE]: "Configura tu marca",
  [WHITE_LABEL_FORM_INTRO]:
    "Personaliza la identidad visual de tu espacio y cómo lo verán tus usuarios.",
  [WHITE_LABEL_FORM_SECTION_GENERAL]: "01 · Información general",
  [WHITE_LABEL_FORM_SECTION_VISUAL]: "02 · Identidad visual",
  [WHITE_LABEL_FORM_SECTION_VISUAL_HELP]:
    "Sube los recursos gráficos que utilizará tu marca.",
  [WHITE_LABEL_FORM_SECTION_COLORS]: "03 · Paleta de colores",
  [WHITE_LABEL_FORM_SECTION_COLORS_HELP]:
    "Define los colores que representarán tu marca.",
  [WHITE_LABEL_FORM_SECTION_DOMAIN]: "04 · Dominio y comentarios",
  [WHITE_LABEL_FORM_BADGE_REQUIRED]: "Obligatorio",
  [WHITE_LABEL_FORM_BADGE_OPTIONAL]: "Opcional",
  [WHITE_LABEL_FORM_DROP_TITLE]: "Arrastra tu logo aquí",
  [WHITE_LABEL_FORM_DROP_HINT]: "O selecciona un archivo · PNG, JPG o SVG",
  [WHITE_LABEL_FORM_INVALID_FILE]: "Archivo inválido.",
  [WHITE_LABEL_FORM_DOMAIN_BLOCKED]: "No puedes usar el dominio adle.ai.",
  [WHITE_LABEL_FORM_DOMAIN_INVALID]: "Dominio inválido.",
  [WHITE_LABEL_FORM_COLOR_INVALID]:
    "Usa un color hexadecimal, por ejemplo #1A2B3C.",
  [WHITE_LABEL_FORM_NAME_INVALID]:
    "El nombre debe tener entre 2 y 60 caracteres.",
  [WHITE_LABEL_FORM_NOTES_INVALID]:
    "Los comentarios no pueden superar 500 caracteres.",
  [WHITE_LABEL_FORM_LOGO_NAV_HELP]: "Para la barra izquierda.",
  [WHITE_LABEL_FORM_LOGO_LOGIN_HELP]: "Para la pantalla de inicio de sesión.",
  [WHITE_LABEL_FORM_FAVICON_CAPTION]: "Icono del navegador",
  [WHITE_LABEL_FORM_FAVICON_HELP]: "Imagen que aparecerá en la pestaña.",
  [WHITE_LABEL_FORM_NAME_PLACEHOLDER]: "Ej. Mi Agencia Digital",
  [WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER]: "app.tuagencia.com",
  [WHITE_LABEL_FORM_NOTES_PLACEHOLDER]:
    "¿Alguna instrucción adicional sobre tu marca?",
  [WHITE_LABEL_FORM_COLOR_PRIMARY]: "Principal",
  [WHITE_LABEL_FORM_COLOR_SECONDARY]: "Secundario",
  [WHITE_LABEL_FORM_COLOR_BUTTONS]: "Botones",
  [WHITE_LABEL_FORM_NAME_BUSINESS]: "Nombre de tu negocio",
  [WHITE_LABEL_FORM_LOGO]: "Logo principal",
  [WHITE_LABEL_FORM_LOGO_NAVBAR]: "Logo de navegación",
  [WHITE_LABEL_FORM_LOGO_LOGIN]: "Logo de acceso",
  [WHITE_LABEL_FORM_FAVICON]: "Favicon",
  [WHITE_LABEL_FORM_PRIMARY_COLOR]: "Color principal",
  [WHITE_LABEL_FORM_SECONDARY_COLOR]: "Color secundario",
  [WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR]: "Color de botones (opcional)",
  [WHITE_LABEL_FORM_DESIRED_DOMAIN]: "Dominio deseado",
  [WHITE_LABEL_FORM_DOMAIN_HELP]:
    "Te enviaremos por correo cómo apuntar tu dominio.",
  [WHITE_LABEL_FORM_NOTES]: "Comentarios para el equipo (Opcional)",
  [WHITE_LABEL_FORM_SUBMIT]: "Enviar marca",
  [WHITE_LABEL_FORM_SUBMITTED]:
    "Recibimos tu marca. Nuestro equipo la configurará y te avisaremos.",
  [WHITE_LABEL_CONFIRMING_PAYMENT]: "Estamos confirmando tu pago…",
  [WHITE_LABEL_CHECKOUT_CANCELLED]:
    "Pago cancelado. No se realizó ningún cobro.",
  [WHITE_LABEL_NOT_ELIGIBLE]:
    "Tu plan no permite comprar white-label. Escríbenos para cotizarlo.",
  [WHITE_LABEL_ERROR_ALREADY_ACTIVE]:
    "White-label ya está activo en tu cuenta.",
  [WHITE_LABEL_NOT_PURCHASED]: "Primero debes comprar white-label.",
  [WHITE_LABEL_INVALID_BRANDING]: "Revisa el campo marcado.",
  [WHITE_LABEL_INVALID_TRANSITION]:
    "Este cambio de estado de white-label no está permitido.",
  [AGENCY_ACCOUNT_LINKING_PICKER_TITLE]: "Tus cuentas publicitarias conectadas",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE]:
    "Obtén mejores resultados y un análisis más profundo",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION]:
    "Permite que Adle acceda a tus cuentas publicitarias para analizar y optimizar tus campañas. A los dueños de las cuentas publicitarias que deseas conectar les llegará un correo o notificación de que se estableció una conexión con {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONSENT]:
    "Permite que Adle acceda a estas cuentas para analizar y optimizar tus campañas",
  [AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP]:
    "Adle usa esto para revisar el rendimiento y sugerir mejoras en tus campañas.",
  [AGENCY_ACCOUNT_LINKING_CONSENT_INFO]: "Más información",
  [AGENCY_ACCOUNT_LINKING_CARD_TITLE]:
    "Obtén mejores resultados y un análisis más profundo.",
  [AGENCY_ACCOUNT_LINKING_CARD_BODY]:
    "Permite que Adle acceda a tus cuentas publicitarias para analizar y optimizar tus campañas.",
  [AGENCY_ACCOUNT_LINKING_ENABLE]: "Activar",
  [AGENCY_ACCOUNT_LINKING_NOT_NOW]: "Ahora no",
  [AGENCY_ACCOUNT_LINKING_SHEET_TITLE]: "Elige Qué Cuentas de Clientes Incluir",
  [AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION]:
    "A los dueños de las cuentas publicitarias que deseas conectar les llegará un correo o notificación de que se estableció una conexión con {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE]: "Confirmar conexión",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY]:
    "A los dueños de las cuentas publicitarias les llegará un correo o notificación avisando de la conexión con {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM]: "Confirmar ({{count}})",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE]:
    "Listo, Adle ya puede ayudarte a optimizar tu cuenta",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER]:
    "Listo, Adle ya puede ayudarte a optimizar tus {{count}} cuentas",
  [AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL]:
    "Listo. Adle puede ayudar a optimizar {{linked}} de {{total}} cuentas.",
  [AGENCY_ACCOUNT_LINKING_TOAST_LATER]:
    "No pudimos terminar esto ahora. Puedes intentarlo de nuevo en un momento.",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_META]: "Meta",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE]: "Google Ads",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK]: "TikTok",
  [AGENCY_ACCOUNT_LINKING_SHEET_LINKING]:
    "Vinculando cuentas, esto puede tardar unos segundos…",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE]:
    "Algunas cuentas no se vincularon",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY]:
    "Vinculamos {{linked}} de {{total}}. Revisa cada cuenta y sigue el paso indicado.",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE]:
    "No pudimos vincular estas cuentas",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY]:
    "Ninguna cuenta se vinculó. Revisa el motivo y el siguiente paso.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE]:
    "Falta la aprobación del cliente",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY]:
    "El cliente debe aprobar la solicitud antes de que Adle pueda usar estas cuentas.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META]:
    "El cliente debe aprobar la solicitud en Meta, en Configuración del negocio → Solicitudes.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE]:
    "El cliente debe aprobar la solicitud en Google Ads, en Administrador → Acceso y seguridad → Administradores.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK]:
    "El cliente debe aprobar la solicitud en TikTok Ads Manager, en Notificaciones → Business Center.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC]:
    "El cliente debe aprobar la solicitud en la plataforma publicitaria.",
  [AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED]:
    "Adle aún está terminando de habilitar la vinculación en esta plataforma. Ya avisamos al equipo y lo reintentaremos automáticamente; no tienes que hacer nada.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT]:
    "Vuelve a conectar la plataforma y revisa que tengas permisos de administrador.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP]: "Puedes volver a intentarlo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN]:
    "El cliente rechazó o retiró el acceso, o la solicitud venció. Pídele que la acepte y vuelve a intentarlo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT]:
    "Esta cuenta necesita una revisión. Escríbele a soporte de Adle y te ayudamos a vincularla.",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE]: "Vinculación en curso",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS]:
    "Ya hay una vinculación en curso. Espera un momento y vuelve a intentarlo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE]: "Vinculación en proceso",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING]:
    "La vinculación sigue en proceso. Espera un momento y vuelve a intentarlo si no se completa.",
  [AGENCY_ACCOUNT_LINKING_COLUMN_STATUS]: "Estado",
  [AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS]: "Detalles",
  [AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED]: "Sin vincular",
  [AGENCY_ACCOUNT_LINKING_STATUS_PENDING]: "Pendiente",
  [AGENCY_ACCOUNT_LINKING_STATUS_FAILED]: "Fallida",
  [AGENCY_ACCOUNT_LINKING_STATUS_LINKED]: "Vinculada",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN]:
    "El usuario conectado no es administrador de esta cuenta.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT]:
    "Hay que volver a conectar la cuenta con permisos de administrador.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE]: "No pudimos leer esta conexión.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED]:
    "Adle todavía no puede vincular esta plataforma.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS]:
    "Esta cuenta no está en un Business Manager o Business Center.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT]:
    "Esta cuenta llegó al límite de administradores.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE]:
    "Esta cuenta ya está administrada en otra jerarquía.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE]:
    "Estas cuentas no se pueden vincular entre sí.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED]:
    "La vinculación fue rechazada en la plataforma.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED]: "La vinculación pendiente venció.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED]: "La vinculación ya no está activa.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED]:
    "Esta plataforma todavía no se puede vincular.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC]:
    "No pudimos completar la vinculación.",
  [ADLE_CARD_WAITLIST_EYEBROW]: "Próximamente",
  [ADLE_CARD_WAITLIST_TITLE]: "Adle Card: Una Tarjeta para Todas tus Campañas",
  [ADLE_CARD_WAITLIST_SUBTITLE]:
    "Paga Meta, Google y TikTok desde un solo saldo y deja de perder días de campaña por pagos rechazados.",
  [ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS]:
    "Una tarjeta virtual por marca, creada en un clic",
  [ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE]:
    "Un solo saldo prepago para Meta, Google y TikTok",
  [ADLE_CARD_WAITLIST_FEATURE_CASHBACK]:
    "1,5% de cashback en toda tu inversión publicitaria",
  [ADLE_CARD_WAITLIST_FEATURE_NO_FEES]:
    "Sin cuota mensual y sin límites de gasto",
  [ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES]:
    "Se acabaron los pagos rechazados que pausan tus campañas",
  [ADLE_CARD_WAITLIST_FEATURE_TOP_UPS]:
    "Recargas por ACH o transferencia bancaria (mínimo USD 1.000)",
  [ADLE_CARD_WAITLIST_EMAIL_LABEL]: "Email",
  [ADLE_CARD_WAITLIST_COUNTRY_LABEL]: "País de tu empresa",
  [ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER]: "Selecciona tu país",
  [ADLE_CARD_WAITLIST_CTA]: "Unirme a la lista de espera",
  [ADLE_CARD_WAITLIST_NOT_NOW]: "Ahora no",
  [ADLE_CARD_WAITLIST_DISCLAIMER]:
    "Sin compromiso. Te avisaremos cuando la Adle Card esté disponible en tu país.",
  [ADLE_CARD_WAITLIST_SUCCESS_TITLE]: "¡Estás en la Lista!",
  [ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION]:
    "Te escribiremos a {{email}} en cuanto abramos los primeros accesos.",
  [ADLE_CARD_WAITLIST_SUBMIT_ERROR]:
    "No pudimos guardar tu registro. Inténtalo de nuevo.",
  [ADLE_CARD_WAITLIST_BANNER]:
    "Nuevo: Adle Card, un saldo para Meta, Google y TikTok con 1,5% de cashback.",
  [ADLE_CARD_WAITLIST_BANNER_LINK]: "Unirme a la lista",
  [ADLE_CARD_WAITLIST_CARD_ARIA]: "Ilustración de la Adle Card",
  [ADLE_CARD_WAITLIST_CARD_VIRTUAL]: "Virtual",
  [ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK]: "Tu marca",
  [OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST]: "Lista de espera Adle Card",
  [`${ADLE_CARD_WAITLIST_ADMIN_TOTAL}_one`]: "{{count}} registro",
  [ADLE_CARD_WAITLIST_ADMIN_TOTAL]: "{{count}} registros",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME]: "Gasto total (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M]: "Gasto últimos 3 meses (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE]:
    "No se pudo cargar el gasto publicitario.",
};

export default translation;
